/*jslint browser: true, white: true, plusplus: true, node: true */
/*eslint angular/di: [2,"array"]*/
/*global angular */
/*global buildMenus */
/*global addToParamFilters */
/*global CMP_EQ:true*/
/*global CMP_GT:true*/
/*global CMP_LT:true*/
/*global CMP_GTE:true*/
/*global CMP_LTE:true*/
/*global CMP_LIKER:true*/
/*global CMP_LIKEL:true*/
/*global CMP_LIKE:true */
/*global CMP_LIKENONE:true*/
/*global CMP_ISNULL:true*/
/*global DROPDOWN_CUSTOM_OPTION:true*/
/*global IxOperationModeBastidor:true*/
/*global convertDateStringsToDates*/
/*global skipValidationErrors*/
/*global deleteSkippedValidations*/
/*global checkPermission*/
/*global showAngularStats*/
/*global saveAs*/
/*global ixMenuMoreFunction*/
/*global ixMenuMore*/
/*var gp4App = angular.module('gp4App', ['ng', 'ngAnimate', 'ui.bootstrap', 'ngRoute', 'textAngular', 'infinite-scroll', 'ivh.treeview', 'gp4Controllers', 'gp4Filters', 'gp4helpers', 'CostesEscala', 'Extranet', 'Global']);*/
(function () {
  angular.module('gp4App', ['ng', 'ngAnimate', 'ui.bootstrap', 'ngRoute', 'textAngular', 'infinite-scroll', 'ivh.treeview', 'ngScrollbars', 'gp4Controllers', 'gp4Filters', 'gp4helpers', 'pascalprecht.translate', 'angular-clipboard', 'angularBootstrapMaterial']);

  var translateProvider = null;

  CMP_EQ = 0;
  CMP_GT = 1;
  CMP_LT = 2;
  CMP_GTE = 3;
  CMP_LTE = 4;
  CMP_LIKER = 5;
  CMP_LIKEL = 6;
  CMP_LIKE = 7;
  CMP_LIKENONE = 8;
  CMP_ISNULL = 9;

  DROPDOWN_CUSTOM_OPTION = -1;

  IxOperationModeBastidor = {
    sinDefinir: 0,
    editarEntrada: 1,
    asignacion: 2,
    salida: 3,
    eliminarAsignacion: 4,
    eliminarSalida: 5,
    eliminarSalidaAsignacion: 6,
    planificarCarga: 7,
    noValidar: 8
  };

  angular.module('gp4App').constant('k', {
    CMP: [{ operator: 0, name: "Igual a", icon: "fa fa-fw flaticon-eq" },
    { operator: 1, name: "Superior a", icon: "fa fa-fw flaticon-gt" },
    { operator: 2, name: "Inferior a", icon: "fa fa-fw flaticon-lt" },
    { operator: 3, name: "Superior o igual a", icon: "fa fa-fw flaticon-gte" },
    { operator: 4, name: "Inferior o igual a", icon: "fa fa-fw flaticon-lte" },
    { operator: 5, name: "Empieza por", icon: "fa fa-fw flaticon-asterisk" },
    { operator: 6, name: "Contiene", icon: "fa fa-fw flaticon-asterisk" },
    { operator: 7, name: "Termina en", icon: "fa fa-fw flaticon-asterisk fa-rotate-90" },
    { operator: 8, name: "No contiene", icon: "fa fa-fw fa-exclamation" },
    { operator: 9, name: "Vacío", icon: "fa fa-fw fa-circle-o" },
    { operator: 10, name: "No Vacío", icon: "fa fa-fw fa-dot-circle-o" }
    ]
  });


  angular.module('gp4App').config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {

    $routeProvider.when('/', { templateUrl: 'app/base/views/desktop.html', controller: 'DesktopController' })
      .when('/login', { templateUrl: 'app/base/views/login.html', controller: 'LoginController' })
      .when('/changePassword', { templateUrl: 'app/base/views/changePassword.html', controller: 'ChangePasswordController' })
      //Especiales de Administracion
      .when('/Administracion/:entity/list', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function ($route) { $route.current.params.module = "app/base/views"; } } })
      .when('/Administracion/api_usuarios/edit', { templateUrl: 'app/base/views/gridUsuarios.html', controller: 'GridUsuariosController' })
      .when('/Administracion/mis_listados_programados/edit', {
        templateUrl: 'app/base/views/gridEditor.html', controller: 'ListadosProgramadosListController',
        resolve: {
          entity: function ($route) {
            $route.current.params.entity = "listados_programados";
          },
          filterByUser: function ($route) {
            $route.current.params.filterByUser = true;
          }
        }
      })
      .when('/Administracion/listados_programados/edit', {
        templateUrl: 'app/base/views/gridEditor.html', controller: 'ListadosProgramadosListController',
        resolve: {
          entity: function ($route) {
            $route.current.params.entity = "listados_programados";
          },
          filterByUser: function ($route) {
            $route.current.params.filterByUser = false;
          }
        }
      })
      .when('/Administracion/api_traduction_msg/edit', { templateUrl: 'app/base/views/gridEditor.html', controller: 'GridTraduccionesController', resolve: { module: function ($route) { $route.current.params.entity = "api_traduction_msg"; } } })
      //Genericos
      .when('/Administracion/:entity/edit', { templateUrl: 'app/base/views/gridEditor.html', controller: 'GridEditorController' })
      //.when('/api_usuarios/edit', { templateUrl: 'views/gridUsuarios.html', controller: 'GridUsuariosCtrl' })
      //.when('/:entity/edit', { templateUrl: 'views/gridEditor.html', controller: 'GridEditorCtrl' })
      //.when('/cliente/list', { templateUrl: 'views/clientes.html', controller: 'ClientesListCtrl' })
      //.when('/cliente/:id', { templateUrl: 'views/cliente.html', controller: 'ClienteCtrl' })
      //.when('/cliente', { templateUrl: 'views/cliente.html', controller: 'ClienteCtrl' })
      //.when('/marca/list', { templateUrl: 'views/marcas.html', controller: 'MarcasListCtrl' })
      //.when('/remvar', { templateUrl: 'remvar/process.html', controller: 'RemvarCtrl' })
      //.when('/:entity/list', { templateUrl: 'views/listEdit.html', controller: 'ListEditController' })
      //.when('/:entity/pivot', { templateUrl: 'views/pivot.html', controller: 'PivotCtrl' })
      //.when('/bastidores', { templateUrl: 'views/bastidores.html', controller: 'BastidoresListCtrl' })
      //.when('/bastidor/:grupo/:chasis/:movimiento', { templateUrl: 'views/bastidor.html', controller: 'BastidorCtrl' })
      .otherwise({ redirectTo: '/' });
    $locationProvider.html5Mode(true);
  }]);

  angular.module('gp4App').config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useLoader('gp4TranslationsLoader');
    //$translateProvider.forceAsyncReload(true);
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.useMissingTranslationHandler('gp4MissingTranslationHandler');
    $translateProvider.registerAvailableLanguageKeys(['es', 'ca', 'en', 'pt', 'es_EX', 'ca_ES'], {
      'en_*': 'en',
      'ca': 'es-ct',
      'pt_*': 'pt',
      'es_EX': 'es_EX',
      'ca_ES': 'ca_ES',
      '*': 'es'
    });
    var langKey = $translateProvider.determinePreferredLanguage();
    translateProvider = $translateProvider;
  }]);

  angular.module('gp4App').factory('gp4TranslationsLoader', ['$http', '$q', 'cfg', 'authService', '$log', function gp4TranslationsLoaderFactory($http, $q, cfg, authService, $log) {
    return function (options) {
      authService.fillAuthData();
      var deferred = $q.defer();

      $log.log("FACTORY gp4TranslationsLoader", options, cfg);

      if (authService.authentication.isAuth) {
        /*var param = {
          Filters: [{Field:"idioma", Operator:CMP_EQ, Value:options.key}],
          OrderBy:[]
        };*/

        //$http.post(cfg.baseURL+'traduction_msg/Search?Page=1&ItemsPerPage=10000',param).then(function(response) {
        $http.get(cfg.baseURL + 'api_traduction_msg/GetByLanguage?language=' + options.key).then(function (response) {
          var tr = {};
          //response.data.Items.forEach(function(e){
          response.data.forEach(function (e) {
            if (e.traduccion == "?") {
              tr[e.gestpark] = e.gestpark;
            } else {
              tr[e.gestpark] = e.traduccion;
            }

          });
          $log.log("Transltions", options.key, tr);
          deferred.resolve(tr);
        }).catch(function (e) {
          $log.error("Error loading translations", options, e);
          deferred.reject(options.key);
        });
      } else {
        $log.log("not ready to load translations yet");
        deferred.reject(options.key);
      }

      return deferred.promise;
    };
  }]);

  angular.module('gp4App').factory('gp4MissingTranslationHandler', ['$http', 'cfg', '$log', '$translate', function gp4MissingTranslationHandlerFactory($http, cfg, $log, $translate) {
    return function (translationID, uses) {
      $log.log("missing translation", translationID, uses);
      var missingEntry = {
        bd: cfg.bd,
        gestpark: translationID,
        idioma: uses,
        traduccion: "?"
      };
      $log.log("adding missiong", missingEntry);
      $http.post(cfg.baseURL + 'api_traduction_msg/AddMissingTranslation', missingEntry).then(function (response) {
        $log.log("New missing translation saved", translationID, uses);
        //Obtenim la col·lecció de traduccions actual, li afegim la nova traducció i la guardem.
        var translations = translateProvider.translations();
        translations[uses][translationID] = translationID;
        translateProvider.translations(translations);
        $translate.use(uses);
        //$translate.refresh();
      }).catch(function (e) {
        $log.error("Error storign missing translation", e);
      });
      return translationID;
    };
  }]);

  angular.module('gp4App').factory('cfg', ['$log', function cfgFactory($log) {
    //var stored = localStorage['gp4App.cfg'];
    var stored = sessionStorage['gp4App.cfg'];
    if (stored) {
      $log.log("Restoring cfg from session", stored);
      return angular.fromJson(stored);
    } else {
      $log.log("No cfg stored in session");
      return {
        appURL: null,
        baseURL: null,
        baseAuthURL: null,
        clientId: null,  // used in refresh_token
        pageSize: null,
        httpTimeout: null,
        logApiCalls: null,  // escribe por consola las request i responses de la api
        dateFormat: null,
        timeDiff: null
      };
    }
  }]);

  angular.module('gp4App').factory('ixReportURL', ['$log', 'cfg', function ixReportURLFactory($log, cfg) {
    return {
      //TODO: Anar omplint amb tots els impresos de la aplicació i defecte false.
      ALBARAN_SALIDA: false,
      ALBARAN_TRASLADO: false,
      IMPRESO_TALLER: false,

      getURL: function (report) {
        var url = "impresos";
        if (this[report])
          return url + cfg.proyectoId;
        return url;
      }
    };
  }]);


  angular.module('gp4App').run(['$rootScope', 'cfg', function ($rootScope, cfg) {
    //angular.extend(cfg, angular.fromJson(localStorage['gp4App.cfg']));
    angular.extend(cfg, angular.fromJson(sessionStorage['gp4App.cfg']));
    //Si la data d'expiració és inferior a ara, esborrem de localStorage per tornar al login.
    /*if(new Date().getTime() > localStorage['expirationTime']){
      delete localStorage['authorizationData'];
    }*/
  }]);

  //Sobreescrivim els separados de milers i decimals del locale actual. Està fent en-us per defecte.
  angular.module('gp4App').run(["$locale", function ($locale) {
    $locale.NUMBER_FORMATS.GROUP_SEP = ".";
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
  }]);

  angular.module('gp4App').config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('loadingInterceptor');
    $httpProvider.interceptors.push('authInterceptorService');

    $httpProvider.defaults.transformResponse.push(function (responseData) {
      convertDateStringsToDates(responseData);
      return responseData;
    });
  }]);


  angular.module('gp4App').config(['$templateRequestProvider', function ($templateRequestProvider) {
    $templateRequestProvider.httpOptions({ headers: { 'Cache-Control': 'no-cache' } });
  }]);

  angular.module('gp4App').factory('loadingInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {

    var loading = 0;

    return {
      request: function (config) {
        loading++;
        $rootScope.api_request_pending = true; //NEW CODE (YVES 18/07/2023)
        $rootScope.$broadcast("loader_show");

        return config || $q.when(config);
      },
      response: function (response) {
        if ((--loading) === 0) {
          $rootScope.api_request_pending = false; //NEW CODE (YVES 18/07/2023)
          $rootScope.$broadcast("loader_hide");
        }
        return response || $q.when(response);
      },
      responseError: function (response) {
        if ((--loading) === 0) {
          $rootScope.api_request_pending = false; //NEW CODE (YVES 18/07/2023)
          $rootScope.$broadcast("loader_hide");
        }
        if (response.data instanceof ArrayBuffer) {
          var decodedString = String.fromCharCode.apply(null, new Uint8Array(response.data));
          var obj = angular.fromJson(decodedString);
          response.data = obj;
        }
        return $q.reject(response);
      }
    }
  }]);

  angular.module('gp4App').directive("ixLoader", [function () {
    return function ($scope, element) {
      $scope.$on("loader_show", function () {
        return element.show();
      });
      return $scope.$on("loader_hide", function () {
        return element.hide();
      });
    };
  }]);


  angular.module('gp4App').directive("ixSplash", [function () {
    return {
      //template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><h1>Cargando</h1><i class="fa fa-spinner fa-pulse"></i></div></div>',
      //template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><img src="assets/images/logogp_loading.png" /><br><br><i class="fa fa-cog fa-spin" style="font-size:60px;color:#b71c1c"></i></div></div>',
      template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><img src="assets/images/logogp-loading.png" /><br><br><i class="fa fa-circle-o-notch fa-spin ix-loading"></i></div></div>',
      link: function ($scope, element) {
        $scope.$on("splash_show", function () {
          element.parent().parent().addClass("splash-active");
          return element.show();
        });
        return $scope.$on("splash_hide", function () {
          element.hide();
          return element.parent().parent().removeClass("splash-active");
        });
      }
    }
  }]);



  angular.module('gp4App').controller('MainController', ['$rootScope', '$scope', '$location', '$log', '$http', '$timeout', '$uibModal', '$window', 'cfg', 'k', 'authService', '$cacheFactory', '$templateRequest', 'ixStatusService', 'i18nService', '$interval', '$translate', 'ixCestaVehiculosService', function ($rootScope, $scope, $location, $log, $http, $timeout, $uibModal, $window, cfg, k, authService, $cacheFactory, $templateRequest, ixStatusService, i18nService, $interval, $translate, ixCestaVehiculosService) {
    $scope.cfg = cfg;
    $rootScope.ixCloseApp = function () {
      if (ixCestaVehiculosService.isShowing())
        ixCestaVehiculosService.emptyCesta();

      ixStatusService.closeApp(ixStatusService.current);
    };

    $rootScope.showGrid = function (grid) {
      $timeout(function () {
        if ((angular.isDefined(grid)) && angular.isDefined(grid.gridApi))
          grid.gridApi.core.handleWindowResize();
        //grid.gridApi.core.scrollTo(grid.data[0], grid.columnDefs[0]);
      }, 200);
    };

    if (cfg.ngStats) {
      showAngularStats({
        position: 'bottomright',
        logDigest: true,
        logWatches: true
      });
    }

    $scope.logOut = function () {
      //De moment no guardem res.
      //ixStatusService.save().finally(function(){
      $timeout(function () {
        authService.logOut();
        $location.path('/login');
        ixStatusService.availApps = [];
        $scope.menu = [];
      });
      //});
    }

    $scope.sinAplicacionAbiertas = function () {
      var aplicaciones_abiertas = ixStatusService.availApps.filter(function (e) { return e.open; });
      return (aplicaciones_abiertas.length == 0);
    };

    $scope.changeLanguage = function (langKey, startingApp) {
      if (angular.isUndefined(langKey) || langKey == "") langKey = cfg.defaultAppLanguage;
      if (!startingApp)
        $http.post(cfg.baseURL + "api_usuarios/ChangeLanguage?Language=" + langKey, { Language: langKey });
      $translate.refresh(langKey);//Si no volem que cada cop que es canvia l'idioma es recarreguin les traduccions desde la api comentar aquesta línea.
      $translate.use(langKey).then(function () {
        // ui-grid utilitza el i18nService per imprimir els textos.
        var i18nLang = (langKey.indexOf('_') == -1) ? langKey : langKey.substr(0, langKey.indexOf('_'));
        //[04/05/2021] - Modificado porque la codificación del $translate service para el catalán (ca) no coincide con la codificación i18nService (es-ct)
        if (i18nLang == 'ca')
          i18nService.setCurrentLang('es-ct');
        else
          i18nService.setCurrentLang(i18nLang);
        if (angular.isDefined($scope.menu) && $scope.menu.length > 0) {
          $scope.calcMenuWidth();
        }
        $rootScope.$broadcast('gridsRefreshLanguage');
      });
    };

    $scope.calcMenuWidth = function () {
      $timeout(function () {
        //angular.element("#user-menu").smartmenus();
        angular.element("#user-menu").smartmenus('refresh').show();
        angular.element("#main-menu").smartmenus('refresh').show();
        ixMenuMoreFunction(jQuery);
        var smartmenus = angular.element("#main-menu").data('smartmenus');
        var ixMenuMoreExecute = ixMenuMore.bind(smartmenus);
        ixMenuMoreExecute(false);
      });
    };

    $scope.go = function (path, pageAnimationClass) {
      if (typeof (pageAnimationClass) === 'undefined') { // Use a default, your choice				
        var pageAnimationSuffix = "";
        if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
          pageAnimationSuffix = "-" + cfg.pageAnimation;

        $rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix;
      }
      else { // Use the specified animation
        $rootScope.pageAnimationClass = pageAnimationClass;
      }
      if (path === 'back') { // Allow a 'back' keyword to go to previous page
        $window.history.back();
      }
      else { // Go to the specified path
        $location.path(path);
      }
    }


    if (!cfg.baseURL) {
      $scope.logOut();
    }

    $scope.isLoggedIn = function () {
      return authService.authentication.isAuth;
    };

    $scope.$on('userLoggedIn', function () {

      var currentApp = $location.absUrl();
      if (currentApp.indexOf("login") != -1)
        currentApp = currentApp.substring(0, currentApp.indexOf("login"));
      if (currentApp.lastIndexOf("/") == currentApp.length - 1)
        currentApp = currentApp.substring(0, currentApp.length - 1);

      currentApp = currentApp.substring(currentApp.indexOf(cfg.appURL), cfg.appURL.length);

      if (currentApp == cfg.appURL) {
        //Tant el GP4 com les Extranet permetràn programar llistats només si el valor d'aquesta estiqueta és 1.
        //if(angular.isUndefined($rootScope.ixPermiteProgramar)){
        //					checkPermission($http, cfg, "PermiteProgramar").then(function(result){
        //						$rootScope.ixPermiteProgramar = result;
        //					});
        //}


        $scope.esExtranet = (cfg.clientId == "Extranet" || cfg.clientId == "ExtranetVideo");
        cfg.minLengthBuscaChasis = cfg.minLengthBuscaChasis || 4;
        $scope.mostraBusquedaVIN = $scope.esExtranet;
        if ($scope.esExtranet) {
          //Sol·lució temporal per el problema de firewall d'extranet.
          //ixPing($interval, $http, cfg);
        }
        $http.get(cfg.baseURL + 'api_usuarios/CurrentUser').then(function (response) {
          $scope.user = response.data.usuario;
          $scope.changeLanguage($scope.user.idioma, true);

          //$scope.perfiles = response.data.perfiles;
          //Guardem el clientId que retorna la API.

          cfg.clientId = $scope.user.client_id;
          $scope.authentication.perfiles = response.data.perfiles;
          $scope.allowedMenus = response.data.menus;
          $rootScope.$broadcast('currentUserLoaded');
          //Carreguem les apps favorites.
          ixStatusService.load().then(function (favApps) {
            $scope.favApps = favApps;
            $scope.menu = buildMenus();
            $scope.menu.splice(1);
            $scope.menu = $scope.menu.filter(hasPermission, "");
            if($scope.menu.length==1 && $scope.menu[0].children.length==1 && $scope.menu[0].children[0].children) {
              // si sólo hay un nodo en el primer nivel de menus, lo aplanamos
              $scope.menu[0].children = $scope.menu[0].children[0].children;
            }            
            //						$timeout(function() {
            //							//angular.element("#user-menu").smartmenus();
            //							angular.element("#user-menu").smartmenus('refresh').show();
            //							angular.element("#main-menu").smartmenus('refresh').show();
            //							ixMenuMoreFunction(jQuery);
            //							var smartmenus = angular.element("#main-menu").data('smartmenus');
            //							var ixMenuMoreExecute = ixMenuMore.bind(smartmenus);
            //							ixMenuMoreExecute(false);
            //						});
            $scope.calcMenuWidth();
          });
        }).catch(function (response) {
          $log.error("error", response);
          $location.path('/login');
        });
      } else {
        authService.logOut();
        $location.path('/login');
      }

    });


    authService.fillAuthData();
    $scope.authentication = authService.authentication;
    if (!authService.authentication.isAuth) {
      $location.path('/login');
    } else {
      $rootScope.$broadcast('userLoggedIn');
    }

    /** expose constants to view */
    $scope.k = k;


    $scope.openModal = function (template, scope, size) {
      return $uibModal.open({
        templateUrl: template,
        size: size || 'lg',
        scope: scope,
        backdrop: 'static',
        keyboard: false
      }).result;
    };

    $scope.openModalV2 = function (template, options, size, params) {
      var defaultOptions = {
        templateUrl: template,
        size: size || 'lg',
        backdrop: 'static',
        keyboard: false
      };
      if (angular.isDefined(options.scope)) {
        defaultOptions.scope = options.scope;
        delete options.scope;
      }

      if (angular.isDefined(params)) {
        if (angular.isUndefined(defaultOptions.resolve)) {
          defaultOptions.resolve = {};
        }
        angular.forEach(params, function (value, key) {
          defaultOptions.resolve[key] = function () { return value; };
        });
      }

      angular.merge(defaultOptions, options);
      if (options.returnInstance)
        return $uibModal.open(defaultOptions);
      else
        return $uibModal.open(defaultOptions).result;
    };

    function hasPermission(node) {
      var vm = this;
      if (node.children) {
        node.children = node.children.filter(hasPermission, vm + (angular.isDefined(node.display) ? "/" + node.display : ""));
        return node.children.length > 0;
      } else {
        var pathApp = vm + "/" + node.display;
        if (node.href && ($scope.allowedMenus.indexOf(pathApp) != -1 || $scope.authentication.perfiles.some(function (e) { return e.toUpperCase().indexOf("IXNET") !== -1; }))) {
          var esFav = $scope.favApps.some(function (e) { return e.display === node.display && e.href === node.href; });
          if (esFav) { node.fav = true; }
          ixStatusService.availApps.unshift(angular.copy(node));
          return true;
        } else {
          return false;
        }
      }
    }


    $scope.setFocus = function (id) {
      $timeout(function () {
        var element = $window.document.getElementById(id);
        if (element) {
          element.focus();
        }
      });
    };

    /* establece el focus en el primer elemento ng-invalid-XXXX visible */
    $scope.setFocusError = function (error) {
      $timeout(function () {
        var visibleInvalids = angular.element.find('.ng-invalid-' + error + ':visible');
        if (angular.isDefined(visibleInvalids && visibleInvalids.length > 1)) {
          //console.log("setting focus to ", visibleInvalids[1]);
          visibleInvalids[1].focus();
        }
      }, 100);
      return;
    };

    $rootScope.numberOfErrors = function (form) {
      var count = 0;
      if (form) {
        angular.forEach(Object.keys(form.$error), function (val) {
          if (angular.isArray(form.$error[val]) && skipValidationErrors().indexOf(val) == -1) {//Mirem si té errors i si aquests no s'han d'ignorar.
            count += form.$error[val].length;
          }
        });
        (count == 0) ? form.$invalid = false : form.$invalid = true;
      }
      return count;
    };


    // for datepickers
    $scope.isOpen = {}
    $scope.switchOpen = function ($event, name) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.isOpen[name] = !$scope.isOpen[name];
    };

    /**
     * Funció per recuperar de forma asyncrona resultats per a uib-typeahead
     *
     * entity: nom de l'entitat a fer el Seaarch
     * fields: string or array[string] - nom dels camps de filtre
     * values: string or array[string] - valors per filtrar (es pot passar $viewValue)
     * cmps: int o arrat[int]  - comparadors a aplicar (Contatns CMP_*) [default: CMP_LIKE]
     * nots: bool o array[bool] - degar o no condicions [default: false]
     * orderBy: array[string] noms dels cams a ordenar (-desc) [default: el mateix que fields]
     *
     */
    $scope.typeahead = function (entity, fields, values, cmps, nots, orderBy) {

      var searchParam = { Filters: [] };

      if (fields.constructor === Array) {
        if (!cmps) cmps = [];
        if (!nots) nots = [];
        if (!orderBy) orderBy = fields;
        fields.forEach(function (f, i) {
          if (!cmps[i]) cmps[i] = CMP_LIKE;
          if (!nots[i]) nots[i] = false;

          searchParam.Filters.push({ Field: fields[i], Value: values[i], Operator: cmps[i], Not: nots[i] })

        })
      } else {
        if (!cmps) cmps = CMP_LIKE;
        if (!nots) nots = false;
        if (!orderBy) orderBy = [fields];
        searchParam.Filters.push({ Field: fields, Value: values, Operator: cmps, Not: nots })
      }
      searchParam.OrderBy = orderBy;

      return $http.post(cfg.baseURL + entity + '/Search?Page=1&ItemsPerPage=10', searchParam).then(function (response) {
        return response.data.Items;
      });
    };

    // Validators
    $scope.validateIBAN = function (val) { return !val || $window.IBAN.isValid(val) };
    $scope.validateTIME = function (val) {
      var regex = /([01]\d|2[0-3]):([0-5]\d)/;
      return !val || regex.test(val);
    };

    //Per tancar campaneta despres de X segons:
    //TODO: S'hauria de crear una directiva per la campaneta i moure aquesta funció i la de numberOfErrors dintre de la directiva. D'aquesta manera podrem accedir a aquestes funcions.
    //desde popup, pantalla amb grid, etc.
    $rootScope.openIfChanges = function (form, status) {
      if (form) {
        deleteSkippedValidations(form.$error, skipValidationErrors());
        //Just acavem d'entrar a la pantalla o hem gravat a API. No mostrem el detall del warning.
        if (((status) && status.response) && status.response.data || !status.deleteEnabled) {
          $scope.oldForm = angular.copy(form);
          $scope.showNotif = false;
          return false;
        }
        if (((angular.isDefined($scope.oldForm) && angular.isDefined(form))) && angular.isDefined($scope.oldForm.$error) && !angular.equals(form.$error, $scope.oldForm.$error)) {
          $scope.showNotif = true;
          angular.forEach(Object.keys(form.$error), function (error) {//si hi ha menys errors no ensenyem la caixa.
            if (angular.isDefined(form.$error[error]) && angular.isDefined($scope.oldForm.$error[error]) && form.$error[error].length < $scope.oldForm.$error[error].length) {
              $scope.showNotif = false;
            }
          });
          $scope.oldForm = angular.copy(form);
          if ($scope.showNotif == true) {
            $timeout(function () {
              $scope.showNotif = false;
            }, 3000);
          }
        }
        $scope.oldForm = angular.copy(form);
      }
      return true;
    };

    $rootScope.openIfError = function (status) {
      if (status) {
        if (status.response) {
          if (status.response.data) {
            if (((status.response.data.GlobalMessage != null)) && (status.response.data.GlobalMessage.ErrType) && status.response.data.GlobalMessage.ErrType == 2 && !angular.equals(status.response.data, $scope.oldStatus)) {
              $scope.showErrorNotif = true;
            }
          }
          $scope.oldStatus = angular.copy(status.response.data);
        }
      }
      if ($scope.showErrorNotif == true) {
        $timeout(function () {
          $scope.showErrorNotif = false;
        }, 3000);
      }
      return true;
    };

    $scope.refreshSliders = function () {
      $timeout(function () {
        $log.log("Refreshing sliders");
        $scope.$broadcast('rzSliderForceRender');
      });
    };

    // helper & utility functions

    /** length of a dictionary */
    $scope.length = function (obj) {
      if (obj) {
        return Object.keys(obj).length;
      } else {
        return 0;
      }
    }

  }]);

  angular.module('gp4App').controller('LoginController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', 'gridConfigService', function ($rootScope, $scope, $location, authService, $http, cfg, $log, gridConfigService) {
    //$scope.timeDiffs = [];
    gridConfigService.clearGridMetadata();
    $scope.frameClass = 'page-login';
    $scope.loginData = {
      userName: authService.authentication.userName,
      password: "",
      domain: authService.authentication.domain,
      api: "",
      serverTimeZone: ""
    };

    $http.get('config.json').success(function (configData) {
      if (!configData) {
        throw new Error('Config.json sin configurar');
      }
      else {
        $scope.allApis = configData;
        $scope.loginData.api = cfg;
        RefreshDominios();
        //Si nomes tenim una api a config.json la marquem.
        if (configData.length == 1) {
          $scope.loginData.api = configData[0];
          $scope.ChangeAPI();
        }
      }
    });

    $scope.ChangeAPI = function () {
      angular.extend(cfg, $scope.loginData.api);
      RefreshDominios();
      //$scope.timeDiffs = cfg.timeDiff;
      //if($scope.timeDiffs.length == 1){
      //$scope.loginData.timeDiff = $scope.timeDiffs[0];
      //}
    };

    $scope.message = "";

    $scope.login = function () {
      $scope.message = '';
      authService.login($scope.loginData).then(function (response) {
        $log.log("login OK", response);
        $rootScope.$broadcast('userLoggedIn');
        $location.path('/');
      },
        function (err) {
          $log.error("error login?", err);
          $scope.message = err;
        });
    };

    if (authService.authentication.isAuth) {
      $location.path('/');
    }

    function RefreshDominios() {
      if (cfg.clientId == "GPv4") {
        $http.get(cfg.baseURL + "api_dominios").then(function (response) {
          $scope.allDomains = response.data.map(function (e) { return e.dominio; });
          if ($scope.allDomains.length == 1) {
            $scope.loginData.domain = $scope.allDomains[0];
          }
          else {
            $scope.loginData.domain = "";
          }
        });
      } else {
        $scope.allDomains = new Array();
      }
    }
  }]);

  angular.module('gp4App').controller('ChangePasswordController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', '$timeout', function ($rootScope, $scope, $location, authService, $http, cfg, $log, $timeout) {
    $scope.frameClass = 'page-login';

    $scope.valid = false;
    $scope.data = {};
    $scope.data.usuario = authService.authentication.userName;

    $scope.message = { Msg: "El password debe tener un mínimo de 8 carácteres", ErrType: 0 };

    $scope.send = function () {
      if ($scope.data.newpassword === $scope.data.repetir) {
        $http.post(cfg.baseURL + "api_usuarios/ChangePassword", $scope.data).then(function (response) {
          $scope.message = response.data.GlobalMessage;
          if (response.data.Result) {
            $timeout(function () { $location.path('/'); }, 2000);
          }
        }, function (err) {
          $scope.message = err.data.GlobalMessage;
        });
      } else {
        $scope.message = { Msg: "Password no coincide", ErrType: 2 };
      }
    };

  }]);


  /* ix-editable: Direciva de atributo. Añadida a un input hace que se active/desactive segín el estado editing del formulario */
  angular.module('gp4App').directive('ixEditable', [function () {
    return {
      restrict: 'A',
      link: function (scope, element) {
        scope.$watch('editing', function () {
          element[0].disabled = !scope.editing;
        });
      }
    };
  }]);

  /* ix-after-fixed-header: Directiva de atributo. Añade padding que queda debajo de un fixed header */
  angular.module('gp4App').directive('ixAfterFixedHeader', ['$window', '$timeout', function ($window, $timeout) {
    return {
      link: function (scope, el) {

        $timeout(function () {
          var height = angular.element(".fixed").outerHeight();
          el.css({ "padding-top": height + "px" });
        }, 1000);

        angular.element($window).on('resize', function () {
          var height = angular.element(".fixed").outerHeight();
          el.css({ "padding-top": height + "px" });
          //		    	el.height(height);
        });
      }
    }
  }]);





  angular.element(document).find('head').prepend('<style type="text/css">input[ix-number] {text-align: right} input[ix-number]:focus {text-align: left}</style>');

  /**
   * Directive to jump to next control on Enter keypress (like Tab)
   * TODO: shift+Enter?
   */
  angular.module('gp4App').directive('input', [function () {
    return function (scope, element, attrs) {
      element.on('keypress', function (e) {
        var keyCode = (e.keyCode ? e.keyCode : e.which);
        //Si hi ha un checkbox i s'apreta espai el marquem
        //Comprovar perque no funciona.
        if (attrs.type === 'checkbox') {
          if (keyCode == 32) {
            element.trigger('click');
            scope.$apply();
          }
        }
        if (keyCode == 13) {  // focus to next input on keypress Enter
          var nextinput = angular.element(':input:not(textarea):visible:enabled:eq(' + (angular.element(':input:not(textarea):visible:enabled').index(element) + 1) + ')');
          if (nextinput) {
            if (nextinput[0].closest('div.ui-grid-filter-container') == null)
              nextinput.focus();
            //els controls de grid, per exemple, la data, no possen el valor al fer intro si es fa el preventDefault.
            if (element[0].closest('div.ui-grid-cell') == null && element[0].closest('div.div-login') == null) {
              e.preventDefault();
            }
            element.blur();
          }
        }
      });
    };
  }]);





  /* default options for ui.bootstrap.datepicker and ui.bootstrap.timepicker */
  angular.module('gp4App').config(['uibDatepickerConfig', 'uibDatepickerPopupConfig', 'uibTimepickerConfig', function (uibDatepickerConfig, uibDatepickerPopupConfig, uibTimepickerConfig) {
    uibDatepickerConfig.startingDay = 1;
    uibDatepickerConfig.showWeeks = true;
    uibDatepickerPopupConfig.datepickerPopup = "dd/MM/yyyy";

    uibTimepickerConfig.showMeridian = false;
    uibTimepickerConfig.showSpinners = false;
  }]);

  /* default options para angular-ivh-treeview */
  angular.module('gp4App').config(['ivhTreeviewOptionsProvider', function (ivhTreeviewOptionsProvider) {
    ivhTreeviewOptionsProvider.set({
      twistieExpandedTpl: '<i class="fa fa-fw fa-minus-square-o"></i>',
      twistieCollapsedTpl: '<i class="fa fa-fw fa-plus-square-o"></i>',
      twistieLeafTpl: '<i class="fa fa-fw"></i>'
    });
  }]);

  angular.module('gp4App').config(['$provide', function ($provide) {

    $provide.decorator('ivhTreeviewDirective', function ($delegate) {
      var directive = $delegate[0];

      directive.template = [
        '<ul class="ivh-treeview">',
        '<li ng-repeat="child in root | ivhTreeviewAsArray | filter: trvw.getFilter() | limitTo:100"',
        'ng-hide="trvw.hasFilter() && !trvw.isVisible(child)"',
        'class="ivh-treeview-node"',
        'ng-class="{\'ivh-treeview-node-collapsed\': !trvw.isExpanded(child) && !trvw.isLeaf(child)}"',
        'ivh-treeview-node="child"',
        'ivh-treeview-depth="0">',
        '</li>',
        '</ul>'
      ].join('\n');
      return $delegate;
    });
  }]);

  angular.module('gp4App').config(['$provide', function ($provide) {
    $provide.decorator('dateFilter', ['$delegate', 'cfg', 'moment', function ($delegate, cfg, moment) {
      var srcFilter = $delegate;

      var extendsFilter = function () {
        var mainArguments = Array.prototype.slice.call(arguments);
        if (mainArguments.length == 2 && angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)) {
          var GMT = "+0100";
          if (angular.isDate(mainArguments[0])) {

            var datePickerTime = moment(mainArguments[0]).format("HH:mm");
            var currentLocalTime = moment(new Date()).format("HH:mm");

            if (datePickerTime == currentLocalTime) {
              mainArguments[0].setHours(0, 0, 0, 0);
            }

            var horaServidor = moment(mainArguments[0]).tz(cfg.serverTimeZone);
            GMT = horaServidor.format("ZZ");
          }
          mainArguments.push(GMT);
        }
        var res = srcFilter.apply(this, mainArguments);
        return res;
      }

      return extendsFilter;
    }])
  }]);


  /*function MomentFactory($window) {
    if(!$window.moment){
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window.moment;
  }*/

  // Define dependencies
  //MomentFactory.$inject = ['$window'];

  // Register factory
  //angular.module('gp4App').factory('moment', MomentFactory);

  angular.module('gp4App').factory('moment', ['$window', function ($window) {
    if (!$window.moment) {
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window.moment;
  }]);

  angular.module('gp4App').factory('lodash', ['$window', function ($window) {
    if (!$window._) {
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window._;
  }]);

  /* definim un decorator per sobreescriure uiGridCellNavService */
  angular.module('gp4App').config(['$provide', function ($provide) {
    $provide.decorator('uiGridCellNavService', ['$delegate', 'uiGridConstants', 'uiGridCellNavConstants', 'ixStatusService', 'cfg', function ($delegate, uiGridConstants, uiGridCellNavConstants, ixStatusService, cfg) {
      //var getDirection = $delegate.getDirection;
      $delegate.getDirection = function (evt) {
        if (cfg.gridNavMode == 1) {
          if (evt.keyCode !== uiGridConstants.keymap.LEFT && evt.keyCode !== uiGridConstants.keymap.RIGHT
            && evt.keyCode !== uiGridConstants.keymap.UP && evt.keyCode !== uiGridConstants.keymap.DOWN
            && evt.keyCode !== uiGridConstants.keymap.TAB && evt.keyCode !== uiGridConstants.keymap.ENTER) {
            ixStatusService.current.ixCellNav = false;
          }
          else if (evt.keyCode === uiGridConstants.keymap.TAB || evt.keyCode === uiGridConstants.keymap.ENTER || evt.keyCode === uiGridConstants.keymap.UP && evt.keyCode === uiGridConstants.keymap.DOWN) {
            ixStatusService.current.ixCellNav = true;
          }
        } else {
          ixStatusService.current.ixCellNav = false;
        }

        if ((evt.keyCode === uiGridConstants.keymap.LEFT && (!ixStatusService.current.editing || ixStatusService.current.ixCellNav)) ||
          (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {
          return uiGridCellNavConstants.direction.LEFT;
        }
        if ((evt.keyCode === uiGridConstants.keymap.RIGHT && (!ixStatusService.current.editing || ixStatusService.current.ixCellNav)) ||
          (evt.keyCode === uiGridConstants.keymap.TAB || evt.keyCode === uiGridConstants.keymap.ENTER)) {
          return uiGridCellNavConstants.direction.RIGHT;
        }

        if (evt.keyCode === uiGridConstants.keymap.UP ||
          (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey)) {
          return uiGridCellNavConstants.direction.UP;
        }

        if (evt.keyCode === uiGridConstants.keymap.PG_UP) {
          return uiGridCellNavConstants.direction.PG_UP;
        }
        // delete listener for key ENTER
        if (evt.keyCode === uiGridConstants.keymap.DOWN) {
          return uiGridCellNavConstants.direction.DOWN;
        }
        // original code
        /*if (evt.keyCode === uiGridConstants.keymap.DOWN ||
          evt.keyCode === uiGridConstants.keymap.ENTER) {
          return uiGridCellNavConstants.direction.DOWN;
        }*/

        if (evt.keyCode === uiGridConstants.keymap.PG_DOWN) {
          return uiGridCellNavConstants.direction.PG_DOWN;
        }

        return null;
      };
      return $delegate;
    }]);
  }]);

  /* definim un decorator per fer que si escrivim una lletra mentre tenim el dropdown sel·leccionat, aquest es desplegui filtrant per aquesta lletra. */
  angular.module('gp4App').config(['$provide', function ($provide) {
    $provide.decorator('uiGridEditService', ['$delegate', 'uiGridConstants', 'ixStatusService', '$rootScope', '$timeout', function ($delegate, uiGridConstants, ixStatusService, $rootScope, $timeout) {
      $delegate.isStartEditKey = function (evt) {
        if (evt.ctrlKey) {
          if (evt.keyCode == 86) {
            return true;
          }
          return null;
        } else if ((evt.keyCode >= 48 && evt.keyCode <= 57) || (evt.keyCode >= 65 && evt.keyCode <= 90) || (evt.keyCode >= 96 && evt.keyCode <= 122)) {
          if ($rootScope.typedText)
            $rootScope.typedText = $rootScope.typedText + evt.key;
          else
            $rootScope.typedText = evt.key;
          return true;
        } else if (evt.keyCode == 32) {//espai
          return true;
        }
        return null;
      };
      return $delegate;
    }]);
  }]);

  //decorem el $http per codificar tots els caràcters especials que viatgin a la url (excluint la query string), excepte [, / ? : & = + $ #].
  //Si es volguessin codificar més, fer-ho concatenant .replace.
  //	angular.module('gp4App').config(['$provide', function($provide){
  //		$provide.decorator('$httpBackend', [ '$delegate', '$sanitize', function ($delegate, $sanitize) {
  //				var decoratedHttpBackend = function (method, url, data, callback, headers, timeout, withCredentials, responseType) {
  //					var url_without_query_string = url;
  //					var query_string = "";
  //					if(url.lastIndexOf("?") != -1){
  //						url_without_query_string = url_without_query_string.substr(0, url.lastIndexOf("?"));
  //						query_string = url.substr(url.lastIndexOf("?"));
  //					}
  //
  //					url_without_query_string = encodeURI( url_without_query_string ).replace(/[!'()]/g, escape).replace(/\*/g, "%2A").replace(/\@/g, "%40");
  //
  //					url = url_without_query_string + query_string;
  //
  //					return $delegate.call(this, method, url, data, callback, headers, timeout, withCredentials, responseType);
  //				};
  //
  //				for (var key in $delegate) {
  //					if ($delegate.hasOwnProperty(key)) {
  //						decoratedHttpBackend[key] = $delegate[key];
  //					}
  //				}
  //				return decoratedHttpBackend;
  //		}]);
  //  }]);

  /* diem que el tema per defecte per el ui-select es el select2 */
  angular.module('gp4App').config(['uiSelectConfig', function (uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
  }]);

  angular.module('gp4App').config(['pdfjsViewerConfigProvider', function (pdfjsViewerConfigProvider) {
    pdfjsViewerConfigProvider.setWorkerSrc("/assets/pdf.js-viewer/pdf.worker.js");
  }]);

  angular.module('gp4App').run(function ($templateCache, $window, $rootScope, uiGridEditConstants, ixStatusService, cfg, $location) {
    //Al sobreescriure els templates del check de sel·lecció de row, si aquest conté un control, la grid no creix correctament al aplicar filtres.
    /*$templateCache.put('ui-grid/selectionRowHeaderButtons',
      "<div class=\"ui-grid-selection-row-header-buttons \" ng-class=\"{'ui-grid-row-selected': row.isSelected}\"><div class=\"checkbox\" abm-checkbox style=\"padding: 0px;\"><input style=\"margin: 0; vertical-align: middle\" type=\"checkbox\" ng-model=\"row.isSelected\" ng-click=\"row.isSelected=!row.isSelected;selectButtonClick(row, $event)\">&nbsp;</div></div>"
    );*/
    /*$templateCache.put('ui-grid/selectionSelectAllButtons',
      "<div class=\"ui-grid-selection-row-header-buttons \" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-if=\"grid.options.enableSelectAll\"><div class=\"checkbox\" abm-checkbox style=\"margin-left: 3px;margin-top: -3px;\"><input style=\"margin: 0; vertical-align: middle\" type=\"checkbox\" ng-model=\"grid.selection.selectAll\" ng-click=\"grid.selection.selectAll=!grid.selection.selectAll;headerButtonClick($event)\"></div></div>"
    );*/

    $templateCache.put("TEMA_GRID/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
    $templateCache.put("TEMA_GRID/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
    $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
    $templateCache.put("TEMA_GRID/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
    $templateCache.put("TEMA_GRID/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");

    $templateCache.put("TEMA_GRID/match.tpl.html", "<div class=\"ui-grid-cell\"><div class=\"ui-grid-cell-contents\" ng-click=\"$select.toggle($event)\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></div></div>");


    $templateCache.put('checkboxCell', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="COL_FIELD" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="checkboxClick($parent.$parent, $parent.$parent.col)"></div>');


    //		$templateCache.put('checkboxCellFT', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="{{ COL_FIELD == 1 || COL_FIELD == true || COL_FIELD == \'True\' }}" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="checkboxClick($parent.$parent, $parent.$parent.col)"></div>');
    $templateCache.put('checkboxCellFT', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="{{ COL_FIELD == 1 }}" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="checkboxClick($parent.$parent, $parent.$parent.col)"></div>');

    //$templateCache.put('checkboxEditCell', '<div class="ix-cell-focus checkbox" abm-checkbox><input type="checkbox" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-checked="COL_FIELD" ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent, $parent.$parent.col)"></div>');


    //$templateCache.put('checkboxCell', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="COL_FIELD" ng-model="MODEL_COL_FIELD" ng-disabled="!$parent.$parent.grid.api.ix.status.editing || $parent.col.colDef.noeditable || $parent.$parent.row.entity.obligatorio || $parent.$parent.grid.api.ix.disableField($parent, col)" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent.$parent.$parent.$parent, $parent.$parent.col)"></div>');
    //$templateCache.put('checkboxEditCell', '<div class="ix-cell-focus checkbox" abm-checkbox><input type="checkbox" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-checked="COL_FIELD" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent.$parent.$parent.$parent, $parent.$parent.col)"></div>');
    $templateCache.put('iconCell', '<div ng-dblclick="$parent.grid.api.ix.showPopup($parent, col, $event)" class ="ui-grid-cell-contents"><i ng-click="$parent.grid.api.ix.showPopup($parent, col)" class="fa fa-fw fa-edit"></i></div>');
    $templateCache.put('listCellNormal', '<div class=\"ui-grid-cell-contents\" title=\"MODEL_COL_FIELD\"><textarea style=\"border: 0; width: 100%; height: 100%">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></div>');
    $templateCache.put('listCell', '<form class=""><textarea ui-grid-editor ng-model="MODEL_COL_FIELD" style=\"width: 100%; height: auto; overflow: auto;">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></form>');
    $templateCache.put('listCellFT', '<form class=""><textarea autosize ui-grid-editor ng-model="MODEL_COL_FIELD" style=\"width: 100%; height: auto; overflow: hidden;">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></form>');
    //Arnau: Aquests 3 radio a continuació són de la Extranet. Moure-ho en quan tinguem els paquets de bower.
    $templateCache.put('radioPeticioTransportCell', '<input type="radio" ng-model="$parent.grid.appScope.idDestino" ng-value="$parent.row.entity.destino" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'idDestino\', $parent.row.entity.destino)" />');
    $templateCache.put('radioPeticioTransportDistCell', '<input type="radio" ng-show="$parent.grid.appScope.idDestino == $parent.row.entity.destino" ng-model="$parent.grid.appScope.distribucionRecojo" value="D" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'distribucionRecojo\', $parent.grid.appScope.distribucionRecojo)" />');
    $templateCache.put('radioPeticioTransportRecCell', '<input type="radio" ng-show="$parent.grid.appScope.idDestino == $parent.row.entity.destino" ng-model="$parent.grid.appScope.distribucionRecojo" value="R" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'distribucionRecojo\', $parent.grid.appScope.distribucionRecojo)" />');


    //Grid
    $templateCache.put('app/base/views/grid/ixGridProgress', '<div class="ui-grid-cell-contents" title="TOOLTIP"><uib-progressbar value="COL_FIELD" type="danger" animate="false"></uib-progressbar></div>');
    $templateCache.put('app/base/views/grid/uiGridSortableCell', '<div><div class="ui-grid-cell-contents" ng-click="grid.appScope.orderInRow(grid, row, col)" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}} <i ng-class="{ \'ui-grid-icon-up-dir\': row.entity.orderby == \'asc\', \'ui-grid-icon-down-dir\': row.entity.orderby == \'desc\' }"><sub ui-grid-visible="grid.appScope.isSortPriorityVisible(grid, row, col)" class="ui-grid-sort-priority-number">{{row.priority + 1}}</sub></i></div></div>');

    $templateCache.put('app/base/views/helpers_templates/ixGridColor', '<div class="ui-grid-cell-contents" title="TOOLTIP" ix-ui-color-grid-cell ng-model="MODEL_COL_FIELD" col="col"></div>');


    var windowElement = angular.element($window);
    windowElement.on('beforeunload', function (event) {
      // Si tenemos alguna aplicacion abierta en modo edicion avisamos
      if (ixStatusService.availApps.filter(function (app) { return app.editing }).length > 0) {
        event.preventDefault();
      }
    });

    var deregisterationCallback = $rootScope.$on('$locationChangeStart', function (event, next, current) {
      //La idea final és guardar a localStorage l'objecte actual per id, el ixStatusService haurà de recuperar del localStorage.
      //Guardo la info actual i el path de la vista on anirem, per tant, ixStatusService hauria de agafar la info guardada amb el valor de next.
      //Per el que sigui, això no acaba de funcionar, ho comento i al fer F5 simplement redirecciono al desktop.
      /*localStorage.setItem(current, JSON.stringify(ixStatusService.current));
      localStorage.setItem("getview", next);*/
      if ($location.path().lastIndexOf('/') == 0) {
        $rootScope.fromDesktop = true;
      }
      if (next === current && $location.path() !== "/" && $location.path() !== "/login") {
        $location.path("/");
      } else {
        if ($location.path() === "/") {
          var pageAnimationSuffix = "";
          if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
            pageAnimationSuffix = "-" + cfg.pageAnimation;

          $rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix;
        }
      }
    });

    $rootScope.$on('$destroy', deregisterationCallback);


  });



  angular.module('gp4App').directive('ixMenu33', [function () {
    return {
      restrict: "E",
      replace: true,
      scope: {
        menu: '='
      },
      template: '<ul class="dropdown-menu"><ix-menu-item33 ng-repeat="item in menu.children" item="item"></ix-menu-item33></ul>'
      //template: '<ul class="dropdown-menu"><ix-sub-menu-item33 ng-repeat="item in menu.children" item="item">{{item.display}}</ix-sub-menu-item33></ul>'
    };
  }]);

  angular.module('gp4App').directive('ixMenuItem33', ['$compile', 'ixStatusService', '$log', function ($compile, ixStatusService, $log) {
    return {
      restrict: "E",
      replace: true,
      scope: {
        item: "="
      },
      //template: '<li><a ng-href="{{item.href}}"><i data-ng-class="item.icon" class="fa fa-fw"></i> {{item.display}}<span class="caret" ng-if="item.children.length>0"></span></a></li>',
      template: '<li><a ng-href="{{::item.href}}"><i class="material-icons">{{::item.icon}}</i> <translate>{{::item.display}}</translate><span class="caret" ng-if="item.children.length>0"></span></a></li>',
      //template: '<li class="dropdown"><a class="dropdown-toggle" data-toggle="dropdown" ng-href="{{item.href}}"><i data-ng-class="item.icon" class="fa fa-fw"></i> {{item.display}}</a></li>',
      link: function (scope, element) {
        if (angular.isArray(scope.item.children)) {
          element.append("<ix-menu33 menu='item'></ix-menu33>");
          $compile(element.contents())(scope);
        } else {
          element.bind('click', function () {
            ixStatusService.openApp(scope.item);
          });
        }
      }
    };
  }]);

  angular.module('gp4App').directive('ixMoreMenuBtn', ['ixStatusService', 'ixMoreMenuService', function (ixStatusService, ixMoreMenuService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '='
      },
      template: '<button count="{{ numberApps() }}">more {{ numberApps() }}</button>',
      link: function (scope, element) {
        scope.numberApps = function () {
          return ixMoreMenuService.getNumberMenus();
        };
      }
    }
  }]);

  angular.module('gp4App').directive('ixSubMenu33', [function () {
    return {
      restrict: "E",
      replace: true,
      scope: {
        menu: '='
      },
      template: '<ul class="dropdown-menu"><ix-sub-menu-item33 ng-repeat="item in menu.children" item="item">{{::item.display}}</ix-sub-menu-item33></ul>'
    };
  }]);

  angular.module('gp4App').directive('ixSubMenuItem33', ['$compile', 'ixStatusService', '$log', function ($compile, ixStatusService, $log) {
    return {
      restrict: "E",
      replace: true,
      scope: {
        item: "="
      },
      template: '<li ng-class="{\'dropdown dropdown-submenu\':haveChildren()}" ng-click="openSubMenu($event)"><a  class="dropdown-toggle" data-toggle="dropdown" ng-href="{{item.href}}"><i data-ng-class="item.icon" class="fa fa-fw"></i> {{item.display}}</a></li>',
      link: function (scope, element) {
        scope.haveChildren = function () {
          return angular.isArray(scope.item.children);
        }
        scope.openSubMenu = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          element.siblings().removeClass('open');
          element.toggleClass('open');
        }
        if (angular.isArray(scope.item.children)) {
          element.append("<ix-sub-menu33 menu='item'></ix-sub-menu33>");
          $compile(element.contents())(scope);
        } else {
          element.bind('click', function () {
            ixStatusService.openApp(scope.item);
          });
        }
      }
    };
  }]);

  angular.module('gp4App').directive('ixToolBar', [function () {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/base/views/framework_templates/ixToolBar.html',
      link: function (scope, elem, attrs) {
        scope.hideHeader = false;
        scope.hideButtons = false;
        scope.specialToolBar = false;
        if (angular.isDefined(attrs.hideheader) && attrs.hideheader == "true") {
          scope.hideHeader = true;
        }
        if (angular.isDefined(attrs.hidebuttons) && attrs.hidebuttons == "true") {
          scope.hideButtons = true;
        }
        if (angular.isDefined(attrs.specialToolBar) && attrs.specialToolBar == "true") {
          scope.specialToolBar = true;
        }
        //open popup
        scope.openPopup = function (responseData) {
          scope.openModal("app/base/views/framework_templates/ixErrorsPopup.html", scope, "small");
        };
        scope.downloadTxt = function (responseData) {
          var errorsTxt = "";
          angular.forEach(scope.status.response.data.Errors, function (err) {
            if (angular.isDefined(err) && err != null)
              errorsTxt += err.Msg + "\r\n";
          });
          if ((angular.isDefined(scope.status.response.data.obj)) && scope.status.response.data.obj.Errors) {
            angular.forEach(scope.status.response.data.obj.Errors, function (err) {
              if (angular.isDefined(err) && err != null)
                errorsTxt += err.Msg + "\r\n";
            });
          }
          angular.forEach(scope.status.response.data.Inserted, function (ins) {
            angular.forEach(ins.Errors, function (err) {
              if (angular.isDefined(err) && err != null)
                errorsTxt += err.Msg + "\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Updated, function (upd) {
            angular.forEach(upd.Errors, function (err) {
              if (angular.isDefined(err) && err != null)
                errorsTxt += err.Msg + "\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Deleted, function (del) {
            angular.forEach(del.Errors, function (err) {
              if (angular.isDefined(err) && err != null)
                errorsTxt += err.Msg + "\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Processed, function (proc) {
            angular.forEach(proc.Errors, function (err) {
              if (angular.isDefined(err) && err != null)
                errorsTxt += err.Msg + "\r\n";
            });
          });

          var nombrePantalla = scope.status.display.split(" ").join("_");
          var data = new Blob([errorsTxt], { type: 'text/plain;charset=utf-8' });
          saveAs(data, "errores_" + nombrePantalla + ".txt");
        };
      }
    };
  }]);


  angular.module('gp4App').directive('ixGridToolBar', [function () {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      templateUrl: 'app/base/views/framework_templates/ixGridToolBar.html'
    };
  }]);

  angular.module('gp4App').directive('ixPopupToolBar', ['$parse', function ($parse) {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/base/views/framework_templates/ixPopupToolBar.html',
      link: function (scope, elem, attrs) {
        (attrs.titleLeft) ? scope.titleLeft = attrs.titleLeft : scope.titleLeft = "";
        (attrs.titleCenter) ? scope.titleCenter = attrs.titleCenter : scope.titleCenter = "";
        if (angular.isDefined(attrs.okBtnText)) scope.okBtnText = attrs.okBtnText;
        if (angular.isDefined(attrs.closeBtnText)) scope.closeBtnText = attrs.closeBtnText;

        if (angular.isDefined(attrs.hideAll)) scope.hideAll = true;

        if (attrs.titleLeftParam) {
          scope.$watch(attrs.titleLeftParam, function (val) {
            scope.titleLeftParam = val;
          });
        } else {
          scope.titleLeftParam = "";
        }

        if (attrs.titleCenterParam) {
          scope.$watch(attrs.titleCenterParam, function (val) {
            scope.titleCenterParam = val;
          });
        } else {
          scope.titleCenterParam = "";
        }
      }
    };
  }]);

  angular.module('gp4App').directive('ixCestaVehiculos', ['ixCestaVehiculosService', 'ixStatusService', 'cfg', function (ixCestaVehiculosService, ixStatusService, cfg) {
    return {
      restrict: "E",
      replace: true,
      template: '<a ng-show="isVisible()" ng-click="openPopup()"><i class="fa fa-car fa-lg"></i><span class="badge">{{ cesta.getCount() }}</span></a>',
      link: function (scope) {

        scope.cesta = ixCestaVehiculosService;

        scope.openPopup = function () {
          //Agafem l'array i substituim totes les comes per salts de linea. El textarea fa ús d'aquesta variable.
          scope.vehiculos = [];
          if (angular.isDefined(ixCestaVehiculosService.getCesta().items)) {
            var cesta = ixCestaVehiculosService.getCesta();
            scope.vehiculos = cesta.items.toString().replace(/,/g, "\n");
            scope.campo = cesta.campo;
            scope.terminacion = cesta.terminacion;
            scope.cortar = cesta.cortar;
            scope.clientId = cfg.clientId;
          }
          scope.openModal('app/base/views/helpers_templates/ixCestaVehiculosModal.html', scope, 'med').then(function () {
            ixCestaVehiculosService.saveCesta({ items: scope.vehiculos, campo: scope.campo, terminacion: scope.terminacion, cortar: scope.cortar });
            var options = ixCestaVehiculosService.getOptions();
            if (ixStatusService.current.data != null && options.requestDataAfterSave !== false) {
              if (angular.isDefined(options.actionGrid) && angular.isFunction(options.actionGrid)) {
                options.actionGrid().ixLoadInitialData();
              } else {
                ixStatusService.current.data.grid.ixLoadInitialData();
              }
            }

          });
        }

        scope.vaciarCesta = function () {
          scope.vehiculos = ixCestaVehiculosService.emptyCesta().items;
        }

        scope.isVisible = function () {
          return ixCestaVehiculosService.isShowing();
        }
      }
    }
  }]);

  angular.module('gp4App').directive('ixBuscaFichaBastidor', ['$http', '$uibModal', 'cfg', function ($http, $uibModal, cfg) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        minLength: '@?',
        template: '@'
      },
      templateUrl: 'app/base/views/helpers_templates/ixBuscaFichaBastidor.html',
      link: function (scope, elem, attrs) {
        //scope.abrir = false;
        scope.buscar = function () {
          scope.listItems = [];
          if (scope.filtreVIN && scope.filtreVIN.length >= scope.minLength) {
            var params = { Filters: [], OrderBy: [] };
            //addToParamFilters(params.Filters, "chasis", scope.filtreVIN, CMP_LIKE);
            params.Filters.push({ Field: "chasis", Value: scope.filtreVIN, Operator: CMP_LIKE, Skip: true });
            params.Filters.push({ Field: "matricula", Value: scope.filtreVIN, Operator: CMP_LIKE, Or: true, Skip: true });

            var gp4Url = "select_bastidor/Search";
            var extranetUrl = "bastidores/GetList";

            var url = "";
            if (cfg.clientId == "Extranet" || cfg.clientId == "ExtranetVideo") {
              url = extranetUrl;
              params.OrderBy = ["-FechaEntrada", "VIN", "Matricula"];
            } else {
              url = gp4Url;
              params.OrderBy = ["-fecha_ent", "vin", "matricula"];
            }

            $http.post(cfg.baseURL + url, params).then(function (response) {
              scope.listItems = response.data.Items;
              convertDateStringsToDates(scope.listItems);
            });
          }
        }
        /*scope.abrirCerrar = function(abrir){
          scope.abrir = abrir;
        }*/

        scope.clearSearch = function () {
          scope.filtreVIN = "";
        }

        scope.open = function (item) {
          //scope.abrirCerrar(false);
          scope.title = "Ficha bastidor";
          scope.VIN = item.VIN || item.vin;
          scope.Matricula = item.Matricula || item.matricula;
          scope.Grupo = item.Grupo || item.grupo;
          scope.Movimiento = item.Movimiento || item.movimiento;
          scope.Marca = item.Marca;
          scope.Modelo = item.Modelo;
          scope.FechaEntrada = item.FechaEntrada;
          scope.FechaSalida = item.FechaSalida;
          if (angular.isDefined(item.estado_gp)) {
            scope.estado_gp = item.estado_gp;
          }
          if (angular.isDefined(item.estado_personalizado)) {
            scope.estado_personalizado = item.estado_personalizado;
          }

          $uibModal.open({
            templateUrl: scope.template,
            size: 'big',
            scope: scope
          });

          scope.filtreVIN = "";
        }
        scope.$watch('filtreVIN', function () {
          scope.buscar();
        });
      }
    }
  }]);

  //scrollbars

  angular.module('gp4App').config(['ScrollBarsProvider', function (ScrollBarsProvider) {
    ScrollBarsProvider.defaults = {
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      },
      axis: 'y', // enable 2 axis scrollbars by default
      autoHideScrollbar: false,
      theme: 'gp4',//lista de temas disponibles en http://iominh.github.io/ng-scrollbars/
      advanced: {
        updateOnContentResize: true
      }
    };
  }]);
})();

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
"use strict"

angular.module('FTBase', ['gp4Controllers', 'pdfjsViewer', 'nzToggle' ])
.config(['$routeProvider', function ($routeProvider) {
	$routeProvider
    //
		//.when('/FTBase/Listado1',{templateUrl:'app/base/views/gridEditor.html', controller:'FichasTecnicasAgrupacionController'})

		.when('/herramientas/cambioestadomasivo', { templateUrl: 'app/FTBase/Herramientas/cambio_estado_masivo.html', controller: 'CambioEstadoMasivoController' })
		.when('/herramientas/cambioeancodinternomasivo', { templateUrl: 'app/FTBase/Herramientas/eans_cod_interno_masivo.html', controller: 'EansCodInternoMasivoController' })

		//Configuración FT
		.when('/ConfiguracionPreguntas/ft_preguntas', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ConfigPreguntasController' })
		.when('/ConfiguracionPreguntas/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/ConfiguracionPreguntas"; } } })

		//Mantenimientos
		.when('/Mantenimientos/:entity/:id', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/Mantenimientos"; } } })
		.when('/Mantenimientos/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/Mantenimientos"; } } })
		.when('/MantenimientosEuromadi/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/MantenimientosEuromadi"; } } })

		//Listados
		.when('/ListadosFT/Listado_Ft', { templateUrl: 'app/FTBase/ListadosFT/listado_ft.html', controller: 'Listado_FtController'})
		.when('/ListadosFT/Listado_ProductosFt', { templateUrl: 'app/FTBase/ListadosFT/listado_productos_ft.html', controller: 'Listado_Productos_FtController'})
		.when('/ListadosFT/Listado_Productos_Marca', { templateUrl: 'app/FTBase/ListadosFT/listado_productos_marca.html', controller: 'Listado_Productos_MarcaController'})
		.when('/ListadosFT/Listado_Proveedores_Ficheros', { templateUrl: 'app/FTBase/ListadosFT/listado_proveedores_ficheros.html', controller: 'Listado_Proveedores_FicherosController'})
		.when('/ListadosFT/Listado_Ft_Fotos_Producto', { templateUrl: 'app/FTBase/ListadosFT/listado_ft_fotos_producto.html', controller: 'Listado_Ft_Fotos_ProductoController'})
		.when('/GestionFichasTecnicas/list',{ templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase"; }, entity: function($route) { $route.current.params.entity = "GestionFichasTecnicas"; } }})
		.when('/ListadosFT/Busqueda_Avanzada', { templateUrl: 'app/FTBase/ListadosFT/busqueda_avanzada.html', controller: 'Busqueda_AvanzadaController'})
		.when('/ListadosFT/Control_presencia_fotos', { templateUrl: 'app/FTBase/ListadosFT/control_presencia_fotos.html', controller: 'Control_presencia_fotosController'})
		.when('/ListadosFT/Listado_analiticas_ft', { templateUrl: 'app/FTBase/ListadosFT/listado_analiticas_ft.html', controller: 'Listado_Analiticas_FTController'})
		.when('/ListadosFT/Descarga_informes_analiticas', { templateUrl: 'app/FTBase/ListadosFT/descarga_informes_analiticas.html', controller: 'Descarga_Informes_AnaliticasController'})
		.when('/Integraciones/Planificaciones_analiticas', { templateUrl: 'app/FTBase/Integraciones/Planificaciones_analiticas/planificacion_analiticas.html', controller: 'PlanificacionAnaliticasController'})
		.when('/ListadosFT/Listado_cambio_estados_ft', { templateUrl: 'app/FTBase/ListadosFT/listado_cambio_estados_ft.html', controller: 'Listado_Cambio_Estados_FtController'})
		.when('/ListadosFT/Listado_control_envio_obs_alergenos_app', {templateUrl: 'app/FTBase/ListadosFT/listado_control_envio_obs_alergenos_app.html', controller: 'Listado_control_envio_obs_alergenos_appController'})
		.when('/ListadosFT/Listado_Fichas_Seguridad', {templateUrl: 'app/FTBase/ListadosFT/listado_emd_fichas_seguridad.html', controller: 'Listado_emd_fichas_seguridadController'})
		.when('/ListadosFt/Carga_Ficheros_FT', {templateUrl: 'app/FTBase/ListadosFT/carga_ficheros_ft.html', controller: 'CargaFicherosFtController'})
		//Versión usando gridEditor.html
		//.when('/HomologacionPlantas/Listado_control_homologacion', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ListadoControlHomologacionController'})
		//Versión con propria página HTML
		.when('/HomologacionPlantas/Listado_control_homologacion', { templateUrl: 'app/FTBase/HomologacionPlantas/listado_control_homologacion.html', controller: 'ListadoControlHomologacionController'})
		.when('/HomologacionPlantas/Listado_resumen_homologacion', { templateUrl: 'app/FTBase/HomologacionPlantas/listado_resumen_homologacion.html', controller: 'ListadoResumenHomologacionController'})

		//Contratos
		.when('/Contratos/extranet_fichas_tecnicas_contratos', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ListaContratosFtController' })

		//Dashboards
		.when('/Dashboards/Dashboard', { templateUrl: 'app/FTBase/Dashboards/Dashboard/dashboard.html', controller: 'DashboardFTController'} )

		//Alarmas
		.when('/Alarmas/estado_fuera_plazo', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Estado_Fuera_PlazoController' })
		.when('/Alarmas/expiracion_certificados', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Expiracion_CertificadosController' })
		.when('/Alarmas/actualizacion_ft', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Actualizacion_FTController' })
		.when('/Alarmas/verificacion_ingredientes', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Verificacion_IngredientesController' })
		.when('/Alarmas/certificados_ficheros', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Certificados_FicherosController' })
		.when('/Alarmas/ingredientes_monitorizar', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Ingredientes_MonitorizarController' })
		.when('/Alarmas/ft_revision_propietario', { templateUrl: 'app/base/views/gridEditor.html', controller: 'AlarmaFtRevisionaPropietarioController' })


	;
}]);

angular.module('FTBase').config([ 'pdfjsViewerConfigProvider', function(pdfjsViewerConfigProvider) {
  pdfjsViewerConfigProvider.setWorkerSrc("/assets/pdf.js-viewer/pdf.worker.js");
}]);

angular.module('FTBase').constant('idiomasFT', [
	{
		codigo: "es",
		descripcion: "Español",
		icon: "assets/images/flags/es.png"
	},
	{
		codigo: "pt",
		descripcion: "Portugués",
		icon: "assets/images/flags/pt.png"
	}
]);

angular.module('gp4App').requires.push("FTBase");

angular.module('FTBase').controller('GridJerarquicoAddRowPopupController', ['$scope', '$uibModalInstance', 'ixStatusService', 'ixUtilsService', '$q', 'ivhTreeviewMgr', '$http', 'cfg', '$timeout', '$rootScope', function ($scope, $uibModalInstance, ixStatusService, ixUtilsService, $q, ivhTreeviewMgr, $http, cfg, $timeout, $rootScope) {
	$scope.status = { editing: true };

	$scope.entity = $scope.$resolve.entity;
	$scope.entityMaster = $scope.$resolve.entityMaster;
	$scope.entityOriginal = angular.copy($scope.entity);
	$scope.modoTraduccion = $scope.$resolve.modoTraduccion;

	$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: [$scope.entity] };
	if ($scope.modoTraduccion) {
		$scope.pregunta.respuestas = [$scope.entityMaster];
		$scope.pregunta.pregunta_idioma = angular.copy($scope.$resolve.pregunta.pregunta_idioma);
		$scope.pregunta.respuestas_idioma = [$scope.entity];
	}


	//$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: angular.copy($scope.$resolve.pregunta.respuestas) };
	$scope.pregunta.pregunta.bucle = 0;
	$scope.pregunta.pregunta.sub_bucle = 0;
	$scope.pregunta.pregunta.preguntar_componente = 0;

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta1 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta1 && !angular.isArray($scope.entity.sub_respuesta1))
		$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta2 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta2 && !angular.isArray($scope.entity.sub_respuesta2))
		$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta3 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta3 && !angular.isArray($scope.entity.sub_respuesta3))
		$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta4 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta4 && !angular.isArray($scope.entity.sub_respuesta4))
		$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta5 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta5 && !angular.isArray($scope.entity.sub_respuesta5))
		$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta6 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta6 && !angular.isArray($scope.entity.sub_respuesta6))
		$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta7 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta7 && !angular.isArray($scope.entity.sub_respuesta7))
		$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta8 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta8 && !angular.isArray($scope.entity.sub_respuesta8))
		$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta9 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta9 && !angular.isArray($scope.entity.sub_respuesta9))
		$scope.entity.sub_respuesta9 = $scope.entity.sub_respuesta9.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta10 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta10 && !angular.isArray($scope.entity.sub_respuesta10))
		$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta10 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta10 && !angular.isArray($scope.entity.sub_respuesta10))
		$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta11 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta11 && !angular.isArray($scope.entity.sub_respuesta11))
		$scope.entity.sub_respuesta11 = $scope.entity.sub_respuesta11.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta12 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta12 && !angular.isArray($scope.entity.sub_respuesta12))
		$scope.entity.sub_respuesta12 = $scope.entity.sub_respuesta12.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta13 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta13 && !angular.isArray($scope.entity.sub_respuesta13))
		$scope.entity.sub_respuesta13 = $scope.entity.sub_respuesta13.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta14 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta14 && !angular.isArray($scope.entity.sub_respuesta14))
		$scope.entity.sub_respuesta14 = $scope.entity.sub_respuesta14.replaceAll(";",",").split(",");

	$scope.rowsGrid = $scope.$resolve.rowsGrid || [];
	$scope.isNew = $scope.$resolve.isNew;
	$scope.grid = $scope.$resolve.grid;

	$scope.clearEmptyRow = function () {
		var emptyRow = $scope.grid.data.find(function (e) { return !e.valor && !e.sub_respuesta1 && !e.sub_respuesta2 && !e.sub_respuesta3 && !e.sub_respuesta4 && !e.sub_respuesta5 && !e.sub_respuesta6 && !e.sub_respuesta7 && !e.sub_respuesta8 && !e.sub_respuesta9 && !e.sub_respuesta10 && !e.sub_respuesta11 && !e.sub_respuesta12 && !e.sub_respuesta13 && !e.sub_respuesta14; });
		if (angular.isDefined(emptyRow)) {
			$scope.grid.data.splice($scope.grid.data.indexOf(emptyRow), 1);
		}
	};

	$scope.resetForm = function () {
		$scope.searchtext = "";
		$scope.entity.orden_bucle = "";
		$scope.entity.valor = "";
		$scope.entity.sub_respuesta1 = "";
		$scope.entity.sub_respuesta2 = null;
		$scope.entity.sub_respuesta3 = null;
		$scope.entity.sub_respuesta4 = "";
		$scope.entity.sub_respuesta5 = "";
		$scope.entity.sub_respuesta6 = "";
		$scope.entity.sub_respuesta7 = "";
		$scope.entity.sub_respuesta8 = "";
		$scope.entity.sub_respuesta9 = "";
		$scope.entity.sub_respuesta10 = "";
		$scope.entity.sub_respuesta11 = "";
		$scope.entity.sub_respuesta12 = "";
		$scope.entity.sub_respuesta13 = "";
		$scope.entity.sub_respuesta14 = "";

		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.reloadDropdown();
	};
	$scope.reloadDropdown = function () {
		$scope.reload = true;
		$timeout(function () {
			$scope.reload = false;
		}, 1);
	};
	$scope.cargarValoresNivel = function () {
		var deferr = $q.defer();

		var ingredientesPrincipales = [{ codigo: 0, descripcion: "Ingrediente Principal" }];

		$scope.rowsGrid.filter(function (e) { return (e["$$treeLevel"] == 0 || e["$$treeLevel"] == 1) && (e.valor); }).forEach(function (row, idx) {
			var orden_sub_bucle = row.orden_sub_bucle || row.orden_tab;
			ingredientesPrincipales.push({ codigo: row.orden_bucle + "-" + orden_sub_bucle, descripcion: row.valor });
		});

		deferr.resolve({ data: ingredientesPrincipales });
		return deferr.promise;
	};

	$scope.$watch('searchtext', function (newVal, oldVal) {
		$scope.changeSelectionIfItemMatching();
	});

	$scope.changeSelectionIfItemMatching = function () {
		if ($scope.searchtext) {
			var matchingItem = $scope.listOfValues.find(function (e) { return e.id.toString().toUpperCase().toString() == $scope.searchtext.toUpperCase() });
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
			//			if(angular.isDefined(matchingItem)){
			//				ivhTreeviewMgr.select($scope.listOfValues, matchingItem);
			//			} else {
			//				ivhTreeviewMgr.select($scope.listOfValues, $scope.listOfValues.find(function(e){ return e.id === 0; }));
			//			}
			$scope.entity.valor = $scope.searchtext;
		}
	};


	$scope.filterItems = function (node) {
		return (node.id == 0) || ixUtilsService.comparar(node.id,$scope.searchtext)>=0;
	};

	var getListIngredientesDiccionario = function () {
		var lista = [{ id: 0, label: "Crear ingrediente", selected: 0 }];
		if ($scope.pregunta.pregunta.diccionario_valores) {
			$scope.pregunta.pregunta.diccionario_valores.forEach(function (valor) {
				if (valor != null)
					lista.push({ id: valor, label: valor, selected: 0 });
			});
		}
		return lista;
	};

	$scope.listOfValues = getListIngredientesDiccionario();

	$scope.selectionChanged = function (ivhNode, ivhIsSelected, ivhTree) {
		$scope.entity.valor = null;
		if (ivhIsSelected) {
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
			ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);

			if (ivhNode.id == 0) {
				$scope.entity.valor = $scope.searchtext;
			} else {
				$scope.entity.valor = ivhNode.label;
				$scope.searchtext = $scope.entity.valor;
			}
		}
		else
			$scope.searchtext = "";
	};

	var getMaxOrdenBucle = function () {
		var max_orden_bucle = 0;
		$scope.rowsGrid.filter(function (e) { return (e.orden_sub_bucle === 0 || e.orden_tab === 0) && e.valor; }).forEach(function (nivel_principal) {
			if (max_orden_bucle < nivel_principal.orden_bucle)
				max_orden_bucle = nivel_principal.orden_bucle;
		});
		return max_orden_bucle;
	};
	$scope.save = function () {
		if ($scope.rowsGrid.length > 0) {
			if ($scope.entity.orden_bucle == 0) {
				//Get max orden_bucle and sum 1.
				$scope.entity.orden_bucle = getMaxOrdenBucle() + 1;
				$scope.entity.orden_tab = 0;
			} else {
				var partsCodigo = $scope.entity.orden_bucle.split("-");
				var orden_bucle = parseInt(partsCodigo[0]);
				$scope.entity.orden_bucle = orden_bucle;
				var orden_sub_bucle = parseInt(partsCodigo[1]);
				if (isNaN(orden_sub_bucle))
					orden_sub_bucle = 0;
				if (orden_sub_bucle == 0) {
					$scope.entity.orden_tab = ($scope.rowsGrid.filter(function (e) { return e.orden_bucle == orden_bucle && (e.orden_sub_bucle > 0 || e.orden_tab > 0) && (!e.orden_tab2 && !e.orden_sub_sub_bucle); }).length) + 1;
					$scope.entity.orden_tab2 = 0;
				} else {
					$scope.entity.orden_tab = orden_sub_bucle;
					$scope.entity.orden_tab2 = ($scope.rowsGrid.filter(function (e) { return e.orden_bucle == orden_bucle && (e.orden_sub_bucle == orden_sub_bucle || e.orden_tab == orden_sub_bucle) && (e.orden_sub_sub_bucle > 0 || e.orden_tab2 > 0); }).length) + 1;
				}
			}
		}

		$scope.transformListsToStrings();

		if ($scope.isNew) {
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", $scope.entity).then(function (response) {
				//Marcar la pregunta 702 para recargar.
				if ($scope.pregunta.pregunta.id_pregunta == 64)
					ixStatusService.current.data.ToReload = { 702: true };
				$scope.clearEmptyRow();
				$scope.resetForm();
				ixStatusService.setResponse(response);
				response.data.obj.Record["$$treeLevel"] = ((response.data.obj.Record.orden_tab == 0) ? 0 : (!response.data.obj.Record.orden_tab2) ? 1 : 2);
				$scope.grid.ixAddRow(response.data.obj.Record);
				$timeout(function () {
					if ($scope.grid.data[$scope.grid.data.length - 1].orden_tab >= 1) {
						var addedRow = $scope.grid.data.splice($scope.grid.data.length - 1, 1);
						addedRow = addedRow[0];
						addedRow.orden_sub_bucle = addedRow.orden_tab;
						addedRow.orden_sub_sub_bucle = addedRow.orden_tab2;

						var itemsNivel2 = $scope.grid.data.filter(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle > 0 && (!e.orden_sub_sub_bucle); });//sub ingredientes
						var itemsNivel3 = [];//sub sub ingredientes
						var previousItem = null;
						if (itemsNivel2.length > 0) {
							if (addedRow.orden_sub_sub_bucle >= 1) {
								previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle); });//ingrediente contenedor
								itemsNivel3 = $scope.grid.data.filter(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == addedRow.orden_sub_bucle && (e.orden_sub_sub_bucle > 0); });//sub sub ingredientes
							}
							else {
								previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle - 1); });
								itemsNivel3 = $scope.grid.data.filter(function (e) { return e.orden_bucle == previousItem.orden_bucle && e.orden_sub_bucle == previousItem.orden_sub_bucle && e.orden_sub_sub_bucle > 0; });//sub sub ingredientes del anterior
							}


						}
						else
							previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle; });

						var indexPreviousItem = $scope.grid.data.indexOf(previousItem);
						$scope.grid.data.splice((indexPreviousItem + 1 + itemsNivel3.length), 0, addedRow);
					}
				}, 250);

				$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: response.data.obj.Record.valor, oldValue: undefined, pregunta: $scope.pregunta, tipo_modificacion: "Add" });

			}, function (err) {
				ixStatusService.setResponse(err);
			});
		} else {
			$uibModalInstance.close($scope.entity);
		}

	};

	$scope.transformListsToStrings = function () {
		if ($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
			$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if ($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if ($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if ($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");

		if ($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if ($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if ($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if ($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");
	};

	$scope.$dismiss = function () {
		$scope.entity.orden_bucle = $scope.entityOriginal.orden_bucle;
		$scope.entity.valor = $scope.entityOriginal.valor;
		$scope.entity.sub_respuesta1 = $scope.entityOriginal.sub_respuesta1;
		$scope.entity.sub_respuesta2 = $scope.entityOriginal.sub_respuesta2;
		$scope.entity.sub_respuesta3 = $scope.entityOriginal.sub_respuesta3;
		$scope.entity.sub_respuesta4 = $scope.entityOriginal.sub_respuesta4;
		$scope.entity.sub_respuesta5 = $scope.entityOriginal.sub_respuesta5;
		$scope.entity.sub_respuesta6 = $scope.entityOriginal.sub_respuesta6;
		$scope.entity.sub_respuesta7 = $scope.entityOriginal.sub_respuesta7;
		$scope.entity.sub_respuesta8 = $scope.entityOriginal.sub_respuesta8;
		$scope.entity.sub_respuesta9 = $scope.entityOriginal.sub_respuesta9;
		$scope.entity.sub_respuesta10 = $scope.entityOriginal.sub_respuesta10;
		$scope.entity.sub_respuesta11 = $scope.entityOriginal.sub_respuesta11;
		$scope.entity.sub_respuesta12 = $scope.entityOriginal.sub_respuesta12;
		$scope.entity.sub_respuesta13 = $scope.entityOriginal.sub_respuesta13;
		$scope.entity.sub_respuesta14 = $scope.entityOriginal.sub_respuesta14;

		if ($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
			$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if ($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if ($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if ($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");

		if ($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if ($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if ($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if ($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");

		if ($scope.entity.sub_respuesta9 && angular.isArray($scope.entity.sub_respuesta9))
			$scope.entity.sub_respuesta9 = $scope.entity.sub_respuesta9.join(",");

		if ($scope.entity.sub_respuesta10 && angular.isArray($scope.entity.sub_respuesta10))
			$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.join(",");

		if ($scope.entity.sub_respuesta11 && angular.isArray($scope.entity.sub_respuesta11))
			$scope.entity.sub_respuesta11 = $scope.entity.sub_respuesta11.join(",");

		if ($scope.entity.sub_respuesta12 && angular.isArray($scope.entity.sub_respuesta12))
			$scope.entity.sub_respuesta12 = $scope.entity.sub_respuesta12.join(",");

		if ($scope.entity.sub_respuesta13 && angular.isArray($scope.entity.sub_respuesta13))
			$scope.entity.sub_respuesta13 = $scope.entity.sub_respuesta13.join(",");
			
		if ($scope.entity.sub_respuesta14 && angular.isArray($scope.entity.sub_respuesta14))
			$scope.entity.sub_respuesta14 = $scope.entity.sub_respuesta14.join(",");

		$uibModalInstance.close();
	};

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/

"use strict";

angular.module('FTBase').controller('Listado_Proveedores_FicherosController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;

    //$scope.gridManualLoad = true;

    if (!$scope.data.filtro) $scope.data.filtro = {};
    $scope.data.filtro.vigentes = true;

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        // $scope.ixEditar = function () {
        //     ixStatusService.setEditing(true);
        // };

        //Cargar grid
        var acciones = [
            {
                title: "Previsualizar PDF",
                icon: "fa-file-pdf-o",
                visible: function (entity) {
                    return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
                },
                accion: function (entity) {
                    var tabla = "proveedores_ficheros";
                    $http({
                        method: 'post',
                        url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                        headers: {},
                        responseType: 'arraybuffer'
                    }).then(function (r) {
                        $scope.selectedPDF = new Uint8Array(r.data);
                        $scope.idFicheroPreview = entity.id;
                        var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                        ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
                    },
                        function (err) {
                            ixStatusService.setResponse(err);
                        });
                }
            },
            {
                title: "Previsualizar Imagen",
                icon: "fa-file-image-o",
                visible: function (entity) {
                    return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
                },
                accion: function (entity) {
                    var tabla = $scope.getEntity();
                    $http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
                        $scope.selectedImage = r.data;
                        $scope.idFicheroPreview = entity.id;
                        var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
                        ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
                    },
                        function (err) {
                            ixStatusService.setResponse(err);
                        });
                }
            },
            {
                title: "Descargar fichero",
                icon: "fa-download",
                visible: function (entity) {
                    return entity.archivo;
                },
                accion: function (entity) {
                    var esProveedor = angular.isDefined(entity.proveedor);
                    $scope.downloadFile(entity.id, esProveedor);
                }
            }
        ];
        if (!$scope.data.gridProveedoresFicheros) {
            $scope.data.gridProveedoresFicheros = gridService.createGrid($scope, 'proveedores_ficheros_grid', { enableCellEdit: true, ixGuardarAction: "ActualizarComentarioVerificacion" }, 'listado_proveedores_ficherosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
        } else {
            $scope.data.gridProveedoresFicheros = gridService.createGridFunctions($scope, $scope.data.gridProveedoresFicheros);
            $scope.data.gridProveedoresFicheros.ixRestoreConfig();
        }

        var usuario = authService.authentication.userName;

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            //asignar cliente
            $scope.extranetUser = response.data;
            //En funcion de si es cliente o no aplicamos el filtro de cliente o no
            if ($scope.extranetUser.cliente != null) {
                $scope.data.filtro.cliente = $scope.extranetUser.cliente;
                $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
                $scope.data.gridProveedoresFicheros.ixLoadInitialData();
            }
            else {
                $scope.data.gridProveedoresFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
                $scope.data.gridProveedoresFicheros.ixLoadInitialData();
            }

            $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        if ($scope.data.gridProveedoresFicheros) {
            $scope.data.gridProveedoresFicheros = gridService.createGridFunctions($scope, $scope.data.gridProveedoresFicheros);
            $scope.data.gridProveedoresFicheros.ixRestoreConfig();
        }

        $scope.downloadFile = function (id) {
            var entity = "proveedores_ficheros";
            $http({
                method: 'post',
                url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
                headers: { 'Content-type': 'application/pdf' },
                responseType: 'arraybuffer'
            }).then(function (r) {
                var file = new Blob([r.data], { type: r.headers('Content-type') });

                var filename = $scope.entity + ".pdf";
                if (r.headers('Content-Disposition')) {
                    filename = r.headers('Content-Disposition').split("=")[1];
                }
                saveAs(file, filename);
            },
                function (err) {
                    ixStatusService.setResponse(err);
                });
        };

        $scope.downloadMultiFile = function () {
            var lineasSeleccionadas = $scope.data.gridProveedoresFicheros.gridApi.selection.getSelectedRows();
            var lista = [];
            lineasSeleccionadas.forEach(function(row){
                lista.push(row.id);
            });

            var config = { responseType: 'arraybuffer' };
            $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
                var file = new Blob([response.data], { type: 'application/zip' });
            
                  var filename = "ficheros_ft.zip";
                  if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                  }
                  saveAs(file, filename);
            },
            function (err) {
                    ixStatusService.setResponse(err);
                });
        };


        /* **** FUNCTION: IXFILTRAR **** */
        $scope.ixFiltrar = function () {
            var usuario = authService.authentication.userName;

            $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
                //asignar cliente
                $scope.extranetUser = response.data;
                //En funcion de si es cliente o no aplicamos el filtro de cliente o no
                if ($scope.extranetUser.cliente != null) {
                    $scope.data.filtro.cliente = $scope.extranetUser.cliente;
                    $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
                    $scope.data.gridProveedoresFicheros.ixLoadInitialData();
                }
                else {
                    $scope.data.gridProveedoresFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
                    $scope.data.gridProveedoresFicheros.ixLoadInitialData();
                }

                $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }

        $scope.ixEditar = $scope.data.gridProveedoresFicheros.ixEditar;
        // $scope.ixCancelEdit = function () {
        //     $scope.data.gridProveedoresFicheros.ixCancelEdit();
        //     ixStatusService.setEditing(false);
        // };

        $scope.ixCancelEdit = $scope.data.gridProveedoresFicheros.ixCancelEdit;

        /* *** FUNCTION IXGUARDAR **** */
        $scope.ixGuardar = $scope.data.gridProveedoresFicheros.ixGuardar;
        // $scope.ixGuardar = function(){
        //     var bulkParam = $scope.data.gridProveedoresFicheros.ixGetBulkParam();

        //     $http.put(cfg.baseURL + "listado_proveedores_ficherosVM/ActualizarComentarioVerificacion",bulkParam).then(function(r){
        //         ixStatusService.setResponse(r);
        //         $scope.data.gridProveedoresFicheros.clearGridAfterSave();
        //     },function(error){
        //         ixStatusService.setResponse(error);
        //     });


        //     // $scope.data.gridProveedoresFicheros.insertedRows = [];
        //     // $scope.data.gridProveedoresFicheros.deletedRows = [];
        //     // $scope.data.gridProveedoresFicheros.updatedRows = [];
        //     ixStatusService.setEditing(false);
        // }
    }

    $scope.$on('destroy', function () {
        if ($scope.data.gridProveedoresFicheros)
            $scope.data.gridProveedoresFicheros.ixSaveConfig();
    });
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
"use strict";

angular.module('FTBase').controller('Listado_Productos_MarcaController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.extranetUser = {};
  $scope.extranetUser.cliente = null;


  $scope.gridManualLoad = true;

  if (!$scope.data.filtro) $scope.data.filtro = {};

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {


    var usuario = authService.authentication.userName;

    $scope.esClienteDM = function () {
      if ($scope.extranetUser.cliente == 1031 && !$scope.esPerfilVisitante())
        return true;
      else
        return false;
    };


    $scope.tienePerfilAdmin = authService.tienePerfilAdmin;
    // $scope.esCliente = function (cell) {
    //   if ($scope.extranetUser.cliente)
    //     return true;
    //   else
    //     return false;
    // }

    $scope.esPerfilVisitante = function () {
      var esVisitante = false;
      var perfilesUsuario = authService.perfilesUsuario();

      angular.forEach(perfilesUsuario, function (perfil) {
        if (perfil == "usr_visitante")
          esVisitante = true;
      });
      return esVisitante;
    }

    $scope.filterStatus = { isCollapsed: true };

    if (!$scope.data.gridProductosMarca) {
      var acciones = [
      ];
      var metadata = [

      ];

      $scope.data.gridProductosMarca = gridService.createGrid($scope, 'productos_marca_grid', { metadata: metadata, enableCellEdit: false }, 'listado_productos_marcaVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
    }
    else {
      $scope.data.gridProductosMarca = gridService.createGridFunctions($scope, $scope.data.gridProductosMarca);
      $scope.data.gridProductosMarca.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridProductosMarca.ixDownloadExcel;

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      if ($scope.extranetUser.cliente != null || $scope.esPerfilVisitante()) {
        $scope.filterStatus.isCollapsed = false;
        if ($scope.extranetUser.cliente != null)
          $scope.data.filtro.propietario = $scope.extranetUser.cliente;
        $scope.ixFiltrar();
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.$on("$destroy", function () {
      $scope.data.gridProductosMarca.ixSaveConfig();
      $scope.isDestroyed = true;
    });

  }

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = true;
    $scope.data.gridProductosMarca.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["propietario", "asociados"]);
    $scope.data.gridProductosMarca.ixLoadInitialData();

    $scope.status.filtered = false;
  }

  $scope.calcularAlturaDisponible = function () {
    var css = {};
    if ($scope.filterStatus.isCollapsed) {
      var alturaCortinaFiltros = angular.element('.ixFilter')[0].offsetHeight;
      css.height = 'calc(100vh - ' + (180 + alturaCortinaFiltros) + 'px)';
    }
    else
      css.height = 'calc(100vh - 220px)';
    return css;
  };

  $scope.$watch('data.filtro', function () {
    if ($scope.data.gridProductosMarca)
      ixUtilsService.showGrid($scope.data.gridProductosMarca);
  });

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_Productos_FtController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService', '$translate', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  $scope.gridManualLoad = true;

  $scope.ocultarSelAsociados = true;

  if (!$scope.data.filtro) $scope.data.filtro = {};

  if (angular.isUndefined($scope.filterStatus))
    $scope.filterStatus = { isCollapsed: true };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {

    var usuario = authService.authentication.userName;

    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.data.extranetUser.cliente == 1031 || !($scope.data.extranetUser.laboratorio || $scope.data.extranetUser.proveedor || $scope.data.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;
      if ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio || $scope.modificacionesRestringidas()) {
        //El botón editar se muestra sólo en el caso de usuarios cliente o admin
        //nop
      }
      else {
        $scope.ixEditar = function () {
          ixStatusService.setEditing(true);
        };
      }
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.displayInformationPopup = function () {
      $scope.informativeDialog = $ngConfirm({
        icon: 'fa fa-info',
        title: '<translate>Información</translate>',
        content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
        scope: $scope,
        buttons: {
          close: {
            text: "Cerrar"
          }
        }
      });
    };

    $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
      $scope.displayInformationPopup();
      return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
    };

    $scope.openAppFT = function (entity, idioma, modo_traduccion) {
      var app = {};
      app.icon = 'perm_device_information';

      if ((entity.idioma) && entity.idioma != idioma)
        app.display = 'Modo Traducción ' + idioma.toUpperCase();
      else
        app.display = 'Datos Ficha Técnica';

      app.href = "GestionFichasTecnicas/list";
      app.atributos = { id_ficha_tecnica: entity.id_ficha_tecnica,pantalla: "ListadosFT/Listado_ProductosFt"  };
      app.multiple = true;

      if ((entity.idioma) && entity.idioma != idioma) {
        app.atributos.idioma = idioma;
      }

      if (angular.isDefined($scope.informativeDialog))
        $scope.informativeDialog.close();

      ixStatusService.openApp(app).bind(ixStatusService);
    };

    $scope.cargarGrid = function () {
      var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-ok': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'OK'), 'row-alarm': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'PENDIENTE'),'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
      if (!$scope.data.gridProductosFt) {
        var acciones = [
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/es.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "ES";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "ES");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "es").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "es");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "es");
            }
          },
          {
            titleFunction: function (entity) {
              var title = "Datos Ficha Técnica";
              if ((entity.idioma) && entity.idioma.toUpperCase() != "PT")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/pt.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "PT";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = (entity.idioma.toUpperCase() != "PT");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "pt").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "pt");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "pt");
            }
          },
          {
            title: 'Descargar Ficha Técnica',
            icon: 'fa-download',
            visible: function (entity) {
              return !$scope.esPerfilLaboratorio();
            },
            accion: function (entity) {
              var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
              var options = { controller: "ImprimirFTPopupController" };
              var params = { tipo: "FT_PRODUCTO", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica, ean: entity.ean };

              ixUtilsService.openModalV2(template, options, "small", params);
            }
          }
        ];
        var metadata = [
          {
            Name: "estado_envio_datos_aecoc",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "fecha_envio_datos_aecoc",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "ultimo_comentario",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "publicar_aecoc",
            NoVisible: ($scope.modificacionesRestringidas())
          },
          {
            Name: "marcas_asociadas",
            NoVisible: ($scope.modificacionesRestringidas())
          },
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];

        $scope.data.gridProductosFt = gridService.createGrid($scope, 'productosftGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridProductosFt.rowTemplate = rowTemplate;
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.gridProductosFt.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
      }
      else {
        $scope.data.gridProductosFt = gridService.createGridFunctions($scope, $scope.data.gridProductosFt);
        $scope.data.gridProductosFt.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridProductosFt.ixDownloadExcel;
    }

    $scope.ixGuardar = function () {
      var bulkParam = $scope.data.gridProductosFt.ixGetBulkParam();

      $http.put(cfg.baseURL + "listado_productosVM/MarcarEnvioAecoc", bulkParam).then(function (r) {
        ixStatusService.setResponse(r);
      }, function (error) {
        ixStatusService.setResponse(error);
      });

      ixStatusService.setEditing(false);
    };

    $scope.ixCancelEdit = function () {
      $scope.data.gridProductosFt.ixCancelEdit();
      ixStatusService.setEditing(false);
    };

    $scope.$on("$destroy", function () {
      $scope.data.gridProductosFt.ixSaveConfig();
    });
  }

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.esPerfilVisitante = function () {
    var esVisitante = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_visitante")
        esVisitante = true;
    });
    return esVisitante;
  }

  $scope.esPerfilLaboratorio = function() {
    var esLaboratorio = false;
    var perfilesUsuario = authService.perfilesUsuario();
    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_laboratorio")
      esLaboratorio = true;
    });
    return esLaboratorio;
  };

  $scope.esPerfilExport = function () {
    var esVisitante = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_export")
        esVisitante = true;
    });
    return esVisitante;
  }

  $scope.modificacionesRestringidas = function () {
    var blockEditAndSensibleInfo = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_visitante" || perfil == "usr_export" || perfil == "usr_laboratorio")
        blockEditAndSensibleInfo = true;
    });
    return blockEditAndSensibleInfo;
  }

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    angular.forEach($scope.data.filtro, function(value,key){
      if(value == null || value == undefined || value=="")
        delete $scope.data.filtro[key];
    });
    $scope.filterStatus.isCollapsed = true;

    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) {
      $scope.data.filtro.estado = ["O", "R", "A", "P", "S"];
    }

    if ($scope.data.extranetUser.laboratorio) {
      if ($scope.data.filtro.estado) {
        $scope.data.filtro.estado = $scope.data.filtro.estado.filter(function (x) { return x != "X" });
      }
    }

    $scope.data.gridProductosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados", "exclusivas"]);
    $scope.data.gridProductosFt.ixLoadInitialData().then(function (response) {
      $scope.drawPivotProductosFt();

      if ($scope.data.activeTab == 1) {
        $timeout(function () {
          $scope.changeTab(1);
        }, 1);
      }
    });

    $scope.status.filtered = true;
  }

  if ($scope.status.filtered)
    $scope.ixFiltrar();

  /* ***** FUNCTION: CHANGETAB ***** */
  $scope.changeTab = function (idxTab) {
    $scope.data.activeTab = idxTab;
    switch (idxTab) {
      case 0:
        $timeout(function () {
          $scope.showGrid($scope.data.gridProductosFt);
        }, 400);
        break;
      case 1:
        $scope.drawPivotProductosFt();
        break;
      default:
        break;
    }
  }

  /* ***** FUNCTION: DRAWPIVOTFICHASTECNICAS ***** */
  $scope.drawPivotProductosFt = function () {
    $timeout(function () {
      var filteredRows = $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().map(function (e) { return angular.copy(e.entity); });
      angular.forEach(filteredRows, function (row) {
        if (row.estado == null) {
          row.estado = "SIN ESTADO";
        }
        if (row.tipo_ft == null) {
          row.tipo_ft = "TIPO DESCONOCIDO";
        }
      });
      $scope.drawPivot("#pivotProductosFt", filteredRows, { rows: ["nombre_estado"], cols: ["descripcion_tipo_ft"] });
    }, 1);
  }

  /* ***** FUNCTION: DRAWPIVOT ***** */
  $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
    $scope.renderers = $.pivotUtilities;
    $scope.pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers: $.extend($.pivotUtilities.renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
      rendererName: "Table",
      derivedAttributes: addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, data)
    };

    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);
    angular.element(tagId).pivotUI($scope.pivotData, pivotOptions, false, "es");
  }
  //TODO: impresionMasivaFT seguramente se tiene que pasar dentro del ImprimirFTPopupController.
  //  $scope.impresionMasivaFT = function (docformat, reducido) {
  //    var params = { docformat: docformat, reducido: reducido };
  //
  //    var lista_productos = [];
  //
  //    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
  //      var nuevoProducto = { id_ft: row.id_ficha_tecnica, ean: row.ean };
  //      lista_productos.push(nuevoProducto);
  //    });
  //
  //    params.lista_productos = lista_productos;
  //
  //    var config = { responseType: 'arraybuffer' };
  //
  //    $http.post(cfg.baseURL + "impresos/ImpresionMasivaProductos", params, config).then(function (response) {
  //      var file = new Blob([response.data], { type: 'application/zip' });
  //
  //      var filename = "ft_analiticas.zip";
  //      if (response.headers('Content-Disposition')) {
  //        filename = response.headers('Content-Disposition').split("=")[1];
  //      }
  //      saveAs(file, filename);
  //    }, function (error) {
  //      ixStatusService.setResponse(error);
  //    });
  //
  //  }

  $scope.impresionMasivaFT = function () {
    var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
    var options = { controller: "ImprimirFTPopupController" };
    var params = { tipo: "FT_PRODUCTO_MASIVA" };

    var lista_productos = [];

    var traducible = 1;

    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      var nuevoProducto = { id_ft: row.id_ficha_tecnica, ean: row.ean };
      if (row.traducible != 1) traducible = 0;
      lista_productos.push(nuevoProducto);
    });

    params.traducible = traducible;
    params.lista_productos = lista_productos;

    if (lista_productos.length > 0)
      ixUtilsService.openModalV2(template, options, "small", params);
  };

  $scope.seleccionarRowsVisibles = function () {
    $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().forEach(function (row) {
      row.entity.Selector = true;
    });
  }

  $scope.desSeleccionarRows = function () {
    $scope.data.gridProductosFt.data.forEach(function (row) {
      row.Selector = false;
    });
  }

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
/*global CMP_GTE*/
/*global CMP_LTE*/
/*global moment*/

"use strict";

angular.module('FTBase').controller('Listado_Ft_Fotos_ProductoController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;

    if (!$scope.data.filtro) $scope.data.filtro = {};

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        $scope.filterStatus = { isCollapsed: true };

        $scope.data.filtro.fecha_inicio = new Date('2018-08-01'); // moment().add(-3, 'months').startOf("month")._d;
        $scope.data.filtro.fecha_fin = moment()._d;

        var usuario = authService.authentication.userName;
        $scope.hideLoadFotos = authService.authentication.perfiles.some(function (e) { return e.toUpperCase().indexOf("USR_VISITANTE") !== -1; });

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;

            if ($scope.extranetUser.cliente) {
                if ($scope.extranetUser.cliente == 1031)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }
            else {
                if (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }

        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.cargarGrid = function () {

            if (!$scope.data.gridft_fotos_producto) {
                var acciones = [
                    {
                        title: 'Descargar fichero',
                        icon: 'fa-download',
                        accion: function (entity) {
                            $http({
                                method: 'post',
                                url: cfg.baseURL + 'ft_fotos_productos/DownloadFile?archivo_imagen=' + entity.archivo_imagen,
                                headers: { 'Content-type': 'image/jpg' },
                                responseType: 'arraybuffer'
                            }).then(function (r) {
                                var file = new Blob([r.data], { type: r.headers('Content-type') });

                                var filename = $scope.entity + ".jpg";
                                if (r.headers('Content-Disposition')) {
                                    filename = r.headers('Content-Disposition').split("=")[1];
                                }
                                saveAs(file, filename);
                            },
                                function (err) {
                                    ixStatusService.setResponse(err);
                                });
                        }
                    },
                    {
                        title: 'Eliminar imagen',
                        icon: 'fa-trash',
                        accion: function (entity) {
                            ixWarningsService.warningConfirmacion($scope, "Eliminar la imagen " + entity.archivo_imagen, $scope.eliminarImagen, undefined, entity.archivo_imagen);
                        }
                    },
                    {
                        title: 'Asignar como principal',
                        icon: 'fa-star',
                        visible: function (entity) {
                            return !entity.principal;
                        },
                        accion: function (entity) {
                            ixWarningsService.warningConfirmacion($scope, "Marcar la imagen " + entity.archivo_imagen + " como principal?", $scope.marcarPrincipal, undefined, entity.archivo_imagen);
                        }
                    }
                ];
                var metadata = [
                    {
                        Name: "estado_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    },
                    {
                        Name: "fecha_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    }
                ];

                $scope.data.gridft_fotos_producto = gridService.createGrid($scope, 'ft_fotos_productoGrid', { metadata: metadata }, 'listado_ft_fotos_productoVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
                $scope.data.gridft_fotos_producto.filtroExterno = [{ Field: "fecha_carga", Operator: CMP_GTE, Value: $scope.data.filtro.fecha_inicio }, { Field: "fecha_carga", Operator: CMP_LTE, Value: $scope.data.filtro.fecha_fin }, { Field: "busqueda_generica", Value: $scope.data.filtro.busqueda_generica, skip: true }];
            }
            else {
                $scope.data.gridft_fotos_producto = gridService.createGridFunctions($scope, $scope.data.gridft_fotos_producto);
                $scope.data.gridft_fotos_producto.ixRestoreConfig();
                $scope.data.gridft_fotos_producto.filtroExterno = [{ Field: "fecha_carga", Operator: CMP_GTE, Value: $scope.data.filtro.fecha_inicio }, { Field: "fecha_carga", Operator: CMP_LTE, Value: $scope.data.filtro.fecha_fin }, { Field: "busqueda_generica", Value: $scope.data.filtro.busqueda_generica, skip: true }];
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }

            $scope.ixDownloadExcel = $scope.data.gridft_fotos_producto.ixDownloadExcel;
        }

        $scope.ixFiltrar = function () {
            $scope.cargarGrid();
            // $scope.status.editing = true;
        }

        $scope.ocultaGuardar = true;

        $scope.ixCancelEdit = function () {
            $scope.data.gridft_fotos_producto.data = [];
            $scope.status.editing = false;
        };

        $scope.abrirPopupSubirFotos = function () {
            var template = "app/FTBase/ListadosFT/acciones/subir_foto_producto_popup.html";
            var optionsPopup = { controller: "SubirFotoProductoPopupController" };
            var modalSubirFotos = ixUtilsService.openModalV2(template, optionsPopup, "small");
            modalSubirFotos.then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            });
        };

        $scope.marcarPrincipal = function (nombreArchivo) {
            $http.post(cfg.baseURL + "ft_fotos_productos/MarcarPrincipal?nombreArchivo=" + nombreArchivo).then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };

        $scope.eliminarImagen = function (nombreArchivo) {
            $http.post(cfg.baseURL + "ft_fotos_productos/EliminarImagen?nombreArchivo=" + nombreArchivo).then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };

        $scope.selectVisibleRows = function () {
            $scope.data.gridft_fotos_producto.gridApi.grid.getVisibleRows().forEach(function (row) {
                row.entity.Selector = true;
            });
        };

        $scope.cleanSelectedRows = function () {
            $scope.data.gridft_fotos_producto.data.forEach(function (row) {
                row.Selector = false;
            });
        };

        $scope.getVisibleRows = function () {
            var selectedRows = [];
            if (angular.isDefined($scope.data.gridft_fotos_producto)) {
                selectedRows = $scope.data.gridft_fotos_producto.data.filter(function (e) { return e.Sel; });
            }
            return selectedRows;
        };

        $scope.downloadSelectedPictures = function () {
            var lista = [];
            $scope.data.gridft_fotos_producto.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
                lista.push(row.archivo_imagen);
            });

            if (lista.length > 0) {
                var config = { responseType: 'arraybuffer' };
                $http.post(cfg.baseURL + "ft_fotos_productos/DownloadMultipleFiles", lista, config).then(function(response){
                    var file = new Blob([response.data], { type: response.headers('Content-type') });

                    var filename = "data.zip";
                    if (response.headers('Content-Disposition')) {
                        filename = response.headers('Content-Disposition').split("=")[1];
                    }
                    saveAs(file, filename);
                },
                function(error){
                    ixStatusService.setResponse(error);
                });
            }
        };

        $scope.$on("$destroy", function () {
            $scope.data.gridft_fotos_producto.ixSaveConfig();
            $scope.isDestroyed = true;
        });

    }

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_FtController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', '$translate', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  $scope.gridManualLoad = true;

  $scope.ocultarSelAsociados = true;


  if (!$scope.data.filtro) $scope.data.filtro = {};

  if (angular.isUndefined($scope.filterStatus))
    $scope.filterStatus = { isCollapsed: true };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {

    var usuario = authService.authentication.userName;

    $scope.esProveedor = function (cell) {
      if ($scope.extranetUser.proveedor)
        return true;
      else
        return false;
    }

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      if ($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente) {
        $scope.ocultaEditar = true;
      }

      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.extranetUser.cliente == 1031 || !($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;
      if ($scope.extranetUser.proveedor != null) {
        $scope.data.filtro.proveedor = $scope.extranetUser.proveedor;
        $scope.ixDeleteSelectedRows = undefined;
        $scope.cargarGrid();
        $scope.data.filtro.estado = ['A', 'O', 'P', 'R', 'S'];
        $scope.data.gridFichasTecnicas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados"]);
        $scope.status.filtered = true;
        $scope.data.gridFichasTecnicas.ixLoadInitialData();
      }
      else {
        $scope.cargarGrid();
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.displayInformationPopup = function () {
      $scope.informativeDialog = $ngConfirm({
        icon: 'fa fa-info',
        title: '<translate>Información</translate>',
        content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
        scope: $scope,
        buttons: {
          close: {
            text: "Cerrar"
          }
        }
      });
    };

    $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
      $scope.displayInformationPopup();
      return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
    };

    $scope.openAppFT = function (entity, idioma, modo_traduccion) {
      var app = {};
      app.icon = 'perm_device_information';

      if (angular.isArray(entity)) {

        var id_fichas_tecnicas = entity.map(function (e) { return e.id_ficha_tecnica; });

        app.display = 'Datos Ficha Técnica';
        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_fichas_tecnicas: id_fichas_tecnicas,pantalla: "ListadosFT/Listado_Ft" };
        app.multiple = true;
        app.atributos.idioma = idioma;
      } else {
        if ((entity.idioma) && entity.idioma != idioma)
          app.display = 'Modo Traducción ' + idioma.toUpperCase();
        else
          app.display = 'Datos Ficha Técnica';

        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_ficha_tecnica: entity.id_ficha_tecnica,pantalla: "ListadosFT/Listado_Ft" };
        app.multiple = true;

        if ((entity.idioma) && entity.idioma != idioma) {
          app.atributos.idioma = idioma;
        }
      }

      if (angular.isDefined($scope.informativeDialog))
        $scope.informativeDialog.close();

      ixStatusService.openApp.bind(ixStatusService)(app);
    };

    $scope.tienePerfilAdmin = authService.tienePerfilAdmin;

    $scope.cargarGrid = function () {
      var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-ok': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'OK'), 'row-alarm': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'PENDIENTE'),'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
      if (!$scope.data.gridFichasTecnicas) {
        var acciones = [
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/es.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "ES";
              }

              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "ES");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "es").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "es");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "es");
            }
          },
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "PT")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/pt.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "PT";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = (entity.idioma.toUpperCase() != "PT");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "pt").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "pt");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "pt");
            }
          },
          {
            title: 'Descargar Ficha Técnica',
            icon: 'fa-download',
            accion: function (entity) {
              var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
              var options = { controller: "ImprimirFTPopupController" };
              var params = { tipo: "FT", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica };

              ixUtilsService.openModalV2(template, options, "small", params);
            }
          }
        ];
        var metadata = [
          {
            Name: "revision_inicial",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "revision_final",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "notificacion_proveedor",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "ultimo_comentario",
            NoVisible: ($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "ultimo_estado_prov_ok_fecha",
            NoVisible: (!$scope.tienePerfilAdmin())
          },
          {
            Name: "ultimo_comentario_interno",
            NoVisible: (!$scope.tienePerfilAdmin())
          },
          {
            Name: "revisor_FT",
            NoVisible: (!$scope.tienePerfilAdmin())
          }
          ,
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];

        $scope.data.gridFichasTecnicas = gridService.createGrid($scope, 'ftGrid', { metadata: metadata, enableCellEdit: false }, 'listado_ftVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Sel', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridFichasTecnicas.rowTemplate = rowTemplate;
        //$scope.data.gridFichasTecnicas.onRegisterApi($scope.gridApi);
        //$scope.data.gridFichasTecnicas.gridApi.core.refresh();
      }
      else {
        $scope.data.gridFichasTecnicas = gridService.createGridFunctions($scope, $scope.data.gridFichasTecnicas);
        $scope.data.gridFichasTecnicas.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridFichasTecnicas.ixDownloadExcel;
    }
  } //END INIT function

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    angular.forEach($scope.data.filtro, function(value,key){
      if(value == null || value == undefined || value =="")
        delete $scope.data.filtro[key];
    });
    $scope.filterStatus.isCollapsed = true;
    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) { //$scope.isEmpty($scope.data.filtro)
      $scope.data.filtro.estado = ['A', 'O', 'P', 'R', 'S'];
    }
    $scope.data.gridFichasTecnicas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados"]);
    $scope.data.gridFichasTecnicas.ixLoadInitialData().then(function (response) {
      $scope.drawPivotFichasTecnicas();

      if ($scope.data.activeTab == 1) {
        $timeout(function () {
          $scope.changeTab(1);
        }, 1);
      }
    });

    $scope.status.filtered = true;
  }

  if ($scope.status.filtered)
    $scope.ixFiltrar();

  /* ***** FINCTION: ISEMPTY  ***** */
  $scope.isEmpty = function (obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }

    return true;
  };


  $scope.getSelectedRows = function () {
    var selectedRows = [];
    if (angular.isDefined($scope.data.gridFichasTecnicas)) {
      selectedRows = $scope.data.gridFichasTecnicas.data.filter(function (e) { return e.Sel; });
    }
    return selectedRows;
  };
  $scope.abrirMultiplesFichasTecnicas = function () {
    var fichas_tecnicas = $scope.getSelectedRows();
    if (fichas_tecnicas.length > 0)
      $scope.openAppFT(fichas_tecnicas);
  };

  /* ***** FUNCTION: CHANGETAB ***** */
  $scope.changeTab = function (idxTab) {
    $scope.data.activeTab = idxTab;
    switch (idxTab) {
      case 0:
        $timeout(function () {
          $scope.showGrid($scope.data.gridFichasTecnicas);
        }, 400);
        break;
      case 1:
        $scope.drawPivotFichasTecnicas();
        break;
      default:
        break;
    }
  }

  /* ***** FUNCTION: DRAWPIVOTFICHASTECNICAS ***** */
  $scope.drawPivotFichasTecnicas = function () {
    $timeout(function () {
      var filteredRows = $scope.data.gridFichasTecnicas.gridApi.grid.getVisibleRows().map(function (e) { return angular.copy(e.entity); });
      angular.forEach(filteredRows, function (row) {
        if (row.estado == null) {
          row.estado = "SIN ESTADO";
        }
        if (row.tipo_ft == null) {
          row.tipo_ft = "TIPO DESCONOCIDO";
        }
      });
      $scope.drawPivot("#pivotFichasTecnicas", filteredRows, { rows: ["desc_estado"], cols: ["tipo_ft"] });
    }, 1);
  }

  /* ***** FUNCTION: DRAWPIVOT ***** */
  $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
    $scope.renderers = $.pivotUtilities;
    $scope.pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers: $.extend($.pivotUtilities.renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
      rendererName: "Table",
      derivedAttributes: addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, data)
    };

    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);
    angular.element(tagId).pivotUI($scope.pivotData, pivotOptions, false, "es");
  }

  /* ***** FUNTION: OPEN POPUP TO ADD A BRAND NEW FT ***** */
  $scope.openAddFtPopup = function () {
    var template = "app/FTBase/ListadosFT/acciones/add_ft_popup.html";
    var optionsPopup = { controller: "AddFtPopupController" };
    var modalAdd = ixUtilsService.openModalV2(template, optionsPopup, "small");
    modalAdd.then(function (response) {
      $log.log(response);
      if (response) {
        var app = {};
        app.icon = "list";
        app.display = "Ficha técnica";
        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_ficha_tecnica: response };
        $timeout(function () {
          ixStatusService.openApp(app).bind(ixStatusService);
        }, 1);
      }
    });
  }

  $scope.ixEditar = function () {
    //$scope.status.editing = true;
    ixStatusService.setEditing(true);
  }

  $scope.ixCancelEdit = function () {
    $scope.data.gridFichasTecnicas.ixCancelEdit();
  }

  $scope.ixDeleteSelectedRows = function () {
    $scope.data.gridFichasTecnicas.ixDeleteSelectedRows();
  }

  $scope.ixGuardar = function () {
    $scope.data.gridFichasTecnicas.ixGuardar();
  }

  $scope.EliminarFtObsoletas = function () {
    $log.log("EliminarFtObsoletas llamada...");
    $http.get(cfg.baseURL + "extranet_fichas_tecnicas/EliminarFTObsoletas").then(function (response) {
      $log.log(response);
    },
      function (error) {
        $log.error(error);
      });
  }

  $scope.Herramientas = function () {
    var tipo = "";
    var unico = true;
    if ($scope.data.gridFichasTecnicas && $scope.data.gridFichasTecnicas.gridApi ) {
        var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
        selectedRows.forEach(function (row) {
          if (tipo != row.tipo_ft && (tipo || tipo.trim().length > 0)) unico = false;
          tipo = row.tipo_ft;
        })
    }
    return unico;
  }

  $scope.VersionarMasivamente = function () {
    var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
    var id_ficha_tecnicas = [];
    selectedRows.forEach(function (row) {
      id_ficha_tecnicas.push(row.id_ficha_tecnica)
    })

    var template = "app/FTBase/ListadosFT/acciones/versionar_masivamente_popup.html";
    var options = { controller: "VersionarMasivamentePopupController" };
    var params = { id_ficha_tecnicas: id_ficha_tecnicas };
    ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
      var responseObj = {
        status: 200,
        data: {
          Result: true,
          GlobalMessage: {
            ErrType: 0,
            Msg: response.data,
            Property: null,
            TypeOfError: 0
          }
        }
      }
      $ngConfirm({
        title: "Versionar masivamente",
        content: responseObj.data.GlobalMessage.Msg.replace(/\r\n/g, '<br>')
      });
      ixStatusService.setResponse(responseObj);
    });
  };

  $scope.DesbloquearMasivamente = function () {
    var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
    var id_ficha_tecnicas = [];
    selectedRows.forEach(function (row) {
      id_ficha_tecnicas.push(row.id_ficha_tecnica)
    })
    var nombretipo = selectedRows[0].tipo_ft;
    var params = buildIxSearch();
    params.Filters.push({ Field: "nombre", Value: nombretipo, Operator: CMP_EQ });
    $http.post(cfg.baseURL + "ft_versiones/Search", params).then(function (response) {
      if (response.data.Items.length == 0 || response.data.Items.length > 1) {
        var responseObj = {
          status: 400,
          data: {
            Result: true,
            GlobalMessage: {
              ErrType: 0,
              Msg: "El tipo de versión no existe o existe más de uno con el mismo nombre.",
              Property: null,
              TypeOfError: 0
            }
          }
        }
        ixStatusService.setResponse(responseObj);
      } else {
        var template = "app/FTBase/ListadosFT/acciones/desbloquear_masivamente_popup.html";
        var options = { controller: "DesbloquearMasivamentePopupController" };
        var params = { id_ficha_tecnicas: id_ficha_tecnicas, tipoFT: response.data.Items[0].version };
        ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
          var responseObj = {
            status: 200,
            data: {
              Result: true,
              GlobalMessage: {
                ErrType: 0,
                Msg: response.data.replace(/\r\n/g, '<br>'),
                Property: null,
                TypeOfError: 0
              }
            }
          }
          $ngConfirm({
            title: "Bloquear/Desbloquear masivamente",
            content: responseObj.data.GlobalMessage.Msg
          });
          ixStatusService.setResponse(responseObj);
        });
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };

  $scope.$on("$destroy", function () {
    $scope.data.gridFichasTecnicas.ixSaveConfig();
  });
}]);

/*global ixFiltersToArray*/
/*global saveAs*/

angular.module('FTBase').controller('Listado_emd_fichas_seguridadController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService','$translate', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;

  $scope.ocultarSelAsociados = true;
  if (!$scope.data.filtro) $scope.data.filtro = {};

  if(angular.isUndefined($scope.filterStatus))
		$scope.filterStatus = { isCollapsed: true };

    /* ***** FUNCTION: INIT ***** */
  $scope.init = function (){
    var usuario = authService.authentication.userName;

    $scope.data.filtro.vigentes = true;

    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.data.extranetUser.cliente == 1031 || !($scope.data.extranetUser.laboratorio || $scope.data.extranetUser.proveedor || $scope.data.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;

      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.cargarGrid = function (){
      if (!$scope.data.gridFicheros){
        var acciones = [
          {
            title: "Previsualizar PDF",
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
            },
            accion: function (entity) {
              $http({
                method: 'post',
                url: cfg.baseURL + 'fichas_tecnicas_ficheros/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: 'Descargar informes',
            icon: 'fa-download',
            visible: function (entity) {
              return true;
            },
            accion: function (entity) {
                $scope.descargarArchivo(entity.id);
            }
          }
        ];
        var metadata = [];

        $scope.data.gridFicheros = gridService.createGrid($scope, 'ficherosSeguridadGrid', { metadata: metadata }, 'listado_euromadi_fichas_seguridadVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["vigentes", "exclusivas", "proveedores", "tipos_ficheros", "asociados"]);
      }
      else {
        $scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
      }

      $scope.ixDownloadExcel = $scope.data.gridFicheros.ixDownloadExcel;
      $scope.data.gridFicheros.ixLoadInitialData();
    };

  };

  // if($scope.status.filtered)
  //   $scope.ixFiltrar();

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = true;

    $scope.data.gridFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["vigentes", "exclusivas", "proveedores", "tipos_ficheros", "asociados"]);
    $scope.data.gridFicheros.ixLoadInitialData();

    $scope.status.filtered = false;
  };

  $scope.descargarArchivo = function(idf){
    $http({
			method: 'post',
			url: cfg.baseURL + 'fichas_tecnicas_ficheros/DownloadFile?id=' + idf,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
  };


  $scope.seleccionarRowsVisibles = function () {
    $scope.data.gridFicheros.gridApi.grid.getVisibleRows().forEach(function (row) {
      row.entity.Selector = true;
    });
  };


  $scope.borrarSeleccionRows = function () {
    $scope.data.gridFicheros.data.forEach(function (row) {
      row.Selector = false;
    });
  };


  $scope.descargaMasivaArchivos = function () {
    var lista = [];

    $scope.data.gridFicheros.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      lista.push(row.id);
    });

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "fichas_tecnicas_ficheros/DescargaMultiple", lista, config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ficheros_ft.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };


}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_control_envio_obs_alergenos_appController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  // $scope.status.editing = false;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function (){
    $scope.cargarGrid = function (){
      if (!$scope.data.grid_envio_obs){
        // var acciones = [];
        // var metadata = [];
        $scope.data.grid_envio_obs = gridService.createGrid($scope, 'control_envio_obs_appGrid', {}, 'list_envio_obs_alergenosVM' /*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }] */);
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.grid_envio_obs.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
      }
      else{
        $scope.data.grid_envio_obs = gridService.createGridFunctions($scope, $scope.data.grid_envio_obs);
        $scope.data.grid_envio_obs.ixRestoreConfig();
      }

      $scope.ixEditar = function(){
      		ixStatusService.setEditing(true);
    	};

      $scope.ixGuardar = function(){
        var bulkParam = $scope.data.grid_envio_obs.ixGetBulkParam();

        $http.put(cfg.baseURL + "list_envio_obs_alergenosVM/MarcarEnvioObs",bulkParam).then(function(r){
          ixStatusService.setResponse(r);
        },function(error){
          ixStatusService.setResponse(error);
        });

        ixStatusService.setEditing(false);
      };

      $scope.ixCancelEdit = function(){
        $scope.data.grid_envio_obs.ixCancelEdit();
        ixStatusService.setEditing(false);
      };


      // $scope.ixDownloadExcel = $scope.data.grid_envio_obs.ixDownloadExcel;
    };

    $scope.cargarGrid();

		$scope.$on("$destroy", function() {
			$scope.data.grid_envio_obs.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  };

}]);

/*global ixFiltersToArray*/
"use strict";

//[ '$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService){
angular.module('FTBase').controller('Listado_Cambio_Estados_FtController', [ '$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', 'authService', '$http', '$filter', '$log', function($scope, ixUtilsService, ixStatusService, gridService, cfg, authService, $http, $filter, $log){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.gridManualLoad = true;
  if(!$scope.data.filtro) $scope.data.filtro = {};

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    var usuario = authService.authentication.userName;

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      $scope.extranetUser = response.data;
    }, function(error){
      ixStatusService.setResponse(error);
    });

    $scope.filterStatus = { isCollapsed: true };

    $scope.cargarGrid = function(){
      if (!$scope.data.gridCambioEstadosFt){
				//Si no hay acciones, no hay acciones...
//        var acciones = [];
//        var metadata = [];

        $scope.data.gridCambioEstadosFt = gridService.createGrid($scope, 'cambiosEstadosFtGrid', {}, 'listado_cambio_estadosFtVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
      }
      else {
        $scope.data.gridCambioEstadosFt = gridService.createGridFunctions($scope, $scope.data.gridCambioEstadosFt);
        $scope.data.gridCambioEstadosFt.ixRestoreConfig();
      }
    };

    $scope.cargarGrid();
    $scope.ixDownloadExcel = $scope.data.gridCambioEstadosFt.ixDownloadExcel;

		$scope.$on("$destroy", function() {
			$scope.data.gridCambioEstadosFt.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  }
  /* ***** END FUNCTION: INIT ***** */

  /* ***** FUNCTION: IXFILTRAR ***** */
  $scope.ixFiltrar = function() {
    $scope.filterStatus.isCollapsed = true;
    $scope.data.gridCambioEstadosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["proveedor", "fecha_inicio","fecha_fin" ]);
    $scope.data.gridCambioEstadosFt.ixLoadInitialData();

    // $scope.showGrid($scope.data.gridCambioEstadosFt);

    $scope.status.filtered = false;
  }
  /* ***** END FUNCTION: IXFILTRAR ***** */
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
/*global moment*/
"use strict";

angular.module('FTBase').controller('Listado_Analiticas_FTController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;
    $scope.gridManualLoad = true;

    $scope.ocultarSelAsociados = true;

    var current_year = moment().format('YYYY');
    if (!$scope.data.filtro) $scope.data.filtro = {
        start_month: 1,
        start_year: current_year
    };

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {

        var usuario = authService.authentication.userName;

        $scope.esAdmin = function () {
            if ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
                return false;
            else
                return true;
        }

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;
            //El selector de cliente asociado será solo visible para DM y Biotecnal
            if ($scope.extranetUser.cliente == 1031 || !($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente))
                $scope.ocultarSelAsociados = false;
            $scope.cargarGrid();
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.filterStatus = { isCollapsed: true };

        if ($scope.data.gridft_analiticas)
            $scope.ixDownloadExcel = $scope.data.gridft_analiticas.ixDownloadExcel;

        $scope.cargarGrid = function () {
            if (!$scope.data.gridft_analiticas) {
                var acciones = [
                    {
                        title: 'Ver editar',
                        icon: 'fa-pencil',
                        visible: function (entity) {
                            return true;
                        },
                        accion: function (entity) {
                            $scope.abrirPopupAnalitica(false, entity.id, entity.marca, entity.proveedor, entity.titulo, entity.cod_interno, entity.fecha_realizacion, entity.informe_analisis, entity.informe_etiquetado, entity.informe_posicionamiento);
                            $scope.data.gridft_analiticas.ixSaveConfig();
                        }
                    },
                    {
                        title: 'Descargar informes',
                        icon: 'fa-download',
                        visible: function (entity) {
                            return $scope.tieneFichero(entity);
                        },
                        accion: function (entity) {
                            $scope.descargarArchivos(entity.id);
                        }
                    },
                    {
                        title: 'Corregir analitica',
                        icon: 'fa-check',
                        visible: function (entity) {
                            return $scope.extranetUser.laboratorio && entity.estado == "FINALIZADO";
                        },
                        accion: function (entity) {
                            $scope.corregirAnalitica(entity.id);
                        }
                    },
                    {
                        title: 'Reactivar',
                        icon: 'fa-undo',
                        visible: function (entity) {
                            return ($scope.esAdmin() && (entity.estado == "FINALIZADO" || entity.estado == "FINALIZADO-CORREGIDO"));
                        },
                        accion: function (entity) {
                            $scope.reactivarAnalitica(entity.id);
                        }
                    },
                    {
                        title: 'Eliminar analitica',
                        icon: 'fa-trash',
                        visible: function (entity) {
                            return ($scope.esAdmin() && (entity.estado != "FINALIZADO" && entity.estado != "FINALIZADO-CORREGIDO")) || ($scope.extranetUser.cliente && entity.estado == 'PLANIFICADO');
                        },
                        accion: function (entity) {
                            $scope.eliminarAnalitica(entity.id);
                        }
                    }
                ];
                var metadata = [
                ];

                $scope.data.gridft_analiticas = gridService.createGrid($scope, 'ft_analiticas_grid', {}, 'listado_analiticas_ftVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
                $scope.ixDownloadExcel = $scope.data.gridft_analiticas.ixDownloadExcel;

                if ($scope.extranetUser.laboratorio)
                    $scope.data.filtro.id_laboratorio = $scope.extranetUser.laboratorio;
                //$scope.data.gridft_analiticas.filtroExterno = [{ Field: "id_laboratorio", Value: $scope.extranetUser.laboratorio, Operator: CMP_EQ }];
                $scope.data.gridft_analiticas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["start_month", "start_year", "end_month", "end_year", "busqueda_generica", "asociados", "exclusivas"]);
            }
            else {
                $scope.data.gridft_analiticas = gridService.createGridFunctions($scope, $scope.data.gridft_analiticas);
                $scope.data.gridft_analiticas.ixRestoreConfig();
            }

            $scope.data.gridft_analiticas.ixLoadInitialData();
        }

        $scope.tieneFichero = function (entity) {
            if (entity.num_boletines > 0)
                return true;
            else
                return false;
        }

        $scope.abrirPopupAnalitica = function (is_new, id_ft, marca, proveedor, titulo, cod_interno, fecha) {
            var template = "app/FTBase/ListadosFT/acciones/analitica_ft_popup.html";
            var optionsPopup = { controller: "AnaliticaFTPopupController" };

            var params = { "is_new": is_new, "id_ft": id_ft, "marca": marca, "proveedor": proveedor, "titulo": titulo, "cod_interno": cod_interno, "extranetUser": $scope.extranetUser, "fecha": fecha };
            var modalAnaliticaFT = ixUtilsService.openModalV2(template, optionsPopup, "medium", params);
            modalAnaliticaFT.then(function (response) {
                if (response)
                    $scope.cargarGrid();
                ixStatusService.setEditing(false);
            });
        }

        $scope.descargarArchivos = function (id) {
            var config = { responseType: 'arraybuffer' };
            $http.get(cfg.baseURL + "boletines_analisis_euromadi/DownloadFiles/" + id, config).then(function (response) {
                var mimetype = response.headers('Content-type');
                var file = new Blob([response.data], { type: mimetype });

                var filename = "ft_analiticas.zip";
                if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                }
                saveAs(file, filename);
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }

        $scope.corregirAnalitica = function (id) {
            $http.post(cfg.baseURL + "ft_analiticas/CorregirAnalitica/" + id).then(function (response) {
                $scope.cargarGrid();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        }

        $scope.eliminarAnalitica = function (id) {
            $http.delete(cfg.baseURL + "ft_analiticas/" + id).then(function (response) {
                $scope.cargarGrid();

            }, function (err) {
                ixStatusService.setResponse(err);
            });
        }

        $scope.reactivarAnalitica = function (id) {
            $http.post(cfg.baseURL + "ft_analiticas/ReactivarAnalitica/" + id).then(function (response) {
                $scope.cargarGrid();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };


        $scope.$on("$destroy", function () {
            $scope.data.gridft_analiticas.ixSaveConfig();
            $scope.isDestroyed = true;
        });
    } //END INIT function

    $scope.ixFiltrar = function () {
        $scope.filterStatus.isCollapsed = true;
        if ($scope.extranetUser.laboratorio)
            $scope.data.filtro.id_laboratorio = $scope.extranetUser.laboratorio;
        //$scope.data.gridft_analiticas.filtroExterno = [{ Field: "id_laboratorio", Value: $scope.extranetUser.laboratorio, Operator: CMP_EQ }];
        $scope.data.gridft_analiticas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["start_month", "start_year", "end_month", "end_year", "busqueda_generica", "asociados", "exclusivas"]);
        $scope.data.gridft_analiticas.ixLoadInitialData();

        $scope.status.filtered = false;
    }
    // $scope.$on("$destroy", function() {
    //   $scope.data.gridft_analiticas.ixSaveConfig();
    //   $scope.isDestroyed=true;
    // });

}]);

/*global saveAs*/

angular.module('FTBase').controller('Descarga_Informes_AnaliticasController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', 'authService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.data.checkInformesEnsayo = true;
    $scope.data.checkInformesEtiquetado = true;
    $scope.data.checkInformesPosicionamiento = true;

    $scope.status.editing = false;


    $scope.descargarInformes = function () {
        var listaEans = $scope.data.listEans.split('\n');
        var config = { responseType: 'arraybuffer' };
        var params = {
            lista_eans: listaEans,
            fecha_inicio: $scope.data.fecha_inicio,
            fecha_fin: $scope.data.fecha_fin,
            check_analitica: $scope.data.checkInformesEnsayo,
            check_etiquetado: $scope.data.checkInformesEtiquetado,
            check_posicionamiento: $scope.data.checkInformesPosicionamiento
        }
        $http.post(cfg.baseURL + "ft_analiticas/DescargarEans", params, config).then(function (response) {

            var file = new Blob([response.data], { type: 'application/zip' });

            var filename = "ft_analiticas.zip";
            if (response.headers('Content-Disposition')) {
                filename = response.headers('Content-Disposition').split("=")[1];
            }
            saveAs(file, filename);
        }, function (error) {
            ixStatusService.setResponse(error);
        });

    }
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Control_presencia_fotosController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        if (!$scope.data.filtro) $scope.data.filtro = {};
        $scope.data.filtro.ft_activas = true;
        $scope.filterStatus = { isCollapsed: false };

        $scope.esAdminODM = false;

        var usuario = authService.authentication.userName;

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;

            if ($scope.extranetUser.cliente) {
                if ($scope.extranetUser.cliente == 1031)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }
            else {
                if (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }

            $scope.cargarGrid();
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.cargarGrid = function () {

            if (!$scope.data.grid_control_fotos) {
                var acciones = [];
                var metadata = [
                    {
                        Name: "estado_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    },
                    {
                        Name: "fecha_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    }

                ];

                $scope.data.grid_control_fotos = gridService.createGrid($scope, 'control_fotos_grid', { metadata: metadata }, 'control_presencia_fotosVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
            }
            else {
                $scope.data.grid_control_fotos = gridService.createGridFunctions($scope, $scope.data.grid_control_fotos);
                $scope.data.grid_control_fotos.ixRestoreConfig();
            }

            $scope.data.grid_control_fotos.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
            $scope.ixDownloadExcel = $scope.data.grid_control_fotos.ixDownloadExcel;
        }

        $scope.ixFiltrar = function () {
            $scope.data.grid_control_fotos.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
            $scope.data.grid_control_fotos.ixLoadInitialData();
        };

        $scope.$on("$destroy", function () {
            $scope.data.grid_control_fotos.ixSaveConfig();
            $scope.isDestroyed = true;
        });

    }

}]);

/*global ixFiltersToArray*/
/*global CMP_EQ*/
"use strict";

angular.module('FTBase').controller('CargaFicherosFtController', ['$scope', '$http', '$filter', '$log', 'ixStatusService', 'gridService', 'cfg', 'authService', 'Upload', function ($scope, $http, $filter, $log, ixStatusService, gridService, cfg, authService, Upload) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;

  $scope.seleccion = {};
  $scope.proveedor = undefined;
  $scope.caducidad_obligatoria = undefined;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {
    var usuario = authService.authentication.userName;
    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //Esta pantalla es visible sólo para proveedores
      if ($scope.data.extranetUser.proveedor)
        $scope.proveedor = $scope.data.extranetUser.proveedor;
      // else
      //   $scope.proveedor = 0;

      //if (angular.isDefined($scope.proveedor))
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.cargarGrid = function (){
      if (!$scope.data.gridProductosFt){
        var acciones = [];
        var metadata = [
          {
            Name: "marcas_todas",
            NoVisible: true
          },
          {
            Name: "fecha_aprobada",
            NoVisible: true
          },
          {
            Name: "fecha_revision",
            NoVisible: true
          },
          {
            Name: "cumplimentada",
            NoVisible: true
          },
          {
            Name: "estado_envio_datos_aecoc",
            NoVisible: true
          },
          {
            Name: "fecha_envio_datos_aecoc",
            NoVisible: true
          },
          {
            Name: "ultimo_comentario",
            NoVisible: true
          },
          {
            Name: "publicar_aecoc",
            NoVisible: true
          },
          {
            Name: "marcas_asociadas",
            NoVisible: true
          },
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];  

        //$scope.data.gridProductosFt = gridService.createGrid($scope, 'CargaFicherosFtGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridProductosFt = gridService.createGrid($scope, 'CargaFicherosFtGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
      }
      else {
        $scope.data.gridProductosFt = gridService.createGridFunctions($scope, $scope.data.gridProductosFt);
        $scope.data.gridProductosFt.ixRestoreConfig();
      }

      $scope.data.filtro = {};
      $scope.data.filtro.estado = ["O", "R", "A", "P", "S"];
      if (angular.isDefined($scope.proveedor))
        $scope.data.filtro.proveedor = $scope.proveedor;

      $scope.data.gridProductosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados", "exclusivas"]);
    };
  };

  $scope.tienePresentacionProductoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_proveedor") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.loadTiposFicheroFT = function (params, search) {
		if($scope.tienePresentacionProductoRestringido()) params.Filters.push({ Field: 'id', value: 28, "Operator": CMP_EQ, not: true });
		return $http.post(cfg.baseURL + "tipos_fichero_ft/Search?ItemsPerPage=150", params);
	  }

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.tipoArchivoSeleccionado = function(entity){
		if (entity){
			$scope.especificar_producto = entity.especificar_producto;
			$scope.caducidad_obligatoria = entity.caducidad_obligatoria;
		}
		else {
			$scope.especificar_producto = undefined;
			$scope.caducidad_obligatoria = undefined;
		}
	};

  $scope.seleccionarRowsVisibles = function(){
    $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };

  $scope.desSeleccionarRows = function(){
    $scope.data.gridProductosFt.data.forEach(function(row){
      row.Selector = false;
    });
  };

  $scope.guardarFichero = function(){
    var fileNames = [];
		angular.forEach($scope.seleccion.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

    $log.log("Tipo: " + $scope.seleccion.tipoSeleccionadoFt);
    $log.log("Inicio validez: " + $scope.seleccion.inicioValidez);
    $log.log("Caducidad: " + $scope.seleccion.fechaCaducidad);

    var lista_ft = [];
    var lista_productos = [];
    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      lista_ft.push(row.id_ficha_tecnica);
      //var prod = { id_ft: row.id_ficha_tecnica, id_producto: row.id_producto };
      lista_productos.push(row.id_producto);
    });

    $log.log(lista_ft);
    $log.log(lista_productos);

    var data = { filename: fileNames[0], detalles: [] };
    for (var i = 0; i < lista_ft.length; i++)
    {
      data.detalles.push({ id_ficha_tecnica: lista_ft[i], id_producto: lista_productos[i], tipo: $scope.seleccion.tipoSeleccionadoFt, fecha_caducidad: $scope.seleccion.fechaCaducidad, inicio_validez: $scope.seleccion.fechaCaducidad });
    }

    $http.post(cfg.baseURL + "fichas_tecnicas_ficheros/CanUploadMultiple", data).then(function(response){
      var strListaFt = lista_ft.join();
      var strListaProductos = lista_productos.join();
      if(response.data.GlobalMessage.ErrType == 0){
        $scope.data.uploadingFile = true;
        var upload = Upload.upload({
          url: cfg.baseURL + "fichas_tecnicas_ficheros/UploadAndCreateMultiple",
          data: {
            file: $scope.seleccion.archivosToUpload,
            ids_ficha_tecnica: strListaFt,
            ids_productos: strListaProductos,
            tipo: $scope.seleccion.tipoSeleccionadoFt,
            fecha_caducidad: $scope.seleccion.fechaCaducidad,
            inicio_validez: $scope.seleccion.inicioValidez
          },
          dataType: 'json'
        });

        upload.then(function(response){
          if(response.data){
            delete $scope.data.ixProgress;
            $scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
            //$scope.status.editing = false;
          }
        },
        function(err){
          if(err.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
            ixStatusService.setResponse(err);
					}
        },
        function(evt){
          $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
      else {
        ixStatusService.setResponse(response);
      }
    },
    function(err){
      ixStatusService.setResponse(err);
    });
  };


}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs */
"use strict";

angular.module('FTBase').controller('Busqueda_AvanzadaController', [ '$scope', '$http', '$filter', 'cfg', 'ixStatusService', 'gridService', 'authService', function($scope, $http, $filter, cfg, ixStatusService, gridService, authService){

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  var imprimirExcel = function(id_pregunta){
    var param = {};
    param.Selection = {};
    param.Selection.Filters = [{Field: 'id_pregunta', Value: id_pregunta, Operator: CMP_EQ, Skip:true}];
    if ($scope.data.filtro.asociados){
      if ($scope.data.filtro.asociados.length > 0){
        var lista_asociados = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["asociados" ]);
        for(var i = 0; i < lista_asociados.length ; i++)
          param.Selection.Filters.push(lista_asociados[i]);
        }
    }

    param.Fields = [
      {Field: 'FichaTecnica'},
      {Field: 'titulo'},
      {Field: 'Proveedor'},
      {Field: 'Cod_Interno'},
      {Field: 'Cod_Interno_Asociados'},
      {Field: 'ean'},
      {Field: 'Marca'},
      {Field: 'MarcasAsociadas'},
      {Field: 'estado'},
      {Field: 'componente'},
      {Field: 'orden_n1'},
      {Field: 'orden_n2'},
      {Field: 'orden_n3'},
      {Field: 'ft_pregunta_informe'},
      {Field: 'marca_etiquetado'},
      {Field: 'observaciones'},
      {Field: 'sub_respuesta1'},
      {Field: 'sub_respuesta2'},
      {Field: 'sub_respuesta3'},
      {Field: 'sub_respuesta4'},
      {Field: 'sub_respuesta5'},
      {Field: 'sub_respuesta6'},
      {Field: 'sub_respuesta7'},
      {Field: 'sub_respuesta8'},
      {Field: 'sub_respuesta9'},
      {Field: 'sub_respuesta10'},
      {Field: 'sub_respuesta11'},
      {Field: 'sub_respuesta12'},
      {Field: 'sub_respuesta13'},
      {Field: 'sub_respuesta14'}
    ];
    var config = {responseType:"arraybuffer"};


    $http.post(cfg.baseURL +'listado_busqueda_avanzadaVM' + '/Excel' , param, config).then(function(r){
      var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      var filename = "listado" + $filter('date')(new Date(), 'HHmmss', null) + ".xlsx";

      if(r.headers('Content-Disposition')) {
        var nameFromServer = r.headers('Content-Disposition').split("=")[1];
        if(nameFromServer != "null.xlsx"){
          filename = nameFromServer;
        }
      }

      saveAs(file, filename);
    }, function(err){
      ixStatusService.setResponse(err);
    });
  }

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    $scope.filterStatus = { isCollapsed: false };
    if(!$scope.data.filtro) $scope.data.filtro = {};
    $scope.ocultarSelAsociados = true;

    var usuario = authService.authentication.userName;
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      var extranetUser = response.data;
      if (extranetUser.cliente == 1031 || !(extranetUser.laboratorio || extranetUser.proveedor || extranetUser.cliente))
        $scope.ocultarSelAsociados = false;

    }, function(error){
      ixStatusService.setResponse(error);
    });

    if (!$scope.data.gridBusqueda){
      var acciones = [
        {
          title: 'Imprimir excel',
          icon: 'fa-list',
          accion: function(entity){
  					imprimirExcel(entity.id_pregunta);
  				}
        }
      ];
      var metadata = [];

      $scope.data.gridBusqueda = gridService.createGrid($scope, 'gestornet_grid_busqueda_avanzada', { }, 'list_preguntas_busqueda_avanzadaVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridBusqueda = gridService.createGridFunctions($scope, $scope.data.gridBusqueda);
      $scope.data.gridBusqueda.ixRestoreConfig();
    }

		$scope.$on("$destroy", function() {
			$scope.data.gridBusqueda.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  }


}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global saveAs*/
"use strict"

angular.module('FTBase').controller('ListadoResumenHomologacionController', ['$scope', '$http', '$filter', 'cfg', 'gridService', 'ixStatusService', 'ixUtilsService', 'authService', function($scope, $http, $filter, cfg, gridService, ixStatusService, ixUtilsService, authService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.filterStatus = { isCollapsed: false };
  if (!$scope.data.filtro) $scope.data.filtro = {};
  $scope.data.filtro.vigentes = 1;
  $scope.data.filtro.solo_exclusivas = 0;

  $scope.init = function (){

    $scope.cargarGrid = function (){
      if (!$scope.data.grid_resumen_homologacion){
        var acciones = [
          {
            title: "Descargar ficheros",
            icon: "fa-file-pdf-o",
            visible: function(entity){
              if (entity.seg_alim_id_fichero == 0 && entity.social_id_fichero == 0 && entity.med_amb_id_fichero == 0)
                return false;
              else
                return true;
            },
            accion: function(entity){
              var lista = [];
              if (entity.seg_alim_id_fichero != 0) lista.push(entity.seg_alim_id_fichero);
              if (entity.social_id_fichero != 0) lista.push(entity.social_id_fichero);
              if (entity.med_amb_id_fichero != 0) lista.push(entity.med_amb_id_fichero);

              if (lista.length > 0){
                var config = { responseType: 'arraybuffer' };
                $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
                  var file = new Blob([response.data], { type: 'application/zip' });
            
                  var filename = "ficheros_ft.zip";
                  if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                  }
                  saveAs(file, filename);
                }, function (error) {
                  ixStatusService.setResponse(error);
                });
              }
            }
          }
        ];
        var metadata = [];

        $scope.data.grid_resumen_homologacion = gridService.createGrid($scope, 'resumen_homologacion_grid', {metadata: metadata}, 'listado_homologacion_plantas_resumenVM', [ { name: 'Acciones', type: 'detalle', acciones: acciones },{ name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
      }
      else {
        $scope.data.grid_resumen_homologacion = gridService.createGridFunctions($scope, $scope.data.grid_resumen_homologacion);
        $scope.data.grid_resumen_homologacion.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.grid_resumen_homologacion.ixDownloadExcel;

      if ($scope.data.extranetUser.cliente != null){
        //$scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes', 'solo_exclusivas']);
      }
      else {
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes','solo_exclusivas']);
      }
      
      $scope.data.grid_resumen_homologacion.ixLoadInitialData();
    };

    $scope.ixFiltrar = function (){
      if ($scope.data.extranetUser.cliente != null){
        //$scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes','solo_exclusivas']);
      }
      else {
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes','solo_exclusivas']);
      }
      //$scope.data.grid_resumen_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
      $scope.data.grid_resumen_homologacion.ixLoadInitialData();
    };
    
    var usuario = authService.authentication.userName;
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      $scope.data.extranetUser = response.data;
      $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
      $scope.cargarGrid();
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };

  $scope.seleccionarRowsVisibles = function(){
    $scope.data.grid_resumen_homologacion.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };

  $scope.desSeleccionarRows = function(){
    $scope.data.grid_resumen_homologacion.data.forEach(function(row){
      row.Selector = false;
    });
  };

  $scope.descargarFicherosSeleccionados = function(){
    var lista = [];
    $scope.data.grid_resumen_homologacion.data.filter(function(row){ return row.Selector == true; }).forEach(function(row){
      if (row.seg_alim_id_fichero != 0) lista.push(row.seg_alim_id_fichero);
      if (row.social_id_fichero != 0) lista.push(row.social_id_fichero);
      if (row.med_amb_id_fichero != 0) lista.push(row.med_amb_id_fichero);
    });

    if (lista.length > 0){
      var config = { responseType: 'arraybuffer' };
      $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
        var file = new Blob([response.data], { type: 'application/zip' });
  
        var filename = "ficheros_ft.zip";
        if (response.headers('Content-Disposition')) {
          filename = response.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (error) {
        ixStatusService.setResponse(error);
      });    }
  };

  $scope.$on("$destroy", function() {
		$scope.data.grid_resumen_homologacion.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global saveAs*/
"use strict"

/* Versión usando gridEditor.html */
/*
angular.module('FTBase').controller('ListadoControlHomologacionController', [ '$scope', '$controller', '$http', 'cfg', 'ixStatusService', 'ixUtilsService', '$log', function($scope, $controller, $http, cfg, ixStatusService, ixUtilsService, $log) {
  $scope.entity = "listado_homologacion_proveedoresVM";

  $scope.acciones = [
    {
      title: 'Visualizar/Editar Auditoría',
      icon: 'fa-pencil-square-o',
      visible: function(entity){
        return entity.grupo == 'AUDITORIAS';
      },
      accion: function(entity){
        var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
        var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
        var paramsPopup = { datosAuditoria: entity, isNew: false };
        ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function(response){
          if (response) $scope.data.grid.ixLoadInitialData();
        });
      }
    }
  ];

  //Crear nueva auditoría
  $scope.ixAddRow = function(){
    var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
    var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
    var paramsPopup = { datosAuditoria: undefined, isNew: true };
    ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function(response){
      if (response) $scope.data.grid.ixLoadInitialData();
    });
  };


  $scope.ixGuardar = function(){
    //Habrá sólo lineas eliminadas
    $log.log("Llamada ixGuardar lista control homologaciones");
  };


  $controller('GridEditorController', { $scope: $scope });
}]);
*/

/* Versión con propria página HTML */
angular.module('FTBase').controller('ListadoControlHomologacionController', ['$scope', '$http', '$filter', '$log', 'cfg', 'gridService', 'ixStatusService', 'ixUtilsService', 'authService', function ($scope, $http, $filter, $log, cfg, gridService, ixStatusService, ixUtilsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.filterStatus = { isCollapsed: false };
  if (!$scope.data.filtro) $scope.data.filtro = {};
  $scope.data.filtro.vigentes = true;

  $scope.init = function () {
    $scope.cargarGrid = function () {
      if (!$scope.data.grid_control_homologacion) {
        var acciones = [
          {
            title: "Previsualizar PDF",
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.grupo == 'CERTIFICADOS';
            },
            accion: function (entity) {
              var tabla = "proveedores_ficheros";
              $http({
                method: 'post',
                url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: "Descargar fichero",
            icon: "fa-download",
            visible: function (entity) {
              return entity.grupo == 'CERTIFICADOS';
            },
            accion: function (entity) {
              $scope.downloadFile(entity, 'CERTIFICADOS');
            }
          },
          {
            title: "Descargar documentos",
            icon: "fa-download",
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS' && entity.existen_docs > 0;
            },
            accion: function (entity) {
              $scope.downloadFile(entity, 'AUDITORIAS');
            }
          },
          {
            title: 'Visualizar/Editar Auditoría',
            icon: 'fa-pencil-square-o',
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS';
            },
            accion: function (entity) {
              var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
              var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
              var paramsPopup = { datosAuditoria: entity, isNew: false };
              ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
                $scope.status.editing = false;
                if (response) $scope.data.grid_control_homologacion.ixLoadInitialData();
              });
            }
          },
          {
            title: 'Archivar auditoría',
            icon: 'fa-archive',
            visible: function (entity) {
              return (entity.grupo == 'AUDITORIAS' && entity.archivada == 0);
            },
            accion: function (entity) {
              var param = [];
              param.push({
                value: 1,
                path: "/archivada",
                op: "replace"
              });

              $http.put(cfg.baseURL + "auditorias_plantas/" + entity.id, param).then(function (response) {
                $scope.data.grid_control_homologacion.ixLoadInitialData();
              },
                function (error) {
                  ixStatusService.setResponse(error);
                });
            }
          },
          {
            title: 'Marcar verificado',
            icon: 'fa-check-square-o',
            visible: function (entity) {
              return entity.verificacion == 0;
            },
            accion: function (entity) {
              var table = "";
              if (entity.grupo == 'AUDITORIAS')
                table = "auditorias_plantas";
              else //CERTIFICADOS
                table = "proveedores_ficheros";

              var param = [];
              param.push({
                value: 1,
                path: "/verificacion",
                op: "replace"
              });

              $http.put(cfg.baseURL + table + "/" + entity.id, param).then(function (response) {
                $scope.data.grid_control_homologacion.ixLoadInitialData();
              },
                function (error) {
                  ixStatusService.setResponse(error);
                });
            }
          },
          {
            title: 'Eliminar auditoría',
            icon: 'fa-trash',
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS' && (authService.tienePerfilAdmin() || authService.tienePerfilUserKey());
            },
            accion: function (entity) {
              $scope.eliminarAuditoriaPlanta(entity);
            }
          }
        ];
        var metadata = [];

        $scope.data.grid_control_homologacion = gridService.createGrid($scope, 'control_homologacion_grid', { metadata: metadata }, 'listado_homologacion_proveedoresVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
      }
      else {
        $scope.data.grid_control_homologacion = gridService.createGridFunctions($scope, $scope.data.grid_control_homologacion);
        $scope.data.grid_control_homologacion.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.grid_control_homologacion.ixDownloadExcel;

      var usuario = authService.authentication.userName;
      $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
        //asignar cliente
        $scope.data.extranetUser = response.data;
        //En funcion de si es cliente o no aplicamos el filtro de cliente o no
        if ($scope.data.extranetUser.cliente != null) {
          $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
          $scope.data.grid_control_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
          $scope.data.grid_control_homologacion.ixLoadInitialData();
        }
        else {
          $scope.data.grid_control_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }];
          $scope.data.grid_control_homologacion.ixLoadInitialData();
        }
      },
        function (error) {
          ixStatusService.setResponse(error);
        });
    };

    $scope.ixFiltrar = function () {
      if ($scope.data.extranetUser.cliente != null) {
        $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_control_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
        $scope.data.grid_control_homologacion.ixLoadInitialData();
      }
      else {
        $scope.data.grid_control_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
        $scope.data.grid_control_homologacion.ixLoadInitialData();
      }
    };

    $scope.openEditAuditoria = function () {
      var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
      var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
      var paramsPopup = { datosAuditoria: undefined, isNew: true };
      ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
        $scope.status.editing = false;
        $log.log("openEditAuditoria Reset Status.Editing");
        if (response)
          $scope.data.grid_control_homologacion.ixLoadInitialData();
      });
    };

    ixUtilsService.checkPermission("SubirHomologacionPlanta").then(function(response){
      $scope.data.permisoSubirCertificado = response;
      if($scope.data.permisoSubirCertificado){
        $scope.openCertificado = function(){
          var templateURL = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
          var controllerName = "UploadFilePopupProveedoresController";
          var optionsPopupFicheros = {
            controller: controllerName
          };
          var params = {"soloHayPlantaPuesta": true};
          var modalInstance = ixUtilsService.openModalV2(templateURL, optionsPopupFicheros, 'medium',params);
          modalInstance.then(function (resp){
            $scope.status.editing = false;
            $log.log("openEditAuditoria Reset Status.Editing");
            if (resp)
              $scope.data.grid_control_homologacion.ixLoadInitialData();
          })
        }
      }
    })

    
    


    $scope.downloadFile = function (entity, grupo) {
      if (grupo == 'CERTIFICADOS') {
        $http({
          method: 'post',
          url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + entity.id,
          headers: {},
          responseType: 'arraybuffer'
        }).then(function (r) {
          var file = new Blob([r.data], { type: r.headers('Content-type') });

          var filename = "Certificado " + entity.tipo + ".pdf";
          if (r.headers('Content-Disposition')) {
            filename = r.headers('Content-Disposition').split("=")[1];
          }
          saveAs(file, filename);
        },
          function (err) {
            ixStatusService.setResponse(err);
          });
      }
      else { // grupo == 'AUDITORIAS'
        $http({
          method: 'post',
          url: cfg.baseURL + 'auditorias_plantas_documentos/DownloadDocumentos/' + entity.id,
          headers: {},
          responseType: 'arraybuffer'
        }).then(function (r) {
          var file = new Blob([r.data], { type: r.headers('Content-type') });

          var filename = "DocumentosAuditoriaPlanta_" + entity.nombre_planta + ".zip";
          if (r.headers('Content-Disposition')) {
            filename = r.headers('Content-Disposition').split("=")[1];
          }
          saveAs(file, filename);
        },
          function (err) {
            ixStatusService.setResponse(err);
          });
      }
    };

    $scope.cargarGrid();
  };

  $scope.eliminarAuditoriaPlanta = function (aud) {
    $http.delete(cfg.baseURL + 'auditorias_plantas/' + aud.id).then(function (response) {
      $scope.data.grid_control_homologacion.ixLoadInitialData();
      ixStatusService.setResponse(response);
    },
      function (error) {
        ixStatusService.setResponse(error);
      });
  };

  $scope.$on("$destroy", function () {
    $scope.data.grid_control_homologacion.ixSaveConfig();
    $scope.isDestroyed = true;
  });


}]);


/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('DetallesAuditoriaPlantaController', ['$scope', '$http', '$uibModalInstance', '$q', '$timeout', '$translate', '$log', 'cfg', 'ixStatusService', 'ixUtilsService', 'gridService', 'Upload', function($scope, $http, $uibModalInstance, $q, $timeout, $translate, $log, cfg, ixStatusService, ixUtilsService, gridService, Upload){
  $scope.status = ixStatusService.current;
	$scope.data = {};
  $scope.data.updated = false;

  $scope.data.isNew = $scope.$resolve.isNew;
  $scope.data.datosAuditoria = $scope.$resolve.datosAuditoria;
  if (angular.isDefined($scope.data.datosAuditoria)){
    if ($scope.data.datosAuditoria.archivada)
      $scope.status.editing = false;
    else
      $scope.status.editing = true;
  }
  else{
    $scope.status.editing = true;
  }

  var buildGridDocs = function() {
    if (!$scope.data.gridDocs){
      var acciones = [
        {
          title: $translate.instant("Descargar fichero"),
          icon: "fa-download",
          visible: function (entity) {
            return entity.nombre_archivo;
          },
          accion: function (entity) {
            $scope.downloadFile(entity);
          }
        }
      ];
      //ar metadata = [];

      $scope.data.gridDocs = gridService.createGrid($scope, "grid_documentos_auditoria_planta", { minRowsToShow: 3, enableCellEdit: false, showOnlyDescribedCols: ["nombre_archivo"]}, "auditorias_plantas_documentos", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }])
      $scope.data.gridDocs.filtroExterno = [{ Field: "auditoria_planta", Operator: CMP_EQ, Value: $scope.data.datos.id }];
      $scope.data.gridDocs.ixLoadInitialData();
    }
    else {
      $scope.data.gridDocs = gridService.createGridFunctions($scope, $scope.data.gridBoletines);
      $scope.data.gridDocs.ixRestoreConfig();
    }
  };
    

  if (!$scope.data.isNew){
    $scope.data.datos = {};
    $scope.data.datos.id = $scope.data.datosAuditoria.id;
    $scope.data.proveedor = $scope.data.datosAuditoria.id_proveedor;
    $scope.data.datos.planta = $scope.data.datosAuditoria.id_planta;
    $scope.data.categoria = $scope.data.datosAuditoria.id_categoria;
    $scope.data.datos.tipo = $scope.data.datosAuditoria.id_tipo;
    $scope.data.datos.alcance = $scope.data.datosAuditoria.alcance;
    $scope.data.datos.fecha_realizacion = $scope.data.datosAuditoria.fecha_caducidad_realizacion;
    $scope.data.datos.laboratorio = $scope.data.datosAuditoria.id_laboratorio;
    $scope.data.datos.resultado_auditoria = $scope.data.datosAuditoria.resultado_auditoria;
    $scope.data.datos.estado_resultado = $scope.data.datosAuditoria.estado;
    $scope.data.datos.comentarios = $scope.data.datosAuditoria.comentarios;
    $scope.data.datos.verificacion = $scope.data.datosAuditoria.verificacion;
    $scope.data.datos.proxima_auditoria = $scope.data.datosAuditoria.proxima_auditoria;

    $scope.data.datosOriginales = angular.copy($scope.data.datos);

    buildGridDocs();
  }

  $scope.cargarPlantasProveedor = function(){
    $log.log($scope.data.proveedor);
    return $http.post(cfg.baseURL + "plantas/ListPorProveedor/" + $scope.data.proveedor);
  };

  $scope.limpiarPlanta = function(){
    $scope.data.datos.planta = undefined;
  };

  $scope.$watchGroup(['data.datos.fecha_realizacion','data.categoria'], function(newValue,oldValue){
    if (newValue!=oldValue){
      //Se calcula la fecha de próxima auditoría sólo para auditorías que no sean del tipo AUDITORIA VALIDADA
      if (!($scope.data.datos.tipo == 7 || $scope.data.datos.tipo == 8 || $scope.data.datos.tipo == 9)){
        if($scope.data.datos.fecha_realizacion){
          var year = $scope.data.datos.fecha_realizacion.getFullYear();
          if ($scope.data.categoria == 1) //Seguridad Alimentaria
            $scope.data.datos.proxima_auditoria = year + 2;
          if ($scope.data.categoria == 2 || $scope.data.categoria == 3) //Social o Medio Ambiente
            $scope.data.datos.proxima_auditoria = year + 3;
        }  
      }
    }
  })

  $scope.save = function(){
    if ($scope.data.isNew){
      //Agregar nueva auditoría
      var nuevaAuditoria = {};

      nuevaAuditoria = $scope.data.datos;
      $http.post(cfg.baseURL + "auditorias_plantas", nuevaAuditoria).then(function(response){
        var fileNames = [];
		    angular.forEach($scope.data.archivosToUpload, function(fileToUpload){
			    fileNames.push(fileToUpload.name);
		    });

        $http.post(cfg.baseURL + "auditorias_plantas_documentos/CanUpload/" + $scope.data.datos.planta + "/" + response.data.obj.Record.id, fileNames).then(function(resp){
          $log.log(resp);
          if(response.data.GlobalMessage.ErrType == 0){
            $scope.data.uploadingFile = true;
            var upload = Upload.upload({
              url: cfg.baseURL + "auditorias_plantas_documentos/UploadAndCreate",
              data: {
                file: $scope.data.archivosToUpload,
                id_planta: $scope.data.datos.planta,
                id_auditoria: response.data.obj.Record.id
              },
              dataType: 'json'
            });

            upload.then(function(r){
              if(r.data){
                delete $scope.data.ixProgress;
                $scope.data.uploadingFile = false;
                ixStatusService.setResponse(response);
                $scope.status.editing = false;
                $scope.data.updated = true;
                $uibModalInstance.close($scope.data.updated);
              }
            },
            function(e){
              if(e.data){
                delete $scope.data.ixProgress;
                $scope.data.uploadingFile = false;
              }
            },
            function(evt){
              $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
          }
          else {
            ixStatusService.setResponse(resp);
          }
        },
        function(err){
          ixStatusService.setResponse(err);
        });
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar auditoría
      var param = {};
      param = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      var cambio =  param.find(function(e) { return e.path == '/proxima_auditoria'});
       if (cambio){
        if (angular.isString(cambio.value)){
          cambio.value = cambio.value.replace('.','');
        }
      } 

      $http.put(cfg.baseURL + "auditorias_plantas/" + $scope.data.datos.id, param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.updated = true;
        $uibModalInstance.close($scope.data.updated);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  }; 

  $scope.deleteSelectedDocs = function(){
    $scope.data.gridDocs.ixDeleteSelectedRows();
    var dataToDel = $scope.data.gridDocs.ixGetBulkParam();
    $http.post(cfg.baseURL + "auditorias_plantas_documentos/UpdateBulk", dataToDel).then(function (response) {
      $scope.data.updated = true;
      ixStatusService.setResponse(response);
      $scope.data.updated = true;
    },
      function (error) {
        ixStatusService.setResponse(error);
      });
  };

  $scope.addDoc = function(){
    var urlTemplate = "app/FTBase/HomologacionPlantas/modales/uploadDocumentoAuditoriaPlanta.html";
    var optionsPopupDocs = { controller: "UploadDocumentoAuditoriaPlantaController" };
    var params = { id_planta: $scope.data.datos.planta, id_auditoria: $scope.data.datosAuditoria.id };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupDocs, 'small', params);
    modalInstance.then(function(resp){
      //Si se han agregado documentos, actualizar el grid
      if (resp) {
        $scope.data.gridDocs.ixLoadInitialData();
        $scope.data.updated = true;
      }
    });
  };

  $scope.downloadFile = function(entity){
    $http({
      method: 'post',
      url: cfg.baseURL + 'auditorias_plantas_documentos/DownloadDocumento/' + entity.id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function(r){
      var file = new Blob([r.data], { type: r.headers('Content-type') });
      var filename = "DocumentoAuditoria.pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    },
    function(err){
      ixStatusService.setResponse(err);
    });
  };

  $scope.$dismiss = function(){
    $uibModalInstance.close($scope.data.updated);
  };
}]);
angular.module('FTBase').controller('EansCodInternoMasivoController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService) {
    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    //GestPark ofrece la opción de simular. De momento solo actualizaremos.
    $scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

    $scope.init = function(){
        $scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 150 },
				{title: 'EAN ACTUAL', readOnly: false, width: 150 },
                {title: 'EAN NUEVO', readOnly: false, width: 150 },
				{title: 'COD INTERNO', readOnly: false, width: 150}
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"ean_antiguo", "2":"ean_nuevo", "3":"cod_interno"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "fichas_tecnicas_productos/EansCodInternoMasivo?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    return dst;
	}


		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
    }

}]);
angular.module('FTBase').controller('CambioEstadoMasivoController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService) {
    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    //GestPark ofrece la opción de simular. De momento solo actualizaremos.
    $scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

    $scope.init = function(){
        $scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 100 },
				{title: 'ESTADO', readOnly: false, width: 100 },
				{title: 'COMENTARIO CAMBIO ESTADO', readOnly: false, width: 250},
				{title: 'COMENTARIO BAJA VERSION ANTERIOR', readOnly: false, width: 250 },
				{title: 'FECHA', readOnly: false, width: 150,type:"date",value:'date', dateFormat:"DD/MM/YYYY",correctFormat: true,allowInvalid: false }
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"estado", "2":"coment_alta", "3":"coment_baja", "4":"fecha_aprobacion"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas/CambioEstadoMasivo?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
				if(key == "4"){
					var fechacasteada = src[key].split("/");
	            	dst[map[key]] = new Date(parseInt(fechacasteada[2])+ "/" + parseInt(fechacasteada[1])+"/"+parseInt((fechacasteada[0])));
				}
				else dst[map[key]] = src[key];
	        else
	            // same key
				if(key == "4"){
					var fechacast = src[key].split("/");
	            	dst[map[key]] = new Date(parseInt(fechacast[2])+ "/" + parseInt(fechacast[1])+"/"+parseInt((fechacast[0])));
				}
				else dst[key] = src[key];
	    }
	    return dst;
	}

		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
    }

}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*eslint angular/no-private-call: 0*/
/*eslint angular/document-service: 0*/
/*global angular */
/*global convertDateStringsToDates*/
/*global ixGetPatchOperations*/
/*global saveAs*/
/*global CMP_EQ*/
/*global buildIxSearch*/
"use strict";

angular.module('FTBase').controller("GestionFichasTecnicasController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', 'ViewBuilderService', '$q', 'ixUtilsService', '$location', '$compile', '$log', '$window', '$rootScope', 'authService', '$filter', '$ngConfirm', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, ViewBuilderService, $q, ixUtilsService, $location, $compile, $log, $window, $rootScope, authService, $filter, $ngConfirm) {
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	var usuario = authService.authentication.userName;

	if (angular.isUndefined($scope.data.fullItemsList))
		$scope.data.fullItemsList = {};

	$scope.data.firstLoad = true;

	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
		if ($scope.extranetUser.proveedor != null) {
			$scope.ixEditar = undefined;
			$scope.status.editing = false;
		}
		//if ($scope.pantallaBasePorProducto())
		//	$scope.status.onCloseGoTo = "ListadosFT/Listado_ProductosFt";
		//else
			//$scope.status.onCloseGoTo = "ListadosFT/Listado_Ft";
		$scope.status.onCloseGoTo = $scope.status.atributos.pantalla ;
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	$scope.scrollBarConfig = {
		//		callbacks: {
		//			onTotalScrollBack:function(){
		//				$log.log("Scroll arriba del todo, cargar previa.");
		//				$scope.selectPreviousPage();
		//			},
		//			onTotalScroll:function(){
		//				$log.log("Scrolled abajo del todo, carga siguiente.");
		//				$scope.selectNextPage();
		//			}
		//		}
	};

	$scope.duplicarFt = function (n) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/duplicarFT_popup.html";
		var optionsPopup = { controller: "DuplicarFtPopupController" };
		var paramsPopup = { ft_origen: $scope.data.id_ficha_tecnica, ft_tipo: $scope.data.datos.ft_cabecera.ft_version, niveles: n };
		ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
	};

	$scope.versionarFt = function () {
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/VersionarFT?ft_origen=" + $scope.data.id_ficha_tecnica).then(function (response) {
			ixStatusService.setResponse(response);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	};

	$scope.imprimirFt = function (tipo_doc, reducida) {
		var config = { responseType: 'arraybuffer' };
		$http.get(cfg.baseURL + "impresos/impresoFT/?idft=" + $scope.data.id_ficha_tecnica + "&docformat=" + tipo_doc + "&reducido=" + reducida, config).then(function (response) {

			var file = new Blob([response.data], { type: 'application/zip' });

			var filename = "ImpresosFichaTecnica_" + $scope.data.id_ficha_tecnica.replace("/", "-") + ".zip";
			if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.imprimirFtRevision = function () {
		var config = { responseType: 'arraybuffer' };
		$http.get(cfg.baseURL + "impresos/ImpresoRevisionFT/?idft=" + $scope.data.id_ficha_tecnica, config).then(function (response) {

			var file = new Blob([response.data], { type: 'application/pdf' });

			var filename = "ImpresoRevision_" + $scope.data.id_ficha_tecnica.replace("/", "-") + ".pdf";
			if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.isFirst = function () {
		return ($scope.getCurrentPage() < 1);
	};

	$scope.isLast = function () {
		return ($scope.getCurrentPage() == angular.element("div.listEditResult").length - 1);
	};

	//¿Qué indices debo de poner para comentarios y log? (YVES - 2/12/2019)
	$scope.getCurrentPage = function () {
		var idx = -1;
		if ($scope.data.pantalla == "cabecera")
			idx = 0;
		else if ($scope.data.pantalla == "ficheros")
			idx = 1;
		else if ($scope.data.pantalla == "proveedor")
			idx = 2;
		else {
			var element = angular.element("div.listEditResult.bg-info");
			if (angular.isDefined(element[0]))
				idx = Array.from(angular.element("div.listEditResult")).indexOf(element[0]);
		}
		return idx;
	};

	$scope.selectPreviousPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx - 1].click();
		}, 1);
	};

	$scope.selectNextPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx + 1].click();
		}, 1);
	};

	$scope.$parent.$parent.$parent.changeWhileEditing = true;

	if (angular.isDefined($routeParams.id_fichas_tecnicas)) {
		$scope.data.id_fichas_tecnicas = $routeParams.id_fichas_tecnicas;
		$scope.data.id_ficha_tecnica = $scope.data.id_fichas_tecnicas[0];
	}
	else
		$scope.data.id_ficha_tecnica = $routeParams.id_ficha_tecnica;

	if ($routeParams.idioma) {
		$scope.data.idioma = $routeParams.idioma;
		$scope.data.modoTraduccion = true;
	}

	convertDateStringsToDates($scope.miFt);

	$scope.data.activeTabFicheros = 0;
	$scope.data.activeTabComentarios = 0;

	$scope.data.ixReadOnly = true;
	$scope.gridManualLoad = true;

	var timer;
	var lastBusqueda = "";

	$scope.TARJETA_CREMA = 'rgb(248, 203, 173)';
	$scope.TARJETA_VERDE = 'rgb(255, 255, 255)'; // 'rgb(169, 209, 142)';
	$scope.TARJETA_VERDE_OSCURO = 'rgb(4, 180, 49)';
	$scope.TARJETA_AZUL = 'rgb(180, 199, 231)';

	$scope.data.pk = "id";
	$scope.data.tituloCabecera = "ficha";

	$scope.$parent.$parent.$parent.ixCancelEdit = function () {
		//FUNCION CUSTOM
		delete ixStatusService.current.response; //?
		//Volver a poner datos cabecera como estaban
		$scope.data.datos.ft_cabecera = angular.copy($scope.data.ft_cabecera_original);
		//TODO: volver a poner grids tal y como estaban
		$scope.data.gridProductosFT.ixCancelEdit(true);
		if (angular.isDefined($scope.data.gridComentariosFt)){
			$scope.data.gridComentariosFt.ixCancelEdit();
			$scope.data.gridComentariosFt.ixLoadInitialData();
		}
		if (angular.isDefined($scope.data.gridComentariosInternosFt)){
			$scope.data.gridComentariosInternosFt.ixCancelEdit();
			$scope.data.gridComentariosInternosFt.ixLoadInitialData();
		}

		ixStatusService.setEditing(false);
	};

	$scope.ixGuardar = function () {
		$log.log("guardar datos");
		var param = {};
		param.jpdFichaTecnica = ixGetPatchOperations($scope.data.ft_cabecera_original, $scope.data.datos.ft_cabecera);
		param.traducir_completa = null;
		if ($scope.data.gridProductosFT) param.ubpProductos = $scope.data.gridProductosFT.ixGetBulkParam();
		//param.ubpFicherosFichaTecnica = $scope.data.gridFicherosFT.ixGetBulkParam();
		param.ubpComentariosFichaTecnica = {
			ToDelete: [],
			ToInsert: [],
			ToUpdate: []
		};
		if ($scope.data.gridComentariosFt){
			var bulkComentarios = $scope.data.gridComentariosFt.ixGetBulkParam();
	
			param.ubpComentariosFichaTecnica.ToDelete = param.ubpComentariosFichaTecnica.ToDelete.concat(bulkComentarios.ToDelete || []);
			param.ubpComentariosFichaTecnica.ToInsert = param.ubpComentariosFichaTecnica.ToInsert.concat(bulkComentarios.ToInsert || []);
			param.ubpComentariosFichaTecnica.ToUpdate = param.ubpComentariosFichaTecnica.ToUpdate.concat(bulkComentarios.ToUpdate || []);
		}
		if ($scope.data.gridComentariosInternosFt){
			var bulkComentariosInternos = $scope.data.gridComentariosInternosFt.ixGetBulkParam();
	
			param.ubpComentariosFichaTecnica.ToDelete = param.ubpComentariosFichaTecnica.ToDelete.concat(bulkComentariosInternos.ToDelete || []);
			param.ubpComentariosFichaTecnica.ToInsert = param.ubpComentariosFichaTecnica.ToInsert.concat(bulkComentariosInternos.ToInsert || []);
			param.ubpComentariosFichaTecnica.ToUpdate = param.ubpComentariosFichaTecnica.ToUpdate.concat(bulkComentariosInternos.ToUpdate || []);
		}

		var path = cfg.baseURL + "extranet_fichas_tecnicas/PutFichaTecnica?id_ficha=" + $scope.data.id_ficha_tecnica;

		if ($scope.data.modoTraduccion) {
			// path = cfg.baseURL + "extranet_fichas_tecnicas_idioma/" + $scope.data.id_ficha_tecnica + "/" + $scope.data.idioma;
			path = cfg.baseURL + "extranet_fichas_tecnicas_idioma/PutFichaTecnicaIdioma?id=" + $scope.data.id_ficha_tecnica + "&idioma=" + $scope.data.idioma;
			if ($scope.data.estado_traduccion_original != $scope.data.datos.estado_traduccion)
				param.jpdFichaTecnica.push({
					value: $scope.data.datos.estado_traduccion,
					path: "/estado",
					op: "replace"
				});
			param = param.jpdFichaTecnica;
		}
		else {
			//Si ha cambiado la opción de traducir completa, paso la información
			param.traducir_completa = $scope.data.datos.traducir_completa;
		}

		$http.put(path, param).then(function (r) {
			ixStatusService.setResponse(r);
			//Si he modificado el estado de bloqueo para la tarjeta proveedores debo actualizar el bloqueo general
			$scope.verificarBloqueoTodaFt();
			
			if ($scope.data.modoTraduccion) {
				$scope.data.estado_traduccion_original = r.data.obj.Record.estado;
			}
			else {
				$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
				$scope.data.datos.ft_cabecera = r.data.obj.Record;
				$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);
			}
			$scope.data.gridProductosFT.clearGridAfterSave();
			$scope.data.gridProductosFT.ixLoadInitialData();
			ixStatusService.setEditing(false);
			if ($scope.data.forzarCargaGridFicherosProveedor) {
				if ($scope.data.gridFicherosProveedor) $scope.data.gridFicherosProveedor.ixLoadInitialData();
				//YVES, queda por terminar la recarga, comenta la linea que sobreescribe el ixLoadInitialData de gridPlantasFabricante y haz que se llame la función que has preparado.
				if ($scope.data.gridPlantasFabricante) $scope.data.gridPlantasFabricante.ixLoadInitialData();
			}
			if ($scope.data.gridComentariosFt){
				$scope.data.gridComentariosFt.clearGridAfterSave();
				$scope.data.gridComentariosFt.ixLoadInitialData();
			}
			if ($scope.data.gridComentariosInternosFt && $scope.tienePerfilAdmin()){
				$scope.data.gridComentariosInternosFt.clearGridAfterSave();
				$scope.data.gridComentariosInternosFt.ixLoadInitialData();
			}
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.getFocusedRow = function () {
		var ingredienteFocus = "";
		if ($scope.data.gridJerarquico.gridApi) {
			var focusedCell = $scope.data.gridJerarquico.gridApi.cellNav.getFocusedCell();
			if (focusedCell) {
				var row = focusedCell.row;
				ingredienteFocus = row.entity.ingredientes;
			}
		}
		return ingredienteFocus;
	};

	$scope.addRow = function (grid) {
		grid.ixAddRow();
	};

	$scope.addRowComentarioFt = function (grid,es_Interno) {
		var nuevo = {};
		nuevo.idficha = $scope.data.datos.ft_cabecera.id;
		nuevo.usu = 0;
		nuevo.es_Interno = es_Interno;
		grid.ixAddRow(nuevo);
	}


	$scope.addRowFromList = function (grid) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/add_elementos_saludables_popup.html";
		var optionsPopup = { controller: "AddElementosSaludablesPopupController" };
		var params = { listelements: $scope.listaElementosSaludables };
		ixUtilsService.openModalV2(template, optionsPopup, "small", params).then(function (response) {
			angular.forEach(response.rows, function (row) {
				var existeElemento = grid.data.find(function (e) { return e.propiedad_saludable == row.label; });

				if (angular.isUndefined(existeElemento))
					grid.ixAddRow({ propiedad_saludable: row.label });
			});
		});
	};

	$scope.openPopupFicheros = function (grid, tipo) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html";
		var optionsPopup = { controller: "UploadFilePopupController" };
		var paramsPopup = { tipo: tipo, id_ft: $scope.data.id_ficha_tecnica };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
		popup.then(function (data) {
			if (tipo != "ficheros_ft") {
				grid.ixAddRow(data.obj.Record);
			}
			else {
				//recargar grid ficheros

				$http.post(cfg.baseURL + "fichas_tecnicas_ficheros/SearchByIdFt?id_ft=" + $scope.data.id_ficha_tecnica).then(function (response) {
					$scope.data.datos.ft_ficheros_fichas_tecnicas = response.data;
					$scope.data.fullItemsList[$scope.data.id_ficha_tecnica].ft_ficheros_fichas_tecnicas = $scope.data.datos.ft_ficheros_fichas_tecnicas;
					grid.ixLoadInitialData();
				},
					function (error) {
						$log.log("ERROR Popup Ficheros: ", error);
					});
			}
		});
	};

	$scope.$parent.$parent.$parent.tienePerfilAdmin = authService.tienePerfilAdmin;

	$scope.bloquearTodasPreguntasFt = function (bulkUpdateTotal, bloquear) {
		if (angular.isUndefined(bulkUpdateTotal)) {
			bulkUpdateTotal = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
		}

		angular.forEach($scope.data.list, function (item) {
			var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
			if (!itemsToSkip.includes(item.icono)) {
				var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
				$scope.bloquearRecursivamente(undefined, item, bloquear);
				bulkUpdateTotal.ToUpdate = bulkUpdateTotal.ToUpdate.concat(bulkUpdate.ToUpdate);
			}
		});

		return bulkUpdateTotal;
	};

	$scope.verificarBloqueoTarjetasPadre = function (item) {
		if (item.nivel2) {
			var tarjetaPadre = $scope.data.list.find(function (n) { return n.nivel1 == item.nivel1 && !n.nivel2; });
			var setBloqueo = 1;
			angular.forEach(tarjetaPadre.subniveles, function (t) {
				if (t.bloqueado == 0) setBloqueo = 0;
			});
			tarjetaPadre.bloqueado = setBloqueo;
		}
	};


	$scope.verificarBloqueoTodaFt = function () {
		var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
		var tarjetaHome = $scope.data.list.find(function (n) { return n.icono == "home"; });
		var setBloqueo = 1;
		angular.forEach($scope.data.list, function (item) {
			if (!itemsToSkip.includes(item.icono)) {
				if (item.bloqueado == 0) setBloqueo = 0;
			}
		});

		tarjetaHome.bloqueado = setBloqueo && $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor;
		tarjetaHome.bloqueado = setBloqueo && $scope.data.datos.ft_cabecera.bloqueo_datos_ficheros;
	};

	$scope.$parent.$parent.$parent.bloquearPreguntas = function (ev, item, bloquear) {
		ev.stopPropagation();
		if (item.icono == 'home') {
			//Bloqueo total de la ficha técnica
			$log.log("Bloquear todas las preguntas FT");
			item.bloqueado = bloquear;
			//BLOQUEAR/DESBLOQUEAR Tarjeta Proveedores
			//TODO
			if (bloquear){
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 1;
			}
			else{
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 0;
			}
				

			var tarjetaProveedores = $scope.data.list.find(function (n) { return n.icono == "industry"; });
			tarjetaProveedores.bloqueado = bloquear;
			var tarjetaFicheros = $scope.data.list.find(function (n) { return n.icono == "paperclip"; });
			tarjetaFicheros.bloqueado = bloquear;
			$scope.ixGuardar();

			//BLOQUEO/DESBLOQUEO Preguntas
			var bulkUpdateTotal = $scope.bloquearTodasPreguntasFt(bulkUpdateTotal, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdateTotal).then(function (response) {
				ixStatusService.setResponse(response);
			}, function (err) {
				ixStatusService.setResponse(err);
				item.bloqueado = !bloquear;
				$scope.bloquearTodasPreguntasFt(bulkUpdateTotal, !bloquear);
			});
		}
		else if (item.icono == 'paperclip') {
			$log.log("Bloquear datos ficheros (TODO)");
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 0;
			item.bloqueado = bloquear;
			$scope.ixGuardar();
		}
		else if (item.icono == 'industry') {
			$log.log("Bloquear datos plantas-fabricantes (TODO)");
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;
			item.bloqueado = bloquear;
			$scope.ixGuardar();
		}
		else { //Tarjetas preguntas
			var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
			$scope.bloquearRecursivamente(undefined, item, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdate).then(function (response) {
				ixStatusService.setResponse(response);
				$scope.verificarBloqueoTarjetasPadre(item);
				$scope.verificarBloqueoTodaFt();
			}, function (err) {
				ixStatusService.setResponse(err);
				$scope.bloquearRecursivamente(bulkUpdate, item, !bloquear);
				$scope.bloquearRecursivamente(undefined, $scope.getObjSeleccionado(item), !bloquear);
			});
		}
	};

	$scope.getObjSeleccionado = function (item) {
		var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

		if (angular.isDefined(ficha_tecnica)) {
			var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1 });
			if (item.nivel2)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
			if (item.nivel3)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

			item = obj_seleccionado;
		}

		return item;
	};


	$scope.bloquearRecursivamente = function (bulkUpdate, item, bloquear) {
		//bloqueamos tarjeta.
		item.bloqueado = bloquear;
		if (angular.isUndefined(bulkUpdate)) {
			bulkUpdate = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			}
		}
		angular.forEach(item.subniveles, function (subnivel) {
			$scope.bloquearRecursivamente(bulkUpdate, subnivel, bloquear);
		});
		angular.forEach(item.preguntas, function (pregunta) {
			angular.forEach(pregunta.respuestas, function (respuesta) {
				//bloquemos todas las preguntas de la tarjeta.
				respuesta.bloqueado = bloquear;
				bulkUpdate.ToUpdate.push({
					PK: { id: respuesta.id },
					PocoToUpdate: [
						{
							value: item.bloqueado,
							path: "/bloqueado",
							op: "replace"
						},
						{
							value: true,
							path: "/disable_before_after",
							op: "replace"
						}
					]
				});
			});
		});
		return bulkUpdate;
	};
	$scope.$on('NUEVO_FICHERO', function (event, data) {
		//TODO: Cargar todos los nuevos ficheros (en caso de asociación con más productos)
		if (angular.isDefined($scope.data.gridFicherosFT))
			$scope.data.gridFicherosFT.ixAddRow(data);
		else
			$scope.data.datos.ft_ficheros_fichas_tecnicas.push(data);
	});

	$scope.refreshCurrentCardContent = function () {
		var aux = angular.copy($scope.data.currentPreguntasTab);
		$scope.data.currentPreguntasTab = "";
		$timeout(function () {
			$scope.data.currentPreguntasTab = aux;
		}, 0);
	};

	//Solo se utiliza en el modo traduccion
	$scope.soloPreguntasPdt = function () {
		$scope.data.solo_preguntas_pdt = true;
		$scope.refreshCurrentCardContent();
		getListElements("PENDIENTES");
	};

	//Solo se utiliza en el modo traduccion pero se podría usar en ambos modos.
	$scope.soloCardsPdt = function () {
		$scope.data.solo_preguntas_pdt = false;
		$scope.refreshCurrentCardContent();
		getListElements("PENDIENTES");
	};

	$scope.verTodasCards = function () {
		$scope.data.solo_preguntas_pdt = false;
		$scope.refreshCurrentCardContent();
		getListElements();
	};

	$scope.$on('RECALCULAR_CUMPLIMENTACION', function (event, data) {
		//identificar tarjeta con los niveles e ir decrementando.
		var incrementar = null;
		if (data.newValue && !data.oldValue) {
			//incrementar uno
			incrementar = true;
			$scope.data.list[0].titulo4_valor = 1;
		} else if (!data.newValue && data.oldValue) {
			//decrementar uno.
			incrementar = false;
			$scope.data.list[0].titulo4_valor = 0;
		}

		if (incrementar != null) {
			var currentPreguntaParts = $scope.data.currentPreguntasTab.split("-");

			var tarjetaNivel1 = undefined;
			var tarjetaNivel2 = undefined;
			var tarjetaNivel3 = undefined;

			tarjetaNivel1 = $scope.data.list.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
			if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
				tarjetaNivel2 = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
				if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
					tarjetaNivel3 = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
			}

			if (angular.isDefined(tarjetaNivel1)) {
				if (incrementar)
					tarjetaNivel1.titulo4_valor++;
				else
					tarjetaNivel1.titulo4_valor--;
			}
			if (angular.isDefined(tarjetaNivel2)) {
				if (incrementar)
					tarjetaNivel2.titulo4_valor++;
				else
					tarjetaNivel2.titulo4_valor--;
			}
			if (angular.isDefined(tarjetaNivel3)) {
				if (incrementar)
					tarjetaNivel3.titulo4_valor++;
				else
					tarjetaNivel3.titulo4_valor--;
			}

			$scope.calcularPorcentajeCumplimentacion();
			/*if (data.pregunta.obligatoria) {
				if (incrementar)
					$scope.data.datos.count_preguntas_obligatorias++
				else
					$scope.data.datos.count_preguntas_obligatorias--;
				$scope.calcularPorcentajeCumplimentacionObligatoria();
			}*/
		}
	});

	$scope.$on('RECALCULAR_CUMPLIMENTACION_GRID', function (event, data) {
		var currentPreguntaParts = $scope.data.currentPreguntasTab.split("-");

		var tarjetaNivel1 = undefined;
		var tarjetaNivel2 = undefined;
		var tarjetaNivel3 = undefined;

		tarjetaNivel1 = $scope.data.list.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
		if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
			tarjetaNivel2 = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
			if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
				tarjetaNivel3 = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
		}

		if (data.tipo_modificacion == "Add" || data.tipo_modificacion == "Delete") {
			var incrementar = false;
			if (data.tipo_modificacion == "Add") incrementar = true;

			if (angular.isDefined(tarjetaNivel1)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel1.titulo4_valor++;
					tarjetaNivel1.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel1.titulo4_valor > 0) tarjetaNivel1.titulo4_valor--;
					tarjetaNivel1.titulo4_valor2--;
				}
			}
			if (angular.isDefined(tarjetaNivel2)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel2.titulo4_valor++;
					tarjetaNivel2.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel2.titulo4_valor > 0) tarjetaNivel2.titulo4_valor--;
					tarjetaNivel2.titulo4_valor2--;
				}
			}
			if (angular.isDefined(tarjetaNivel3)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel3.titulo4_valor++;
					tarjetaNivel3.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel3.titulo4_valor > 0) tarjetaNivel3.titulo4_valor--;
					tarjetaNivel3.titulo4_valor2--;
				}
			}

			$scope.calcularPorcentajeCumplimentacion();
		} else {
			var incrementarTodo = true;

			var tarjetaNivel1Full = undefined;
			var tarjetaNivel2Full = undefined;
			var tarjetaNivel3Full = undefined;

			tarjetaNivel1Full = $scope.data.fullList.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
			if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
				tarjetaNivel2Full = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
				if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
					tarjetaNivel3Full = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
			}
			var pregunta = {};

			if (angular.isDefined(tarjetaNivel3Full)) {
				for (var tn3 = 0; tn3 < tarjetaNivel3Full.preguntas.length; tn3++) {
					pregunta = tarjetaNivel3Full.preguntas[tn3].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}
			else if (angular.isDefined(tarjetaNivel2Full)) {
				for (var tn2 = 0; tn2 < tarjetaNivel2Full.preguntas.length; tn2++) {
					pregunta = tarjetaNivel2Full.preguntas[tn2].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}
			else if (angular.isDefined(tarjetaNivel1Full)) {
				for (var tn1 = 0; tn1 < tarjetaNivel1Full.preguntas.length; tn1++) {
					pregunta = tarjetaNivel1Full.preguntas[tn1].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}

			if (incrementarTodo) {
				if (angular.isDefined(tarjetaNivel1)) {
					tarjetaNivel1.titulo4_valor++;
				}
				if (angular.isDefined(tarjetaNivel2)) {
					tarjetaNivel2.titulo4_valor++;
				}
				if (angular.isDefined(tarjetaNivel3)) {
					tarjetaNivel3.titulo4_valor++;
				}
			}

			$scope.calcularPorcentajeCumplimentacion();
		}
	});

	$scope.calcularPorcentajeCumplimentacion = function () {
		var cumplimentadas = 0;
		var cumplimentadasObligatorias = 0;
		var totalPreguntas = 0;
		var totalPreguntasObligatorias = 0;

		var tarjetasPreguntas = $scope.data.fullList.filter(function (e) { return e.nivel1 != null; });
		for (var i = 0; i < tarjetasPreguntas.length; i++) {
			var tarjeta = tarjetasPreguntas[i];
			for (var j = 0; j < tarjeta.subniveles.length; j++) {
				var subniveles = tarjeta.subniveles[j];
				if (subniveles.preguntas == null) {
					for (var k = 0; k < subniveles.subniveles.length; k++) {
						var subsubnivel = subniveles.subniveles[k];
						for (var y = 0; y < subsubnivel.preguntas.length; y++) {
							var preguntasub = subsubnivel.preguntas[y];
							for (var x = 0; x < preguntasub.respuestas.length; x++) {
								var respuestasub = preguntasub.respuestas[x];
								totalPreguntas++;
								if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) cumplimentadas++;
								if (preguntasub.pregunta.obligatoria == 1) {
									if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) {
										cumplimentadasObligatorias++;
									}
									totalPreguntasObligatorias++;
								}
							}
						}
					}
				}
				else {
					for (var z = 0; z < subniveles.preguntas.length; z++) {
						var pregunta = subniveles.preguntas[z];
						for (var r = 0; r < pregunta.respuestas.length; r++) {
							var respuesta = pregunta.respuestas[r];
							totalPreguntas++;
							if ($scope.IsCompleted(pregunta.pregunta, respuesta)) cumplimentadas++;
							if (pregunta.pregunta.obligatoria == 1) {
								if ($scope.IsCompleted(pregunta.pregunta, respuesta)) {
									cumplimentadasObligatorias++;
								}
								totalPreguntasObligatorias++;
							}
						}
					}
				}
			}
		}
		$scope.data.list[0].titulo4_valor = $filter("number")(((cumplimentadas / totalPreguntas) * 100), 0);
		$scope.data.list[0].titulo5_valor = $filter("number")(((cumplimentadasObligatorias / totalPreguntasObligatorias) * 100), 0);
	};

	/*$scope.calcularPorcentajeCumplimentacionObligatoria = function () {
		$scope.data.list[0].titulo5_valor = $filter("number")((($scope.data.datos.count_preguntas_obligatorias / $scope.data.datos.total_preguntas_obligatorias) * 100), 0);
	};*/

	$scope.IsCompleted = function (ftp, eftd) {
		var answer_complete = true;
		if (ftp.id_pregunta == 1160 || ftp.id_pregunta == 1168 || ftp.id_pregunta == 1173 || ftp.id_pregunta == 1178) {
			answer_complete = answer_complete && (eftd.valor == null || eftd.valor == '');

			if (ftp.validar_sub_pregunta1 == 1) answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');
			if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
			if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');

			if (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '') {
				if (eftd.sub_respuesta3 === "No") {
					if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
					if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
					if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
					if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
					if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
					if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
					if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
					if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
					if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
					if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
					if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');
				}
			}
			else {
				answer_complete = false;
			}

			return answer_complete;
		}

		answer_complete = answer_complete && (eftd.valor != null && eftd.valor != '');

		if (ftp.validar_sub_pregunta1 == 1
			&& !(ftp.id_pregunta == 777 && (eftd.orden_bucle.Value == 5 || eftd.orden_bucle.Value == 6 || eftd.orden_bucle.Value == 9 || eftd.orden_bucle.Value == 10 || eftd.orden_bucle.Value == 11)))
			answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');

		if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
		if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');
		if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
		if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
		if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
		if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
		if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
		if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
		if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
		if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
		if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
		if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
		if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');

		return answer_complete;

	}

	$scope.addRowFocus = function (grid, subcategoria) {
		if ((!subcategoria) || (subcategoria && !$scope.condicionSubcategoria($scope.data.gridJerarquico))) {
			var focusedCell = grid.gridApi.cellNav.getFocusedCell();
			var newRow = {};
			if (focusedCell && subcategoria) {
				var row = focusedCell.row;
				if (grid.data.indexOf(row.entity) != -1) {
					newRow.$$treeLevel = row.entity.$$treeLevel;
				}

				if (subcategoria) {
					newRow.$$treeLevel++;
					newRow.manuallyAdded = true;
				}

			} else {
				newRow.$$treeLevel = 0;
			}
			grid.ixAddRow(newRow);
			if ((focusedCell) && subcategoria) {
				if (row.treeNode.state == "collapsed") {
					$scope.expandGroup(row);
				}
				$scope.moveNewRowIntoGroup(grid, row);
			}
		}
	};

	$scope.expandGroup = function (row) {
		row.treeNode.state = "expanded";
	}

	$scope.deleteSelectedRows = function (grid, guardarCambios) {
		grid.ixDeleteSelectedRows();
		if (guardarCambios) {
			grid.ixGuardar();
		}
	};

	$scope.condicionSubcategoria = function (grid) {
		var disabled = false;
		if (grid.gridApi) {
			var focusedCell = grid.gridApi.cellNav.getFocusedCell();
			if (!focusedCell)
				disabled = true;
			else if (focusedCell.row.entity.$$treeLevel == 2)
				disabled = true;
		}
		return disabled;
	};

	$scope.deleteSelectedRowsJerarquico = function (grid) {
		$scope.selectChildrenRows();
		grid.ixDeleteSelectedRows();
	};

	$scope.moveNewRowIntoGroup = function (grid, row) {
		var newRow = grid.data[grid.data.length - 1];
		var from = grid.data.indexOf(row.entity);
		var to = from;
		while ((grid.data[to + 1]) && grid.data[to + 1].$$treeLevel > row.entity.$$treeLevel) {
			to++;
		}
		grid.data.splice(grid.data.length - 1, 1);
		grid.data.splice((to + 1), 0, newRow);
	};

	//sobreescrita la función
	$scope.$parent.$parent.$parent.cargarGrid = function () {
		var meta = [
			{ Name: 'categoria', Type: "string" },
			{ Name: 'subcategoria', Type: "string" },
			{ Name: 'nc', Type: "numeric", ColumnDescription: "% No conformidad" },
			{ Name: 'alarma', Type: "numeric", ColumnDescription: "Alarma", Control: "CheckBox" }

		];
		$scope.data.grid = gridService.createGrid($scope, "Mant_GestionFichasTecnicaGrid", { minWidth: 75, minRowsToShow: 5, enableCellEdit: false, enableFiltering: true, loadItemWhenSelect: true, metadata: meta });
		$scope.data.grid.columnDefs = [];
		$scope.data.grid.ixGetColsFromAPI();
		$scope.data.grid.data = getListElements();
	};

	$scope.marcarRecargaFicherosProveedor = function () {
		$scope.data.forzarCargaGridFicherosProveedor = true;
	};

	$scope.changeTabFicheros = function (idxTab) {
		$scope.data.activeTabFicheros = idxTab;
		switch (idxTab) {
			case 0:
				$scope.data.gridFicherosTab = 0;
				ixUtilsService.showGrid($scope.data.gridFicherosFT);
				break;
			case 1:
				//TODO: Redraw pivot:
				$scope.data.gridFicherosTab = 1;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					ixUtilsService.showGrid($scope.data.gridFicherosProveedor);
				else
					buildGridFicherosProveedor();
				if ($scope.data.forzarCargaGridFicherosProveedor) {
					$scope.data.forzarCargaGridFicherosProveedor = false;
					$scope.data.gridFicherosProveedor.ixLoadInitialData();
				}
				break;
			default:
				break;
		}
	};

	$scope.changeTabComentarios = function (idxTab) {
		$scope.data.activeTabComentarios = idxTab;
		switch (idxTab) {
			case 0:
				if (angular.isDefined($scope.data.gridComentariosFt)) {
					ixUtilsService.showGrid($scope.data.gridComentariosFt);
				} else {
					buildGridComentariosFt();
				}
				break;
			case 1:
				if (angular.isDefined($scope.data.gridComentariosInternosFt))
					ixUtilsService.showGrid($scope.data.gridComentariosInternosFt);
				else
					buildGridComentariosInternosFt();
				break;
			default:
				break;
		}
	};

	//Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)
	var buscarEnSubniveles = function (el, modo) {
		var match = false;
		var resultado = [];
		if (el.subniveles) {
			/* PRUEBA YVES PARA BUSCAR EN TARJETAS SUBNIVELES */
			resultado = el.subniveles.filter(function (e) {
				//				return ((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo3) && e.titulo3.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.subniveles) && buscarEnSubniveles(e).length > 0);
				return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);

			});
			/* FIN PRUEBA YVES PARA BUSCAR EN TARJETAS SUBNIVELES */
		}
		el.subniveles = resultado;
		return el.subniveles;
	};
	//FIN Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)

	$scope.cambiarFicha = function (ficha_tecnica, activeTab) {
		var firstLoad = false;
		if (angular.isUndefined($scope.data.fullItemsList[ficha_tecnica]))
			firstLoad = true;

		$scope.data.activeTabFichaTecnica = activeTab;

		$scope.data.id_ficha_tecnica = ficha_tecnica;

		if (angular.isDefined($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]))
			$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;
		else
			$scope.data.fullList = [];

		getListElements();
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx].click();
			if (!firstLoad)
				$scope.refreshCurrentCardContent();
		}, 1);
	}

	$scope.setDatosCabecera = function (data) {
		$scope.data.datos = {
			id: data.ft_cabecera.id,
			count_preguntas_obligatorias: data.count_preguntas_obligatorias,
			total_preguntas_obligatorias: data.total_preguntas_obligatorias,
			ft_cabecera: data.ft_cabecera,
			ft_ficheros_fichas_tecnicas: data.ft_ficheros_fichas_tecnicas,
			ft_ficheros_proveedores: data.ft_ficheros_proveedores,
			ft_productos: data.ft_productos,
			plantas_asociadas: data.plantas_asociadas,
			comentarios: data.comentarios,
			estado_traduccion: data.estado_traduccion,
			traducir_completa: data.traducir_completa
		};
	};

	//Sobreescrita la función ya que no vamos a acceder API para cargar los datos.
	var getListElements = function (modo) {
		if (angular.isUndefined($scope.data.fullList))
			$scope.data.fullList = [];
		var list = [];
		if ($scope.data.fullList.length == 0) {
			var path = cfg.baseURL + "ft_data?id_ft=" + $scope.data.id_ficha_tecnica;
			if ($scope.data.idioma)
				path += "&idioma_traduccion=" + $scope.data.idioma;

			$http.get(path).then(function (response) {
				$scope.data.fullItemsList[$scope.data.id_ficha_tecnica] = response.data;
				$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;

				$scope.excluirTarjetasRestringidas();

				list = angular.copy($scope.data.fullList);
				$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);

				$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);
				$scope.data.ft_productos_original = angular.copy($scope.data.datos.ft_productos);
				if ($scope.data.modoTraduccion) {
					$scope.data.estado_traduccion_original = $scope.data.datos.estado_traduccion;
				}
				else {
					$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
				}
				$scope.data.datos.comentariosInternos = angular.copy(response.data.comentariosInternos);

				if ($scope.data.busqueda || angular.isDefined(modo)) {
					list = list.filter(function (e) {
						//						return (
						//						((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.subniveles) && buscarEnSubniveles(e).length > 0)
						//						);
						return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
					});
				}
				$scope.data.list = list;
				$scope.data.loaded = true;
				if ($scope.data.firstLoad) {
					$scope.selectNextPage();
					$scope.data.firstLoad = false;
				}

			});
		} else {
			$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);
			list = angular.copy($scope.data.fullList);
			if ($scope.data.busqueda || angular.isDefined(modo))
				list = list.filter(function (e) {
					//						return (
					//						((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.subniveles) && buscarEnSubniveles(e).length > 0)
					//					);
					return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
				});
			$scope.data.list = list;
		}
	};

	$scope.filterAlgorithmSelector = function (e, modo) {
		var busqueda = $scope.data.busqueda || "";
		if (modo == "PENDIENTES") {
			return (
				(ixUtilsService.comparar(e.titulo1, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2_valor, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo3, busqueda) != -1)) &&
				(parseInt(e.titulo4_valor) < parseInt(e.titulo4_valor2));
		}
		else {
			return (
				(ixUtilsService.comparar(e.titulo1, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2_valor, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo3, busqueda) != -1)
				//((e.subniveles) && buscarEnSubniveles(e).length > 0)
			);
		}
	};

	$scope.listaElementosSaludables = [
		{ id: 1, label: "Light Azúcar", selected: 0 },
		{ id: 2, label: "Light Grasa", selected: 0 },
		{ id: 3, label: "Sin azúcaras añadidos. Contiene azúcaras naturalmente presentes", selected: 0 },
		{ id: 4, label: "Sin lactosa", selected: 0 }
	];

	$scope.$parent.$parent.$parent.actualizarListado = function (forzarActualizacion) {
		if (angular.isUndefined($scope.data.list) || forzarActualizacion) {
			$scope.data.list = [];
			$scope.data.loaded = false;
		}
		if (timer) { $timeout.cancel(timer); }
		timer = $timeout(function () {
			getListElements();
			/*
			$scope.data.list = getListElements();
			if($scope.data.busqueda)
				$scope.data.list = $scope.data.list.filter(function(e){ return (
					e.nivel1nombre.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1 ||
					e.nivel2nombre.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1);
																															});
			$scope.data.loaded = true;
			*/
		}, 350);
		lastBusqueda = $scope.data.busqueda;
	};

	$scope.tieneCabeceraNoVisible = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.tieneFicherosNoVisible = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.compruebaRestricciones = function (perfilesRestringidos) {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});
		return perfilRestringido;
	}

	$scope.guardarConfigGridsActivos = function () {
		var num_card_activa = ixStatusService.current.data.currentPreguntasTab;
		if (num_card_activa) {
			var ajuste_tarjetas = 0; //Sirve para ajustar indice de tarjetas visibles y evitar errores para perfiles que no visualizan algunas tarjetas
			if ($scope.tieneCabeceraNoVisible()) ajuste_tarjetas++;
			if ($scope.tieneFicherosNoVisible()) ajuste_tarjetas++;
			var partes_card_activa = num_card_activa.split('-');
			var card_activa = undefined;

			if (partes_card_activa[0] != "null") {
				card_activa = ixStatusService.current.data.list[parseInt(partes_card_activa[0]) + 1 - ajuste_tarjetas];
				if (partes_card_activa[1] != "null") {
					card_activa = card_activa.subniveles[parseInt(partes_card_activa[1]) - 1];
					if (partes_card_activa[2] != "null") {
						card_activa = card_activa.subniveles[parseInt(partes_card_activa[2]) - 1];
					}
				}
			}

			if (angular.isDefined(card_activa)) {
				var preguntas_grid = card_activa.preguntas.filter(function (e) { return e.pregunta.bucle; });
				angular.forEach(preguntas_grid, function (pregunta_grid) {
					if (angular.isDefined(ixStatusService.current.data.grids)) {
						angular.forEach(Object.keys(ixStatusService.current.data.grids), function (key, idx) {
							if (key.lastIndexOf("grid" + pregunta_grid.pregunta.id_pregunta) != -1) {
								ixStatusService.current.data.grids[key].ixSaveConfig();
							}
						});
					}
				});
			}
		}
	};


	$scope.$parent.$parent.$parent.selectItem = function (item, evt) {

		if (!ixStatusService.current.editing && !ixStatusService.current.filtered || $scope.changeWhileEditing) {
			$log.log("selectItem");
			$log.log(item);
			if (!item.subniveles) {
				$log.log("no tiene detalles, cargamos pantalla");
				$scope.guardarConfigGridsActivos();
				var currentCard = item.icono;
				// var idxCard = $scope.data.list.indexOf(item);
				if (currentCard == "home") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					if (!$scope.tienePerfilAdmin())
						ixStatusService.setEditing(false);
					//Cabecera.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "cabecera";
					buildGridProductos();
				} else if (currentCard == "paperclip") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Ficheros.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "ficheros";
					buildGridFicherosFT();
				} else if (currentCard == "industry") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Datos proveedor.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "proveedor";
					buildGridListaPlantasFabricante();
				} else if (currentCard == "comments") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					//Comentarios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "comentarios";
					buildGridComentariosFt();
				} else if (currentCard == "database") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Log de cambios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "log";
					buildGridCambioDatosFt();
				} else {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					ixStatusService.setEditing(true);
					//Cargar dinámicamente:
					$scope.data.pantalla = "preguntas";


					$scope.data.currentPreguntasTab = item.nivel1 + "-" + item.nivel2 + "-" + item.nivel3;

					var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

					if (angular.isDefined(ficha_tecnica)) {
						var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1; });
						if (item.nivel2)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
						if (item.nivel3)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

						$scope.data.selectedItem = obj_seleccionado;
					} else {
						$scope.data.selectedItem = item;
					}
					// $log.log("Element: " + "#preguntas" + $scope.data.currentPreguntasTab);
					// $log.log(angular.element('#preguntas' + $scope.data.currentPreguntasTab));
					// $log.log("Length element: " + angular.element('#preguntas' + $scope.data.currentPreguntasTab).length);
					if (angular.element('#preguntas' + $scope.data.currentPreguntasTab).length == 0) {
						$timeout(function () {
							$log.log("Append ft_preguntas...");
							$log.log(angular.element("form"));
							//$log.log($scope.data.selectedItem.preguntas);
							if ($scope.data.modoTraduccion) {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas preguntas='data.selectedItem.preguntas' data='data' modo-traduccion='true' solo-preguntas-pdt-traduccion='data.solo_preguntas_pdt'></ft-preguntas></div></div>")($scope));
							} else {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas preguntas='data.selectedItem.preguntas' data='data'></ft-preguntas></div></div>")($scope));
							}
						}, 200);
					}
				}
			} else {
				$log.log("que se vean/oculten todas las cards que tiene por debajo.");
				$scope.data.pantalla = "";
				angular.forEach(item.subniveles, function (detalle) {
					if ($scope.fromBtn) {
						detalle.visible = true;
					} else {
						detalle.visible = !detalle.visible;
					}

				});
				$scope.fromBtn = false;
			}

			$scope.$parent.$parent.$parent.current = item;

			//$scope.current = angular.merge($scope.current, item);
		}
	};

	if ($scope.data.pantalla == "preguntas") {
		$scope.selectItem($scope.data.selectedItem);
	}

	$scope.isShowing = function (id) {
		return ("preguntas" + $scope.data.currentPreguntasTab) == id;
	};

	var buildGridProductos = function () {

		var metadata = [
			{
				Name: "id_producto",
				Pk: true
			},
			{
				Name: "ean",
				NoEditable: function (cell) { return cell.row.entity["ean"] && !cell.row.entity["ean"].includes("PTE"); }
			},
			{
				Name: "marca",
				copySelectedValues: ["propietario"]
			}
		];

		if (!$scope.data.gridProductosFT) {
			$scope.data.gridProductosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridProductosFT", { disableFiltering: true, enableFiltering: false, enableSorting: false, minRowsToShow: 5, metadata: metadata }, "ft_productosVM");
			//$scope.data.gridProductosFT.data = angular.copy($scope.data.datos.ft_productos);
			$scope.data.gridProductosFT.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridProductosFT.gridApi) {
					var doit = true;
					if ($scope.data.gridProductosFT.deletedRows.length + $scope.data.gridProductosFT.insertedRows.length + $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridProductosFT.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridProductosFT.deletedRows = [];
						$scope.data.gridProductosFT.insertedRows = [];
						$scope.data.gridProductosFT.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridProductosFT.gridApi.rowEdit.setRowsClean(dataRows);

						$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);

						if (!$scope.data.gridProductosFT.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridProductosFT.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridProductosFT.originalGridOrder)) {
							$scope.data.gridProductosFT.applyOriginallySortedColumns();
						}
						$scope.data.gridProductosFT.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
		} else {
			$scope.data.gridProductosFT = gridService.createGridFunctions($scope, $scope.data.gridProductosFT);
			$scope.data.gridProductosFT.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridProductosFT.gridApi) {
					var doit = true;
					if ($scope.data.gridProductosFT.deletedRows.length + $scope.data.gridProductosFT.insertedRows.length + $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridProductosFT.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridProductosFT.deletedRows = [];
						$scope.data.gridProductosFT.insertedRows = [];
						$scope.data.gridProductosFT.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridProductosFT.gridApi.rowEdit.setRowsClean(dataRows);

						$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);

						if (!$scope.data.gridProductosFT.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridProductosFT.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridProductosFT.originalGridOrder)) {
							$scope.data.gridProductosFT.applyOriginallySortedColumns();
						}
						$scope.data.gridProductosFT.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

					}
				}
			}
			$scope.data.gridProductosFT.ixRestoreConfig();
		}
		$scope.data.gridProductosFT.ixLoadInitialData = function () { return true; };
	};

	$scope.accionesGridFicheros = [
		{
			title: "Previsualizar PDF",
			icon: "fa-file-pdf-o",
			visible: function (entity) {
				return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http({
					method: 'post',
					url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
					headers: {},
					responseType: 'arraybuffer'
				}).then(function (r) {
					$scope.selectedPDF = new Uint8Array(r.data);
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: "Previsualizar Imagen",
			icon: "fa-file-image-o",
			visible: function (entity) {
				return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
					//$scope.selectedImage = new Uint8Array(r.data);
					$scope.selectedImage = r.data;
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: "Descargar fichero",
			icon: "fa-download",
			visible: function (entity) {
				return entity.archivo;
			},
			accion: function (entity) {
				$scope.downloadFile(entity);
			}
		}
	];

	var buildGridFicherosFT = function () {

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosFT) {
			var metadata = [
				{ Name: 'id', NoVisible: true },
				{ Name: 'id_ficha_tecnica', NoVisible: true },
				{ Name: 'ruta_raiz', NoVisible: true },
				{ Name: 'ruta_relativa', NoVisible: true },
				{ Name: 'version', NoVisible: true },
				{ Name: 'en_impreso', NoVisible: true }
			];
			$scope.data.gridFicherosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosFT", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata }, "fichas_tecnicas_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosFT.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
			$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
		} else {
			$scope.data.gridFicherosFT = gridService.createGridFunctions($scope, $scope.data.gridFicherosFT);
			$scope.data.gridFicherosFT.ixRestoreConfig();
		}
	};

	$scope.getEntity = function () {
		return ($scope.data.gridFicherosTab) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
	};

	$scope.downloadFile = function (entity) {
		var id = entity.id;
		var tabla = $scope.getEntity();
		$http({
			method: 'post',
			url: cfg.baseURL + tabla + '/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
	};

	var buildGridFicherosProveedor = function () {

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosProveedor) {
			var metadata = [
				{ Name: 'tipo', NoVisible: true },
				//{ Name: 'grupo', NoVisible: true},
				{ Name: 'fabricante', NoVisible: true },
				{ Name: 'planta', NoVisible: true },
				{ Name: 'ruta_relativa', NoVisible: true }
			];
			$scope.data.gridFicherosProveedor = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosProveedor", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata, ixLoadInitialDataAction: "SearchCustom" }, "proveedores_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosProveedor.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
		} else {
			$scope.data.gridFicherosProveedor = gridService.createGridFunctions($scope, $scope.data.gridFicherosProveedor);
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		}
		//$scope.data.gridFicherosProveedor.ixLoadInitialData = function(){ return true; };
	};

	var buildGridListaPlantasFabricante = function () {

		var acciones = [
			{
				title: 'Datos de fabricante',
				icon: "fa-industry",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_fabricante_popup.html";
					var optionsPopup = { controller: "DatosFabricantePopupController" };
					var paramsPopup = { fabricante: entity.fabricante };
					ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
				}
			},
			{
				title: 'Datos de planta',
				icon: "fa-building",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_planta_popup.html";
					var optionsPopup = {
						controller: ['$scope', '$http', 'cfg', '$uibModalInstance', 'ixStatusService', function ($scope, $http, cfg, $uibModalInstance, ixStatusService) {
							$scope.status = { editing: false };
							$scope.data = {};
							$http.get(cfg.baseURL + "plantas/" + $scope.$resolve.planta).then(function (response) {
								$scope.datos_planta = response.data;
							}, function (err) {
								ixStatusService.setResponse(err);
							});
						}]
					};
					var params = { planta: entity.planta };
					// $scope.planta_nombre = entity.planta_nombre;
					ixUtilsService.openModalV2(template, optionsPopup, "medium", params);
				}
			}
		];

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', width: 100, acciones: acciones }];

		if (!$scope.data.gridPlantasFabricante) {
			var metadata = [
				{ Name: 'asociado', Type: "Int32", Control: "CheckBox",NoEditable: function () { return $scope.tieneCabeceraRestringida() || $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor; } },
				{ Name: 'razon_social', ColumnDescription: 'Fabricante', Type: "string", NoEditable: true },
				{ Name: 'cif', ColumnDescription: 'CIF Fabricante', Type: "string", NoEditable: true },
				{ Name: 'nombre_planta', ColumnDescription: 'Planta', Type: "string", NoEditable: true },
				{ Name: 'fabricante', Pk: true, NoVisible: true },
				{ Name: 'planta', Pk: true, NoVisible: true }
			];

			$scope.data.gridPlantasFabricante = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridPlantasFabricante", { minRowsToShow: 10, enableCellEdit: true, onCellEdit: asociarPlantaFt, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata });
			$scope.data.gridPlantasFabricante.columnDefs = [];
			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				return !cell.col.colDef.noeditable();
			};

			//$scope.data.gridPlantasFabricante = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridPlantasFabricante",  { minRowsToShow: 10, disableFiltering: true, enableFiltering: false, enableSorting: false }, "ft_plantas_asociadasVM");
			// $timeout(function(){
			// 		$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
			// },1);
			$scope.data.gridPlantasFabricante.drawExtraColumns($scope.extraColumnsGrid);
			$scope.data.gridPlantasFabricante.ixGetColsFromAPI();


			//$scope.data.gridPlantasFabricante.data = angular.copy($scope.list_plantas_fabricante);
			//me queda la info de las plantas.

		} else {
			$scope.data.gridPlantasFabricante = gridService.createGridFunctions($scope, $scope.data.gridPlantasFabricante);
			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				return !cell.col.colDef.noeditable();
			};
			$scope.data.gridPlantasFabricante.ixRestoreConfig();
		}
		$scope.data.gridPlantasFabricante.ixLoadInitialData = function () {
			$http.get(cfg.baseURL + "ft_data/GetPlantasAsociadas?id_ft=" + $scope.data.id_ficha_tecnica).then(function (response) {
				$scope.data.datos.plantas_asociadas = response.data;
				$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;

				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};

		$scope.data.gridPlantasFabricante.ixLoadInitialData();
	};

	var asociarPlantaFt = function (rowEntity, colDef, newValue, oldValue) {
		$log.log("Llamada función asociarPlantaFt");
		$log.log(rowEntity);
		$log.log(colDef);
		$log.log(newValue);
		$log.log(oldValue);

		$scope.data.forzarCargaGridFicherosProveedor = true;

		var param = {
			id_ficha_tecnica: $scope.data.id_ficha_tecnica,
			fabricante: rowEntity.fabricante,
			planta: rowEntity.planta,
			asociado: newValue
		};
		$http.put(cfg.baseURL + "fichas_tecnicas_plantas_asociadas/PutAsociaPlantasFt", param).then(function (r) {
			ixStatusService.setResponse(r);
		}, function (error) {
			rowEntity.asociado = rowEntity.asociado == 0 ? 1 : 0;
			ixStatusService.setResponse(error);
		});
	};

	var buildGridComentariosFt = function () {
		if (!$scope.data.gridComentariosFt) {
			var metadata = [
				{ Name: 'idcomentario', NoVisible: true },
				{ Name: 'idficha', NoVisible: true },
				{ Name: 'fecha', NoEditable: false },
				{ Name: 'usu', NoVisible: true },
				{ Name: 'comentario', NoEditable: false },
				{ Name: 'ruta_archivo', NoVisible: true },
				{ Name: 'es_Interno', NoVisible: true },
				{ Name: 'usuario', NoVisible: true },
				{ Name: 'ubicacion', NoVisible: true }
			];
			$scope.data.gridComentariosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridComentariosFt", { minRowsToShow: 10, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: true, metadata: metadata }, "ft_comentarios");
			$scope.data.gridComentariosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosFt.deletedRows.length + $scope.data.gridComentariosFt.insertedRows.length + $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosFt.deletedRows = [];
						$scope.data.gridComentariosFt.insertedRows = [];
						$scope.data.gridComentariosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosFt.originalGridOrder)) {
							$scope.data.gridComentariosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
		} else {
			$scope.data.gridComentariosFt = gridService.createGridFunctions($scope, $scope.data.gridComentariosFt);
			$scope.data.gridComentariosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosFt.deletedRows.length + $scope.data.gridComentariosFt.insertedRows.length + $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosFt.deletedRows = [];
						$scope.data.gridComentariosFt.insertedRows = [];
						$scope.data.gridComentariosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosFt.originalGridOrder)) {
							$scope.data.gridComentariosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
			$scope.data.gridComentariosFt.ixRestoreConfig();
			if($scope.data.datos.comentarios.length > 0){
				$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
			}
			else{
				$scope.data.gridComentariosFt.data = [];
			}
		}
		$scope.data.gridComentariosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			param.Filters.push({ Field: "es_Interno", Operator: CMP_EQ, Value: 0 });
			param.Filters.push({ Field: "idficha", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			$http.post(cfg.baseURL + "ft_comentarios/Search", param).then(function (response) {
				$scope.data.datos.comentarios = response.data.Items;
				$scope.data.gridComentariosFt.data = response.data.Items;
				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};
	};

	var buildGridComentariosInternosFt = function () {
		if (!$scope.data.gridComentariosInternosFt) {
			var metadata = [
				{ Name: 'idcomentario', NoVisible: true },
				{ Name: 'idficha', NoVisible: true },
				{ Name: 'fecha', NoEditable: false },
				{ Name: 'usu', NoVisible: true },
				{ Name: 'comentario', NoEditable: false },
				{ Name: 'ruta_archivo', NoVisible: true },
				{ Name: 'es_Interno', NoVisible: true },
				{ Name: 'usuario', NoVisible: true },
				{ Name: 'ubicacion', NoVisible: true }
			];
			$scope.data.gridComentariosInternosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridComentariosInternosFt", { minRowsToShow: 10, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: true, metadata: metadata }, "ft_comentarios");
			if($scope.data.datos.comentariosInternos.length > 0){
				$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
			}
			else{
				$scope.data.gridComentariosInternosFt.data = [];
			}
			$scope.data.gridComentariosInternosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosInternosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosInternosFt.deletedRows.length + $scope.data.gridComentariosInternosFt.insertedRows.length + $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosInternosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosInternosFt.deletedRows = [];
						$scope.data.gridComentariosInternosFt.insertedRows = [];
						$scope.data.gridComentariosInternosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosInternosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosInternosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosInternosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosInternosFt.originalGridOrder)) {
							$scope.data.gridComentariosInternosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosInternosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}

				}
			}
		} else {
			$scope.data.gridComentariosInternosFt = gridService.createGridFunctions($scope, $scope.data.gridComentariosInternosFt);
			$scope.data.gridComentariosInternosFt.ixRestoreConfig();
			$scope.data.gridComentariosInternosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosInternosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosInternosFt.deletedRows.length + $scope.data.gridComentariosInternosFt.insertedRows.length + $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosInternosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosInternosFt.deletedRows = [];
						$scope.data.gridComentariosInternosFt.insertedRows = [];
						$scope.data.gridComentariosInternosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosInternosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosInternosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosInternosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosInternosFt.originalGridOrder)) {
							$scope.data.gridComentariosInternosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosInternosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}

				}
			}
			if($scope.data.datos.comentariosInternos.length > 0){
				$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
			}
			else{
				$scope.data.gridComentariosInternosFt.data = [];
			}
		}

		$scope.data.gridComentariosInternosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			param.Filters.push({ Field: "es_Interno", Operator: CMP_EQ, Value: 1 });
			param.Filters.push({ Field: "idficha", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			$http.post(cfg.baseURL + "ft_comentarios/Search", param).then(function (response) {
				$scope.data.datos.comentariosInternos = response.data.Items;
				$scope.data.gridComentariosInternosFt.data = response.data.Items;
				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};
	};

	var buildGridCambioDatosFt = function () {
		if (!$scope.data.gridCambioDatosFt) {
			var metadata = [
				{
					Name: "fecha",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 0
					}
				},
				{
					Name: "hora",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 1
					}
				},
				{
					Name: "id",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 2
					}
				}
			];
			$scope.data.gridCambioDatosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridLogAuditoriasFt", { minRowsToShow: 20, enableCellEdit: false, enableSorting: true, metadata: metadata }, "listado_log_auditoriasFtVM");
			$scope.data.gridCambioDatosFt.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }]
		}

		$scope.data.gridCambioDatosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			//param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			param.Filters = $scope.data.gridCambioDatosFt.filtroExterno;
			$http.post(cfg.baseURL + "listado_log_auditoriasFtVM/Search", param).then(function (response) {
				$scope.data.gridCambioDatosFt.data = response.data.Items;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

			return true;
		};

		$scope.data.gridCambioDatosFt.ixLoadInitialData();

	};

	$scope.descargarExcelLog = function () {
		$scope.data.gridCambioDatosFt.ixDownloadExcel();
	};

	/*
	var buildGridLista = function () {
		if (!$scope.data.gridLista) {
			var metadata = [
				{ Name: 'propiedad_saludable', Type: "string" }
			];
			$scope.data.gridLista = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridNormal", { minRowsToShow: 8, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata });
			$scope.data.gridLista.columnDefs = [];
			//$scope.data.gridLista.drawExtraColumns($scope.extraColumnsGrid);
			$scope.data.gridLista.ixGetColsFromAPI();
			$scope.data.gridLista.data = $scope.data.datos.detalle.elementos_saludables;

			$scope.refreshDemoGridDropdowns($scope.data.gridLista);
		} else {
			$scope.data.gridLista = gridService.createGridFunctions($scope, $scope.data.gridLista);
			$scope.data.gridLista.ixRestoreConfig();
		}
	};
*/
	$scope.openProveedor = function () {
		var app = {};
		app.icon = "people";
		app.display = "Proveedores";
		app.href = "Mantenimientos/proveedores/" + $scope.data.datos.ft_cabecera.proveedor;
		$timeout(function () {
			ixStatusService.openApp(app).bind(ixStatusService);
		}, 1);
	}

	$scope.refreshDemoGridDropdowns = function (grid) {
		angular.forEach(grid.data, function (row) {
			var columnFKDescs = grid.columnDefs.filter(function (e) { return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
			angular.forEach(columnFKDescs, function (columnFKDesc) {
				columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
			});
		});
	};

	/* ***** FUNCIONES CONSTRUCCION GRID ***** */

	if (!$scope.data.list) {
		$scope.$parent.$parent.$parent.actualizarListado();
	}

	$scope.restoreConfigCreatedGrids = function () {
		if ($scope.data.gridProductosFT)
			$scope.data.gridProductosFT.ixRestoreConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixRestoreConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixRestoreConfig();
	};

	$scope.restoreConfigCreatedGrids();

	$scope.saveConfigCreatedGrids = function () {
		if ($scope.data.gridProductosFT)
			$scope.data.gridProductosFT.ixSaveConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixSaveConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixSaveConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixSaveConfig();
	};

	$scope.$on('metadataLoaded', function () {
		$timeout(function () {
			if ($scope.data.pantalla == "cabecera") {
				$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);
				$scope.data.gridProductosFT.ixRefreshGridDropDowns();
			} else if ($scope.data.pantalla == "ficheros") {
				$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					$scope.data.gridFicherosProveedor.data = $scope.data.datos.ft_ficheros_proveedores;
			} else if ($scope.data.pantalla == "proveedor") {
				$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
			} else if ($scope.data.pantalla == "comentarios") {
				if($scope.data.datos.comentarios.length > 0){
					$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
				}else{
					$scope.data.gridComentariosFt.data = [];
				}
				if($scope.data.datos.comentariosInternos.length > 0){
					$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
				}else{
					$scope.data.gridComentariosInternosFt.data = [];
				}
			}
		}, 300);
	});

	$scope.limpiarPreguntasErroneas = function () {
		angular.forEach($scope.data.list, function (tarjeta) {
			if (tarjeta.error)
				tarjeta.error = false;
			if (tarjeta.subniveles) {
				angular.forEach(tarjeta.subniveles, function (subnivel1) {
					if (subnivel1.error)
						subnivel1.error = false;
					if (subnivel1.subniveles) {
						angular.forEach(subnivel1.subniveles, function (subnivel2) {
							if (subnivel2.error)
								subnivel2.error = false;
						});
					}
				});
			}
		});
	};

	$scope.marcarPreguntasErroneas = function (error) {
		var erroresTarjetas = error.obj.Errors;
		angular.forEach(erroresTarjetas, function (errorTarjetaCab) {
			var errorTarjetaDet = errorTarjetaCab.Values;
			if (errorTarjetaDet) {
				var tarjeta = $scope.data.list.find(function (e) { return e.nivel1 == errorTarjetaDet[0].nivel1; });
				tarjeta.visible = true;
				if (errorTarjetaDet[0].nivel2) {
					if (tarjeta.subniveles)
						tarjeta.subniveles.forEach(function (x) { x.visible = true; });
					tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel2 == errorTarjetaDet[0].nivel2; });
					if (errorTarjetaDet[0].nivel3) {
						if (tarjeta.subniveles)
							tarjeta.subniveles.forEach(function (x) { x.visible = true; });
						tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel3 == errorTarjetaDet[0].nivel3; });
					}
				}
			}

			if (angular.isDefined(tarjeta))
				tarjeta.error = true;
		});
	};

	$scope.pantallaBasePorProducto = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	}
		;
	$scope.tieneCabeceraRestringida = function () {
		//var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_proveedor", "usr_visitante", "usr_export"];
		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.tienePerfilRestringido = function () {
		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	// $scope.tieneAccionesRestringidas = function () {
	// 	var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
	// 	return $scope.compruebaRestricciones(perfilesRestringidos);
	// };

	$scope.tieneTarjetasRestringidas = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_proveedor", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};


	$scope.excluirTarjetasRestringidas = function () {
		//ATENCION: Para "localizar" las tarjetas usamos el atributo icono para evitar depender de la traducción
		//Escondo las tarjetas comentarios y log cambios si estoy en modalidad traducción o si el usuario tieneTarjetasRestringidas
		if ($scope.tieneTarjetasRestringidas() || $scope.data.modoTraduccion) {
			//var tarjetaComentarios = $scope.data.fullList.find(function(e){ return e.titulo1 == "COMENTARIOS"; });
			var tarjetaComentarios = $scope.data.fullList.find(function (e) { return e.icono == "comments"; });
			if (angular.isDefined(tarjetaComentarios)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaComentarios), 1);
			}

			//var tarjetaLogCambios = $scope.data.fullList.find(function(e){ return e.titulo1 == "LOG CAMBIOS"; });
			var tarjetaLogCambios = $scope.data.fullList.find(function (e) { return e.icono == "database"; });
			if (angular.isDefined(tarjetaLogCambios)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaLogCambios), 1);
			}
		}

		if ($scope.tieneCabeceraNoVisible()) {
			var tarjetaCabecera = $scope.data.fullList.find(function (e) { return e.icono == "home"; });
			if (angular.isDefined(tarjetaCabecera)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaCabecera), 1);
			}
		}

		if ($scope.tieneFicherosNoVisible()) {
			//var tarjetaFicheros = $scope.data.fullList.find(function(e){ return e.titulo1 == "FICHEROS"; });
			var tarjetaFicheros = $scope.data.fullList.find(function (e) { return e.icono == "paperclip"; });
			if (angular.isDefined(tarjetaFicheros)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaFicheros), 1);
			}
		}
	};

	$scope.permiteControlTransformacion = function () {
		if ($scope.data.datos.ft_cabecera) {
			if ($scope.data.datos.ft_cabecera.estado == 'T' && (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor && !$scope.extranetUser.cliente))
				return true;
			else
				return false;
		}
		else {
			return false;
		}
	};

	$scope.permiteImprimirFtRevision = function () {
		if ($scope.data.datos.ft_cabecera) {
			if ($scope.data.datos.ft_cabecera.ft_version == 5 && (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor && !$scope.extranetUser.cliente))
				return true;
			else
				return false;
		}
		else
			return false;
	};

	if ($scope.tienePerfilRestringido()) {
		$scope.ixEditar = undefined;
		$scope.ixGuardar = undefined;
	}


	//Sobreescribo la función ixCloseApp para poder realizar el cálculo de los porcentajes de cumplimentación
	//La llamada se ejecuta al hacer click en el botón CERRAR de la app
	$scope.ixCloseApp = function () {
		$scope.isDestroyedFT = true;
		$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
			ixStatusService.closeApp(ixStatusService.current);
		},
			function (error) {
				$log.log("Error al registrar Porcentajes cumplimentación");
				$log.log(error);
				ixStatusService.closeApp(ixStatusService.current);
			});
	};

	//Se ejecuta al cerrar la App desde el botón CERRAR o al pasar a otras App
	$scope.$on("$destroy", function () {
		if (!$scope.isDestroyedFT) {
			$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
				$scope.saveConfigCreatedGrids();
			},
				function (error) {
					$log.log("Error al registrar Porcentajes cumplimentación");
					$log.log(error);
					$scope.saveConfigCreatedGrids();
				});
		}
		else {
			$scope.saveConfigCreatedGrids();
		}

	});

	$scope.control_errores_transformacion = function () {
		var param = { Selection: { Filters: [], OrderBy: [] }, Fields: [] };
		//Agregar columnas
		param.Fields.push({ Field: 'id_ficha_tecnica' });
		param.Fields.push({ Field: 'nivel1' });
		param.Fields.push({ Field: 'nivel2' });
		param.Fields.push({ Field: 'nivel3' });
		param.Fields.push({ Field: 'id_pregunta' });
		param.Fields.push({ Field: 'pregunta' });
		param.Fields.push({ Field: 'componente' });
		param.Fields.push({ Field: 'orden_bucle' });
		param.Fields.push({ Field: 'orden_tab' });
		param.Fields.push({ Field: 'orden_tab2' });
		param.Fields.push({ Field: 'posicion' });
		param.Fields.push({ Field: 'valor' });
		param.Fields.push({ Field: 'error_desc' });
		//Agregar filtros
		param.Selection.Filters.push({ Field: 'version', Value: $scope.data.datos.ft_cabecera.ft_version, Operator: CMP_EQ, Skip: 1 });
		param.Selection.Filters.push({ Field: 'id_ft', Value: $scope.data.id_ficha_tecnica, Operator: CMP_EQ, Skip: 1 });

		var config = { responseType: "arraybuffer" };
		$http.post(cfg.baseURL + 'control_errores_transformacion/Excel', param, config).then(function (r) {
			var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			var filename = 'ControlErrorestransformacion_' + $scope.data.id_ficha_tecnica.replace("/", "-") + ".xlsx";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		});
	};

	$scope.confirmarCumplimentacion = function () {
		$scope.limpiarPreguntasErroneas();
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/ConfirmarCumplimentacion?id_ficha_tecnica=" + $scope.data.id_ficha_tecnica).then(function (r) {
			ixStatusService.setResponse(r);
			$scope.data.datos.ft_cabecera = r.data.obj.Record;
		}, function (error) {
			var errors = error.data.obj.Errors;
			var contentMsg = errors.map(function (e) { return e.Msg; }).join('<br/>')
			error.data.obj.Errors = error.data.obj.Errors.map(function (e) { return angular.extend({}, e, { Msg: e.Msg.replace(/<[^>]*>/g, '') }); });
			$ngConfirm({
				title: "<span style=\"color:red;\">Errores al finalizar FT, por favor contactad con Biotecnal al Tel: 93.721.12.55 </span>",
				content: contentMsg
			});
			ixStatusService.setResponse(error);
			$scope.marcarPreguntasErroneas(error.data);
		});
	}

	$scope.cambioEstadoTraduccion = function (nuevoEstado) {
		var changes = ixGetPatchOperations({ estado: '' }, { estado: nuevoEstado });
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_idioma/" + $scope.data.id_ficha_tecnica + "/" + $scope.data.idioma, changes).then(function (r) {
			ixStatusService.setResponse(r);
			$scope.data.datos.estado_traduccion = nuevoEstado;
		}, function (error) {
			ixStatusService.setResponse(error);
			$scope.marcarPreguntasErroneas(error.data);
		});
	}

	$scope.loadEstadosTraduccion = function (params) {
		if ($scope.data.datos.traducir_completa == 1) {
			params.Filters.push({ field: 'codigo', value: 'V', op: '0', not: true });
		}
		else {
			params.Filters.push({ field: 'codigo', value: 'W', op: '0', not: true });
		}
		return $http.post(cfg.baseURL + "ft_estados_traduccion/Search", params);
	}

	$scope.loadRevisionEtiquetado = function (params) {
		var deferred = $q.defer();
		$timeout(function () {
			var list = [];
			list.push({ descripcion: "OK" });
			list.push({ descripcion: "PENDIENTE" });
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;
	}
	// $scope.guardarProveedores = function(){
	// 	$log.log("Guardando proveedores");
	// 	console.log($scope.data.gridPlantasFabricante.ixGetBulkParam());
	// }

}]);

angular.module('FTBase')
.controller('DashboardFTController', [ '$scope', '$controller', function($scope, $controller){
  $scope.modulo = "fichas_tecnicas";
  $controller('DashboardController', { $scope: $scope});
}]);

/*global saveAs*/

angular.module('FTBase').controller('ListaContratosFtController',['$scope', '$controller', 'ixUtilsService', '$http', 'cfg', 'ixStatusService', function($scope, $controller,  ixUtilsService, $http, cfg, ixStatusService){
    $scope.entity = "extranet_fichas_tecnicas_contratos";
    //, 'ixUtilsService', '$http', 'cfg', 'ixStatusService'
    //,  ixUtilsService, $http, cfg, ixStatusService
    $scope.acciones = [
      {
        title: 'Ver contrato',
        icon: 'fa-search',
        accion: function(entity){
          var templateURL = "app/FTBase/Contratos/detalles_contrato_ft.html";
          var optionsPopup = { controller: "DetallesContratoFtController" };
          var paramsPopup = { contrato: entity, is_new: false };
          ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function(response){
            if (response){
              $scope.data.grid.ixLoadInitialData();
            }
          });
        }
      },
      {
        title: 'Imprimir',
        icon: 'fa-print',
        accion: function(entity){
          var config = {responseType: 'arraybuffer'};
          $http.get(cfg.baseURL + "impresos/ImpresoContrato/?idcontrato=" + entity.idcontrato + "&docformat=PDF",config).then(function(response){
            var filename = "Contrato_" + entity.idcontrato + ".pdf";
            var file = new Blob([response.data], { type: 'application/pdf' });

            if (response.headers('Content-Disposition')) {
              filename = response.headers('Content-Disposition').split("=")[1];
            }

            saveAs(file, filename);
          }, function(error){
            ixStatusService.setResponse(error);
          });
        }
      }
    ];

    $scope.ixAddRow = function(){
      var templateURL = "app/FTBase/Contratos/detalles_contrato_ft.html";
      var optionsPopup = { controller: "DetallesContratoFtController" };
      var paramsPopup = { contrato: {}, is_new: true };
      ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function(response){
        if (response){
          $scope.data.grid.ixLoadInitialData();
        }
      });
    };

    $controller('GridEditorController', { $scope: $scope });
}]);

/*global CMP_EQ*/
/*global CMP_ISNULL:true*/
/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller('DetallesContratoFtController', ['$scope', 'cfg', 'ixStatusService', 'gridService', '$http', '$timeout','$log','$uibModalInstance', function($scope, cfg, ixStatusService, gridService, $http, $timeout, $log, $uibModalInstance){
  $scope.status = { editing: true };
	$scope.data = ixStatusService.current.data;
  // ixStatusService.setEditing(true);

  $scope.contrato  = angular.copy($scope.$resolve.contrato);
  $scope.contrato_original = angular.copy($scope.contrato);
  $scope.is_new = $scope.$resolve.is_new;
  $scope.data_updated = false;

  // $scope.$on('metadataLoaded', function(){
  //   $timeout(function(){
  //     $scope.data.gridFt.ixRefreshGridDropDowns();
  //   }, 300);
  // });

  $scope.loadFt = function (param){
  //   // debugger;
  //   param = buildIxSearch();
    param.Filters.push({ Field: "proveedor", Value: $scope.contrato.proveedor, Operator: CMP_EQ });
    param.Filters.push({ Field: "idcontrato", Value:"", Operator: CMP_ISNULL });

    return $http.post(cfg.baseURL + "extranet_fichas_tecnicas/Search", param);
  };

  $scope.loadDetFt = function(entity){
    if (angular.isDefined(entity))
      $scope.titulo_ft = entity.titulo;
  };

  if(!$scope.data.gridFt){
    $scope.data.gridFt = gridService.createGrid($scope, "Mant_gridFtContratosDet",  { enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, minRowsToShow: 5, showOnlyDescribedCols: [ "id", "titulo" ] }, "extranet_fichas_tecnicas");
  }
  else {
    $scope.data.gridFt = gridService.createGridFunctions($scope, $scope.data.gridFt);
    $scope.data.gridFt.ixRestoreConfig();
  }

  $scope.data.gridFt.filtroExterno = [{ Field:"idcontrato", Operator: CMP_EQ, Value: $scope.contrato.idcontrato }]
  $scope.data.gridFt.ixLoadInitialData();

  $scope.save = function(){
    $log.log("Saving...");
    var param = {};
    if ($scope.is_new){
      $log.log("... new");
      param.nuevo_contrato = $scope.contrato;
      $log.log($scope.data.gridFt.data);
      param.fichas_tecnicas = $scope.data.gridFt.data;
      $http.post(cfg.baseURL + "extranet_fichas_tecnicas_contratos/PostContrato", param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.gridFt.ixLoadInitialData();
        $scope.data_updated = true;
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }else {
      $log.log("... update");
  		param.jpdContrato = ixGetPatchOperations($scope.contrato_original, $scope.contrato);
      param.ubpFichas = $scope.data.gridFt.ixGetBulkParam();
      $http.put(cfg.baseURL + "extranet_fichas_tecnicas_contratos/PutContrato/" + $scope.contrato.idcontrato, param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.gridFt.ixLoadInitialData();
        $scope.data_updated = true;
      },function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.addRow = function(grid){
    // grid.ixAddRow();
    $log.log("addRow");
    if ($scope.ft_add){
      var nr = { id: $scope.ft_add, titulo: $scope.titulo_ft };
      grid.ixAddRow(nr);
      $timeout(function(){
        grid.gridApi.rowEdit.setRowsDirty([nr]);
      },1);
    }
  };

  $scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

  $scope.$dismiss = function(){
    $uibModalInstance.close($scope.data_updated);
  };

	$scope.$on("$destroy", function() {
		$scope.data.gridFt.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*global angular*/

angular.module('FTBase').controller('Alarma_Verificacion_IngredientesController', ['$scope', '$controller', '$http', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', 'ixWarningsService', '$log', '$translate', function ($scope, $controller, $http, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, ixWarningsService, $log, $translate) {
    $scope.entity = "alarma_verificacion_nuevo_ingredienteVM";
    $scope.ocultaEditar = true;

    var perfilesUsuario = authService.perfilesUsuario();
    $scope.allow2delete = false;
    angular.forEach(perfilesUsuario, function(perfil){
        if (perfil == "ixnet" || perfil == "usr_bio_userkey")
        $scope.allow2delete = true;
    });

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            },
            visible: function(){
                return cfg.appCliente == "EUROMADI";
            }
        },
        {
            title: 'Formulario Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'FormularioFtBP/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            },
            visible: function(){
                return cfg.appCliente == "BONPREU";
            }
        },
        {
            title: 'Eliminar',
            icon: 'fa-trash',
            accion: function(entity){
                ixWarningsService.warningConfirmacion($scope, "¡Atención!  Se eliminará la alarma seleccionada ¿Deseas confirmar?", $scope.eliminarAlarmaIngrediente, undefined, entity);
            },
            visible: function(){
                return $scope.allow2delete;
            }
        }
    ];

    $scope.eliminarAlarmaIngrediente = function(entity){
        $http.delete(cfg.baseURL + "diccionario_valores_por_validar/" + entity.id).then(function(response){
            ixStatusService.setResponse(response);
            $scope.data.grid.ixLoadInitialData();
        },
        function(error){
            ixStatusService.setResponse(error);
        });
    };

    $controller('GridEditorController', { $scope: $scope });

}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Ingredientes_MonitorizarController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_ingredientes_monitorizarVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/
/*global CMP_EQ*/

angular.module('FTBase').controller('AlarmaFtRevisionaPropietarioController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', 'ixUtilsService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, $log, $translate, ixCestaVehiculosService, ixUtilsService) {
  $scope.entity = "listado_ftVM";
  $scope.ocultaEditar = true;
  

  // $scope.metadata = [
  //   { Name: 'revision_inicial',  NoVisible: true},
  //   { Name: 'revision_final', NoVisible: true},
  //   { Name: 'notificacion_proveedor', NoVisible: true}
  // ];
  $scope.gridOptions = { showOnlyDescribedCols: [ "id_ficha_tecnica", "tipo_ft", "titulo", "nombre_proveedor", "eans", "cod_internos", "marcas", "familia", "desc_estado", "fecha", "fecha_aprobada", "fecha_revision", "fecha_baja", "num_ficheros", "ultimo_comentario", "analisis_anyo_vigente", "analisis_anyo_proximo", "traducible", "estado_traduccion", "idioma" ] };
  $scope.filtroExterno =  [{ Field: "estado", Operator: CMP_EQ, Value: "S" }];

  $scope.acciones = [
      {
          title: 'Datos Ficha Técnica',
          icon: 'fa-list',
          redirect: {
              template: 'GestionFichasTecnicas/list',
              atributos: ['id_ficha_tecnica'],
              atributosTitle: [],
              iconBox: 'perm_device_information',
              multiple: true
          }
      },
      {
        title: 'Descargar Ficha Técnica',
        icon: 'fa-download',
        accion: function(entity){
          var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
          var options = { controller: "ImprimirFTPopupController" };
          var params = { tipo: "FT", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica };

          ixUtilsService.openModalV2(template, options, "small", params);
        }     
      }
  ];
  $controller('GridEditorController', { $scope: $scope });

}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Expiracion_CertificadosController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_expiracion_certificadosVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    //$scope.acciones = [];
    $scope.acciones = [
        {
            title: 'Detalles proveedor',
            icon: 'fa-vcard',
            redirect: {
                template: 'Mantenimientos/proveedores',
                atributos: ['proveedor'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });

}]);

/*global angular*/

angular.module('FTBase').controller('Alarma_Estado_Fuera_PlazoController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_estado_fuera_plazoVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Certificados_FicherosController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_certificado_ficherosVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Actualizacion_FTController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, $log, $translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_actualizacion_ftVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });

}]);
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('FTBase').directive('ftPreguntas', ['$http', '$compile', '$log', function ($http, $compile, $log) {
	return {
		restrict: 'E',
		scope: {
			preguntas: '=',
			data: '=?',
			preview: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos padre son: {{ data | json }}</div>",
		link: function (scope, elem, attrs) {
			scope.getContainerElement = function () {
				return elem;
			};
			//iteramos el array de preguntas para crear el formulario.
			scope.preguntas.forEach(function (pregunta, idx) {
				scope.pregunta = pregunta;
				var separador_linea = pregunta.pregunta.separador_linea;
				elem.append($compile("<div class='row'><ft-pregunta pregunta='preguntas[" + idx + "]' preview='preview' modo-traduccion='modoTraduccion' idioma='idioma' solo-preguntas-pdt-traduccion='soloPreguntasPdtTraduccion' data='data'></ft-pregunta>" + ((separador_linea) ? "<hr style='clear:both; border-color:black' class='no-margin'/>" : "") + "</div>")(scope));
			});
		}
	}
}]);

angular.module('FTBase').directive('ftPregunta', ['$http', '$compile', '$filter', '$log', '$q', 'gridService', 'ixStatusService', 'cfg', 'ixUtilsService', '$timeout', '$rootScope', 'authService', 'authInterceptorService', 'ixWarningsService', '$ngConfirm', function ($http, $compile, $filter, $log, $q, gridService, ixStatusService, cfg, ixUtilsService, $timeout, $rootScope, authService, authInterceptorService, ixWarningsService, $ngConfirm) {
	return {
		restrict: 'E',
		scope: {
			pregunta: '=',
			respuestas: '=?',
			data: '=?',
			preview: '=?',
			inPopup: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos son: {{ pregunta | json }}</div>",
		link: function (scope, elem, attrs) {
			var ESTADO_PDT_APROVACION = 1;
			var ESTADO_CONFIRMADO = 2;
			var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };
			scope.status = {};
			if (scope.preview)
				scope.status.editing = true;
			else
				scope.status = ixStatusService.current;
				

			if (angular.isUndefined(scope.data))
				scope.data = {};

			scope.getUniqueID = function (idx, nombre) {
				var id = "";
				if (angular.isDefined(nombre)) {
					if (nombre == "obs")
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.respuestas[idx].observaciones;
					else
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.pregunta[nombre];
				}
				else
					id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta : scope.pregunta.respuestas[idx].id;

				if (angular.isDefined(scope.componentesCount))
					id += "" + scope.componentesCount;
				return id;
			};

			scope.getCssClass = function () {
				var cssClassDimensions = 12;
				if (!scope.inPopup) {
					if (scope.pregunta.pregunta.preguntar_obs)
						cssClassDimensions = 6;

					if (scope.num_subpreguntas)
						cssClassDimensions = 12 / scope.num_subpreguntas;

					//el mínimo es un tercio del ancho por control.
					if (cssClassDimensions < 4)
						cssClassDimensions = 4;
				}
				scope.getCssControlesPregunta(cssClassDimensions, scope.creando_subpregunta);
				return "col-md-" + cssClassDimensions;
			};

			scope.getCssControlesPregunta = function (columnsContainer, subpregunta) {
				if (columnsContainer == 12) {
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-6";
				}
				else if (columnsContainer == 6) {
					if (subpregunta)
						scope.labelClass = "col-md-4";
					else
						scope.labelClass = "col-md-8";
					scope.inputClass = "col-md-4";
				}
				else if (columnsContainer == 4) {
					//calcular cuando tengamos un caso
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-8";
				}
			};

			scope.multiplesElementosEnLaLinea = function () {
				var multiples = false;
				if (scope.pregunta.pregunta.preguntar_obs)
					multiples = true;
				if (scope.num_subpreguntas)
					multiples = true;
				return multiples;
			};

			//CONTROLES DE FORMULARIO INI
			scope.getHTMLTag = function (tipo_valor) {
				var tag;
				switch (tipo_valor) {
					case tiposValor.TEXTO:
					case tiposValor.NUMERICO:
					case tiposValor.DECIMAL:
						//tag = "ix-text";
						tag = "ix-text-area-ft";
						break;
					case tiposValor.AREA_TEXTO:
						tag = "ix-text-area-ft";
						break;
					case tiposValor.DICCIONARIO:
						tag = "ix-select-ft";
						break;
					case tiposValor.DICCIONARIO_MULTIPLE:
						tag = "ix-select-multiple-ft";
						break;
					case tiposValor.SINO:
						tag = "ft-nz-toggle";
						break;
					case tiposValor.FECHA:
						tag = "ix-date-ft";
						break;
				}
				return tag;
			};

			scope.buildControlObs = function (idx) {
				if (!scope.preview)
					scope.observaciones_original = scope.pregunta.respuestas[idx].observaciones;

				//YVES - 18/02/2022
				//Parche para hacer que se traduzca la etiqueta de Observaciones
				var etiqObs = "Observaciones";
				if (scope.idioma == "ca") etiqObs = "Observacions";
				if (scope.idioma == "pt") etiqObs = "Observações";

				var prop = scope.getUniqueID(idx, "obs");
				var strEl = "";
				if (scope.preview)
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='data[\"" + prop + "\"]' name='" + etiqObs + "' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' rows='3'></ix-text-area-ft></div>";
				else if (scope.modoTraduccion) {
					var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
					$log.log("buildControlObs(" + idx + ") -->");
					$log.log(scope.pregunta.respuestas_idioma[0]);
					$log.log(scope.pregunta.respuestas[0]);
					if (scope.pregunta.respuestas[0].observaciones)
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\") || (!pregunta.pregunta.traducible) || (!pregunta.respuestas[" + idx + "].observaciones && pregunta.respuestas_idioma[" + idx + "].fecha_modif_observaciones == null)' placeholder='" + scope.pregunta.respuestas[0].observaciones + "' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
					else
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\") || (!pregunta.pregunta.traducible)' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				}
				else
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta.respuestas[" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\")' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.buildControlImg = function (idx) {
				var clave = "valor";
				scope.setValorOriginal(idx);

				var prop = scope.getUniqueID(idx);
				var pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;

				var isRequired = 0;
				if (clave != "valor") {
					var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
					isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
				}
				else {
					isRequired = scope.pregunta.pregunta.obligatoria;
				}				

				var strEl = "";
				if (scope.preview)
					strEl = '<div class="row"><div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="data[\'' + prop + '\']" ng-disabled="pregunta.bloqueado || tienePerfilRestringido() || (modoTraduccion && !pregunta.pregunta.traducible)" style="margin-top:10px;"></ft-nz-toggle></div></div>';
				else {
					if (scope.modoTraduccion) {
						var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta[\'' + propertyVisible + '\'][' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido()  || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')|| (!pregunta.pregunta.traducible)" after-click="guardarTraduccion" style="margin-top:10px;"></ft-nz-toggle></div>';
					} else {
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta.respuestas[' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido()  || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')" after-click="guardarValor" ix-focus-out-param="valor" ix-focus-out-param-idx="' + idx + '"  style="margin-top:10px;"></ft-nz-toggle></div>';
					}
				}
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.openPopupFicheros = function (id_ficha_tecnica, tipo) {
				var template = "app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html";
				var optionsPopup = { controller: "UploadFilePopupController" };
				var paramsPopup = { tipo: tipo, id_ft: id_ficha_tecnica };
				var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
				popup.then(function (data) {
					$rootScope.$broadcast("NUEVO_FICHERO", data.obj.Record);
				});
			};

			scope.openPopupDedependenciaEtiquetado = function (id_ficha_tecnica, id_pregunta, pregunta_formulario, bloquear_valor_b, idioma, desc_componente) {

				var templateDepEtiquetado = "";
				var optionsPopupDepEtiquetado = {};
				var esTablaEnvases = false;
				if (id_pregunta == 777 || id_pregunta == 856 || id_pregunta == 1189 || id_pregunta == 1192){
					templateDepEtiquetado = "app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_nutricionales_popup.html";
					optionsPopupDepEtiquetado.controller = "DependenciaEtiquetadoNutricionalesPopupController";
				}
				else{
					templateDepEtiquetado = "app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_popup.html";
					optionsPopupDepEtiquetado.controller = "DependenciaEtiquetadoPopupController";
					if (id_pregunta == 1160 || id_pregunta == 1168 || id_pregunta == 1173 || id_pregunta == 1178){
						esTablaEnvases = true;
					}
				}
				
				var pregunta_bloqueada = scope.pregunta.respuestas[0].bloqueado;
				var paramsPopupDepEtiquetado = { id_ft: id_ficha_tecnica, id_pregunta: id_pregunta, pregunta_formulario: pregunta_formulario, bloquear_valor_b: bloquear_valor_b, pregunta_bloqueada: pregunta_bloqueada, modo_traduccion: scope.modoTraduccion, idioma: idioma, traducible: scope.pregunta.pregunta.traducible, pregunta: scope.pregunta, tablaEnvases: esTablaEnvases, componente: desc_componente};
				ixUtilsService.openModalV2(templateDepEtiquetado, optionsPopupDepEtiquetado, "medium", paramsPopupDepEtiquetado);
			};

			scope.setValorOriginal = function (idx, clave) {
				var propertyRespuesta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";

				if (angular.isDefined(clave)) {
					if (angular.isUndefined(scope["valor_original_" + clave])) {
						scope["valor_original_" + clave] = {};
					}
					scope["valor_original_" + clave][idx] = scope.pregunta[propertyRespuesta][idx][clave];
				}
				else {
					if (angular.isUndefined(scope.valor_original))
						scope.valor_original = {};
					scope.valor_original[idx] = scope.pregunta[propertyRespuesta][idx].valor;
				}
			};

			//			scope.esDiccionario = function(){
			//				return (scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO || scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO_MULTIPLE);
			//			};

			scope.sePuedeVisualizar = function (idx, clave) {
				var soloPdtTraduccion = scope.soloPreguntasPdtTraduccion;
				var propertyTraduccion = "traducible";
				if (clave != "valor")
					propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta") + "_traducible";

				//TODO: Yves agregar condición para verificar que la FT master no resulte modificada respecto al valor traducido
				if (soloPdtTraduccion)
					return (scope.pregunta.pregunta[propertyTraduccion]) && (scope.pregunta.respuestas[idx][clave] && !scope.pregunta.respuestas_idioma[idx][clave]);
				else
					return true;

				//Tenemos que devolver solo:
				//-Aquellas que sean traducibles y que el idioma master tenga valor pero no haya traducción. (YVES: agregar que el idioma master tenga valor, hay traducción, pero en el master haya habido modificación)
			};

			scope.textWithQuotes = function (text) {
				return text.replace(/'/g, "&apos;");
			};

			scope.buildControl = function (idx, clave, pregunta, tipo) {
				if (!scope.preview) {
					scope.setValorOriginal(idx, clave);//esto esta antes de la definicion la variable clave a proposito. Ya que hay veces que nos llega por parametro y veces que no. Queremos distinguir esos casos.
					if (angular.isUndefined(clave))
						clave = "valor";
				}
				var prop;
				if (angular.isDefined(clave))
					prop = scope.getUniqueID(idx, clave);
				else
					prop = scope.getUniqueID(idx);

				var tag;
				if (angular.isDefined(tipo))
					tag = scope.getHTMLTag(tipo);
				else
					tag = scope.getHTMLTag(scope.pregunta.pregunta.tipo_valor);

				if (angular.isUndefined(pregunta)) {
					if (scope.modoTraduccion) {
						pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
					else {
						pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
				}

				var strEl = "";
				pregunta = scope.textWithQuotes(pregunta);
				if (scope.preview)
					strEl = "<div class='" + scope.getCssClass() + "'><" + tag + " ng-model='data[\"" + prop + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' " + scope.addSpecificProperties(clave) + "></" + tag + "></div>";
				else {
					strEl = "<div class='" + scope.getCssClass() + "'>";

					var isRequired = 0;
					if (clave != "valor") {
						var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
						isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
					}
					else {
						isRequired = scope.pregunta.pregunta.obligatoria;
					}

					if (scope.modoTraduccion) {
						if (scope.sePuedeVisualizar(idx, clave)) {
							var propertyVisible;
							if (clave == "valor") {
								propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
								scope.se_puede_visualizar = true;
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta.traducible) || (pregunta.pregunta.tipo_valor != \"TEXTO\")) || (!pregunta.respuestas[" + idx + "].valor && pregunta.respuestas_idioma[" + idx + "].fecha_modif_valor == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")'";
								strEl += " ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							} else {
								var propertyTraduccion = clave;
								propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta");

								var propertyTraducible = propertyTraduccion + "_traducible";

								propertyVisible = (scope.pregunta.pregunta[propertyTraducible]) ? "respuestas_idioma" : "respuestas";

								var tipoValor = "tipo_valor_" + propertyTraduccion;

								//strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta[\"" + propertyTraducible + "\"])) || (pregunta.pregunta[\"" + tipoValor + "\"] != \"TEXTO\") || (!pregunta.respuestas[" + idx + "][\"" + clave + "\"] && pregunta.respuestas_idioma[" + idx + "][\"fecha_modif_" + clave + "\"] == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ";
								strEl += "ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							}
						} else if (clave == "valor") {
							scope.se_puede_visualizar = false;
						}
					}
					else {
						scope.se_puede_visualizar = true;

						if (tag == "ix-select-multiple-ft" && scope.pregunta.respuestas[idx][clave] != "")
							scope.pregunta.respuestas[idx][clave] = ixUtilsService.fromJson(scope.pregunta.respuestas[idx][clave]);

						//strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido()' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
						strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
					}

					strEl += "</div>";

				}
				var el = $compile(strEl)(scope);
				return el;
			};

			//			scope.getSelected = function(idx, clave){//Esta funcion hace que cuando estemos en modo traducción, aparezca por defecto
			//				if(!scope.pregunta.respuestas_idioma[idx][clave]){
			//					scope.pregunta.respuestas_idioma[idx][clave] = scope.pregunta.respuestas[idx][clave];
			//					scope.setValorOriginal(idx, clave);
			//				}
			//			};

			scope.cuentaSubPreguntas = function () {
				var num = 0;
				if (scope.pregunta.pregunta.sub_pregunta1)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta2)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta3)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta4)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta5)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta6)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta7)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta8)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta9)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta10)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta11)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta12)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta13)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta14)
					num++;
				if (num > 0)
					num++;//sumamos uno para despues dividir el ancho para que quepan como minimo 3 controles por fila.
				return num;
			};

			scope.buildControlSubPreguntas = function (idx) {
				//var strEl = "";
				var propertyPregunta = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				for (var i = 1; i <= 14; i++) {
					if (scope.pregunta[propertyPregunta]["sub_pregunta" + i]) {
						scope.creando_subpregunta = true;
						elem.append(scope.buildControl(idx, "sub_respuesta" + i, scope.pregunta[propertyPregunta]["sub_pregunta" + i], scope.pregunta.pregunta["tipo_valor_sub_pregunta" + i]));
						scope.creando_subpregunta = false;
					}

				}
				//return strEl;
			};

			scope.guardarObservaciones = function () {

				var entity = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				$log.log("guardamos solo si ha cambiado.");
				if (scope.observaciones_original != scope.pregunta[respuestasProperty][0].observaciones) {
					scope.observaciones_original = scope.pregunta[respuestasProperty][0].observaciones;
					$log.log("ha cambiado, guardamos.");
					$log.log(scope.pregunta);
					var data = [
						{
							op: "replace",
							path: "/observaciones",
							value: scope.pregunta[respuestasProperty][0].observaciones
						}
					];

					var pathParams = scope.pregunta[respuestasProperty][0].id;
					if (scope.modoTraduccion)
						pathParams += "/" + scope.pregunta[respuestasProperty][0].idioma;

					$http.put(cfg.baseURL + entity + "/" + pathParams, data);
				}
			};

			scope.guardarValor = function (event) {

				var entity = "extranet_fichas_tecnicas_det";
				var respuestaProp = "respuestas";

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.guardarTraduccion = function (event) {
				var entity = "extranet_fichas_tecnicas_det_idioma";
				var respuestaProp = "respuestas_idioma";

				scope.$broadcast("focusOut");

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.grabarValor = function (event, entity, respuestaProp) {
				if (!scope.inPopup) {
					var prop = event.data.prop;
					var idx = event.data.idx;
					var valor_original_prop = "valor_original";
					if (prop != "valor")
						valor_original_prop += "_" + prop;

					$log.log("guardamos solo si ha cambiado.");
					if (scope[valor_original_prop][idx] != scope.pregunta[respuestaProp][idx][prop]) {

						var auxValorOriginal = scope[valor_original_prop][idx];
						var nuevoValor = scope.pregunta[respuestaProp][idx][prop];

						scope[valor_original_prop][idx] = scope.pregunta[respuestaProp][idx][prop];
						$log.log("ha cambiado, guardamos.");
						$log.log(scope.pregunta);

						var valor = scope.pregunta[respuestaProp][idx][prop];
						if (angular.isArray(valor))
							valor = ixUtilsService.toJson(valor);

						var data = [
							{
								op: "replace",
								path: "/" + prop,
								value: valor
							}
						];
						var pathParams = scope.pregunta[respuestaProp][idx].id;
						if (scope.modoTraduccion)
							pathParams += "/" + scope.pregunta[respuestaProp][idx].idioma;

						$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
							//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
							//OJO: Hay un BUG que resolver en la función actualizarRespuestas, porque modifica el valor de la pregunta 828 (YVES 19/11/2020)
							/* START
							if (scope.pregunta.pregunta.id_pregunta == 828) {
								scope.actualizarGrids(777);
								scope.actualizarGrids(856);
							}
							END */
							// if (cfg.appCliente == "EUROMADI") {
							// 	if (scope.pregunta.pregunta.id_pregunta == 855){
							// 		scope.actualizarGrids(855);
							// 	}
							// }
							// if (cfg.appCliente == "BONPREU") {
							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de ALIMENTACIÓN
							// 	if (scope.pregunta.pregunta.id_pregunta == 5083) {
							// 		scope.actualizarGrids(5084);
							// 		scope.actualizarGrids(5637);
							// 	}

							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de FRESCOS
							// 	if (scope.pregunta.pregunta.id_pregunta == 5791) {
							// 		scope.actualizarGrids(5792);
							// 		scope.actualizarGrids(5793);
							// 	}
							// }

							if (scope.modoTraduccion)
								scope.pregunta[respuestaProp][idx]["fecha_modif_" + prop] = null;
							ixStatusService.setResponse(response);
							$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION", { newValue: nuevoValor, oldValue: auxValorOriginal, pregunta: scope.pregunta.pregunta });
						}, function (err) {
							//Si diera error al guardar, conservamos el valor anterior.
							scope.pregunta[respuestaProp][idx][prop] = auxValorOriginal;
							ixStatusService.setResponse(err);
						});
					}
				}
			};

			scope.loadValores = function (param, search, entity) {
				var deferr = $q.defer();
				var valores = [];
				var propertyPregunta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "pregunta_idioma" : "pregunta";
				var propertyValores = "diccionario_valores";
				var propertyName = entity;
				if (propertyName.lastIndexOf("sub_pregunta") != -1) {
					propertyName = propertyName.substring(propertyName.indexOf("sub_pregunta"));
					propertyValores = "diccionario_" + propertyName + "_valores";
				}
				angular.forEach(scope.pregunta[propertyPregunta][propertyValores], function (valor) {
					valores.push({ codigo: valor, descripcion: valor });
				});
				deferr.resolve({ data: valores });
				return deferr.promise;
			};

			scope.addSpecificProperties = function (tipoProp, multiplesElementosEnLaLinea) {
				var nameProperty = "";
				var namePropertyOriginal = "";
				var numlineas = "1";

				if (angular.isUndefined(tipoProp) || tipoProp == "valor") {
					nameProperty = "valor";
					tipoProp = "tipo_valor";
					numlineas = scope.pregunta.pregunta.numlineas_texto_pregunta;
				}
				else if (tipoProp.lastIndexOf("sub_respuesta") != -1) {
					namePropertyOriginal = tipoProp;
					tipoProp = tipoProp.replace("sub_respuesta", "sub_pregunta");
					nameProperty = tipoProp;
					tipoProp = "tipo_valor_" + tipoProp;
					numlineas = scope.pregunta.pregunta["numlineas_texto_" + nameProperty];
				}
				var specificProperties = "";

				switch (scope.pregunta.pregunta[tipoProp]) {
					case tiposValor.TEXTO:

						specificProperties += "rows='" + numlineas + "' ";
						if (scope.modoTraduccion) {
							if (nameProperty == "valor") {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0].valor + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta.traducible + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0].fecha_modif_valor) + "' ";
							}
							else {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta[nameProperty + "_traducible"] + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0]["fecha_modif_" + namePropertyOriginal]) + "' ";
							}
						}
						break;
					case tiposValor.NUMERICO:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						break;
					case tiposValor.DECIMAL:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						specificProperties += "with-decimals='2' ";
						specificProperties += "comma-separator='true' ";
						break;
					case tiposValor.DICCIONARIO:
					case tiposValor.DICCIONARIO_MULTIPLE:
						scope.addNewElementsToDictionary(tipoProp);
						specificProperties += "entity='" + tipoProp + "' pk='codigo' desc='descripcion' load-function='loadValores' append-to-body='true' limit-to='9999' ";
						if (scope.modoTraduccion) {
							specificProperties += " keep-original-value='true' ";
						}
						break;
					case tiposValor.FECHA:
						specificProperties += "append-to-body='true' ";
						break;
					case tiposValor.SINO:
						specificProperties += ((scope.modoTraduccion) ? "after-click='guardarTraduccion' " : "after-click='guardarValor' ");
						if (multiplesElementosEnLaLinea)
							specificProperties += " text-max-width='true' ";
						break;
				}

				if (scope.modoTraduccion) {
					if (nameProperty == "valor" && scope.pregunta.pregunta.traducible && scope.pregunta.respuestas[0].valor)
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0].valor + "' ";
					else if (scope.pregunta.pregunta[nameProperty + "_traducible"] && scope.pregunta.respuestas[0][namePropertyOriginal])
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ";
				}

				if (scope.pregunta.pregunta.ayuda_pregunta && !scope.inPopup) {
					if (scope.modoTraduccion)
						specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + "'  float-left='true' ";
					else
						specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + "'  float-left='true' ";
				}


				specificProperties += " label-class='" + scope.labelClass + "' input-class='" + scope.inputClass + "' ";

				return specificProperties;
			}
			//CONTROLES DE FORMULARIO FIN

			//GRID INI
			scope.isRowSelectable = function (row) {
				return !row.entity.bloqueado;
			};

			scope.estaBloqueadoValor = function (cell) {
				return (scope.estaBloqueado(cell)) || scope.pregunta.pregunta.bloquear_valor_b || scope.tienePerfilRestringido();
			};

			scope.estaBloqueado = function (cell) {
				if (cell.col.field == "valor")
					return cell.row.entity.bloqueado || (scope.modoTraduccion && !scope.pregunta.pregunta.traducible) || scope.tienePerfilRestringido();
				else {
					//miramos si la sub_pregunta esta bloqueada.
					var propertyFTPreguntas = cell.col.field.replace("respuesta", "pregunta");
					var propertyABuscar = "deshabilitar_" + propertyFTPreguntas;
					var propertyTraducible = propertyFTPreguntas + "_traducible";
					return (scope.pregunta.pregunta[propertyABuscar] == 1 || cell.row.entity.bloqueado) || (scope.modoTraduccion && !scope.pregunta.pregunta[propertyTraducible]) || scope.tienePerfilRestringido();
				}
			};

			scope.getFakeMetadata = function () {
				var metadata = [{ Name: "id", NoVisible: true, Pk: true }];
				var auxTitle = scope.pregunta.pregunta.pregunta_formulario;
				if (scope.pregunta.pregunta.bucle == 1)
					auxTitle = scope.pregunta.pregunta.titulo_primera_columna;
				var valor = { Name: "valor", ColumnDescription: auxTitle, Type: "String", NoEditable: scope.estaBloqueadoValor, NoFilterable: true };
				scope.addSpecificControl(valor, scope.pregunta.pregunta.tipo_valor, scope.esGridJerarquico());
				metadata.push(valor);
				if (scope.pregunta.pregunta.sub_pregunta1) {
					var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta1, scope.pregunta.pregunta.tipo_valor_sub_pregunta1, scope.esGridJerarquico());
					metadata.push(sub_pregunta1);
				}
				if (scope.pregunta.pregunta.sub_pregunta2) {
					var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta2, scope.pregunta.pregunta.tipo_valor_sub_pregunta2, scope.esGridJerarquico());
					metadata.push(sub_pregunta2);
				}
				if (scope.pregunta.pregunta.sub_pregunta3) {
					var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta3, scope.pregunta.pregunta.tipo_valor_sub_pregunta3, scope.esGridJerarquico());
					metadata.push(sub_pregunta3);
				}
				if (scope.pregunta.pregunta.sub_pregunta4) {
					var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta4, scope.pregunta.pregunta.tipo_valor_sub_pregunta4, scope.esGridJerarquico());
					metadata.push(sub_pregunta4);
				}
				if (scope.pregunta.pregunta.sub_pregunta5) {
					var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta5, scope.pregunta.pregunta.tipo_valor_sub_pregunta5, scope.esGridJerarquico());
					metadata.push(sub_pregunta5);
				}
				if (scope.pregunta.pregunta.sub_pregunta6) {
					var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta6, scope.pregunta.pregunta.tipo_valor_sub_pregunta6, scope.esGridJerarquico());
					metadata.push(sub_pregunta6);
				}
				if (scope.pregunta.pregunta.sub_pregunta7) {
					var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta7, scope.pregunta.pregunta.tipo_valor_sub_pregunta7, scope.esGridJerarquico());
					metadata.push(sub_pregunta7);
				}
				if (scope.pregunta.pregunta.sub_pregunta8) {
					var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta8, scope.pregunta.pregunta.tipo_valor_sub_pregunta8, scope.esGridJerarquico());
					metadata.push(sub_pregunta8);
				}
				if (scope.pregunta.pregunta.sub_pregunta9) {
					var sub_pregunta9 = { Name: "sub_respuesta9", ColumnDescription: scope.pregunta.pregunta.sub_pregunta9, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta9, scope.pregunta.pregunta.tipo_valor_sub_pregunta9, scope.esGridJerarquico());
					metadata.push(sub_pregunta9);
				}
				if (scope.pregunta.pregunta.sub_pregunta10) {
					var sub_pregunta10 = { Name: "sub_respuesta10", ColumnDescription: scope.pregunta.pregunta.sub_pregunta10, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta10, scope.pregunta.pregunta.tipo_valor_sub_pregunta10, scope.esGridJerarquico());
					metadata.push(sub_pregunta10);
				}
				if (scope.pregunta.pregunta.sub_pregunta11) {
					var sub_pregunta11 = { Name: "sub_respuesta11", ColumnDescription: scope.pregunta.pregunta.sub_pregunta11, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta11, scope.pregunta.pregunta.tipo_valor_sub_pregunta11, scope.esGridJerarquico());
					metadata.push(sub_pregunta11);
				}
				if (scope.pregunta.pregunta.sub_pregunta12) {
					var sub_pregunta12 = { Name: "sub_respuesta12", ColumnDescription: scope.pregunta.pregunta.sub_pregunta12, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta12, scope.pregunta.pregunta.tipo_valor_sub_pregunta12, scope.esGridJerarquico());
					metadata.push(sub_pregunta12);
				}
				if (scope.pregunta.pregunta.sub_pregunta13) {
					var sub_pregunta13 = { Name: "sub_respuesta13", ColumnDescription: scope.pregunta.pregunta.sub_pregunta13, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta13, scope.pregunta.pregunta.tipo_valor_sub_pregunta13, scope.esGridJerarquico());
					metadata.push(sub_pregunta13);
				}
				if (scope.pregunta.pregunta.sub_pregunta14) {
					var sub_pregunta14 = { Name: "sub_respuesta14", ColumnDescription: scope.pregunta.pregunta.sub_pregunta14, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta14, scope.pregunta.pregunta.tipo_valor_sub_pregunta14, scope.esGridJerarquico());
					metadata.push(sub_pregunta14);
				}
				return metadata;
			};

			scope.addNewElementsToDictionary = function (prop) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				var diccionarioProperty = "diccionario_valores";
				var valorProperty = "valor";
				if(prop.startsWith("tipo_valor_sub_pregunta")) {
					diccionarioProperty = prop.replace("tipo_valor_sub_","diccionario_sub_")+"_valores";
					valorProperty = prop.replace("tipo_valor_sub_pregunta","sub_respuesta");
				}

				scope.pregunta[respuestasProperty].forEach(function (respuesta) {					
					if (scope.pregunta[preguntaProperty][diccionarioProperty]) {
						if (angular.isArray(respuesta[valorProperty])) {
							respuesta[valorProperty].forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(";")>=0) {
								respuesta[valorProperty].split(";").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(",")>=0) {
							respuesta[valorProperty].split(",").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						}
						else if (respuesta[valorProperty] && scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(respuesta[valorProperty]) == -1) {
							scope.pregunta[preguntaProperty][diccionarioProperty].push(respuesta[valorProperty]);
						}
					}
				});
		
			};

			scope.addSpecificControl = function (obj, tipo, esJerarquico) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (esJerarquico && scope.modoTraduccion && tipo == tiposValor.DICCIONARIO_MULTIPLE)
					tipo = tiposValor.TEXTO;

				if (tipo == tiposValor.TEXTO) {
					if (scope.modoTraduccion) {
						if (obj.Name == "valor" && scope.pregunta.pregunta.traducible) {
							obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
							obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
						} else {
							var nameColumn = obj.Name.replace("respuesta", "pregunta");
							if (scope.pregunta.pregunta[nameColumn + "_traducible"]) {
								obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
								obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
							}
						}
					} else {
						obj.Control = "List";
					}
				}

				if (tipo == tiposValor.SINO) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					obj.Control = "CheckBox";
					obj.Type = "Int32";
					obj.ignoreCellModifications = true;
				}
				else if (tipo == tiposValor.DICCIONARIO || tipo == tiposValor.DICCIONARIO_MULTIPLE) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					if (tipo == tiposValor.DICCIONARIO_MULTIPLE)
						obj.Control = "MultiBusqueda";

					switch (obj.Name) {
						case "valor":
							if (scope.pregunta[preguntaProperty].diccionario_valores) scope.addNewElementsToDictionary("tipo_valor");
							break;
						case "sub_respuesta1":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta1_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta1");
							break;
						case "sub_respuesta2":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta2_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta2");
							break;
						case "sub_respuesta3":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta3_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta3");
							break;
						case "sub_respuesta4":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta4_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta4");
							break;
						case "sub_respuesta5":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta5_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta5");
							break;
						case "sub_respuesta6":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta6");
							break;
						case "sub_respuesta7":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta7");
							break;
						case "sub_respuesta8":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta8_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta8");
							break;
						case "sub_respuesta9":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta9_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta9");
							break;
						case "sub_respuesta10":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta10_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta10");
							break;
						case "sub_respuesta11":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta11_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta11");
							break;
						case "sub_respuesta12":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta12_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta12");
							break;
						case "sub_respuesta13":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta13_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta13");
							break;
						case "sub_respuesta14":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta14_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta14");
							break;
					}

					if (esJerarquico && obj.Name == "valor")
						obj.ColumnFkDescription = "valor";

					obj.Search = {
						"KeyFields": [obj.Name],
						"LookUpTableName": "",
						"LookUpKeyFields": ["codigo"],
						"LookUpResultFields": ["codigo"],
						"LookUpTableAlias": "",
						"LookUpOrders": [{ "KeyField": "codigo", "Desc": false }],
						"LookUpConditions": []
					};
					obj.busquedaFunction = function (column, param, text) {
						var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
						var deferr = $q.defer();
						var valores = [];
						var diccionario_valores = [];
						if (scope.preview)
							diccionario_valores = scope.pregunta.pregunta.diccionario_valores;
						else {
							var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
							fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
							diccionario_valores = scope.pregunta[preguntaProperty][fieldToSearch];
						}

						if (text)
							diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

						angular.forEach(diccionario_valores, function (valor) {
							var item = { codigo: valor, descripcion: valor };
							if (column.ColumnFKDescription)
								item[column.ColumnFKDescription] = valor;

							valores.push(item);
						});
						deferr.resolve(valores);
						return deferr.promise;
					};
				}
				else if (tipo == tiposValor.FECHA)
					obj.Type = "DateTime";
				else if (tipo == tiposValor.DECIMAL) {
					obj.Type = "Decimal";
					obj.MaxLength = 11;
					obj.CommaSeparator = true; // Forzar cambio de . por , en la entrada de valores
				}
				else if (tipo == tiposValor.NUMERICO) {
					obj.Type = "Int32";
					obj.MaxLength = 11;
				}
			};

			scope.guardarDatosGrid = function (rowEntity, colDef, newValue, oldValue) {
				// $log.log("guardaremos los datos del grid.");
				// $log.log(rowEntity);
				// $log.log(colDef);
				// $log.log(newValue);
				// $log.log(oldValue);
				var data = [
					{
						op: "replace",
						path: "/" + colDef.name,
						value: newValue
					}
				];

				var entity = ((scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det");
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";

				var pathParams = rowEntity.id;
				if (scope.modoTraduccion)
					pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

				rowEntity.editingCols=rowEntity.editingCols||[];
				rowEntity.editingCols.push(colDef.name);
				$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
					if (!scope.modoTraduccion) {
						//Modificar propietats de la línea actual per el que arriva de l'API.

						//Modificar una pregunta pot fer que s'hagi de recarregar un altre.
						if (cfg.appCliente == "EUROMADI") {
							if (scope.pregunta[preguntaProperty].id_pregunta == 845)
								scope.addToReload([780]);
						}
						if (cfg.appCliente == "BONPREU") {
							if (scope.pregunta[preguntaProperty].id_pregunta == 5634)
								scope.addToReload([5102]);
							if (scope.pregunta[preguntaProperty].id_pregunta == 5794)
								scope.addToReload([5799]);
						}

						if (response.data.obj) {
							//Guardamos lo que devuelve la API pero si fueran booleanos, como viene como string lo pasamos a booleano.
							//OJO!!! Esto no muestra el valor en celdas numéricas en las cuales se quiera poner el valor 1 ó 0. Debe de sustituirse el valor sólo si la celda es de tipo Checkbox
							if (response.data.obj.Record[colDef.name] === "1" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 1;
							}
							else if (response.data.obj.Record[colDef.name] === "0" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 0;
							}
							else {
								rowEntity[colDef.name] = response.data.obj.Record[colDef.name];
							}

						}
						//En alguns casos (id_pregunta hardcoded), el grid s'haura de recarregar sencer.
						//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
						/* START
						if (scope.pregunta[preguntaProperty].id_pregunta == 777) {
							scope.actualizarGrids(777, rowEntity.componente);
						}
						END */
						if ((scope.pregunta[preguntaProperty].id_pregunta == 1160 || scope.pregunta[preguntaProperty].id_pregunta == 1168 || scope.pregunta[preguntaProperty].id_pregunta == 1173 || scope.pregunta[preguntaProperty].id_pregunta == 1178) 
							&& cfg.appCliente == "EUROMADI") {
							if (colDef.name == "sub_respuesta3")
								scope.actualizarGridsSinComponente(scope.pregunta[preguntaProperty].id_pregunta);
							// Actualiamos la los valores de rowEntity porque el grid tiene columnas con valores calculados en backend
							if(response.data.obj) {
								var grid = scope.data.grids["grid"+scope.pregunta[preguntaProperty].id_pregunta];
								Object.keys(response.data.obj.Record).forEach(function(key){
									var colDef = grid.columnDefs.find(function(cd){cd.field==key})
									if (colDef && response.data.obj.Record[colDef.name] === "1" && colDef.control == "CheckBox") {
										rowEntity[colDef.name] = 1;
									}
									else if (colDef && response.data.obj.Record[colDef.name] === "0" && colDef.control == "CheckBox") {
										rowEntity[colDef.name] = 0;
									}
									else {
										rowEntity[key] = response.data.obj.Record[key];
									}									
								})
							}
						}

						// if (cfg.appCliente == "BONPREU") {
						// 	//Tabla de nutricionales para fichas de ALIMENTACIÓN
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5084) {
						// 		scope.actualizarGrids(5084, rowEntity.componente);
						// 	}
						// 	//Tabla de nutricionales para fichas de FRESCOS
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5792) {
						// 		scope.actualizarGrids(5792, rowEntity.componente);
						// 	}
						// }
					} else {
						rowEntity["fecha_modif_"+colDef.name] = response.data.obj.Record["fecha_modif_"+colDef.name];
					}

					$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: newValue, oldValue: oldValue, pregunta: response.data.obj.Record, tipo_modificacion: "Update" });
					ixStatusService.setResponse(response);
				}, function (err) {
					//Si diera error al guardar, conservamos el valor anterior.
					rowEntity[colDef.name] = oldValue;
					ixStatusService.setResponse(err);
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
				});
			};

			scope.esGridJerarquico = function () {
				return scope.pregunta.pregunta.sub_bucle == 1;
			};

			scope.getEntityMaster = function (id) {
				return scope.pregunta.respuestas.find(function (e) { return e.id == id; });
			};

			scope.eliminarIngrediente = function (entity, grid) {
				//var gridRows = grid.rows.map(function(e){return e.entity;});
				var gridRows = grid.data;
				var pos = gridRows.indexOf(entity);
				var ingredienteSiguiente = gridRows[pos + 1];
				if (!ingredienteSiguiente) {
					//No hay más ingredientes, por lo tanto es ingrediente único
					scope.deleteRow({ grid: grid, row: entity });
				}
				else {
					if (ingredienteSiguiente["$$treeLevel"] > entity["$$treeLevel"]) {

						ixWarningsService.warningConfirmacion(scope, "¡Atención!  Se eliminarán todos los subingredientes ¿Deseas confirmar?", scope.deleteRow, undefined, { grid: grid, row: entity });
					}
					else {
						scope.deleteRow({ grid: grid, row: entity });
					}
				}
			};

			scope.abrirPopupAlimentacion = function (entity, grid, isNew) {
				var entityOriginal = angular.copy(entity);

				var templateURL = "app/FTBase/views/grid_jerarquico_add_row_popup.html";
				var optionsPopup = { controller: "GridJerarquicoAddRowPopupController" };
				var paramsPopup = { entity: entity, pregunta: scope.pregunta, isNew: isNew, modoTraduccion: scope.modoTraduccion };

				if (scope.modoTraduccion) {
					paramsPopup.entityMaster = scope.getEntityMaster(entity.id);
				}

				if (angular.isDefined(grid)) {
					paramsPopup.rowsGrid = (isNew) ? grid.data : [];
					paramsPopup.grid = grid;
					grid.ixRefreshGridDropDowns();
				}

				ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function (response) {
					if (angular.isDefined(response)) {
						if (!isNew) {
							var changes = ixGetPatchOperations(entityOriginal, entity);
							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
							var pathParams = entity.id;
							if (scope.modoTraduccion)
								pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

							$http.put(cfg.baseURL + tabla + "/" + pathParams, changes).then(function (response) {
								if (scope.modoTraduccion) {
									entity.fecha_modif_valor = response.data.obj.Record.fecha_modif_valor;
									entity.fecha_modif_sub_respuesta1 = response.data.obj.Record.fecha_modif_sub_respuesta1;
									entity.fecha_modif_sub_respuesta2 = response.data.obj.Record.fecha_modif_sub_respuesta2;
									entity.fecha_modif_sub_respuesta3 = response.data.obj.Record.fecha_modif_sub_respuesta3;
									entity.fecha_modif_sub_respuesta4 = response.data.obj.Record.fecha_modif_sub_respuesta4;
									entity.fecha_modif_sub_respuesta5 = response.data.obj.Record.fecha_modif_sub_respuesta5;
									entity.fecha_modif_sub_respuesta6 = response.data.obj.Record.fecha_modif_sub_respuesta6;
									entity.fecha_modif_sub_respuesta7 = response.data.obj.Record.fecha_modif_sub_respuesta7;
									entity.fecha_modif_sub_respuesta8 = response.data.obj.Record.fecha_modif_sub_respuesta8;
									entity.fecha_modif_sub_respuesta9 = response.data.obj.Record.fecha_modif_sub_respuesta9;
									entity.fecha_modif_sub_respuesta10 = response.data.obj.Record.fecha_modif_sub_respuesta10;
									entity.fecha_modif_sub_respuesta11 = response.data.obj.Record.fecha_modif_sub_respuesta11;
									entity.fecha_modif_sub_respuesta12 = response.data.obj.Record.fecha_modif_sub_respuesta12;
									entity.fecha_modif_sub_respuesta13 = response.data.obj.Record.fecha_modif_sub_respuesta13;
									entity.fecha_modif_sub_respuesta14 = response.data.obj.Record.fecha_modif_sub_respuesta14;
								}
								$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: response.data.obj.Record.valor, oldValue: undefined, pregunta: scope.pregunta.pregunta, tipo_modificacion: "Update" });
							}, function (err) {
								//console.error("Response put ERROR",err);
								entity.sub_respuesta1 = entityOriginal.sub_respuesta1;
								entity.sub_respuesta2 = entityOriginal.sub_respuesta2;
								entity.sub_respuesta3 = entityOriginal.sub_respuesta3;
								entity.sub_respuesta4 = entityOriginal.sub_respuesta4;
								entity.sub_respuesta5 = entityOriginal.sub_respuesta5;
								entity.sub_respuesta6 = entityOriginal.sub_respuesta6;
								entity.sub_respuesta7 = entityOriginal.sub_respuesta7;
								entity.sub_respuesta8 = entityOriginal.sub_respuesta8;
								entity.sub_respuesta9 = entityOriginal.sub_respuesta9;
								entity.sub_respuesta10 = entityOriginal.sub_respuesta10;
								entity.sub_respuesta11 = entityOriginal.sub_respuesta11;
								entity.sub_respuesta12 = entityOriginal.sub_respuesta12;
								entity.sub_respuesta13 = entityOriginal.sub_respuesta13;
								entity.sub_respuesta14 = entityOriginal.sub_respuesta14;
								ixStatusService.setResponse(err);
							});
							if (angular.isDefined(grid) && entity.valor!=entityOriginal.valor) {
								// Si cambia el valor debemos repintar la tabla entera porque sino no se refresca (no es editable)
								grid.ixRefreshGridDropDowns();
								$timeout(function () {
									grid.gridApi.core.refresh();
								}, 300);
							}
						}
					} else {
						scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid);
					}

					//Marcar la pregunta 845 para recargar.
					if (scope.pregunta.pregunta.id_pregunta == 767) {
						scope.addToReload([845, 780]);
					}
				});
			};

			scope.addToReload = function (listaPreguntas) {
				if (angular.isUndefined(scope.data.ToReload))
					scope.data.ToReload = {};

				angular.forEach(listaPreguntas, function (pregunta) {
					if (!scope.data.ToReload[pregunta])
						scope.data.ToReload[pregunta] = true;

				});
			};

			scope.addTreeLevel = function (respuestas) {
				// $timeout(function(){
				// 	angular.forEach(respuestas, function (respuesta) {
				// 		respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
				// 	});
				// 	},1);
					angular.forEach(respuestas, function (respuesta) {
						respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
					});
			};

			scope.getCustomHint = function (row, col) {
				var respuestaOriginal = scope.pregunta.respuestas.find(function (e) { return e.id == row.entity.id; });
				if (angular.isDefined(respuestaOriginal))
					return respuestaOriginal[col.field];
				return "";
			};

			scope.changeCellValue = function (row, col, nuevoValor) {
				var respuesta = scope.pregunta.respuestas_idioma.find(function (e) { return e.id == row.entity.id; });
				respuesta[col.field] = nuevoValor;
			};

			scope.checkColState = function (row, col) {
				var estado = 0;

				if (scope.pregunta.pregunta.traducible && col.field == "valor") {
					if (row.entity.fecha_modif_valor)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta1_traducible && col.field == "sub_respuesta1") {
					if (row.entity.fecha_modif_sub_respuesta1)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta2_traducible && col.field == "sub_respuesta2") {
					if (row.entity.fecha_modif_sub_respuesta2)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_PDT_APROVACION;
				}
				if (scope.pregunta.pregunta.sub_pregunta3_traducible && col.field == "sub_respuesta3") {
					if (row.entity.fecha_modif_sub_respuesta3)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta4_traducible && col.field == "sub_respuesta4") {
					if (row.entity.fecha_modif_sub_respuesta4)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta5_traducible && col.field == "sub_respuesta5") {
					if (row.entity.fecha_modif_sub_respuesta5)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta6_traducible && col.field == "sub_respuesta6") {
					if (row.entity.fecha_modif_sub_respuesta6)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta7_traducible && col.field == "sub_respuesta7") {
					if (row.entity.fecha_modif_sub_respuesta7)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta8_traducible && col.field == "sub_respuesta8") {
					if (row.entity.fecha_modif_sub_respuesta8)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta9_traducible && col.field == "sub_respuesta9") {
					if (row.entity.fecha_modif_sub_respuesta9)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta10_traducible && col.field == "sub_respuesta10") {
					if (row.entity.fecha_modif_sub_respuesta10)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta11_traducible && col.field == "sub_respuesta11") {
					if (row.entity.fecha_modif_sub_respuesta11)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta12_traducible && col.field == "sub_respuesta12") {
					if (row.entity.fecha_modif_sub_respuesta12)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta13_traducible && col.field == "sub_respuesta13") {
					if (row.entity.fecha_modif_sub_respuesta13)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta14_traducible && col.field == "sub_respuesta14") {
					if (row.entity.fecha_modif_sub_respuesta14)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				return estado;
			};

			scope.filtrarSoloPendientesTraduccion = function (respuestas) {
				var result = [];
				respuestas.forEach(function (respuesta) {
					//Devolver solo las que sean traducibles y que en master tengan valor pero en la traduccion no.
					var cumple = false;
					var configuracionPregunta = scope.pregunta.pregunta;
					var preguntaMaster = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id });

					if (configuracionPregunta.traducible && (preguntaMaster.valor && !respuesta.valor))
						cumple = true;
					if (configuracionPregunta.sub_pregunta1_traducible && (preguntaMaster.sub_respuesta1 && !respuesta.sub_respuesta1))
						cumple = true;
					if (configuracionPregunta.sub_pregunta2_traducible && (preguntaMaster.sub_respuesta2 && !respuesta.sub_respuesta2))
						cumple = true;
					if (configuracionPregunta.sub_pregunta3_traducible && (preguntaMaster.sub_respuesta3 && !respuesta.sub_respuesta3))
						cumple = true;
					if (configuracionPregunta.sub_pregunta4_traducible && (preguntaMaster.sub_respuesta4 && !respuesta.sub_respuesta4))
						cumple = true;
					if (configuracionPregunta.sub_pregunta5_traducible && (preguntaMaster.sub_respuesta5 && !respuesta.sub_respuesta5))
						cumple = true;
					if (configuracionPregunta.sub_pregunta6_traducible && (preguntaMaster.sub_respuesta6 && !respuesta.sub_respuesta6))
						cumple = true;
					if (configuracionPregunta.sub_pregunta7_traducible && (preguntaMaster.sub_respuesta7 && !respuesta.sub_respuesta7))
						cumple = true;
					if (configuracionPregunta.sub_pregunta8_traducible && (preguntaMaster.sub_respuesta8 && !respuesta.sub_respuesta8))
						cumple = true;
					if (configuracionPregunta.sub_pregunta9_traducible && (preguntaMaster.sub_respuesta9 && !respuesta.sub_respuesta9))
						cumple = true;
					if (configuracionPregunta.sub_pregunta10_traducible && (preguntaMaster.sub_respuesta10 && !respuesta.sub_respuesta10))
						cumple = true;
					if (configuracionPregunta.sub_pregunta11_traducible && (preguntaMaster.sub_respuesta11 && !respuesta.sub_respuesta11))
						cumple = true;
					if (configuracionPregunta.sub_pregunta12_traducible && (preguntaMaster.sub_respuesta12 && !respuesta.sub_respuesta12))
						cumple = true;
					if (configuracionPregunta.sub_pregunta13_traducible && (preguntaMaster.sub_respuesta13 && !respuesta.sub_respuesta13))
						cumple = true;
					if (configuracionPregunta.sub_pregunta14_traducible && (preguntaMaster.sub_respuesta14 && !respuesta.sub_respuesta14))
						cumple = true;


					if (cumple)
						result.push(respuesta);
				});
				return result;
			};

			scope.ajustarDataFromApi = function (array, grid) {
				var controlIsCheck = function(columnas, posicion){
					var cd = columnasDefs.find(function(c){ return c.field.toUpperCase() == "SUB_RESPUESTA" + posicion;});
					if (angular.isUndefined(cd))
						return false;
					else
						return cd.control == "CheckBox";
				};
				var columnasDefs = grid.columnDefs;
				var dataRespuestas = [];
				angular.forEach(array, function (value, key) {
					$log.log("array foreach", value, key);
					var dr = {};
					dr.id = value.id;
					dr.idioma = null;
					dr.id_ficha_tecnica = value.id_ficha_tecnica;
					dr.orden_bucle = value.orden_bucle;
					dr.orden_sub_bucle = value.orden_tab===0?0: (value.orden_tab || value.orden_sub_bucle);
					dr.orden_sub_sub_bucle = value.orden_tab2===0?0: (value.orden_tab2 || value.orden_sub_sub_bucle);
					dr.componente = value.componente;
					dr.valor = value.valor;
					dr.observaciones = value.observaciones;

					dr.sub_respuesta1 = value.sub_respuesta1;
					if (controlIsCheck(columnasDefs, 1)){
						if (dr.sub_respuesta1 === '1')
							dr.sub_respuesta1 = 1;
						else
							dr.sub_respuesta1 = 0;
					}

					dr.sub_respuesta2 = value.sub_respuesta2;
					if (controlIsCheck(columnasDefs, 2)){
						if (dr.sub_respuesta2 === '1')
						dr.sub_respuesta2 = 1;
					else
						dr.sub_respuesta2 = 0;
					}

					dr.sub_respuesta3 = value.sub_respuesta3;
					if (controlIsCheck(columnasDefs, 3)){
						if (dr.sub_respuesta3 === '1')
						dr.sub_respuesta3 = 1;
					else
						dr.sub_respuesta3 = 0;
					}

					dr.sub_respuesta4 = value.sub_respuesta4;
					if (controlIsCheck(columnasDefs, 4)){
						if (dr.sub_respuesta4 === '1')
						dr.sub_respuesta4 = 1;
					else
						dr.sub_respuesta4 = 0;
					}

					dr.sub_respuesta5 = value.sub_respuesta5;
					if (controlIsCheck(columnasDefs, 5)){
						if (dr.sub_respuesta5 === '1')
						dr.sub_respuesta5 = 1;
					else
						dr.sub_respuesta5 = 0;
					}

					dr.sub_respuesta6 = value.sub_respuesta6;
					if (controlIsCheck(columnasDefs, 6)){
						if (dr.sub_respuesta6 === '1')
						dr.sub_respuesta6 = 1;
					else
						dr.sub_respuesta6 = 0;
					}
					
					dr.sub_respuesta7 = value.sub_respuesta7;
					if (controlIsCheck(columnasDefs, 7)){
						if (dr.sub_respuesta7 === '1')
							dr.sub_respuesta7 = 1;
						else
							dr.sub_respuesta7 = 0;
					}

					dr.sub_respuesta8 = value.sub_respuesta8;
					if (controlIsCheck(columnasDefs, 8)){
						if (dr.sub_respuesta8 === '1')
							dr.sub_respuesta8 = 1;
						else
							dr.sub_respuesta8 = 0;
					}

					dr.sub_respuesta9 = value.sub_respuesta9;
					if (controlIsCheck(columnasDefs, 9)){
						if (dr.sub_respuesta9 === '1')
							dr.sub_respuesta9 = 1;
						else
							dr.sub_respuesta9 = 0;
					}

					dr.sub_respuesta10 = value.sub_respuesta10;
					if (controlIsCheck(columnasDefs, 10)){
						if (dr.sub_respuesta10 === '1')
							dr.sub_respuesta10 = 1;
						else
							dr.sub_respuesta10 = 0;
					}

					dr.sub_respuesta11 = value.sub_respuesta11;
					if (controlIsCheck(columnasDefs, 11)){
						if (dr.sub_respuesta11 === '1')
							dr.sub_respuesta11 = 1;
						else
							dr.sub_respuesta11 = 0;
					}

					dr.sub_respuesta12 = value.sub_respuesta12;
					if (controlIsCheck(columnasDefs, 12)){
						if (dr.sub_respuesta12 === '1')
							dr.sub_respuesta12 = 1;
						else
							dr.sub_respuesta12 = 0;
					}

					dr.sub_respuesta13 = value.sub_respuesta13;
					if (controlIsCheck(columnasDefs, 13)){
						if (dr.sub_respuesta13 === '1')
							dr.sub_respuesta13 = 1;
						else
							dr.sub_respuesta13 = 0;
					}

					dr.sub_respuesta14 = value.sub_respuesta14;
					if (controlIsCheck(columnasDefs, 14)){
						if (dr.sub_respuesta14 === '1')
							dr.sub_respuesta14 = 1;
						else
							dr.sub_respuesta14 = 0;
					}

					dr.bloqueado = value.bloqueado;
					//dr.contiene_info_etiquetado = false;
					dr.fecha_modif_valor = value.fecha_modif_valor;
					dr.fecha_modif_observaciones = value.fecha_modif_observaciones;
					dr.fecha_modif_sub_respuesta1 = value.fecha_modif_sub_respuesta1;

					dataRespuestas.push(dr);
				});

				//return DataRespuestas;
				$log.log("DataRespuestas",dataRespuestas);
				return dataRespuestas;
			};


			scope.edicionGridEnvase = function (cell) {
				var nivel = cell.row.entity["$$treeLevel"];
				//Puede ser nivel 0 o 1. El 0 es linea principal y 1 linea interna.
				//$log.log("Call edicionGridEnvase, row = " + cell.row.entity["orden_bucle"] + ", $$treeLevel = " + cell.row.entity["$$treeLevel"]);
				var celdas_editables = [];
				if (nivel == 0) {//Nivel principal se puede editar todo menos celdas calculadas 6 y 8.
					if (cell.row.entity["sub_respuesta3"] != "Si")
						celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3", "SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
					else
						celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3"];
				}
				else {
					celdas_editables = ["SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
				}
				if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1) {
					if (cell.row.entity.bloqueado || (cell.row.entity.editingCols && cell.row.entity.editingCols.indexOf(cell.col.colDef.name)>=0)) {
						return false;
					}
					else {
						return !scope.estaBloqueado(cell) && !((typeof(cell.col.colDef.noeditable) == "function") ? cell.col.colDef.noeditable(cell) : cell.col.colDef.noeditable);
					}
				} else {
					return false;
				}				
			};

			scope.buildGrid = function (respuestas) {
				scope.gridManualLoad = true;
				//var prop = scope.getUniqueID(0);
				var prop = scope.pregunta.pregunta.id_pregunta;
				if (scope.pregunta.pregunta.preguntar_componente) {
					if (angular.isUndefined(scope.contadorTablas)) {
						scope.contadorTablas = 0;
					}
					prop += "-" + scope.contadorTablas;
					scope.contadorTablas++;
				}

				var metadata = scope.getFakeMetadata();
				if (!scope.data.grids) {
					scope.data.grids = {};
				}
				var gridName = "grid" + prop;
				var strEl = "";

				if (!scope.data.grids[gridName]) {
					//scope.data.grids[gridName] = gridService.createGrid(scope, "testListado", {}, undefined);
					var lineasDefault = 3;
					if (angular.isDefined(respuestas)) {
						if (respuestas.length) {
							if (respuestas.length > 15)
								lineasDefault = 15;
							else
								lineasDefault = respuestas.length;
						}
					}

					var optionsGrid = { pruebaFT: true, checkboxTemplate: 'checkboxCellFT', minRowsToShow: lineasDefault,/* minRowsToShow: 100,*/ metadata: metadata, enableGridMenu: scope.tienePerfilAdmin(), isRowSelectable: scope.isRowSelectable, onCellEdit: ((!scope.preview) ? scope.guardarDatosGrid : undefined) };

					if (scope.modoTraduccion) {
						optionsGrid.rowTemplate = 'app/FTBase/views/ui-grid-row-ft.html';
						optionsGrid.checkColState = scope.checkColState;
						optionsGrid.getCustomHint = scope.getCustomHint;
					}

					var acciones = [];

					if (scope.tienePerfilAdmin()) {
						acciones.push({
							icon: "fa-lock",
							title: "Desbloquear",
							visible: function (entity) {
								return scope.tienePerfilAdmin() && entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
						acciones.push({
							icon: "fa-unlock",
							title: "Bloquear",
							visible: function (entity) {
								return scope.tienePerfilAdmin() && !entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
					}

					if (scope.esGridJerarquico()) {
						if (scope.pregunta.pregunta.bucle_subnivel_simple) {
							optionsGrid.showTreeExpandNoChildren = false;
							acciones.push({
								icon: "fa-plus",
								title: "Agregar elemento mismo nivel",
								visible: function (entity) {
									if (scope.tienePerfilRestringido()) return false;

									if (entity["$$treeLevel"] > 0) {
										var respuestas_sn = scope.pregunta.respuestas.filter(function(item){
											return item.orden_bucle === entity.orden_bucle;
										});
										var max_index = respuestas_sn.sort(function(a,b){
											return parseInt(b.orden_sub_bucle) - parseInt(a.orden_sub_bucle);
										});
										//$log.log("Add element same level - Visible function: ");
										//$log.log("Maximo: " + max_index[0].orden_sub_bucle);
										return (entity.orden_sub_bucle === max_index[0].orden_sub_bucle);
									} 
									else
										return false;
								},
								accion: function (entity, grid) {
									// var ftd = {};
									// ftd.id_ficha_tecnica = entity.id_ficha_tecnica;
									// ftd.id_pregunta = scope.pregunta.pregunta.id_pregunta;
									// ftd.orden_bucle = entity.orden_bucle;
									// ftd.marca = entity.marca;
									$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarElementoSubNivel/" + entity.id).then(function (response) {
										$log.log(response.data.obj.Record);
										var ftd = response.data.obj.Record;
										//ftd.idioma = null;
										ftd.orden_sub_bucle = ftd.orden_tab;
										ftd.orden_sub_sub_bucle = ftd.orden_tab2;

										grid.options.ixAddRow(ftd);
										scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
										$timeout(function () {
											grid.gridApi.core.refresh();
										}, 300);
									},
									function(error){
										$log.log("Error call AgregarElementoSubNivel");
										$log.log(error);
									});
								}
							});
							acciones.push({
								icon: "fa-trash",
								title: "Eliminar línea",
								visible: function(entity){
									return !entity.bloqueado && !scope.tienePerfilRestringido();
								},
								accion: function(entity, grid){
									var row = entity;
									$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarElementoTablaJerarquicaSimple/" + entity.id).then(function(response){
										scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
										$timeout(function () {
											grid.gridApi.core.refresh();
										}, 300);

									},
									function(error){
										$log.log("Call EliminarElementoTablaJerarquicaSimple Error:");
										$log.log(error);
										ixStatusService.setResponse(error);
									});
								}
							});
							acciones.push({
								icon: "fa-sort",
								title: "Ordenar filas",
								visible: function (entity) {
									return !scope.modoTraduccion && scope.status.editing && !entity.bloqueado && !scope.tienePerfilRestringido();
								},
								accion: function (entity) { return true; }
							});
						} else {
							optionsGrid.enableCellEdit = !scope.tienePerfilRestringido();
							optionsGrid.keepFocusOnAddRow = true;
							var columnValor = optionsGrid.metadata.find(function (e) { return e.Name == "valor"; });
							columnValor.NoEditable = true;	
							optionsGrid.showTreeExpandNoChildren = false;

							//TODO: Hacer push
							acciones.push({
								icon: "fa-sort",
								title: "Ordenar filas",
								visible: function (entity) {
									return !scope.modoTraduccion && scope.status.editing && !entity.bloqueado && !scope.tienePerfilRestringido(); 
								},
								accion: function (entity) { return true; }
							});
							acciones.push({
								icon: "fa-pencil",
								title: "Editar",
								visible: function (entity) {
									return !scope.tienePerfilRestringido() && ((scope.status.editing && !entity.bloqueado) || (scope.status.editing && scope.modoTraduccion));
								},
								accion: function (entity, grid) {
									scope.abrirPopupAlimentacion(entity, grid.options);
								}
							});
							acciones.push({
								icon: "fa-trash",
								title: "Eliminar",
								visible: function (entity) {
									return (scope.status.editing && !entity.bloqueado && !scope.modoTraduccion && !scope.tienePerfilRestringido());
								},
								accion: function (entity) {
									scope.eliminarIngrediente(entity, scope.data.grids[gridName]);
								}
							});
						}
						optionsGrid.afterDragRow = function (grid, item, from, to) {
							var nextItem = null;
							var bulkParam = {
								ToInsert: [],
								ToUpdate: [],
								ToDelete: []
							};

							var contador_primer_nivel = 1;
							var contador_segundo_nivel = 1;
							var contador_tercer_nivel = 1;

							angular.forEach(grid.data, function (row) {

								row.orden_bucle = contador_primer_nivel;
								var update = {
									PK: grid.buildPK(row),
									PocoToUpdate: [
										{
											value: row.orden_bucle,
											path: "/orden_bucle",
											op: "replace"
										}
									]
								}

								if (row["$$treeLevel"] == 0) {
									contador_primer_nivel++;
									if (contador_segundo_nivel > 1)
										contador_segundo_nivel = 1;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else if (row["$$treeLevel"] == 1) {
									row.orden_bucle--;
									row.orden_sub_bucle = contador_segundo_nivel;
									row.orden_tab = row.orden_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }];
									contador_segundo_nivel++;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else {
									row.orden_bucle--;
									row.orden_sub_bucle = (contador_segundo_nivel - 1);
									row.orden_tab = row.orden_sub_bucle;
									row.orden_sub_sub_bucle = contador_tercer_nivel;
									row.orden_tab2 = row.orden_sub_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }, { value: row.orden_sub_sub_bucle, path: "/orden_tab2", op: "replace" }];
									contador_tercer_nivel++;
								}

								bulkParam.ToUpdate.push(update);
							});

							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";

							$http.post(cfg.baseURL + tabla + "/UpdateBulk", bulkParam).then(function (response) {
								$log.log("After update bulk respuestas", response, respuestas);
							}, function (err) {
								$log.error("Error actualizando el orden de los ingredientes", err);
							});

						};

						if (scope.modoTraduccion)
							optionsGrid.rowTemplate = "app/FTBase/views/ui-grid-tree-row-traduccion.html";
						else
							optionsGrid.rowTemplate = "app/base/views/grid/ui-grid-tree-row.html";

						scope.addTreeLevel(respuestas);
					}

					scope.data.grids[gridName] = gridService.createGrid(scope, 'ft_preguntagrid_' + scope.pregunta.pregunta.id_pregunta, optionsGrid);

					scope.data.grids[gridName].entity = "extranet_fichas_tecnicas_det";
					scope.data.grids[gridName].filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica },{ Field: "marca", Operator: CMP_EQ, Value: 0 }];

					scope.data.grids[gridName].columnDefs = [];
					scope.data.grids[gridName].ixGetColsFromAPI();
					//if(scope.esGridJerarquico())
					if (acciones.length > 0)
						scope.data.grids[gridName].drawExtraColumns([{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }]);

				} else {
					scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
					scope.data.grids[gridName].ixRestoreConfig();
					scope.addTreeLevel(respuestas);
				}

				if (scope.pregunta.pregunta.bucle_subnivel_simple) {
					scope.data.grids[gridName].cellEditableCondition = scope.edicionGridEnvase;
				} else {
					// Bloqueamos la edición si hay alguna request peindiente en esa fila para la misma columna
					scope.data.grids[gridName].cellEditableCondition = function (cell) {
						if (cell.row.entity.bloqueado || (cell.row.entity.editingCols && cell.row.entity.editingCols.indexOf(cell.col.colDef.name)>=0)) {
							return false;
						}
						else {
							return !((typeof(cell.col.colDef.noeditable) == "function") ? cell.col.colDef.noeditable(cell) : cell.col.colDef.noeditable);
						}
					}					
				}

				if (scope.modoTraduccion && scope.soloPreguntasPdtTraduccion) {
					respuestas = scope.filtrarSoloPendientesTraduccion(respuestas);
				}

				if (respuestas.length > 0) {
					if (scope.data.grids[gridName].reloadData || ((angular.isDefined(scope.data.ToReload)) && scope.data.ToReload[scope.pregunta.pregunta.id_pregunta]))
						scope.data.grids[gridName].ixLoadInitialData().then(function (data) {
							scope.pregunta.respuestas = angular.copy(data);
							//scope.addTreeLevel(respuestas);
							scope.data.grids[gridName].reloadData = false;
							if (scope.data.ToReload) {
								if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
									scope.data.ToReload[scope.pregunta.pregunta.id_pregunta] = false;
							}
						});
					else
						scope.data.grids[gridName].data = respuestas.sort(function (a, b) {
							if (a.orden_bucle > b.orden_bucle) return 1;
							if (a.orden_bucle < b.orden_bucle) return -1;
							if (a.orden_sub_bucle > b.orden_sub_bucle) return 1;
							if (a.orden_sub_bucle < b.orden_sub_bucle) return -1;
							if (a.orden_sub_sub_bucle > b.orden_sub_sub_bucle) return 1;
							if (a.orden_sub_sub_bucle < b.orden_sub_sub_bucle) return -1;
							return 0;
						});

					if (scope.esGridJerarquico())
						scope.data.grids[gridName].ixRefreshGridDropDowns();

					ixUtilsService.showGrid(scope.data.grids[gridName]);

					var pregunta = "";

					if (scope.modoTraduccion) {
						pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
					else {
						pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}

					if (respuestas[0].componente)
						strEl += '<div ng-show="elComponenteEsVisible(\'' + respuestas[0].componente + '\')">';

					if ((!scope.modoTraduccion) && scope.pregunta.pregunta.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + '">';
					else if ((scope.modoTraduccion) && scope.pregunta.pregunta_idioma.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + '">';
					else
						strEl += '<span>';

					strEl += '<label>' + pregunta + ((scope.pregunta.pregunta.obligatoria) ? '<i class="fa fa-asterisk" style="color:red"></i>' : '') + '</label>';
					strEl += '</span>';

					strEl += '<div class="btn-toolbar" style="display:inline-block;float:right;">';

					//botones add/remove
					if (!scope.pregunta.pregunta.bloquear_borrar_b && !scope.esGridJerarquico())
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-danger pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="data.grids[\'' + gridName + '\'].gridApi.selection.getSelectedRows().length==0 || tienePerfilRestringido() || (modoTraduccion)" data-ng-click="deleteSelectedRows(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Eliminar registros seleccionados\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-trash-o"></i></button>';

					if (!scope.pregunta.pregunta.bloquear_insert_b)
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-primary pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="tienePerfilRestringido() || (modoTraduccion)" data-ng-click="addRow(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Nuevo\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-plus"></i></button>';

					//grid html
					// Establecemos el numdero de filas visibles igual a los datos que se mostrarán, para que no haya scroll en el grid.
					scope.data.grids[gridName].minRowsToShow= Math.max(scope.data.grids[gridName].data.length, 3) + 1;

					var styleHeight = "";

					// 3.2 COMPOSICION - Ingredientes : mostrar el grid a pantalla completa
					if(scope.pregunta.pregunta.id_pregunta==767  
						|| scope.pregunta.pregunta.id_pregunta==918
						|| scope.pregunta.pregunta.id_pregunta==1004
						|| scope.pregunta.pregunta.id_pregunta==1109
					) {  
						styleHeight = 'style="height: calc(100vh - 350px)"';
					}

					if (scope.esGridJerarquico())
						strEl += '</div><div class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate data-ui-grid-tree-view ui-grid-draggable-rows><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';
					else
						strEl += '</div><div class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';

					if (respuestas[0].componente)
						strEl += '</div>';

					/*} else {
						scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
						//scope.data.grids[gridName].ixRestoreConfig();
					}
					*/
					if (scope.esGridJerarquico()) {
						$timeout(function () {
							scope.data.grids[gridName].ixEditar();
						}, 0);
					}
				}

				scope.se_puede_visualizar = true;

				var el = $compile(strEl)(scope);
				return el;
			};

			scope.respuestasBloqueadas = function () {
				var respuestasBloqueadas = scope.pregunta.respuestas.filter(function (e) { return e.bloqueado; });
				return (scope.pregunta.respuestas.length == respuestasBloqueadas.length);
			};

			scope.actualizarRespuestas = function (data, componente, grid) {
				$log.log("actualizarRespuestas", data)
				var aux = scope.ajustarDataFromApi(data, grid);
				if (scope.pregunta.pregunta.preguntar_componente) {
					$log.log("actualizarRespuestas preguntar_componente")
					//Coger todas las preguntas del componente.
					var respuestasComponente = scope.pregunta.respuestas.filter(function (e) { return e.componente == componente; });
					if (respuestasComponente.length > 0) {
						var primerItemIdx = scope.pregunta.respuestas.indexOf(respuestasComponente[0]);
						scope.pregunta.respuestas.splice(primerItemIdx, respuestasComponente.length);

						for (var i = (aux.length - 1); i >= 0; i--) {
							scope.pregunta.respuestas.splice(primerItemIdx, 0, aux[i]);
						}

					} else {
						scope.pregunta.respuestas.push.apply(scope.pregunta.respuestas, aux);
					}
				}
				else {
					if (scope.pregunta.pregunta.bucle_subnivel_simple){
						angular.forEach(aux, function (respuesta) {
							respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
						});
					}

					scope.pregunta.respuestas = aux;
				}

			};


			scope.actualizarGridsSinComponente = function (idPregunta) {
				// var tmpGrid = scope.data.grids["grid" + idPregunta];
				var keyGrids = Object.keys(scope.data.grids).filter(function (e) { return e.indexOf("grid" + idPregunta) != -1; });

				angular.forEach(keyGrids, function (keyGrid) {
					var grid = scope.data.grids[keyGrid];
					if (angular.isDefined(grid)) {
						grid.reloadData = true;

						grid.ixLoadInitialData().then(function (data) {
							//var colDet = grid.columnDefs;
							scope.actualizarRespuestas(angular.copy(data), null, grid);
							scope.pregunta.respuestas = $filter('orderBy')(scope.pregunta.respuestas, ['orden_bucle', 'orden_sub_bucle']);
							grid.data = scope.pregunta.respuestas;
							
							$timeout(function(){
								grid.reloadData = false; //YVES: 07/02/2023
								if (grid.gridApi.treeBase){
									grid.gridApi.treeBase.expandAllRows();
								}
								grid.gridApi.core.refresh();
								ixUtilsService.showGrid(grid);
							},300);                                                
							
						});
					}
				});
			};

			scope.actualizarGrids = function (idPregunta, componente) {
				var keyGrids = Object.keys(scope.data.grids).filter(function (e) { return e.indexOf("grid" + idPregunta + "-") != -1; });

				if (angular.isDefined(componente)) {
					//Dejar en keyGrids solo elemento con el ID que toque.
					keyGrids = keyGrids.filter(function (elem) {
						return scope.data.grids[elem].data[0].componente == componente
					});
				}
				angular.forEach(keyGrids, function (keyGrid) {
					var componenteIdx = undefined;
					if (keyGrid.lastIndexOf("-") != -1)
						componenteIdx = keyGrid.substr(keyGrid.lastIndexOf("-") + 1);

					var grid = scope.data.grids[keyGrid];
					if (angular.isDefined(grid)) {
						grid.reloadData = true;
						//grid.data = [];


						if (componenteIdx) {
							var fComponente = grid.filtroExterno.find(function (e) { return e.Field == "componente"; });
							if (angular.isUndefined(fComponente))
								grid.filtroExterno.push({ Field: "componente", Operator: CMP_EQ, Value: scope.$parent.componentesRespuestas[componenteIdx].nombre });
						}

						grid.ixLoadInitialData().then(function (data) {
							var componente = undefined;
							if (scope.$parent.componentesRespuestas && componenteIdx)
								componente = scope.$parent.componentesRespuestas[componenteIdx];

							scope.actualizarRespuestas(angular.copy(data), componente, grid);
						});
					}
				});
			};

			scope.addRow = function (grid) {
				if (!scope.preview) {
					var data = {
						id_ficha_tecnica: scope.pregunta.respuestas[0].id_ficha_tecnica,
						id_pregunta: scope.pregunta.pregunta.id_pregunta,
						
						componente: grid.data[0].componente
					};

					if (scope.esGridJerarquico() && !scope.pregunta.pregunta.bucle_subnivel_simple) {
						scope.abrirPopupAlimentacion(data, grid, true);
					}
					else {
						$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", data).then(function (response) {
							grid.ixAddRow(response.data.obj.Record);
							//YVES: ¿Como Copiar datos recibidos?
							if (scope.esGridJerarquico() && scope.pregunta.pregunta.bucle_subnivel_simple) {
								scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
								$timeout(function () {
									grid.gridApi.treeBase.expand.expandAllRows();
									grid.gridApi.core.refresh();
								}, 300);
							}
							else {
								scope.actualizarRespuestas(grid.data, data.componente, grid);
								$timeout(function () {
									grid.gridApi.core.refresh();
								}, 300);
							}
							$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: scope.pregunta.pregunta, tipo_modificacion: "Add" });
						}, function (err) {
							ixStatusService.setResponse(err);
						});
					}
				} else {
					grid.ixAddRow();
				}
			};

			scope.deleteRow = function (param) {
				var row = param.row;
				var grid = param.grid;
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: [row]
					};

					$http.delete(cfg.baseURL + "extranet_fichas_tecnicas_det/" + row.id).then(function (response) {
						var indexDeletedRow = grid.data.indexOf(row);
						if (indexDeletedRow != grid.data.length - 1) {
							if (row["$$treeLevel"] == 0) {
								var subingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 1 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow) e.orden_bucle--;
								});
							}
							else if (row["$$treeLevel"] == 1) {
								var subsubingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 2 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle == row.orden_sub_bucle && e.orden_sub_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subsubingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle) {
										if (angular.isDefined(e.orden_tab)) {
											e.orden_tab--;
											e.orden_sub_bucle = e.orden_tab;
										}
										if (angular.isDefined(e.orden_sub_bucle)) {
											e.orden_sub_bucle--;
											e.orden_tab = e.orden_sub_bucle;
										}
									}
								});
							}
							else { //row.$$treeLevel == 2
								grid.data.splice(indexDeletedRow, 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle && ((e.orden_sub_bucle == row.orden_sub_bucle) || (e.orden_tab == row.orden_tab2))) {
										if (angular.isDefined(e.orden_tab2)) {
											e.orden_tab2--;
											e.orden_sub_sub_bucle = e.orden_tab2;
										}
										if (angular.isDefined(e.orden_sub_sub_bucle)) {
											e.orden_sub_sub_bucle--;
											e.orden_tab2 = e.orden_sub_sub_bucle;
										}
									}
								});
							}
						}
						else {
							grid.data.splice(indexDeletedRow, 1);
						}

						if (grid.data.length == 0) {
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid)
						}
						grid.ixDeleteSelectedRows();
						$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: response.data.obj.Record, tipo_modificacion: "Delete" });
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}

			};
			scope.deleteSelectedRows = function (grid) {
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: grid.gridApi.selection.getSelectedRows()
					};

					$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkParam).then(function (response) {
						grid.ixDeleteSelectedRows();

						if (grid.data.length == 0) {
							//							grid.entity = "extranet_fichas_tecnicas_det";
							//							grid.filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica } ];
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid)
						}
						
						$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: response.data.Deleted[0].Record, tipo_modificacion: "Delete" });
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}
			};

			//GRID FIN

			//FUNCIONES POR COMPONENTES
			scope.showDetails = function (evt) {
				var textoComponenteClick = evt.target.innerHTML;

				scope.$parent.componentesRespuestas.forEach(function (panel) {
					panel.visible = false;
				});

				var panelComponente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == textoComponenteClick; });

				var contentTarget = angular.element(evt.currentTarget).parent().find("div.content");
				if (contentTarget.hasClass("visible")) {
					contentTarget.removeClass("visible");
					panelComponente.visible = false;
				}
				else {
					angular.element(angular.element(angular.element(evt.currentTarget).parent()).parent()).children().children().removeClass("visible");
					contentTarget.addClass("visible");
					panelComponente.visible = true;
				}
			};
			//FIN FUNCIONES POR COMPONENTES

			scope.getComponentesRespuestas = function () {
				if (angular.isUndefined(scope.pregunta.panelesComponentes)) {
					scope.pregunta.panelesComponentes = [];
				}
				angular.forEach(scope.pregunta.respuestas, function (respuesta, idx) {
					var existe = scope.pregunta.panelesComponentes.find(function (e) { return e.nombre == respuesta.componente; });
					if (angular.isUndefined(existe)) {
						var panelComponente = { nombre: respuesta.componente, visible: ((idx == 0) ? true : false) };
						scope.pregunta.panelesComponentes.push(panelComponente);
					}
				});

				return scope.pregunta.panelesComponentes;
			};

			scope.elComponenteEsVisible = function (nombre) {
				var esVisible = false;

				if (angular.isDefined(scope.$parent.componentesRespuestas)) {
					var componente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == nombre; });
					esVisible = componente.visible;
				}
				return esVisible;
			};

			scope.createPanels = function () {
				scope.$parent.componentesRespuestas = scope.getComponentesRespuestas();

				angular.forEach(scope.$parent.componentesRespuestas, function (componente, idx) {
					var accordion = "";
					if (scope.preview) {
						accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente A</div><div class="content detalles"></div></div>';
						elem.append($compile(accordion)(scope));

					} else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 0) {
						//Creamos el accordion cuando no exista.
						accordion = '<div id="componente' + scope.quitarespacios(componente.nombre) + '" class="card"><div class="title" ng-click="showDetails($event)">' + componente.nombre + '</div><div class="content detalles';
						if (idx == 0)
							accordion += ' visible';

						accordion += '"><div></div></div></div>';
						elem.append($compile(accordion)(scope));
					}
				});
			};

			scope.quitarespacios = function (componente) {
				var remplazado = componente.split(" ").join("_").split(".").join("_");

				return remplazado;
			};

			scope.divComponente = function () {
				//return "div.content";
				return "div.content > div";
			};

			scope.createPreguntas = function (elem) {

				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (scope.pregunta.pregunta.preguntar_componente) {
					angular.forEach(scope.$parent.componentesRespuestas, function (componente) {
						var containerComponent;
						if (scope.preview)
							containerComponent = elem.find("div.card > " + scope.divComponente());
						else
							if (angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());
							else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());

						if (angular.isUndefined(scope.pregunta.respuestasComponentes))
							scope.pregunta.respuestasComponentes = {};

						var respuestasComponente = scope.pregunta[respuestasProperty].filter(function (e) { return e.componente == componente.nombre; });

						if (scope.modoTraduccion) {
							//Estamos en un grid, si la columna no es traducible, mostaremos el valor original.
							respuestasComponente = scope.rellenarNoTraducibles(respuestasComponente);
						}

						scope.pregunta.respuestasComponentes[componente.nombre] = respuestasComponente;

						scope.createPregunta(scope.pregunta.respuestasComponentes[componente.nombre], containerComponent);
					});
					scope.createPreviewComponentes();
				} else {
					if (scope.modoTraduccion && scope.pregunta.pregunta.bucle == 1) {
						scope.pregunta.respuestas_idioma = scope.rellenarNoTraducibles(scope.pregunta.respuestas_idioma);
					}
					scope.createPregunta(scope.pregunta[respuestasProperty], elem);
				}
			};

			scope.rellenarNoTraducibles = function (respuestasComponente) {
				angular.forEach(respuestasComponente, function (respuesta) {

					var respuesta_original = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id; });

					if (!respuesta.valor && !scope.pregunta.pregunta.traducible) {
						respuesta.valor = respuesta_original.valor;
					}
					if (!respuesta.sub_respuesta1 && !scope.pregunta.pregunta.sub_pregunta1_traducible) {
						respuesta.sub_respuesta1 = respuesta_original.sub_respuesta1;
					}
					if (!respuesta.sub_respuesta2 && !scope.pregunta.pregunta.sub_pregunta2_traducible) {
						respuesta.sub_respuesta2 = respuesta_original.sub_respuesta2;
					}
					if (!respuesta.sub_respuesta3 && !scope.pregunta.pregunta.sub_pregunta3_traducible) {
						respuesta.sub_respuesta3 = respuesta_original.sub_respuesta3;
					}
					if (!respuesta.sub_respuesta4 && !scope.pregunta.pregunta.sub_pregunta4_traducible) {
						respuesta.sub_respuesta4 = respuesta_original.sub_respuesta4;
					}
					if (!respuesta.sub_respuesta5 && !scope.pregunta.pregunta.sub_pregunta5_traducible) {
						respuesta.sub_respuesta5 = respuesta_original.sub_respuesta5;
					}
					if (!respuesta.sub_respuesta6 && !scope.pregunta.pregunta.sub_pregunta6_traducible) {
						respuesta.sub_respuesta6 = respuesta_original.sub_respuesta6;
					}
					if (!respuesta.sub_respuesta7 && !scope.pregunta.pregunta.sub_pregunta7_traducible) {
						respuesta.sub_respuesta7 = respuesta_original.sub_respuesta7;
					}
					if (!respuesta.sub_respuesta8 && !scope.pregunta.pregunta.sub_pregunta8_traducible) {
						respuesta.sub_respuesta8 = respuesta_original.sub_respuesta8;
					}
					if (!respuesta.sub_respuesta9 && !scope.pregunta.pregunta.sub_pregunta9_traducible) {
						respuesta.sub_respuesta9 = respuesta_original.sub_respuesta9;
					}
					if (!respuesta.sub_respuesta10 && !scope.pregunta.pregunta.sub_pregunta10_traducible) {
						respuesta.sub_respuesta10 = respuesta_original.sub_respuesta10;
					}
					if (!respuesta.sub_respuesta11 && !scope.pregunta.pregunta.sub_pregunta11_traducible) {
						respuesta.sub_respuesta11 = respuesta_original.sub_respuesta11;
					}
					if (!respuesta.sub_respuesta12 && !scope.pregunta.pregunta.sub_pregunta12_traducible) {
						respuesta.sub_respuesta12 = respuesta_original.sub_respuesta12;
					}
					if (!respuesta.sub_respuesta13 && !scope.pregunta.pregunta.sub_pregunta13_traducible) {
						respuesta.sub_respuesta13 = respuesta_original.sub_respuesta13;
					}
					if (!respuesta.sub_respuesta14 && !scope.pregunta.pregunta.sub_pregunta14_traducible) {
						respuesta.sub_respuesta14 = respuesta_original.sub_respuesta14;
					}
				});
				return respuestasComponente;
			}

			/*
			scope.agregarPropiedadesNecesariasComponente = function(trad, original){
				trad.orden_bucle = original.orden_bucle;
				trad.orden_sub_bucle = original.orden_sub_bucle;
				trad.orden_sub_sub_bucle = original.orden_sub_sub_bucle;
				trad.componente = original.componente;
			};
			*/

			scope.createPreviewComponentes = function () {
				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 1;
					elem = elem.parent().parent();

					var accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente B</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);


					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}

				}

				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 2;
					elem = elem.parent().parent();

					accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente C</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);


					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}
				}
			};

			scope.switchBloqueado = function (bloqueado) {
				if (bloqueado)
					bloqueado = 0;
				else
					bloqueado = 1;
				return bloqueado;
			};

			scope.changeLock = function () {

				scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: scope.pregunta.respuestas[0].bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + scope.pregunta.respuestas[0].id, data).then(function (response) {

				}, function (err) {
					scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				});
			};

			scope.changeLockGrid = function (entity) {
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: entity.bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

				}, function (err) {
					entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
				});
			};

			scope.addAdjuntarFichero = function () {
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '<a class="btn btn-primary" role="button" data-ng-click="openPopupFicheros(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', \'ficheros_ft\')" uib-tooltip="{{ \'Subir fichero\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-upload"></i></a>';
				var el = $compile(strEl)(scope);

				if (elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs))
					lastDiv.append(el);
				else
					lastDiv.after(el);
			};


			scope.addDependenciaEtiquetado = function (esComponente, elem_componente, esBucle) {
				var lastDiv = undefined;
				if (esComponente){
					lastDiv = elem_componente.children("div").eq(elem_componente.children("div").length - 1);
					if (esBucle)
						lastDiv = lastDiv.children("div").eq(lastDiv.children("div").length - 1);
				}
				else
					lastDiv = elem.children("div").eq(elem.children("div").length - 1);

				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '';

				//En caso se trate de un componente recupero la descripción
				var desc_componente = undefined;
				if (angular.isDefined(elem_componente)){
					//desc_componente = elem_componente.selector.replace("div#componente","").replace(" > div.content > div","").trim();
					//desc_componente = "'" + desc_componente + "'";
					desc_componente = "'" + elem_componente.parent().prev().text() + "'";
				}

				if (scope.modoTraduccion) {
					var pregunta_formulario = scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta_formulario;
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tieneLlamadasPendientes(pregunta.respuestas[0].id,\'button\') || (!pregunta.pregunta.traducible)" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ',\'' + scope.pregunta.respuestas_idioma[0].idioma + '\',' + desc_componente + ')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';
				}
				else
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tieneLlamadasPendientes(pregunta.respuestas[0].id,\'button\')" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + scope.pregunta.pregunta.pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ',undefined,' + desc_componente + ')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';

				var el = $compile(strEl)(scope);

				if ((elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs)) || (esComponente && !esBucle))
					lastDiv.append(el);
				else {
					if (scope.pregunta.pregunta.bucle)
						lastDiv.before(el);
					else
						lastDiv.after(el);
				}

			};

			scope.addLockAction = function (elem) {
				//El icono de bloquear/desbloquear lo pondremos al final de la pregunta.
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = "<i class='fa' ng-click='changeLock()' ng-attr-title='{{pregunta.pregunta.pregunta || pregunta.pregunta.pregunta_formulario}}' ng-class='{ \"fa-lock\": pregunta.respuestas[0].bloqueado, \"fa-unlock\": !pregunta.respuestas[0].bloqueado }' aria-hidden='true' ";

				strEl += " style='right: 5px;top: 6px;position: absolute;' ";

				strEl += "></i>";
				var el = $compile(strEl)(scope);
				lastDiv.append(el);
			};

			scope.tienePerfilAdmin = function () {
				return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
			};

			scope.tienePerfilRestringido = function () {
				var perfilRestringido = false;
				var perfilesUsuario = authService.perfilesUsuario();

				var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

				angular.forEach(perfilesUsuario, function (perfil) {
					if (perfilesRestringidos.indexOf(perfil) != -1)
						perfilRestringido = true;
				});

				return perfilRestringido;
			};

			scope.tieneLlamadasPendientes = function (idRespuesta, tag) {
				if(tag=='ix-select-ft') {
					return; // Para los ix-select-ft no miramos si tiene llamadasPendientes para que no se haga un disabled, ya que le hace perder el focus y luego el ix-focus-out que graba el valor no se ejecuta
				}
				return authInterceptorService.tieneLlamadasPendientes(cfg.baseURL + "extranet_fichas_tecnicas_det/" + idRespuesta);
			};

			scope.createPregunta = function (respuestas, elem) {
				//&& scope.pregunta.pregunta.bucle == 0 (AGREGADO POR YVES)
				if (scope.hayQueRecargarPregunta()) {
					var param = buildIxSearch();
					param.Filters.push({ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta });
					param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica });

					$http.post(cfg.baseURL + "ft_data/GetRespuestas", param).then(function (response) {
						scope.pregunta.respuestas = response.data;
						if (angular.isDefined(respuestas))
							respuestas = scope.pregunta.respuestas;

						scope.montarControlPreguntas(respuestas, elem);
					});
				} else {
					scope.montarControlPreguntas(respuestas, elem);
				}
			};

			scope.hayQueRecargarPregunta = function () {
				var recargar = false;
				if (angular.isDefined(scope.data.ToReload)) {
					if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
						recargar = true;
				}
				return recargar;
			};

			scope.montarControlPreguntas = function (respuestas, elem) {
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				if (scope.pregunta.pregunta.nota_pregunta) {
					if (scope.modoTraduccion)
						elem.append("<h5><b>" + scope.pregunta.pregunta_idioma.nota_pregunta + "</b></h5>");
					else
						elem.append("<h5><b>" + scope.pregunta.pregunta.nota_pregunta + "</b></h5>");
				}

				if (scope.pregunta.pregunta.bucle) {
					//TODO: Gestionar dependencia etiquetado
					/*
					if (scope.pregunta.pregunta.dependencia_etiquetado){
						//TODO: montar tabs
						elem.append("<uib-tabset class='ix-tabs no-margin-bottom' active='0'>");
						elem.append("<uib-tab index='0' heading='Marca Común' select='changeTab(0)'>");
						elem.append(scope.buildGrid(respuestas));
						elem.append("</uib-tab");
						elem.append("</uib-tabset>");
					}
					else {
						elem.append(scope.buildGrid(respuestas));
					}
					*/
					elem.append(scope.buildGrid(respuestas));
					if (scope.pregunta.pregunta.dependencia_etiquetado){
						scope.addDependenciaEtiquetado(scope.pregunta.pregunta.preguntar_componente, (scope.pregunta.pregunta.preguntar_componente ? elem : undefined),scope.pregunta.pregunta.bucle);
					}
						
				}
				else {
					scope.num_subpreguntas = scope.cuentaSubPreguntas();
					angular.forEach(respuestas, function (respuesta) {
						var idx = scope.pregunta[respuestasProperty].indexOf(respuesta);

						if (!scope.inPopup) {
							if (scope.pregunta.pregunta.tiene_imagen)
								elem.append(scope.buildControlImg(idx));
							else
								elem.append(scope.buildControl(idx));
						}

						if (scope.num_subpreguntas > 0) {
							scope.buildControlSubPreguntas(idx);
						}
					});

					//Aplica sólo en preguntas simples
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs(0));
					}

					//Aplica sólo en preguntas simples
					if (scope.pregunta.pregunta.adjuntar_fichero && !scope.preview)
						scope.addAdjuntarFichero();

					//Para preguntas bucle se gestiona de manera diferente
					if (scope.pregunta.pregunta.dependencia_etiquetado /*&& scope.se_puede_visualizar */)
						scope.addDependenciaEtiquetado(scope.pregunta.pregunta.preguntar_componente,(scope.pregunta.pregunta.preguntar_componente ? elem : undefined),scope.pregunta.pregunta.bucle);
				}

				if (!scope.pregunta.pregunta.bucle) {
					if (scope.tienePerfilAdmin() && !scope.inPopup && !scope.soloPreguntasPdtTraduccion)//Mirar si el usuario tiene perfil de ixnet y solo llamar la función si es así.
						scope.addLockAction(elem);
				}
			};

			//Creamos los controles necesarios:
			if (scope.pregunta.pregunta.preguntar_componente) {
				scope.createPanels();
			}
			scope.createPreguntas(elem);
		}
	}
}]);

angular.module('FTBase').directive('ftNzToggle', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=?',
			name: '@',
			icono: '@?',
			ngDisabled: '=?',
			textMaxWidth: '=?',
			ngDefault: '=?',
			afterClick: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		link: function (scope, elem, attrs) {
			scope.prop = attrs.ixFocusOutParam;
			scope.idx = attrs.ixFocusOutParamIdx;
			scope.changeSelected = function () {
				if (scope.afterClick) {
					$timeout(function () {
						scope.afterClick({ data: { prop: scope.prop, idx: scope.idx } });
					}, 0);
				}
			}
		},
		templateUrl: 'app/FTBase/views/ftNzToggle.html'
	};
}]);

angular.module('FTBase').directive('ftTitulo', [function () {
	return {
		restrict: 'E',
		scope: {
			item: '='
		},
		templateUrl: 'app/FTBase/views/ftTitulo.html'
	}
}]);

//Controles FT (no se traducen usando el sistema de traducciones de GestPark)
angular.module('FTBase').directive('ixTextFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		transclude: true,
		scope: {
			ngModel: '=',
			ngModel2: '=?',
			ngRequired: '=',
			name: '@',
			ngDisabled: '=?',
			ngValue: '=?',
			ngPlaceholder: '@?',
			isFilter: '=?',
			cleanSpecialChars: '&?',
			maxLength: '=?',
			maxLength2: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		templateUrl: 'app/FTBase/views/ixTextFt.html',
		link: function (scope, elem, attrs, ctrl) {
			if (!ctrl) return;

			if (angular.isDefined(scope.cleanSpecialChars)) {
				scope.$watch('ngModel', function (newValue, oldValue) {
					if (newValue != oldValue) {
						scope.ngModel = scope.cleanSpecialChars()(newValue);
					}
				});
			}
			var input = angular.element(elem.find('input')[0]);
			var inputModelCtrl = input.controller('ngModel');

			if (angular.isDefined(inputModelCtrl)) {
				//El formatter del ixNumber modifica el valor que apareix en pantalla.
				//Per tant, si hi ha validació de maxlength, aquesta donaria error sempre que el numero contingui separador de milers.
				if (angular.isDefined(attrs.maxLength) && angular.isDefined(attrs.ixNumber)) {
					inputModelCtrl.$validators.maxlength = function (modelValue, viewValue) {
						if (angular.isDefined(modelValue) && modelValue != null) {
							var withoutSeparators = modelValue.replace(/\./g, '');
							withoutSeparators = withoutSeparators.replace(/\,/g, '');
							return withoutSeparators.length <= scope.maxLength;
						}
					};
				}
			}
		}
	};
}]);

angular.module('FTBase').directive('ixDateFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=',
			name: '@',
			dateLimit: '=?',
			dateMin: '=?',
			ngDisabled: '=',
			appendToBody: '=?',
			oneLineText: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		templateUrl: 'app/FTBase/views/ixDateFt.html'
	};
}]);

angular.module('FTBase').directive('ixOptionsSiNoFt', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=?',
			name: '@',
			ngDisabled: '=?',
			textMaxWidth: '=?',
			ngDefault: '=?',
			afterClick: '=?'
		},
		link: function (scope, elem, attrs) {
			$timeout(function () {
				var label = angular.element(elem.find('label')[0]);
				label.on('click', function (e) {
					if (e.target !== e.currentTarget) return;
					e.preventDefault();
				});
			}, 1);
		},
		controller: ['$scope', function ($scope) {
			if (angular.isDefined($scope.ngDefault)) {
				if (!angular.isFunction($scope.ngDefault)) {
					$scope.ngModel = $scope.ngDefault;
				} else {
					//En cas de que el default sigui una etiqueta de config s'executarà una funció que ha d'estar definida al controller de la pantalla.
					$scope.ngDefault().then(function (result) {
						$scope.ngModel = result;
						$scope.ngDefault = result;
					});
				}
			}
			if (isNaN($scope.ngModel)) {
				$scope.ngModel = 0;
			}

			$scope.changeSelected = function () {
				$scope.ngModel = (($scope.ngModel == 1) ? 0 : 1);
				if ($scope.afterClick) {
					$timeout(function () {
						$scope.afterClick($scope.ngModel);
					}, 0);
				}
			}

			$scope.$watch("ngModel", function (value) {
				//Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
				if (angular.isUndefined(value) && angular.isDefined($scope.ngDefault)) {
					$scope.ngModel = $scope.ngDefault;
				} else {
					if (isNaN($scope.ngModel)) {
						$scope.ngModel = 0;
					}
					else if (typeof $scope.ngModel == "boolean") {
						$scope.ngModel == true ? $scope.ngModel = 1 : $scope.ngModel = 0;
					}
					$scope.estaSeleccionado = angular.copy($scope.ngModel);
				}
				return $scope.ngModel;
			});
		}],
		templateUrl: 'app/FTBase/views/ixOptionsSiNoFt.html'
	};
}]);

angular.module('FTBase').directive('ixSelectFt', [function () {
	return {
		restrict: 'E',
		//require: '?ngModel',
		scope: {
			entity: '@',
			pk: '@',
			desc: '@',
			extraField: '@?',
			filterFields: '=?',
			ngModel: '=',
			name: '@',
			preload: '=?',
			ngDisabled: '=',
			ngRequired: '=',
			conditions: '=?',
			loadFunction: '=?',
			ngDefault: '=?',
			//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
			wholeObj: '=?',
			orderStringAsInt: '=?',
			//permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
			editableDropdown: '=?',
			allowCustomPriority: '=?',
			//Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
			preloadFunction: '=?',
			//
			preloadObj: '@?',
			//La pk no sempre s'ha de dir igual que la del viewmodel.
			preloadPk: '@?',
			//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
			loadAllItems: '=?',
			//Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
			appendToBody: '=?',
			//Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
			entityData: '=?',
			entityDataPk: '@?',
			entityDataDesc: '@?',
			oneLineText: '=?',
			onSelect: '=?',
			template: '@?',
			skipTableNameFilter: '=?',
			skipTableNameOrderBy: '=?',
			labelClass: '@?',
			inputClass: '@?',
			keepOriginalValue: '=?'
		},
		//controller: 'ixSelectController',
		templateUrl: 'app/FTBase/views/ixSelect2Ft.html'/*,
					link: function(scope, elem, attrs){
						if(!scope.allItems)
							scope.allItems = [];

						scope.$watch('wholeObj', function(newVal, oldVal){
							console.log("wholeObj updated");
						});
					}*/
	};
}]);

angular.module('FTBase').directive('ixSelectMultipleFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			entity: '@',
			pk: '@',
			desc: '@',
			extraField: '@?',
			ngModel: '=',
			name: '@',
			preload: '=?',
			ngDisabled: '=',
			ngRequired: '=',
			conditions: '=?',
			loadFunction: '=?',
			limitTo: '=?',
			ngDefault: '=?',
			//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
			wholeObj: '=?',
			orderStringAsInt: '=?',
			//permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
			editableDropdown: '=?',
			//Aquesta serà una funció que carregui un viewmodel sencer. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
			preloadFunction: '=?',
			//La pk no sempre s'ha de dir igual que la del viewmodel.
			preloadPk: '@?',
			//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
			loadAllItems: '=?',
			//Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
			appendToBody: '=?',
			skipTableNameFilter: '=?',
			labelClass: '@?',
			inputClass: '@?',
			keepOriginalValue: '=?'
		},
		controller: 'ixSelectMultipleController',
		templateUrl: 'app/FTBase/views/ixSelectMultipleFt.html'
	};
}]);

angular.module('FTBase').directive('ixTextAreaFt', ['$compile', '$timeout', function ($compile, $timeout) {
	return {
		restrict: 'E',
		scope: {
			ngModel: '=',
			ngRequired: '=',
			name: '@',
			ngClass: '@?',
			ngDisabled: '=?',
			maxLength: '=?',
			rows: '@?',
			cols: '@?',
			labelClass: '@?',
			inputClass: '@?',
			placeholder: '@?',
			customHint: '@?',
			traducible: '=?',
			confirmado: '=?'
		},
		templateUrl: 'app/FTBase/views/ixTextAreaFt.html',
		link: function (scope, element, attrs) {

			scope.$on("focusOut", function () {
				scope.hasFocus = false;
			});

			scope.showCustomHint = function (ev) {
				if (scope.traducible) {
					scope.hasFocus = true;
					var auxElement = angular.element(element).find("textarea");
					if (angular.element(auxElement).parent().find("ix-custom-hint-ft").length == 0) {
						//auxElement.append("<ix-custom-hint-ft value='customHint'></ix-custom-hint-ft>");//Esto servira para poner el icono.
						auxElement.before($compile("<ix-custom-hint-ft ng-if='hasFocus' value='customHint'></ix-custom-hint-ft>")(scope));
					}
				}
			};

			scope.$on("CopiarValorHint", function () {
				scope.ngModel = scope.customHint;
			});

			$timeout(function () {
				var textareaElement = angular.element(element.find("textarea")[0]);
				scope.oldHeight = textareaElement[0].offsetHeight;
				textareaElement.on("mousemove", function () {
					var textareaElement = angular.element(element.find("textarea")[0]);
					var actualHeight = textareaElement[0].offsetHeight;
					if (scope.oldHeight != actualHeight) {
						scope.changedTextAreaHeight = true;
						scope.oldHeight = actualHeight;
					}
				});
				textareaElement.on("mouseup", function () {
					if (scope.changedTextAreaHeight) {
						scope.hasFocus = false;
						$timeout(function () {
							scope.hasFocus = true;
						});
					}
				});
			});
		}
	};
}]);

angular.module('FTBase').directive('ixCustomHintFt', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		scope: {
			value: '=?',
			valueGrid: '@?',
			onCopyValue: '=?',
			row: '=?',
			col: '=?'
		},
		templateUrl: 'app/FTBase/views/ixCustomHintFt.html',
		link: function (scope, elem, attrs) {

			scope.calculateTop = function () {
				$timeout(function () {
					var height = angular.element(elem).parent().children("textarea")[0].offsetHeight;
					var calculatedTop = (height) + (2);
					var css = {};
					css["position"] = "fixed";
					css["margin-top"] = calculatedTop + 'px';
					css["z-index"] = '999';
					elem.css(css);
				});
			};

			scope.calculateMarginTop = function () {
				var height = angular.element(elem)[0].offsetHeight;
				var calculatedTop = scope.row.height;
				var css = {};
				css["margin-top"] = calculatedTop + 'px';
				elem.css(css);
			};

			if (angular.isDefined(scope.value)) {
				scope.calculateTop();
			} else if (angular.isDefined(scope.valueGrid)) {
				scope.calculateMarginTop();
			}

			scope.copiarValorHint = function () {
				if (angular.isDefined(scope.onCopyValue))
					scope.onCopyValue(scope.row, scope.col, scope.valueGrid);
				else
					scope.$emit("CopiarValorHint");
			};
		}
	};
}]);

angular.module('FTBase').directive('autosize', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function (scope, elem, attrs) {
			var autosize = function () {
				//angular.element(elem)[0].style.cssText = 'width: 100%; height: auto; overflow: hidden; padding:0';
				$timeout(function () {
					var height = angular.element(elem)[0].scrollHeight + 2;
					if(height<26) {
						height = 26;
					} 
					angular.element(elem)[0].style.height = height + 'px';
					angular.element(elem)[0].style.maxHeight = '25vh';
				}, 1);
			};
			elem.on('keyup', function (e) {
				autosize();
			});
			autosize();
		}
	}
}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBase').controller('PlantasPopupController', ['$scope', '$uibModalInstance', 'gridService', 'ixStatusService', '$http', 'cfg', '$timeout', '$q', 'ixUtilsService', 'authService', function ($scope, $uibModalInstance, gridService, ixStatusService, $http, cfg, $timeout, $q, ixUtilsService, authService) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.planta = $scope.$resolve.clickedItem;
	$scope.data.planta_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.data.fabricante = $scope.$resolve.fabricante;
	$scope.data.planta.fabricante = $scope.data.fabricante.fabricante;
	$scope.isNew = $scope.$resolve.isNew;
	$scope.gridManualLoad = true;

	$scope.es_proveedor = true;
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_proveedor"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.$resolve.extranetUser.cliente && !$scope.$resolve.bloqueado)
		$scope.status.editing = true;

	$scope.addFicheros = function (){
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_proveedor": $scope.data.fabricante.proveedor, "grupo": "PLANTA", fabricante: $scope.data.fabricante.fabricante, planta: $scope.data.planta.planta };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			$scope.data.gridCertificadosPlanta.ixLoadInitialData();
		});
	};

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	//GRID CERTIFICADOS PLANTA
	if (!$scope.data.gridCertificadosPlanta) {
		var accionesCertificados = [
			{
				title: "Previsualizar PDF",
				icon: "fa-file-pdf-o",
				visible: function (entity) {
					return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
				},
				accion: function (entity){
					var tabla = "proveedores_ficheros";
					$http({
						method: 'post',
						url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
						headers: {},
						responseType: 'arraybuffer'
					}).then(function (r) {
						$scope.selectedPDF = new Uint8Array(r.data);
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: "Previsualizar Imagen",
				icon: "fa-file-image-o",
				visible: function (entity) {
					return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
				},
				accion: function (entity){
					var tabla = $scope.getEntity();
					$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r){
						$scope.selectedImage = r.data;
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
					function (err) {
						ixStatusService.setResponse(err);
					});
				}
			},
			{
				title: "Descargar fichero",
				icon: "fa-download",
				visible: function (entity) {
					return entity.archivo;
				},
				accion: function(entity){
				 	$scope.downloadFile(entity.id);
			 	}
			}
		];

		var metadata = [
			// { Name: "descripcion_actividad", NoVisible: true },
			// { Name: "baja", NoVisible: true },
			// { Name: "fecha_alta", NoVisible: true },
			// { Name: "fecha_baja", NoVisible: true },
			// { Name: "homologada", NoVisible: true },
			// { Name: "fecha_homologacion", NoVisible: true },
			// { Name: "certificacion_brc", NoVisible: true },
			// { Name: "certificacion_ifs", NoVisible: true }
		];

		$scope.data.gridCertificadosPlanta = gridService.createGrid($scope, 'gnet_grid_certificados_planta', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "num_certificado", "certificadora", "fecha_caducidad", "inicio_validez", "alcance"] }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: accionesCertificados }]);
		$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
		$scope.data.gridCertificadosPlanta.ixLoadInitialData();
	}
	else {
		$scope.data.gridCertificadosPlanta = gridService.createGridFunctions($scope, $scope.data.gridCertificadosPlanta);
		$scope.data.gridCertificadosPlanta.ixRestoreConfig();
	}

	$scope.guardar = function (){
		if ($scope.isNew){
			$http.post(cfg.baseURL + "plantas", $scope.data.planta).then(function (r){
				delete $scope.isNew;
				$scope.data.planta.planta = r.data.obj.Record.planta;
				$scope.data.planta.fecha_alta=r.data.obj.Record.fecha_alta;
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				$scope.data.planta_datos_originales.fecha_alta = $scope.data.planta.fecha_alta
				//Actualizo el filtro externo ????
				$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
				$scope.dataModified = true;
				ixStatusService.setResponse(r);

			}, function(error){
				ixStatusService.setResponse(error);
			});
		}
		else {
			var data = {};
			data.jpdPlanta = ixGetPatchOperations($scope.data.planta_datos_originales, $scope.data.planta);
			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosPlanta.gridApi.rowEdit){
				data.ubpFicheros = $scope.data.gridCertificadosPlanta.ixGetBulkParam();
			}

			$http.put(cfg.baseURL + "plantas/PutPlanta/" + $scope.data.planta.planta, data).then(function (r) {
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				if(new Date($scope.data.planta.fecha_baja).getTime() 
					!= new Date(r.data.obj.Record.fecha_baja).getTime() ){
					$scope.data.planta.fecha_baja=r.data.obj.Record.fecha_baja;
					$scope.data.planta_datos_originales.fecha_baja = $scope.data.planta.fecha_baja;
				}
				
				$scope.dataModified = true;
				$scope.data.gridCertificadosPlanta.clearGridAfterSave();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};


	/*
	$scope.guardarOLD = function () {
		var data = {}
		if ($scope.isNew) {
			data.nuevaPlanta = $scope.data.planta;
			data.nuevosCertificados = $scope.data.gridCertificadosPlanta.data;
			$http.post(cfg.baseURL + "plantas/PostPlanta", data).then(function (r) {
				delete $scope.isNew;

				$http.get(cfg.baseURL + "plantas/" + r.data.obj.Record.planta).then(function(response){
					$scope.data.planta = response.data;
					$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				});

				$scope.data.gridCertificadosPlanta.deletedRows = [];
				$scope.data.gridCertificadosPlanta.insertedRows = [];
				$scope.data.gridCertificadosPlanta.clearFocus();
				var dataRows = $scope.data.gridCertificadosPlanta.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
				$scope.data.gridCertificadosPlanta.gridApi.rowEdit.setRowsClean( dataRows );
				$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: r.data.obj.Record.planta, Operator: CMP_EQ }];
				$scope.data.gridCertificadosPlanta.ixLoadInitialData();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		} else {
			data.jpdPlanta = ixGetPatchOperations($scope.data.planta_datos_originales, $scope.data.planta);
			// console.log(data.jpdPlanta);
			// console.log($scope.data.planta_datos_originales);
			// console.log($scope.data.planta);
			data.ubpCertificados = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosPlanta.gridApi.rowEdit){
				data.ubpCertificados = $scope.data.gridCertificadosPlanta.ixGetBulkParam();
			}

			$http.put(cfg.baseURL + "plantas/PutPlanta/" + $scope.data.planta.planta, data).then(function (r) {
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);

				$scope.data.gridCertificadosPlanta.deletedRows = [];
				$scope.data.gridCertificadosPlanta.insertedRows = [];
				$scope.data.gridCertificadosPlanta.clearFocus();
				var dataRows = $scope.data.gridCertificadosPlanta.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
				$scope.data.gridCertificadosPlanta.gridApi.rowEdit.setRowsClean( dataRows );
				$scope.data.gridCertificadosPlanta.ixLoadInitialData();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}

	};
*/
	// $scope.$close = function () {
	// 	$uibModalInstance.dismiss('cancel');
	// };

	$scope.$dismiss = function () {
		//$scope.save();
		var resp = {};
		// resp.planta = $scope.data.planta;
		// resp.planta_datos_originales = $scope.data.planta_datos_originales;
		resp.dataModified = $scope.dataModified;

		$uibModalInstance.close(resp);
	}

	$scope.downloadFile = function (id){
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err){
			ixStatusService.setResponse(err);
		});
	}

}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global CMP_ISNULL*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBase').controller('FabricantesPopupController', ['$scope', '$uibModalInstance', 'gridService', 'ixStatusService', '$http', 'cfg', '$timeout', '$q', 'ixUtilsService', 'ixWarningsService', '$log', function ($scope, $uibModalInstance, gridService, ixStatusService, $http, cfg, $timeout, $q, ixUtilsService, ixWarningsService, $log) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.fabricante = $scope.$resolve.clickedItem;
	$scope.data.fabricante_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.bloqueado = $scope.$resolve.bloqueado;
	$scope.isNew = $scope.$resolve.isNew;

	$scope.dataModified = false;

	$scope.gridManualLoad = true;
	if (!$scope.$resolve.extranetUser.cliente && !$scope.bloqueado)
		$scope.status.editing = true;

	// $scope.addFicheros = function () {
	// 	var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
	// 	var controllerName = "UploadFilePopupProveedoresController";
	// 	var optionsPopupFicheros = {
	// 		controller: controllerName
	// 	};
	// 	var params = { "id_proveedor": $scope.data.fabricante.proveedor, "grupo": "FABRICANTE", fabricante: $scope.data.fabricante.fabricante };
	// 	var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
	// 	modalInstance.then(function (resp) {
	// 		$scope.data.gridCertificadosFabricante.ixLoadInitialData();
	// 	});
	// };

	$scope.addRow = function (grid, item) {
		var nuevo = item || {};
		if (grid.entity == 'plantas') {
			nuevo.fabricante = $scope.data.fabricante.fabricante;
			abrirPopupPlantas(nuevo, true);
		}
	};

	$scope.deleteSelectedRows = function (grid) {
		var warningSentence = "ATENCIÓN: Se eliminaran las plantas seleccionadas con todos los documentos y auditorías asociados. ¿Se desea continuar?";
		ixWarningsService.warningConfirmacion($scope, warningSentence, confirmaEliminarPlanta, undefined, grid);
		//grid.ixDeleteSelectedRows();
	};

	//GRID PLANTAS
	if (!$scope.data.gridPlantas) {
		//var metadata = [];
		var acciones = [
			{
				icon: "fa-search",
				title: "Plantas",
				visible: function (entity) {
					return true;//!$scope.data.datos.isNew;
				},
				accion: function (entity) {
					abrirPopupPlantas(entity, false);
				}
			}
		];
		$scope.data.gridPlantas = gridService.createGrid($scope, 'gnet_grid_plantas', { metadata: [], minRowsToShow: 5 }, "plantas", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
		$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
		$scope.data.gridPlantas.ixLoadInitialData();

	} else {
		$scope.data.gridPlantas = gridService.createGridFunctions($scope, $scope.data.gridPlantas);
		$scope.data.gridPlantas.ixRestoreConfig();
	}

	// //GRID CERTIFICADOS FABRICANTE
	// if (!$scope.data.gridCertificadosFabricante) {
	// 	var accionesCertificados = [
	// 		{
	// 			title: "Previsualizar PDF",
	// 			icon: "fa-file-pdf-o",
	// 			visible: function (entity) {
	// 				return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
	// 			},
	// 			accion: function (entity) {
	// 				var tabla = "proveedores_ficheros";
	// 				$http({
	// 					method: 'post',
	// 					url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
	// 					headers: {},
	// 					responseType: 'arraybuffer'
	// 				}).then(function (r) {
	// 					$scope.selectedPDF = new Uint8Array(r.data);
	// 					$scope.idFicheroPreview = entity.id;
	// 					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
	// 					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
	// 				},
	// 					function (err) {
	// 						ixStatusService.setResponse(err);
	// 					});
	// 			}
	// 		},
	// 		{
	// 			title: "Previsualizar Imagen",
	// 			icon: "fa-file-image-o",
	// 			visible: function (entity) {
	// 				return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
	// 			},
	// 			accion: function (entity) {
	// 				var tabla = $scope.getEntity();
	// 				$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
	// 					$scope.selectedImage = r.data;
	// 					$scope.idFicheroPreview = entity.id;
	// 					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
	// 					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
	// 				},
	// 					function (err) {
	// 						ixStatusService.setResponse(err);
	// 					});
	// 			}
	// 		},
	// 		{
	// 			title: "Descargar fichero",
	// 			icon: "fa-download",
	// 			visible: function (entity) {
	// 				return entity.archivo;
	// 			},
	// 			accion: function (entity) {
	// 				$scope.downloadFile(entity.id);
	// 			}
	// 		}
	// 		// {
	// 		// 	icon: "fa-upload",
	// 		// 	title: "Subir fichero",
	// 		// 	visible: function(entity){
	// 		// 		return !entity.isNew;
	// 		// 	},
	// 		// 	accion: function (entity){
	// 		// 		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
	// 		// 		var controllerName = "UploadFilePopupProveedoresController";
	// 		// 		var optionsPopupFicheros = {
	// 		// 			controller: controllerName
	// 		// 		};
	// 		// 		var params = { "id_proveedor": $scope.data.fabricante.proveedor, "grupo": "FABRICANTE", fabricante: entity.fabricante };
	// 		// 		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
	// 		// 		modalInstance.then(function (resp) {
	// 		//
	// 		// 		});
	// 		// 	}
	// 		// }
	// 	];
	// 	var metadata = [];
	// 	$scope.data.gridCertificadosFabricante = gridService.createGrid($scope, 'gnet_grid_certificados_fabricante', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "num_certificado", "certificadora", "fecha_caducidad", "inicio_validez", "alcance"] }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: accionesCertificados }]);
	// 	$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
	// 	$scope.data.gridCertificadosFabricante.ixLoadInitialData();

	// } else {
	// 	$scope.data.gridCertificadosFabricante = gridService.createGridFunctions($scope, $scope.data.gridCertificadosFabricante);
	// 	$scope.data.gridCertificadosFabricante.ixRestoreConfig();
	// }


	//$scope.ixEditar = $scope.data.gridPlantas.ixEditar;


	$scope.guardar = function () {
		if ($scope.isNew) {
			$http.post(cfg.baseURL + "fabricantes", $scope.data.fabricante).then(function (r) {
				delete $scope.isNew;
				$scope.dataModified = true;
				$scope.data.fabricante.fabricante = r.data.obj.Record.fabricante;
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				//Actualizo el filtro externo de los ficheros y plantas (????)
				//$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
		else {
			var data = {};

			data.jpdFabricante = ixGetPatchOperations($scope.data.fabricante_datos_originales, $scope.data.fabricante);

			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			// if ($scope.data.gridCertificadosFabricante && $scope.data.gridCertificadosFabricante.gridApi.rowEdit)
			// 	data.ubpFicheros = $scope.data.gridCertificadosFabricante.ixGetBulkParam();

			data.ubpPlantas = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			}
			if ($scope.data.gridPlantas && $scope.data.gridPlantas.gridApi.rowEdit)
				data.ubpPlantas = $scope.data.gridPlantas.ixGetBulkParam();

			$http.put(cfg.baseURL + "fabricantes/PutFabricante/" + $scope.data.fabricante.fabricante, data).then(function (r) {
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				$scope.dataModified = true;

				$scope.data.gridPlantas.clearGridAfterSave();
				$scope.data.gridCertificadosFabricante.clearGridAfterSave();

				$scope.status.editing = true; //Porque las llamadas al clearGridAfterSave lo ponen a false
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};

	var confirmaEliminarPlanta = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	$scope.$dismiss = function () {
		//$scope.save();
		var resp = {};
		// resp.fabricante = $scope.data.fabricante;
		// resp.fabricante_datos_originales = $scope.data.fabricante_datos_originales;
		resp.isNew = $scope.isNew;
		resp.dataModified = $scope.dataModified;
		$uibModalInstance.close(resp);
	}

	var abrirPopupPlantas = function (entity, isNew) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/plantasPopup.html";
		var controllerName = "PlantasPopupController";
		var optionsPopupPlantas = {
			controller: controllerName,
			resolve: {
				clickedItem: function () {
					return entity;
				},
				isNew: function () {
					return isNew;
				}
			}
		};
		var params = { "clickedItem": entity, "isNew": isNew, "fabricante": $scope.data.fabricante, "extranetUser": $scope.$resolve.extranetUser, "bloqueado": $scope.bloqueado };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupPlantas, 'medium', params);
		modalInstance.then(function (resp) {
			if (resp.dataModified) {			
				$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
				$scope.data.gridPlantas.ixLoadInitialData();
			}
			$scope.dataModified = resp.dataModified;
		});
	};

	$scope.downloadFile = function (id) {
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	}

}]);

angular.module('FTBase').controller('UploadFilePopupProveedoresController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', 'ixWarningsService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService, ixWarningsService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
  	$scope.proveedor = $scope.$resolve.id_proveedor;
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.grupo = $scope.$resolve.grupo;
	$scope.soloHayPlantaPuesta = $scope.$resolve.soloHayPlantaPuesta;
	if($scope.soloHayPlantaPuesta) $scope.status.editing=true;
	$scope.bloquearGrupos = $scope.grupo ? true : false;
	if(angular.isUndefined($scope.grupo) || $scope.grupo == null || $scope.grupo == "")
		$scope.grupo ="PLANTA";
	$scope.fabricante = $scope.$resolve.fabricante;
	$scope.planta = $scope.$resolve.planta;
	//Datos usados en caso de sustitución fichero
	//En el parámetro sustituir envío el id del fichero que se sostituirá para poder marcarlo como archivado
	$scope.sustituir = $scope.$resolve.sustituir;
	if ($scope.sustituir) $scope.status.editing = true; //Me aseguro de que la modalidad edición esté activa
	$scope.tipoSeleccionadoProveedor = $scope.$resolve.tipoFichero;
	$scope.alcance = $scope.$resolve.alcance;
	if ($scope.grupo === "PLANTA"){
		$scope.seleccionadoCertificado = 1;
		$scope.caducidadObligatoria = true;
	}
	else{
		$scope.seleccionadoCertificado = 0;
		$scope.caducidadObligatoria = false;
	}	
		
	$scope.save = function(){
		if(angular.isDefined($scope.sustituir)){
			var frase ="ATENCIÓN: Se eliminaran los certificados anteriores que esten obsoletos, siempre que haya uno activo y otro archivado. ¿Se desea continuar con la operación?";
			ixWarningsService.warningConfirmacion($scope,frase,guardarConfirmed);
		}else{
			guardarConfirmed();
		}
	};

	var guardarConfirmed = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		// var upl_info = {
		// 	toReplace: $scope.sustituir,
		// 	fileNames: fileNames
		// };

		$http.post(cfg.baseURL + "proveedores_ficheros/CanUpload?id_proveedor="+$scope.proveedor, fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				if ($scope.grupo == 'PROVEEDOR'){
					$scope.fabricante = null;
					$scope.planta = null;
				}
				if ($scope.grupo == 'FABRICANTE'){
					$scope.planta = null;
				}
				var upload = Upload.upload({
					url: cfg.baseURL + "proveedores_ficheros/UploadAndCreate",
					data: {
						file: $scope.archivosToUpload,
						grupo: $scope.grupo,
						proveedor: $scope.proveedor,
						fabricante: $scope.fabricante,
						planta: $scope.planta,
						tipo: $scope.tipoSeleccionadoProveedor,
						fecha_caducidad: $scope.fechaCaducidad,
						inicio_validez: $scope.inicio_validez,
						num_certificado: $scope.num_certificado,
						certificadora: $scope.certificadora,
						alcance: $scope.alcance
					},
					dataType: 'json'
				});

				upload.then(function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
						$scope.status.editing = false;
						if ($scope.sustituir){
							var param = [];
							param.push({
								value: 1,
								path: "/archivado",
								op: "replace"
							});

							$http.put(cfg.baseURL + "proveedores_ficheros/" + $scope.sustituir, param).then(function(response){
								ixStatusService.setResponse(response);
								$uibModalInstance.close($scope.data);
							},
							function(error){
								ixStatusService.setResponse(error);
							});
						}
						else{
							$uibModalInstance.close($scope.data);
						}
					}
					else{
						$uibModalInstance.close($scope.data);
					}
				}, function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function(evt){
					$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
			else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});

		//$uibModalInstance.close($scope.data);
	}

	//Limpio los eventuales valores del tipo fichero, caducidad y alcance
	$scope.seleccionadoGrupo = function(){
		$scope.tipoSeleccionadoProveedor = undefined;
		if ($scope.grupo == 'PROVEEDOR' || $scope.grupo == 'FABRICANTE'){
			$scope.fechaCaducidad = null;
			$scope.alcance = null;
			$scope.seleccionadoCertificado = 0;
			$scope.caducidadObligatoria = 0;
		}
		else{
			$scope.seleccionadoCertificado = 1;
			$scope.caducidadObligatoria = true;
		} 
	};


	// $scope.tipoFicheroSelected = function(entity){
	// 	$scope.seleccionadoCertificado = entity.certificado;
	// 	$scope.caducidadObligatoria = (entity.caducidad_obligatoria == 1)
	// };

	$scope.limpiarPlanta = function(){
    	$scope.planta = undefined;
		$scope.fabricante = undefined;
  	};


	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close({});
	}

}]);

/*global ixGetPatchOperations*/

angular.module('FTBase').controller('PopupFicheroLaboratorioController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.status = ixStatusService.current;
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.data = {};
  $scope.idFichero = $scope.$resolve.idFichero;
  $scope.idLab = $scope.$resolve.idLab;
  $scope.mantenimiento_lab = $scope.$resolve.mantenimiento_lab;

  $scope.data.laboratorio = $scope.idLab;
  if (!$scope.mant_proveedor) $scope.bloquearGrupos = true;
  $scope.uploadingFile = false;
  $scope.uploadedFile = false;
  $scope.status.editing = true;
  $scope.esNuevo = false;

  if ($scope.idFichero == 0){
		//Es un nuevo fichero
		$scope.esNuevo = true;
    $scope.tituloPopup = "Cargar nuevo fichero";
	}
  else {
    //Se está editando un fichero existente
    $scope.tituloPopup = "Editar fichero";
    $http.get(cfg.baseURL + "laboratorios_ficheros/" + $scope.idFichero).then(function(response){
			$scope.data = response.data;
			$scope.original_data = angular.copy($scope.data);
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }

  $scope.save = function(){
    if ($scope.esNuevo){
      if (angular.isUndefined($scope.archivosToUpload)){
        $log.log("No se ha seleccionado un archivo");
      }
      else {
        var fileNames = [];
        fileNames.push($scope.archivosToUpload[0].name);

        $http.post(cfg.baseURL + "laboratorios_ficheros/CanUpload?laboratorio=" + $scope.idLab, fileNames).then(function(response){
          if (response.data.GlobalMessage.ErrType == 0){
            $scope.uploadingFile = true;
            var upload = Upload.upload({
              url: cfg.baseURL + "laboratorios_ficheros/UploadAndCreate",
              data: {
                file: $scope.archivosToUpload,
                laboratorio: $scope.idLab,
                tipo: $scope.data.tipo,
                fecha_caducidad: $scope.data.fecha_caducidad,
                fecha_carga: $scope.data.fecha_carga,
                inicio_validez: $scope.data.inicio_validez
              },
              dataType: 'json'
            });

            upload.then(function(response){
              if (response.data){
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
                $scope.uploadedFile = true;
                ixStatusService.setResponse(response);
                //$scope.status.editing = false;
                $uibModalInstance.close($scope.uploadedFile);
                }
            }, function(error){
              if (error.data) {
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
              }
              ixStatusService.setResponse(error);
            }, function(evt){
              $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
          }
          else {
            ixStatusService.setResponse(response);
          }
        }, function(error){
          ixStatusService.setResponse(error);
        });
      }
    }
    else { //EDITAR
      var param = {};
      param = ixGetPatchOperations($scope.original_data, $scope.data);

      $http.put(cfg.baseURL + "laboratorios_ficheros/" + $scope.data.id, param).then(function(response){
        ixStatusService.setResponse(response);
        //$scope.status.editing = false;
        $uibModalInstance.close(true);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.$dismiss = function () {
		$uibModalInstance.close(false);
	};

}]);
/*global ixGetPatchOperations*/
/*global CMP_EQ*/

angular.module("FTBase").controller("EditarPreguntaPopupController", [ "$scope",'$uibModalInstance','$http','cfg','ixStatusService', '$q', 'Upload', function($scope,$uibModalInstance,$http,cfg,ixStatusService, $q, Upload){
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.isNew = $scope.$resolve.isNew;
	$scope.pregunta  = angular.copy($scope.$resolve.pregunta);
	//nivel, lleno los campos dropdown segun cada subnivel, buscando en la tabla ft_niveles por el nivel general
	if($scope.pregunta.nivel > 0){
		$http.get(cfg.baseURL + "ft_niveles/" + $scope.pregunta.nivel).then(function(response){
			setNiveles(response.data);
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	//tipos_fichero separo los valores que vienen en forma de string separados por ';' en un array de numbers con los ids para el select-multiple
	if($scope.pregunta.tipos_fichero){
		$scope.pregunta.tipos_fichero = $scope.pregunta.tipos_fichero.split(';').map(Number);
	}

	$scope.preguntaOriginal = angular.copy($scope.pregunta);


  $scope.changeTab = function(idxTab){
    $scope.data.activeTab = idxTab;
  }

	$scope.save = function(){

		if($scope.data.nivel1)
		{
			//nivel hace el get de la pk del nivel en la tabla ft_niveles en funcion de los valores de los dropdowns de nivel
			var nivel = 0;
			getNivel()
			.then(function(nivelReturned){

				nivel = nivelReturned;

				if(nivel != 0)
					$scope.pregunta.nivel = nivel;

				if($scope.data.archivosToUpload){
					subirArchivo();
				}

				separarTiposFichero();

				var patch = ixGetPatchOperations($scope.preguntaOriginal, $scope.pregunta);
				$http.put(cfg.baseURL + "ft_preguntas/" + $scope.pregunta.id_pregunta, patch).then(function(response){
					ixStatusService.setResponse(response);
					$uibModalInstance.close();
				}, function(err){
					ixStatusService.setResponse(err);
				});
			})
			.catch(function(error){
				ixStatusService.setResponse(error);
			})
		}
		else{

			$scope.pregunta.nivel = null;

			if($scope.data.archivosToUpload){
				subirArchivo();
			}

			separarTiposFichero();

			var patch = ixGetPatchOperations($scope.preguntaOriginal, $scope.pregunta);
			$http.put(cfg.baseURL + "ft_preguntas/" + $scope.pregunta.id_pregunta, patch).then(function(response){
				ixStatusService.setResponse(response);
				$uibModalInstance.close();
			}, function(err){
				ixStatusService.setResponse(err);
			});
		}


	}

	var separarTiposFichero = function(){
		//tipos_fichero se crea un string con los valores separados por ';' para guardarlos en DB
		var separados = "";
		if($scope.pregunta.tipos_fichero){
			$scope.pregunta.tipos_fichero.forEach(function(element){
				if(separados == "")
					separados = element;
				else {
					separados += ";" + element;
				}
			});
			$scope.pregunta.tipos_fichero = separados;
		}
	}

	var subirArchivo = function(){
		var fileNames = [];
		fileNames.push($scope.data.archivosToUpload.name);


		$http.post(cfg.baseURL + "ft_preguntas/CanUpload/"+$scope.pregunta.id_pregunta, fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var upload = Upload.upload({
					url: cfg.baseURL + "ft_preguntas/UploadAndCreate/"+$scope.pregunta.id_pregunta,
					data: {file: $scope.data.archivosToUpload},
					dataType: 'json'
				});

				upload.then(function (response) {
					if(response.data){
						delete $scope.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function (response) {
					if(response.data){
						delete $scope.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function (evt) {
					// Math.min is to fix IE which reports 200% sometimes
					//file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					$scope.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			} else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});
	};

	$scope.eliminarImagenPregunta = function(){
		$scope.pregunta.imagen = null;
	};


	var getNivel = function(){
		var nivel = 0;
		var defered = $q.defer();
    	var promise = defered.promise;
		var params = {Filters: [{Field: 'version', Value: $scope.pregunta.version, Operator: CMP_EQ},{Field: 'nivel1', Value: $scope.data.nivel1, Operator: CMP_EQ},{Field: 'nivel2', Value: $scope.data.nivel2 ? $scope.data.nivel2 : 0, Operator: CMP_EQ}, {Field: 'nivel3', Value: $scope.data.nivel3 ? $scope.data.nivel3 : 0, Operator: CMP_EQ }]};
		$http.post(cfg.baseURL + "ft_niveles/List",params).then(function(response){
			nivel = response.data[0].nivel;
			defered.resolve(nivel);
		}, function(error){
			defered.reject(error);
		});

    	return promise;
	}

	var setNiveles = function(nivel){
		$scope.data.nivel1 = nivel.nivel1;
		$scope.data.nivel2 = nivel.nivel2;
		$scope.data.nivel3 = nivel.nivel3;
	}

	$scope.$dismiss = function(){
		if($scope.isNew)
			$uibModalInstance.close();
		else
			$uibModalInstance.dismiss('cancel');
	}


}]);

angular.module("FTBase").controller("PrevisualizarPreguntaPopupController", [ "$scope", function($scope){
	$scope.status = { editing: true };
	$scope.preguntas = [ { pregunta: $scope.$resolve.pregunta } ];
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicherosCertificadosAuditoriasController", ['$scope', '$http', '$routeParams', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_proveedor");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_proveedor", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_proveedor/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  // $scope.openPopupTraduccion = function(v){
	// 	var template = "app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html";
	// 	var optionsPopup = { controller: "TraduccionesTiposFicheroProveedorController" };
	// 	var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
	// 	var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
	// 	popup.then(function (data) {
	// 	});
  // }

}]);

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("TiposAuditoriasPlantasController", [ '$scope', '$http', 'cfg', 'ixStatusService', 'ixWarningsService', function($scope, $http, cfg, ixStatusService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if (!$scope.data.metadataForm)
    $scope.loadMetadata("tipos_auditorias_plantas");

  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "descripcion", "ccp.categoria" ];
  $scope.data.fieldsToOrderBy = [ "descripcion DESC" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_auditorias_plantas/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

  $scope.ixGuardar = function(){
    var data = {};

    if ($scope.data.datos.isNew){
      data.nuevoTipo = $scope.data.datos;
      //Crear nuevo tipo auditoría
      $http.post(cfg.baseURL + "tipos_auditorias_plantas", data.nuevoTipo).then(function(response){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(response);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar tipo auditoría
      data.tipoAuditoria = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + "tipos_auditorias_plantas/" + $scope.data.datos[$scope.data.pk], data.tipoAuditoria).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo auditoría " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "tipos_auditorias_plantas/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};

}]);

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("CategoriasCertificacionesProveedorController", [ '$scope', '$http', 'cfg', 'ixStatusService', 'ixWarningsService', function($scope, $http, cfg, ixStatusService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if (!$scope.data.metadataForm)
    $scope.loadMetadata("categorias_certificaciones_proveedores");

  $scope.data.pk = "id";
  $scope.data.showAsID = "categoria";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "categoria" ];
  $scope.data.fieldsToOrderBy = [ "categoria" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "categorias_certificaciones_proveedores/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

  $scope.ixGuardar = function(){
    var data = {};

    if ($scope.data.datos.isNew){
      data.nuevaCategoria = $scope.data.datos;
      //Crear nueva categoría
      $http.post(cfg.baseURL + "categorias_certificaciones_proveedores", data.nuevaCategoria).then(function(response){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(response);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar categoria
      data.categoria = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + "categorias_certificaciones_proveedores/" + $scope.data.datos[$scope.data.pk], data.categoria).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar la categoría " + $scope.data.datos.categoria + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "categorias_certificaciones_proveedores/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};

}]);

angular.module('FTBase').controller('SubirFotoProductoPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.status = { editing: true };
	$scope.data = {};

	$scope.save = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		$http.post(cfg.baseURL + "ft_fotos_productos/CanUpload", fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var upload = Upload.upload({
					url: cfg.baseURL + "ft_fotos_productos/UploadAndCreate",
					data: {
						file: $scope.archivosToUpload
					},
					dataType: 'json'
				});

				upload.then(function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
						$scope.status.editing = false;
						$uibModalInstance.close($scope.data);
					}
				}, function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						$scope.erroresUpload = response.data.obj.Errors;
					}
				}, function(evt){
					$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
			else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});

	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close({});
	}

}]);

/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global buildIxSearch*/
/*global CMP_GTE*/
/*global saveAs*/

angular.module('FTBase').controller('AnaliticaFTPopupController', ['$scope', 'cfg', '$http', 'gridService', 'ixUtilsService', '$uibModalInstance', 'ixStatusService', '$q', '$timeout', 'Upload', '$ngConfirm', '$translate', function ($scope, cfg, $http, gridService, ixUtilsService, $uibModalInstance, ixStatusService, $q, $timeout, Upload, $ngConfirm, $translate) {
    $scope.status = ixStatusService.current;
    $scope.status.editing = true;
    $scope.data = {};
    $scope.data.datos = {};
    $scope.datos_modificados = false;

    $scope.loadValoresResultados = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "CORRECTO" },
                { valor: "INCORRECTO" },
                { valor: "NO CONFORME" }
            ];

            if ($scope.data.datos.tipo_analisis == 5) { //SOMMELIER
                //Agrego respuestas adicionales
                list.push({ valor: "ACEPTABLE" });
                list.push({ valor: "NOTABLE" });
                list.push({ valor: "EXCELENTE" });
            }

            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresRevisionNutriscore = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Correcto" },
                { valor: "Incorrecto" },
                { valor: "No lo tiene en etiquetado" },
                { valor: "No aparece en FT" },
                { valor: "N/A" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPuntuacionNutriscore = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "A" },
                { valor: "B" },
                { valor: "C" },
                { valor: "D" },
                { valor: "E" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.load_desviaciones_analiticas = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "FISICAS: Peso/Volumen" },
                { descripcion: "FISICAS: Categoría comercial" },
                { descripcion: "FISICAS: Otras" },
                { descripcion: "QUIMICAS" },
                { descripcion: "MICROBIOLOGICAS" },
                { descripcion: "ORGANOLEPTICAS" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_acciones_correctoras = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "Análisis Extra del parámetro afectado" },
                { descripcion: "Baja de la referencia" },
                { descripcion: "Se realiza un cambio especificaciones ficha técnica" },
                { descripcion: "Otros" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_desviaciones_etiquetados = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "MARCADO DE FECHAS" },
                { descripcion: "DECLARACIONES INCORRECTAS" },
                { descripcion: "CAMPO VISUAL" },
                { descripcion: "NUTRICIONALES E INGESTA DE REFERENCIA" },
                { descripcion: "ALTURA TEXTOS Y/O CIFRAS" },
                { descripcion: "DECLARACIONES ENGAÑOSAS" },
                { descripcion: "ALERGENOS" },
                { descripcion: "OTRAS" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_valores_revision_online = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "Correcto" },
                { descripcion: "En web aparece foto front+traser" },
                { descripcion: "NC condiciones de conservación" },
                { descripcion: "NC info nutricional obligatoria" },
                { descripcion: "NC lista de ingredientes" },
                { descripcion: "NC nombre del fabricante" },
                { descripcion: "NC peso" },
                { descripcion: "No localizado producto en la web" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresEstadosIncidencia = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "ANULADO" },
                { valor: "PRODUCTO NO LOCALIZADO" },
                { valor: "APLAZADO" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresTiposEstudio = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Sensorial" },
                { valor: "FQ" },
                { valor: "Expertos" },
                { valor: "Prueba funcional" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresCategorizaciones = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Igual" },
                { valor: "Mejor" },
                { valor: "Aceptabilidad" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPerfilesNutricionales = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Sin diferencias" },
                { valor: "Con diferencias" },
                { valor: "No aplica" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPuntuacionVinos = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: 0.0 },
                { valor: 0.5 },
                { valor: 1.0 },
                { valor: 1.5 },
                { valor: 2.0 },
                { valor: 2.5 },
                { valor: 3.0 },
                { valor: 3.5 },
                { valor: 4.0 },
                { valor: 4.5 },
                { valor: 5.0 }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.cleanValues = function (entity) {
        if ($scope.data.datos.tipo_analisis == 3 && entity.valor == "INCORRECTO") $scope.data.datos.categorizacion = null;
    };

    if (!$scope.$resolve.is_new) {
        $http.get(cfg.baseURL + "ft_analiticas/" + $scope.$resolve.id_ft).then(function (response) {
            $scope.data.datos = response.data;
            $scope.data.datos.marca_desc = $scope.$resolve.marca;
            $scope.data.datos.proveedor = $scope.$resolve.proveedor;
            $scope.data.datos.cod_interno = $scope.$resolve.cod_interno;
            $scope.data.datos.denominacion = $scope.$resolve.titulo;
            // $scope.data.datos.ano_planificacion = $scope.data.datos.año_planificacion;

            $scope.data.datos_originales = angular.copy($scope.data.datos);

            //Convertir todos los campos que se separan por punto y coma a array (estos se volveran separar por ; al guardar los datos)
            if ($scope.data.datos.desviacion_analisis) {

                $scope.data.datos.desviacion_analisis = $scope.data.datos.desviacion_analisis.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.acciones_analisis) {
                $scope.data.datos.acciones_analisis = $scope.data.datos.acciones_analisis.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.desviacion_etiquetado) {
                $scope.data.datos.desviacion_etiquetado = $scope.data.datos.desviacion_etiquetado.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.revision_online && ($scope.data.datos.estado == 'PLANIFICADO' || $scope.data.datos.estado == 'EN CORRECCION')) {
                $scope.data.datos.revision_online = $scope.data.datos.revision_online.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
        }, function (error) {
            ixStatusService.setResponse(error);
        });
    }

    $scope.definirSave = function () {
        $scope.save = function () {
            var resultCabecera = $scope.validarCabecera();

            if (resultCabecera) {
                $ngConfirm(resultCabecera);
                return;
            }

            //Pasar los campos que son arrays a separados por punto y coma de nuevo
            separarArraysPuntoYComa();

            // $scope.data.datos.año_planificacion = $scope.data.datos.ano_planificacion;

            if ($scope.$resolve.is_new) {
                $scope.data.datos.estado = "PLANIFICADO";
                $http.post(cfg.baseURL + "ft_analiticas", $scope.data.datos).then(function (response) {
                    $scope.$resolve.is_new = false;
                    $scope.data.datos = response.data.obj.Record;
                    // $scope.data.datos['año_planificacion'] = $scope.data.datos.año_planificacion;
                    $scope.datos_modificados = true;
                    ixStatusService.setResponse(response);
                }, function (err) {
                    ixStatusService.setResponse(err);
                });
            }
            else {
                var jsonPatch = ixGetPatchOperations($scope.data.datos_originales, $scope.data.datos);
                $http.put(cfg.baseURL + "ft_analiticas/" + $scope.data.datos.id, jsonPatch).then(function (response) {
                    $scope.datos_modificados = true;
                    $uibModalInstance.close($scope.datos_modificados);
                }, function (err) {
                    ixStatusService.setResponse(err);
                });
            }
        }
    }

    if (!$scope.$resolve.is_new)
        $scope.definirSave();

    $scope.validarCabecera = function () {
        if (!$scope.data.datos.id_laboratorio || !$scope.data.datos.mes_planificacion || !$scope.data.datos['año_planificacion'] || !$scope.data.datos.tipo_analisis)
            return "Es obligatorio llenar todos los campos de la cabecera";

        if ($scope.data.datos.tipo_analisis == 2) {
            if (!$scope.data.datos.parametro || !$scope.data.datos.num_unidades)
                return "Es obligatorio llenar todos los campos de la cabecera";
        }
        return null;
    }

    $scope.validarResultados = function () {

        // if (!$scope.data.datos.fecha_realizacion)
        //     return "La fecha de análisis es obligatoria";
        if (!$scope.data.datos.ref_analisis)
            return "La referéncia de análisis es obligatoria";

        if (!$scope.data.datos.resultado_analisis && !$scope.data.datos.resultado_etiquetado)
            return "Se debe de seleccionar al menos un resultado (analítica o etiquetado)";

        if ($scope.data.datos.resultado_analisis) {
            // if($scope.data.datos.resultado_analisis != "CORRECTO"){ 
            //yves -mayo 2023: Cambio la condición para permitir que se finalicen análisis de tipo SOMMELIER con valores ACEPTABLE, NOTABLE, EXCELENTE
            if ($scope.data.datos.resultado_analisis == "INCORRECTO" || $scope.data.datos.resultado_analisis == "NO CONFORME") {
                if (!$scope.data.datos.desviacion_analisis)
                    return "Cuando el resultado analítica no es CORRECTO es necesario especificar las desviaciones";
                if (!$scope.data.datos.descripcion_desviacion_analisis)
                    return "Cuando el resultado analítica no es CORRECTO es necesario cumplimentar la descripción detallada de las desviaciones";
            }
            if ($scope.data.datos.resultado_analisis == "INCORRECTO" && !$scope.data.datos.acciones_analisis)
                return "Cuando el resultado analítica es INCORRECTO es necesario especificar las acciones correctoras";

        }

        if ($scope.data.datos.resultado_etiquetado) {
            if ($scope.data.datos.resultado_etiquetado == "INCORRECTO") {
                if (!$scope.data.datos.desviacion_etiquetado)
                    return "Cuando el resultado etiquetado no es CORRECTO es necesario especificar las desviaciones";
                if (!$scope.data.datos.descripcion_desviacion_etiquetado)
                    return "Cuando el resultado etiquetado no es CORRECTO es necesario cumplimentar la descripción detallada de las desviaciones";
            }
        }

        var posicionamiento = false;
        var analisis = false;
        var etiquetado = false;
        angular.forEach($scope.data.griddocumentos.data, function (value, key) {
            if (value.tipo == 3) {
                posicionamiento = true;
            } else if (value.tipo == 1) {
                analisis = true;
            } else if (value.tipo == 2) {
                etiquetado = true;
            }
        });

        if ($scope.data.datos.tipo_analisis == 3) {
            if (!posicionamiento)
                return "Es obligatorio subir un informe de posicionamiento";
        } else {
            if ($scope.data.datos.resultado_analisis && !analisis)
                return "Es obligatorio subir un informe de análisis";
            if ($scope.data.datos.resultado_etiquetado) {
                if (!$scope.data.datos.resultado_analisis && !etiquetado)
                    return "Es obligatorio subir un informe de etiquetado";
            }
        }

        return null;

    }

    $scope.finalizar = function () {
        var returnedValue = $scope.validarResultados();
        if (returnedValue) {
            $ngConfirm(returnedValue);
            return;
        }

        $scope.data.datos.fecha_finalizacion = new Date();
        if ($scope.data.datos.estado == "PLANIFICADO") {
            $scope.data.datos.estado = "FINALIZADO";
        }
        if ($scope.data.datos.estado == "EN CORRECCION") {
            $scope.data.datos.estado = "FINALIZADO-CORREGIDO";
        }

        $scope.save();
    }

    var separarArraysPuntoYComa = function () {
        //Se crea un string con los valores separados por ';' para guardarlos en DB
        //Desviacion analisis
        var separados = "";
        if ($scope.data.datos.desviacion_analisis) {
            $scope.data.datos.desviacion_analisis.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.desviacion_analisis = separados;
        }
        //Acciones analisis
        separados = "";
        if ($scope.data.datos.acciones_analisis) {
            $scope.data.datos.acciones_analisis.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.acciones_analisis = separados;
        }
        //Desviacion etiquetado
        separados = "";
        if ($scope.data.datos.desviacion_etiquetado) {
            $scope.data.datos.desviacion_etiquetado.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.desviacion_etiquetado = separados;
        }
        //Revisión Online
        separados = "";
        if ($scope.data.datos.revision_online) {
            $scope.data.datos.revision_online.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.revision_online = separados;
        }
    }

    $scope.cargarCamposLectura = function () {
        if ($scope.data.datos.id_ficha_tecnica && $scope.data.datos.ean) {
            var param = {};
            param.Filters = [];
            param.Filters.push({ Field: 'id_ficha_tecnica', Value: $scope.data.datos.id_ficha_tecnica, Operator: CMP_EQ });
            param.Filters.push({ Field: 'ean', Value: $scope.data.datos.ean, Operator: CMP_EQ });
            $http.post(cfg.baseURL + "listado_productos_analiticasFtVM/Search", param).then(function (response) {
                $scope.data.datos.marca_desc = response.data.Items[0].nombre_marca;
                $scope.data.datos.proveedor = response.data.Items[0].nombre_proveedor;
                $scope.data.datos.cod_interno = response.data.Items[0].cod_interno;
                $scope.data.datos.denominacion = response.data.Items[0].titulo;
                $scope.definirSave();
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }
    }

    if (!$scope.$resolve.is_new) {
        if (!$scope.data.griddocumentos) {
            var acciones = [
                {
                    title: $translate.instant("Descargar fichero"),
                    icon: "fa-download",
                    accion: function (entity) {
                        $scope.downloadDocFile(entity);
                    }
                }
            ];
            var param = buildIxSearch();
            param.Filters.push({ Field: 'id_analisis', Operator: CMP_EQ, Value: $scope.$resolve.id_ft })

            $scope.data.griddocumentos = gridService.createGrid($scope, 'gnet_grid_boletines_analisis_euromadi', {metadata: [], minRowsToShow: 5}, "boletines_analisis_euromadi", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
            $scope.data.griddocumentos.filtroExterno = param.Filters;

        } else {
            $scope.data.griddocumentos = gridService.createGridFunctions($scope, $scope.data.griddocumentos);
            $scope.data.griddocumentos.ixRestoreConfig();
        }
    }

    $scope.addRow = function (grid, item) {
        var nuevo = item || {};

        if (grid.entity == 'boletines_analisis_euromadi') {
            nuevo.id_analisis = $scope.$resolve.id_ft;
            abrirPopupDocumento(nuevo);
        }
    };

    var abrirPopupDocumento = function (nuevo) {
        var template = "app/FTBase/ListadosFT/acciones/add_documentos_analitica_ft_popup.html";
        var options = { controller: "AddDocumentosAnaliticaFtPopupController" };
        var params = { id_analisis: $scope.$resolve.id_ft, tipo_analisis: $scope.data.datos.tipo_analisis };
        ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
            if (response) {
                $scope.data.griddocumentos.ixAddRow(nuevo);
                $scope.data.griddocumentos.ixLoadInitialData();
                $scope.datos_modificados = true;
            }
        });
    };

    $scope.downloadDocFile = function (entity) {
        $http({
            method: 'post',
            url: cfg.baseURL + 'boletines_analisis_euromadi/DownloadFile?id=' + entity.id,
            headers: {},
            responseType: 'arraybuffer'
        }).then(function (r) {
            var mimetype = r.headers('Content-type');
            var file = new Blob([r.data], { type: mimetype });

            var filename = entity.archivo;
            if (r.headers('Content-Disposition')) {
                filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
            }
            saveAs(file, filename);
        }, function (err) {
            ixStatusService.setResponse(err);
        });
    };

    $scope.deleteSelectedRows = function (grid) {
        if (grid.entity == "boletines_analisis_euromadi") {
            var lineasSeleccionadas = grid.gridApi.selection.getSelectedRows();
            $http.post(cfg.baseURL + "boletines_analisis_euromadi/DeleteBulk", lineasSeleccionadas).then(function (response) {
                if (response) {
                    $scope.data.griddocumentos.ixLoadInitialData();
                    ixStatusService.setResponse(response);
                    $scope.datos_modificados = true;
                }
            },
                function (error) {
                    ixStatusService.setResponse(error);
                });
        }
    };


    $scope.mostrarCamposExtaordinarios = function () {
        if ($scope.data.datos.tipo_analisis.descripcion == "EXTRAORDINARIO")
            return true;
        else
            return false;
    }

    $scope.deshabilitarResultados = function () {
        if (!$scope.$resolve.extranetUser.laboratorio || $scope.data.datos.estado == 'FINALIZADO' || $scope.data.datos.estado == 'FINALIZADO-CORREGIDO' || $scope.data.datos.estado == 'CORREGIDO')
            return true;
        else
            return false;
    }

    $scope.$dismiss = function () {
        $uibModalInstance.close($scope.datos_modificados);
        if (angular.isDefined($scope.data.griddocumentos)) {
            $scope.data.griddocumentos.ixSaveConfig();
        }
    }

    $scope.$on("$destroy", function () {
        if (angular.isDefined($scope.data.griddocumentos)) {
            $scope.data.griddocumentos.ixSaveConfig();
        }
        $scope.isDestroyed = true;
    });

}]);

angular.module('FTBase').controller('VersionarMasivamentePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.status = { editing: true };
	$scope.data = {};
    $scope.data.id_ficha_tecnicas = $scope.$resolve.id_ficha_tecnicas;

	$scope.save = function(){
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/VersionarFTMasivamente" , $scope.data).then(function(response){
			$uibModalInstance.close(response);
		}, function(err){
			ixStatusService.setResponse(err);
		});

	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close();
	}

}]);

/*global saveAs*/
angular.module('FTBase').controller('ImprimirFTPopupController', [ "$scope", "$uibModalInstance", "$http", "cfg", "ixStatusService", "idiomasFT", 'authService', function($scope, $uibModalInstance, $http, cfg, ixStatusService, idiomasFT, authService){

	$scope.status = { editing: true };

	$scope.traducible = $scope.$resolve.traducible;

	var tipo = $scope.$resolve.tipo;
	var id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
	var ean = $scope.$resolve.ean;
	var lista_productos = $scope.$resolve.lista_productos;
	
	$scope.datos = {};
	$scope.datos.tipo_doc = "PDF"; //Por algún motivo no le gustaba $scope.tipo_doc
	$scope.reducida = 0;
	
	$scope.idiomas = idiomasFT.map(function(e){ return { value: e.codigo, text: e.descripcion, icon: e.icon }});
	$scope.idioma = null;

	var usuario = authService.authentication.userName;
	//Get condition user
  $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
    $scope.extranetUser = response.data;
  }, function (error) {
    ixStatusService.setResponse(error);
  });

	$scope.okBtnText = "Descargar";
	$scope.save = function(){
		if(tipo == "FT"){
			$scope.imprimirFt();
		} else if(tipo == "FT_PRODUCTO"){
			$scope.imprimirFtProducto();
		} else if(tipo == "FT_PRODUCTO_MASIVA"){
			$scope.impresionMasivaFT();
		}
	};

	
	$scope.imprimirFt = function(){
		var path = cfg.baseURL + "impresos/impresoFT/?idft=" + id_ficha_tecnica + "&docformat="+ $scope.datos.tipo_doc + "&reducido=" + $scope.reducida;
		if($scope.idioma)
			path+= "&idioma="+$scope.idioma;

		var config = {responseType: 'arraybuffer'};

		$http.get(path, config).then(function(response){

			var file = new Blob([response.data], { type: 'application/zip'});

			var filename = "ImpresosFichaTecnica_" + id_ficha_tecnica.replace("/","-") +".zip";
			if(response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};
	
	$scope.imprimirFtProducto = function () {
		var path = cfg.baseURL + "impresos/ImpresoProducto/?idft=" + id_ficha_tecnica + "&ean=" + ean + "&docformat=" + $scope.datos.tipo_doc + "&reducido=" + $scope.reducida; 
		if($scope.idioma)
			path+= "&idioma="+$scope.idioma;

    var config = { responseType: 'arraybuffer' };
    $http.get(path, config).then(function (response) {
      var file;
			var filename = ean + "_" + id_ficha_tecnica.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'-');

      if ($scope.datos.tipo_doc == "PDF") {
        file = new Blob([response.data], { type: 'application/pdf' });
        filename = filename + ".pdf";
      }
      else {
        file = new Blob([response.data], { type: 'application/ms-word' });
        filename = filename + ".doc";
      }
      if (response.headers('Content-Disposition')) {
        // filename = response.headers('Content-Disposition').split("=")[1];
				filename = response.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }

      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };
	
	$scope.impresionMasivaFT = function () {
    var params = { docformat: $scope.datos.tipo_doc, reducido: $scope.reducida };
		if($scope.idioma)
			params.idioma = $scope.idioma;

    params.lista_productos = lista_productos;

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "impresos/ImpresionMasivaProductos", params, config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ft_analiticas.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });

  }
}]);

angular.module('FTBase').controller('DesbloquearMasivamentePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', '$q', '$timeout', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService, $q, $timeout){
	$scope.status = { editing: true };
	$scope.data = {};
    $scope.data.id_ficha_tecnicas = $scope.$resolve.id_ficha_tecnicas;
    $scope.tipoFT = $scope.$resolve.tipoFT;

    $scope.loadBloquearDesbloquear = function () {
		var deferred = $q.defer();
		$timeout(function () {
			var list = [];
			list.push({ id: 1, nombre: "Bloquear"});
			list.push({ id: 0, nombre: "Desbloquear" });
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;
	};

	$scope.save = function(){
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/DesbloquearFTMasivamente" , $scope.data).then(function(response){
			$uibModalInstance.close(response);
		}, function(err){
			ixStatusService.setResponse(err);
		});
	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close();
	}

}]);

angular.module('FTBase').controller('AddFtPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'ixStatusService', '$q', 'idiomasFT', function($scope, cfg, $http, $uibModalInstance, ixStatusService, $q, idiomasFT){
  $scope.status = {editing: true};
  // $scope.newIdFicha;

	$scope.loadIdiomas = function(param){
		var deferral = $q.defer();
    deferral.resolve({
        data: idiomasFT
    });
    return deferral.promise;
	};

  $scope.save = function(){
    //Crear nueva FT.
    $http.post(cfg.baseURL + "extranet_fichas_tecnicas", $scope.nuevaft).then(function (r) {
      ixStatusService.setResponse(r);
      // $scope.ixCancelEdit();
      $scope.newIdFicha = r.data.obj.Record.id;
      $uibModalInstance.close(r.data.obj.Record.id);
      //Abro nueva FT generada
    },
    function (error) {
      ixStatusService.setResponse(error);
    });
  }

  // $scope.$close = function () {
	// 	$uibModalInstance.dismiss('cancel');
	// };
  //
  // $scope.dismiss = function(){
  //   $uibModalInstance.close({ response: $scope.newIdFicha });
  // }
}]);

/*global angular*/
/*global buildIxSearch*/
/*global CMP_EQ*/
/*global saveAs*/
/*global ixGetPatchOperations*/
"use strict"

angular.module("FTBase").controller("AddDocumentosAnaliticaFtPopupController", ['$scope', '$uibModalInstance', '$http', 'cfg', 'gridService', '$filter', 'ixStatusService', 'ixUtilsService', '$q', '$timeout', 'Upload', '$translate', 'authService', function ($scope, $uibModalInstance, $http, cfg, gridService, $filter, ixStatusService, ixUtilsService, $q, $timeout, Upload, $translate, authService) {

    $scope.status = ixStatusService.current;
    $scope.status.editing = true;
    $scope.data = {};
    $scope.data.tipo_analisis = $scope.$resolve.tipo_analisis;
    $scope.data.id_analisis = $scope.$resolve.id_analisis;
    $scope.fileUploaded = false;

    $scope.save = function () {
        var fileNames = [];
        angular.forEach($scope.data.filesToUpload, function (elem) {
            fileNames.push(elem.name);
        });


        $http.post(cfg.baseURL + "ft_analiticas/CanUpload/" + $scope.data.id_analisis + "/" + $scope.data.datos.tipo, fileNames).then(function (response) {
            if (response.data.GlobalMessage.ErrType == 0) {
                var upload = Upload.upload({
                    url: cfg.baseURL + "ft_analiticas/UploadAndCreate/" + $scope.data.id_analisis + "/" + $scope.data.datos.tipo,
                    data: { file: $scope.data.filesToUpload },
                    dataType: 'json'
                });

                upload.then(function (response) {
                    if (response.data) {
                        delete $scope.ixProgress;
                        $scope.fileUploaded = true;
                        $scope.data.filesToUpload = null
                        $scope.data.datos.tipo = null
                    }
                }, function (error) {
                    delete $scope.data.ixProgress;
                    ixStatusService.setResponse(error);
                }, function (evt) {
                    // Math.min is to fix IE which reports 200% sometimes
                    //file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                    $scope.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            } else {
                ixStatusService.setResponse(response);
            }
        }, function (err) {
            ixStatusService.setResponse(err);
        });
    }

    $scope.$dismiss = function () {
        $uibModalInstance.close($scope.fileUploaded);
    };


}]);
/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroProveedorController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_proveedor', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_proveedor_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroProveedorController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_proveedor");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_proveedor", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_proveedor/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroProveedorController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroLaboratorioController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_laboratorio', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_laboratorio_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroLaboratorioController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_laboratorio");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_laboratorio/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_laboratorio", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.updTipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_laboratorio/' + $scope.data.datos[$scope.data.pk], data.updTipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + ", desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_laboratorio/" + $scope.data.datos[$scope.data.pk]).then(function(r){
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_laboratorio/traducciones_tipos_fichero_laboratorio.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroLaboratorioController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroFtController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_ft', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_ft_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroFtController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_ft");
  }
  $scope.data.pk = "id";
	$scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_ft/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_ft", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_ft/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_ft/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_ft/traducciones_tipos_fichero_ft.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroFtController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }


  }]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposCertificadosProveedorController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_certificados_proveedor");
  }
  $scope.data.pk = "id";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_certificados_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_certificados_proveedor", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.tipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_certificados_proveedor/' + $scope.data.datos[$scope.data.pk], data.tipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo certificado " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_certificados_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

  }]);

/*global CMP_EQ*/
"use strict"

angular.module('FTBase').controller("TraduccionesTiposAnalisisController", ['$scope', 'gridService', function($scope, gridService){
	$scope.status = {
		editing: true
	};

  $scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  /* FUNCTIONS */
  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_analisis', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_analisis_idioma");
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
    }

    filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
    $scope.grid.filtroExterno = filtroEstado;
    $scope.grid.ixLoadInitialData();
  };


  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  };


  $scope.crearGrid();


  $scope.save = function(){
    $scope.grid.ixGuardar();
  };


  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  };

	$scope.$on("$destroy", function() {
		if(angular.isDefined($scope.grid))
			$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
"use strict"

angular.module('FTBase').controller("TiposAnalisisController", ['$scope', '$http', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', 'ixWarningsService', '$log', function($scope, $http, $translate, cfg, ixStatusService, ixUtilsService, ixWarningsService, $log){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_analisis");
  }

  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.actualizarListado();

  /* FUNCTIONS */
  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_analisis/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);


  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_analisis", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } 
    else {
      //Editar tipo.
      data.updTipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_analisis/' + $scope.data.datos[$scope.data.pk], data.updTipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo de análisis " + $scope.data.datos.descripcion + ", desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};


	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_analisis/" + $scope.data.datos[$scope.data.pk]).then(function(r){
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  };


  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_analisis/traducciones_tipos_analisis.html";
		var optionsPopup = { controller: "TraduccionesTiposAnalisisController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  };

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
/*global saveAs*/


angular.module('FTBase').controller("ProveedoresController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$location', '$timeout', '$log', '$q', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $location, $timeout, $log, $q, ixUtilsService, ixWarningsService, authService) {

	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;
	$scope.isUserKeyBiotecnal = false;

	var usuario = authService.authentication.userName;
	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
		if ($scope.extranetUser.cliente != null) {
			$scope.ixEditar = undefined;
			$scope.status.editing = false;
			$scope.$parent.$parent.$parent.addNewItem = undefined;
		}
		if ($scope.extranetUser.proveedor != null) {
			$scope.blockMainDetails = true;
			$scope.$parent.$parent.$parent.addNewItem = undefined;
			$scope.data.ocultaExportarList = true;
		}
		if ($scope.extranetUser.cliente == null && $scope.extranetUser.proveedor == null && $scope.extranetUser.laboratorio == null) {
			$scope.isUserKeyBiotecnal = true;
		}
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	if (!$scope.data.metadataForm) {
		$scope.loadMetadata("proveedores");
	}

	if (!$scope.data.activeTab) {
		$scope.data.activeTab = 0;
	}

	$scope.data.pk = "proveedor";
	$scope.data.useModel = true;
	$scope.data.fieldsToOrderBy = ["nombre ASC"];
	$scope.data.fieldsToFilter = ["nombre"];

	$scope.$parent.filters[0].onNew = function () {
		var nuevo = {};
		nuevo[$scope.data.pk] = "0";
		nuevo.isNew = true;
		$scope.data.datos = {};
		$scope.data.datos = nuevo;

		// $scope.crearGridCertificadosProveedor();
		$scope.crearGridFabricantes();
		$scope.crearGridFicheros();

		return nuevo;
	};

	$scope.$watch('current', function (current) {
		// if ($scope.data.cancelEdit) {
		// 	$scope.data.cancelEdit = false;
		// }
		if (!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
			$http.get(cfg.baseURL + "proveedores/" + current[$scope.data.pk]).then(function (response) {

				$scope.data.datos = response.data;
				$scope.data.datosOriginales = angular.copy(response.data);

				// $scope.crearGridCertificadosProveedor();
				$scope.crearGridFabricantes();
				$scope.crearGridFicheros();

			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	}, true);

	//Preguntar a Arnau si es correcto mantener las lineas 81-84
	if (angular.isDefined($routeParams.id)) {
		$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.id;
	}
	if (angular.isDefined($routeParams.proveedor)) {
		$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.proveedor;
	}

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
		var data = {};
		if ($scope.data.datos.isNew) {
			data.nuevoProveedor = $scope.data.datos;
			//data.nuevosCertificados = $scope.data.gridCertificadosProveedor.data;

			$http.post(cfg.baseURL + "proveedores", $scope.data.datos).then(function (r) {
				//$http.post(cfg.baseURL + "proveedores/PostProveedor", data).then(function (r) {
				delete $scope.data.datos.isNew;
				ixStatusService.setResponse(r);
				ixStatusService.setEditing(false);
				//$scope.ixCancelEdit();
				// if ($scope.data.gridCertificadosProveedor.gridApi)
				// 	$scope.data.gridCertificadosProveedor.clearGridAfterSave();
				$scope.data.datos.proveedor = r.data.obj.Record.proveedor;
				// $scope.data.gridCertificadosProveedor.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }, { Field: 'fabricante', Value: null, Operator: CMP_ISNULL }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		} else {
			//Editar proveedor.
			data.jpdProveedor = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

			//data.ubpCertificados = $scope.data.gridCertificadosProveedor.ixGetBulkParam();
			data.ubpFabricantes = $scope.data.gridFabricantes.ixGetBulkParam();
			data.ubpFicheros = $scope.data.gridFicheros.ixGetBulkParam();

			$http.put(cfg.baseURL + "proveedores/PutProveedor/" + $scope.data.datos.proveedor, data).then(function (r) {
				ixStatusService.setResponse(r);
				ixStatusService.setEditing(false);

				if ($scope.data.gridFabricantes.gridApi)
					$scope.data.gridFabricantes.clearGridAfterSave();
				// if ($scope.data.gridCertificadosProveedor.gridApi)
				// 	$scope.data.gridCertificadosProveedor.clearGridAfterSave();
				if ($scope.data.gridFicheros.gridApi)
					$scope.data.gridFicheros.clearGridAfterSave();

				$scope.ixCancelEdit();
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		}
	};

	$scope.ixDeleteSelectedRows = function () {
		var frase = "¿Se va a eliminar el proveedor " + $scope.data.datos.nombre + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope, frase, accionEliminar);
	}

	var accionEliminar = function () {
		$http.delete(cfg.baseURL + "proveedores/" + $scope.data.datos[$scope.data.pk]).then(function (r) {
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);

			$scope.data.datos = {};
			$scope.data.gridFabricantes.data = {};
			// $scope.data.gridCertificadosProveedor.data = {};
			$scope.data.gridFicheros.data = {};

			$scope.ixCancelEdit();
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}

	$scope.changeTab = function (tabIdx) {
		if (angular.isDefined($scope.data.gridFabricantes) && $scope.data.activeTab != 1) {
			$scope.data.gridFabricantes.ixSaveConfig();
		}

		$scope.data.activeTab = tabIdx;
		// switch (tabIdx) {
		// 	case 2:
		// 		//$scope.crearGridFabricantes();
		// 		break;
		// }

		switch(tabIdx){
			case 1:
				$timeout(function(){
					$scope.data.gridFabricantes && $scope.data.gridFabricantes.gridApi && 
					$scope.data.gridFabricantes.gridApi.core.handleWindowResize();
				},300);
			break;

			case 2:
				$timeout(function(){
					$scope.data.gridFicheros && $scope.data.gridFicheros.gridApi && 
					$scope.data.gridFicheros.gridApi.core.handleWindowResize();
				},300);
		}
		
	};

	$scope.crearGridFabricantes = function () {
		var metadata = [];
		var filtroFabricantes = [];
		if (!$scope.data.gridFabricantes) {
			var acciones = [
				{
					icon: "fa-search",
					title: "Fabricante",
					visible: function (entity) {
						return true;//!$scope.data.datos.isNew;
					},
					accion: function (entity) {
						abrirPopupFabricante(entity, false);
					}
				}
			];
			$scope.data.gridFabricantes = gridService.createGrid($scope, 'gnet_grid_proveedores_fabricantes', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "fabricantes", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		} else {
			$scope.data.gridFabricantes = gridService.createGridFunctions($scope, $scope.data.gridFabricantes);
			$scope.data.gridFabricantes.ixRestoreConfig();
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		}
	}

	$scope.esVigente = function(fechaCaducidad) {
		if (!fechaCaducidad) {
			return true;
		}
		
		var fechaLimite = new Date(fechaCaducidad);
		var hoy = new Date();
		
		fechaLimite.setHours(0, 0, 0, 0);
		hoy.setHours(0, 0, 0, 0);
		
		return fechaLimite >= hoy;
	};

	$scope.crearGridFicheros = function () {
		var metadata = [
			{ Name: 'archivo', NoEditable: true },
			{ Name: 'tipo', NoEditable: true },
			// { Name: 'inicio_validez', NoEditable: true },
			// { Name: 'fecha_caducidad', NoEditable: true },
			{ Name: 'archivado', NoEditable: !$scope.isUserKeyBiotecnal }
		];
		var filtroFicheros = [];
		if (!$scope.data.gridFicheros) {
			var acciones = [
				{
					title: "Previsualizar PDF",
					icon: "fa-file-pdf-o",
					visible: function (entity) {
						return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http({
							method: 'post',
							url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
							headers: {},
							responseType: 'arraybuffer'
						}).then(function (r) {
							$scope.selectedPDF = new Uint8Array(r.data);
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title: "Previsualizar Imagen",
					icon: "fa-file-image-o",
					visible: function (entity) {
						return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
							$scope.selectedImage = r.data;
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title: "Descargar fichero",
					icon: "fa-download",
					visible: function (entity) {
						return entity.archivo;
					},
					accion: function (entity) {
						var esProveedor = angular.isDefined(entity.proveedor);
						$scope.downloadFile(entity.id, esProveedor);
					}
				},
				{
					icon: "fa-retweet",
					title: "Sustituir/Actualizar",
					visible: function (entity) {
						return (entity.archivado == 0);
					},
					accion: function (entity) {
						$scope.sustituirFicheros(entity);
					}
				}
			];
			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': !(grid.appScope.esVigente(row.entity.fecha_caducidad)), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			$scope.data.gridFicheros = gridService.createGrid($scope, 'gnet_grid_proveedores_ficheros', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			$scope.data.gridFicheros.rowTemplate = rowTemplate;	
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		} else {
			$scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
			$scope.data.gridFicheros.ixRestoreConfig();
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		}
	}

	$scope.deleteSelectedRows = function (grid) {
		// if (grid.gridName == "gnet_grid_proveedores_fabricantes")
		// 	grid.ixDeleteSelectedRows(); //¿Poner Alerta de eliminación?
		// 	else
		grid.ixDeleteSelectedRows();
	};

	$scope.addRow = function (grid, item) {
		var nuevo = item || {};

		if (grid.entity == 'fabricantes') {
			nuevo.proveedor = $scope.data.datos.proveedor;
			abrirPopupFabricante(nuevo, true);
		}
		// if (grid.entity == 'proveedores_certificados') {
		// 	nuevo.id = 0;
		// }
		grid.ixAddRow(nuevo);
	};

	$scope.addFicheros = function () {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_proveedor": $scope.data.datos.proveedor };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			// Recargar grid de ficheros
			$scope.data.gridFicheros.ixLoadInitialData();
		});
	};


	$scope.sustituirFicheros = function (entity) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = {
			"id_proveedor": $scope.data.datos.proveedor,
			"grupo": entity.grupo,
			"fabricante": entity.fabricante,
			"planta": entity.planta,
			"sustituir": entity.id,
			"tipoFichero": entity.tipo,
			"alcance": entity.alcance
		};
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			// Recargar grid de ficheros
			$scope.data.gridFicheros.ixLoadInitialData();
		});
	};

	var abrirPopupFabricante = function (entity, isNew) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/fabricantesPopup.html";
		var controllerName = "FabricantesPopupController";
		var optionsPopupFabricante = {
			controller: controllerName,
			resolve: {
				clickedItem: function () {
					return entity;
				},
				isNew: function () {
					return isNew;
				}
			}
		};
		var params = { "clickedItem": entity, "isNew": isNew, "bloqueado": $scope.data.datos.bloqueado, "extranetUser": $scope.extranetUser, "statusEditingoriginal": $scope.status.editing };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFabricante, 'medium', params);
		var statusEditingOriginal = $scope.status.editing;
		modalInstance.then(function (resp) {
			if (resp.dataModified) {
				$scope.data.gridFabricantes.ixLoadInitialData();
				$scope.data.gridFicheros.ixLoadInitialData();
			}
			//Ripristinar $scope.status.editing original
			$scope.status.editing = statusEditingOriginal;
		});
	};


	var checkDifferences = function (entity, property, finalValue, originalValue) {
		if (finalValue != originalValue) {
			if (angular.isUndefined(entity.modifiedValues)) entity.modifiedValues = [];
			if (entity.modifiedValues.indexOf(property) == -1)
				entity.modifiedValues.push(property);
		}
	};

	//Aplica los cambios en la row de fabricante añadiendole los cambios al array "modifiedValues" que luego utilizara el ixGetBulkParam para crear el item de updatebulk.
	var modificacionFabricante = function (entity, resp) {
		checkDifferences(entity, "razon_social", entity.razon_social, resp.razon_social);
		checkDifferences(entity, "cif", entity.cif, resp.cif);
		checkDifferences(entity, "direccion", entity.direccion, resp.direccion);
		checkDifferences(entity, "cp", entity.cp, resp.cp);
		checkDifferences(entity, "localidad", entity.localidad, resp.localidad);
		checkDifferences(entity, "provincia", entity.provincia, resp.provincia);
		checkDifferences(entity, "pais", entity.pais, resp.pais);
		checkDifferences(entity, "telefono", entity.telefono, resp.telefono);
		checkDifferences(entity, "fax", entity.fax, resp.fax);
		checkDifferences(entity, "email", entity.email, resp.email);
		checkDifferences(entity, "reg_sanitario", entity.reg_sanitario, resp.reg_sanitario);
		checkDifferences(entity, "acreditaciones_certificados", entity.acreditaciones_certificados, resp.acreditaciones_certificados);
	};


	var modifiedBulkParam = function (gridOptions) {
		var bulkParam = {
			ToInsert: [],
			ToUpdate: [],
			ToDelete: []
		};

		if (gridOptions.gridApi) {
			var dirtyRows = gridOptions.gridApi.rowEdit.getDirtyRows();
			dirtyRows.forEach(function (row) {
				// if(row.entity.manuallyAdded) delete row.entity.manuallyAdded;
				if (gridOptions.insertedRows.indexOf(row.entity) >= 0) {
					// delete(row.entity.isNew);
					bulkParam.ToInsert.push(row.entity);
				} else {
					bulkParam.ToUpdate.push({
						PK: gridOptions.buildPK(row.entity),
						PocoToUpdate: gridOptions.getPatchOperations(row.entity)
					});
				}
			});
			gridOptions.deletedRows.forEach(function (data) {
				bulkParam.ToDelete.push(gridOptions.buildPK(data));
			});
		}

		return bulkParam;
	}

	$scope.ixCancelEdit = function () {
		if (angular.isDefined($scope.data.gridFabricantes.gridApi))
			$scope.data.gridFabricantes.clearGridAfterSave();
		$scope.$parent.ixCancelEdit();
	}

	$scope.downloadFile = function (id, esProveedor) {
		var entity = (esProveedor) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
		$http({
			method: 'post',
			url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
	};

	$scope.$on("$destroy", function() {
		if(angular.isDefined($scope.data.gridFabricantes))
			$scope.data.gridFabricantes.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesFtEstadosController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.cod_estado = $scope.$resolve.cod_estado;
  $scope.descripcion = $scope.$resolve.descripcion;
  $scope.posicion = $scope.$resolve.posicion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.codigo = $scope.cod_estado;
    nuevo.posicion = $scope.posicion;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_estados', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "ft_estados_idioma");
      filtroEstado = [{ Field: 'codigo', Value: $scope.cod_estado, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'codigo', Value: $scope.cod_estado, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Ft_EstadosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', 'ixUtilsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService, ixUtilsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  //$scope.$parent.$parent.$parent.buscar = "ft_estados";//nombre de la clase que hay que utilizar para cargar el grid de resultados.

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_estados");
  }
  $scope.data.pk = "codigo";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "codigo", "descripcion" ];
  $scope.data.fieldsToOrderBy = ["posicion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "ft_estados/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //data = ViewBuilderService.getChangesTables();
      data.nuevoEstado = $scope.data.datos;

      //Crear nueva marca.
      $http.post(cfg.baseURL + "ft_estados", data.nuevoEstado).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar estado.
      data.estado = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'ft_estados/' + $scope.data.datos[$scope.data.pk], data.estado).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el estado " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "ft_estados/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

  $scope.openPopupTraduccion = function(cod){
    $log.log(cod);
		var template = "app/FTBase/Mantenimientos/ft_estados/traducciones_ft_estados.html";
		var optionsPopup = { controller: "TraduccionesFtEstadosController" };
		var paramsPopup = { cod_estado: $scope.data.datos.codigo, descripcion: $scope.data.datos.descripcion, posicion: $scope.data.datos.posicion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller("LaboratoriosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if (!$scope.data.metadataForm) {
    $scope.loadMetadata("laboratorios");
  }

  if (!$scope.data.activeTab) {
    $scope.data.activeTab = 0;
  }

  $scope.data.pk = "id_laboratorio";
  $scope.data.showAsID = "nombre";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = ["nombre"];
  $scope.data.fieldsToOrderBy = ["nombre"];

  $scope.$parent.filters[0].onNew = function () {
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridContactos();
    $scope.crearGridFicheros();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if ($scope.data.cancelEdit) {
      $scope.data.cancelEdit = false;
    }
    if (!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
    else {
      if (angular.isDefined($scope.data.activeTab)) {
        switch ($scope.data.activeTab) {
          case 0:
            if (angular.isDefined($scope.data.gridContactos)) $scope.data.gridContactos.ixSaveConfig();
            break;
          case 1:
            if (angular.isDefined($scope.data.gridFicheros)) $scope.data.gridFicheros.ixSaveConfig();
            break;
        }
      }

      $http.get(cfg.baseURL + "laboratorios/" + current[$scope.data.pk]).then(function (response) {

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridContactos();
        $scope.crearGridFicheros();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  $scope.changeTab = function (tabIdx) {
    if (angular.isDefined($scope.data.gridContactos) && $scope.data.activeTab == 0)
      $scope.data.gridContactos.ixSaveConfig();
    if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 1)
      $scope.data.gridFicheros.ixSaveConfig();

    $scope.data.activeTab = tabIdx;

    if (angular.isDefined($scope.data.gridContactos) && $scope.data.activeTab == 0)
      $scope.data.gridContactos.ixRestoreConfig();
    if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 1)
      $scope.data.gridFicheros.ixRestoreConfig();
  };


  $scope.crearGridContactos = function () {
    var metadata = [];

    if (!$scope.data.gridContactos) {
      $scope.data.gridContactos = gridService.createGrid($scope, 'gnet_grid_contactoslab', { minRowsToShow: 5, metadata: metadata }, "laboratorios_contactos");
      // $scope.data.gridContactos.filtroExterno = [ { Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
      // $scope.data.gridContactos.ixLoadInitialData();
    }
    else {
      $scope.data.gridContactos = gridService.createGridFunctions($scope, $scope.data.gridContactos);
      $scope.data.gridContactos.ixRestoreConfig();
    }

    $scope.data.gridContactos.filtroExterno = [{ Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
    $scope.data.gridContactos.ixLoadInitialData();
  };


  $scope.addRowContactos = function () {
    var nuevo = {};
    nuevo.laboratorio = $scope.data.datos.id_laboratorio;
    $scope.data.gridContactos.ixAddRow(nuevo);
  };


  $scope.addFicherosPopup = function () {
    var urlTemplate = "app/FTBase/Mantenimientos/laboratorios/modales/popupFicheroLaboratorio.html";
    var controllerName = "PopupFicheroLaboratorioController";
    var optionsPopupFicheros = {
      controller: controllerName
    };
    var params = { "idFichero": 0, "idLab": $scope.data.datos.id_laboratorio, "mantenimiento_lab": true };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
    modalInstance.then(function (resp) {
      if (resp) {
        // Recargar grid de ficheros
        $scope.data.gridFicheros.ixLoadInitialData();
      }
    });

  };


  $scope.deleteSelectedRows = function (grid) {
    grid.ixDeleteSelectedRows();
  };


  $scope.crearGridFicheros = function () {
    var metadata = [];
    var acciones = [
      {
        title: "Descargar fichero",
        icon: "fa-download",
        accion: function (entity) {
          downloadFile(entity);
        }
      }
    ];

    if (!$scope.data.gridFicheros) {
      $scope.data.gridFicheros = gridService.createGrid($scope, 'gnet_grid_ficheroslab', { enableCellEdit: false, compruebaAlarmaFunc: $scope.compruebaCaducidadFichero, minRowsToShow: 5, metadata: metadata }, "laboratorios_ficheros", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
      $scope.data.gridFicheros.ixRestoreConfig();
    }

    $scope.data.gridFicheros.filtroExterno = [{ Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
    $scope.data.gridFicheros.ixLoadInitialData();
  };

  $scope.compruebaCaducidadFichero = function (row) {
    if (row.entity.fecha_caducidad)
      return row.entity.fecha_caducidad < Date.now();
    else
      return false;

  };


  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo laboratorio.
      $http.post(cfg.baseURL + "laboratorios", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar laboratorio.
      data.jpdLaboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      if ($scope.data.gridContactos) data.ubpContactos = $scope.data.gridContactos.ixGetBulkParam();
      if ($scope.data.gridFicheros) data.ubpFicheros = $scope.data.gridFicheros.ixGetBulkParam();

      $http.put(cfg.baseURL + 'laboratorios/Modificalaboratorio/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        if ($scope.data.gridContactos)
          $scope.data.gridContactos.clearGridAfterSave();
        if ($scope.data.gridFicheros)
          $scope.data.gridFicheros.clearGridAfterSave();
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function () {
    var frase = "¿Se va a eliminar el laboratorio " + $scope.data.datos.nombre + " , desea continuar?";
    ixWarningsService.warningConfirmacion($scope, frase, accionEliminar);
  }

  var downloadFile = function (entity) {
    $http({
      method: 'post',
      url: cfg.baseURL + 'laboratorios_ficheros/DownloadFile?id=' + entity.id,
      headers: { 'Content-type': 'application/pdf' },
      responseType: 'arraybuffer'
    }).then(function (r) {
      var file = new Blob([r.data], { type: r.headers('Content-type') });

      var filename = entity.archivo + ".pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    },
      function (err) {
        ixStatusService.setResponse(err);
      });
  };


  var accionEliminar = function () {
    $http.delete(cfg.baseURL + "laboratorios/" + $scope.data.datos[$scope.data.pk]).then(function (r) {

      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }

  $scope.$on("$destroy", function () {
    if (angular.isDefined($scope.data.gridContactos))
      $scope.data.gridContactos.ixSaveConfig();

    if (angular.isDefined($scope.data.gridFicheros))
      $scope.data.gridFicheros.ixSaveConfig();

    $scope.isDestroyed = true;
  });


}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Extranet_MarcasController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("extranet_marcas");
  }

  $scope.data.pk = "id";
	$scope.data.showAsID = "marca";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "marca", "propietarionombre" ];
  $scope.data.fieldsToOrderBy = ["marca"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "extranet_marcas/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //data = ViewBuilderService.getChangesTables();
      data.nuevaMarca = $scope.data.datos;

      //Crear nueva marca.
      $http.post(cfg.baseURL + "extranet_marcas", data.nuevaMarca).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar marca.
      data.marca = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'extranet_marcas/' + $scope.data.datos[$scope.data.pk], data.marca).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar la marca " + $scope.data.datos.marca + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "extranet_marcas/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("DiccionariosController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("diccionarios");
  }
  $scope.data.pk = "diccionario";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "descripcion" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridDiccionariosValores();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "diccionarios/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridDiccionariosValores();

        // var filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
        // $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
        // $scope.data.gridDiccionariosValores.ixLoadInitialData();

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    $scope.actualizarPosiciones();
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo diccionario.
      data.nuevoDiccionario = $scope.data.datos;
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.post(cfg.baseURL + "diccionarios/PostDiccionario", data).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar diccionario.
      data.jpdDiccionario = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.put(cfg.baseURL + 'diccionarios/PutDiccionario/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixCancelEdit = function(){
    $scope.$parent.ixCancelEdit();
    $scope.data.gridDiccionariosValores.clearGridAfterSave();
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el diccionario " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "diccionarios/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
      $scope.data.gridDiccionariosValores.clearGridAfterSave(true);
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	$scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

	$scope.addRow = function(grid, item){
		var nuevo = item || {};

		nuevo.diccionario = $scope.data.datos.diccionario;
		grid.ixAddRow(nuevo);
  };






  $scope.crearGridDiccionariosValores = function(){
    if(!$scope.data.gridDiccionariosValores){
      var metadata = [];
      var filtroDiccionariosValores = [];
      var acciones = [
        {
          icon: "fa-arrows-alt",
          title: "Ordenar filas",
          visible: function(entity){
            return $scope.status.editing;
          },
          accion: function(entity){ return true; }
        }
      ];
      var extraColumns = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }];
      $scope.data.gridDiccionariosValores = gridService.createGrid($scope, 'gnet_grid_diccionarios_valores', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: false, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "diccionarios_valores",  extraColumns);
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, Skip: true }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
      //$scope.data.gridDiccionariosValores.drawExtraColumns(extraColumns);
    } else {
      $scope.data.gridDiccionariosValores = gridService.createGridFunctions($scope, $scope.data.gridDiccionariosValores);
      $scope.data.gridDiccionariosValores.ixRestoreConfig();
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, Skip: true }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
    }
  }

  $scope.crearGridDiccionariosValores();

    $scope.actualizarPosiciones = function(){
      $scope.data.gridDiccionariosValores.data.forEach(function(element,index){

        if(!element.isNew){
          if(element.posicion != index + 1){
            element.posicion = index + 1;
            if(angular.isUndefined(element.modifiedValues)) element.modifiedValues = [];
            if(element.modifiedValues.indexOf("posicion") == -1)
      				element.modifiedValues.push("posicion");
            $scope.data.gridDiccionariosValores.gridApi.rowEdit.setRowsDirty([element]);
          }
        }else{
          element.posicion = index + 1;
        }

      })
    }


  $scope.ordenarValores = function(){
    function compare( a, b ) {
      if ( a.valor < b.valor ){
        return -1;
      }
      if ( a.valor > b.valor ){
        return 1;
      }
      return 0;
    }

    $scope.data.gridDiccionariosValores.data.sort( compare );
  }

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

  angular.module('FTBase').controller("DiccionariosController", ['$scope', '$http', '$translate', 'cfg', 'ixStatusService', 'gridService', 'ixWarningsService', function ($scope, $http, $translate, cfg, ixStatusService, gridService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("diccionarios");
  }
  $scope.data.pk = "diccionario";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "descripcion" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = undefined;
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridDiccionariosValores();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "diccionarios/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridDiccionariosValores();
      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    $scope.actualizarPosiciones();
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo diccionario.
      data.nuevoDiccionario = $scope.data.datos;
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.post(cfg.baseURL + "diccionarios/PostDiccionario", data).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar diccionario.
      data.jpdDiccionario = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.put(cfg.baseURL + 'diccionarios/PutDiccionario/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixCancelEdit = function(){
    $scope.$parent.ixCancelEdit();
    $scope.data.gridDiccionariosValores.clearGridAfterSave();
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el diccionario " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "diccionarios/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
      $scope.data.gridDiccionariosValores.clearGridAfterSave(true);
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	$scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

	$scope.addRow = function(grid, item){
		var nuevo = item || {};

		nuevo.diccionario = $scope.data.datos.diccionario;
		grid.ixAddRow(nuevo);
  };


  $scope.crearGridDiccionariosValores = function(){
    if(!$scope.data.gridDiccionariosValores){
      var metadata = [];
      var filtroDiccionariosValores = [];
      var acciones = [
        {
          icon: "fa-arrows-alt",
          title: $translate.instant("Ordenar filas"),
          visible: function(entity){
            return $scope.status.editing;
          },
          accion: function(entity){ return true; }
        }
      ];
      var extraColumns = [{ name: $translate.instant('Acciones'), type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }];
      $scope.data.gridDiccionariosValores = gridService.createGrid($scope, 'gnet_grid_diccionarios_valores', { minRowsToShow: 20, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: false, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "valores_diccionariosVM",  extraColumns);
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
      //$scope.data.gridDiccionariosValores.drawExtraColumns(extraColumns);
    } else {
      $scope.data.gridDiccionariosValores = gridService.createGridFunctions($scope, $scope.data.gridDiccionariosValores);
      $scope.data.gridDiccionariosValores.ixRestoreConfig();
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
    }
  }

  $scope.crearGridDiccionariosValores();

    $scope.actualizarPosiciones = function(){
      $scope.data.gridDiccionariosValores.data.forEach(function(element,index){

        if(!element.isNew){
          if(element.posicion != index + 1){
            element.posicion = index + 1;
            if(angular.isUndefined(element.modifiedValues)) element.modifiedValues = [];
            if(element.modifiedValues.indexOf("posicion") == -1)
      				element.modifiedValues.push("posicion");
            $scope.data.gridDiccionariosValores.gridApi.rowEdit.setRowsDirty([element]);
          }
        }else{
          element.posicion = index + 1;
        }

      })
    }


  $scope.ordenarValores = function(){
    function compare( a, b ) {
      if ( a.valor < b.valor ){
        return -1;
      }
      if ( a.valor > b.valor ){
        return 1;
      }
      return 0;
    }

    $scope.data.gridDiccionariosValores.data.sort( compare );
  }

	$scope.$on("$destroy", function() {
		$scope.data.gridDiccionariosValores.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*global CMP_EQ*/

angular.module('FTBase').controller('TraduccionesDepartamentosController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'ixUtilsService', function ($scope, cfg, gridService, $http, ixStatusService, ixUtilsService) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_departamentos', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "departamentos_idioma");
      filtroEstado = [{ Field: 'codigo', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'codigo', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("DepartamentosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("departamentos");
  }
  $scope.data.pk = "codigo";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "departamentos/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoDepartamento = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "departamentos", data.nuevoDepartamento).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'departamentos/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el área " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};


	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "departamentos/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  };


  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/departamentos/traducciones_departamentos.html";
		var optionsPopup = { controller: "TraduccionesDepartamentosController" };
		var paramsPopup = { id: $scope.data.datos.codigo, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  };


}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("CompradoresController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', '$ngConfirm', 'ixWarningsService',  function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, $ngConfirm, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("compradores");
  }

  $scope.data.pk = "id";
	$scope.data.showAsID = "nombre";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "nombre" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "compradores/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      //data = ViewBuilderService.getChangesTables();
      data.nuevoComprador = $scope.data.datos;

      //Crear nuevo comprador.
      $http.post(cfg.baseURL + "compradores", data.nuevoComprador).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar comprador.
      data.comprador = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'compradores/' + $scope.data.datos[$scope.data.pk], data.comprador).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "Se va a eliminar el comprador " + $scope.data.datos.nombre + " ¿Desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "compradores/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("ClientesController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService',  function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("clientes");
  }

  $scope.data.pk = "cliente";
	$scope.data.showAsID = "nombre";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "referencia", "nombre" ];
  $scope.data.marcas_extra = [];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "clientes/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        //Obtengo la lista de marcas de otros clientes que están permitidas
        $http.get(cfg.baseURL + "clientes/GetMarcasExtra/"+current[$scope.data.pk]).then(function(response){
          $scope.data.marcas_extra = response.data;
          //TODO: Copiar valores originales para verificar si se hacen cambios
        }, function(error){
          ixStatusService.setResponse(error);
        });

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardarOLD = function () {
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      data.nuevoCliente = $scope.data.datos;

      //Crear nuevo cliente.
      $http.post(cfg.baseURL + "clientes", data.nuevoCliente).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar cliente.
      data.cliente = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'clientes/' + $scope.data.datos[$scope.data.pk], data.cliente).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixGuardar = function (){
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      data.nuevoCliente = $scope.data.datos;

      //Crear nuevo cliente.
      $http.post(cfg.baseURL + "clientes", data.nuevoCliente).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar cliente.
      data.id_cliente = $scope.data.datos.cliente;
      data.upd_cliente = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.marcas_permitidas = $scope.data.marcas_extra;

      $http.put(cfg.baseURL + "clientes/ModificarInfoClente", data).then(function(r){
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        //TODO: ¿Actualizar $scope.data.marcas_extra?
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function(error){

      });
    }
  };



	$scope.ixDeleteSelectedRows = function(){
		var frase = "Se va a eliminar el cliente " + $scope.data.datos.nombre + " ¿Desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

  $scope.loadMarcas = function(params){
    //params.Filters.push({ field: 'propietario', value: $scope.data.datos.cliente, op: '0', not: true });
    return $http.post(cfg.baseURL + "extranet_marcas/SearchFromOtherOwners", params);
  };


	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "clientes/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

angular.module('FTBase').controller('PlanificacionAnaliticasController', [ '$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService){
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	//GestPark ofrece la opción de simular. De momento solo actualizaremos.
	$scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

	$scope.init = function(){

		$scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 100 },
				{title: 'EAN', readOnly: false, width: 100 },
				{title: 'LABORATORIO', readOnly: false, width: 110 },
				{title: 'MES', readOnly: false, width: 80 },
				{title: 'AÑO', readOnly: false, width: 80 },
				{title: 'TIPO ANALISIS', readOnly: false, width: 110 },
				{title: 'PARAMETRO', readOnly: false, width: 110 },
				{title: 'UNIDADES', readOnly: false, width: 110 }
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"ean", "2":"laboratorio", "3":"mes", "4":"año", "5":"tipo_analisis", "6":"parametro", "7":"unidades"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "ft_analiticas/TrapasoDatos?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    return dst;
	}

	//================================================
	// Rename Objet's Keys [Direct]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename2(src, map) {
	    var dst = {};
	    // src --> dst
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    // clear src
	    for(var key2 in src){
	        delete src[key2];
	    }
	    // dst --> src
	    for(var key3 in dst){
	        src[key3] = dst[key3];
	    }
	}

		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
	}

}]);

"use strict";

angular.module("FTBase").controller("UploadDocumentoAuditoriaPlantaController", ['$scope', '$uibModalInstance', '$http', 'cfg', 'ixStatusService', 'Upload', function($scope, $uibModalInstance, $http, cfg, ixStatusService, Upload) {
  $scope.status = ixStatusService.current;
  $scope.data = {id_planta: $scope.$resolve.id_planta, id_auditoria: $scope.$resolve.id_auditoria };
  $scope.fileUploaded = false; //El volver a la pantalla de llamada esta variable me permitirá señalar si se ha cargado algún archivo nuevo o no

  ixStatusService.setEditing(true); //Siempre se podrá añadir fichero

  $scope.save = function(){
    var fileNames = [];
    angular.forEach($scope.data.archivosToUpload, function (elem) {
      fileNames.push(elem.name);
    });

    $http.post(cfg.baseURL + 'auditorias_plantas_documentos/CanUpload/' + $scope.data.id_planta + '/' + $scope.data.id_auditoria, fileNames).then(function(response){
      var upload = Upload.upload({
        url: cfg.baseURL + "auditorias_plantas_documentos/UploadAndCreate",
        data: {
          file: $scope.data.archivosToUpload,
          id_planta: $scope.data.id_planta,
          id_auditoria: $scope.data.id_auditoria
        },
        dataType: 'json'
      });

      upload.then(function(resp){
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(response);
        $uibModalInstance.close(true);
      },
      function(err){
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(err);
      },
      function(evt){
        $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };

  $scope.$dismiss = function () {
		$uibModalInstance.close(false);
	};
}]);
angular.module('FTBase').controller('UploadFilePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.tipo = $scope.$resolve.tipo;
	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.especificar_producto = undefined;
	$scope.caducidad_obligatoria = undefined;

	$scope.tipoArchivoSeleccionado = function(entity){
		if (entity){
			$scope.especificar_producto = entity.especificar_producto;
			$scope.caducidad_obligatoria = entity.caducidad_obligatoria;
		}
		else {
			$scope.especificar_producto = undefined;
			$scope.caducidad_obligatoria = undefined;
		}
	};


	$scope.save = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		$http.post(cfg.baseURL + "fichas_tecnicas_ficheros/CanUpload?id_ficha_tecnica="+$scope.id_ficha_tecnica, fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var strProductosSeleccionados = "";
				if ($scope.productoSeleccionado)
					strProductosSeleccionados = $scope.productoSeleccionado.join();
				var upload = Upload.upload({
					url: cfg.baseURL + "fichas_tecnicas_ficheros/UploadAndCreate",
					data: {
						file: $scope.archivosToUpload,
						id_ficha_tecnica: $scope.id_ficha_tecnica,
						tipo: $scope.tipoSeleccionadoFt,
						fecha_caducidad: $scope.fechaCaducidad,
						inicio_validez: $scope.inicioValidez,
						id_producto: strProductosSeleccionados
					},
					dataType: 'json'
				});

				upload.then(function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
						$scope.status.editing = false;
						$uibModalInstance.close(response.data);
					}
				}, function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function(evt){
					$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
			else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});

		// $uibModalInstance.close($scope.data);
	};

	$scope.$close = function () {
		$scope.status.editing = false;
		$uibModalInstance.dismiss('cancel');
	};
	// $scope.getTiposFichero = function(){
	// 	var method;
	// 	if($scope.tipo == "ficheros_ft")
	// 		method = "tipos_fichero_ft";
	// 	else
	// 		method = "tipos_fichero_proveedor";
	//
	// 	return $http.get(cfg.baseURL + method);
	// };
	// $scope.$close = function () {
	// 	$scope.status.editing = false;
	// 	$uibModalInstance.dismiss('cancel');
	// };

	// $scope.hideTipoFicheroFt = function(){
	// 	if($scope.tipo == "ficheros_ft"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };
	//
	// $scope.hideTipoFicheroProveedor = function(){
	// 	if($scope.tipo == "proveedor"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };

}]);

angular.module('FTBase').controller('DuplicarFtPopupController', [ '$scope', '$http', '$ngConfirm', 'cfg', '$uibModalInstance', 'ixStatusService', function($scope, $http, $ngConfirm, cfg, $uibModalInstance, ixStatusService){
  $scope.status = ixStatusService.current;
	$scope.status.editing = true;
  $scope.okBtnText = "Confirmar";
  $scope.ft_origen = $scope.$resolve.ft_origen;
  $scope.version = $scope.$resolve.ft_tipo;
  $scope.nivel_duplicar =  $scope.$resolve.niveles;
  if ($scope.nivel_duplicar == 0) {
    $scope.nivel1 = 0;
    $scope.nivel2 = 0;
  }
  else if ($scope.nivel_duplicar == 1) {
    $scope.nivel2 = 0;
  }

  $scope.save = function(checkdata){
    if (!$scope.nivel1) $scope.nivel1 = 0;
    if (!$scope.nivel2) $scope.nivel2 = 0;

    var warning = true;
    if (angular.isDefined(checkdata) && checkdata == false) warning = false;
    $http.put(cfg.baseURL + "extranet_fichas_tecnicas/DuplicarFT?ft_origen=" + $scope.$resolve.ft_origen + "&ft_destino=" + $scope.ft_destino + "&nivel1=" + $scope.nivel1 + "&nivel2=" + $scope.nivel2 + "&warning=" + warning).then(function(response){
			ixStatusService.setResponse(response);
  	}, function(err){
      if (err.data.GlobalMessage.ErrType == 1){
        $ngConfirm({
          icon: 'fa fa-warning',
          title: 'Aviso',
          content: err.data.GlobalMessage.Msg + ' ¿Desea continuar la operación?',
          scope: $scope,
          closeIcon: false,
          buttons: {
            ok: {
              text: "Continuar",
              btnClass: 'btn-ix-green',
              show: 'true',
              keys: ['enter'], // will trigger when enter is pressed
              action: function(scope){
                $scope.save(false);
                return true;
              }
            },
            cancelar: {
              text: "Cancelar",
              btnClass: 'btn-ix-green',
              show: 'true',
              action: function(scope){
                return true;
              }
            }
          }
        });
      }
      else
  		  ixStatusService.setResponse(err);
  	});

  }
}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('DependenciaEtiquetadoPopupController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', 'ixUtilsService', '$filter', '$timeout', 
function ($scope, cfg, gridService, $http, ixStatusService, authService, $q, ixUtilsService, $filter, $timeout) {
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.tienePerfilRestringido()) {
		$scope.status = {
			editing: true
		};
	}else{
		$scope.status = {
			editing: false
		};
	}

	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.id_pregunta = $scope.$resolve.id_pregunta;
	$scope.pregunta_formulario = $scope.$resolve.pregunta_formulario;
	$scope.bloquear_valor_b = $scope.$resolve.bloquear_valor_b;
	$scope.pregunta_bloqueada = $scope.$resolve.pregunta_bloqueada;
	$scope.modoTraduccion = $scope.$resolve.modo_traduccion;
	$scope.idioma = $scope.$resolve.idioma;
	$scope.traducible = $scope.$resolve.traducible;
	$scope.tablaEnvases = $scope.$resolve.tablaEnvases;
	$scope.pregunta = $scope.$resolve.pregunta;
	$scope.componente = $scope.$resolve.componente; //Me permitirá filtrar sólo por el eventuual componente

	if ($scope.pregunta.pregunta.bucle)
		$scope.activeTabDependenciaEtiquetado = 0;

	var acciones = [];

	$scope.tienePerfilAdmin = function () {
		return authService.tienePerfilAdmin();
	};

	$scope.esGridJerarquico = function () {
		return $scope.tablaEnvases;
	};

	if ($scope.tienePerfilAdmin()) {
		acciones.push({
			icon: "fa-lock",
			title: "Desbloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
		acciones.push({
			icon: "fa-unlock",
			title: "Bloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && !entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
	}

	if($scope.esGridJerarquico()){


		$scope.actualizarGridsSinComponente = function (grid) {
			grid.reloadData = true;

			grid.ixLoadInitialData().then(function (data) {
				$scope.addTreeLevel(grid.data);
				grid.data = $scope.sortGridData(grid.data);
				
				
				$timeout(function(){
					grid.reloadData = false;
					if (grid.gridApi.treeBase){
						grid.gridApi.treeBase.expandAllRows();
					}
					grid.gridApi.core.refresh();
					ixUtilsService.showGrid(grid);
				},300);
			});
		};


		acciones.push({
			icon: "fa-plus",
			title: "Agregar elemento mismo nivel",
			visible: function (entity) {
				if (entity["$$treeLevel"] > 0) {
					var target = $scope.getTargetGrid();
					var respuestas_sn = target.grid.data.filter(function(item){
						return item.orden_bucle === entity.orden_bucle;
					});
					var max_index = respuestas_sn.sort(function(a,b){
						return parseInt(b.orden_tab) - parseInt(a.orden_tab);
					});
					return (entity.orden_tab === max_index[0].orden_tab);
				} 
				else
					return false;
			},
			accion: function (entity, grid) {
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarElementoSubNivel/" + entity.id).then(function (response) {
					var ftd = response.data.obj.Record;
					ftd.orden_sub_bucle = ftd.orden_tab;
					ftd.orden_sub_sub_bucle = ftd.orden_tab2;

					grid.options.ixAddRow(ftd);
					var target = $scope.getTargetGrid();
					$scope.actualizarGridsSinComponente(target.grid);
					// $timeout(function () {
					// 	grid.gridApi.core.refresh();
					// }, 300);
				},
				function(error){
				});
			}
		});
		acciones.push({
			icon: "fa-trash",
			title: "Eliminar línea",
			visible: function(entity){
				return true;
			},
			accion: function(entity, grid){
				var row = entity;
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarElementoTablaJerarquicaSimple/" + entity.id).then(function(response){
					var target = $scope.getTargetGrid();
					$scope.actualizarGridsSinComponente(target.grid);
					$timeout(function () {
						grid.gridApi.core.refresh();
					}, 300);

				},
				function(error){
					ixStatusService.setResponse(error);
				});
			}
		});
	}


	$scope.switchBloqueado = function (bloqueado) {
		if (bloqueado)
			bloqueado = 0;
		else
			bloqueado = 1;
		return bloqueado;
	};


	$scope.changeLockGrid = function (entity) {
		var data = [
			{
				op: "replace",
				path: "/bloqueado",
				value: entity.bloqueado
			}
		];
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

		}, function (err) {
			entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
		});
	};


	if (!$scope.pregunta_bloqueada) {
		$scope.save = function () {
			var target = $scope.getTargetGrid();
			target.grid.ixGuardar().then(function (response) {
				$scope.status.editing = true;
				ixStatusService.setEditing(true);
				$scope.pregunta.respuestas[0].contiene_info_etiquetado = target.grid.data.length > 0;
			});
		};
	}

	//////////////////////REUTILIZADO DE helpers.js. Si no presenta cambios pasar a un service/////////////////////////////////
	$scope.addNewElementsToDictionary = function () {
		//TODO: Descomentar y probar funcionamiento

		// var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		// var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
		//
		// //Para etiquetado por marca siempre agregaremos simplemente valores
		// $scope.pregunta[respuestasProperty].forEach(function(respuesta){
		// 	if ($scope.pregunta[preguntaProperty].diccionario_valores){
		// 		if($scope.pregunta[preguntaProperty].diccionario_valores.indexOf(respuesta.valor) == -1)
		// 			$scope.pregunta[preguntaProperty].diccionario_valores.push(respuesta.valor);
		// 	}
		// }
	};

	var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };

	$scope.addSpecificControl = function (obj, tipo, esJerarquico) {
		var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

		if (esJerarquico && $scope.modoTraduccion && tipo == tiposValor.DICCIONARIO_MULTIPLE)
			tipo = tiposValor.TEXTO;

		if ($scope.modoTraduccion && tipo == tiposValor.TEXTO) {
			if (obj.Name == "valor" && $scope.pregunta.pregunta.traducible) {
				obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			} else {
				var nameColumn = obj.Name.replace("respuesta", "pregunta");
				if ($scope.pregunta[nameColumn + "_traducible"])
					//obj.cellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
					obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
		}

		if (tipo == tiposValor.SINO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			obj.Control = "CheckBox";
			obj.ignoreCellModifications = true;
		}
		else if (tipo == tiposValor.DICCIONARIO || tipo == tiposValor.DICCIONARIO_MULTIPLE) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			if (tipo == tiposValor.DICCIONARIO_MULTIPLE)
				obj.Control = "MultiBusqueda";

			if ($scope.pregunta[respuestasProperty][0].componente && $scope.pregunta[preguntaProperty].diccionario_valores) {
				$scope.addNewElementsToDictionary();
			}
			if (esJerarquico && obj.Name == "valor")
				obj.ColumnFkDescription = "valor";

			obj.Search = {
				"KeyFields": [obj.Name],
				"LookUpTableName": "",
				"LookUpKeyFields": ["codigo"],
				"LookUpResultFields": ["descripcion", "codigo"],
				"LookUpTableAlias": "",
				"LookUpOrders": [{ "KeyField": "descripcion", "Desc": false }],
				"LookUpConditions": []
			};
			obj.busquedaFunction = function (column, param, text) {
				var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var deferr = $q.defer();
				var valores = [];
				var diccionario_valores = [];
				if ($scope.preview)
					diccionario_valores = $scope.pregunta.pregunta.diccionario_valores;
				else {
					var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
					fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
					diccionario_valores = $scope.pregunta[preguntaProperty][fieldToSearch];
				}

				if (text)
					diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

				angular.forEach(diccionario_valores, function (valor) {
					var item = { codigo: valor, descripcion: valor };
					if (column.ColumnFKDescription)
						item[column.ColumnFKDescription] = valor;

					valores.push(item);
				});
				deferr.resolve(valores);
				return deferr.promise;
			};
		}
		else if (tipo == tiposValor.FECHA)
			obj.Type = "DateTime";
		else if (tipo == tiposValor.DECIMAL) {
			obj.Type = "Decimal";
			obj.CommaSeparator = true;
			obj.MaxLength = 11;
		}
		else if (tipo == tiposValor.NUMERICO) {
			obj.Type = "Int32";
			obj.MaxLength = 11;
		}
	};


	$scope.getFakeMetadata = function () {
		var metadata = [];
		metadata.push({ Name: "id", NoVisible: true, Pk: true });
		var valor = { Name: "valor", ColumnDescription: $scope.pregunta_formulario, Type: "String", NoEditable: $scope.estaBloqueadoValor, NoFilterable: true };
		$scope.addSpecificControl(valor, $scope.pregunta.pregunta.tipo_valor, $scope.esGridJerarquico());
		metadata.push(valor);
		if ($scope.pregunta.pregunta.sub_pregunta1) {
			var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta1, $scope.pregunta.pregunta.tipo_valor_sub_pregunta1, $scope.esGridJerarquico());
			metadata.push(sub_pregunta1);
		}
		if ($scope.pregunta.pregunta.sub_pregunta2) {
			var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta2, $scope.pregunta.pregunta.tipo_valor_sub_pregunta2, $scope.esGridJerarquico());
			metadata.push(sub_pregunta2);
		}
		if ($scope.pregunta.pregunta.sub_pregunta3) {
			var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta3, $scope.pregunta.pregunta.tipo_valor_sub_pregunta3, $scope.esGridJerarquico());
			metadata.push(sub_pregunta3);
		}
		if ($scope.pregunta.pregunta.sub_pregunta4) {
			var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta4, $scope.pregunta.pregunta.tipo_valor_sub_pregunta4, $scope.esGridJerarquico());
			metadata.push(sub_pregunta4);
		}
		if ($scope.pregunta.pregunta.sub_pregunta5) {
			var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta5, $scope.pregunta.pregunta.tipo_valor_sub_pregunta5, $scope.esGridJerarquico());
			metadata.push(sub_pregunta5);
		}
		if ($scope.pregunta.pregunta.sub_pregunta6) {
			var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta6, $scope.pregunta.pregunta.tipo_valor_sub_pregunta6, $scope.esGridJerarquico());
			metadata.push(sub_pregunta6);
		}
		if ($scope.pregunta.pregunta.sub_pregunta7) {
			var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta7, $scope.pregunta.pregunta.tipo_valor_sub_pregunta7, $scope.esGridJerarquico());
			metadata.push(sub_pregunta7);
		}
		if ($scope.pregunta.pregunta.sub_pregunta8) {
			var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta8, $scope.pregunta.pregunta.tipo_valor_sub_pregunta8, $scope.esGridJerarquico());
			metadata.push(sub_pregunta8);
		}
		if ($scope.pregunta.pregunta.sub_pregunta9) {
			var sub_pregunta9 = { Name: "sub_respuesta9", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta9, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta9, $scope.pregunta.pregunta.tipo_valor_sub_pregunta9, $scope.esGridJerarquico());
			metadata.push(sub_pregunta9);
		}
		if ($scope.pregunta.pregunta.sub_pregunta10) {
			var sub_pregunta10 = { Name: "sub_respuesta10", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta10, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta10, $scope.pregunta.pregunta.tipo_valor_sub_pregunta10, $scope.esGridJerarquico());
			metadata.push(sub_pregunta10);
		}
		if ($scope.pregunta.pregunta.sub_pregunta11) {
			var sub_pregunta11 = { Name: "sub_respuesta11", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta11, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta11, $scope.pregunta.pregunta.tipo_valor_sub_pregunta11, $scope.esGridJerarquico());
			metadata.push(sub_pregunta11);
		}
		if ($scope.pregunta.pregunta.sub_pregunta12) {
			var sub_pregunta12 = { Name: "sub_respuesta12", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta12, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta12, $scope.pregunta.pregunta.tipo_valor_sub_pregunta12, $scope.esGridJerarquico());
			metadata.push(sub_pregunta12);
		}
		if ($scope.pregunta.pregunta.sub_pregunta13) {
			var sub_pregunta13 = { Name: "sub_respuesta13", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta13, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta13, $scope.pregunta.pregunta.tipo_valor_sub_pregunta13, $scope.esGridJerarquico());
			metadata.push(sub_pregunta13);
		}
		if ($scope.pregunta.pregunta.sub_pregunta14) {
			var sub_pregunta14 = { Name: "sub_respuesta14", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta14, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta14, $scope.pregunta.pregunta.tipo_valor_sub_pregunta14, $scope.esGridJerarquico());
			metadata.push(sub_pregunta14);
		}

		return metadata;
	};

	$scope.getTabs = function () {
		$scope.tabs = undefined;
		if ($scope.pregunta.pregunta.bucle) {
			$http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
				if (response.data) {
					if(response.data.length > 0){
						$scope.tabs = [];
						for (var i = 0; i < response.data.length; i++) {
							$scope.tabs.push({ index: i, valor: response.data[i].marca, nombre: response.data[i].marcanombre });
						}
						$scope.buildGrid($scope.tabs[0]);
					} else
						$scope.buildGrid();
				}
			});
		}
	};


	$scope.cambiarTabDependenciaEtiquetado = function (tab, index) {
		var target = $scope.getTargetGrid();
		target.grid.ixSaveConfig();
		$scope.activeTabDependenciaEtiquetado = index;
		$scope.buildGrid(tab);
	};

	////////////////////////////////////////////////////////////////////////////////

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	$scope.estaBloqueadoValor = function (cell) {
		return ($scope.estaBloqueado(cell)) || $scope.bloquear_valor_b;
	};

	$scope.estaBloqueado = function (cell) {
		return cell.row.entity.bloqueado;
	};

	$scope.noTraducible = function () {
		return $scope.traducible != 1;
	};

	$scope.getCustomHint = function (row, col) {
		return row.entity.valor_original;
	};


	$scope.buildMarcaColumn = function () {
		return {
			Name: "marca",
			NoEditable: $scope.estaBloqueadoValor,
			Required: true,
			overridePreloadedOptions: true,
			busquedaFunction: function (column, param, text, row, config) {
				return $http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
					response.data.forEach(function (data) {
						data.id = data.marca;
						data.marca = data.marcanombre;
					});
					return response.data;
				});
			}
		};
	};

	$scope.buildComponenteColumn = function() {
		return {
			Name: "componente",
			NoEditable: true,
			Required: true,
			overridePreloadedOptions: true			
		};
	};


	var calcularOrdenBucle = function (rowEntity, colDef, newValue, oldValue) {
		if (colDef.field == "marca") {
			var marca = newValue;
			var target = $scope.getTargetGrid();
			var lineasConLaMarca = target.grid.data.filter(function (e) { return e.marca == marca; });
			rowEntity.orden_bucle = (lineasConLaMarca.length);
			if (!rowEntity.modifiedValues)
				rowEntity.modifiedValues = [];
			if (rowEntity.modifiedValues.indexOf("orden_bucle") == -1)
				rowEntity.modifiedValues.push("orden_bucle");

			//Recalculamos ordenes bucle de la marca anterior, para no dejar huecos.
			if (oldValue) {
				var marcaAnterior = oldValue;
				var lineasConMarcaAnterior = target.grid.data.filter(function (e) { return e.marca == marcaAnterior; });
				lineasConMarcaAnterior.forEach(function (linea, idx) {
					var currentOrdenBucle = linea.orden_bucle;
					linea.orden_bucle = (idx + 1);
					if (currentOrdenBucle != linea.orden_bucle) {
						if (!linea.modifiedValues)
							linea.modifiedValues = [];
						if (linea.modifiedValues.indexOf("orden_bucle") == -1)
							linea.modifiedValues.push("orden_bucle");
						target.grid.gridApi.rowEdit.setRowsDirty([linea]);
					}
				});
			}
		}
	};


	$scope.getTargetGrid = function () {
		var target = null;
		if (angular.isDefined($scope.tabs)) {
			target = $scope.tabs[$scope.activeTabDependenciaEtiquetado];
		}
		else {
			target = $scope;
		}

		return target;
	};

	$scope.estaBloqueado = function (cell) {
		if (cell.col.field == "valor")
			return cell.row.entity.bloqueado || ($scope.modoTraduccion && !$scope.traducible);
		else {
			//miramos si la sub_pregunta esta bloqueada.
			var propertyFTPreguntas = cell.col.field.replace("respuesta", "pregunta");
			var propertyABuscar = "deshabilitar_" + propertyFTPreguntas;
			var propertyTraducible = propertyFTPreguntas + "_traducible";
			return ($scope.pregunta[propertyABuscar] == 1 || cell.row.entity.bloqueado) || ($scope.modoTraduccion && !$scope.pregunta[propertyTraducible]);
		}
	};

	$scope.edicionGridEnvase = function(cell){
		var nivel = cell.row.entity["$$treeLevel"];
		//Puede ser nivel 0 o 1. El 0 es linea principal y 1 linea interna.
		var celdas_editables = [];
		if (nivel == 0) {//Nivel principal se puede editar todo menos celdas calculadas 6 y 8.
			celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3", "SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
			
			if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1)
				return !$scope.estaBloqueado(cell);
			else
				return false;
		}
		else {
			celdas_editables = ["SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
			if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1)
				return !$scope.estaBloqueado(cell);
			else
				return false;
		}
	};
	

	$scope.buildGrid = function (tab) {
		var target = $scope.getTargetGrid();

		var metadata = $scope.getFakeMetadata();

		if (!$scope.modoTraduccion) {
			metadata.push($scope.buildMarcaColumn());
			//metadata.push($scope.buildComponenteColumn());
			$scope.showOnlyDescribedCols = metadata.filter(function (e) { return e.Name != "id"; }).map(function (e) { return e.Name; });

			if ($scope.pregunta.pregunta.bucle)
				$scope.showOnlyDescribedCols.push("orden_bucle");
			// if ($scope.pregunta.pregunta.sub_bucle)
			// 	$scope.showOnlyDescribedCols.push("orden_tab");

			if (angular.isUndefined(target.grid)) {


				var gridOptions = {
					enableRowSelection: (angular.isUndefined($scope.modoTraduccion)),
					enableRowHeaderSelection: (angular.isUndefined($scope.modoTraduccion)),
					enableCellEdit: (angular.isUndefined($scope.modoTraduccion) && !$scope.pregunta_bloqueada),
					metadata: metadata,
					onCellEdit: $scope.pregunta.pregunta.bucle ? calcularOrdenBucle : undefined,
					showOnlyDescribedCols: $scope.showOnlyDescribedCols,
					ixLoadInitialDataAction: "PreguntasDependenciaEtiquetado"
				};

				if($scope.esGridJerarquico()){
					gridOptions.showTreeExpandNoChildren = false;
					gridOptions.rowTemplate = "app/base/views/grid/ui-grid-tree-row.html";
					if ($scope.tablaEnvases) gridOptions.pruebaFT = true;
				}
					

				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetadoGrid_" + $scope.id_pregunta, gridOptions, 
				"extranet_fichas_tecnicas_det", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
		} else {
			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetado_idiomaGrid_" + $scope.id_pregunta, {
					enableRowSelection: false,
					enableRowHeaderSelection: false,
					metadata: metadata,
					getCustomHint: $scope.getCustomHint
				}, "dependencia_etiquetado_idiomaVM", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
			target.grid.entity = "dependencia_etiquetado_idioma";
		}

		if ($scope.tablaEnvases)
			target.grid.cellEditableCondition = $scope.edicionGridEnvase;

		target.grid.filtroExterno = [{
			Field: "id_ficha_tecnica",
			Operator: CMP_EQ,
			Value: $scope.id_ficha_tecnica
		}, {
			Field: "id_pregunta",
			Operator: CMP_EQ,
			Value: $scope.id_pregunta
		}];

		if ($scope.pregunta.pregunta.bucle) {
			//Agregar filtro para la marca
			var tabul = $scope.tabs.find(function (e) { return e.index == $scope.activeTabDependenciaEtiquetado; });
			if (angular.isDefined(tabul)) {
				target.grid.filtroExterno.push({
					Field: "marca",
					Operator: CMP_EQ,
					Value: tabul.valor
				});
			}
		}

		if (angular.isDefined($scope.componente)){
			target.grid.filtroExterno.push({
				Field: "componente",
				Operator: CMP_EQ,
				Value: $scope.componente
			});
		}

		if ($scope.modoTraduccion) {
			target.grid.filtroExterno.push({
				Field: "idioma",
				Operator: CMP_EQ,
				Value: $scope.idioma
			});
		}

		target.grid.ixGetBulkParam = function () {
			var bulkParam = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};

			if (target.grid.gridApi) {
				var dirtyRows = target.grid.gridApi.rowEdit.getDirtyRows();
				dirtyRows.forEach(function (row) {
					if (row.entity.manuallyAdded) delete row.entity.manuallyAdded;
					if (target.grid.insertedRows.indexOf(row.entity) >= 0) {
						delete (row.entity.isNew);
						bulkParam.ToInsert.push(row.entity);
					} else {
						bulkParam.ToUpdate.push({
							PK: target.grid.buildPK(row.entity),
							PocoToUpdate: target.grid.getPatchOperations(row.entity)
						});
					}
				});
				target.grid.deletedRows.forEach(function (data) {
					var toDelete = target.grid.buildPK(data);
					//toDelete.disable_before_after = true;
					bulkParam.ToDelete.push(toDelete);
				});
			}

			return bulkParam;
		};
	};

	$scope.addRow = function(grid){
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
		var componente = $scope.pregunta[respuestasProperty][0].componente;
		var newEntity = { componente: componente};
		if($scope.esGridJerarquico())
			newEntity["$$treeLevel"] = 0;
		grid.ixAddRow(newEntity);
		/* Código original (tal vez no usado/ejecutado porque en html: data-ng-click="grid.ixAddRow()") */
		// var newEntity = {};
		// if($scope.esGridJerarquico())
		// 	newEntity["$$treeLevel"] = 0;

		// grid.ixAddRow(newEntity);
	};

	$scope.addTreeLevel = function (respuestas) {
		angular.forEach(respuestas, function (respuesta) {
			respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
		});
	};

	$scope.sortGridData = function(data){
		data = $filter('orderBy')(data, ['orden_bucle', 'orden_sub_bucle']);
		return data;
	};

	if ($scope.pregunta.pregunta.bucle)
		$scope.getTabs();
	else
		$scope.buildGrid();

	if($scope.tablaEnvases){
		$scope.$on("gridLoaded", function(){
			var target = $scope.getTargetGrid();
			$scope.addTreeLevel(target.grid.data);
			target.grid.data = $scope.sortGridData(target.grid.data)
		});
	}

}]);

/*global CMP_EQ*/

//Este controlador es únicamente para la pantalla del popup para entrar los valores por etiquetado de las tablas de nutricionales y vitaminas y minerales.
angular.module("FTBase").controller('DependenciaEtiquetadoNutricionalesPopupController', ['$scope', '$http', '$q', '$log', 'cfg', 'authService', 'gridService', 'ixStatusService', function ($scope, $http, $q, $log, cfg, authService, gridService, ixStatusService) {
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.tienePerfilRestringido()) {
		$scope.status = {
			editing: true
		};
	}else{
		$scope.status = {
			editing: false
		};
	}

	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.id_pregunta = $scope.$resolve.id_pregunta;
	$scope.pregunta_formulario = $scope.$resolve.pregunta_formulario;
	$scope.bloquear_valor_b = $scope.$resolve.bloquear_valor_b;
	$scope.pregunta_bloqueada = $scope.$resolve.pregunta_bloqueada;
	$scope.modoTraduccion = $scope.$resolve.modo_traduccion;
	$scope.idioma = $scope.$resolve.idioma;
	$scope.traducible = $scope.$resolve.traducible;

	$scope.pregunta = $scope.$resolve.pregunta;

	$scope.activeTabDependenciaEtiquetado = 0;

	var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };

	///////////////////////// FUNCIONES ////////////////////////////////////////////
	$scope.tienePerfilAdmin = function () {
		return authService.tienePerfilAdmin();
	};

	$scope.switchBloqueado = function (bloqueado) {
		if (bloqueado)
			bloqueado = 0;
		else
			bloqueado = 1;
		return bloqueado;
	};

	$scope.changeLockGrid = function (entity) {
		var data = [
			{
				op: "replace",
				path: "/bloqueado",
				value: entity.bloqueado
			}
		];
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

		}, function (err) {
			entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
		});
	};

	$scope.getTabs = function () {
		$scope.tabs = undefined;

		$http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
			if (response.data) {
				if (response.data.length > 0) {
					$scope.tabs = [];
					for (var i = 0; i < response.data.length; i++) {
						$scope.tabs.push({ index: i, valor: response.data[i].marca, nombre: response.data[i].marcanombre });
					}
					$scope.buildGrid($scope.tabs[0]);
				} else
					$scope.buildGrid();
			}
		});
	};

	$scope.getTargetGrid = function () {
		var target = null;
		if (angular.isDefined($scope.tabs)) {
			target = $scope.tabs[$scope.activeTabDependenciaEtiquetado];
		}

		return target;
	};


	$scope.addNewElementsToDictionary = function () {

	};


	$scope.buildMarcaColumn = function () {
		return {
			Name: "marca",
			NoEditable: $scope.estaBloqueadoValor,
			Required: true,
			overridePreloadedOptions: true,
			busquedaFunction: function (column, param, text, row, config) {
				return $http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
					response.data.forEach(function (data) {
						data.id = data.marca;
						data.marca = data.marcanombre;
					});
					return response.data;
				});
			}
		};
	};


	$scope.addSpecificControl = function (obj, tipo) {
		var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

		if ($scope.modoTraduccion) {
			tipo = tiposValor.TEXTO;
			if (obj.Name == "valor" && $scope.pregunta.pregunta.traducible) {
				obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
			else {
				var nameColumn = obj.Name.replace("respuesta", "pregunta");
				if ($scope.pregunta[nameColumn + "_traducible"])
					obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
		}

		if (tipo == tiposValor.SINO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			obj.Control = "CheckBox";
			obj.ignoreCellModifications = true;
		}
		else if (tipo == tiposValor.DICCIONARIO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			if ($scope.pregunta[respuestasProperty][0].componente && $scope.pregunta[preguntaProperty].diccionario_valores) {
				$scope.addNewElementsToDictionary();
			}
			if (obj.Name == "valor")
				obj.ColumnFkDescription = "valor";

			obj.Search = {
				"KeyFields": [obj.Name],
				"LookUpTableName": "",
				"LookUpKeyFields": ["codigo"],
				"LookUpResultFields": ["descripcion", "codigo"],
				"LookUpTableAlias": "",
				"LookUpOrders": [{ "KeyField": "descripcion", "Desc": false }],
				"LookUpConditions": []
			};

			obj.busquedaFunction = function (column, param, text) {
				var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var deferr = $q.defer();
				var valores = [];
				var diccionario_valores = [];

				if ($scope.preview)
					diccionario_valores = $scope.pregunta.pregunta.diccionario_valores;
				else {
					var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
					fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
					diccionario_valores = $scope.pregunta[preguntaProperty][fieldToSearch];
				}

				if (text)
					diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

				angular.forEach(diccionario_valores, function (valor) {
					var item = { codigo: valor, descripcion: valor };
					if (column.ColumnFKDescription)
						item[column.ColumnFKDescription] = valor;

					valores.push(item);
				});

				deferr.resolve(valores);
				return deferr.promise;
			}
		}
		else if (tipo == tiposValor.FECHA)
			obj.Type = "DateTime";
		else if (tipo == tiposValor.DECIMAL) {
			obj.Type = "Decimal";
			obj.CommaSeparator = true;
			obj.MaxLength = 11;
		}
		else if (tipo == tiposValor.NUMERICO) {
			obj.Type = "Int32";
			obj.MaxLength = 11;
		}
	};


	$scope.getFakeMetadata = function () {
		var metadata = [];
		metadata.push({ Name: "id", NoVisible: true, Pk: true });
		var valor = { Name: "valor", ColumnDescription: $scope.pregunta_formulario, Type: "String", NoEditable: true, NoFilterable: true };
		$scope.addSpecificControl(valor, $scope.pregunta.pregunta.tipo_valor);
		metadata.push(valor);
		if ($scope.pregunta.pregunta.sub_pregunta1) {
			var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta1, $scope.pregunta.pregunta.tipo_valor_sub_pregunta1);
			metadata.push(sub_pregunta1);
		}
		if ($scope.pregunta.pregunta.sub_pregunta2) {
			var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta2, $scope.pregunta.pregunta.tipo_valor_sub_pregunta2);
			metadata.push(sub_pregunta2);
		}
		if ($scope.pregunta.pregunta.sub_pregunta3) {
			var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta3, $scope.pregunta.pregunta.tipo_valor_sub_pregunta3);
			metadata.push(sub_pregunta3);
		}
		if ($scope.pregunta.pregunta.sub_pregunta4) {
			var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta4, $scope.pregunta.pregunta.tipo_valor_sub_pregunta4);
			metadata.push(sub_pregunta4);
		}
		if ($scope.pregunta.pregunta.sub_pregunta5) {
			var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta5, $scope.pregunta.pregunta.tipo_valor_sub_pregunta5);
			metadata.push(sub_pregunta5);
		}
		if ($scope.pregunta.pregunta.sub_pregunta6) {
			var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta6, $scope.pregunta.pregunta.tipo_valor_sub_pregunta6);
			metadata.push(sub_pregunta6);
		}
		if ($scope.pregunta.pregunta.sub_pregunta7) {
			var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta7, $scope.pregunta.pregunta.tipo_valor_sub_pregunta7);
			metadata.push(sub_pregunta7);
		}
		if ($scope.pregunta.pregunta.sub_pregunta8) {
			var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta8, $scope.pregunta.pregunta.tipo_valor_sub_pregunta8);
			metadata.push(sub_pregunta8);
		}

		return metadata;
	};


	var calcularOrdenBucle = function (rowEntity, colDef, newValue, oldValue){
		if (colDef.field == "marca") {
			var marca = newValue;
			var target = $scope.getTargetGrid();
			var lineasConLaMarca = target.grid.data.filter(function (e) { return e.marca == marca; });
			rowEntity.orden_bucle = (lineasConLaMarca.length);
			if (!rowEntity.modifiedValues)
				rowEntity.modifiedValues = [];
			if (rowEntity.modifiedValues.indexOf("orden_bucle") == -1)
				rowEntity.modifiedValues.push("orden_bucle");

			//Recalculamos ordenes bucle de la marca anterior, para no dejar huecos.
			if (oldValue) {
				var marcaAnterior = oldValue;
				var lineasConMarcaAnterior = target.grid.data.filter(function (e) { return e.marca == marcaAnterior; });
				lineasConMarcaAnterior.forEach(function (linea, idx) {
					var currentOrdenBucle = linea.orden_bucle;
					linea.orden_bucle = (idx + 1);
					if (currentOrdenBucle != linea.orden_bucle) {
						if (!linea.modifiedValues)
							linea.modifiedValues = [];
						if (linea.modifiedValues.indexOf("orden_bucle") == -1)
							linea.modifiedValues.push("orden_bucle");
						target.grid.gridApi.rowEdit.setRowsDirty([linea]);
					}
				});
			}
		}
	};


	$scope.buildGrid = function (tab) {
		var target = $scope.getTargetGrid();

		var metadata = $scope.getFakeMetadata();

		//Indicar las columnas que queramos ocultar o hacer no editables
		metadata.push({ Name: "orden_bucle", NoVisible: true });
		metadata.push({ Name: "marca", NoVisible: true });

		if (!$scope.modoTraduccion) {
			metadata.push($scope.buildMarcaColumn());

			$scope.showOnlyDescribedCols = metadata.filter(function (e) { return e.Name != "id"; }).map(function (e) { return e.Name; });

			if ($scope.pregunta.pregunta.bucle)
				$scope.showOnlyDescribedCols.push("orden_bucle");

			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetadoGrid_" + $scope.id_pregunta, {
					enableCellEdit: (angular.isUndefined($scope.modoTraduccion) && !$scope.pregunta_bloqueada),
					enableRowSelection: false, 
                	enableRowHeaderSelection: false,
					metadata: metadata,
					onCellEdit: $scope.pregunta.pregunta.bucle ? calcularOrdenBucle : undefined,
					showOnlyDescribedCols: $scope.showOnlyDescribedCols,
					ixLoadInitialDataAction: "PreguntasDependenciaEtiquetado"
				}, "extranet_fichas_tecnicas_det", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
		}
		else {
			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetado_idiomaGrid_" + $scope.id_pregunta, {
					enableRowSelection: false,
					enableRowHeaderSelection: false,
					metadata: metadata,
					getCustomHint: $scope.getCustomHint
				}, "dependencia_etiquetado_idiomaVM", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
			target.grid.entity = "dependencia_etiquetado_idioma";
		}

		target.grid.filtroExterno = [{
			Field: "id_ficha_tecnica",
			Operator: CMP_EQ,
			Value: $scope.id_ficha_tecnica
		}, {
			Field: "id_pregunta",
			Operator: CMP_EQ,
			Value: $scope.id_pregunta
		}];

		//Agregar filtro para la marca
		var tabul = $scope.tabs.find(function (e) { return e.index == $scope.activeTabDependenciaEtiquetado; });
		if (angular.isDefined(tabul)) {
			target.grid.filtroExterno.push({
				Field: "marca",
				Operator: CMP_EQ,
				Value: tabul.valor
			});
		}

		if ($scope.modoTraduccion) {
			target.grid.filtroExterno.push({
				Field: "idioma",
				Operator: CMP_EQ,
				Value: $scope.idioma
			});
		}

		target.grid.ixGetBulkParam = function () {
			var bulkParam = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};

			if (target.grid.gridApi) {
				var dirtyRows = target.grid.gridApi.rowEdit.getDirtyRows();
				dirtyRows.forEach(function (row) {
					if (row.entity.manuallyAdded) delete row.entity.manuallyAdded;
					if (target.grid.insertedRows.indexOf(row.entity) >= 0) {
						delete (row.entity.isNew);
						bulkParam.ToInsert.push(row.entity);
					} else {
						bulkParam.ToUpdate.push({
							PK: target.grid.buildPK(row.entity),
							PocoToUpdate: target.grid.getPatchOperations(row.entity)
						});
					}
				});
				target.grid.deletedRows.forEach(function (data) {
					var toDelete = target.grid.buildPK(data);
					toDelete.disable_before_after = true;
					bulkParam.ToDelete.push(toDelete);
				});
			}

			return bulkParam;
		};
	};


	$scope.cambiarTabDependenciaEtiquetado = function (tab, index) {
		var target = $scope.getTargetGrid();
		target.grid.ixSaveConfig();
		$scope.activeTabDependenciaEtiquetado = index;
		$scope.buildGrid(tab);
	};


	$scope.addNutricionales = function(t, idx){
		$log.log("addNutricionales");
		var componente = $scope.pregunta.respuestas[0].componente;
		if (angular.isUndefined($scope.idioma)){
			$scope.idioma = "es";
		}

		var request_data = {
			id_ft: $scope.id_ficha_tecnica,
			id_pregunta: $scope.id_pregunta,
			componente: componente,
			id_marca: t.valor,
			idioma: $scope.idioma
		};

		$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarNutricionalesMarca", request_data).then(function(response){
			$log.log(response);
			$scope.registrosCreados = true;
			var target = $scope.getTargetGrid();
			angular.forEach(response.data.Inserted, function(nueva_linea){
				nueva_linea.Record.manuallyAdded = true;
				target.grid.ixAddRow(nueva_linea.Record);
			});
			//Limpio insertedRows para evitar que al editar se agreguen nuevas lineas (la función getDirtyRows no tiene que pescarlas)
			target.grid.insertedRows = [];
		},
		function(error){
			$scope.status.response = error;
		});
	};


	$scope.deleteNutricionales = function(grid){
		$log.log("deleteNutricionales");
		var listaIdFtDet = grid.data.map(function (d) {
			return d.id;
		});

		$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarNutricionalesMarca", listaIdFtDet).then(function(response){
			$log.log(response);
			$scope.registrosCreados = false;
			if(response.data.Result){
				grid.data = [];
			}
			$scope.status.response = response;
		},
		function(error){
			$scope.status.response = error;
		});
	};


	///////////////////////// FIN FUNCIONES ////////////////////////////////////////////  


	if (!$scope.pregunta_bloqueada) {
		$scope.save = function () {
			var target = $scope.getTargetGrid();
			if (target) {
				target.grid.ixGuardar().then(function (response) {
					$scope.status.editing = true;
					ixStatusService.setEditing(true);
					$scope.pregunta.respuestas[0].contiene_info_etiquetado = target.grid.data.length > 0;
				});
			}
		};
	}

	var acciones = [];

	if ($scope.tienePerfilAdmin()) {
		acciones.push({
			icon: "fa-lock",
			title: "Desbloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
		acciones.push({
			icon: "fa-unlock",
			title: "Bloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && !entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
	}

	$scope.getTabs();
}]);
angular.module('FTBase').controller('DatosFabricantePopupController', [ '$scope', '$http', 'cfg', '$uibModalInstance', 'ixStatusService', function($scope, $http, cfg, $uibModalInstance, ixStatusService){
	$scope.status = { editing: false };
	$http.get(cfg.baseURL + "fabricantes/" + $scope.$resolve.fabricante).then(function(response){
		$scope.datos_fabricante = response.data;
	}, function(err){
		ixStatusService.setResponse(err);
	});
}]);

angular.module('FTBase').controller('AddElementosSaludablesPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.listOfValues = angular.copy($scope.$resolve.listelements);
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.save = function(){
		var selecteds = $scope.listOfValues.filter(function(e){ return e.selected; });
		$uibModalInstance.close({ rows: selecteds });
	};
	$scope.$close = function () {
		$scope.status.editing = false;
		$uibModalInstance.dismiss('cancel');
	};
}]);

/*jslint browser: true, white: true, plusplus: true, node:true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
(function() {
  'use strict';


  angular.module('gp4Controllers', ['ui.grid', 'ui.grid.edit', 'ui.grid.rowEdit', 'ui.grid.cellNav', 'ui.grid.resizeColumns', 'ui.grid.moveColumns', 'ui.grid.pinning', 'ui.grid.infiniteScroll', 'ui.grid.selection', 'ui.grid.saveState', 'ui.grid.autoResize', 'ui.mask', 'ui.validate', 'ui.select', 'ngSanitize', 'rzModule', 'chart.js', 'ui.layout', 'ui.grid.exporter', 'ui.grid.validate', 'ui.grid.draggable-rows', 'com.2fdevs.videogular', 'com.2fdevs.videogular.plugins.controls','com.2fdevs.videogular.plugins.overlayplay','com.2fdevs.videogular.plugins.poster', 'rzModule', 'nvd3', 'gridster', 'ngFileUpload', 'cp.ngConfirm', 'pdfjsViewer', 'angular-virtual-select', 'FBAngular']);





  angular.module('gp4Controllers').controller('EditorController', [ '$scope', '$rootScope', '$http', 'cfg', '$window' ], function($scope, $rootScope, $http, cfg, $window) {

      // Obtener metadata de backend (TODO: cache)
      $http.get(cfg.baseURL+"metadata/"+$scope.entity).then(function(r){
          $scope.metadata = r.data;
          if($scope.gridOptions) {
              $scope.gridOptions.columnDefs = [];
              $scope.metadata.forEach(function(x){
                  //$scope.gridOptions.columnDefs.push({field:x.Name, type: convertFromServerType(x.Type)});
              });
          }
      });


    $scope.editar = function() {
      // TODO: crear un bloqueo
      $scope.bloqueo = {user : $rootScope.user,  ts : new Date(), app: $rootScope.currentApp};
      $scope.editing = true;
      $scope.editing = true;
    };

    $scope.cancelEdit = function() {
      // TODO: confirmació si dirty i eliminar bloqueig al server
      $scope.bloqueo = null;
      $scope.editing = false;
      $rootScope.editing = false;

      //TODO: restaurar si tenim copia original
      // $scope.model = angular.copy($scopy.originalModel);
      // $scope.editForm.$setPristine();
      // ... per guardar copia original
      // $scope.originalModel = angular.copy($scope.model);
    };

    $scope.newIncidencia = {};

    $scope.addIncidencia = function() {

      $scope.incidencias = $scope.incidencias || [];
      var newIncidencia = {};
      newIncidencia.time = new Date();
      newIncidencia.user = $rootScope.user;
      newIncidencia.text = $scope.newIncidencia.text;
      $scope.incidencias.push(newIncidencia);
      delete $scope.newIncidencia.text;
    };

    $scope.$on('$locationChangeStart', function( event ) {
      if($scope.editing) {
        // TODO: check if formObj.$pristine === false
        var answer = $window.confirm("Are you sure you want to leave this page? \n(all changed data will be lost)");
        if (!answer) {
          event.preventDefault();
        }
      }
    });

  } )


  angular.module('gp4Controllers').controller('ListController', ['$scope', '$rootScope', '$http', 'cfg', function($scope, $rootScope, $http, cfg) {
    $scope.search = {};
    $scope.items = [];
    $scope.page = 1;

    $scope.clearItems = function() {
      $scope.items = [];
      $scope.page = 1;
    };

    $scope.orderBy = [];
    $scope.setOrderBy = function(field, event) {
      if($scope.orderBy.indexOf(field)>=0) {
        $scope.orderBy[$scope.orderBy.indexOf(field)]="-"+field;
      } else if ($scope.orderBy.indexOf("-"+field)>=0) {
        $scope.orderBy.splice($scope.orderBy.indexOf("-"+field),1);
      } else {
        if(event.ctrlKey) {
          $scope.orderBy = $scope.orderBy.concat(field);
        } else {
          $scope.orderBy = [field];
        }
      }
      $scope.clearItems();
      $scope.loadMore();
    };

    $scope.loadMore = function() {

          var searchParam = $scope.buildSearchParam();
      searchParam.OrderBy = $scope.orderBy;

      $http.post(cfg.baseURL+$scope.entity+'/Search?Page='+$scope.page, searchParam).then(function(response) {
        $scope.items = $scope.items.concat(response.data.Items);
        $scope.page++;
      }, function(response){
        $scope.response = response;
      });
    };


  }])


  angular.module('gp4Controllers').controller('SetOrderByController', ['$scope', '$uibModalInstance', 'filter', function($scope, $uibModalInstance,filter) {
      $scope.filter = filter;
      $scope.orderBy = filter.search.OrderBy;

      $scope.ok = function() {
          $uibModalInstance.close($scope.orderBy);
      };

  }])


  angular.module('gp4Controllers').controller('ClientesListController', ['$scope','$controller', function($scope, $controller) {
    $scope.entity = "clientes";
    $controller('ListController', {$scope: $scope});

    $scope.columns = [{name:"cliente",class:"col-lg-1"},
                  {name:"nombre",class:"col-lg-4"},
                  {name:"nif",class:"col-lg-1"},
                  {name:"direccion",class:"col-lg-3"},
                  {name:"cpostal",class:"col-lg-1"},
                  {name:"poblacion",class:"col-lg-2"}
                  ];

    $scope.buildSearchParam = function() {
      return {Filters:[{Field:"nombre", Value:$scope.search.nombre, Operator: 6, Not: false}]};
    }


  }])

  angular.module('gp4Controllers').controller('MarcasListController', ['$scope','$controller', function($scope, $controller) {
    $controller('ListController', {$scope: $scope});

    $scope.entity="marcas";
    $scope.columns = [{name:"marca",class:"col-lg-2"},{name:"nombre",class:"col-lg-4"},{name:"activo",class:"col-lg-1"},{name:"color",class:"col-lg-1"}];

    $scope.buildSearchParam = function() {
      return {Filters:[{Field:"nombre", Value:$scope.search.nombre, Operator: 6, Not: false}]};
    };

  }])


  angular.module('gp4Controllers').controller('ClienteController', ['$scope', '$rootScope', '$controller', '$routeParams', '$http', 'uiGridConstants', 'cfg'], function($scope, $rootScope, $controller, $routeParams, $http, uiGridConstants, cfg) {
    $scope.entity = "clientes";
    $controller('EditorController', {$scope: $scope});

    if($routeParams.id) {

      // TODO: reload app from ws
      $scope.status.setTitle("cliente "+$routeParams.id);

      $http.get(cfg.baseURL+'clientes/'+$routeParams.id).then(function(response) {
        $scope.cliente = response.data;

        // TODO: remove hardcoded values for demo
        $scope.cliente.limiteInferior=30;
        $scope.cliente.limiteSuperior=70;
        $scope.cliente.prioridad=1;
        $scope.cliente.agudos=3;
        $scope.cliente.medios=6;
        $scope.cliente.graves=4;


        $scope.status.setTitle($scope.cliente.nombre);

        $http.post(cfg.baseURL+'clientes_cue/Search',{"Filters": [{"Field": "cliente","Value": $routeParams.id,"Operator": 0,"Not": false}],"OrderBy": ["cuenta"]}).then(function(response) {
          $scope.numCuentas = response.data.Items.length;
        },function(response){
          $scope.response = response;
        });

        $http.get(cfg.baseURL+'barcos').then(function(response) {
          $scope.allBarcos = response.data;
        },function(response){
          $scope.response = response;
        });


      },function(response){
        $scope.response = response;
      });


    } else {
      $scope.editing=true;
      $rootScope.editing=true;
    }


    $scope.guardar = function() {
      $http.put(cfg.baseURL+'clientes/'+$scope.cliente.cliente, $scope.cliente).then(function(response) {
        $scope.response = response;
        $scope.bloqueo = null;
        $scope.editing = false;
      },function(response){
        $scope.response = response;
      });
    };



  })






  angular.module('gp4Controllers').controller('BastidorController', ['$scope', '$rootScope', '$controller', '$routeParams', '$http', 'uiGridConstants', 'cfg'], function($scope, $rootScope, $controller, $routeParams, $http, uiGridConstants, cfg) {
    $controller('EditorController', {$scope: $scope});

    $scope.gridOptions = {enableHorizontalScrollbar : 0};
    $scope.gridOptions.columnDefs = [
      {name:"tipo",width:"6%", enableColumnMenu: false},
      {name:"grupo", enableColumnMenu: false},
      {name:"movimiento",width:"6%", enableColumnMenu: false},
      {name:"entrada", enableColumnMenu: false},
      {name:"salida", enableColumnMenu: false},
      {name:"cliente", enableColumnMenu: false},
      {name:"operacion", enableColumnMenu: false}
    ];

    $scope.grupo = $routeParams.grupo;
    $scope.chasis = $routeParams.chasis;
    $scope.movimiento = $routeParams.movimiento;

    var searchParam = {
      "Filters": [
        {"Field": "grupo", "Value": $routeParams.grupo, "Operator": 0, "Not": true},
        {"Field": "chasis", "Value": $routeParams.chasis, "Operator": 0, "Not": true},
        {"Field": "movimiento", "Value": $routeParams.movimiento, "Operator": 0, "Not": true}
      ],
      "OrderBy": [
        "grupo","chasis","movimiento"
      ]
    }

    $http.post(cfg.baseURL+'bastidores/Search',searchParam).then(function(response) {
      $scope.gridOptions.data = response.data.Items;
    },function(response){
      $scope.response = response;
    });






  })


  angular.module('gp4Controllers').controller('BastidoresListController', ['$scope', '$rootScope', '$http', 'uiGridConstants', '$timeout', '$q', 'cfg'], function($scope, $rootScope, $http, uiGridConstants, $timeout, $q, cfg) {
    $scope.data = [];
    $scope.firstPage = 0;
    $scope.lastPage = 0;

    $http.get(cfg.baseURL+'bastidores/ListadoGrupoChasis?page=1&itemsPerPage='+cfg.pageSize).then(function(response) {
      $scope.gridOptions.data = response.data.Items;
      $scope.firstPage++;
      $scope.lastPage++;
      $timeout(function() {
        $scope.gridApi.infiniteScroll.resetScroll( false,  response.data.CurrentPage < response.data.TotalPages );
      });
    },function(response){
      $scope.response = response;
    });

    $scope.gridOptions = {
      enableFiltering: true,
      showGridFooter: true,
      enableGridMenu: true,
      enableCellEdit: true,
      infiniteScrollRowsFromEnd: 40,
          infiniteScrollUp: true,
          infiniteScrollDown: true,
        columnDefs : [{name:'grupo'},{name:'chasis'},{name:'movimiento'}],
          onRegisterApi: function(gridApi){
            gridApi.infiniteScroll.on.needLoadMoreData($scope, $scope.getDataDown);
            gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, $scope.getDataUp);
            $scope.gridApi = gridApi;
          }
    }

      $scope.toggleFiltering = function(){
        $scope.gridOptions.enableFiltering = !$scope.gridOptions.enableFiltering;
        $scope.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
      };


      /*$scope.getDataDown = function() {
          var promise = $q.defer();
          //url, pageSize,... no estan definides
          /*$http.get(url+"?page="+($scope.lastPage+1)+"&itemsPerPage="+pageSize).then(function(response) {
            $scope.lastPage++;
            $scope.gridApi.infiniteScroll.saveScrollPercentage();
            $scope.data = $scope.data.concat(response.data.Items);
            $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 1, response.data.CurrentPage < response.data.TotalPages ).then(function() {$scope.discardData('top');}).then(function() {
              promise.resolve();
            });
          },function(response) {
            $scope.gridApi.infiniteScroll.dataLoaded();
            promise.reject();
          });
          return promise.promise;
        };*/

    /*$scope.getDataUp = function() {
      var promise = $q.defer();
      //url, pageSize,... no estan definides
      /*$http.get(url+"?page="+($scope.firstPage-1)+"&itemsPerPage="+pageSize).then(function(response) {
              $scope.firstPage--;
              $scope.gridApi.infiniteScroll.saveScrollPercentage();
              $scope.data = response.data.Items.concat($scope.data);
              $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 1, response.data.CurrentPage < response.data.TotalPages).then(function() {$scope.discardData('bottom');}).then(function() {
                promise.resolve();
              });
            },function(response) {
              $scope.gridApi.infiniteScroll.dataLoaded();
              promise.reject();
            });
            return promise.promise;
          };*/
    /*$scope.discardData = function(direction) {
      //pageSize,... no estan definides
      if($scope.lastPage - $scope.firstPage > 3) {
        $scope.gridApi.infiniteScroll.saveScrollPercentage();
        if(direction==='top') {
          $scope.data = $scope.data.slice(pageSize);
          $scope.firstPage++;
             $timeout(function() {
                   // wait for grid to ingest data changes
                   $scope.gridApi.infiniteScroll.dataRemovedBottom($scope.firstPage > 1, true);
             });

        } else {
          $scope.data = $scope.data.slice(0, pageSize*4);
          $scope.lastPage--;
             $timeout(function() {
                   // wait for grid to ingest data changes
                   $scope.gridApi.infiniteScroll.dataRemovedBottom($scope.firstPage > 1, true);
             });
        }
      }
    }*/

  })

  angular.module('gp4Controllers').controller("ChartController", [ '$scope' ], function ($scope) {
      $scope.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012','2013','2014','2015'];
      $scope.series = ['Series A', 'Series B'];

      $scope.data = [
        [65, 59, 80, 81, 56, 55, 40, 44, 60, 77],
        [28, 48, 40, 19, 86, 27, 90, 80, 75, 88]
      ];


      $scope.pielabels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
      $scope.piedata = [300, 500, 100];


  })

  angular.module('gp4Controllers').controller("PivotController", ['$scope','$http','$routeParams','cfg', '$log',function ($scope,$http,$routeParams,cfg, $log) {
    $scope.entity = $routeParams.entity;

    $scope.renderers = $.pivotUtilities;

    $log.log("calling api");
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $log.log("api called");
      $scope.pivotData = r.data;
      var derivers = $.pivotUtilities.derivers;
          angular.element("#pivotTableOutput").pivotUI($scope.pivotData, {
              rows: [],
              cols: [],
              renderers : $.extend($.pivotUtilities.renderers,$.pivotUtilities.d3_renderers,$.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
              rendererName: "Table"
          });
    });

  }]);
})();

/*global convertDateStringsToDates*/
/*global d3*/
/*global buildIxSearch*/
/*global saveAs*/
angular.module('gp4Controllers').factory('DataService', [ '$timeout', '$http', 'cfg', 'gridService', '$filter', function($timeout, $http, cfg, gridService, $filter) {
	var DataService = {
  
	  getCharts: getCharts,
	  updateChart: updateChart,
	  showWidget: showWidget,
	  exportWidget: exportWidget,
	  loadWidget: loadWidget,
		  getWidgetColorsByValue: getWidgetColorsByValue,
  
	  lineChart: {
		options: lineChartOptions,
		data: lineChartData
	  },
	  multiBarChart: {
		options: multiBarChartOptions,
		data: multiBarChartData
	  },
		  multiBarValuesChart: {
		options: multiBarValuesChartOptions,
		data: multiBarValuesChartData
	  },
		  multiChart: {
			  options: multiChartOptions,
			  data: multiChartData
		  },
	  multiBarHorizontalChart: {
		options: multiBarHorizontalChartOptions,
		data: multiBarHorizontalChartData
	  },
		  multiBarHorizontalValuesChart: {
		options: multiBarHorizontalValuesChartOptions,
		data: multiBarHorizontalValuesChartData
	  },
	  pieChart: {
		options: pieChartOptions,
		data: pieChartData
	  },
	  donutChart: {
		options: donutChartOptions,
		data: donutChartData
	  }
	};
  
	return DataService;
  
  
	function getCharts(modulo){
	  return $http.get(cfg.baseURL + "api_dashboard/GetMultiple/"+modulo).then(function(response){
		return response.data;
	  });
	}
  
	function updateChart(modulo, nombre, filtros){
	  var param = buildIxSearch();
		  filtros.forEach(function(filtro){
			  if(angular.isUndefined(filtro.value))
				  filtro.value = null;
		  });
	  param.Filters = filtros;
	  return $http.post(cfg.baseURL + "api_dashboard/GetSingle/"+modulo+"?nombre="+nombre, param).then(function(response){
		return response.data;
	  });
	}
  
	  function convertToIxSearchParameterFilter(filtros){
		  var IxSearchParamFilter = [];
		  angular.forEach(filtros, function(filtro){
  
			  if(filtro.tipo != "periodo")
				  convertDateStringsToDates(filtro);
  
		if(filtro.value == "") filtro.value = null;
			  if(angular.isDate(filtro.value)){
				  IxSearchParamFilter.push({field: filtro.name, value: $filter("date")(filtro.value, "yyyyMMdd") });
			  }
		else if(angular.isArray(filtro.value)){
		  IxSearchParamFilter.push({ field: filtro.name, value: filtro.value.join() });
		} else {
		  IxSearchParamFilter.push({ field: filtro.name, value: filtro.value });
		}
	  });
		  return IxSearchParamFilter;
	  }
  
	  function exportWidget(modulo, nombre, filtrosWidget){
		  var param = buildIxSearch();
		  filtrosWidget = convertToIxSearchParameterFilter(filtrosWidget);
		  filtrosWidget.forEach(function(filtro){
			  if(angular.isUndefined(filtro.value))
				  filtro.value = null;
		  });
	  param.Filters = filtrosWidget;
  
  
		  var config = {responseType:"arraybuffer"};
		  return $http.post(cfg.baseURL + "api_dashboard/Excel/"+modulo+"?nombre="+nombre, param, config).then(function(r){
		var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
			  var filename = nombre + ".xlsx";
			  if(r.headers('Content-Disposition')) {
				  filename = r.headers('Content-Disposition').split("=")[1];
			  }
			  saveAs(file, filename);
	  });
	  }
  
	  function moverEtiquetasEjeX(){
		  d3.selectAll('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .tick').each(function(tick){
			  tick = d3.select(this);
			  var curAttribute = tick.attr('transform');
			  var valoresTransform = curAttribute.substr(curAttribute.lastIndexOf('(')+1, (curAttribute.lastIndexOf(')') - curAttribute.lastIndexOf('(')) - 1);
			  valoresTransform = valoresTransform.split(',');
			  var primerValorTransform = parseFloat(valoresTransform[0]);
			  var segundoValorTransform = valoresTransform[1];
  
			  var incremento = 30;
  
			  tick.attr('transform', 'translate('+ (primerValorTransform + incremento) +', ' + segundoValorTransform + ')');
		  });
  
		  var minTick = d3.select('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .nv-axisMaxMin.nv-axisMaxMin-x.nv-axisMin-x');
		  minTick.attr('transform', 'translate(33, 0)');
  
		  var maxTick = d3.select('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .nv-axisMaxMin.nv-axisMaxMin-x.nv-axisMax-x');
		  maxTick.attr('transform', 'translate(1767, 0)');
	  }
  
	function loadWidget(scope, modulo, widget) {
	  var filtros = convertToIxSearchParameterFilter(widget.filtros);
	  updateChart(modulo, widget.dataSource, filtros).then(function(response){
		widget.results = response.results;
		widget.tipo = (response.tipo.toUpperCase() != "GRAFICA") ? response.tipo.toLowerCase() : (widget.tipo || response.tipo.toLowerCase());
		if(response.colores)
		  widget.colores = response.colores;
  
		showWidget(scope, widget);
	  });
	}
  
	function showWidget(scope, widget){
	  var filtros = convertToIxSearchParameterFilter(widget.filtros);
	  if(widget.tipo == "medidor_radial") widget.tipo = "donutChart";
			if(widget.tipo == "tabla") widget.tipo = "grid";
	  if(widget.tipo == 'grid'){
				var metadata = (widget.grid) ? widget.grid.metadata : [];
  
				if(widget.results[0]){
					metadata = Object.keys(widget.results[0]).map(function(e,i){
						if(i>0){
							var colType = "";
							var rowValue = widget.results.find(function(row){ return row[e] != null; });
							if(angular.isUndefined(rowValue))
								colType = "string";
							else {
								var columnValue = rowValue[e];
								if(angular.isNumber(columnValue)){
									if(columnValue.toString().lastIndexOf('.') != -1){
										colType = "Decimal";
									} else {
										colType = "Int32";
									}
								} else if(angular.isDate(columnValue)){
									colType = "DateTime";
								} else {
									colType = "string";
								}
							}
  
							var columnsTotalizar = [];
							if(widget.totales != null) columnsTotalizar = widget.totales.split(",");
  
							if(columnsTotalizar.indexOf((i+1)+"") != -1){
								return { Name: e, Type: colType, SumColumn: true };
							} else {
								return { Name: e, Type: colType };
							}
  
						} else {
								return {Name: e, Type: (angular.isDate(widget.results[0][e]) ? "DateTime" : "") };
						}
					});
				}
  
		//Crear una grid amb les dades que tenim i les propietats de l'objecte com a capçaleres (totes de tipus int).
				if(!widget.grid)
			widget.grid = gridService.createGrid(scope, "Dashboard_"+widget.dataSource+"_grid", { enableCellEdit: false, enableRowSelection: false, enableRowHeaderSelection: false, showColumnFooter: true, metadata: metadata });
				else {
					widget.grid.ixSaveConfig();
					widget.grid.metadata = metadata;
					widget.grid = gridService.createGridFunctions(scope, widget.grid);
					widget.grid.ixColDefCreated = false;
					widget.grid.ixRestoreConfig();
				}
  
  
		widget.grid.columnDefs = [];
		widget.grid.ixGetColsFromAPI();
		widget.grid.data = widget.results;
	  } else {
		//update with new options and data
		if (widget.tipo){
			if(widget.tipo == "multiBarChart" && widget.invertir_bar_lin){
				
				widget.chart.options = DataService["multiChart"].options(undefined, undefined, widget.invertir_bar_lin);
				widget.chart.data = DataService["multiChart"].data(widget.results, filtros, widget.mostrar, widget.invertir_bar_lin);
			}
			else {
				widget.chart.options = DataService[widget.tipo].options(undefined, undefined, widget.invertir_bar_lin);
				if(widget.colores)
					widget.chart.options.chart.color = angular.fromJson(widget.colores);
				else {
					if((angular.isDefined(widget.results)) && angular.isDefined(widget.results[0])){
						var objectKeys = Object.keys(widget.results[0]);
						var region = objectKeys.find(function(e,i){ return i==0; });
						widget.chart.options.chart.color = DataService.getWidgetColorsByValue(widget.results, region);
					}
				}
  
				  widget.chart.data = DataService[widget.tipo].data(widget.results, filtros, widget.mostrar, widget.invertir_bar_lin);
			}
  
		  //Serveix per desmarcar aquells valors que s'hagin guardat com a desmarcats a la llegenda.
		  angular.forEach(widget.disableds, function(disabled){
			var toDisable = widget.chart.data.find(function(e){ return e.key == disabled;});
			if(angular.isDefined(toDisable)) toDisable.disabled = true;
		  });
  
		  angular.merge(widget.chart.options.chart, widget.storedOptions);
  
		  //El nom de l'eix X és sempre el nom de la primera propietat que ve de la API.
		  widget.ejeX;
		  widget.valoresEjeY;
		  if(angular.isDefined(widget.results[0])){
			objectKeys = Object.keys(widget.results[0]);
			widget.ejeX = objectKeys.find(function(e,i){return i==0;});
						widget.valoresEjeY = objectKeys.filter(function(e,i){return i!==0;});
		  }
  
		  //Agafem la label més llarga per calcular el marge que deixarem.
		  var lengthX = 0;
					var lengthY = 0;
		  widget.results.forEach(function(result){
			var ejeXString = result[widget.ejeX] + "";
  
			if(ejeXString.length > lengthX)
			  lengthX = ejeXString.length;
						widget.valoresEjeY.forEach(function(ejeY){
							var ejeYString = result[ejeY] + "";
  
							if(ejeYString.length > lengthY)
								lengthY = ejeYString.length;
						});
		  });
					if(widget.tipo == 'multiBarHorizontalChart'){
						lengthY = (lengthX * 6) + 10;
						lengthX = 0;
						if(widget.chart.options.chart.margin.left < lengthY)
				widget.chart.options.chart.margin.left = lengthY;
					}
		  else if(widget.tipo == 'lineChart' || widget.tipo == 'multiBarChart'){
			lengthY = lengthY * 6;
						lengthX = lengthX * 6;
  
						if(widget.chart.options.chart.margin.left < lengthY)
				widget.chart.options.chart.margin.left = lengthY;
		  } else {
			lengthX = lengthX * 4;
		  }
					if(widget.chart.options.chart.margin.bottom < lengthX)
						widget.chart.options.chart.margin.bottom = lengthX;
  
  
		  if(widget.tipo == 'lineChart'/* || widget.tipo == 'multiBarChart'*/){
			widget.chart.options.chart.x = function(d){ if(angular.isDefined(d)) return d.x; };
			widget.chart.options.chart.xAxis.tickValues = function(d){
			  var values=[];
			  widget.results.map(function(v,i){
				values.push(i);
			  })
			  return values
			};
  
			widget.chart.options.chart.xAxis.tickFormat = function(d) {
			  var label = "";
			  if(angular.isDefined(widget.results[d-1]))
				label = widget.results[d-1][widget.ejeX];
			  return label;
			};
		  } else if(widget.tipo != 'pieChart') {
			widget.chart.options.chart.x = function(d){ if(angular.isDefined(d)) return d.x; };
			if(angular.isDefined(widget.chart.options.chart.xAxis)){
  
							if(widget.chart.options.chart.type == "multiChart" || widget.chart.options.chart.labelAsMultiChart){
								widget.chart.options.chart.xAxis.tickFormat = function(d) {
									return widget.chart.data[0].values[d-1].xLabel;
								};
							}
							else {
								widget.chart.options.chart.xAxis.tickFormat = function(d) {
					var label = d;
					return label;
								};
							}
			}
		  }
		  if(widget.tipo != 'pieChart' && angular.isDefined(widget.chart.options.chart.xAxis)) widget.chart.options.chart.xAxis.axisLabel = widget.ejeX;
  
		}
		//update new chart
		$timeout(function(){
		  widget.chart.api.update();
		},600);
	  }
	}
  
	  /**
	   *  Data & Options Generators
	   */
	  function lineChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
				  chart: {
					  //type: 'lineChart',
					  type: 'multiChart',
					  reduceXTicks: false,
					  margin : {
							  top: 40,
							  right: 20,
							  bottom: 40,
							  left: 55
					  },
					  x: function(d){ return d.x; },
					  y: function(d){ return d.y; },
					  useInteractiveGuideline: true,
					  xAxis: {
						  showMaxMin: true,
						  rotateLabels: -25,
						  axisLabel: xAxisLabel || 'Concesionario',
						  axisLabelDistance: -5,
						  tickFormat: function(d){
							  return d;
						  }
					  },
					  /*yAxis: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },*/
					  yAxis1: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },
					  /*yAxis2: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },*/
					  showLegend: true,
					  lines: {
						  forceY: [0]
					  }
				  }
		  };
  
		  options.class = "dashboard-show-values";
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function lineChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
	  angular.forEach(objectKeys, function(key){
		var i = 0;
		filtros.forEach(function(filtro){
		  i++;
		  if(filtro == key){
			var i = 0;
			linesKey.push(filtro);
			linesData.push(data.map(function(e){ i++; return {x: i, y: e[key] }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
			  chartData.push({ values: linesData[i], key: linesKey[i], yAxis: 1, type: (hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i])) ? "bar" : "line" });
	  }
  
	  $timeout(function(){
		  mostrarValoresEnWidget();
	  },500);
  
	  return chartData;
	  }
  
	  function multiChartOptions(xAxisLabel, yAxisLabel) {
		  //A SUBSTITUIR
		  var options = {
				  chart: {
					  type: 'multiChart',
					  reduceXTicks: false,
					  margin : {
							  top: 40,
							  right: 20,
							  bottom: 50,
							  left: 55
					  },
					  clipEdge: true,
					  duration: 500,
					  stacked: true,
					  controlLabels: {
						  grouped: "Agrupado",
						  stacked: "Apilado"
					  },
					  x: function(d){ return d.x; },
					  y: function(d){ return d.y; },
					  useInteractiveGuideline: true,
					  xAxis: {
						  showMaxMin: true,
						  rotateLabels: -25,
						  axisLabel: xAxisLabel || 'Concesionario',
						  axisLabelDistance: -5,
						  tickFormat: function(d){
							  return d;
						  }
					  },
					  yAxis1: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },
					  showLegend: true,
					  lines: {
						  forceY: [0]
					  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
  
	  function multiChartData(data, filtros, mostrar, invertir_bar_lin) {
		  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  //filtros = objectKeys.filter(function(e,i){ return i!==0;});
	  filtros = getVisibleColumns(data, mostrar);
		  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
			  var i = 0;
		filtros.forEach(function(filtro){
				  i++;
		  if(filtro == key){
					  var i = 0;
			linesKey.push(filtro);
					  linesData.push(data.map(function(e){ i++; return {x: i, y: e[key], xLabel: e[region] }; }));
		  }
		});
		  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
		//chartData.push({ values: linesData[i], key: linesKey[i], area: true });
			  //chartData.push({ values: linesData[i], key: linesKey[i], type: (linesKey[i].indexOf("limite") != -1) ? "line" : "area" });
			  chartData.push({ values: linesData[i], key: linesKey[i], yAxis: 1, type: (hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i])) ? "line" : "bar" });
	  }
  
	  return chartData;
  
	  }
  
	  function multiBarChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
				  chart: {
						  type: 'multiBarChart',
						  //height: 450,
						  reduceXTicks: false,
						  margin : {
								  top: 20,
								  right: 20,
								  bottom: 50,
								  left: 100
						  },
						  clipEdge: true,
						  duration: 500,
						  stacked: true,
						  controlLabels: {
							  grouped: "Agrupado",
							  stacked: "Apilado"
						  },
						  xAxis: {
							  rotateLabels: -25,
							  axisLabel: xAxisLabel || 'Concesionario',
							  showMaxMin: false,
							  tickFormat: function(d){
								  if(angular.isNumber(d))
									  return d3.format(',f')(d);
								  else
									  return d;
							  }
						  },
						  yAxis: {
								  axisLabel: yAxisLabel || 'Cantidad',
								  axisLabelDistance: -20,
								  tickFormat: function(d){
									  //return d3.format(',.1f')(d);
									  return d3.format('.02f')(d);
								  }
						  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function multiBarChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
	  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
			  var i = 0;
		filtros.forEach(function(filtro){
				  i++;
		  if(filtro == key){
					  var i = 0;
			linesKey.push(filtro);
					  linesData.push(data.map(function(e){ return {x: e[region], y: (angular.isDefined(e[key]) ? e[key] : 0) }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
		chartData.push({ values: linesData[i], key: linesKey[i], area: true });
	  }
  
	  mostrarValoresEnWidget();
  
	  return chartData;
	  }
	  //
	  function multiBarValuesChartOptions(xAxisLabel, yAxisLabel, invertir_bar_lin){
		  var options;
		  if(invertir_bar_lin == null){
			  options = multiBarChartOptions(xAxisLabel, yAxisLabel);
			  options.chart.labelAsMultiChart = true;
		  }
		  else
			  options = multiChartOptions(xAxisLabel, yAxisLabel);
  
		  options.class = "dashboard-show-values";
		  return options;
	  }
  
	  function mostrarValoresEnWidget(){
		  d3.selectAll('.dashboard-show-values .nv-multibar .nv-group').each(function(group){
			  var g = d3.select(this);
  
			  // Remove previous labels if there is any
			  g.selectAll('text').remove();
			  g.selectAll('.nv-bar').each(function(bar){
				  var b = d3.select(this);
				  var barWidth = b.attr('width');
				  var barHeight = b.attr('height');
  
				  g.append('text')
					  // Transforms shift the origin point then the x and y of the bar
					  // is altered by this transform. In order to align the labels
					  // we need to apply this transform to those.
					  .attr('transform', b.attr('transform'))
					  .text(function(){
						  // No decimals format and eliminate zero values
						  if (bar.y === 0) {
							  return;
						  }
						  return parseFloat(bar.y).toFixed(2);
					  })
					  .attr('y', function(){
						  // Center label vertically
						  var height = this.getBBox().height;
						  return parseFloat(b.attr('y')) + 15;
					  })
					  .attr('x', function(){
						  // Center label horizontally
						  var width = this.getBBox().width;
						  return parseFloat(b.attr('x')) + (parseFloat(barWidth) / 2) - (width / 2);
					  })
					  .style("stroke","black")
					  .attr('class', 'bar-values');
			  });
		  });
	  }
  
	  function multiBarValuesChartData(data, filtros, mostrar, invertir_bar_lin){
		  $timeout(function () {
			  mostrarValoresEnWidget();
		  }, 800);
		  return multiChartData(data, filtros, mostrar, invertir_bar_lin);
	  }
  
	function multiBarHorizontalChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
		chart: {
		  type: 'multiBarHorizontalChart',
		  //height: 450,
		  margin : {
			  top: 20,
			  right: 20,
			  bottom: 45,
			  left: 150
		  },
		  clipEdge: true,
		  duration: 500,
		  stacked: true,
		  controlLabels: {
			grouped: "Agrupado",
			stacked: "Apilado"
		  },
		  xAxis: {
			axisLabel: xAxisLabel || 'Mes',
			rotateLabels: -25,
			showMaxMin: false,
			tickFormat: function(d){
			  return d3.format(',f')(d);
			}
		  },
		  yAxis: {
			axisLabel: yAxisLabel || 'Cantidad',
			axisLabelDistance: -20,
			tickFormat: function(d){
			  //return d3.format(',.1f')(d);
						  return d3.format('.02f')(d);
			}
		  }
		}
	  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function multiBarHorizontalChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
  
	  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
		filtros.forEach(function(filtro){
		  //if(filtro.field == key && (angular.isDefined(filtro.value) && filtro.value != null)){
		  if(filtro == key){
			//linesKey.push(filtro.value);
			linesKey.push(filtro);
			linesData.push(data.map(function(e){ return {x: e[region], y: (angular.isDefined(e[key]) ? e[key] : 0) }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
			  if(!hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i]))
			chartData.push({ values: linesData[i], key: linesKey[i], area: true });
	  }
  
	  return chartData;
	  }
  
	  function multiBarHorizontalValuesChartOptions(xAxisLabel, yAxisLabel) {
		  var options = multiBarHorizontalChartOptions(xAxisLabel, yAxisLabel);
  
		  options.chart.stacked = false;
		  options.chart.showControls = false;
		  options.chart.showValues = true;
  
		  getWidgetColors(options);
  
		  return options;
	  }
  
	  function multiBarHorizontalValuesChartData(data, filtros, mostrar, invertir_bar_lin) {
	  return multiBarHorizontalChartData(data, filtros, mostrar, invertir_bar_lin);
	  }
  
	function pieChartOptions() {
	  var options = {
				  chart: {
						  type: 'pieChart',
						  margin : {
								  top: 30,
								  right: 0,
								  bottom: 0,
								  left: 0
						  },
						  x: function(d){return d.key;},
						  y: function(d){return d.y;},
						  showLabels: true,
						  duration: 500,
						  labelThreshold: 0.01,
						  labelSunbeamLayout: true,
						  showLegend: true,
						  labelType: function(d){
							  var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
							  return d.data.key + " - " + d3.format('.2%')(percent);
						  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	}
	function pieChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var datos = [];
	  if((angular.isDefined(data)) && angular.isDefined(data[0])){
		var objectKeys = Object.keys(data[0]);
		var region = objectKeys.find(function(e,i){ return i==0; });
		var lastAttrName = "";
		if(angular.isDefined(mostrar)){
		  var camposAMostrar = mostrar.split(",");
		  lastAttrName = objectKeys[camposAMostrar.length-1];
		} else {
		  lastAttrName = objectKeys[objectKeys.length-1];
		}
		angular.forEach(data, function(value){
		  datos.push({"key": value[region], "y": value[lastAttrName] });
		});
	  }
	  return datos;
	}
  
	function donutChartOptions() {
	  var options = {
		chart: {
		  "type": "pieChart",
		  "height": 450,
		  "donut": true,
		  "showLabels": true,
		  x: function(d){ return d.key; },
		  y: function(d){ return d.y; },
		  "pie": {
			startAngle: function (d) { return d.startAngle/2 -Math.PI/2 },
			endAngle: function (d) { return d.endAngle/2 -Math.PI/2 }
		  },
		  "duration": 500,
		  /*"legend": {
			"margin": {
			  "top": 5,
			  "right": 140,
			  "bottom": 5,
			  "left": 0
			}
		  }*/
		  showLegend: true
		}
	  };
  
		  getWidgetColors(options);
  
		  return options;
	}
	function donutChartData(data) {
  
	  var datos = [];
	  if((angular.isDefined(data)) && angular.isDefined(data[0])){
		angular.forEach(data[0], function(value, key){
		  datos.push({"key": key, "y": value });
		});
	  }
	  return datos;
  
	  /*return [
			  {
				  key: "One",
				  y: 5
			  },
			  {
				  key: "Two",
				  y: 2
			  },
			  {
				  key: "Three",
				  y: 9
			  },
			  {
				  key: "Four",
				  y: 7
			  },
			  {
				  key: "Five",
				  y: 4
			  },
			  {
				  key: "Six",
				  y: 3
			  },
			  {
				  key: "Seven",
				  y: 5
			  }
		  ];*/
	}
  
	function getVisibleColumns(data, visibles){
	  var visibleColumns = [];
	  var objectKeys = [];
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
	  visibleColumns = objectKeys.filter(function(e,i){
		if(angular.isDefined(visibles) && visibles != null){
		  var visiblesIndex = visibles.split(",");
		  return (i !== 0) && visiblesIndex.indexOf((i+1)+"") != -1;
		} else {
		  return (i !== 0);
		}
	  });
	  return visibleColumns;
	}
  
	  function getWidgetColorsByValue(values, key){
		  var colores = undefined;
		  angular.forEach(cfg.dashboard_colors_by_key, function(color){
			  if(angular.isObject(color)){
				  if(angular.isUndefined(colores)){
					  colores = [];
					  var pos = 0;
					  for(var i = 0; i < values.length; i++){
						  if(pos == cfg.dashboard_colors.length)
							  pos = 0;
  
						  colores.push(cfg.dashboard_colors[pos]);
						  pos++;
					  }
				  }
				  var clave = Object.keys(color);
				  clave = clave[0];
  
				  var coincidencia = values.find(function(e){
					  if(angular.isDefined(e[key]))
						  return e[key].toString().toUpperCase() == clave.toUpperCase();
					  else
						  return undefined;
				  });
				  if(angular.isUndefined(coincidencia)){
					  //Busco per nom de propietat dintre de la llista.
					  //aixo es util quan el eix X no conte el valor, si no que ve com a propietat
					  var keysInValues = Object.keys(values[0]);
					  coincidencia = keysInValues.find(function(e){
						  return e.toString().toUpperCase() == clave.toUpperCase();
					  });
				  }
  
				  if(angular.isDefined(coincidencia)){
					  var posicion = values.indexOf(coincidencia);
					  if(posicion == -1)
						  posicion = (keysInValues.indexOf(coincidencia) - 1);
					  if(posicion != -1)
						  colores[posicion] = color[clave];
				  }
			  }
		  });
		  return colores;
	  }
  
  
	  function hayQueInvertir(keyNames, invertir_bar_lin, nameField){
		  var result = false;
		  if(invertir_bar_lin){
			  var idxInvertirArr = invertir_bar_lin.split(",");
			  var idxColumn = keyNames.indexOf(nameField) + 1;
			  result = (idxInvertirArr.indexOf(idxColumn.toString()) != -1);
		  }
		  return result;
	  }
  
	  function getWidgetColors(options){
		  if(angular.isDefined(cfg.dashboard_colors))
			  options.chart.color = angular.copy(cfg.dashboard_colors);
	  }
  
  }]);
  
angular.module("FTBase").controller("SettingsAnimacionPopupController", [ "$scope", "$uibModalInstance", function($scope, $uibModalInstance){
    $scope.status = { editing: true };
    $scope.save = function(){
        $uibModalInstance.close({ animacion_segundos: $scope.animacion_segundos });
    };
}]);
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('gp4Controllers').controller('DashboardController', [ '$scope', 'ixStatusService', 'DataService', '$timeout', '$uibModal', '$q', 'gridService', '$http', 'cfg', 'authService', '$filter', 'ixUtilsService', 'Fullscreen', '$interval', function($scope, ixStatusService, DataService, $timeout, $uibModal, $q, gridService, $http, cfg, authService, $filter, ixUtilsService, Fullscreen, $interval){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.data.fullScreenDashboard = false;
	$scope.cfg = cfg;
  $scope.cancellerAnimationTimer;
  if(angular.isUndefined($scope.activeRow))
    $scope.activeRow = 0;

  $scope.init = function(){

		//Comprobar si el usuario tiene permiso para crear, editar y eliminar dashboards.
		ixUtilsService.checkPermission("DashboardsEdit").then(function(data){
			$scope.data.dashboardsEdit = data;
			if(data > 0){
				$scope.ixAddRow = function(){
					$scope.data = { dashboardsEdit: $scope.data.dashboardsEdit };
					$scope.data.isNew = true;
					$scope.ixEditar();
				};
				$scope.ixEditar = function(){
					$scope.gridsterOptions.draggable.enabled = true;
					$scope.gridsterOptions.resizable.enabled = true;
					ixStatusService.setEditing(true);
				};
				$scope.ixGuardar = function(){
					if($scope.data.dashboard.ToDelete == true){
						$http.delete(cfg.baseURL + "fend_config_dashboards/DeleteDashboard?usuario="+authService.authentication.userName+"&modulo="+$scope.modulo+"&id="+$scope.data.filtro.id).then(function(response){
							$scope.data.dashboard = {};
							ixStatusService.setResponse(response);
							ixStatusService.setEditing(false);
							$scope.data.isNew = false;
							$scope.status.filtered = false;
						}, function(error){
							ixStatusService.setResponse(error);
						});
					} else {
						var obj = {};
						obj.id = $scope.data.filtro.id;
						obj.clave = $scope.data.filtro.nombre_dashboard;
						obj.grupo = $scope.data.filtro.grupo;
						obj.nivel_acceso = $scope.data.filtro.nivel_acceso;
						obj.desktop = $scope.data.filtro.desktop;
						obj.modulo = $scope.modulo;
						var widgetsWithDataSource = $scope.data.dashboard.widgets.filter(function(e){ return angular.isDefined(e.dataSource); });
						obj.valor = angular.toJson(widgetsWithDataSource.map(function(e){
							var widgetObj = { col: e.col, dataSource: e.dataSource, filtros: e.filtros, row: e.row, tipo: e.tipo, titulo: e.titulo, subtitulo: e.subtitulo, totales: e.totales, mostrar: e.mostrar, invertir_bar_lin: e.invertir_bar_lin, explicativo: e.explicativo, colores: e.colores };
							if(angular.isDefined(e.chart) && angular.isDefined(e.chart.data)) widgetObj.disableds = e.chart.data.filter(function(e){ return e.disabled == true;}).map(function(e){ return e.key; });
							if(angular.isDefined(e.sizeX)) widgetObj.sizeX = e.sizeX;
							if(angular.isDefined(e.sizeY)) widgetObj.sizeY = e.sizeY;



							widgetObj.storedOptions = {};
							if(((angular.isDefined(e.chart)) && ((e.chart.api.getScope()).chart != null)) && angular.isDefined((e.chart.api.getScope()).chart.stacked)){
								if((e.chart.api.getScope()).chart.stacked()){
									widgetObj.storedOptions.stacked = true;
									widgetObj.storedOptions.grouped = false;
								} else {
									widgetObj.storedOptions.stacked = false;
									widgetObj.storedOptions.grouped = true;
								}
							}
							return widgetObj;
						}));
						var url = "";

						if(angular.isUndefined(obj.id)) obj.id = null;
						var usuario = "";
						if($scope.data.filtro.usuario)
							usuario = $scope.data.filtro.usuario;
						var perfil = "";
						if($scope.data.filtro.perfil)
							perfil = $scope.data.filtro.perfil;

						if($scope.data.filtro.nivel_acceso == "u"){
							$scope.data.filtro.perfil = '';
							url = cfg.baseURL+"fend_config_dashboards/usuario?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						} else if($scope.data.filtro.nivel_acceso == "p"){
							url = cfg.baseURL+"fend_config_dashboards/perfil?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						} else {
							url = cfg.baseURL+"fend_config_dashboards/global?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						}


						$http({
							url: url,
							method: "POST",
							data: obj.valor
						}).then(function(response){
							$scope.data.dashboard = {};
							ixStatusService.setResponse(response);
							ixStatusService.setEditing(false);
							$scope.data.isNew = false;
							$scope.status.filtered = false;
						});
					}

				};
			}
		});

    $scope.gridManualLoad = true;
    $scope.filterStatus = { isCollapsed: true };

    $scope.gridsterOptions = {
      margins: [20, 20],
      columns: 4,
      mobileModeEnabled: false,
      draggable: {
        enabled: false,
        handle: '.box-header'
      },
      resizable: {
        enabled: false,
        handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],

        // optional callback fired when resize is started
        start: function(event, $element, widget) {},
        // optional callback fired when item is resized,
        resize: function(event, $element, widget) {
          if (widget.chart.api) widget.chart.api.update();
        },

        // optional callback fired when item is finished resizing
        stop: function(event, $element, widget) {
          $timeout(function(){
            if (widget.chart.api) widget.chart.api.update();
          },400)
        }
      }
    };

    // We want to manually handle `window.resize` event in each directive.
    // So that we emulate `resize` event using $broadcast method and internally subscribe to this event in each directive
    // Define event handler
    $scope.events = {
      resize: function(e, scope){
        $timeout(function(){
          scope.api.update()
        },200)
      }
    };
    angular.element(window).on('resize', function(e){
      $scope.$broadcast('resize');
    });

    // We want to hide the charts until the grid will be created and all widths and heights will be defined.
    // So that use `visible` property in config attribute
    $scope.config = {
      visible: false
    };
    $timeout(function(){
      $scope.config.visible = true;
    }, 200);




    $scope.addWidget = function(){
      if(angular.isUndefined($scope.data.dashboard)) $scope.data.dashboard = {};
      if(angular.isUndefined($scope.data.dashboard.widgets)) $scope.data.dashboard.widgets = [];
      $scope.data.dashboard.widgets.push({ isNew: true });
    };

		$scope.onSelectDashboard = function(entity){
			$scope.data.filtro.grupo = entity.grupo;
			$scope.data.filtro.nivel_acceso = entity.nivel_acceso;
			$scope.data.filtro.desktop = entity.desktop;
			$scope.data.filtro.usuario = entity.usuario;
			$scope.data.filtro.perfil = entity.perfil;
		};

    $scope.ixFiltrar = function(){
      $scope.status.filtered = true;

      //Fem un get del llistat per tenir tota la info actualitzada.

      $http.get(cfg.baseURL + "fend_config_dashboards/usuario?usuario="+authService.authentication.userName+"&id="+$scope.data.filtro.id).then(function(response){
        if(angular.isUndefined($scope.data.dashboard)) $scope.data.dashboard = {};
        $scope.data.dashboard.widgets = angular.fromJson(response.data.valor);
        $scope.data.dashboardOriginal = angular.copy($scope.data.dashboard);
        $scope.data.filtro.nombre_dashboard = response.data.clave;
        $scope.data.filtro.grupo = response.data.grupo;
        $scope.data.filtro.nivel_acceso = response.data.nivel_acceso;
        $scope.data.filtro.desktop = response.data.desktop || 0;
        $scope.data.filtro.usuario = response.data.usuario;
        $scope.data.filtro.perfil = response.data.perfil;
        $scope.max_row = Math.max.apply(Math, $scope.data.dashboard.widgets.map(function(e) { return e.row; }));

        
        $scope.cargarWidgets();
      });
    };

    $scope.refresh = function(){
      //$timeout(function(){
        for(var i = 0; i < $scope.data.dashboard.widgets.length; i++){
          var widget = $scope.data.dashboard.widgets[i];
          var copia_widgets_originales = angular.copy($scope.data.dashboardOriginal.widgets);

          var widgetOriginal = copia_widgets_originales.find(function(e){ return e.titulo == widget.titulo && 
            e.subtitulo == widget.subtitulo && 
            e.tipo == widget.tipo &&
            e.col == widget.col; });

          if(widgetOriginal.row == $scope.activeRow)
            widget.visible_animacion = true;
          else 
            widget.visible_animacion = false;
        }
      //},1000);
    };

    $scope.siguienteFilaDashboard = function(){
      if(angular.isUndefined($scope.activeRow))
      $scope.activeRow = 0;
      else {
        if($scope.activeRow >= $scope.max_row)
          $scope.activeRow = 0;
        else
          $scope.activeRow++;
      }
      var widgetsEnRow = $scope.data.dashboardOriginal.widgets.filter(function(e){ return e.row == $scope.activeRow; });
      if(widgetsEnRow.length > 0)
        return $scope.activeRow;
      else
        return $scope.siguienteFilaDashboard();
    };

    $scope.cargarWidgetsAnimacion = function(){
      if($scope.data.fullScreenDashboard){
          if($scope.activeRow >= $scope.max_row)
            $scope.activeRow = 0;
          else
            $scope.activeRow = $scope.siguienteFilaDashboard();  
        // //$scope.data.dashboard.widgets = angular.copy($scope.data.dashboardOriginal.widgets);
        // console.log($scope.data.dashboard.widgets.map(function(e){ return e.row; }));
        // console.log($scope.data.dashboard.widgets);
        // console.log($scope.max_row);
        // console.log($scope.activeRow);

        $scope.refresh();

        var maxRow = 0;
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(maxRow < widget.row)
            maxRow = widget.row;
        });
        
        if(angular.isDefined($scope.rowObjetivo))
          $scope.cargarWidgets($scope.rowObjetivo);

        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(widget.row == $scope.activeRow)
            DataService.showWidget($scope, widget);
        });

        $scope.rowObjetivo = $scope.activeRow;
      }
    };

		$scope.cargarWidgets = function(row){

      if(angular.isDefined(row)){
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(widget.row == row)
            DataService.loadWidget($scope, $scope.modulo, widget);
        });

      } else {
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          DataService.loadWidget($scope, $scope.modulo, widget);
        });
      }
      
		};

    $scope.settingsAnimacionPopup = function(){
      var template = "app/FTBase/Dashboards/Dashboard/settings_animacion_popup.html";
      var options = { controller: "SettingsAnimacionPopupController" };
      ixUtilsService.openModalV2(template, options, "small").then(function(response){
        if(response.animacion_segundos){
          $scope.animacion_segundos = response.animacion_segundos;
          $scope.data.fullScreenDashboard = true;
          //TODO: Meter la carga en pantalla completa e ir pasando.
          //Timer para ir llamando a cargarWidgets de forma recursiva.
          $scope.cargarWidgetsAnimacion();
          //$scope.data.dashboard.widgetsOriginales = angular.copy($scope.data.dashboard.widgets);
        }
      });
    };

    $scope.$watch('data.fullScreenDashboard', function(newVal, oldVal){
      if(angular.isDefined(newVal)){
        if(newVal){
          //Definir timer para ir cambiando de mapa.
          $scope.cancellerAnimationTimer = $interval(function(){
            

            $scope.cargarWidgetsAnimacion();
          }, $scope.animacion_segundos * 1000);
        }
        else {
          //Hacer cancel del timer.
          if(angular.isDefined($scope.cancellerAnimationTimer))
            $interval.cancel($scope.cancellerAnimationTimer);
        }
      }
    });

    // $scope.myFilter = function(item){
    //   if(angular.isDefined($scope.activeRow)){
    //     //if(item.row == $scope.activeRow)
    //       //return false;
    //     //else
    //       //return false;
    //       return (item.row == $scope.activeRow);
    //   }
    //   else
    //     return true;
    // };


    $scope.ixCancelEdit = function(){
      if($scope.data.isNew){
        $scope.data.isNew = false;
        ixStatusService.setEditing(false);
      }
      if($scope.status.editing){
        $scope.gridsterOptions.draggable.enabled = false;
        $scope.gridsterOptions.resizable.enabled = false;
        ixStatusService.setEditing(false);
        if((angular.isDefined($scope.data.dashboardOriginal)) && angular.isDefined($scope.data.dashboardOriginal.widgets)){
          angular.forEach($scope.data.dashboardOriginal.widgets, function(widget){
            DataService.loadWidget($scope, $scope.modulo, widget);
          });
        }

      } else {
        $scope.data.fullScreenDashboard = false;
        $scope.status.filtered = false;
        $scope.data.dashboard = {};
        $scope.activeRow = undefined;
      }
    };

    $scope.ixDeleteSelectedRows = function(){
      $scope.data.dashboard.ToDelete = true;
    };

    $scope.numberOfChanges = function(){
      return (($scope.data.dashboard) && $scope.data.dashboard.ToDelete) ? 1 : undefined;
    };

    $scope.openSettings = function(widget){
      var modalInstance = $uibModal.open({
        //scope: $scope,
        templateUrl: 'app/FTBase/Dashboards/Dashboard/widget_settings_popup.html',
        controller:['$scope', '$timeout', '$uibModalInstance', 'widget', 'modulo', 'isEditing', function ($scope, $timeout, $uibModalInstance, widget, modulo, isEditing) {
					$scope.modulo = modulo;
					$scope.isEditing = isEditing;
          $scope.status = { editing: true };
          $scope.ixCancelEdit = undefined;
          $scope.ixAddRow = undefined;
          $scope.formSettings = {
            titulo: widget.titulo,
            subtitulo: widget.subtitulo,
            dataSource: widget.dataSource,
            tipo: widget.tipo,
            filtros: widget.filtros,
            mostrar: widget.mostrar,
						invertir_bar_lin: widget.invertir_bar_lin,
            totales: widget.totales,
            explicativo: widget.explicativo,
						colores: widget.colores
          };


          //$scope.$watch("dataSourceObj", function(newValue,oldValue){
					$scope.onSelectDataSource = function(newValue){
            if(angular.isDefined(newValue) && !angular.equals(newValue, $scope.oldDataSourceObj)){
							$scope.dataSourceObj = newValue;
							$scope.buildFilters($scope.oldDataSourceObj);
							$scope.oldDataSourceObj = newValue;
						}
          //});
					};

          $scope.buildFilters = function(oldValue){
            if(angular.isDefined($scope.dataSourceObj)){
              if(angular.isUndefined($scope.formSettings.titulo) || $scope.formSettings.titulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.titulo = $scope.dataSourceObj.titulo;
              if(angular.isUndefined($scope.formSettings.subtitulo) || $scope.formSettings.subtitulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.subtitulo = $scope.dataSourceObj.subtitulo;
              $scope.formSettings.mostrar = $scope.dataSourceObj.mostrar;
							$scope.formSettings.invertir_bar_lin = $scope.dataSourceObj.invertir_bar_lin;
              $scope.formSettings.totales = $scope.dataSourceObj.totales;
              $scope.formSettings.explicativo = $scope.dataSourceObj.explicativo;
							$scope.formSettings.colores = $scope.dataSourceObj.colores;
              //Construim filtres del widget.
              if(angular.isDefined(oldValue) || angular.isUndefined($scope.formSettings.filtros)){
                $scope.formSettings.filtros = [];
                var filtros = $scope.dataSourceObj.filtros.split(",");
                angular.forEach(filtros, function(filtro, i){
                  var filterInfo = filtro.split("$");
                  var tipo = "";
                  var multiple = false;
                  if(filterInfo[0].lastIndexOf("anyo") != -1) tipo = "anyo";
                  else if(filterInfo[0].lastIndexOf("mes") != -1) tipo = "mes";
                  else if(filterInfo[0].lastIndexOf("periodo") != -1) tipo = "periodo";
                  else if(filterInfo[0].lastIndexOf("texto") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("zonas") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("modos") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("fecha") != -1) tipo = "fecha";
                  else tipo = "busqueda";

                  if(filterInfo[0].lastIndexOf('*') != -1){
                    filterInfo[0] = filterInfo[0].replace("*", "");
                    multiple = true;
                  }


                  $scope.formSettings.filtros.push({ name: filterInfo[0], visibleText: filterInfo[1], tipo: tipo, multiple: multiple });
                });
                //$scope.$apply();
              }
            }
          };

					$scope.loadClientesCuenta = function(param){
						return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=9999", param);
					};
					$scope.loadClientesCuentaMin = function(param){
						return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=10", param);
					};
					$scope.loadZonasDistinct = function(param){
						return $http.post(cfg.baseURL + "zonas/Search?ItemsPerPage=9999", param).then(function(response){
							var registrosAgrupados = $filter("groupBy")(response.data.Items, "zona");
							var keys = Object.keys(registrosAgrupados);
							var listZonas = [];
							angular.forEach(keys, function(zona){
								listZonas.push({ zona: zona });
							});
							return { data: listZonas };
						});
					};

          $scope.save = function(){
            angular.extend(widget, $scope.formSettings);
            $uibModalInstance.close(widget);
          };

          $scope.loadDataSources = function(){
            var param = { Fields: [ { Field: "nombre" }, { Field: "tipo" }, { Field: "filtros" }, { Field: "titulo" }, { Field: "subtitulo" }, { Field: "totales" }, { Field: "mostrar" }, { Field: "invertir_bar_lin" }, { Field: "explicativo" }, { Field: "colores" } ], Selection: buildIxSearch() };
            param.Selection.Filters.push({ Field: "modulo", Value: modulo, Operator: CMP_EQ });
            return $http.post(cfg.baseURL + "api_dashboard/SelectAndProject", param);
          };

          $scope.loadChartTypes = function(){
            var deferr = $q.defer();

            if(widget.tipo != "medidor_radial"){
              $timeout(function(){
                deferr.resolve({data: [ { tipo: 'lineChart', nombre: 'Gráfica lineas'}, { tipo: 'pieChart', nombre: 'Gráfico pastel' }, { tipo: 'multiBarChart', nombre: 'Gráfico barras múltiples verticales' },{ tipo: 'multiBarValuesChart', nombre: 'Gráfico barras múltiples verticales con valor' }, { tipo: 'multiBarHorizontalChart', nombre: 'Gráfico barras múltiples horizontales' }, { tipo: 'multiBarHorizontalValuesChart', nombre: 'Gráfico barras múltiples horizontales con valor' }, { tipo: 'grid', nombre: 'Tabla' } ] });
              },1);
            }
            return deferr.promise;
          };
        }],
        backdrop: 'static',
        keyboard: false,
        resolve: {
          widget: function() {
            return widget;
          },
          modulo: function(){
            return $scope.modulo;
          },
					isEditing: function(){
						return $scope.status.editing;
					}
        }
      });

      modalInstance.result.then(function(widget){
        if(angular.isDefined(widget)){
            DataService.loadWidget($scope, $scope.modulo, widget);
        }
      });
    };

		$scope.exportWidget = function(widget){
			DataService.exportWidget($scope.modulo, widget.dataSource, widget.filtros);
		};

    $scope.remove = function(widget){
      $scope.data.dashboard.widgets.splice($scope.data.dashboard.widgets.indexOf(widget), 1);
    };
  }

  $scope.loadDashboardsUsuario = function(){
    return $http.get(cfg.baseURL + "fend_config_dashboards/dashboards_usuario?usuario="+authService.authentication.userName+"&modulo="+$scope.modulo).then(function(response){
      var result = [];
      if(response.data != null){
				angular.forEach(response.data, function(data){
					if(data.nivel_acceso == "p")
						data.asignado_a = "perfil " + data.perfil;
					else if(data.nivel_acceso == "u")
						data.asignado_a = "usuario " + data.usuario;
				});
        result = response;
      }
      return result;
    }, function(err){
      ixStatusService.setResponse(err);
    });
  };

  $scope.loadNivelesAcceso = function () {
    var deferral = $q.defer();
    deferral.resolve({
        data: [{acceso: 'u', nombre: 'Usuario'}, {acceso: 'p', nombre: 'Perfil'}, {acceso: 't', nombre: 'Todos'}]
    });
    return deferral.promise;
  };  


}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesFtVersionesController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.version = $scope.$resolve.version;
  $scope.nombre = $scope.$resolve.nombre;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.version = $scope.version;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_versiones', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "ft_versiones_idioma");
      filtroEstado = [{ Field: 'version', Value: $scope.version, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'version', Value: $scope.version, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

//angular.module('FTBase').controller("Ft_VersionesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q) {
angular.module('FTBase').controller("Ft_VersionesController", ['$scope', '$http', 'cfg', 'ixStatusService', 'ixUtilsService', '$log', function ($scope, $http, cfg, ixStatusService, ixUtilsService, $log) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_versiones");
  }

  $scope.data.pk = "version";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "version", "nombre" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }

    if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) {
      return;
    }
    else {
      $http.get(cfg.baseURL + "ft_versiones/"+current[$scope.data.pk]).then(function(response){
        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  /* ***** FUNCTION: IXGUARDAR ***** */
  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo tipo_ft
      data.nuevotipo = $scope.data.datos;
      $http.post(cfg.baseURL + "ft_versiones", data.nuevotipo).then(function (r){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar tipo_ft.
      data.tipo_ft = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + 'ft_versiones/' + $scope.data.datos[$scope.data.pk], data.tipo_ft).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }

  /* ***** FUNCTION: IXDELETESELECTEDROWS ***** */
  $scope.ixDeleteSelectedRows = function() {
    $http.delete(cfg.baseURL + "ft_versiones/" + $scope.data.datos[$scope.data.pk]).then(function(r) {
      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }

  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/ConfiguracionPreguntas/ft_versiones/traducciones_ft_versiones.html";
		var optionsPopup = { controller: "TraduccionesFtVersionesController" };
		var paramsPopup = { version: $scope.data.datos.version, nombre: $scope.data.datos.nombre };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }
}]);

angular.module('FTBase').controller('ConfigPreguntasController', [ '$scope', '$controller', 'ixUtilsService', '$http', 'cfg', 'ixStatusService', function($scope, $controller, ixUtilsService, $http, cfg, ixStatusService){
	$scope.entity = "ft_preguntas";
	//$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
	$scope.acciones = [
		{
			title: "Previsualizar pregunta",
			icon: "fa-search",
			accion: function(entity){
				var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/previsualizar_pregunta_popup.html";
				var optionsPopup = { controller: "PrevisualizarPreguntaPopupController" };
				var paramsPopup = { pregunta: entity };

				ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
			}
		},
		{
			title: "Editar pregunta",
			icon: "fa-pencil",
			accion: function(entity){
				var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html";
				var optionsPopup = { controller: "EditarPreguntaPopupController" };
				var paramsPopup = { pregunta: entity, isNew : false };

				var popup = $scope.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
				popup.then(function(data){
					$scope.data.grid.ixLoadInitialData();
				});
			}
		}
	];

	$scope.ixAddRow = function(){

		var nuevaPregunta = {};
		$http.post(cfg.baseURL + "ft_preguntas", nuevaPregunta).then(function (r) {

			var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html";
			var optionsPopup = { controller: "EditarPreguntaPopupController" };
			var paramsPopup = { pregunta: r.data.obj.Record, isNew : true };

			var popup = $scope.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
			popup.then(function(data){
				$scope.data.grid.ixLoadInitialData();
			});
	
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		
	}
	$controller('GridEditorController', { $scope: $scope });
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Ft_NivelesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_niveles");
  }

  $scope.data.pk = "nivel";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "nombre", "version", "nivel1", "nivel2" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }

    if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) {
      return;
    }
    else {
      $http.get(cfg.baseURL + "ft_niveles/"+current[$scope.data.pk]).then(function(response){
        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  /* ***** FUNCTION: IXGUARDAR ***** */
  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo nivel
      data.nuevonivel = $scope.data.datos;
      $http.post(cfg.baseURL + "ft_niveles", data.nuevonivel).then(function (r){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar nivel.
      data.nivel = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + 'ft_niveles/' + $scope.data.datos[$scope.data.pk], data.nivel).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }

  /* ***** FUNCTION: IXDELETESELECTEDROWS ***** */
  $scope.ixDeleteSelectedRows = function() {
    $http.delete(cfg.baseURL + "ft_niveles/" + $scope.data.datos[$scope.data.pk]).then(function(r) {
      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }
}]);

/*jslint browser: true, white: false*/
/*global buildBaseAppMenus*/
/*global mergeSubArrays*/
var buildMenus = function() {
  var generalMenus = buildBaseAppMenus();
  var menus = {
	children: [
    { // Administracion
			display: 'Administración',
			children: [
        {
          display: 'Configuraciones',
          href: 'Administracion/configuraciones/edit',
          icon: 'settings'
        },
        {
          display : 'Herramientas',
          children : [
            {
              display : 'Cambio estado masivo',
              href: 'herramientas/cambioestadomasivo',
              icon: 'attachment'
            }, 
            {
              display : 'Cambio ean/cod interno masivo',
              href: 'herramientas/cambioeancodinternomasivo',
              icon: 'attachment'
            }
          ]
        }
      ]
		},
    
    {
      display: 'Configuración FT',
      icon: '',
      children:
      [
        {
          display: 'Tipos Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_versiones',
          icon: 'list'
        },
        {
          display: 'Niveles Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_niveles',
          icon: 'list'
        },
        {
          display: 'Preguntas Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_preguntas',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Tablas Maestras',
      icon: '',
      children:
      [
        /* SOLO BONPREU */
        {
          display: 'Áreas',
          href: 'Mantenimientos/departamentos',
          icon: 'store'
        },
        {
          display: 'Clientes',
          href: 'Mantenimientos/clientes',
          icon: 'person_pin'
        },
        /* SOLO BONPREU */
        {
          display: 'Compradores',
          href: 'Mantenimientos/compradores',
          icon: 'shopping_cart'
         
        },
        {
          display: 'Laboratorios',
          href: 'Mantenimientos/laboratorios',
          icon: 'people'
        },
        {
          display: 'Marcas',
          href: 'Mantenimientos/extranet_marcas',
          icon: 'local_play'
        },
        {
          display: 'Estados',
          href: 'Mantenimientos/ft_estados',
          icon: 'list'
        },
        {
          display: 'Diccionarios',
          href: 'Mantenimientos/diccionarios',
          icon: 'import_contacts'
        },
        {
          display: 'Tipos Fichero Ficha técnica',
          href: 'Mantenimientos/tipos_fichero_ft',
          icon: 'rate_review'
        },
        {
          display: 'Categorías certificaciones proveedor',
          href: 'MantenimientosEuromadi/categorias_certificaciones_proveedores',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Ficheros y Certificados Proveedor',
          href: 'MantenimientosEuromadi/tipos_fichero_proveedor',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Auditorías',
          href: 'MantenimientosEuromadi/tipos_auditorias_plantas',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Fichero Proveedor',
          href: 'Mantenimientos/tipos_fichero_proveedor',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Fichero Laboratorio',
          href: 'Mantenimientos/tipos_fichero_laboratorio',
          icon: 'rate_review'
        },
        /* SOLO BONPREU */
        {
          display: 'Tipos análisis',
          href: 'Mantenimientos/tipos_analisis',
          icon: 'rate_review'
        }
      ]
    },
    {
      display: 'Proveedores',
      icon: '',
      children:
      [
        {
          display: 'Gestión proveedores',
          href: 'Mantenimientos/proveedores',
          icon: 'people'
        },
        // {
        //   display: 'Listado proveedores',
        //   href: '',
        //   icon: 'list'
        // },
        {
          display: 'Homologación proveedores',
          href: 'HomologacionPlantas/Listado_control_homologacion',
          icon: 'list'
        },
        {
          display: 'Resumen homologación proveedores',
          href: 'HomologacionPlantas/Listado_resumen_homologacion',
          icon: 'list'
        },
        {
          display: 'Carga ficheros FT',
          href: 'ListadosFt/Carga_Ficheros_FT',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Fichas Técnicas',
      icon: '',
      children:
      [
        {
          display: 'Listado Fichas Técnicas por agrupación',
          href: 'ListadosFT/Listado_Ft',
          icon: 'list'
        },
        {
          display: 'Listado Fichas Técnicas por Producto',
          href: 'ListadosFT/Listado_ProductosFt',
          icon: 'list'
        },
        {
          display: 'Búsqueda Avanzada',
          href: 'ListadosFT/Busqueda_Avanzada',
          icon: 'search'
				},
        {
          display: 'Control envío observaciones alérgenos App',
          href: 'ListadosFT/Listado_control_envio_obs_alergenos_app',
          icon: 'perm_device_information'
        },
        {
          display: 'Listado Proveedores/Fabricantes',
          href: 'ListadosFT/Listado_Productos_Marca',
          icon: 'list'
        },
        {
          display: 'Listado Fichas de Seguridad y Certificaciones',
          href: 'ListadosFT/Listado_Fichas_Seguridad',
          icon: 'list'
        },
        {
          display: 'Cambios de estado FT',
          href: 'ListadosFT/Listado_cambio_estados_ft',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Ficheros',
      icon: '',
      children:
      [
        {
          display: 'Listado Ficheros',
          href: 'ListadosFT/Listado_Proveedores_Ficheros',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Fotos Productos',
      icon: '',
      children:
      [
        {
          display: 'Carga Fotos',
          href: 'ListadosFT/Listado_Ft_Fotos_Producto',
          icon: 'list'
        },
        {
          display: 'Control Presencia Fotos',
          href: 'ListadosFT/Control_presencia_fotos',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Analíticas',
      icon: '',
      children:
      [
				{
          display: 'Planificaciones analiticas',
          href: 'ListadosFT/Listado_analiticas_ft',
          icon: 'list'
        },
        {
          display: 'Descarga de informes',
          href: 'ListadosFT/Descarga_informes_analiticas',
          icon: 'list'
        },
				{
					display: 'Carga masiva planificaciones',
					href: 'Integraciones/Planificaciones_analiticas',
					icon: 'attachment'
				}
      ]
    },
    {
      display: 'Contratos',
      icon: '',
      children:
      [
        {
          display: 'Contratos Fichas Técnicas',
          href: 'Contratos/extranet_fichas_tecnicas_contratos',
          icon:'euro_symbol'
        }
      ]
    },
    {
      display: 'Dashboards',
      icon: '',
      children:
      [
				{
          display: 'Dashboard',
          href: 'Dashboards/Dashboard',
          icon: 'dashboard'
        }
      ]
    },
    {
      display: 'Alarmas',
      icon: '',
      children:
      [
				{
          display: 'Estado fuera de plazo',
          href: 'Alarmas/estado_fuera_plazo',
          icon: 'list'
        },
        {
          display: 'Expiración certificados',
          href: 'Alarmas/expiracion_certificados',
          icon: 'list'
        },
        {
          display: 'Actualización FT',
          href: 'Alarmas/actualizacion_ft',
          icon: 'list'
        },
        {
          display: 'Verificación nuevos ingredientes',
          href: 'Alarmas/verificacion_ingredientes',
          icon: 'list'
        },
        {
          display: 'Certificados con ficheros obligatorios',
          href: 'Alarmas/certificados_ficheros',
          icon: 'list'
        },
        {
          display: 'Ingredientes por monitorizar',
          href: 'Alarmas/ingredientes_monitorizar',
          icon: 'list'
        }
      ]
    }
	]
};
  var mergedMenus = mergeSubArrays([].concat(generalMenus, menus));
  mergedMenus.splice(1);
  return mergedMenus;
}

var buildGP4Menus = angular.copy(buildMenus);

(function(){
  'use strict';
  angular.module('FTBaseApp', [ 'gp4App', 'ngHandsontable' ]);
})();

/*global foo*/
angular.module('gp4App').factory('WebWorkerService', [ '$http', 'cfg', '$q', '$window', function($http, cfg, $q, $window) {
	var service = {};		
	
  var _blobString = function ()
  {
    return "BLOB_FOR_WEB_WORKER";
  }

	var _get = function(url){
    //var _worker = new Worker('app/base/workers/ix_worker.js');
    var _worker = _blobString();
    if(_worker != "BLOB_FOR_WEB_WORKER" && $window.Blob && $window.URL.createObjectURL) {
      //worker's string was loaded successfully
      var blob = new Blob([_worker], {type: 'application/javascript'});
      ///Continue with the worker blob to url initialization
      _worker = new Worker(URL.createObjectURL(blob));
    } else {
      //Fallback! Can be used for debugging purposes.
      _worker = new Worker("app/base/workers/ix_worker.js");
    }
		var defer = $q.defer();
		_worker.onmessage = function(e) {           
			defer.resolve({ data: angular.fromJson(e.data) });
			_worker.terminate();
		};
		
		var urlObj = { url: url };
		var authData = angular.fromJson(sessionStorage['authorizationData']);
		if (authData && authData.token) {
			urlObj.Authorization = 'Bearer ' + authData.token;
			urlObj.TimeDiff = authData.timeDiff;
		}

		_worker.postMessage(urlObj);
		return defer.promise;
	};
	
	service.get = _get;
	return service;
	
}]);


angular.module('gp4App').factory('ixWarningsService', ['$rootScope', '$location','cfg','authService','$http', 'uiGridConstants', '$timeout', 'ixLockedViewService', '$log', '$window', '$ngConfirm', function ($rootScope, $location, cfg, authService, $http, uiGridConstants, $timeout, ixLockedViewService, $log, $window, $ngConfirm) {
	var serviceInstance = {

    warningConfirmacion : function(scope,frase,accionOk,accionCancelar,parametrosOk){
      $ngConfirm({
  			icon: 'fa fa-warning',
  			title: 'Aviso',
  			content: frase,
  			scope: scope,
  			closeIcon: false,
  			buttons: {
  				ok: {
  					text: "Continuar",
  					btnClass: 'btn-ix-green',
  					show: 'true',
  					keys: ['enter'], // will trigger when enter is pressed
  					action: function(scope){
              if(angular.isDefined(accionOk))
					      accionOk(parametrosOk);
  						return true;
  					}
  				},
          cancelar: {
            text: "Cancelar",
  					btnClass: 'btn-ix-green',
  					show: 'true',
  					action: function(scope){
              if(angular.isDefined(accionCancelar))
					      accionCancelar();
  						return true;
  					}
          }
  			}
  		});
    }

	};

	return serviceInstance;
}]);

/*eslint angular/json-functions: 0*/
/*global addDateDeriveds*/
/*global saveAs*/
/*global checkPermission*/
/*global CMP_EQ*/
/*global CMP_GTE*/
/*global CMP_LT*/
angular.module("gp4App").factory("ixUtilsService", [ 'cfg', '$filter', '$translate', 'gridUtil', '$http', '$sce', '$window', '$uibModal', '$timeout', function(cfg, $filter, $translate, gridUtil, $http, $sce, $window, $uibModal, $timeout){

	var service = {};

	service.drawPivot = function(tagId, data, pivotOptionsOverride, colDefs){
    var renderers = $.pivotUtilities;
    var pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers : $.extend($.pivotUtilities.renderers,$.pivotUtilities.d3_renderers,$.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers, $.pivotUtilities.derivers),
      rendererName: "Table"
    };
    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);

		var propertyNamesWithTranslation = [];

		if(angular.isDefined(colDefs)){
			//Agafar del displayName de la metadata.
			if(angular.isDefined(pivotData) && pivotData[0]){
				propertyNamesWithTranslation = getPropertyNames(pivotData[0], colDefs);

				translateObjsProperties(pivotData, propertyNamesWithTranslation);

				translateStrings(pivotOptions.rows, propertyNamesWithTranslation);
				translateStrings(pivotOptions.cols, propertyNamesWithTranslation);

				if(pivotOptions.vals)
					translateStrings(pivotOptions.vals, propertyNamesWithTranslation);
			}

		} else {
			//Traducció de totes les propietats de la pivot.

			if(angular.isDefined(pivotData) && pivotData[0]){
				propertyNamesWithTranslation = getPropertyNames(pivotData[0]);
				translateObjsProperties(pivotData, propertyNamesWithTranslation);

				translateStrings(pivotOptions.rows, propertyNamesWithTranslation);
				translateStrings(pivotOptions.cols, propertyNamesWithTranslation);

				if(pivotOptions.vals)
					translateStrings(pivotOptions.vals, propertyNamesWithTranslation);
			}
		}
		if(!pivotOptions.derivedAttributes)
			pivotOptions.derivedAttributes = addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, pivotData);

    angular.element(tagId).pivotUI(pivotData, pivotOptions, true, "es");
  };
	
	service.downloadPDF = function(file, filename) {
		checkPermission($http, cfg, "OpenPdfNewTab").then(function(result){
    	if(result) {
				var objectUrl = URL.createObjectURL(file);
				$window.open($sce.trustAsResourceUrl(objectUrl), "_blank");
			}
			else {			
				saveAs(file, filename);
			}
		}, function(err) {
			saveAs(file, filename);
		});
	};
	
	service.openModalV2 = function(template, options, size, params) {
		var defaultOptions = {
			templateUrl: template,
			size: size || 'lg',
			backdrop: 'static',
			keyboard: false
		};
		if(angular.isDefined(options.scope)){
			defaultOptions.scope = options.scope;
			delete options.scope;
		}

		if(angular.isDefined(params)){
			if(angular.isUndefined(defaultOptions.resolve)){
				defaultOptions.resolve = {};
			}
			angular.forEach(params, function(value, key){
				defaultOptions.resolve[key] = function(){ return value; };
			});
		}

		angular.merge(defaultOptions, options);
	if (options.returnInstance)							
	return $uibModal.open(defaultOptions);
	else
			return $uibModal.open(defaultOptions).result;      
	};

	function getPropertyNames(item, colDefs){
		var propertyNamesWithTranslation = [];
		angular.forEach(Object.keys(item), function(prop){
			if(angular.isDefined(colDefs)){
				var displayGridName = colDefs.find(function(e){ return e.field == prop; });
				if(displayGridName){
					propertyNamesWithTranslation.push({ original: prop, translated: displayGridName.displayName });
				} else {
					propertyNamesWithTranslation.push({ original: prop, translated: gridUtil.readableColumnName(prop) });
				}
			} else {
				propertyNamesWithTranslation.push({ original: prop, translated: $translate.instant(gridUtil.readableColumnName(prop)) });
			}
		});
		return propertyNamesWithTranslation;
	}

	function translateObjsProperties(collection, translations){
		angular.forEach(collection, function(item){
			angular.forEach(translations, function(translation){
				if(translation.translated != translation.original){
					item[translation.translated] = item[translation.original];
					delete item[translation.original];
				}
			});
		});
	}

	function translateStrings(collection, translations){
		for(var i = 0; i < collection.length; i++){
			var translation = translations.find(function(e){ return e.original == collection[i]; });
			if(translation)
				collection[i] = translation.translated;
		}
	}

	service.checkPermission = function(etiqueta){
		return $http.get(cfg.baseURL + "configuraciones/GetConfig/" + etiqueta).then(function(response){
			return response.data;
		});
	};

	service.toJson = function (data, objPropertiesMap) {
		var notEmpties = service.skipEmptyObjects(data);
		if (angular.isDefined(objPropertiesMap)) {
			service.renameObjectKeys(notEmpties, objPropertiesMap);
		}
		var jsonData = JSON.stringify(notEmpties, function (key, val) {
			if (key == "modifiedValues" || key == "$$hashKey" || key == "isNew" || key == "estaSeleccionado") return undefined;
			if (angular.isString(val))
				return val.trim();
			else
				return val;
		});
		return jsonData;
	};

	service.renameObjectKeys = function (src, map) {
		if (angular.isArray(src)) {
			for (var i = 0; i < src.length; i++) {
				src[i] = service.renameObjectKeys(src[i], map);
			}
		} else {
			var dst = {};
			// src --> dst (copy)
			for (var key in src) {
				if (key in map)
					// rename key
					dst[map[key]] = src[key];
				else
					// same key
					dst[key] = src[key];
			}
			return dst;
		}
	};

	service.skipEmptyObjects = function (data) {
		data = data.filter(function (e) {
			return service.isNotEmptyObject(e);
		});
		return data;
	};

	service.isNotEmptyObject = function(e){
		return (!angular.isObject(e) || angular.isArray(e) || (Object.keys(e).length > 0 && !allPropertiesNull(e)));
	};

	function allPropertiesNull(obj){
		var countNulls = 0;
		angular.forEach(obj, function(val, key){
			if(!val) countNulls++;
		});
		return (Object.keys(obj).length == countNulls);
	}

	service.fromJson = function(data){
		return angular.fromJson(data);
	};

	service.showGrid = function(grid){
		if (angular.isDefined(grid.ixRestoreConfig))
			grid.ixRestoreConfig();
		$timeout(function(){
			if((angular.isDefined(grid)) && angular.isDefined(grid.gridApi))
				grid.gridApi.core.handleWindowResize();
				//grid.gridApi.core.scrollTo(grid.data[0], grid.columnDefs[0]);
		},200);
	};

	service.ixFiltersToArray = function(filtersArray, entity, fieldsToSkip){
		var param = [];
		var paramValue;
		var filter;
		angular.forEach(filtersArray, function(value, key){
			var i = 0;
			if(angular.isObject(value) && Object.keys(value).length > 0){
				var notNullValues = Object.keys(value).filter(function(e){ return angular.isDefined(value[e]) && value[e] != null && value[e] != ""; }).map(function(a){ return { value: value[a], first: (a == 0) }; });
				while(i < notNullValues.length) {
					paramValue = notNullValues[i].value;

					if(angular.isUndefined(entity)){
						filter = { Field: key, Value: paramValue };
					} else {
						filter = { Field: entity+"."+key, Value: paramValue };
					}

					//obrim parentesis
					if(i == 0){
						filter.StartPar = true;
					} else if(i < (notNullValues.length) && !angular.isDate(paramValue)){//si hi ha múltiples i no són dates anem possant OR
						filter.Or = true;
					}

					if(angular.isDate(paramValue)){
						if(i == 0 && notNullValues[i].first){
							filter.Value = $filter("date")(filter.Value, "yyyy-MM-dd");
							filter.Operator = CMP_GTE;
						} else {
							var now = $filter("date")(filter.Value, "yyyy-MM-dd");
							var partsDate = now.split("-");
							var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
							//li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
							dateMax.setDate(dateMax.getDate() + 1);
							filter.Value = $filter("date")(dateMax, "yyyy-MM-dd");
							filter.Operator = CMP_LT;
						}
					} else {
						filter.Operator = CMP_EQ;
					}

					if(i == (notNullValues.length - 1)){
						filter.EndPar = true;
					}
					if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
					param.push(filter);
					i++;
				}
			} else {
				paramValue = value;

				if(angular.isUndefined(entity)){
					filter = { Field: key };
				} else {
					filter = { Field: entity+"."+key };
				}
				if(angular.isDate(paramValue)){
					filter.Value = $filter("date")(paramValue, "yyyy-MM-dd");
				} else {
					filter.Value = paramValue;
				}
				filter.Operator = CMP_EQ;
				if(angular.isDefined(filter.Value) && filter.Value != null && filter.Value !== ""){
					if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
					param.push(filter);
				}
			}
		});
		return param;
	};

	/**
	 * Busca la existencia de 'search' en 'cadena' sin tener en cuenta mayúsculas ni acentos (accent folding)
	 * la funcion normalize("NFD") separa los acentos de su vocal, i el replace(/[\u0300-\u036f]/g,"") elimina cualquier cosa que no sea un 'char'
	 * @param {string} cadena cadena en la que buscar
	 * @param {string} search valor a buscar en cadena
	 * @returns cadena.indexOf(search) sin tener en cuenta mayúsculas ni acentos
	 */
	service.comparar =  function(cadena,search) {
		if(!cadena) return -1;
		if(!search) return 0;
		return cadena.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").indexOf(search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,""));
	}

	//Si ens trobem que hi ha algun problema al enviar una data per query string a la API quan el format de la data està en un format diferent al espanyol dd/MM/yyyy es farà servir
	//aquesta funció. Exemple: fecha="+ixStatusService.dateEncoder($scope.data.fecha)+".....".
	service.dateEncoder = function(d){
		var z = function (n) { return (n < 10 ? '0' : '') + n; };
  	var off = d.getTimezoneOffset();
  	var sign = off < 0? '+' : '-';
  	off = Math.abs(off);

  	return encodeURIComponent(d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
															z(d.getDate()) + 'T' + z(d.getHours()) + ':'  + z(d.getMinutes()) +
															':' + z(d.getSeconds()) + sign + z(off/60|0) + z(off%60));
	};

	return service;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global convertDateStringsToDates */
'use strict';
angular.module('gp4App').factory('ixStatusService', ['$rootScope', '$location','cfg','authService','$http', 'uiGridConstants', '$timeout', 'ixLockedViewService', '$log', '$window', '$ngConfirm', function ($rootScope, $location, cfg, authService, $http, uiGridConstants, $timeout, ixLockedViewService, $log, $window, $ngConfirm) {
	var serviceInstance = {

		/* status de la aplicacio oberta */
		current: {},

		/* llista aplicacions obertes (o marcasdes com a fav) */
		availApps: [],

    checkObjAndHref: function(arr, obj){
      for(var i = 0; i < arr.length; i++){
        if(angular.equals(arr[i], obj) || angular.equals(arr[i].href, obj.href)){//Si l'objecte es troba a l'array o si l'atribut href coincideix.
          if(obj.atributos == null || angular.equals(arr[i].atributos, obj.atributos))//Si la nova app no conté 'atributos' o si hi ha un objecte a l'array que té el mateix valor a 'atributos'
          return i;                                                                   //la app ja està oberta.
        }

      }
      return -1;
    },

		/* obrir una aplicacio */
		openApp: function(app, param) {
      if(this.current !== app || $rootScope.fromDesktop == true){
        this.current.transitionend = false;
        $rootScope.fromDesktop = false;
      }
      $log.log("openApp");
			
			var pageAnimationSuffix = ""; 
			if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
					pageAnimationSuffix = "-" + cfg.pageAnimation;
			
      if($rootScope.pageAnimationClass == 'page-animation-bottom' + pageAnimationSuffix) { $rootScope.pageAnimationClass = 'page-animation-top' + pageAnimationSuffix; }
			else { $rootScope.pageAnimationClass = 'page-animation-left' + pageAnimationSuffix; }
      //var indexAvail = this.availApps.indexOf(app);
      var indexAvail = this.availApps.map(function(e){ return e.href; }).indexOf(app.href);
      var indexDynApp = this.checkObjAndHref(this.availApps, app);
      //La directiva ixAccion genera objectes app dinamicament. Aquestes app no es trobem al menus.js
      //Els únics atributs que té l'objecte són:
      //display, href i atributos
      //
      //if(!app.open && (this.availApps[indexAvail] == null || !this.availApps[indexAvail].open)) {

			if(app.multiple)
				indexAvail = indexDynApp;

      if(!app.open) {
          app.data = param || {};
					app.open = true;
          this.availApps[indexAvail] = app;
          this.current = app;

      } else if(!app.open && (this.availApps[indexDynApp] == null || !this.availApps[indexDynApp].open)){
        app.data = param || {};
        app.open = true;
        this.current = app;
      } else {
				if(angular.isDefined(param)){
					this.availApps[indexAvail] = angular.merge(this.availApps[indexAvail], param);
				}
				this.current = this.availApps[indexAvail];
      }

      if(app.atributos){
        $location.path("/"+app.href).search(app.atributos);
      } else {
        $location.path("/"+app.href);
      }
			$timeout(function(that,app,indexAvail){
				if(indexAvail === -1) {
					that.availApps.push(app);
				}
			},300,true,this, app, indexAvail)
		},

		/* canvia el mode edicio a l'aplicacio actual */
		setEditing: function(editing) {
      if(editing == true){
        // ixLockedViewService.lock(this.current);
        var ixStatusInstance = this;
        $timeout(function(){
          ixStatusInstance.current.deleteEnabled = true;
        },5000);
      } 
      // else {
      //   ixLockedViewService.free(this.current);
      // }
      this.current.deleteEnabled = false;
			this.current.editing = editing;
		},

		blockUIWhileProcessing: function(process, callbackOK, callbackErr){
			var serviceObj = this;
			var currentApp = this.current;
			this.blockUIBtns(currentApp, true);
			process.then(function(res){
				serviceObj.blockUIBtns(currentApp, false);
				callbackOK(res);
			}, function(err){
				serviceObj.blockUIBtns(currentApp, false);
				callbackErr(err);
			});
		},

		blockUIBtns: function(app, block){
			app.blockUIBtns = block;
		},

    //Iteració de Warnings per anar montant els missatges de toast.
    buildWarnIfNecessary: function(response, scopeObj){
      var theStatusObj = this;

      var content = "";
      if(angular.isDefined(response.data)){
        if(angular.isDefined(response.data.Inserted) && response.data.Inserted != null){
          response.data.Inserted.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.Updated) && response.data.Updated != null){
          response.data.Updated.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.Deleted) && response.data.Deleted != null){
          response.data.Deleted.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.obj) && response.data.obj != null){
          response.data.obj.Errors.forEach(function(errorObj){
            if(errorObj.ErrType == 1){
              content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
            }
          });
        }

      }


      if(angular.isDefined(content) && content != ""){
        theStatusObj.current.data.warnings = true;
        //Montar la nova directiva pels warning.
        $ngConfirm({
          icon: 'fa fa-warning',
          title: 'Aviso',
          content: content,
          scope: scopeObj,
          buttons: {
            ok: {
              text: "Guardar",
              btnClass: 'btn-ix-green',
              show: angular.isDefined(scopeObj),
              keys: ['enter'], // will trigger when enter is pressed
              action: function(scope){
                theStatusObj.current.data.warnings = false;
								if(angular.isDefined(scope.executeAfterProcess)){
									scope.executeAfterProcess();
									theStatusObj.current.data.warnings = true;
								}
                else if(angular.isDefined(scope.ixGuardar)){
                  scope.ixGuardar();
                  theStatusObj.current.data.warnings = true;
                }
              }
            },
            close: {
              text: "Cerrar"
            }
          }
        });
      }/* else if(theStatusObj.current.data.hasWarnings && response.data.GlobalMessage.ErrType == 0) {
        //TODO: Si no venen warnings i el ErrorNotice no és error (2) possarem el editing a false.
        theStatusObj.current.data.warnings = undefined;
      }*/

    },

    setResponse: function(response, scope){
      var theStatusObj = this;
      theStatusObj.current.response = response;

      if(response && response.data && response.data.GlobalMessage && response.data.GlobalMessage.ErrType == 1)
        this.buildWarnIfNecessary(response, scope);


      if(response && response.status == 200 && response.data.GlobalMessage && response.data.GlobalMessage.ErrType == 0){
        $timeout(function(){
          delete theStatusObj.current.response;
        }, 2500);
      }
    },

    sendWarnings: function(){
      var warningString = "";
      if(angular.isDefined(this.current.data.hasWarnings)){
        warningString += "warning="+(this.current.data.warnings !== false);
      }
      return warningString;
    },

		/* tancar una aplicacio */
		closeApp: function(app) {
      $log.log("closeApp");
			this.blockUIBtns(app, false);
			
			var pageAnimationSuffix = ""; 
			if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
				pageAnimationSuffix = "-" + cfg.pageAnimation;
					
			
      $rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix;
      // ixLockedViewService.free(app);
      delete(this.current.response);
      //this.current = app;
      //this.setEditing(false);
      var indexAvail = this.availApps.indexOf(app);
      if(indexAvail >= 0) {
        this.availApps[indexAvail].open = false;
        this.availApps[indexAvail].editing = false;
        if(this.availApps[indexAvail].filtered) this.availApps[indexAvail].filtered = false;
				delete(this.availApps[indexAvail].data);
				/*if(!this.availApps[indexAvail].fav) {
					this.availApps.splice(indexAvail,1);
					$log.log("closedApp", this.availApps);
				}*/
			}
      //Redirecciona a index en cas de tancar la app desde la app oberta.
      if($location.path() !== "/" && !app.onCloseGoTo){
        $location.path("/");
      } else if($location.path() !== "/" && angular.isDefined(app.onCloseGoTo)) {
        //Si al tancar ha de tornar a alguna app en concret, la busca a partir del href i la obre.
				//Si tiene onCloseGoTo puede pasar parametros a la pantalla anterior.

				var sendParamsBack = app.onCloseSendParam;

        this.openApp(this.availApps.find(function(e){ return e.href === app.onCloseGoTo; }), sendParamsBack);
      }
		},

		/* recuprear estat de backend (es crida just després del login) */
		load: function () {
			$log.log("restoring status");
			var that = this;
      that.availApps = [];
			/*return $http.get(cfg.baseURL+"fend_config/usuario/"+authService.authentication.userName+"/openApps").then( function(response){
        if(response.data != null && response.data.valor != null){
          var news = angular.fromJson(response.data.valor);
					news = news.filter(function(app){return app.open || app.fav});
          convertDateStringsToDates(news);
          that.availApps = news;

					$log.log("restored status", that.availApps);

          // Establir current app a partir de la URL
          //Arnau: $location.path abans era $location.$$path, comprobar al final.
          that.availApps.forEach(function(app) {
            if($location.path === "/" + app.href) {
              that.current = app;
              if(!app.data) {
                app.data={};
              }
              app.open = true;
              $log.log("current app is",$location.path, app);
            }
          })
        }
      });*/
      //Recupera les apps favorites.
      return $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave=Desktop").then( function(response){        
        var favApps = (angular.isDefined(response.data) && response.data != null) ? angular.fromJson(response.data.valor) : [];
        /*favApps.forEach(function(favApp){
          var app = that.availApps.find(function(e){ return e.display === favApp.display; });
          var index = that.availApps.indexOf(app);
          app.fav = true;
          that.availApps[index] = app;
        });*/
        return favApps;
      });
		},

		/* guardar estat a backend (es crida al fer logout) */
		save: function() {
			// Eliminar cicles provocats per gridApi
			this.availApps.forEach(function(app){
				angular.forEach(app.data,function(key) {
					if(key.gridApi) {
						delete(key.gridApi);
					}
				});
			});
			$log.log("Si dona error al saving status, buscar cycles aquí",this.availApps);
      var bodyValue = angular.toJson(this.availApps);
			return $http.post(cfg.baseURL+"fend_config/usuario/"+authService.authentication.userName+"/openApps", bodyValue);
		}


	};

	return serviceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('ixLockedViewService', [ 'cfg', '$http', 'authService', '$log', function(cfg, $http, authService, $log){
  var serviceInstance = {
    checkIsLocked: function(app){
      //TODO: Comprobará en el servidor, si la app que llega por parámetro está o no bloqueada.
      //Si lo está, crearemos el bloqueo en el objeto de app que llega por parámetro.
      //Nota: Esta función no hará falta si se hace mediante WebSockets.
      //Si se hace mediante WebSockets, definir una función init que se subscriba al WebSocket, está se ejecutará al abrir una nueva app.
    },
    lock: function(app){
      $log.log("lock the app");
      //TODO: Bloquear, añadirá (o notificará a WebSocket) el bloqueo.
      app.data.bloqueo = {
        user: authService.authentication.userName,
        ts: new Date(),
        app: app.display
      };
    },
    free: function(app){
      $log.log("free the app");
      //TODO: Desbloquear, borrará (o notificará a WebSocket) el bloqueo.
      if(app.data && app.data.bloqueo){
        delete app.data.bloqueo;
      }
    }
  };

  return serviceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict'
angular.module('gp4App').factory('ixCestaVehiculosService',[ function() {
  var service = {};
  //var _cesta = JSON.fromJson(localStorage.getItem('cesta')) || [];
  var _pantalla = "";
  var _cesta = {};
  var _options = {};
  var _showing = false;
  var _parseLines = function(items){
    if(items == ""){ return []; }

    var array = [];
    var lines = items.split('\n');
    lines.forEach(function(line){
      if(line !== "")
        array.push(line);
    });
    return array;
  }

  service.getCesta = function(){
    return _cesta[_pantalla] ? _cesta[_pantalla] : "";
  }

  service.getOptions = function(){
    return _options[_pantalla] ? _options[_pantalla] : "";
  }

  service.saveCesta = function(cesta){
    /*
    if(items == null) _cesta[_pantalla] = [];
    else if(angular.isString(items)){ _cesta[_pantalla] = _parseLines(items); }
    else _cesta[_pantalla] = items;
    */
    if(cesta == null){
      _cesta[_pantalla] = {};
    }
    else if(angular.isString(cesta.items)){
      _cesta[_pantalla] = {
        campo: cesta.campo,
        items: _parseLines(cesta.items),
        terminacion: cesta.terminacion,
				cortar: cesta.cortar
      };
    }
    else {
      _cesta[_pantalla] = {
        campo: cesta.campo,
        items: cesta.items,
        terminacion: cesta.terminacion,
				cortar: cesta.cortar
      };
    }
  }

  service.emptyCesta = function(){
    _cesta[_pantalla] = cestaInitialValues();
    return _cesta[_pantalla];
  }

  service.getCount = function(){
    return ((_cesta[_pantalla]) && _cesta[_pantalla].items) ? _cesta[_pantalla].items.length : 0;
  }

  service.isShowing = function(){
    return _showing;
  }

  service.setShowing = function(visible){
    _showing = visible;
  }

  service.init = function(pantalla, cestaOptions){
    _pantalla = pantalla;
    _cesta[_pantalla] = _cesta[_pantalla] || cestaInitialValues();
    _options[_pantalla] = _options[_pantalla] || angular.merge({ requestDataAfterSave: true }, cestaOptions);
    service.setShowing(true);
  }

	var cestaInitialValues = function(){
		return { items: [], campo: "chasis", terminacion: 0 };
	}

  return service;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*eslint no-constant-condition: 0*/
/*global v */
/*global setDefaultFilter */
/*global saveAs */
/*global getDefaultFilters */
/*global getLocalFilters*/
/*global getCestaFilters */
/*global getColors */
/*global convertFromServerType */
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
/*global mergeArraysByTag */
/*global parseObjectsToString */
/*global ixGridColumnFilterCondition*/
/*global canceller*/
/*global ixNewDate*/
'use strict';
angular.module('gp4App').factory('gridService', ['ixStatusService','ixCestaVehiculosService','$compile','cfg','authService','$http', 'uiGridConstants', 'uiGridEditConstants', '$timeout', '$filter', '$log', '$window', '$document', '$translate', 'gridUtil', 'uiGridExporterService', 'uiGridExporterConstants', 'clipboard', 'uiGridValidateService', 'gridConfigService', '$interval', '$uibModal', '$q', '$rootScope', 'WebWorkerService', 'moment', 'uiGridCellNavService', 'uiGridCellNavConstants', 'ixUtilsService', function (ixStatusService, ixCestaVehiculosService, $compile, cfg, authService, $http, uiGridConstants, uiGridEditConstants, $timeout, $filter, $log, $window, $document, $translate, gridUtil, uiGridExporterService, uiGridExporterConstants, clipboard, uiGridValidateService, gridConfigService, $interval, $uibModal, $q, $rootScope, WebWorkerService, moment, uiGridCellNavService, uiGridCellNavConstants, ixUtilsService) {

  var canceller;
	var cancellerBusquedaFunction;

	var TOOLTIP_CLASSIC = 0;
	var TOOLTIP_NOT_EMPTY_VALUES = 1;
	var TOOLTIP_ALL_VALUES = 2;

	var TAB_KEY = 9;
	var INTRO_KEY = 13;
	var DOWN_KEY = 40;
	var LEFT_KEY = 37;
	var RIGHT_KEY = 39;
	var gridServiceInstance = {

		/**
		 * Crea un griodOptions per a ui-grid
		 *
		 * @param   {object}   scope       [[Description]]
		 * @param   {[[Type]]} gridName    [[Description]]
		 * @param   {[[Type]]} gridOptions [[Description]]
		 * @param   [[String]]   entity      [[Si s'informa, recuperara les columnes de metadata]]
     * @param   [{object}] extraColumns [{name: "string", type: "string", enPopup: Boolean, url: "string", atributos: ["string"] }]
		 * @returns gridOptions
		 */
		createGrid: function(scope, gridName, gridOptionsOverride, entity, extraColumns) {
			$log.log("creating grid",gridName);
			ixStatusService.current.ixCellNav = true;
      //Canviem la manera de funcionar del grid després d'afegir el botó de bloquerar/desbloquejar ordre. Aquest botó està sempre a la columna que permet sel·leccionar files a eliminar.
      //Si la propietat ve com a false, la convertim a true perquè la columna es segueixi mostrant però fem que sigui impossible marcar les files.
      if(gridOptionsOverride.enableRowHeaderSelection == false && !gridOptionsOverride.hideBlockOrderColumn){
        gridOptionsOverride.enableRowHeaderSelection = true;
        gridOptionsOverride.isRowSelectable = function(row){
          return false;
        };
      }
			var gridOptions = angular.merge({
        headerTemplate: "app/base/views/grid/ui-grid-header.html",
        rowTemplate: "app/base/views/grid/ui-grid-row.html",
        rowHeight: 40,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.ALWAYS,//D'entrada sempre es mostra l'scroll horitzontal.
        modifierKeysToMultiSelectCells: true,//permet sel·leccionar multiples cel·les deixant apretada la tecla ctrl.
        showColumnFooter: false,
				enableFiltering: true,
				showGridFooter: false,
				enableGridMenu: true,
				enableCellEdit: true,
				rowEditWaitInterval: -1, // save won't be triggered automatically (see: getDirtyRows/setRowsClean in http://ui-grid.info/docs/#/api/ui.grid.rowEdit.api:PublicApi)
				saveFilter: true,
				saveFocus: true,
				saveGroupingExpandedStates: true,
				saveSelection: true,
				saveWidths: true,
        //Edit on single click:
        enableCellEditOnFocus: true,
        exporterMenuAllData: false,
        exporterMenuVisibleData: false,

				ixIsLoading: false,
        ixContador: false,//aqui guardarem si la grid en concret utilitza o no contadors.
        ixColDefCreated: false,

        //Paths per defecte.
				ixLoadInitialDataEntity: undefined,
        ixGuardarAction: "UpdateBulk",
        ixLoadInitialDataAction: "Search",
        ixDownloadExcelAction: "Excel",

				//keyDownOverrides: [ { keyCode: 9 }, { keyCode: 13 }, { keyCode: 40 }, { keyCode: 37 }, { keyCode: 39 }],
				keyDownOverrides: [ { keyCode: 9 }, { keyCode: 13 }, { keyCode: 40 }],

        exporterFieldCallback: function (grid, row, col, value) {
          var returnString = value;
          if(col.colDef.control == "Search"){
            returnString = $filter("gridfk")(value, row, col);
          }
					else if(col.colDef.type==="date") {
            returnString = $filter("date")(value, cfg.dateFormat);
					}
          return returnString;
        },

				columnDefs: [{field: "loading...",type: "string"}],

				gridMenuCustomItems: [
					{
							icon: 'fa fa-unlock',
							title: 'Bloquear/Desbloquear orden',
							shown: function() {if(angular.isDefined(this.grid)) return this.grid.options.enableSorting; else false},
							action: function($event) { this.grid.api.ix.blockOrUnblockGridOrder() }
					},
					{
							icon: 'fa fa-lock',
							title: 'Bloquear/Desbloquear orden',
							shown: function() {if(angular.isDefined(this.grid)) return !this.grid.options.enableSorting; else false},
							action: function($event) { this.grid.api.ix.blockOrUnblockGridOrder() }
					},
          //Acció que permet copiar a clipboard tota la grid mitjançant la llibreria angular-clipboard (S'ha de baixar per bower)
          {
            icon: 'fa fa-clipboard',
            title: $translate.instant('Copiar contenido'),
            shown: function(){ return true; },
            action: function($event){
              var exportColumnHeaders = uiGridExporterService.getColumnHeaders(this.grid, uiGridExporterConstants.VISIBLE);
              //var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE);
							var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
              var gridCSV = uiGridExporterService.formatAsCsv(exportColumnHeaders, exportData, "\t");
              clipboard.copyText(gridCSV);
            },
            order: 98
          },
					{
            icon: 'fa fa-clipboard',
            title: $translate.instant('Copiar lineas seleccionadas'),
            shown: function(){ return true; },
            action: function($event){
              var exportColumnHeaders = uiGridExporterService.getColumnHeaders(this.grid, uiGridExporterConstants.VISIBLE);
							var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE);
              var gridCSV = uiGridExporterService.formatAsCsv(exportColumnHeaders, exportData, "\t");
              clipboard.copyText(gridCSV);
            },
            order: 99
          },
					{
						icon: 'fa fa-filter',
						title: $translate.instant('Activar filtros'),
						shown: function() { if(angular.isDefined(this.grid))return !this.grid.options.enableFiltering && !this.grid.options.disableFiltering;},
						action: function ($event) {
							this.grid.options.enableFiltering = true;
							this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
						},
						order: 101
					},
					{
						icon: 'fa fa-filter',
						title: $translate.instant('Desactivar filtros'),
						shown: function() { if(angular.isDefined(this.grid))return this.grid.options.enableFiltering && !this.grid.options.disableFiltering;},
						action: function ($event) {
							this.grid.options.enableFiltering = false;
							this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
						},
						order: 101
					},
					{
						title: $translate.instant('Preferencias de visualización:'),
						order: 101
					},
					{
						icon: 'fa fa-wrench',
						title: $translate.instant('Guardar configuración'),
						action: function ($event) {
              //Substitueix els filtres d'API actuals pels valors suggerits abans de guardar estat.
              var cols = this.grid.api.grid.columns;
              var auxAPIFilters = [];
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  auxAPIFilters.push(angular.copy(column.filters[0]));
                  column.filters = [];
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyOriginallySortedColumns();
              }
							var bodyValue = angular.toJson(this.grid.api.saveState.save());
              gridConfigService.saveConfig(gridName, this.grid.api.saveState.save());
              $http({
                url: cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridName,
                method: "POST",
                data: bodyValue
              }).then(function(r){
                ixStatusService.setResponse(r);
							});
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  column.filters = auxAPIFilters.splice(0,1);
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyCurrentlySortedColumns();
              }
						},
						order: 101
					},
					{
						icon: 'fa fa-wrench',
						title: $translate.instant('Guardar configuración (admin)'),
						shown: function() {
              if(angular.isDefined(this.grid)){
                var visible = false;
                angular.forEach(this.grid.options.getProfiles(), function(perfil){
                  if(perfil.toUpperCase().indexOf("IXNET") !== -1 || perfil.toUpperCase().indexOf("USERKEY") !== -1) visible = true;
                });
                return visible;
              }
            },//Nomes es mostra quan l'usuari tingui perfil ixnet o userkey.
						action: function ($event) {
              //Substitueix els filtres d'API actuals pels valors suggerits abans de guardar estat.
              var cols = this.grid.api.grid.columns;
              var auxAPIFilters = [];
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  auxAPIFilters.push(angular.copy(column.filters[0]));
                  column.filters = [];
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyOriginallySortedColumns();
              }

							var bodyValue = angular.toJson(this.grid.api.saveState.save());
              gridConfigService.saveConfig(gridName, this.grid.api.saveState.save());
							$http.post(cfg.baseURL+"fend_config/global/"+gridName, bodyValue).then(function(r){
                ixStatusService.setResponse(r);
							});
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  column.filters = auxAPIFilters.splice(0,1);
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyCurrentlySortedColumns();
              }
						},
						order: 101
					},
					{
						icon: 'fa fa-undo',
						title: $translate.instant('Deshacer cambios'),
						action: function ($event) {
							//this.grid.options.ixRestoreConfig();
              var gridInstance = this;

              $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridOptions.gridName).then(function(r){
                if(r.data) {
                  //Recupera l'estat
                  gridOptions.gridApi.saveState.restore(scope, angular.fromJson(r.data.valor));
                }
                gridInstance.grid.options.ixSaveConfig();
                gridInstance.grid.options.ixRestoreConfig();
              });
						},
						order: 102
					},
					{
						icon: 'fa fa-trash',
						title: $translate.instant('Restablecer configuración'),
						action: function ($event) {
							var that = this;

              $http.delete(cfg.baseURL+"fend_config?usuario="+authService.authentication.userName+"&clave="+gridName).then(function(){
								$http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridName).then(function(r){
									if(r.data) {
										that.grid.api.saveState.restore(scope, angular.fromJson(r.data.valor));
									} else {
										// esto está duplicado aqui porque el API debería devolver un 404 not found y no un null
										that.grid.options.columnDefs.forEach(function (c) {
											if(!c.pk) c.visible = true;
											c.width = "*";
										});
										that.grid.columns.forEach(function (c, i) {
											if (i > 0) {
												c.width = "*";
											}
										});
										that.grid.api.core.refresh();
									}
								}, function() {
									this.grid.options.columnDefs.forEach(function (c) {
										if(!c.pk) c.visible = true;
										c.width = "*";
									});
									that.grid.columns.forEach(function (c, i) {
										if (i > 0) {
											c.width = "*";
										}
									});
									that.grid.api.core.refresh();
								});
							}, function(r){
                ixStatusService.setResponse(r);
							});
						},
						order: 103
					}
				]

			}, gridOptionsOverride);


			this.createGridFunctions(scope, gridOptions);

			// Si ens passen una entity buscarem la metadada
      //TODO: Quan ens passin una entity s'hauràn de fer 2 peticions extres a API: 1. Comprobar si utilitza alguna mena de contador. 2. Comprobar si l'usuari té permis per Afegir, modificar,... etiqueta Mant_XXX...

      gridOptions.gridName = gridName;

			if(entity) {
        if(entity.length - entity.toUpperCase().lastIndexOf('VM') == 'VM'.length){
          gridOptions.skipTableName = true;
        }
				gridOptions.entity = entity;

        var storedMetadata = gridConfigService.getConfig(gridOptions.gridName+"-metadata");
        if(storedMetadata != ""){
          gridOptions.metadata = (angular.isDefined(gridOptions.metadata)) ? mergeArraysByTag(gridOptions.metadata, storedMetadata, "Name") : storedMetadata;
          gridOptions.columnDefs = [];
          //Possem les columnes extres primer:
          if(extraColumns){
            gridOptions.drawExtraColumns(extraColumns);
          }
          gridOptions.ixGetColsFromAPI();
        } else {
          $http.get(cfg.baseURL + "metadata/" + entity).then(function (r) {
            //gridOptions.metadata = r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
            gridOptions.metadata = (angular.isDefined(gridOptions.metadata)) ? mergeArraysByTag(gridOptions.metadata, r.data, "Name") : r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
            gridConfigService.saveConfig(gridOptions.gridName+"-metadata", gridOptions.metadata);
            gridOptions.columnDefs = [];
            //Possem les columnes extres primer:
            if(extraColumns){
              gridOptions.drawExtraColumns(extraColumns);
            }

            gridOptions.ixGetColsFromAPI();
          });
        }
			}

			return gridOptions;
		},

		createGridFunctions: function(scope, gridOptions) {
			gridOptions.ixGetBulkParam = function () {
				var bulkParam = {
					ToInsert: [],
					ToUpdate: [],
					ToDelete: []
				};

				if(gridOptions.gridApi){
					var dirtyRows = gridOptions.gridApi.rowEdit.getDirtyRows();
					dirtyRows.forEach(function (row) {
						if(row.entity.manuallyAdded) delete row.entity.manuallyAdded;
						if (gridOptions.insertedRows.indexOf(row.entity) >= 0) {
							delete(row.entity.isNew);
							bulkParam.ToInsert.push(row.entity);
						} else {
							bulkParam.ToUpdate.push({
								PK: gridOptions.buildPK(row.entity),
								PocoToUpdate: gridOptions.getPatchOperations(row.entity)
							});
						}
					});
					gridOptions.deletedRows.forEach(function (data) {
						bulkParam.ToDelete.push(gridOptions.buildPK(data));
					});
				}

				return bulkParam;
			};

      gridOptions.checkControlPkUnica = function(){
        var arrPkUnica = [];
        var hasControlPkUnica = gridOptions.metadata.some(function(e){ return e.EnableControlPkUnica; });
        var controlPkUnicaSuccess;
        if(hasControlPkUnica){
          var checkFields = gridOptions.metadata.filter(function(e){ return e.EnableControlPkUnica; });
          controlPkUnicaSuccess = true;
          for(var i=0; i < gridOptions.data.length; i++){
            var rowToCheck = gridOptions.data[i];
            var pkUnica = "";
            checkFields.forEach(function(checkField){
              var newCondition = "";
              if(checkField.Control == "CheckBox"){
                newCondition = (angular.isUndefined(rowToCheck[checkField.Name]) ? 0 : rowToCheck[checkField.Name])
              } else {
                newCondition = (angular.isUndefined(rowToCheck[checkField.Name]) ? null : rowToCheck[checkField.Name])
              }
              pkUnica += newCondition + "$";

            });
            if(arrPkUnica.indexOf(pkUnica) == -1){
              arrPkUnica.push(pkUnica);
            } else {
              controlPkUnicaSuccess = false;
              break;
            }
          }
        }
        if((!hasControlPkUnica) || (hasControlPkUnica && controlPkUnicaSuccess)){
          return true;
        } else {
          return false;
        }
      };

      gridOptions.ixGetNewMetaData = function(newMetadata, gridName, extraColumns, newEntity){
        gridOptions.ixColDefCreated = false;
        return $http.get(cfg.baseURL + "metadata/" + newMetadata).then(function (r) {
          gridOptions.entity = newEntity ? newEntity : newMetadata;
					gridOptions.metadata = r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
          gridOptions.gridName = gridName;
          gridOptions.columnDefs = [];
          //Possem les columnes extres primer:
          //Check if there are extraColumns.
          if(extraColumns){
            gridOptions.drawExtraColumns(extraColumns);
          }
          gridOptions.ixGetColsFromAPI();
				});
      };

      gridOptions.ixGetColsFromAPI = function(){
        var that = this;
        that.ixIsLoading = true;
          if(!that.ixColDefCreated){
            //Al final es farà una crida a SelectAndProject sempre i quan showOnlyDescribedCols tingui valor.
            that.ixColDefCreated = true;
            var columnNames = (that.showOnlyDescribedCols) ? that.showOnlyDescribedCols : [];
            that.ixCreateColDef(columnNames);
          }
      };

			gridOptions.tooltipSelector = function(){
				var tooltipMode = gridOptions.cellTooltipFunction;

				if(angular.isUndefined(cfg.gridTooltip) || cfg.gridTooltip == TOOLTIP_NOT_EMPTY_VALUES){
					gridOptions.hintDiscardEmpties = true;
				}
				else if(cfg.gridTooltip == false || cfg.gridTooltip == TOOLTIP_CLASSIC)
					tooltipMode = true;

				return tooltipMode;
			};

			gridOptions.cellTooltipFunction = function(row){
				var visibleCols = getVisibleCols();
				var tooltip = "";

				angular.forEach(visibleCols, function(col){
					var formattedValue = row.entity[col.field];
					if(angular.isUndefined(formattedValue) || formattedValue == null || formattedValue === "")
						formattedValue = "(sin valor)";
					else {
						if(col.colDef.control == "Search"){
							formattedValue = $filter("gridfk")(formattedValue, row, col);
						}
						else if(col.colDef.type==="date") {
							formattedValue = $filter("date")(formattedValue, cfg.dateFormat);
						}
					}

					if(!gridOptions.hintDiscardEmpties || formattedValue != "(sin valor)")
						tooltip += col.displayName + ": " + formattedValue + "\n";
				});

				var noVisibleCols = getNoVisibleCols();
				if(noVisibleCols.length > 0)
					tooltip += "-------------------------------\n"
				angular.forEach(noVisibleCols, function(col){
					var formattedValue = row.entity[col.field];
					if(angular.isUndefined(formattedValue) || formattedValue == null || formattedValue === "")
						formattedValue = "(sin valor)";
					else {
						if(col.colDef.control == "Search"){
							formattedValue = $filter("gridfk")(formattedValue, row, col);
						}
						else if(col.colDef.type==="date") {
							formattedValue = $filter("date")(formattedValue, cfg.dateFormat);
						}
					}
					if(!gridOptions.hintDiscardEmpties || formattedValue != "(sin valor)")
						tooltip += col.displayName + ": " + formattedValue + "\n";
				});

				return tooltip;
			};

      gridOptions.ixCreateColDef = function(columnNames) {
        var numVisibleCols = gridOptions.metadata.filter(function(e){ return !e.NoVisible; });
        numVisibleCols = (columnNames && columnNames.length > 0) ? columnNames.length : numVisibleCols.length;
				var tooltipAction = gridOptions.tooltipSelector();
        gridOptions.metadata.forEach(function (x,i,a) {
          //El controller pot passar una llista de filtres d'api en cas de que hagin de ser-ho només per una vista en concret.
          var apiFilter = (angular.isDefined(gridOptions.filtersAPI)) ? gridOptions.filtersAPI.find(function(e){ return e.field == x.Name; }) : false;
          if(columnNames.length == 0 || columnNames.indexOf(x.Name) != -1 || columnNames.indexOf("_"+x.Name) != -1){
            var columnType = convertFromServerType(x.Type);
            var colDef = {
							headerTooltip: (x.Tooltip) ? x.Tooltip : "",
              displayName: (!x.ColumnDescription) ? $translate.instant(gridUtil.readableColumnName(x.Name)) : $translate.instant(gridUtil.readableColumnName(x.ColumnDescription)),
              field: x.Name,
              type: columnType == "decimal" ? "number" : columnType,
							maxLength: x.MaxLength,
              filterHeaderTemplate: ((x.Filter || apiFilter) && gridOptions.skipAPIFilter !== true) ? '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>' : '<ix-grid-filtro></ix-grid-filtro>',
              cellTooltip: tooltipAction,
              pk: x.Pk,
              fk: x.Fk,
              noeditable: x.NoEditable,
							columnexpandable: x.ColumnExpandable,
              TableAliasName: x.TableAliasName,
              //cellClass: gridOptions.getCellClass,
              width: (gridOptions.width) ? gridOptions.width : ((numVisibleCols > 10) ? 200 : "*"),//Si passen un width per parametre s'aplica. Si no, i la grid té mes de 10 columnes s'aplica width de 200.
                                                                                                     //En qualsevol altre cas, el width es auto.
              filter: {
                condition: ixGridColumnFilterCondition($filter)
              }
			};
			if (x.cellTemplate)
				colDef.cellTemplate = x.cellTemplate;
			if (x.editableCellTemplate)
				colDef.editableCellTemplate = x.editableCellTemplate;
            if(x.SumColumn){
              gridOptions.showColumnFooter = true;
							colDef.footerCellTemplate = '<div class="ui-grid-cell-contents">Total: {{col.getAggregationValue() | number }}</div>';
              colDef.aggregationType = uiGridConstants.aggregationTypes.sum;
              colDef.NoFilterable = true;
            }
            if(convertFromServerType(x.Type)==="decimal") {
              //colDef.cellFilter = "number:'"+(x.DecimalScale || cfg.DecimalScale || "2")+"'";
              colDef.cellFilter = "customFormatNumber";
            } else if(convertFromServerType(x.Type)==="number" && !x.Search){
              colDef.cellFilter = "number:'0'";
							//colDef.cellFilter = "customFormatNumber:'0'";
            }
            if(colDef.type==="date") {
              colDef.cellFilter = "date:'"+cfg.dateFormat+"'";
              colDef.filterCellFiltered = true;
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridDateEditor.html';
            }
            if(x.Control==="CheckBox") {
							colDef.enableCellEdit = false;
              colDef.cellTemplate = gridOptions.checkboxTemplate ? gridOptions.checkboxTemplate : 'checkboxCell';
              //colDef.editableCellTemplate = 'checkboxEditCell';
              if(!x.Filter){
                colDef.filterHeaderTemplate = 'app/base/views/grid/checkBoxHeaderCell.html';
              }
              colDef.sortingAlgorithm = function(a,b){
                if(!a) a = 0;
                if(!b) b = 0;
                if (a === b) { return 0 }
                if (a < b) { return -1 }
                if (a > b) { return 1 }
              }
              colDef.control = "CheckBox";
              //colDef.enableCellEdit = false;
							if(x.beforeClick){ colDef.beforeClick = x.beforeClick }
            	if(x.afterClick){ colDef.afterClick = x.afterClick }
            }
            else if(x.Control==="List") {
							colDef.cellTemplate = "<div class=\"ui-grid-cell-contents ngCellText\" title=\"TOOLTIP\"><span ng-cell-text style=\"white-space: normal;\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>";
							if(gridOptions.pruebaFT){
								colDef.editableCellTemplate = 'listCellFT';
							} else{
								colDef.editableCellTemplate = 'listCell';
							}
            } else if(x.Control==="Progress"){
              colDef.cellTemplate = 'app/base/views/grid/ixGridProgress';
            }
            if(x.Required || x.Pk) {
              colDef.headerCellClass = "HeaderCellRequired";
							colDef.required = true;
              colDef.enableHiding = false;
            }
            if(x.Search && x.Control !== "Text") {
                if(x.Control !== "ixGridSelect" && x.Control !== "MultiBusqueda"){
									if(x.template){
										colDef.template = 'app/base/views/select/'+x.template+'2.html';
									}
									colDef.enableCellEdit = false;
									colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridSelectEditor2.html';
                }
                colDef.allFkObjects = [];
                colDef.editDropdownOptionsArray = [""];
								if(!x.ColumnFkDescription && !x.skipFirstLoad){
                  // necessitem una primera carrega de tots els valors pel filter que mostra clau-valor
									if(angular.isUndefined(x.busquedaFunction)){
										$http.get(cfg.baseURL+x.Search.LookUpTableName).then(function(r){
											colDef.allFkObjects = r.data;
											colDef.editDropdownOptionsArray = r.data;
											scope.$broadcast("gridfkUpdate");
										});
									} else {
										x.busquedaFunction(x).then(function(fields){
											colDef.allFkObjects = fields;
											colDef.editDropdownOptionsArray = fields;
											scope.$broadcast("gridfkUpdate");
										});
									}
                } else {
                  colDef.ColumnFkDescription = x.ColumnFkDescription;
                  colDef.ColumnFkDescriptionExtra = x.ColumnFkDescriptionExtra;
                  colDef.skipFirstLoad = x.skipFirstLoad;
                  colDef.setDropdownValueAfterLoad = function(colDef, isNewRow){
                    if((angular.isDefined(gridOptions.data)) && gridOptions.data.length > 0){
                      var keyFieldsToGenerate = [];
                      var fieldsToGenerate = [];
                      colDef.LookUpKeyFields.forEach(function(field){
                        if(keyFieldsToGenerate.indexOf(field) == -1){
                          keyFieldsToGenerate.push(field);
                        }
                      });
                      colDef.LookUpResultFields.forEach(function(field){
                        if(fieldsToGenerate.indexOf(field) == -1){
                          fieldsToGenerate.push(field);
                        }
                      });



                      gridOptions.data.forEach(function(row){
                        var obj = {};
                        var filteredOptions;
                        for(var i = 0; i < keyFieldsToGenerate.length; i++){
                          if(angular.isUndefined(filteredOptions)){
                            filteredOptions = colDef.allFkObjects.filter(function(e){ return e[keyFieldsToGenerate[i]] == row[colDef.KeyFields[i]]; });
                          }
                          else {
                            filteredOptions = filteredOptions.filter(function(e){ return e[keyFieldsToGenerate[i]] == row[colDef.KeyFields[i]]; });
                          }
                        }

                        if(angular.isDefined(filteredOptions) && filteredOptions.length == 0){
                          if(keyFieldsToGenerate.length > 1){
                            for(i = 0; i < keyFieldsToGenerate.length - 1; i++){
                              obj[keyFieldsToGenerate[i]] = row[colDef.KeyFields[i]];
                            }
                          }
                          for(i = 0; i < fieldsToGenerate.length; i++){
                            //if(angular.isUndefined(obj[fieldsToGenerate[i]])){
                              if(i == 0){
                                if(colDef.ColumnFkDescription){
                                  obj[fieldsToGenerate[i]] = row[colDef.ColumnFkDescription];
                                } else {
                                  obj[fieldsToGenerate[i]] = row[colDef.field];
                                }
                              } else if(i == (fieldsToGenerate.length - 1)){
																obj[fieldsToGenerate[i]] = row[colDef.field];
															} else {
																obj[fieldsToGenerate[i]] = colDef.ColumnFkDescriptionExtra ? row[colDef.ColumnFkDescriptionExtra] : row[fieldsToGenerate[i]];
															}
															/* else if((i > 1 && keyFieldsToGenerate.indexOf(fieldsToGenerate[i]) == -1) || (i == 1) ){
                                obj[fieldsToGenerate[i]] = row[colDef.field];
                              }*/
                            //}
                          }
                          if(colDef.allFkObjects.indexOf(obj) == -1 && isNewRow){


														//Comprovar que té clau / valor definits i amb valor, si no farem el Get corresponent.
														var hasKeyValue = true;
														var hasValue = true;
														angular.forEach(colDef.LookUpResultFields, function(lookUpResultField, idx){
															hasKeyValue = (hasKeyValue && angular.isDefined(obj[lookUpResultField]));
															if(idx == colDef.LookUpResultFields.length - 1)
																//hasValue = angular.isDefined(obj[lookUpResultField]);
																hasValue = (angular.isDefined(obj[lookUpResultField]) && obj[lookUpResultField] != null);
														});

														if(hasKeyValue){
															colDef.allFkObjects.push(obj);
														} else if(hasValue) {
															var getParams = "";
															angular.forEach(colDef.LookUpKeyFields, function(lookupkeyField){
																getParams += obj[lookupkeyField] + "/";
															});
															$http.get(cfg.baseURL + colDef.LookUpTableName + "/" + getParams).then(function(response){
																delete response.data.ContextID;
																colDef.allFkObjects.push(response.data);
																scope.$broadcast("gridfkUpdate");
															}, function(err){
																ixStatusService.setResponse(err);
															});
														}
                          } else {
														colDef.allFkObjects.push(obj);
													}
                        }
                      });
                    }
                    if((colDef.editDropdownOptionsArray.length == 0) || ((colDef.editDropdownOptionsArray.length == 1) && colDef.editDropdownOptionsArray[0] == "") )
                      colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
                  };
                }

                colDef.editDropdownOptionsArray = [""];

                colDef.onSelectDropdown = function($item, $model) {
                  if($model == "(sin valor)" && colDef.LookUpResultFields.length == 1 && Object.keys($item).indexOf(colDef.LookUpResultFields[0]) !== -1)
                    gridOptions.gridApi.clickedRowObj.entity[colDef.LookUpResultFields[0]] = undefined;

									var isnewrow = gridOptions.gridApi.clickedRowObj.entity.isNew;
                  if(angular.isDefined(colDef.copySelectedValues) && ($item.specialFlag != -1)){
										var propsToCopy = [];

										if(angular.isFunction(colDef.copySelectedValues)){
											propsToCopy = colDef.copySelectedValues($item);
										} else {
											propsToCopy = colDef.copySelectedValues;
										}
                    angular.forEach(propsToCopy, function(value){
                      if(angular.isObject(value)){
                        if(Object.keys(value).length == 1){
                          angular.forEach(value, function(val, key){
                            gridOptions.gridApi.clickedRowObj.entity[val] = $item[key];
														gridOptions.addToModifiedValues(val);
                            //Agafem automaticament camps que es diguin igual pero acabant en nombre.
                            if(angular.isDefined($item[key+"nombre"])){
                              gridOptions.gridApi.clickedRowObj.entity[val+"nombre"] = $item[key+"nombre"];
                            }

                            var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
                            angular.forEach(columnFKDescs, function(columnFKDesc){
                              columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, isnewrow);
                            });

                          });
                        } else {
                          angular.forEach(value.condition, function(val, key){
                            if(gridOptions.gridApi.clickedRowObj.entity[val] == $item[key]){
                              gridOptions.gridApi.clickedRowObj.entity[value.gridField] = $item[value.dropdownField];
															gridOptions.addToModifiedValues(value.gridField);
                              //Agafem automaticament camps que es diguin igual pero acabant en nombre.
                              if(angular.isDefined($item[value.dropdownField+"nombre"])){
                                gridOptions.gridApi.clickedRowObj.entity[value.dropdownField+"nombre"] = $item[value.dropdownField+"nombre"];
                              }
                            } else {
                              gridOptions.gridApi.clickedRowObj.entity[value.gridField] = null;
                            }
                          });
                        }
                      } else {
                        gridOptions.gridApi.clickedRowObj.entity[value] = $item[value];
												gridOptions.addToModifiedValues(value);
                        if(angular.isDefined($item[value+"nombre"])){
                          gridOptions.gridApi.clickedRowObj.entity[value+"nombre"] = $item[value+"nombre"];
                        }
                      }
                    });
                    //Si s'han d'arrossegar valors, s'executa funció per que els valors de dropdown s'omplin per si ve algun registre que no hi és.
                    var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

                    angular.forEach(columnFKDescs, function(columnFKDesc){
                      columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, isnewrow);
                    });
                  }

									if(colDef.LookUpResultFields.length == 1)
										colDef.setDropdownValueAfterLoad(colDef, isnewrow);

                  //Els dropdowns depenents es buiden si el $model es undefined i si no ho és es recarreguen.
                  var fieldName = colDef.field;
                  var dependantFields = gridOptions.metadata.filter(function(e){
                    if(e.Search){
                      var idx = e.Search.KeyFields.indexOf(fieldName);
                      return idx != -1 && idx < (e.Search.KeyFields.length - 1);
                    }
                  });

                  if($model == undefined){
                    angular.forEach(dependantFields, function(dependantField){
                      gridOptions.gridApi.clickedRowObj.entity[dependantField.Name] = undefined;
                    });
                  } else {
                    angular.forEach(dependantFields, function(dependantField){
                      //var depCol = gridOptions.gridApi.grid.columns.find(function(c){ return c.field == dependantField.Name});
                      var depCol = gridOptions.columnDefs.find(function(c){ return c.field == dependantField.Name; });
                      if(angular.isDefined(depCol)){
												if(angular.isDefined(depCol.refreshDropdown)){
													depCol.refreshDropdown({ search: '' }, gridOptions.gridApi.clickedRowObj, undefined, undefined, true);
												}
                      }
                    });
                  }

                  // function to close cellEditor when selecting a value
									//Disabled angular-virtual-select
                  //gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
                };

                colDef.onOpenCloseDropdown = function(isOpen) {
                  // function to close cellEditor when closing dropdown
                  gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
                  if(!isOpen) {
                    gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                  }
                };

								var getEditableDropdown = function(){
									var result = colDef.EditableDropdown;
									if(angular.isFunction(colDef.EditableDropdown))
										result = colDef.EditableDropdown(gridOptions.gridApi.clickedRowObj.entity);
									return result;
								};

                colDef.refreshDropdown = function($select, row, paramsGeneratedInVirtualSelect, cancellerDropdown, isDependanField) {

                  if(x.minLengthToLoad){
                    colDef.editDropdownOptionsArray = [];
                  }
									var text = $select.search != "" ? $select.search : row.entity[colDef.field];
                  //Si es de tipus EditableDropdown, se li permet afegir nous registres. (nomes funcionarà per a selects de clau simple)
                  if(getEditableDropdown()){
                    var list = angular.copy(colDef.editDropdownOptionsArray);
                    var FLAG = -1;

                    if(text){
                      var userInputItem = {
                        specialFlag: FLAG
                      };
                      angular.forEach(x.Search.LookUpKeyFields, function(lookupkeyField, idx){
												if(x.Search.LookUpKeyFields.length-1 == idx)
												{
													userInputItem[lookupkeyField] = text;
												} else {
													userInputItem[lookupkeyField] = row.entity[x.Search.KeyFields[idx]];
												}
											});
                      userInputItem[x.Search.KeyFields[x.Search.KeyFields.length-1]] = text;
                      $select.selected = userInputItem;
                      colDef.editDropdownOptionsArray = [userInputItem].concat(list);
                      colDef.allFkObjects.push(userInputItem);
                    }
                  }

                  colDef.lastSearch = text;

                  if(angular.isDefined(x.busquedaFunction)){

										//var defer = $q.defer();

										if(angular.isDefined(cancellerBusquedaFunction)){
											cancellerBusquedaFunction.resolve();
										}

										cancellerBusquedaFunction = $q.defer();

										var param = paramsGeneratedInVirtualSelect || buildDropdownFilters(x, text, row);
										if(paramsGeneratedInVirtualSelect)
											buildDropdownExtraFilters(param, x, text, row);

                    //colDef.editDropdownOptionsArray.splice(1);
                    x.busquedaFunction(x, param, text, row, { timeout: cancellerBusquedaFunction.promise }).then(function(fields){
                      //Tenim dues opcins: Sobreescriure les opcions que s'han carregat previament mitjançant el GET inicial o bé afegir els resultats retornats a les opcions carregades previament.
                      if(((angular.isDefined(x.overridePreloadedOptions)) && x.overridePreloadedOptions == true) || (colDef.allFkObjects.length == 0)){
                        colDef.allFkObjects = fields;
                        colDef.editDropdownOptionsArray = fields;
                      } else {
                        //Si hay alguna lista definida entonces aplicamos esa lista, sino la cargamos de la API.
                        var arrayToAdd = [];
                        angular.forEach(fields, function(field){
                            var itemInList = colDef.allFkObjects.find(function(e){ return e[x.Search.LookUpKeyFields[0]] == field[x.Search.LookUpKeyFields[0]] });
                            if(!itemInList)
                            arrayToAdd.push(field);
                        });
                        colDef.allFkObjects = colDef.allFkObjects.concat(arrayToAdd);
                        colDef.editDropdownOptionsArray = colDef.editDropdownOptionsArray.concat(arrayToAdd);
                      }
											cancellerBusquedaFunction.resolve({ data: fields });
                    });

										return cancellerBusquedaFunction.promise;
                  }
                  //Fa un Get a un path diferent passant parametres per url.
                  //Es un cas especial que podria utilitzar-se més cops.
                  else if(x.lookUpExtraParam || x.lookUpExtraParam == ""){
                    var lookUpExtraParam = "";
                    if(x.rowAttr && x.rowAttr != ""){
                      lookUpExtraParam = "/" + row.entity[x.rowAttr];
                    } else if(scope.data.datos){
                      lookUpExtraParam = "/" + scope.data.datos[scope.data.pk];
                    }
										if(lookUpExtraParam != "") lookUpExtraParam = "/" + lookUpExtraParam;
										if(angular.isDefined(canceller)){
											canceller.resolve();
										}
										canceller = $q.defer();
										var requestPromiseEspecial = $http({
											url: cfg.baseURL+ x.Search.LookUpTableName + ((x.lookUpExtraParam != "") ? "/" + x.lookUpExtraParam : x.lookUpExtraParam) + lookUpExtraParam,
											timeout: canceller.promise,
											method: "GET"
										});

										return requestPromiseEspecial.success(function(resultData){
                      if($select.selected && $select.selected.specialFlag == -1){
												resultData.push($select.selected);
											}
											return {data: resultData };
                    });
                  } else {
                    if((!x.SinPaginar) && !x.minLengthToLoad || (x.minLengthToLoad && text.length >= x.minLengthToLoad) && row) {

											param = paramsGeneratedInVirtualSelect || buildDropdownFilters(x, text, row);
											if(paramsGeneratedInVirtualSelect)
												buildDropdownExtraFilters(param, x, text, row);
                      var controllerMethod = "/Search";
                      if(x.CustomMethod == true){
                        controllerMethod = "";
                      } else if(x.CustomMethod){
                        controllerMethod = "/" + x.CustomMethod;
                      }
                      var requestPromise = $http({
                        url: cfg.baseURL+x.Search.LookUpTableName+controllerMethod+"?ItemsPerPage=99",
                        data: param,
                        //timeout: canceller.promise,
												//timeout: cancellerDropdown ? cancellerDropdown.promise : canceller.promise,
												timeout: cancellerDropdown ? cancellerDropdown.promise : undefined,
                        method: "POST"
                      });

                      return requestPromise.success(function(data){
                        $log.log("Refresh data in dropdown", data);

												data.Items.forEach(function(result, resultIndex){
													if(result.ContextID)
														delete result.ContextID;

													// actualitzar valor selected
													var isSelected = true;
													x.Search.KeyFields.forEach(function(keyField,idx){
														if((angular.isDefined(result)) && row.entity[keyField]!==result[x.Search.LookUpKeyFields[idx]]) {
															isSelected = false;
														}
													});
													if(isSelected) {
														$select.selected = result;
														$select.activeIndex = resultIndex + (x.Required || (text != "" && "sin valor".indexOf(text) == -1) ? 0 : 1);
													}
													// Afegir resultats nous a allFkObjects perquè el fitre gridfk els mostri bé
													var found = colDef.allFkObjects.some(function(e) {
														return angular.equals(e,result);
													});

													if(!found){
														colDef.allFkObjects.push(result);
													}
												});


                        colDef.editDropdownOptionsArray = data.Items;
												if(angular.isDefined($select.selected)){
													if(angular.isDefined($select.selected.specialFlag) && $select.selected.specialFlag == -1){
														colDef.editDropdownOptionsArray.push($select.selected);
													}

												}

												if(colDef.editDropdownOptionsArray.length == 0 && isDependanField) {
													//vaciamos valor selected
													row.entity[colDef.field] = null;
													gridOptions.ixCheckErrors();
												}

                        if(angular.isDefined(x.ZeroOption)){
                          colDef.editDropdownOptionsArray.unshift(x.ZeroOption);
                        }

												return data;
                      });

                    } else if(!x.minLengthToLoad) {
                      colDef.editDropdownOptionsArray = $filter("orderBy")(colDef.allFkObjects, x.Search.LookUpResultFields[0]);
                      colDef.editDropdownOptionsArray.forEach(function(result, resultIndex){
                        // actualitzar valor selected
                        var isSelected = true;
                        x.Search.KeyFields.forEach(function(keyField,idx){
                          if((angular.isDefined(result)) && row.entity[keyField]!==result[x.Search.LookUpKeyFields[idx]]) {
                            isSelected = false;
                          }
                        });
                        if(isSelected) {
                          $select.selected = result;
                          //$select.activeIndex = resultIndex + (x.Required || (text != "" && "sin valor".indexOf(text) == -1) ? 0 : 1);
                          //Si hi ha algun problema es miraria de possar la de dalt modificada.
                          $select.activeIndex = resultIndex;
                        }
                      });
											$log.log("refreshing dropdown with text", text, row);
											var defer = $q.defer();
											if($select.search){
												var returnedElements = colDef.editDropdownOptionsArray.filter(function(e){
													var match = false;
													angular.forEach(x.Search.LookUpResultFields, function(resultField){
														if(ixUtilsService.comparar(e[resultField],$select.search) != -1)
															match = true;
													});
													return match;
												});
												defer.resolve({ data: returnedElements });
											} else {
												defer.resolve({ data: angular.copy(colDef.editDropdownOptionsArray) });
											}
											return defer.promise;
                    }
                  }
                };

                if(x.minLengthToLoad){ colDef.minLengthToLoad = x.minLengthToLoad; }
                if(x.copySelectedValues){ colDef.copySelectedValues = x.copySelectedValues; }
              //}
              colDef.LookUpKeyFields = x.Search.LookUpKeyFields;
              colDef.KeyFields = x.Search.KeyFields;
              colDef.LookUpResultFields = x.Search.LookUpResultFields;
              colDef.LookUpTableName = x.Search.LookUpTableName;
              colDef.LookUpTableAlias = x.Search.LookUpTableAlias;
              colDef.LookUpConditions = x.Search.LookUpConditions;
							colDef.LookUpOrders = x.Search.LookUpOrders;
							colDef.EditableDropdown = x.EditableDropdown;
							colDef.skipTableNameFilter = (x.skipTableName || scope.skipTableName || gridOptions.skipTableName);
							colDef.skipTableNameOrderBy = x.skipTableNameForDropdown;
							if(angular.isDefined(x.EditableDropdownPriority)){ colDef.EditableDropdownPriority = x.EditableDropdownPriority; }

              colDef.control = "Search";
            }
            if(x.Control === "MultiBusqueda"){
              colDef.cellFilter = "";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridMultipleSelectEditor.html';
              colDef.control = "MultiBusqueda";
            }

            if(x.Control === "ixSiNo"){
              colDef.cellTemplate = "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\" tabindex=\"0\">{{COL_FIELD CUSTOM_FILTERS}}<span class=\"glyphicon glyphicon-chevron-down\"></span></div>";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridSiNoEditor.html';
              colDef.control = "ixSiNo";
              colDef.LookUpKeyFields = ["pk"];
              colDef.KeyFields = [colDef.field];
              colDef.LookUpResultFields = ["desc","pk"];

							var ixSiNoOptions = [];
              if(!colDef.required)
                ixSiNoOptions.push({ pk: null, desc: "(sin valor)" });

							//Es poden definir les opcions que tindrà el dropdown a través d'un array d'objectes.
							//En aquest punt només les aplicarà si customIxSiNoOptions no es una funció.
              if(angular.isDefined(x.customIxSiNoOptions) && !angular.isFunction(x.customIxSiNoOptions)){
                ixSiNoOptions.push.apply(ixSiNoOptions, x.customIxSiNoOptions);
              } else {
                ixSiNoOptions.push({ pk: 0, desc: "No" });
                ixSiNoOptions.push({ pk: 1, desc: "Si" });

                if(angular.isDefined(x.extraIxSiNoOptions) && x.extraIxSiNoOptions.length > 0)
                  ixSiNoOptions.push.apply(ixSiNoOptions, x.extraIxSiNoOptions);
              }

              colDef.allFkObjects = ixSiNoOptions;

              colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
              colDef.enableCellEditOnFocus = false;
              colDef.cellFilter = "gridfk:row:col";

              colDef.onSelectDropdown = function($item, $model) {
                // function to close cellEditor when selecting a value
                gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
              };

              colDef.onOpenCloseDropdown = function(isOpen) {
                // function to close cellEditor when closing dropdown
                gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
                if(!isOpen) {
                  gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                } else {
									//en cas de que customIxSiNoOptions sigui una funció es carregaràn els items al obrir.
                  if(angular.isDefined(x.customIxSiNoOptions) && angular.isFunction(x.customIxSiNoOptions)){
                    x.customIxSiNoOptions(gridOptions.gridApi.clickedRowObj.entity).then(function(result){
                      colDef.allFkObjects = result.data;
                      colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
                    });

                  }
                }
              };
            }

            if(x.InPopup){
              colDef.cellTemplate = 'iconCell';
              //colDef.enableFiltering = false;
              colDef.NoFilterable = true;
              colDef.enableCellEdit = false;//La columna no és editable, prevenim que el valor es pugui modificar al fer doble click.
            }
            //La directiva ix-search-from-grid passa els camps que el frontend li digui que son filtres d'api com a filtersAPI a les opcions de grid.
            //var apiFilter = (angular.isDefined(gridOptions.filtersAPI)) ? gridOptions.filtersAPI.find(function(e){ return e.field == x.Name; }) : false;
            if((x.Filter || apiFilter) && gridOptions.skipAPIFilter !== true){
              colDef.filteropt = (apiFilter) ? apiFilter.type : x.Filter;
              if(colDef.filteropt == "Fecha"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                //Aplicar filtre per defecte de dates: (mes actual)
                var filterAPIUnit = angular.isUndefined(scope.filterAPIBy) ? cfg.filterAPIUnit : scope.filterAPIBy;
                var filterAPIPeriod = angular.isUndefined(scope.period) ? cfg.filterAPIPeriod : scope.period;
                colDef.filters = setDefaultFilter(colDef.filteropt, filterAPIUnit, filterAPIPeriod, (scope.filtroAPISinFecha || x.NoFiltered));
                gridOptions.enableFiltering = true;
              } else if(colDef.filteropt == "CheckBox"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                colDef.filter.term = setDefaultFilter(colDef.filteropt, x.APICheckDefValue);
              } else if(colDef.filteropt == "Texto"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                var filterAPIValue = angular.isUndefined(gridOptions.APIStringDefValue) ? x.APIStringDefValue : gridOptions.APIStringDefValue;
                colDef.filters = setDefaultFilter(colDef.filteropt, filterAPIValue);
                //TODO: La llista de possibles valors haurà de venir de la API o definir-la al controller del frontend.
                if(angular.isDefined(x.filterOptionsFunction)){
                  x.filterOptionsFunction().then(function(data){
                    colDef.listValues = data;
                  });
                } else if(angular.isDefined(x.filterOptions)){
                  colDef.listValues = x.filterOptions;
                } else if(angular.isDefined(x.ColumnFkDescription) && x.ColumnFkDescription){
                  //Encara que vingui amb el ColumnFkDescription, farem un GetAll ja que la intenció del filtre d'API és aquesta:
                  $http.get(cfg.baseURL+x.Search.LookUpTableName).then(function(r){
				          //WebWorkerService.get(cfg.baseURL+x.Search.LookUpTableName).then(function(r){
                    colDef.listValues = parseObjectsToString(r.data, colDef.LookUpResultFields);
                  });
                } else {
                  colDef.listValues = [ "Autorizada", "NO Autorizada", "PDT Autorizacion" ];
                }
              }
            }

            if(x.Control === "Color"){
              colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridColor';
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridColorEditor.html';
              colDef.colors = getColors();
							colDef.hideDesc = x.hideDesc;
							colDef.enableCellEditOnFocus = false;

              colDef.onSelectDropdown = function($item, $model) {
                if(angular.isDefined(colDef.copySelectedValues)){
                  angular.forEach(colDef.copySelectedValues, function(value){
                    if(angular.isObject(value)){
                      angular.forEach(value, function(val, key){
                        gridOptions.gridApi.clickedRowObj.entity[val] = $item[key];
                      });
                    } else {
                      gridOptions.gridApi.clickedRowObj.entity[value] = $item[value];
                    }
                  });
                }
								// function to close cellEditor when selecting a value
                gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
							};

							colDef.onOpenCloseDropdown = function(isOpen) {
								// function to close cellEditor when closing dropdown
                gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
								if(!isOpen) {
                  gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
								}
							};
            }

            if(x.Control === "ixGridSelect"){
              colDef.cellFilter = "";
              colDef.control = "ixGridSelect";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixSelectFromGrid.html';
            }

            if(x.Control=== "ixTime"){
              colDef.control = "ixTime";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridTimeEditor.html';
            }

            if(x.NoFilterable){
              colDef.NoFilterable = true;
            }

            if(x.Sort){
              colDef.sort = x.Sort;
            }

            if(x.VirtualVMField/* || x.DisableSorting*/){
              colDef.VirtualVMField = true;
            }

            colDef.menuItems = [
							{
								icon: 'ui-grid-icon-filter',
								title: 'Activar filtros',
								//shown: function() { return !this.grid.options.enableFiltering;},
								shown: function() { if(angular.isDefined(this.grid))return !this.grid.options.enableFiltering && !this.grid.options.disableFiltering;},
								action: function ($event) {
									this.grid.options.enableFiltering = true;
									this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
								}
							},
							{
								icon: 'ui-grid-icon-angle-down',
								title: 'Expandir',
								shown: function() { return colDef.columnexpandable && (this.grid.api.cellNav.getFocusedCell().col.field == this.context.col.field);},
								action: function ($event) {
									var field = this.context.col.field;
									var grid = this.grid;
									var currentcell =  this.grid.api.cellNav.getFocusedCell();
									var visiblerows = this.grid.api.core.getVisibleRows();
									var currentrowindex = visiblerows.indexOf(currentcell.row);

									for(currentrowindex; currentrowindex < visiblerows.length; currentrowindex++)
									{
										var row = visiblerows[currentrowindex];
										if(!grid.api.ix.disableField({ col: currentcell.col, row: row }))
										{
											row.entity[field] = currentcell.row.entity[field];
											//sino s'omple modifiedValues no fa el update
											if (!row.entity.modifiedValues) {
												row.entity.modifiedValues = [];

											}
											if(row.entity.modifiedValues.indexOf(field)===-1) {
												row.entity.modifiedValues.push(field);
											}
											grid.api.rowEdit.setRowsDirty([row.entity]);
										}
									}
									grid.api.grid.options.ixCheckErrors();
								}
							},
							{
								//icon: 'ui-grid-icon-menu',
								icon: 'fa fa-clipboard',
								title: 'Copiar valores',
								shown: function() { return true;},
								action: function ($event) {
									var grid = this.grid;
									var gridCol = this.context.col;
									var columnToCopy = gridCol.field;

									var exportData = [];
									angular.forEach(this.grid.api.core.getVisibleRows(), function(row) {
										//exportData.push(row.entity[columnToCopy]);
										var cellValue = grid.getCellValue(row, gridCol);
										var extractedField = grid.options.exporterFieldCallback(grid,row,gridCol,cellValue);
										if(extractedField)
											exportData.push(extractedField);
									});
									var gridCSV = exportData.join("\n");
									clipboard.copyText(gridCSV);
								}
							}
						];

            if(angular.isUndefined(colDef.editableCellTemplate) && angular.isDefined(x.MaxLength) && x.MaxLength !== 0){
              if(colDef.type === "string"){
                //Si es un camp de text i no se li ha aplicat encara cap html d'edició especial li possem el nostre per limitar la longitud dels camps.
                colDef.editableCellTemplate = "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\" maxlength='"+x.MaxLength+"'></form></div>";
              } else if(colDef.type === "number"){
								//colDef.editableCellTemplate = "<div><form name=\"inputForm\"><input type='text' ng-model=\"MODEL_COL_FIELD\" ng-class=\"'colt' + col.uid\" ui-grid-editor maxlength='"+x.MaxLength+"' ix-number comma-separator='true' ";
								colDef.editableCellTemplate = "<div><form name=\"inputForm\"><input type='text' ng-model=\"MODEL_COL_FIELD\" ng-class=\"'colt' + col.uid\" ui-grid-editor maxlength='"+x.MaxLength+"' ix-number ";
								if (x.CommaSeparator) colDef.editableCellTemplate += " comma-separator='true' ";

                if(angular.isDefined(x.MinValue) && x.MinValue != null){
                  colDef.editableCellTemplate += " min='"+x.MinValue+"' min-value='"+x.MinValue+"'";
                }

                if(angular.isDefined(x.MaxValue) && x.MaxValue != null){
                  colDef.editableCellTemplate += " max='"+x.MaxValue+"' max-value='"+x.MaxValue+"'";
                }

                if(convertFromServerType(x.Type) == "decimal"){
                  colDef.editableCellTemplate += " with-decimals='2'";
                }

                colDef.editableCellTemplate += "></form></div>";
              }
            }
            //En cas de que es pugui tenir més d'un template, podriem permetre rebre per param el nom del template i aplicar-lo directament per nom.
            if(x.sortableCellTemplate == true){
              colDef.cellTemplate = 'app/base/views/grid/uiGridSortableCell';
            }

            if(!x.NoVisible){
              colDef.cellClass = gridOptions.getCellClass(colDef);
              gridOptions.columnDefs.push(colDef);
            } else if(x.NoVisible && (x.Pk || x.Fk)){
              colDef.visible = false;
              gridOptions.columnDefs.push(colDef);
            }
          }
        });
        var virtualOrderColumn = {
          field: "virtualOrderColumn",
          type: "number",
          visible: false,
          VirtualVMField: true,
          enableHiding: false
        };
        //
        gridOptions.columnDefs.push(virtualOrderColumn);

				if(gridOptions.gridName)
					gridOptions.loadConfig();
				else {
					gridOptions.ixIsLoading = false;
					if(!scope.gridManualLoad){
						gridOptions.ixLoadInitialData();
					}
					scope.$emit('gridConfigLoaded');
				}

        gridOptions.metadataLoaded = true;
        scope.$emit('metadataLoaded');
        var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

        angular.forEach(columnFKDescs, function(columnFKDesc){
          columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
        });
      };

			gridOptions.ixGuardar = function (emptyTable, queryString) {
        var bulkParam  = gridOptions.ixGetBulkParam();
        if(angular.isUndefined(queryString)) queryString = "";
        var warnings = "";
        if((warnings = ixStatusService.sendWarnings()) != ""){
          if(queryString != "") queryString += "&";
          else queryString += "?";
          queryString += warnings;
        }

        return $http.patch(cfg.baseURL + gridOptions.entity + '/' + gridOptions.ixGuardarAction + queryString, bulkParam).then(function (response) {
              if (response.data.Result) {
                //Comprovar si hi ha alguna acció que s'ha guardat pel final.
                if(angular.isDefined(gridOptions.delayedActions)){
                    gridOptions.delayedActions.forEach(function (delayedAction){
                        var url = delayedAction.url;
                        delete(delayedAction.url);
                        $http.post(url, delayedAction).then(function(r){
                            ixStatusService.setResponse(r);
                        });
                    });
                    delete(gridOptions.delayedActions);
                }
                ixStatusService.setResponse(response);
                gridOptions.clearGridAfterSave(emptyTable);
              } else {
                ixStatusService.setResponse(response);
              }
							return response;
            }, function (response) {
              gridOptions.insertedRows.forEach(function(e){e.isNew=true;});
              //Probar les dues lineas seguents.
              gridOptions.deletedRows.forEach(function(e){ if(gridOptions.data.indexOf(e) == -1) gridOptions.data.push(e);});
              gridOptions.deletedRows = [];
              ixStatusService.setResponse(response, scope);
            });
          };

      gridOptions.clearGridAfterSave = function(emptyTable){

        gridOptions.deletedRows = [];
        gridOptions.insertedRows = [];

				gridOptions.clearFocus();

        var dataRows = gridOptions.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
        gridOptions.gridApi.rowEdit.setRowsClean( dataRows );

        //gridOptions.bloqueo = null;
        ixStatusService.setEditing(false);

        if(!gridOptions.keepSortingEditing){
          // Rehabilitar ordenacion al finalizar la edición
          gridOptions.enableSorting = true;
        }
        if(angular.isDefined(gridOptions.originalGridOrder)){
          gridOptions.applyOriginallySortedColumns();
          //ixTODO: Valorar si fa falta tornar a bloquejar sempre i quan ho estigui.
        }
        //gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
        gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

        if(!emptyTable){
          gridOptions.ixLoadInitialData();
        } else {
          gridOptions.data = [];
        }
      };
      gridOptions.ixCancelEdit = function (emptyTable, force) {
				if(gridOptions.gridApi){
					// TODO: eliminar bloqueig al server
					var doit = true;
					if(gridOptions.deletedRows.length+gridOptions.insertedRows.length+gridOptions.gridApi.rowEdit.getDirtyRows().length>0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if(doit || force) {
						gridOptions.clearFocus();
						delete(ixStatusService.current.response);
						gridOptions.deletedRows = [];
						gridOptions.insertedRows = [];
						gridOptions.gridStatus = {$invalid:false, $error:{}};

						var dataRows = gridOptions.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
						gridOptions.gridApi.rowEdit.setRowsClean( dataRows );

						if(gridOptions.gridApi.dragndrop){
							gridOptions.gridApi.dragndrop.setDragDisabled(true);
						}

						if(!emptyTable){
							gridOptions.ixLoadInitialData().then(function(){
								//that.bloqueo = null;
								ixStatusService.setEditing(false);
							});
						} else {
							gridOptions.data = [];
						}

						if(!gridOptions.keepSortingEditing){
							// Rehabilitar ordenacion al finalizar la edición
							gridOptions.enableSorting = true;
						}
						if(angular.isDefined(gridOptions.originalGridOrder)){
							gridOptions.applyOriginallySortedColumns();
							//ixTODO: Valorar si fa falta tornar a bloquejar sempre i quan ho estigui.
						}
						gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

					}
				}

			};

			gridOptions.ixAddRow = function(entityProps){
        var newEntity = entityProps || {};
        newEntity.isNew = true;

        if(!gridOptions.ignorePredefinedValuesOnCreate){
          // Preasignamos valores de filtroExterno a la nueva entidad
          angular.forEach(gridOptions.filtroExterno, function(value,filter) {
            if(angular.isObject(value)){
              //comprovem si és una data per formatejar-la al format que tenim definit al config.json
              var ptrn = /(\d{4})\-(\d{2})\-(\d{2})/;
              if((typeof value.Value == "string") && value.Value.match(ptrn)){
                //value.Value = new Date(value.Value);
                //value.Value = $filter("date")(new Date(value.Value), cfg.dateTimeFormat, null);
                var parts = value.Value.split("-");
                value.Value = ixNewDate(cfg, moment, parts[2], parseInt(parts[1])-1, parts[0]);
                value.Value.setHours(0, 0, 0, 0);//hours,minutes,seconds,milliseconds
              }
              if(value.Field.lastIndexOf(".") !== -1){
                newEntity[value.Field.substr(value.Field.lastIndexOf(".")+1)] = value.Value;
              } else {
                newEntity[value.Field] = value.Value;
              }
            } else {
              //
              newEntity[filter] = value;
            }
          });
        }
				if(gridOptions.arrastrarValoresAddRow && gridOptions.gridApi.core.getVisibleRows().length > 0 && gridOptions.gridApi.cellNav.getFocusedCell())
				{
					var row = gridOptions.gridApi.cellNav.getFocusedCell().row;
					angular.forEach(gridOptions.arrastrarValoresAddRow, function(field) {
						if(!newEntity[field])
							newEntity[field] = row.entity[field];
					});
				}
				gridOptions.data.push(newEntity);
				gridOptions.insertedRows.push(newEntity);
				if((angular.isDefined(gridOptions.columnDefs)) && gridOptions.columnDefs.length > 0){
					var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
					angular.forEach(columnFKDescs, function(columnFKDesc){
						columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, true);
					});
				}
				gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
				if(!newEntity.manuallyAdded && !gridOptions.loadItemWhenSelect && !gridOptions.keepFocusOnAddRow){
          gridOptions.gridApi.ix.goToBottom();
        }
			};

			gridOptions.ixSelectRow = function(row){
				gridOptions.gridApi.selection.selectRow(row);
			};
      gridOptions.ixDeleteSelectedRows = function(){
				var focusedCell = gridOptions.gridApi.cellNav.getFocusedCell();
				if(focusedCell){
					if(gridOptions.gridApi.selection.getSelectedRows().indexOf(focusedCell.row.entity) != -1){
						gridOptions.clearFocus();
					}
				}
        gridOptions.gridApi.rowEdit.setRowsClean( gridOptions.gridApi.selection.getSelectedRows() );
        gridOptions.gridApi.selection.getSelectedRows().reverse().forEach(function (item) {
          gridOptions.data.splice(gridOptions.data.indexOf(item), 1);
          var insertedIdx = gridOptions.insertedRows.indexOf(item);
          if(insertedIdx===-1) {
            gridOptions.deletedRows.push(item);
          } else {
            gridOptions.insertedRows.splice(insertedIdx,1);
          }
          $timeout(function(){
            gridOptions.ixCheckErrors();
          });
        });
      };

      gridOptions.ixDownloadExcel = function(){

        var config = {responseType:"arraybuffer"};
        var param = gridOptions.buildIxProjectionParam();

        $http.post(cfg.baseURL + gridOptions.entity + '/' + gridOptions.ixDownloadExcelAction, param, config).then(function(r){
          var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

					var filename = gridOptions.entity + ".xlsx";
					if(r.headers('Content-Disposition')) {
						filename = r.headers('Content-Disposition').split("=")[1];
					}
					saveAs(file, filename);
        });
      };

      gridOptions.ixProgramar = function(){
        var modalInstance = $uibModal.open({
          templateUrl: 'app/base/views/listados_programados_popup.html',
          controller: 'ListadosProgramadosController',
          //scope: scope,
          size: 'medium',
          backdrop: 'static',
          keyboard: false
        });

        modalInstance.result.then(function(datosListadoProgramado){
          if(angular.isDefined(datosListadoProgramado)){
            var paramProgramar = {};
            paramProgramar.Param = gridOptions.buildIxProjectionParam();
            paramProgramar.Mailto = angular.isDefined(datosListadoProgramado.mailto) ? angular.copy(datosListadoProgramado.mailto) : [];
            paramProgramar.Mailcco = angular.isDefined(datosListadoProgramado.mailcc) ? angular.copy(datosListadoProgramado.mailcc) : [];

            delete datosListadoProgramado.mailto;
            delete datosListadoProgramado.mailcc;

            paramProgramar.Listado = datosListadoProgramado;
            paramProgramar.Listado.client_id = cfg.clientId;

            $http.post(cfg.baseURL + gridOptions.entity + "/Programar", paramProgramar).then(function(response){
              ixStatusService.setResponse(response);
            }, function(err){
              ixStatusService.setResponse(err);
            })
          }
        });
      };

      gridOptions.addIncidencia = function () {

        gridOptions.incidencias = gridOptions.incidencias || [];
        var newIncidencia = {};
        newIncidencia.time = new Date();
        newIncidencia.user = authService.authentication.userName;
        newIncidencia.text = gridOptions.newIncidencia.text;
        gridOptions.incidencias.push(newIncidencia);
        delete gridOptions.newIncidencia.text;
      };


      gridOptions.numberOfChanges = function(){
				if(gridOptions.gridApi) {
					var insertedModified = gridOptions.insertedRows.reduce(function(p,e){ return p+(e.modifiedValues || e.manuallyAdded?1:0);},0);
        	return (gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified) + gridOptions.deletedRows.length + gridOptions.insertedRows.length;
				} else {
					return 0;
				}
      };

      gridOptions.updateIxGuardarTooltip = function(){
          var tooltip = [];
          var insertedModified = gridOptions.insertedRows.reduce(function(p,e){return p+(e.modifiedValues?1:0);},0);
          if((gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified)>0) {
            tooltip.push((gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified)+" filas modificadas");
          }
          if(gridOptions.deletedRows.length>0) {
            tooltip.push(gridOptions.deletedRows.length+" filas eliminadas");
          }
          if(gridOptions.insertedRows.length>0) {
            tooltip.push(gridOptions.insertedRows.length+" filas nuevas");
          }
          gridOptions.ixGuardarTooltip = "Guardar cambios" + (tooltip.length>0?" : " + tooltip.join(","):"");

      };


      gridOptions.buildPK = function(item) {
        var key = {};
        this.metadata.forEach(function(f){
          if(f.Pk) {
            key[f.Name] = item[f.Name];
          }
        });
        return key;
      };

      gridOptions.getPatchOperations = function(data){
        var r = [];
				if(angular.isDefined(data.modifiedValues)){
					data.modifiedValues.forEach(function (col) {
						var propName = getRealName(col);
						r.push({
							value: data[col],
							path: "/" + propName,
							op: "replace"
						});
					});
				}
        return r;
      };

			gridOptions.ixCheckErrors = function() {
				var that = this;
        scope.gridStatus = {$invalid:false, $error:{}};
				var requiredFields = this.metadata.filter(function(f){return !f.NoVisible && f.Required || !f.NoVisible && f.Pk && !f.Fk;});//Si son Fk no son obligatories.
				var dateFields = this.metadata.filter(function(f){ return f.Type == "DateTime"; });
				this.gridApi.rowEdit.getDirtyRows().forEach(function(row){
					requiredFields.forEach(function(f) {
            if((!row.entity[f.Name] && row.entity[f.Name]!==0) || row.entity[f.Name]==="") {
              scope.gridStatus.$invalid = true;
							if(!scope.gridStatus.$error.required) {
								scope.gridStatus.$error.required=[];
							}
							scope.gridStatus.$error.required.push({$name:f.Name, pk:that.buildPK(row.entity)});
            }
					});

					dateFields.forEach(function(f){
						var fecha = row.entity[f.Name];
						if(fecha){
							if(fecha.getFullYear() > 9999){
								scope.gridStatus.$invalid = true;
								if(!scope.gridStatus.$error.fecha) {
									scope.gridStatus.$error.fecha=[];
								}
								scope.gridStatus.$error.fecha.push({message: "Fecha con año {{param}} incorrecta", param: fecha.getFullYear()});
							}
						}
					});

					if(angular.isDefined(gridOptions.ixCheckErrorsExtra)){
						var requiredProperty = gridOptions.ixCheckErrorsExtra(row.entity);
						if(requiredProperty != ""){
							scope.gridStatus.$invalid = true;
							if(!scope.gridStatus.$error.required) {
								scope.gridStatus.$error.required=[];
							}
							scope.gridStatus.$error.required.push({$name:requiredProperty, pk:that.buildPK(row.entity)});
						}
					}
				});
			};

			gridOptions.onRegisterApi = function (gridApi) {
          this.deletedRows = (gridOptions.deletedRows) ? gridOptions.deletedRows : [];
          this.insertedRows = (gridOptions.insertedRows) ? gridOptions.insertedRows : [];
          this.ixGuardarTooltip = "Guardar cambios";

					this.gridApi = gridApi;
          //this.gridApi.core.handleWindowResize();


					//Test drag rows:
					if(gridApi.dragndrop)
						gridApi.dragndrop.setDragDisabled(true);

					//beforeRowMove

					if(gridApi.draggableRows){
						gridApi.draggableRows.on.beforeRowMove(scope, function(from, to, data) {
							var item = data[from];
							var auxFrom = angular.copy(from);
							//Si se intenta meter un item de nivel superior en uno inferior, que no haga nada (to = from).
							if(item["$$treeLevel"] != data[to]["$$treeLevel"])
								gridOptions.dragBack = true;
							else {
								while((data[auxFrom+1]) && data[auxFrom+1]["$$treeLevel"] > item["$$treeLevel"]){
									auxFrom++;
								}
							}
							gridOptions.firstChildrenItemIndex = from + 1;
							gridOptions.lastChildrenItemIndex = auxFrom;
							gridOptions.draggedFrom = from;
							gridOptions.draggedTo = to;

							gridOptions.copyOfList = angular.copy(data);

						});

						gridApi.draggableRows.on.rowFinishDrag(scope, function() {
							var removed = [];

							var minus = 0;

							if(angular.isDefined(gridOptions.draggedFrom) && angular.isDefined(gridOptions.draggedTo)){
								if(gridOptions.dragBack){
									removed = gridOptions.data.splice(gridOptions.draggedTo, 1);
									gridOptions.data.splice(gridOptions.draggedFrom, 0, removed[0]);
								}
								else if(angular.isDefined(gridOptions.firstChildrenItemIndex) && angular.isDefined(gridOptions.lastChildrenItemIndex)){
									if(gridOptions.draggedFrom < gridOptions.draggedTo)
										minus = 1;

									var x = 1;
									var item = gridOptions.data[gridOptions.draggedTo];


									if((gridOptions.data[gridOptions.draggedTo - 1] && gridOptions.data[gridOptions.draggedTo + 1]) && gridOptions.data[gridOptions.draggedTo - 1]["$$treeLevel"] == item["$$treeLevel"] && gridOptions.data[gridOptions.draggedTo + 1]["$$treeLevel"] > item["$$treeLevel"]){
										while((gridOptions.copyOfList[gridOptions.draggedTo+1]) && gridOptions.copyOfList[gridOptions.draggedTo+1]["$$treeLevel"] > item["$$treeLevel"]){
											gridOptions.draggedTo++;
										}
										var currIdx = gridOptions.data.indexOf(item);
										removed = gridOptions.data.splice(currIdx, 1);
										gridOptions.data.splice(gridOptions.draggedTo + ((minus == 0) ? 1 : 0), 0, removed[0]);
									}


									//for(var i = gridOptions.firstChildrenItemIndex; i <= gridOptions.lastChildrenItemIndex; i++){
										var removeds = gridOptions.data.splice(gridOptions.firstChildrenItemIndex - minus, (gridOptions.lastChildrenItemIndex - gridOptions.firstChildrenItemIndex) + 1);
										gridOptions.draggedTo = gridOptions.data.indexOf(item);
										angular.forEach(removeds, function(remov){
											gridOptions.data.splice((gridOptions.draggedTo + x), 0, remov);
											x++;
										});
									//}

									if(angular.isDefined(gridOptions.afterDragRow)){
										gridOptions.afterDragRow(gridOptions, item, gridOptions.draggedFrom, gridOptions.draggedTo);
									}
								}
								gridOptions.dragBack = undefined;
								gridOptions.firstChildrenItemIndex = undefined;
								gridOptions.lastChildrenItemIndex = undefined;
								gridOptions.draggedFrom = undefined;
								gridOptions.draggedTo = undefined;
							}
						});
					}



          //pintar tota la fila després de fer clic a una cel·la:
          if(gridApi.cellNav){
            gridApi.cellNav.on.navigate(scope, function (selected){
              var isDifferent = false;
              if('.ui-grid-cell-focus'){
                if(selected.row.uid != gridApi.clickedRow) isDifferent = true;
                gridApi.clickedRow = selected.row.uid;
                gridApi.ix.focusSelectedRow(selected.row);
                //gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);//Aquest notify fa que vagi molt lenta la navegació, només es fa servir per pintar la row sel·leccionada.
              }
              if(gridOptions.loadItemWhenSelect && isDifferent){
                //Carrega fitxa.
                scope.accion(selected.row.entity, gridApi.grid.options.entity);
              }
              gridApi.clickedRowObj = selected.row;
            });

						gridApi.cellNav.on.viewPortKeyDown(scope, function (evt, newRowCol, defaultHandler) {
							var fireDefaultHandler = true;
							var row = {};
							var col = {};
							var obj = {};
							if (evt.keyCode === TAB_KEY || evt.keyCode === INTRO_KEY) {
								row = newRowCol.row;
								col = newRowCol.col
								if(scope.status.editing && gridOptions.enableCellEdit && angular.isDefined(scope.ixAddRow)){
									var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""}).map(function(e){return { Field: e.name } });
									if (
											uiGridCellNavService.getDirection(evt) == uiGridCellNavConstants.direction.RIGHT &&
											gridApi.grid.rows.indexOf(row) ==gridApi.grid.rows.length - 1 &&
											visibleCols.findIndex(function (record){return  record.Field === col.field;}) == visibleCols.length - 1
									) {
											obj.toInsert = true;
											gridOptions.ixAddRow(obj);
										}
								}
							}
							if (evt.keyCode === DOWN_KEY) {
								row = newRowCol.row;
								col = newRowCol.col;
								if(scope.status.editing && gridOptions.enableCellEdit && angular.isDefined(scope.ixAddRow)){
									if (
											uiGridCellNavService.getDirection(evt) == uiGridCellNavConstants.direction.DOWN &&
											gridApi.grid.rows.indexOf(row) ==gridApi.grid.rows.length - 1
									) {
											obj.toInsert = true;
											gridOptions.ixAddRow(obj);
										}
								}
							}
							if (fireDefaultHandler)
								defaultHandler(evt);
						});
          }

					if(gridApi.edit) {
						//if(!gridOptions.originalflagScrollingHorizontallyFunc){
						gridOptions.originalflagScrollingHorizontallyFunc = angular.copy(gridApi.grid.flagScrollingHorizontally);
						//}
						if(gridOptions.originalflagScrollingHorizontallyFunc){
							gridApi.grid.flagScrollingHorizontally = function(scrollEvent){
								scrollEvent.withDelay = true; //ibran
								gridOptions.originalflagScrollingHorizontallyFunc(scrollEvent);
							}
						}

						gridOptions.originalflagScrollingVerticallyFunc = angular.copy(gridApi.grid.flagScrollingVertically);
						//}
						if(gridOptions.originalflagScrollingVerticallyFunc){
							gridApi.grid.flagScrollingVertically = function(scrollEvent){
								scrollEvent.withDelay = true; //ibran
								gridOptions.originalflagScrollingVerticallyFunc(scrollEvent);
								$timeout(function(){
									//llamada a gridfkupdate para refrescar el valor de los combos angular-virtual-select al hacer scroll
									scope.$broadcast("gridfkUpdate");
								},1);
							}
						}

						// Guardamos registro de las columnas modificadas en cada fila
						gridApi.edit.on.afterCellEdit(scope, function (rowEntity, colDef, newValue, oldValue) {
							if(newValue!==oldValue) {
								//Si la columna forma part de la PK i es de tipus string, no pot contenir espais.
								if(colDef.pk && colDef.type == "string" && colDef.field != "referencia"){
									newValue = newValue.replace(/ /g, '');
									rowEntity[colDef.field] = newValue;
								}
                //TODO: En cas que s'hagi modificar la pk (colDef.pk == true); Esborrar totes les entrades d'error que tinguin una pk = a oldValue (Aixi evitarem arrossegar errors de validació falsos).
								if (!rowEntity.modifiedValues) {
									rowEntity.modifiedValues = [];
								}
								if(rowEntity.modifiedValues.indexOf(colDef.name)===-1) {
									rowEntity.modifiedValues.push(colDef.name);
								}


                if(angular.isDefined(gridApi.grid.options.onCellEdit)
                   && typeof gridApi.grid.options.onCellEdit == "function"){
                  gridApi.grid.options.onCellEdit(rowEntity, colDef, newValue, oldValue);
                }
                //Si no possem timeout, la funció ixCheckErrors es crida i la fila no està encara a la col·lecció de dirty rows.
                $timeout(function(){
								  gridApi.grid.options.ixCheckErrors();
                });
							}
						});
          }

//					if(angular.isDefined(gridOptions.onRowsRendered)){
//						gridApi.core.on.rowsRendered( scope, gridOptions.onRowsRendered );
//					}

					//PRUEBAS FT

					if(gridOptions.pruebaFT){
						var alignContainers =  function alignContainers ( gridContainer , grid) {
							gridOptions.headerHeight = 0;
							gridOptions.largestRow = 0;
							var header = angular.element(gridContainer + ' .ui-grid-header-cell-row')[0].offsetHeight;
							gridOptions.headerHeight = header;

							var rows = angular.element(gridContainer + '.ui-grid .ui-grid-render-container-body .ui-grid-row');
							var pinnedRowsLeft = angular.element(gridContainer + '.ui-grid .ui-grid-pinned-container-left .ui-grid-row');
							var gridHasRightContainer = grid.hasRightContainer();
							if (gridHasRightContainer) {
								var pinnedRowsRight = angular.element(gridContainer + '.ui-grid .ui-grid-pinned-container-right .ui-grid-row');
							}

							var bodyContainer = grid.renderContainers.body;

							// get count columns pinned on left
							var columnsPinnedOnLeft = grid.renderContainers.left.renderedColumns.length;

							for (var r = 0; r < heightRowsChanged.length; r++) {
								heightRowsChanged[r].height = 30;
							}
							heightRowsChanged = [];

							gridOptions.totalHeight = 0;

							for(r = 0; r < rows.length; r++) {
								// Remove height CSS property to get new height if container resized (slidePanel)
								var elementBody = angular.element(rows[r]).children('div');
								elementBody.css('height', '');
								var elementLeft = angular.element(pinnedRowsLeft[r]).children('div');
								elementLeft.css('height', '');
								if (gridHasRightContainer) {
									var elementRight = angular.element(pinnedRowsRight[r]).children('div');
									elementRight.css('height', '');
								}

								// GET Height when set in auto for each container
								// BODY CONTAINER
								var rowHeight = rows[r].offsetHeight;
								// LEFT CONTAINER
								var pinnedRowLeftHeight = 0;
								if (columnsPinnedOnLeft) {
									pinnedRowLeftHeight = pinnedRowsLeft[r].offsetHeight;
								}
								// RIGHT CONTAINER
								var pinnedRowRightHeight = 0;
								if (gridHasRightContainer) {
									pinnedRowRightHeight = pinnedRowsRight[r].offsetHeight;
								}
								// LARGEST
								var largest = Math.max(rowHeight, pinnedRowLeftHeight, pinnedRowRightHeight);

								if(gridOptions.largestRow < largest)
									gridOptions.largestRow = largest;

								gridOptions.totalHeight += largest;

								// Apply new row height in each container
								elementBody.css('height', largest);
								elementLeft.css('height', largest);
								if (gridHasRightContainer) {
									elementRight.css('height', largest);
								}

								// Apply new height in gridRow definition (used by scroll)
								//bodyContainer.renderedRows[r].height = largest;
								var heightRowChanged = bodyContainer.renderedRows[r];
								if(angular.isDefined(heightRowChanged)){
									heightRowChanged.height = largest;
									heightRowsChanged.push(heightRowChanged);
								}
							}
							// NEED TO REFRESH CANVAS
							$timeout(function(){
								bodyContainer.canvasHeightShouldUpdate = true;
							},300);

						};
				// END alignContainers()
					var heightRowsChanged = [];
					var rowsRenderedTimeout;
					// ROWS RENDER
					gridApi.core.on.rowsRendered(scope, function () {
						// each rows rendered event (init, filter, pagination, tree expand)
						// Timeout needed : multi rowsRendered are fired, we want only the last one
						if (rowsRenderedTimeout) {
							$timeout.cancel(rowsRenderedTimeout)
						}
						rowsRenderedTimeout = $timeout(function () {
							//alignContainers('', gridApi.grid);
							alignContainers('.grid'+gridApi.grid.id, gridApi.grid);
						},300);
					});

					// SCROLL END
					gridApi.core.on.scrollEnd(scope, function () {
						//alignContainers('', gridApi.grid);
						alignContainers('.grid'+gridApi.grid.id, gridApi.grid);

					});
				}


					//ibran
					gridApi.core.on.rowsVisibleChanged( scope, function() {
						$timeout(function(){
							//llamada a gridfkupdate para refrescar el valor de los combos angular-virtual-select al hacer filtros
							scope.$broadcast("gridfkUpdate");
						},10);
					});

          gridApi.ix = {};
          gridApi.ix.status = scope.status; // Binding amb status de la pagina
          gridApi.ix.focusSelectedRow = function(selectedRow){
            gridApi.ix.unfocusPreviousRow(selectedRow);
            selectedRow.estaSeleccionado = true;
          };

          gridApi.ix.unfocusPreviousRow = function(selectedRow){
            var lastRow = gridApi.cellNav.getFocusedCell();
            if((angular.isDefined(lastRow) && lastRow !== null) && lastRow.col.colDef.control == "Search" && lastRow.col.colDef.isOpen) lastRow.col.colDef.isOpen = false;
            if(angular.isDefined(lastRow) && lastRow !== null && lastRow.row !== selectedRow.row){
              lastRow.row.estaSeleccionado = false;
            }
          };

					gridApi.ix.disableField = function(cell, col){
						return !gridOptions.cellEditableCondition(cell);
					};
          //Nova funció per obrir un popup en quan el icon d'una columna es clica.
          gridApi.ix.showPopup = function(cell, col, $event) {
            if(scope.status.editing){
              var $elm;

              scope.entityObj = cell.row.entity;
              scope.colDisplayname = col.displayName;
              scope.colField = col.field;
              scope.gridEntity = gridOptions.entity;
              scope.isNew = cell.row.entity.isNew;

              var html = '<ix-grid-modal col-displayname="col.displayName" col-field="col.field" entity="entity" is-new="cell.row.entity.isNew"></ix-grid-modal>';

              $elm = angular.element(html);
              angular.element($document.find('body').eq(0)).prepend($elm);

              $compile($elm)(scope);
            }
          };

          gridApi.ix.blockOrUnblockGridOrder = function(){
						if(!gridOptions.disableOrderLock){
							if(gridOptions.enableSorting){
								gridApi.ix.blockGridOrder();
							} else {
								gridApi.ix.unblockGridOrder();
							}
						}
          };

          gridApi.ix.blockGridOrder = function(){
            var rows = gridOptions.gridApi.core.getVisibleRows();

            angular.forEach(rows, function(row,i){
              row.entity.virtualOrderColumn = i;
            });

            var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
            gridOptions.originalGridOrder = sortedColumns.map(function(e){ return { field: e.field, sort: e.sort }; });

            sortedColumns.forEach(function(column){ column.sort = {}; });

            var virtualOrderColumn = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == "VIRTUALORDERCOLUMN"; });
            virtualOrderColumn.sort = { priority: 0, direction: "asc" };


            gridOptions.enableSorting = false;
            gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          };

          gridApi.ix.unblockGridOrder = function(){
            if(angular.isDefined(gridOptions.originalGridOrder)){
              gridOptions.applyOriginallySortedColumns();
              delete gridOptions.originalGridOrder;
            }

            gridOptions.enableSorting = true;
            gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          };

          gridApi.ix.goToBottom = function(){
            var gridPrevToRow = gridOptions.data[gridOptions.data.length - 2];
            var gridRow = gridOptions.data[gridOptions.data.length - 1];
            gridOptions.gridApi.ix.focusSelectedRow(gridRow);
            //var gridCol = gridOptions.columnDefs[0];
						var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""}).map(function(e){return { Field: e.name } });
						var gridCol = gridOptions.columnDefs.find(function(c){ return c.field == visibleCols[0].Field; });

            $timeout(function() {
              gridOptions.gridApi.cellNav.scrollToFocus( gridPrevToRow, gridCol);
            }, 100);
            $timeout(function() {
              gridOptions.gridApi.cellNav.scrollToFocus( gridRow, gridCol);
            }, 200);
          };

          gridApi.ix.drawDirtyRows = function(){
            // marcar les dirty rows si estem restaurant la grid
            $timeout(function(that,gridApi){
              if(that.data) {
                var dirtyRows = that.data.filter(function(x){
                  return x.modifiedValues || x.manuallyAdded
                });
                $log.log("dirty rows",dirtyRows);
                gridApi.rowEdit.setRowsDirty(dirtyRows);
                if(dirtyRows.length > 0){
                  gridApi.grid.options.ixCheckErrors();
                }
              }
            },100,true,this,gridApi);
          };
          if(angular.isDefined(gridApi.rowEdit)){
            var bound = gridApi.ix.drawDirtyRows.bind(gridOptions);
            bound();
          }
			};

			gridOptions.cellEditableCondition = function (cell) {
        var noeditable = true;
				(typeof(gridOptions.NoEditable) == "function") ? noeditable = gridOptions.NoEditable(cell) : noeditable = cell.col.colDef.noeditable;
				(typeof(cell.col.colDef.noeditable) == "function") ? noeditable = cell.col.colDef.noeditable(cell) : noeditable = noeditable;
				if(!cell.col.colDef.isExtraColumn){
					return (gridOptions.enableCellEdit && scope.status.editing && !noeditable && !cell.col.colDef.fk && (!cell.col.colDef.pk || cell.row.entity.isNew ));
				} else {
					return (angular.isDefined(noeditable) && !noeditable);
				}
			};

      gridOptions.ixEditar = function(loadData){
          // TODO: crear un bloqueig

          //grid.bloqueo = {
            //user: authService.authentication.userName,
            //ts: new Date(),
            //app: grid.entity
          //};
          //if(loadData) this.ixLoadInitialData();
          ixStatusService.setEditing(true);
				if(gridOptions.gridApi.dragndrop){
					gridOptions.gridApi.dragndrop.setDragDisabled(false);
				}
		  ixStatusService.current.ixCellNav = true;

        if(!gridOptions.keepSortingEditing){
					// Deshabilitar ordenacion durante la edición
					gridOptions.enableSorting = false;
					//gridOptions.gridApi.grid.columns.forEach(function(c){c.unsort()});
					gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

      };

			var buildOrderByCol = function(c){
				var metadataColumn = gridOptions.metadata.find(function(e){ return e.Name == c.field; });
				var fieldName = ((c.colDef.TableAliasName || c.colDef.LookUpTableAlias) && c.colDef.LookUpKeyFields) ? c.colDef.LookUpKeyFields[c.colDef.LookUpKeyFields.length-1] : c.field;
				if((angular.isDefined(metadataColumn)) && (!metadataColumn.skipTableName || metadataColumn.addTableNameOrderBy) && !scope.skipTableName && !gridOptions.skipTableName){
					var tableName = gridOptions.entity;
					if(c.colDef.TableAliasName) tableName = c.colDef.TableAliasName;
					if(c.colDef.LookUpTableAlias) tableName = c.colDef.LookUpTableAlias;
					if(fieldName.indexOf("_") == 0){
						fieldName = fieldName.substring(1);
					}
					return (c.sort.direction==="desc"?"-":"")+ tableName + "." +fieldName;
				} else {
					return (c.sort.direction==="desc"?"-":"")+ fieldName;
				}
			};

			gridOptions.ixLoadInitialData = function (page, param) {
          page = angular.isDefined(page) ? page : 1;
          //Excluim les columnes que vinguin marcades com VirtualVMField.
          var sortCols = angular.isDefined(gridOptions.gridApi) ? (gridOptions.gridApi.grid.columns.filter(function(c){return c.sort.priority>=0 && !c.colDef.VirtualVMField;}).sort(function(a,b){return a.sort.priority-b.sort.priority}).map(function(c){
            return buildOrderByCol(c);
          })) : [];
          param = angular.isDefined(param) ? param : {Filters: [], OrderBy: sortCols};

					var that = gridOptions;
					that.ixIsLoading = true;
					if (that.incloureCesta) {
            getCestaFilters(param, $filter, cfg, ixCestaVehiculosService.getCesta(), gridOptions.metadata, gridOptions.skip);
					}
          if(!gridOptions.skipAPIFilter){
            if (getDefaultFilters(that.columnDefs, param, $filter)) {
              that.enableFiltering = true;
            }
          }
					//Si la grid té algún select o algún altre input per filtrar ho comprovarem aquí.
					//En cas afirmatiu, afegirem els valors a l'objecte Filters de la variable param.
					if (that.filtroExterno) {
						angular.forEach(that.filtroExterno, function (valor, filtro) {
              if(valor && typeof valor == "object"){
                if(angular.isDate(valor.Value)){
                  valor.Value = $filter("date")(valor.Value, 'yyyy-MM-dd', null);
                }
                param.Filters.push(valor);
              } else {
								param.Filters.push({
									Field: filtro,
									Value: valor,
									Operator: CMP_EQ
								});
              }
						});
					}

					if (that.orderByExterno){
						angular.forEach(that.orderByExterno, function(orderByExterno){
							param.OrderBy.push(orderByExterno);
						});
					}
										
          var listado = "";
          if(that.listado){
            listado = "/" + that.listado;
          }
					var searchEntity = angular.isDefined(gridOptions.ixLoadInitialDataEntity) ? gridOptions.ixLoadInitialDataEntity : that.entity;
					return $http.post(cfg.baseURL + searchEntity + listado + '/'+gridOptions.ixLoadInitialDataAction+'?Page=' + page + '&ItemsPerPage=' + cfg.pageSize, param).then(function (response) {
						//Per a cada crida s'actualitzarà la data d'informació generada.
						that.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
						if (page == 1) {
							if(angular.isDefined(scope.data)) scope.data.ixProgress = 0;
							that.data = response.data.Items || response.data;
						} else {
							that.data.push.apply(that.data, (response.data.Items || response.data));
						}


						if (!scope.isDestroyed && response.data.TotalItems > response.data.CurrentPage * response.data.ItemsPerPage) {
							var x = 100 / (response.data.TotalItems / response.data.ItemsPerPage);
							if(angular.isDefined(scope.data)) scope.data.ixProgress = page * x;

              var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

              angular.forEach(columnFKDescs, function(columnFKDesc){
                columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
              });

							return that.ixLoadInitialData(page + 1);

						} else {

              columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

              angular.forEach(columnFKDescs, function(columnFKDesc){
                columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
              });


							//if(response.data.TotalItems <= response.data.CurrentPage*response.data.ItemsPerPage){
							//Cridar event de que ja ha acabat.
							scope.$emit('gridLoaded');
							if(angular.isDefined(scope.data)) scope.data.ixProgress = 100;
							that.ixIsLoading = false;
              if(angular.isDefined(scope.data)){
                $timeout(function () {
                  delete scope.data.ixProgress;
                }, 500);
              }
              return that.data;
						}
					}, function (response) {
						that.ixIsLoading = false;
            ixStatusService.setResponse(response);
					});

				//TODO: Fer el load passant pel blockUiBtns del IxStatusService per a que no es pugui fer res mentre es fa el load.
				/*
				var process = $http.post(cfg.baseURL + that.entity + listado + '/'+gridOptions.ixLoadInitialDataAction+'?Page=' + page + '&ItemsPerPage=' + cfg.pageSize, param);
				var callbackOK = function(response){
					//Per a cada crida s'actualitzarà la data d'informació generada.
					that.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
					if (page == 1) {
						if(angular.isDefined(scope.data)) scope.data.ixProgress = 0;
						that.data = response.data.Items || response.data;
					} else {
						that.data.push.apply(that.data, (response.data.Items || response.data));
					}


					if (!scope.isDestroyed && response.data.TotalItems > response.data.CurrentPage * response.data.ItemsPerPage) {
						var x = 100 / (response.data.TotalItems / response.data.ItemsPerPage);
						if(angular.isDefined(scope.data)) scope.data.ixProgress = page * x;

						var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});

						return that.ixLoadInitialData(page + 1);

					} else {

						columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});


						//if(response.data.TotalItems <= response.data.CurrentPage*response.data.ItemsPerPage){
						//Cridar event de que ja ha acabat.
						scope.$emit('gridLoaded');
						if(angular.isDefined(scope.data)) scope.data.ixProgress = 100;
						that.ixIsLoading = false;
						if(angular.isDefined(scope.data)){
							$timeout(function () {
								delete scope.data.ixProgress;
							}, 500);
						}
						return that.data;
					}
				};
				var callbackErr = function(response){
					that.ixIsLoading = false;
					ixStatusService.setResponse(response);
				};
				ixStatusService.blockUIWhileProcessing(process, callbackOK, callbackErr);*/

			};
			gridOptions.ixRefreshGridDropDowns = function () {
				var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
				angular.forEach(columnFKDescs, function(columnFKDesc){
					columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
				});
			};

			gridOptions.ixRestoreConfig = function() {
					if(this.savedStatus) {
						var that = this;
						$timeout(function() {
							that.gridApi.saveState.restore(that, angular.fromJson(that.savedStatus));
							// Un cop restaurada la configuracio, recuperem el filtre si és de selecció múltiple: Issue #96
							/*that.gridApi.grid.columns.forEach(function(col){
								if(col.filters[0] && col.filters[0].term && typeof(col.filters[0].term) == "string" && col.filters[0].term.indexOf("|")>=0) {
									//col.filters[0].condition = new RegExp(col.filters[0].term);
                  $log.log(col.filters[0]);
								}
							});*/
						},0);
					}
			};

			gridOptions.ixSaveConfig = function() {
        if(angular.isDefined(this.gridApi)){
          this.savedStatus = angular.toJson(this.gridApi.saveState.save());
          gridConfigService.saveConfig(gridOptions.gridName, this.gridApi.saveState.save());
        }
			};

      gridOptions.getProfiles = function(){
        return authService.authentication.perfiles;
      };

      gridOptions.getCellClass = function(colDef) {
        var clase = "";

        if(colDef.type==="number") {
          clase = "text-right";
        }
        if(colDef.control==="CheckBox"){
          clase = "text-center";
        }
        else if(colDef.control==="Search" || colDef.control==="ixSiNo"){
          clase = "text-left";
        }

        return clase;
      };

      gridOptions.drawExtraColumns = function(extraColumns){
				var tooltipAction = gridOptions.tooltipSelector();
        extraColumns.forEach(function(column){
          var colDef = {
            field: column.name,
            type: column.type,
            filterHeaderTemplate: '<ix-grid-filtro></ix-grid-filtro>',
						cellTooltip: tooltipAction,
            isExtra: true,
            enableSorting: false
            //cellClass: gridOptions.getCellClass,
          };
					if(column.allowCellFocus == false)
						colDef.allowCellFocus = false;

          if(colDef.type==="date") {
            colDef.cellFilter = "date:'"+cfg.dateFormat+"'";
            colDef.filterCellFiltered = true;
          }
          else if(colDef.type==="detalle"){
            colDef.cellTemplate = '<div class="ui-grid-cell-contents">';
            colDef.acciones = column.acciones;
            var numberActions = 0;
            column.acciones.forEach(function(accion,i){
              colDef.cellTemplate += '<ix-accion-grid index="'+i+'"></ix-accion-grid>';
              numberActions++;
            });
            colDef.cellTemplate += "</div>";
            colDef.width = (column.width) || (numberActions * 30);
            colDef.minWidth = (column.width) || (numberActions * 30);
            //colDef.enableFiltering = false;
            colDef.enableCellEdit = false;//La columna no és editable, prevenim que el valor es pugui modificar al fer doble click.

          } else if(colDef.type==="CheckBox"){
            colDef.cellTemplate = 'checkboxCell';
            colDef.filterHeaderTemplate = 'app/base/views/grid/checkBoxHeaderCell.html';
            colDef.enableCellEdit = false;
            colDef.control = "CheckBox";
						colDef.noeditable = column.NoEditable;
						if(column.beforeClick){ colDef.beforeClick = column.beforeClick }
            if(column.afterClick){ colDef.afterClick = column.afterClick }
            //colDef.cellClass = "text-center";
						colDef.isExtraColumn = true;
						if(column.ignoreCellModifications)colDef.ignoreCellModifications = true;
          } else {
            colDef.cellTemplate = colDef.type;
          }
          colDef.cellClass = gridOptions.getCellClass(colDef);
          colDef.NoFilterable = true;
          gridOptions.columnDefs.push(colDef);
        });
      };



      gridOptions.buildIxProjectionParam = function(){
        var IxProjectionParameter = { Selection: {Filters: [], OrderBy: [] }, Fields: [] };

        var visibleCols = getVisibleCols("name");
        //Excluim les columnes que vinguin marcades com VirtualVMField.
        var sortCols = gridOptions.gridApi.grid.columns.filter(function(c){return c.sort.priority>=0 && !c.colDef.VirtualVMField;}).sort(function(a,b){return a.sort.priority-b.sort.priority}).map(function(c){
            return buildOrderByCol(c);
          });

        IxProjectionParameter.Selection.OrderBy = sortCols;
        IxProjectionParameter.Fields = visibleCols;

        if(gridOptions.incloureCesta){ getCestaFilters(IxProjectionParameter.Selection, $filter, cfg, ixCestaVehiculosService.getCesta(), gridOptions.metadata); }
        getDefaultFilters(gridOptions.columnDefs, IxProjectionParameter.Selection, $filter);
        getLocalFilters(gridOptions.columnDefs, IxProjectionParameter.Selection, $filter);

				if (gridOptions.filtroExterno) {
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(valor && typeof valor == "object"){
							if(angular.isDate(valor.Value)){
								valor.Value = $filter("date")(valor.Value, 'yyyy-MM-dd', null);
							}
							IxProjectionParameter.Selection.Filters.push(valor);
						} else {
							IxProjectionParameter.Selection.Filters.push({
								Field: filtro,
								Value: valor,
								Operator: CMP_EQ
							});
						}
					});
				}

        return IxProjectionParameter;
      };

      scope.leftMarkup = function(){
        return !gridOptions.enableRowSelection;
      };

			scope.conAlarma = function(row){
				if(angular.isDefined(gridOptions.compruebaAlarmaFunc))
					return gridOptions.compruebaAlarmaFunc(row);
				else
					return false;
			};

      scope.$on('gridsRefreshLanguage', function(){
        gridOptions.columnDefs.forEach(function(columnDef){
          columnDef.displayName = $translate.instant(gridUtil.readableColumnName(columnDef.field));
        });
        gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      });

      var addSelectedOptionsToDropdown = function(column, colDef, row, data){
        //Afegim el registre marcat a la llista de opcions.
        var lastKeyField = column.Search.KeyFields[column.Search.KeyFields.length - 1];
        var lastLookUpKeyField = column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1];
        if(angular.isDefined(row.entity[lastKeyField])){
          //var selectedOptionId = row.entity[lastKeyField];
          //var selectedOption = colDef.allFkObjects.find(function(e){ return e[lastLookUpKeyField] == selectedOptionId; });

          var selectedOption = colDef.allFkObjects.find(function(e){
            var result = true;
            for(var i = 0; i < column.Search.KeyFields.length; i++){
              if(e[column.Search.LookUpKeyFields[i]] != row.entity[column.Search.KeyFields[i]]) result = false;
            }
            return result;
          });

          if(angular.isDefined(selectedOption)){
            var found = data.some(function(e) {
              return angular.equals(e,selectedOption) || e[lastLookUpKeyField] == row.entity[lastKeyField];
            });

            if(!found){
              data.push(selectedOption);
            }
          }
        }
      };

			var buildDropdownFilters = function(x, text, row){
				var param = {};
				var filtersConditions = x.Search.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ,Not:(c.Not==true)};});

				var filtersKey = x.Search.LookUpKeyFields.map(function (c, ii, aa) {
				//Filtrem per clau composta només quan té valor.
				//var filtersKey = x.Search.LookUpKeyFields.filter(function(e, i){ return angular.isDefined(row.entity[x.Search.KeyFields[i]]) && row.entity[x.Search.KeyFields[i]] != null && i < x.Search.LookUpKeyFields.length - 1; }).map(function (c, ii) {
					if(ii!==x.Search.LookUpKeyFields.length-1) {
						// no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
						// PREMISA: pos(KeyField)===pos(LookupKeyField).
						var tblName = "";
						if(!x.skipTableName && !scope.skipTableName && !gridOptions.skipTableName){
							tblName = x.Search.LookUpTableName+".";
						}
						return {Field: tblName + c, Value:row.entity[x.Search.KeyFields[ii]], Operator: CMP_EQ};
					}
				});
				filtersKey.pop();//Treiem l'últim valor de l'array. Després del map, a la ultima posició tenim null.
				if(text) {
					var filtersDesc = x.Search.LookUpResultFields.map(function(c,i,a){return {StartPar:i===0, Or: i>0, Field:c,Value:text,Operator:CMP_LIKE, EndPar:i==a.length-1, Skip: x.Skip };});
					param.Filters = filtersKey.concat(filtersDesc).concat(filtersConditions);
				} else {
					param.Filters = filtersKey.concat(filtersConditions);
				}
				//Agafem tots els filtres de filtroExterno i els passem al Search.
				if(gridOptions.enviaParamsFiltroExterno){
					param.Filters = [];
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(angular.isFunction(valor.Value)){
							param.Filters.push({ Field: valor.Field, Value: valor.Value(), Operator: valor.Operator });
						} else {
							param.Filters.push(valor);
						}
					});
				} else if(angular.isDefined(x.conditions) && x.conditions.length > 0){
					angular.forEach(x.conditions, function (condition){
						var filtroExternoCondition = gridOptions.filtroExterno.find(function(e){
							var parts = e.Field.split('.');
							var stringToEval = parts[parts.length-1];
							return stringToEval.toLowerCase() == condition.toLowerCase();
						});
						if(angular.isDefined(filtroExternoCondition)){
							var copyFiltro = angular.copy(filtroExternoCondition);
							var parts = copyFiltro.Field.split('.');
							copyFiltro.Field = parts[parts.length-1];
							param.Filters.push(copyFiltro);
						}
					});
				}

				if(angular.isDefined(x.extraConditions) && x.extraConditions.length > 0){
					x.extraConditions.forEach(function(extraCondition){
						param.Filters.push(extraCondition);
					});
				}

				//if(!x.skipTableName && !scope.skipTableName && !gridOptions.skipTableName){
				var tblName = "";
				if(!x.skipTableNameForDropdown){
					if(x.TableAliasName)
						tblName = x.TableAliasName + ".";
					else if(!x.skipTableName)
						tblName = (!gridOptions.enviaParamsFiltroExterno ? (x.Search.LookUpTableName + ".") : "");
				}

				param.OrderBy = x.Search.LookUpOrders.map(function (o) {return (o.Desc ? "-" : "") + tblName + o.KeyField;});
				//} else {
					//param.OrderBy = x.Search.LookUpOrders.map(function (o) {return (o.Desc ? "-" : "") + o.KeyField;});
				//}

				return param;
			};

			var buildDropdownExtraFilters = function(param, x, text, row){
				if(gridOptions.enviaParamsFiltroExterno){
					param.Filters = [];
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(angular.isFunction(valor.Value)){
							param.Filters.push({ Field: valor.Field, Value: valor.Value(), Operator: valor.Operator });
						} else {
							param.Filters.push(valor);
						}
					});
				} else if(angular.isDefined(x.conditions) && x.conditions.length > 0){
					angular.forEach(x.conditions, function (condition){
						var filtroExternoCondition = gridOptions.filtroExterno.find(function(e){
							var parts = e.Field.split('.');
							var stringToEval = parts[parts.length-1];
							return stringToEval.toLowerCase() == condition.toLowerCase();
						});
						if(angular.isDefined(filtroExternoCondition)){
							var copyFiltro = angular.copy(filtroExternoCondition);
							var parts = copyFiltro.Field.split('.');
							copyFiltro.Field = parts[parts.length-1];
							param.Filters.push(copyFiltro);
						}
					});
				}

				if(angular.isDefined(x.extraConditions) && x.extraConditions.length > 0){
					x.extraConditions.forEach(function(extraCondition){
						param.Filters.push(extraCondition);
					});
				}
				return param;
			};

			var getRealName = function(col){
				if(gridOptions.realVsAliasName){
					angular.forEach(gridOptions.realVsAliasName, function(value, key){
						if(value == col)
							col = key;
					});
				}
				return col;
			};

			var getVisibleCols = function(returnProperty){
				var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""});
				if(angular.isDefined(returnProperty))
					visibleCols = visibleCols.map(function(e){return { Field: (e[returnProperty]) } });

				return visibleCols;
			};

			var getNoVisibleCols = function(returnProperty){
				var noVisibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible==false && e.field != "virtualOrderColumn" });
				if(angular.isDefined(returnProperty))
					noVisibleCols = noVisibleCols.map(function(e){return { Field: (e[returnProperty]) } });

				return noVisibleCols;
			};

      gridOptions.applyOriginallySortedColumns = function(){
        var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
        sortedColumns.forEach(function(column){ column.sort = {}; });

        angular.forEach(gridOptions.originalGridOrder, function(sortedColumn){
          var col = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == sortedColumn.field.toUpperCase(); });
          if(angular.isDefined(col)){
            col.sort = sortedColumn.sort;
          }
        });
      };

      gridOptions.applyCurrentlySortedColumns = function(){
        var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
        sortedColumns.forEach(function(column){ column.sort = {}; });
        var virtualOrderColumn = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == "VIRTUALORDERCOLUMN"; });
        virtualOrderColumn.sort = { priority: 0, direction: "asc" };
      };

			gridOptions.hasPropertyModified = function(row, property){
				var isModified = false;
				if(angular.isDefined(property)){
					isModified = ((angular.isDefined(row.entity.modifiedValues)) && row.entity.modifiedValues.indexOf(property) != -1);
				}
				else {
					isModified = ((angular.isDefined(row.entity.modifiedValues)) && row.entity.modifiedValues.length > 0);
				}
				return isModified;
			};

			gridOptions.addToModifiedValues = function(field){
				if(!gridOptions.gridApi.clickedRowObj.entity.modifiedValues)
					gridOptions.gridApi.clickedRowObj.entity.modifiedValues = [];

				gridOptions.gridApi.clickedRowObj.entity.modifiedValues.push(field);
			};

			gridOptions.clearFocus = function(){
				if(this.gridApi.grid.cellNav){
					this.gridApi.grid.cellNav.clearFocus();
					this.gridApi.grid.cellNav.lastRowCol = null;
				}
			};

			gridOptions.loadConfig = function(){
        var storedConfig = gridConfigService.getConfig(gridOptions.gridName);
        if(storedConfig != ""){
            var restoreConfig = $interval(function(){
              if(angular.isDefined(gridOptions.gridApi)){
                $interval.cancel(restoreConfig);
                if(storedConfig != null){
                  gridOptions.gridApi.saveState.restore(scope, storedConfig);
                  gridOptions.ixSaveConfig();
                  gridOptions.ixRestoreConfig();
                }
                gridOptions.ixIsLoading = false;
                if(!scope.gridManualLoad){
                  gridOptions.ixLoadInitialData();
                }
								scope.$emit('gridConfigLoaded');
              }
            },200);
        } else {
          $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridOptions.gridName).then(function(r){
						var restoreConfigIni = $interval(function(){
							if(angular.isDefined(gridOptions.gridApi)){
                $interval.cancel(restoreConfigIni);
								if(r.data) {
									//Recupera l'estat
									gridOptions.gridApi.saveState.restore(scope, angular.fromJson(r.data.valor));
								}
								//El guarda a l'objecte
								gridOptions.ixSaveConfig();
								//El recupera per aplicar filtres correctament
								gridOptions.ixRestoreConfig();
								//gridConfigService.saveConfig(gridOptions.gridName, null);
								gridOptions.ixIsLoading = false;
								if(!scope.gridManualLoad){
									gridOptions.ixLoadInitialData();
								}
								scope.$emit('gridConfigLoaded');
							}
						},200);

          });
        }
			};

			return gridOptions;
		}

	};
	return gridServiceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('gridConfigService', ['$http', '$q', 'cfg', '$log', '$timeout', function ($http, $q, cfg, $log, $timeout) {
  var gridConfigService = {};
  var _getConfig = function(nombre){
    var config = sessionStorage[nombre];
    return (angular.isDefined(config)) ? angular.fromJson(config) : "";
  };

  var _saveConfig = function(nombre, config){
    sessionStorage[nombre] = angular.toJson(config);
    return true;
  };

  var _clearGridMetadata = function(){
    angular.forEach(sessionStorage, function(item, key){
      if(key.lastIndexOf("-metadata") !== -1){
        sessionStorage.removeItem(key);
      }
    });
  };

  gridConfigService.getConfig = _getConfig;
  gridConfigService.saveConfig = _saveConfig;
  gridConfigService.clearGridMetadata = _clearGridMetadata;

  return gridConfigService;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('authService', ['$http', '$q', 'cfg', '$log', '$timeout', 'gridConfigService', 'moment', '$location', function ($http, $q, cfg, $log, $timeout, gridConfigService, moment, $location) {

    //var serviceBase = cfg.baseAuthURL;
    var authServiceFactory = {};

    var _authentication = {
        isAuth: false,
        userName: "",
        language: "",
        domain: "",
        perfiles: []
    };

    var _login = function (loginData) {
        var data = "grant_type=password&username=" + loginData.userName.toLowerCase() + "&password=" + loginData.password + "&client_id=" + cfg.clientId;

				if(loginData.domain) {
					data += "&domain=" + loginData.domain;
				}

        //TODO: Afegir el timeDiff a data per enviar-ho a la API.

        var deferred = $q.defer();

        $http.post(cfg.baseAuthURL + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).success(function (response) {
          $log.log("Login OK", response);
          loginData.userName = response.userName;
          //localStorage['gp4App.cfg'] = angular.toJson(cfg);
          //localStorage['authorizationData'] = angular.toJson({ token: response.access_token, userName: loginData.userName, language: response.language, refreshToken: response.refresh_token});
          /*var fechaActual = new Date();
          var expirationTime = fechaActual.setHours(fechaActual.getHours() + 8);
          localStorage['expirationTime'] = expirationTime;*/


          _authentication.isAuth = true;
          _authentication.userName = loginData.userName;
          _authentication.domain = loginData.domain;
          _authentication.language = response.language;
          _authentication.perfiles = []; //Se cargará

          if(angular.isDefined(cfg.serverTimeZone)){
            var now = moment.utc();
            var clientTZ = moment.tz.guess();

            var client_tz_offset = moment.tz.zone(clientTZ).utcOffset(now);
            var server_tz_offset = moment.tz.zone(cfg.serverTimeZone).utcOffset(now);
            // calculate the difference in hours
            var difference = ((client_tz_offset - server_tz_offset) / 60);

            if(angular.isDefined(difference)){
              _authentication.timeDiff = difference * -1;
              cfg.timeDiff = difference * -1;
            }
          }
					
					var currentApp = $location.absUrl();
					if(currentApp.indexOf("/login") != -1)
						currentApp = currentApp.substring(0, currentApp.indexOf("/login"));
					if(currentApp.lastIndexOf("/") == currentApp.length - 1)
						currentApp = currentApp.substring(0, currentApp.length - 1);
					cfg.appURL = currentApp;

          sessionStorage['gp4App.cfg'] = angular.toJson(cfg);
          sessionStorage['authorizationData'] = angular.toJson({ token: response.access_token, userName: loginData.userName, language: response.language, refreshToken: response.refresh_token, timeDiff: _authentication.timeDiff});

          deferred.resolve(response);

        }).error(function (err, status) {
          $log.log("error on login in authService",err, status);
          _logOut();
          deferred.reject(err);
        });
        return deferred.promise;

    };

    var _logOut = function () {
      gridConfigService.clearGridMetadata();
      var keys = Object.keys(sessionStorage);
      angular.forEach(keys, function(key){
        if(key != "gp4App.cfg")
          delete sessionStorage[key];
      });

      _authentication.isAuth = false;
      _authentication.userName = "";
      _authentication.domain = "";
      _authentication.language = "";
      _authentication.timeDiff = "";
      _authentication.appURL = "";
      _authentication.perfiles = [];
    };

    var _fillAuthData = function () {

        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);
        if (authData) {
          _authentication.isAuth = true;
          _authentication.userName = authData.userName;
          _authentication.domain = authData.domain;
          _authentication.language = authData.language;
          _authentication.timeDiff = authData.timeDiff;
        }

    };

    var _refreshToken = function ()
    {
        var deferred = $q.defer();

        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);

        $log.log("method refresh token from auth service", authData);


        if (authData) {
					$log.log("test if refreshing");
					if(authData.refreshing) {
						$log.log("token is already refresing, let's wait 5 seconds", new Date());
						var waitforawhile = $q.defer();
						$timeout(function () {
							//authData = angular.fromJson(localStorage['authorizationData']);
							authData = angular.fromJson(sessionStorage['authorizationData']);
							$log.log("after 5 seconds, token refreshing is ", authData, new Date());
							if(authData && authData.token) {
								waitforawhile.resolve("token should be refreshed now");
							} else {
								waitforawhile.reject("token not refreshed in 5 seconds");
							}
  					}, 5000);
  					return waitforawhile.promise;
					} else {
						$log.log("try to refresh token");
						authData.refreshing=true;
						//localStorage['authorizationData'] = angular.toJson(authData);
						sessionStorage['authorizationData'] = angular.toJson(authData);
						var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + cfg.clientId;
						return $http.post(cfg.baseAuthURL + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
							$log.log("return OK from token (storing new token)",response);
							//localStorage['authorizationData'] = angular.toJson({ token: response.data.access_token, userName: response.data.userName, language: response.data.language, refreshToken: response.data.refresh_token });
							sessionStorage['authorizationData'] = angular.toJson({ token: response.data.access_token, userName: response.data.userName, language: response.data.language, refreshToken: response.data.refresh_token });
							//authData = angular.fromJson(localStorage['authorizationData']);
							authData = angular.fromJson(sessionStorage['authorizationData']);
							authData.refreshing=false;
							return response.data;
						});
					}
        } else {
        	$log.log("No stored token");
        	deferred.reject("No stored token");
        }

        return deferred.promise;
    };
		var _tienePerfilAdmin = function(){
			return (_authentication.perfiles.indexOf("ixnet") != -1);
		};
		
    var _tienePerfilUserKey = function(){
			var tiene = false;
			for(var i = 0; i < _authentication.perfiles.length; i++){
				var perfil = _authentication.perfiles[i];
				tiene = perfil.indexOf("userkey") !== -1;
				if(tiene)
					break;
			}
			return tiene;
		};

    var _perfilesUsuario = function(){
			return _authentication.perfiles;
		};
	
    authServiceFactory.login = _login;
    authServiceFactory.logOut = _logOut;
    authServiceFactory.fillAuthData = _fillAuthData;
    authServiceFactory.authentication = _authentication;
    authServiceFactory.refreshToken = _refreshToken;
	  authServiceFactory.tienePerfilAdmin = _tienePerfilAdmin;
	  authServiceFactory.perfilesUsuario = _perfilesUsuario;
    authServiceFactory.tienePerfilUserKey = _tienePerfilUserKey;
    return authServiceFactory;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('authInterceptorService', ['$q', '$injector','$location', '$log', 'moment', function ($q, $injector,$location,$log,moment) {

    var authInterceptorServiceFactory = {};
		var requestsPending = [];

		var formatDatesToServerTime = function(data, timeDiff){
			if (!angular.isObject(data)) {
				return data;
			}
			var key = "";
			for (key in data) {
				if (!data.hasOwnProperty(key)){ continue; }

				var value = data[key];
				if(angular.isDate(value)){
					var originalDate = new Date(value);

					var year = originalDate.getFullYear();
					var month = (originalDate.getMonth()+1);
					if(month < 10)
						month = "0" + month;

					var day = originalDate.getDate();
					if(day < 10)
						day = "0" + day;

					/*var hours = originalDate.getHours();
					if(hours < 10)
						hours = "0" + hours;

					var minutes = originalDate.getMinutes();
					if(minutes < 10)
						minutes = "0"+minutes;

					var seconds = originalDate.getSeconds();
					if(seconds < 10)
						seconds = "0"+seconds;*/

					var cfg = $injector.get('cfg');

					var tzServer = moment().tz(cfg.serverTimeZone).format("ZZ");

					data[key] = year + "-" + month + "-" + day + "T00:00:00" + tzServer;

				} else if (angular.isObject(value)) {
					// Recurse into object
					formatDatesToServerTime(value);
				}
			}
		}

	var _tieneLlamadasPendientes = function(path){
		return (requestsPending.indexOf(path) != -1);
	}

    var _request = function (config) {


        config.headers = config.headers || {};
        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);
        if (authData && authData.token) {
          config.headers.Authorization = 'Bearer ' + authData.token;
          config.headers.TimeDiff = authData.timeDiff;
        }

        var cfg = $injector.get('cfg');

		if(tienePathAPI(cfg.baseAuthURL, config.url)){
			if(requestsPending.indexOf(config.url) == -1)
				requestsPending.push(config.url);
		}

        if(cfg.logApiCalls && config.url.indexOf(cfg.baseURL)==0) {
        	$log.log("API request" , config.method+ " " + config.url, config);
        }

				formatDatesToServerTime(config.data, config.headers.TimeDiff);

        return config;
    }

    var _response = function (response) {

        var cfg = $injector.get('cfg');

		if(tienePathAPI(cfg.baseAuthURL, response.config.url)){
			var idx = requestsPending.indexOf(response.config.url);
			if(idx != -1)
				requestsPending.splice(idx, 1);
		}

        if(cfg.logApiCalls && response.config.url.indexOf(cfg.baseURL)==0) {
        	$log.log("API response" , response.config.method+ " " + response.config.url, response);
        }
        return response;
    }


    var _responseError = function (rejection) {

		var cfg = $injector.get('cfg');
		if(tienePathAPI(cfg.baseAuthURL, rejection.config.url)){
			var idx = requestsPending.indexOf(rejection.config.url);
			if(idx != -1)
				requestsPending.splice(idx, 1);
		}

    	if (rejection.status === 401) {
            var authService = $injector.get('authService');
            //var authData = angular.fromJson(localStorage['authorizationData']);
            var authData = angular.fromJson(sessionStorage['authorizationData']);
            var $http = $injector.get('$http');

						$log.log("got a 401 error", authData, rejection);
            if (authData) {

								if(authData.token) {
									delete authData.token;
									sessionStorage['authorizationData'] = angular.toJson(authData);
									$log.log("deleted old access token and saving in sessionStorage",authData)
								}

                $log.log("using refresh_token", authData);
                return authService.refreshToken().then(function(r){
                    $log.log("token refreshed", r,"relaunch revious rejected request", rejection.config);
                    //rejection.config.headers.Authorization = 'Bearer ' + r.data.access_token;
                	return $http(rejection.config);
                }, function(e) {
                	$log.error("refresh token failed", e);
                    authService.logOut();
                    $location.path('/login');
                	return $q.reject(rejection);
                });

            } else {
                $log.error("no auth data stored going to /login");
                authService.logOut();
                $location.path('/login');
            }
        } else {
        	$log.error("API response error "+rejection.status+" at "+rejection.config.method+" "+rejection.config.url , rejection);
        }
        return $q.reject(rejection);
    }

	var tienePathAPI = function(APIBaseUrl, url){
		return (url.lastIndexOf(APIBaseUrl) != -1);
	}

    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.response = _response;
    authInterceptorServiceFactory.responseError = _responseError;
	authInterceptorServiceFactory.tieneLlamadasPendientes = _tieneLlamadasPendientes;

    return authInterceptorServiceFactory;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';

angular.module('gp4App').factory('apiHubService', ['$rootScope', 'cfg', '$log', function ($rootScope, cfg, $log) {

		function apiHubServiceFactory(hubName, jobId) {
			//var proxy = $.connection.ixJobHub;

			var connection = $.hubConnection(cfg.baseAuthURL);
			var proxy = connection.createHubProxy(hubName);

      //$log.log("proxy");
      proxy.on('foo',function(){});

			connection.start().done(function () {
        //$log.log("trackJob");
        proxy.invoke('trackJob', jobId);
			}).fail(function (e) {
          $log.warn(e);
      });

			return {
        connection: connection,
				on: function (eventName, callback) {
					proxy.on(eventName, function (result) {
						$rootScope.$apply(function () {
							if (callback) {
								callback(result);
							}
						});
					});
				},
				off: function (eventName, callback) {
					proxy.off(eventName, function (result) {
						$rootScope.$apply(function () {
							if (callback) {
								callback(result);
							}
						});
					});
				},
				invoke: function (methodName, callback) {
					proxy.invoke(methodName)
						.done(function (result) {
            //$log.log("proxy invoke");
							$rootScope.$apply(function () {
								if (callback) {
									callback(result);
								}
							});
						});
				},
        getConnection: function(){
          return this.connection;
        },
        closeConnection: function(connection){
          connection.stop();
        }
			};
		}

		return apiHubServiceFactory;

}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ */
'use strict';
angular.module('gp4App').service('ViewBuilderService', [ 'ixStatusService', 'gridService', '$timeout', '$log', function(ixStatusService, gridService, $timeout, $log){
  var ViewBuilderService = {};
  ViewBuilderService.scope = {};
  ViewBuilderService.init = function(scope, viewName, loadViewFunction){
    ViewBuilderService.scope = scope;
    this.viewName = viewName;

    //Si la vista encara no s'ha carregat, la carreguem i iniciem les grids que faci falta.
    if(!this.scope.data.gridsTab){
      this.view = loadViewFunction();
      angular.forEach(this.view, function(value, key){
        value.grids.forEach(function(grid, i){
          if((key == "general" || grid.startup == true) && value.refresh == true){
            ViewBuilderService.loadTabGrid(grid, value.Gkeys[i], true);
          }
        });
      });
    } else {
      //Si ja s'havia iniciat previament restaurar configuració de grids.
      this.view = this.scope.data.gridsTab;
      angular.forEach(this.scope.data.gridsTab, function(value, key){
        if(value.grids){
          value.grids.forEach(function(grid, i){
            if(ViewBuilderService.scope.data[grid.nombre]){
              ViewBuilderService.scope.data[grid.nombre] = gridService.createGridFunctions(ViewBuilderService.scope, ViewBuilderService.scope.data[grid.nombre]);
              ViewBuilderService.scope.data[grid.nombre].ixRestoreConfig();
            }
          });
        }
        if(value.gridspopup){
          value.gridspopup.forEach(function(grid, i){
            if(ViewBuilderService.scope.data[grid.nombre]){
              ViewBuilderService.scope.data[grid.nombre] = gridService.createGridFunctions(ViewBuilderService.scope, ViewBuilderService.scope.data[grid.nombre]);
              ViewBuilderService.scope.data[grid.nombre].ixRestoreConfig();
            }
          });
        }
      });
    }

    return this.view;
  };
  ViewBuilderService.clearGridDirtyRows = function(grid){
    grid.deletedRows = [];
    grid.insertedRows = [];
    var dataRows = grid.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
    grid.gridApi.rowEdit.setRowsClean( dataRows );
  };
  ViewBuilderService.clearGrid = function(grid){
    ViewBuilderService.clearGridDirtyRows(grid);
    grid.data = [];
  };
  ViewBuilderService.changesInTables = function(){
    var num = 0;
    angular.forEach(this.scope.data.gridsTab, function(value, key){
      if(value.grids){
        value.grids.forEach(function(grid, i){
          if(ViewBuilderService.scope.data[grid.nombre]){
            num += ViewBuilderService.scope.data[grid.nombre].numberOfChanges();
          }
        });
      }
      if(value.gridspopup){
        value.gridspopup.forEach(function(grid, i){
          if(ViewBuilderService.scope.data[grid.nombre]){
            num += ViewBuilderService.scope.data[grid.nombre].numberOfChanges();
          }
        });
      }
    });
    return num;
  };
  ViewBuilderService.numberOfChanges = function(){
    return (this.scope.data.datos.ToDelete) ? 1 : ViewBuilderService.changesInTables() + (this.scope.data.datosOriginales ? (!angular.equals(this.scope.data.datos, this.scope.data.datosOriginales) ? 1 : 0) : (this.scope.data.datos.isNew) ? 1 : 0);
  };
  ViewBuilderService.changeTab = function(tabName){
    this.checkGridsTab(tabName);
    this.scope.data.selectedTab = tabName;
  };
  ViewBuilderService.checkGridsTab = function(tabName){
    var i = 0;
    var tabGeneral = this.scope.data.gridsTab["general"];
    var tab = this.scope.data.gridsTab[tabName];
    if(this.scope.data.datos && this.scope.data.datos[this.scope.data.pk]){
      //Carreguem sempre la tab general.
      if(tabGeneral && tabGeneral.refresh){
        for(i = 0; i < tabGeneral.grids.length; i++){
          this.loadTabGrid(tabGeneral.grids[i], tabGeneral.Gkeys[i]);
        }
        tabGeneral.refresh = false;
      }
      //Carreguem la data de la tab sel·leccionada.
      if(angular.isDefined(tab))
        tab.grids[i].visible = false;
      if(tab && tab.refresh){
        for(i = 0; i < tab.grids.length; i++){
          this.loadTabGrid(tab.grids[i], tab.Gkeys[i]);
        }
        if(tab.gridspopup){
          for(i = 0; i < tab.gridspopup.length; i++){
            this.loadTabGrid(tab.gridspopup[i], tab.Gkeys[i]);
          }
        }
        tab.refresh = false;
      }// else {
        //Fem que la grid no es vagi redimensionant visualment.
      if(angular.isDefined(tab))
        this.handleWindowResize(tab.grids);
      //}
    }
  };
  ViewBuilderService.refreshAllGrids = function(){
    angular.forEach(this.scope.data.gridsTab, function(gridsInTab){
      gridsInTab.refresh = true;
      angular.forEach(gridsInTab.grids, function(grid){
        //Si la grid s'ha iniciat.
        if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
          ViewBuilderService.clearGrid(ViewBuilderService.scope.data[grid.nombre]);
        }
      });
      if(gridsInTab.gridspopup){
        angular.forEach(gridsInTab.gridspopup, function(gridpopup){
          if(ViewBuilderService.scope.data[gridpopup.nombre] && ViewBuilderService.scope.data[gridpopup.nombre].gridApi){
            ViewBuilderService.clearGrid(ViewBuilderService.scope.data[gridpopup.nombre]);
          }
        });
      }
    });
  };
  ViewBuilderService.saveConfig = function(){
    angular.forEach(ViewBuilderService.scope.data.gridsTab, function(gridsInTab){
      //gridsInTab.refresh = true;
      angular.forEach(gridsInTab.grids, function(grid){
        //Si la grid s'ha iniciat.
        if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
          ViewBuilderService.scope.data[grid.nombre].ixSaveConfig();
        }
      });
      if(gridsInTab.gridspopup){
        angular.forEach(gridsInTab.gridspopup, function(gridpopup){
          if(ViewBuilderService.scope.data[gridpopup.nombre] && ViewBuilderService.scope.data[gridpopup.nombre].gridApi){
             ViewBuilderService.scope.data[gridpopup.nombre].ixSaveConfig();
          }
        });
      }
    });
  };
  ViewBuilderService.loadTabGrid = function(grid, keys, onlyInitialize){

    if(!this.scope.data[grid.nombre]){
      if(!onlyInitialize){
        this.scope.gridManualLoad = false;
      }
      var gridOptions = { minRowsToShow: 8, enableCellEdit: true };
      if(grid.options){
        gridOptions = angular.merge(gridOptions, grid.options);
      }
      this.scope.data[grid.nombre] = gridService.createGrid(this.scope, this.viewName + "_G" + grid.entity, gridOptions, grid.entity, (grid.acciones) ? [{ name: 'Acciones', type: 'detalle', acciones: grid.acciones }] : null );
      this.scope.data[grid.nombre].visible = false;
      this.applyFilters(grid, keys);
    } else {
      this.scope.data[grid.nombre].visible = false;
      this.applyFilters(grid, keys);
      return this.scope.data[grid.nombre].ixLoadInitialData();
    }
  };

  ViewBuilderService.applyFilters = function(grid, keys){
    var filtros = [];
    keys.forEach(function(key){
      if(angular.isObject(key)){
        filtros.push({Field: Object.keys(key)[0], Value: key[Object.keys(key)[0]], Operator: CMP_EQ });
      } else {
        var keyFormatted = "";
        if(key.indexOf("_") == 0){
          keyFormatted = key.substr(key.indexOf("_") + 1);
        } else {
          keyFormatted = key;
        }

        filtros.push({Field: grid.sendTblName === true ? grid.entity + "." + keyFormatted : keyFormatted, Value: ViewBuilderService.scope.data.datos[key], Operator: CMP_EQ });
      }
    });
    this.scope.data[grid.nombre].filtroExterno = filtros;
  };

  ViewBuilderService.handleWindowResize = function(grids){
    for(var i = 0; i < grids.length; i++){
      grids[i].visible = true;
      this.scope.showGrid(ViewBuilderService.scope.data[grids[i].nombre]);
    }
  };
  ViewBuilderService.getChangesTables = function(){
    var data = {};
    angular.forEach(this.scope.data.gridsTab, function(value, key){
      if(value.grids){
        value.grids.forEach(function(grid){
          if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
            data[grid.nombre] = ViewBuilderService.scope.data[grid.nombre].ixGetBulkParam();
          }
        });
      }
      if(value.gridspopup){
        value.gridspopup.forEach(function(grid){
          if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
            data[grid.nombre] = ViewBuilderService.scope.data[grid.nombre].ixGetBulkParam();
          }
        });
      }
    });

    return data;
  };

  ViewBuilderService.getViewDefault = function(){
    var view = {};
    view["general"] = { grids: [{ entity: this.scope.entity, nombre: "grid", class: "col-md-12" }], Gkeys: [ [ ]], refresh: true };
    return view;
  };
  return ViewBuilderService;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
(function(){
  'use strict';
  angular.module('gp4Filters',[]);


  angular.module('gp4Filters').filter("timeago", [ function () {
      //time: the time
      //local: compared to what time? default: now
      //raw: wheter you want in a format of "5 minutes ago", or "5 minutes"
      return function (time, local, raw) {
          if (!time) return "never";

          if (!local) {
              (local = Date.now())
          }

          if (angular.isDate(time)) {
              time = time.getTime();
          } else if (angular.isString(time)) {
              time = new Date(time).getTime();
          }

          if (angular.isDate(local)) {
              local = local.getTime();
          }else if (angular.isString(local)) {
              local = new Date(local).getTime();
          }

          if (!angular.isNumber(time) || !angular.isNumber(local)) {
              return;
          }

          var
              offset = Math.abs((local - time) / 1000),
              span = [],
              MINUTE = 60,
              HOUR = 3600,
              DAY = 86400,
              WEEK = 604800,
              MONTH = 2629744,
              YEAR = 31556926,
              DECADE = 315569260;

          if (offset <= MINUTE)              span = [ '', raw ? 'now' : 'less than a minute' ];
          else if (offset < (MINUTE * 60))   span = [ Math.round(Math.abs(offset / MINUTE)), 'min' ];
          else if (offset < (HOUR * 24))     span = [ Math.round(Math.abs(offset / HOUR)), 'hr' ];
          else if (offset < (DAY * 7))       span = [ Math.round(Math.abs(offset / DAY)), 'day' ];
          else if (offset < (WEEK * 52))     span = [ Math.round(Math.abs(offset / WEEK)), 'week' ];
          else if (offset < (YEAR * 10))     span = [ Math.round(Math.abs(offset / YEAR)), 'year' ];
          else if (offset < (DECADE * 100))  span = [ Math.round(Math.abs(offset / DECADE)), 'decade' ];
          else                               span = [ '', 'a long time' ];

          span[1] += (span[0] === 0 || span[0] > 1) ? 's' : '';
          span = span.join(' ');

          if (raw === true) {
              return span;
          }
          return (time <= local) ? span + ' ago' : 'in ' + span;
      }
  }]);

angular.module('gp4Filters').filter("getFieldsInColumn", [ function(){
    return function(fields, level){
      if(angular.isDefined(fields)){
        return fields.filter(function(e){
          if(e.ColumnAndOrder){ return e.ColumnAndOrder.Column == level; }
        });
      }
    }
  }]);

angular.module('gp4Filters').filter("reverse", [ function() {
  return function(input) {
    var result = "";
    input = input || "";
    for (var i=0; i<input.length; i++) {
      result = input.charAt(i) + result;
    }
    return result;
  };
}]);

/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
angular.module('gp4Filters').filter('unique', [ function () {

  return function (items, filterOn) {

    if (filterOn === false) {
      return items;
    }

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
      var hashCheck = {}, newItems = [];

      var extractValueToCompare = function (item) {
        if (angular.isObject(item) && angular.isString(filterOn)) {
          return item[filterOn];
        } else {
          return item;
        }
      };

      angular.forEach(items, function (item) {
        var valueToCheck, isDuplicate = false;

        for (var i = 0; i < newItems.length; i++) {
          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
            isDuplicate = true;
            break;
          }
        }
        if (!isDuplicate) {
          newItems.push(item);
        }

      });
      items = newItems;
    }
    return items;
  };
}]);


angular.module('gp4Filters').filter('groupBy', [ function () {
  var results={};
  return function (data, key) {
    if (!(data && key)) return;
    var result = {};
    for(var groupKey in result)
      result[groupKey].splice(0,result[groupKey].length);

    for (var i=0; i<data.length; i++) {
      if (!result[data[i][key]])
        result[data[i][key]]=[];
      result[data[i][key]].push(data[i]);
    }

    var keys = Object.keys(result);
    for(var k=0; k<keys.length; k++){
      if(result[keys[k]].length===0)
        delete result[keys[k]];
    }
    return result;
  };
}]);


angular.module('gp4Filters').filter('customFormatNumber', [ function() {
	return function(input) {
		if(input){
			if(isNaN(input))
			 	return input;
		 	else
			 	return Number(input);
		}
	};
}]);

angular.module('gp4Filters').filter('highlight', [ '$sce', function($sce){
  return function(text, phrase) {
    if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
      '<span class="highlightedText">$1</span>')

    return $sce.trustAsHtml(text);
  };
}]);

angular.module('gp4Filters').filter('underscoreToSpace', [function() {
  return function(input) {
    if (!input) return '';
    return input.replace(/_/g, ' ');
  };
}]);

})();

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*eslint angular/window-service: 0 */
/*eslint angular/document-service: 0 */
/*global angular */
angular.module('gp4App').directive('uiGridClipboard', [ '$rootScope', '$document', '$timeout', function($rootScope, $document, $timeout){
  return {
    replace: true,
    require: '^uiGrid',
    scope: false,
    controller: function () { },
    compile: function(){
      return {
        pre: function(scope, elem, attrs, controller){},
        post: function(scope, elem, attrs, controller){
          //Abans el possavem al document. Millor el possem al grid així evitem l'error [Object object]. D'aquesta manera tampoc possem al document la funció múltiples vegades.
          controller.grid.api.cellNav.on.viewPortKeyDown(scope, function(e){
            var cKey = 67;
            var endKey = 35;
            var curTarget = angular.element(e.target);
            //Si l'usuari esta fent el ctrl + c tenint el focus en el grid, evitem que tingui conflictes amb el copy de l'excel.
            var uiGridTarget = angular.element(document.querySelector('.ui-grid-focuser'));
            if(angular.equals(uiGridTarget, curTarget)){
              if(e.keyCode !== 86 || !e.ctrlKey){
                window.getSelection().removeAllRanges();
                e.preventDefault();
                e.stopPropagation();
              }
            }
            if (e.keyCode == cKey && e.ctrlKey){
              if(window.getSelection() + '' === '') {
                scope.copyData = scope.getSelection(controller);
                document.execCommand('copy');
                e.preventDefault();
              }
            } else if(e.keyCode == endKey && e.ctrlKey){
              controller.grid.api.ix.goToBottom();
            }
          });

          $document.on('copy', documentCopyCells);
          $document.on('paste', documentPaste);

          scope.getSelection = function(controller){
            var selectionText = "";
            var selection = controller.grid.api.cellNav.getCurrentSelection();
            selection.forEach(function(cellSelection){
              selectionText += cellSelection.getIntersectionValueRaw() + ((selection.length > 1) ? "\n" : "");
            });
            return selectionText;
          };

          function documentCopyCells(evt) {
            var cbData,
              cbType;

            if(evt.originalEvent.clipboardData){
              cbData = evt.originalEvent.clipboardData;
              cbType = 'text/plain';
            } else {
              cbData = window.clipboardData;
              cbType = 'Text';
            }

            //if(cbData && (window.getSelection() + '' === '' || window.getSelection() + '' === ' ') && scope.copyData !== ''){
            if(cbData && angular.isDefined(scope.copyData) && scope.copyData !== '' && !angular.isObject(scope.copyData)){
              cbData.setData(cbType, scope.copyData);
              scope.copyData = {};
              evt.preventDefault();
            }
          }

          function documentPaste(evt){
            var cbData,
              cbType;

            if(evt.originalEvent.clipboardData){
              cbData = evt.originalEvent.clipboardData;
              cbType = 'text/plain';
            } else {
              cbData = window.clipboardData;
              cbType = 'Text';
            }

            if(cbData){
              //Si tenim marcada una sola columna i aquesta té control search farem el ctrl + v
              if(controller.grid.cellNav.focusedCells.length == 1 && controller.grid.cellNav.focusedCells[0].col.colDef.control == "Search" && !controller.grid.cellNav.focusedCells[0].col.colDef.isOpen){
                var text = cbData.getData(cbType);
                $rootScope.typedText = text.trim();
              }
            }
          }

          //Definim una funció per quan es canvii o tanqui la pantalla (si es un popup no es fa ja que ens carregariem l'event de la pantalla de sota).
          //Els events dels popups s'eliminaran al canviar o tancar la pantalla de sota.
          var isAPopup = document.querySelector("div.modal-dialog");
          if(isAPopup == null){
            scope.$on("$destroy", function(){
              $document.off('copy');
              $document.off('paste');
            });
          }
        }
      }
    }
  }
}]);

/*global angular */
angular.module('gp4App').directive('sidebarToggle', ['$document', 'sidebarService', function($document, sidebarService) {
	return {
		restrict: 'A',
		link: function (scope, iElement, iAttrs) {

			scope.element = iElement[0];
			scope.body = $document.body;

			scope.element.addEventListener("click", function() {
				var _element = $document[0].getElementById(iAttrs.sidebarToggle);
				/* YVES: DESCOMENTAR siguientes lineas 13-17) para que side-bar se cierre sólo manualmente */
				if(_element.classList.contains("sidebar--is-open")){
					sidebarService.manuallyOpened = false;
				} else {
					sidebarService.manuallyOpened = true;
				}
				_element.classList.toggle("sidebar--is-open");
				/* YVES: DESCOMENTAR siguiente linea para que side-bar se cierre sólo manualmente */
				angular.element(angular.element(_element.parentElement).children("#main-page"))[0].classList.toggle("sidebar--is-open");

				//var _bgSidebar = $document[0].getElementById(iAttrs.sidebarToggle + "-bg");
				//_bgSidebar.classList.toggle("sidebar-bg--is-visible");

				//control body
				/*
				if (scope.body.style.overflowY == "auto") {
					scope.body.style.overflowY = "hidden";
				} else {
					scope.body.style.overflowY = "auto";
				}
				*/
			});

		}
	};
}]);

angular.module('gp4App').directive('sidebar', ['$compile', '$document', 'ixStatusService', 'sidebarService', function($compile, $document, ixStatusService, sidebarService) {
	return {
		restrict: 'E',
		templateUrl: 'app/base/views/sidebar_apps.html',
		link: function (scope, iElement, iAttrs) {
			scope.status  = ixStatusService;
			scope.body = $document.body;
			scope.element = iElement[0];

			scope.isCurrent = function(app) {
				return angular.equals(app, scope.status.current)
			}

			scope.filterFunction = function (filter) {
				return filter.open;
			};
			scope.isSideBarOpen = function() {
				return angular.element(scope.element).hasClass('sidebar--is-open');
			};

			scope.openSideBar = function(){
				scope.element.classList.add("sidebar--is-open");
				angular.element(angular.element(scope.element.parentElement).children("#main-page"))[0].classList.add("sidebar--is-open");
			};

			scope.closeSideBarApps = function() {
				if(!sidebarService.manuallyOpened){
					scope.element.classList.toggle("sidebar--is-open");
					angular.element(angular.element(scope.element.parentElement).children("#main-page"))[0].classList.toggle("sidebar--is-open");
				}
			};

			//renderize sidebar
			scope.element.style.display = "block";
			scope.element.style.top = "50px";
			scope.element.style.height = "calc(100vh - 82px)";

			//add width on sidebar
			function isNumber(n) {
				return !isNaN(parseFloat(n)) && isFinite(n);
			}

			if (isNumber(iAttrs.size)) {
				scope.element.style.maxWidth = iAttrs.size + 'px';
			} else {
				scope.element.style.maxWidth = iAttrs.size;
			}

			// if(iAttrs.openOnMouseClose){
			// 	scope.element.parentElement.addEventListener("mousemove", function(ev) {
			// 		var offsetWidth = scope.element.parentElement.offsetWidth;
			// 		var mouseX = ev.clientX;
			//
			// 		if((offsetWidth - mouseX) < 6)
			// 			scope.openSideBar();
			//
			// 	});
			// }

			//add class to position on sidebar
			scope.element.classList.add("sidebar--" + iAttrs.position);

			//renderize bg-sidebar
			/*
			var bgSidebar = $document[0].createElement("div");
			bgSidebar.setAttribute("class", "sidebar-bg");
			bgSidebar.setAttribute("id", iAttrs.id + "-bg");
			bgSidebar.setAttribute("sidebar-toggle", iAttrs.id);
			scope.body.appendChild(bgSidebar);

			$compile(bgSidebar)(scope);
			*/

		}
	};
}]);

angular.module('gp4App').factory('sidebarService', [ function(){
	var sidebarServiceInstance = {
		manuallyOpened: false
	};
	return sidebarServiceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global getColors */
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
/*global buildIxSearch*/
/*global ixNewDate*/
/*global moment*/
/*global simulateAPIError*/
(function(){
  'use strict';
  angular.module('gp4helpers', []);

	/*angular.module('gp4helpers').directive('datepickerTimezone', [ function () {
		return {
			restrict: 'A',
			priority: 1,
			require: 'ngModel',
			link: function (scope, element, attrs, ctrl) {
				//TODO: if scope firstopen fer calcul de les dates
					ctrl.$formatters.push(function (value) {
							var date = new Date(Date.parse(value));
							date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
							//if (!dateFormat || !modelValue) return "";
							//var retVal = moment(modelValue).format(dateFormat);
							return date;
					});

					ctrl.$parsers.push(function (value) {
							var date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
							return date;
					});
			}
		};
	}]);*/

  angular.module('gp4helpers').directive('ixDatepicker', ['$filter', 'cfg', '$timeout', function($filter, cfg, $timeout) {
      return {
          restrict: 'E',
          require: 'ngModel',
          scope: {
            ngModel: '=',
            name: '@',
            dateLimit: '=?',
						dateMin: '=?',
            ngDisabled: '=',
            appendToBody: '=?'
          },
          template: '<div class="input-group add-on"><input type="text" uib-datepicker-popup ng-model="ngModel" is-open="isOpen" datepicker-options="{maxDate: dateLimit, minDate: dateMin}" show-button-bar="false" placeholder="DD/MM/YYYY" ng-disabled="ngDisabled" datepicker-append-to-body="appendToBody" /><span class="input-group-btn"><span class="btn btn-default btn-calendar" ng-disabled="ngDisabled" ng-click="isOpen=!isOpen"><i class="glyphicon glyphicon-calendar"></i></span></span></div>',
          link: function(scope, elem, attrs, ngModelController) {
            if(angular.isDefined(scope.dateLimit) && scope.dateLimit == true){ scope.dateLimit = new Date(); }
            var input = elem.children(0).children(0);
                input.on('keypress', function(e){
              var keyCode = (e.which||e.charCode||e.keyCode);
              if("0123456789/-. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
              ) {
                return true;
              } else {
                e.preventDefault();
                return false;
              }
            });



            input.on('blur',function(event){
              var newVal = event.target.value;
              var dateParts = newVal.split(/[\/\.\- '\+]{1}/);

              //var now = new Date();
              var now = ixNewDate(cfg,moment);
              var day = now.getDate();
              var month = now.getMonth() + 1;
              var year = now.getFullYear();
              //var momentParts = now.split("T");
              //var parts = momentParts[0].split("-");
              //var parts = now.split("-");
              //var day = parts[2];
              //var month = parts[1];
              //var year = parts[0];
              if(dateParts.length==1) {
                if(dateParts[0].length==0) {
                  ngModelController.$setViewValue(null);
                  ngModelController.$render();

                  //scope.$apply;
                  return;
                }
                day = dateParts[0].slice(0,2);
                if(dateParts[0].length>2) {
                  month = dateParts[0].slice(2,4)
                }
                if(dateParts[0].length>4) {
                  year = dateParts[0].slice(4,8);
                }
              }

              if(dateParts[0].length>0 && dateParts[0].length<=2) {
                day = dateParts[0];
              }
              if(dateParts.length>1 && dateParts[1].length>0) {
                month = dateParts[1];
              }
              if(dateParts.length>2 && dateParts[2].length>0) {
                year = dateParts[2];
              }

              if(year.length<=2) {
                // si sintrodueix l'any en 2 dígits, el passem al segle que correspon
                year = parseInt(year) + (now.getFullYear()-(now.getFullYear()%100));
              }

							var newdate = ixNewDate(cfg,moment, day, month-1, year);
							if(newdate.getFullYear() > 9999){
								if(!scope.$parent.$parent.form.$error.fecha) {
									scope.$parent.$parent.form.$error.fecha=[];
								}
								scope.$parent.$parent.form.$error.fecha.push({message: "Fecha con año {{param}} incorrecta", param: newdate.getFullYear()});
							}
              if(angular.isDefined(scope.dateLimit)){
                scope.ngModel = newdate;
                $timeout(function(){ scope.validar(newdate); }, 1);
              } else {
                scope.ngModel = newdate;
              }
              scope.$apply();
          });

          scope.validar = function(fecha){
            if(scope.dateLimit < fecha){
              //scope.$parent.$parent.form.$invalid = true;
              scope.$parent.$parent.form.$error.validacion = [];
              scope.$parent.$parent.form.$error.validacion.push({$name:"La fecha no puede ser superior a " + $filter("date")(scope.dateLimit, cfg.dateFormat)});
            } else {
              //scope.$parent.$parent.form.$invalid = false;
              scope.$parent.$parent.form.$error.validacion = [];
            }
          }
        }
      };
    }])

	//ixSelect Original
  /*angular.module('gp4helpers').directive('ixSelect', [ function() {
      return {
          restrict: 'E',
          require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
            //Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
            entityData: '=?',
            entityDataPk: '@?',
            entityDataDesc: '@?',
						oneLineText: '=?'
          },
          controller: 'ixSelectController',
          templateUrl: 'app/base/views/helpers_templates/ixSelect.html'
      };
    }]);
	*/
	//nuevo ixSelect
	angular.module('gp4helpers').directive('ixSelect', [ function() {
      return {
          restrict: 'E',
          //require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
			filterFields: '=?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
						allowCustomPriority: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
						//
						preloadObj: '@?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
            //Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
            entityData: '=?',
            entityDataPk: '@?',
            entityDataDesc: '@?',
						oneLineText: '=?',
						onSelect: '=?',
						template: '@?',
						skipTableNameFilter: '=?',
						skipTableNameOrderBy: '=?',
						labelClass: '@?',
						inputClass: '@?',
						longerResultBox: '=?'
          },
          //controller: 'ixSelectController',
          templateUrl: 'app/base/views/helpers_templates/ixSelect2.html'/*,
					link: function(scope, elem, attrs){
						if(!scope.allItems)
							scope.allItems = [];

						scope.$watch('wholeObj', function(newVal, oldVal){
							console.log("wholeObj updated");
						});
					}*/
      };
    }]);

  angular.module('gp4helpers').directive('ixSelectMultiple', [ function() {
      return {
          restrict: 'E',
          require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
						limitTo: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
						skipTableNameFilter: '=?',
						//Si queremos manipular el valor para que el resultado sea el array de items seleccionados separado por coma.
						commaSeparated: '=?'
          },
          controller: 'ixSelectMultipleController',
          templateUrl: 'app/base/views/helpers_templates/ixSelectMultiple.html'
      };
    }])


  angular.module('gp4helpers').directive('ixCheckbox', [ function() {
      return {
          restrict: 'E',
          scope: {
          entity: '=entity',
          field: '@field',
          name: '@'
          },
          template: '<div class="checkbox"><label><input type="checkbox" name="{{name}}" id="{{name}}" ng-model="entity[field]" ng-true-value="1" ng-false-value="0"></input>  {{field}}</label></div>'


      };
    }])

  angular.module('gp4helpers').directive('ixOptionsSiNo', ['$timeout', function ($timeout) {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=?',
        name: '@',
        ngDisabled: '=?',
        textMaxWidth: '=?',
        ngDefault: '=?',
				afterClick: '=?'
      },
      link: function(scope, elem, attrs){
        $timeout(function(){
          var label = angular.element(elem.find('label')[0]);
          label.on('click', function(e){
            if(e.target !== e.currentTarget) return;
            e.preventDefault();
          });
        },1);
      },
      controller: ['$scope', function($scope){
        if(angular.isDefined($scope.ngDefault)){
          if(!angular.isFunction($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //En cas de que el default sigui una etiqueta de config s'executarà una funció que ha d'estar definida al controller de la pantalla.
            $scope.ngDefault().then(function(result){
              $scope.ngModel = result;
              $scope.ngDefault = result;
            });
          }
        }
        if(isNaN($scope.ngModel)){
          $scope.ngModel = 0;
        }

        $scope.changeSelected = function(){
          $scope.ngModel = (($scope.ngModel == 1) ? 0 : 1);
					if($scope.afterClick){
						$timeout(function(){
							$scope.afterClick($scope.ngModel);
						},0);
					}
        }

        $scope.$watch("ngModel", function(value){
          //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
          if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            if(isNaN($scope.ngModel)){
              $scope.ngModel = 0;
            }
            else if(typeof $scope.ngModel == "boolean"){
              $scope.ngModel == true ?  $scope.ngModel = 1 : $scope.ngModel = 0;
            }
            $scope.estaSeleccionado = angular.copy($scope.ngModel);            
          }
          return $scope.ngModel;
        });
      }],
      templateUrl: 'app/base/views/helpers_templates/ixOptionsSiNo.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTextArea', [ function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngClass: '@?',
        ngDisabled: '=?',
        maxLength: '=?',
				rows: '@?',
				cols: '@?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixTextArea.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTextField', [ function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngClass: '@?',
        ngDisabled: '='
      },
      template: '<div class="form-group"> ' +
        '<label class="col-md-4"><translate>{{::name}}</translate><i class="fa fa-asterisk" style="color:red" ng-show="ngRequired"></i></label> ' +
        '<div class="col-md-8 btn-group"> ' +
        '<input class="btn btn-default form-control" ng-class="ngClass" type="text" ng-model="ngModel" readonly="ngDisabled" />' +
        '</div></div> '
    };
  }])

	angular.module('gp4helpers').directive('ixListSelect', [ 'ixUtilsService', 'ivhTreeviewMgr', function (ixUtilsService, ivhTreeviewMgr) {
    return {
      restrict: 'E',
			require: 'ngModel',
			transclude: true,
      scope: {
        ngModel: '=',
				pk: '@',
				desc: '@',
				values: '=?',
				loadFunction: '=?',
				ngDisabled: '=?',
        ngRequired: '=?',
        name: '@',
        ngValue: '=?',
        ngPlaceholder: '@?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixListSelect.html',
      link: function(scope, elem, attrs, ngModelController){

				if(scope.loadFunction) {
					scope.loadFunction().then(function(r) {
						scope.optionValues = r.data.Items ? r.data.Items : r.data;
						scope.optionValues.forEach(function(option){
							option.id = option[scope.pk];
							option.label = option[scope.desc];
							option.children = [];
							option.selected = false;
						});
					});
				} else if(scope.values){
					scope.optionValues = angular.copy(scope.values);
					scope.optionValues.forEach(function(option){
						option.id = option[scope.pk];
						option.label = option[scope.desc];
						option.children = [];
						option.selected = false;
					});
				}

				scope.selectedOptions = scope.ngModel;
				scope.searchvalue = "";
				scope.showModalSelection = function() {
					if(!scope.ngDisabled){
						ixUtilsService.openModalV2("ixListSelectModal.html", { scope: scope }, "small").then(function(){
							var selectedValues = [];
							scope.optionValues.forEach( function( val ) {
								if(val.selected) {
									selectedValues.push( val.id );
								}
								val.children.forEach(function(v2) {
									v2.children.forEach(function(v3) {
										if(v3.selected){
											selectedValues.push(v3.id);
										}
									});
								});
							});
							scope.selectedOptions = selectedValues.join(',');
							ngModelController.$setViewValue(scope.selectedOptions);
						});

						var distinctValues = {};
						//scope.optionValues = [];
						var selectedValues = [];
						if(scope.selectedOptions) {
							selectedValues=scope.selectedOptions.split(",");
						}
						//Sort recursive.
						sortListOfValues(scope.optionValues);
					}
				};

				var sortListOfValues = function(listOfValues){
					//Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
					if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

					listOfValues.sort(function(a,b){
						//Ordenem els fills de l'objecte que estem comparant (si n'hi han).
						if(hasChildrenToSort(a)){
							sortListOfValues(a.children);
						}
						if(hasChildrenToSort(b)){
							sortListOfValues(b.children);
						}
						//return (a.label>b.label)-(a.label<b.label);
						return (a.id>b.id)-(a.id<b.id);
					});
				};

				var hasChildrenToSort = function(obj){
					return obj.children && obj.children.length > 1;
				};

				scope.selectAll = function() {
					var matchingValues = [];
					if(scope.searchvalue != null){
						angular.forEach(scope.optionValues, function(value){
							if(ixUtilsService.comparar(value.label,scope.searchvalue) !== -1){
							 matchingValues.push(value);
							}
						});
						ivhTreeviewMgr.selectAll(matchingValues);
					} else {
						ivhTreeviewMgr.selectAll(scope.optionValues);
					}

				};

				scope.deselectAll = function() {
					ivhTreeviewMgr.deselectAll(scope.optionValues);
				};
      }
    };
  }])

  angular.module('gp4helpers').directive('ixDate', [ function () {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        dateLimit: '=?',
				dateMin: '=?',
        ngDisabled: '=',
        appendToBody: '=?',
				oneLineText: '=?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixDate.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTime', [ '$filter', function ($filter) {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngDisabled: '=?',
				oneLineText: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixTime.html',
      link: function(scope, elem, attrs, ngModelController){
				
				var input = angular.element(elem.find('input')[0]);
				input.on('keypress', function(e){
              var keyCode = (e.which||e.charCode||e.keyCode);
              if("0123456789:. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
              ) {
                return true;
              } else {
                e.preventDefault();
                return false;
              }
            });						
				
				
				input.on('blur',function(event){
              var newVal = event.target.value;
              var dateParts = newVal.split(/[\:\.\- '\+]{1}/);
              
              var now = ($filter("date")(new Date(), "H:mm:ss", null)).split(":");
              var hours = now[0];
              var minutes = now[1];              
							var seconds = "00";
					
              /* INI introduccio sense separadors (. | + | -) */
              if(dateParts.length==1) {
                if(dateParts[0].length==0) {
                  ngModelController.$setViewValue(null);
                  ngModelController.$render();
              
                  return;
                }
								var index = 2;
                hours = parseInt(dateParts[0].slice(0,2));								
								if(hours>23) {									
									hours = dateParts[0].slice(0,1);
									index = 1;
								}
                if(dateParts[0].length>2) {									
                  minutes = dateParts[0].slice(index,index+2);
									if(parseInt(minutes)>59)
									{
										minutes = "0"+dateParts[0].slice(index,index+1);
										index = index + 1;
									}
									else {
										index = index + 2;
									}
                }
                if(dateParts[0].length>4) {
                  //seconds = dateParts[0].slice(index,index+2);
									seconds = parseInt(dateParts[0].slice(index,index+2)) < 9 ? "0"+parseInt(dateParts[0].slice(index,index+2)) : dateParts[0].slice(index,index+2);
                } else {
									seconds = "00";
								}
              }
							/* FIN introduccio sense separadors (. | + | -) */
					
							/* INI introduccio amb separadors (. | + | -) */
              if(dateParts[0].length>0 && dateParts[0].length<=2) {
                hours = parseInt(dateParts[0]);
              }
              if(dateParts.length>1 && dateParts[1].length>0) {
								if(parseInt(dateParts[1]) < 9){
									minutes = "0"+parseInt(dateParts[1]);
								} else if(parseInt(dateParts[1]) > 59){
									minutes = "00";
								} else {
									minutes = dateParts[1];
								}
              }
              if(dateParts.length>2 && dateParts[2].length>0) {
								if(parseInt(dateParts[2]) < 9){
									seconds = "0"+parseInt(dateParts[2]);
								} else if(parseInt(dateParts[2]) > 59){
									seconds = "00";
								} else {
									seconds = dateParts[2];
								}
              }
							/* FIN introduccio amb separadors (. | + | -) */              
              
              scope.ngModel = hours + ":" + minutes + ":" + seconds;
							scope.validateTIME(scope.ngModel);
              scope.$apply();
          });
				
				
				
				
				
        scope.validateTIME = function(val){
          //TODO: Fer que rebi per paràmetre si ha de ser en format hh:mm o hh:mm:ss.
          //var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
					var regex = /^(?:\d|[01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;					
          if(val && !regex.test(val)){
						ngModelController.$setViewValue(null);
						ngModelController.$render();
					}
        };				
      }
    };
  }])

  angular.module('gp4helpers').directive('ixDateTime', [ function() {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngModelTime: '=',
        ngRequired: '=',
        name: '@'
      },
      templateUrl: 'app/base/views/helpers_templates/ixDateTime.html'
    };
  }])

  angular.module('gp4helpers').directive('ixP', [ function(){
    return {
      restrict: 'E',
      scope: {
        name: '@'
      },
      template: '<p translate="{{::name}}"></p>'
    }
  }])

  angular.module('gp4helpers').directive('ixText', [ function () {
    return {
      restrict: 'E',
			require: '?ngModel',
			transclude: true,
      scope: {
        ngModel: '=',
        ngModel2: '=?',
        ngRequired: '=',
        name: '@',
        ngDisabled: '=?',
        ngValue: '=?',
        ngPlaceholder: '@?',
        isFilter: '=?',
        cleanSpecialChars: '&?',
        maxLength: '=?',
        maxLength2: '=?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixText.html',
      link: function(scope, elem, attrs, ctrl){
				if (!ctrl) return;

        if(angular.isDefined(scope.cleanSpecialChars)){
          scope.$watch('ngModel', function (newValue, oldValue) {
            if (newValue != oldValue) {
              scope.ngModel = scope.cleanSpecialChars()(newValue);
            }
          });
        }
				var input = angular.element(elem.find('input')[0]);
				var inputModelCtrl = input.controller('ngModel');

				if(angular.isDefined(inputModelCtrl)){
					//El formatter del ixNumber modifica el valor que apareix en pantalla.
					//Per tant, si hi ha validació de maxlength, aquesta donaria error sempre que el numero contingui separador de milers.
					if(angular.isDefined(attrs.maxLength) && angular.isDefined(attrs.ixNumber)){
						inputModelCtrl.$validators.maxlength = function(modelValue, viewValue){
							if(angular.isDefined(modelValue) && modelValue != null){
								var withoutSeparators = modelValue.replace(/\./g,'');
								withoutSeparators = withoutSeparators.replace(/\,/g,'');
								return withoutSeparators.length <= scope.maxLength;
							}
						};
					}
				}
      }
    };
  }])

  angular.module('gp4helpers').directive('ixRadio', [ function() {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        options: '=',
        ngDisabled: '=?',
        label: '@?',
        multipleInLine: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixRadio.html'
    }
  }])

  /**
   * Directiva per formatejar/desformatejar inputs text amb valors numèrics
   * Ús: <input type="text" class="form-control" ng-model="facutra.importe" format-number with-decimals="2" allow-negative />
   */
  angular.module('gp4helpers').directive('ixNumber', ['$filter', 'cfg', function ($filter, cfg) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        var input = angular.element(elem.find('input')[0]);

        // si attrs.withDecimals es nunumero, asumimos que es el numero de posiciones decimales deseadas. En caso que sea otra cosa (bool?) usaremos el valor cfg.DecimalScale (o 2 si no está definido)
				var decimals = (!isNaN(attrs.withDecimals) && attrs.withDecimals !== null && attrs.withDecimals !== '')?attrs.withDecimals:(cfg.DecimalScale || 2);
				
				var inputModelCtrl = input.controller('ngModel');

				if(angular.isDefined(inputModelCtrl)){
					//Afegim $formatter per fer que els valors que es veuen al carregar en pantalla tinguin el separador de numero i si cal decimal.
					inputModelCtrl.$formatters.push(function(value) {
						if(attrs.withDecimals)
							return $filter('number')(value, decimals);
						else
							return $filter('number')(value, 0);
					});
				}

        input.on('blur', function (e) {
          if(angular.isDefined(attrs.minValue) && parseInt(ctrl.$modelValue) < attrs.minValue){
            scope.showCustomError("El rango es incorrecto = Desde " + attrs.minValue + " hasta " + attrs.maxValue);
            input.focus();
          }
          else if(angular.isDefined(attrs.maxValue) && parseInt(ctrl.$modelValue) > attrs.maxValue){
            scope.showCustomError("El rango es incorrecto = Desde " + attrs.minValue + " hasta " + attrs.maxValue);
            input.focus();
          }
          else {
            scope.clearCustomError();
          }

					if(attrs.withDecimals){
						if(attrs.commaSeparator)
							ctrl.$modelValue = ctrl.$modelValue.toString().replace(".",",");
						else
							ctrl.$modelValue = ctrl.$modelValue.toString().replace(",",".");
						
						var display = $filter('number')(ctrl.$modelValue, decimals);

						if (display)
							e.target.value = display;
						else {
							e.target.value = null;
						}
					}

        });

        elem.on('keypress', function (e) {
					
          var key = e.which;
          var numeros = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]; //0123456789
          var separadores = [44, 46]; //,.  (teclat normal i numpad)
          var negativeSign = [45]; // -

          if(!key) {
            return true;
          } else if (numeros.indexOf(key) >= 0) {
            if(angular.isDefined(attrs.minValue) && parseInt(ctrl.$viewValue + (key - 48 ) ) < attrs.minValue){
              e.preventDefault();//si hi ha valor minim, ens assegurem que es cumpleix.
              return false;
            }
            //En el caso de que estamos usando decimales la siguiente condición no se debe de ejecutar porque en caso de que se haya presionado ','
            //el caracter no pasa al $viewValue y el cálculo del valor máximo lo hace mal
            if(!attrs.withDecimals && angular.isDefined(attrs.maxValue) && parseInt(ctrl.$viewValue + (key - 48 ) ) > attrs.maxValue){
              e.preventDefault();//si hi ha valor maxim, ens assegurem que es cumpleix.
              return false;
            }
            return true; // Allow: numbers
          } else if	(separadores.indexOf(key) >= 0 && attrs.withDecimals>0) {
						
						if(attrs.commaSeparator){
							if (e.target.value.indexOf(",")== -1) { // only one separateor allowed
								if (key === 46) { // si es . reemplazar por ,
									e.target.value = e.target.value.slice(0, e.target.selectionStart) + "," + e.target.value.slice(e.target.selectionEnd);
									e.preventDefault();
									return false; // Replace , for .
								} else {
									return true;  //Allow: valid separators
								}
							} else {	// Si ya hay un separador decimal ignorar
								e.preventDefault();
								return false;
							}
						} else {
							if (e.target.value.indexOf(".")== -1) { // only one separateor allowed
								if (key === 44) { // si es , reemplazar por .
									e.target.value = e.target.value.slice(0, e.target.selectionStart) + "." + e.target.value.slice(e.target.selectionEnd);
									e.preventDefault();
									return false; // Replace , for .
								} else {
									return true;  //Allow: valid separators
								}
							} else {	// Si ya hay un separador decimal ignorar
								e.preventDefault();
								return false;
							}
						}
          } else if (negativeSign.indexOf(key) >= 0 && attrs.allowNegative && e.target.selectionStart==0) {
            return true; //Allow: negative sign at first position if enabled
          } else if (key==8) {
            return true;  // Allow backspace (firefox)
          } else if (e.ctrlKey === true || e.metaKey === true) {
            return true;  // Allow (ignore) Ctrl key
          }
          e.preventDefault();
          return false;

        });

        scope.showCustomError = function(msg){
          simulateAPIError(scope.form, "atencion", [{ message: msg }]);
        };

        scope.clearCustomError = function(){
					if(angular.isDefined(scope.form)){
						scope.form.$invalid = false;
						delete scope.form.$error["atencion"];	
					}
        };
      }
    };
  }]);


  /**
   * Directiva validar que el valor d'un control sigui inferior al d'un altre. Per exemple, per dates.
   */
  angular.module('gp4helpers').directive('lowerThan', ['$timeout', '$log', 'cfg', '$filter', function($timeout, $log, cfg, $filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl){
        if (!ctrl) return;
        elem.on('focus', function (e) {
          if (ctrl.$modelValue) {
            e.target.value = ctrl.$modelValue;
          }
        });
        elem.on('keypress', function (e) {
          $timeout(function(){ scope.validar() }, 1);
        });

        scope.validar = function(){
          var value = attrs.lowerThan.split('.').reduce(function(a, b) {
            return a[b];
          }, scope);

          if(angular.isDefined(ctrl.$modelValue)){
            if(ctrl.$modelValue > value){
              //scope.form.$invalid = true;
              scope.form.$error.validacion = [];
              scope.form.$error.validacion.push({$name:"El tiempo no puede ser superior a " + $filter("date")(value, cfg.dateFormat)});
            } else {
              //scope.form.$invalid = false;
              scope.form.$error.validacion = [];
            }
          }
        }
      }
    }
  }]);


  /**
   * Directiva validar que el valor d'un control sigui superior al d'un altre. Per exemple, per dates.
   */
  angular.module('gp4helpers').directive('higherThan', ['$timeout', '$log', 'cfg', '$filter', function($timeout, $log, cfg, $filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl){
        if (!ctrl) return;
        elem.on('focus', function (e) {
          if (ctrl.$modelValue) {
            e.target.value = ctrl.$modelValue;
          }
        });
        elem.on('keypress', function (e) {
          $timeout(function(){ scope.validar() }, 1);
        });

        scope.validar = function(){
          var value = attrs.higherThan.split('.').reduce(function(a, b) {
            return a[b];
          }, scope);

          if(angular.isDefined(ctrl.$modelValue)){
            if(ctrl.$modelValue < value){
              //scope.form.$invalid = true;
              scope.form.$error.validacion = [];
              scope.form.$error.validacion.push({$name:"El tiempo no puede ser inferior de " +$filter("date")(value, cfg.dateFormat)});
            } else {
              //scope.form.$invalid = false;
              scope.form.$error.validacion = [];
            }
          }
        }
      }
    }
  }]);


  angular.module('gp4helpers').directive('ixGrid', [ function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        options : "@",
        height: "@"
      },
      templateUrl: 'app/base/views/helpers_templates/ixGrid.html'
    };
  }])

  angular.module('gp4helpers').directive('ixColor', [ function() {
    return {
      restrict: "E",
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngRequired: '='
      },
      controller: ['$scope', function($scope) {
        $scope.colors = getColors();
      }],
      templateUrl: 'app/base/views/helpers_templates/ixColor.html'
    };
  }])

  angular.module('gp4helpers').directive('ixSearchFromGrid', [ function(){
    return {
      restrict: 'E',
      require: '?ngModel',
      transclude: true,
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngRequired: '=',
        name: '@',
        validateFunction: '=',
        ngValueFunc: '=?',
        //La entidad sobre la que cargaremos la tabla y sus datos.
        entity: '@',
        //Guardará en ng-model la propiedad que se especifique cómo pk.
        pk: '@',
        //Opcionales:
        //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
        wholeObj: '=?',
        //permite especificar que columnas se quieren mostrar, independientemente de la metadata.
        showOnlyDescribedCols: '=?',
        conditions: '=?',
        filtersApi: '=?',
        filterApiBy: '@?',
        period: '@?',
        identifierName: '@?'
      },
      controller: [ '$scope', 'gridService', '$uibModal', 'ixStatusService', '$timeout', function($scope, gridService, $uibModal, ixStatusService, $timeout){
        $scope.openWindow = function(size){
          $scope.status = ixStatusService.current;
          $scope.data = ixStatusService.current.data;
          if(!$scope.gridBusqueda){
            var acciones = [
              {
                icon: "fa-eye",
                title: "Condiciones",
                accion: function(entity){
                  $scope.ngModel = entity[$scope.pk];
                  //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
                  setValue(entity);
                  $scope.wholeObj = entity;
                  //Mirem si té algún camp depenent, si és així l'actualitzem.
                  updateDependentFields(entity);
                  $scope.modalDialog.close();
                  return true;
                }
              }
            ];
            var visibleCols = ($scope.showOnlyDescribedCols) ? $scope.showOnlyDescribedCols : [];
            var filtersApi = ($scope.filtersApi) ? $scope.filtersApi : [];
            $scope.gridBusqueda = gridService.createGrid($scope, "searchFromGrid_"+$scope.entity+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, filtersAPI: filtersApi }, $scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
            $scope.gridBusqueda.filtroExterno = getAppliableConditions();
          } else {
            $scope.gridBusqueda = gridService.createGridFunctions($scope, $scope.gridBusqueda);
            $scope.gridBusqueda.ixRestoreConfig();
          }

          $scope.modalDialog = $uibModal.open({
            templateUrl: "ixSearchGridModal.html",
            scope: $scope,
            size: size,
            windowClass: 'megawhere-popup',
            backdrop: 'static',
            keyboard: false
          });

        };

        var setValue = function(entity){
          if(angular.isDefined($scope.ngValueFunc) && typeof $scope.ngValueFunc == "function"){
            $scope.ngValueFunc($scope, entity).then(function(response){
              $scope.ngValue = response.data;
            });
          } else {
            $scope.ngValue = $scope.ngModel;
          }
        };

        var getAppliableConditions = function(){
          var appliableConditions = [];
          if(angular.isDefined($scope.conditions)){
            appliableConditions = $scope.conditions.filter(function(condition){ return angular.isDefined(condition.value) && condition.value != null; });
          }
          return appliableConditions;
        };

        var updateDependentFields = function(entity){
          if(angular.isDefined($scope.conditions)){
            var auxConditions = angular.copy($scope.conditions);
            auxConditions.forEach(function(condition){
              var dField = angular.isDefined(condition.dependentField) ? condition.dependentField : condition.field;
              //TODO: Buscar tots els <ix-search-from-grid> i revissar que sempre que hi ha condicions aquestes s'apliquen a propietats dintre de $scope.data.datos.
              $scope.data[dField] = entity[condition.field];
            });
          }
        };

        if($scope.conditions) {
          $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
            if(!angular.equals(nv,ov)) {
              if(angular.isDefined($scope.gridBusqueda)){
                $scope.gridBusqueda.filtroExterno = getAppliableConditions();
                $scope.gridBusqueda.ixLoadInitialData();
              }
            }
          });
        }

        $scope.$watch('ngModel', function(nv, ov) {
          if(!angular.equals(nv,ov)) {
            $timeout(function(){
              setValue(undefined);
            },1);
          }
        });
      }],
      templateUrl: 'app/base/views/helpers_templates/ixSearchFromGrid.html'
    };
  }]);

  angular.module("gp4App").directive('ixNavbarResize', [ '$window', '$timeout', function($window,$timeout) {
	  return {
	    link: function(scope, el) {
	    	return;
	    }
	  }
	}]);

  angular.module("gp4App").directive('translateAttr', [ '$translate', function($translate){
    return {
      restrict: 'A',
      link: {
        pre: function (scope, elem, attrs) {
          var attribute = attrs.translateAttr,
              attributeValue = attrs[attribute];

          if (attributeValue) {
            $translate(attributeValue).then(function (translation) {
              //attrs.$set(attribute, translation[attributeValue]);
              attrs.$set(attribute, translation);
            });
          }
        }
      }
    };
  }]);

  angular.module("gp4App").directive('ixClearInput', [ '$compile', function($compile){
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function(scope, elem, attr, ngModelCtrl){
        var modelController = ngModelCtrl;

        var template = '<span ng-show="notEmpty() && !status.editing" class="input-group-addon icon" ng-click="clear()"><i class="fa fa-close fa-lg"></i></span>';
        elem.parent().append($compile(template)(scope));

        scope.clear = function(){
          elem.val("");
          modelController.$setViewValue("");
        }

        scope.notEmpty = function(){
          if(angular.isDefined(modelController.$viewValue)){
            return modelController.$viewValue.length > 0;
          }
          return false;
        }
      }
    }
  }]);

  angular.module("gp4App").directive('gridScrollShared', [ '$timeout', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, elem, attr){
        $timeout(function() {
          var gridToSync = angular.element("#" + attr['gridScrollShared']);
          var target = gridToSync.find('.ui-grid-viewport');
          var source = elem.find('.ui-grid-viewport');

          source.scroll(function (evt) {
            target.scrollLeft(angular.element(this).scrollLeft());
          });
        }, 200);
      }
    }
  }]);

  angular.module("gp4App").directive('ixPivotTotal', [ '$q', '$log', function($q, $log){
    return {
      restrict: 'EA',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        fields: '='
      },
      template: '<h3>Totales</h3><button ng-click="addTotal()">+</button><button ng-click="removeTotal()">-</button><div class="row" ng-repeat="total in ngModel track by $index"><div class="col-md-6"><ix-select ng-model="total.field" name="Campo" pk="campo" desc="nombre" load-function="listFields" load-all-items="true"></ix-select></div><div class="col-md-6"><ix-select ng-model="total.op" name="Operación" pk="operacion" desc="nombre" load-function="listOperations" load-all-items="true"></ix-select></div></div></div>',
      link: function(scope, elem, attr, ctrl){
        scope.addTotal = function(){
          var total = {};
          total.field = undefined;
          total.op = undefined;
          scope.ngModel.push(total);
        };

        scope.removeTotal = function(){
          scope.ngModel.pop();
        };

        scope.listFields = function(){
          var deferr = $q.defer();
          deferr.resolve({ data: Object.keys(scope.fields[0]).map(function(e){ return { campo: e, nombre: e }; }) });
          return deferr.promise;
        };

        scope.listOperations = function(){
          var deferr = $q.defer();
          deferr.resolve({ data: [ { operacion: 'count', nombre: 'Contar' }, { operacion: 'sum', nombre: 'Sumar' } ] });
          return deferr.promise;
        };
      }
    }
  }]);

  angular.module("gp4App").directive('ixBreadCrumb', [ '$log', '$filter', function($log, $filter){
    return {
      restrict: 'E',
      scope: {
        app: '=',
        menu: '='
      },
      template: "<span>{{ ::getBreadCrumb() }}</span>",
      link: function(scope, elem, attr){
				
        scope.setParentsMenu = function(menulevel, parent){
          angular.forEach(menulevel, function(level){
            if(angular.isDefined(parent)) level.parent = parent;
            if(angular.isDefined(level.children)) var existe = level.children.find(function(e){ return e == scope.app; });
            if(angular.isDefined(existe)){
              scope.itemInMenu = existe;
            }
            if(angular.isDefined(level.children)){
              scope.setParentsMenu(level.children, level);
            }
          });
        };
        scope.getBreadCrumb = function(){
          var breadcrumb = "";
          if(angular.isDefined(scope.itemInMenu)){
            return scope.generateBreadCrumb(scope.itemInMenu.parent, breadcrumb);
          } else {
            return "";
          }
        };

        scope.generateBreadCrumb = function(item, breadcrumb){
          if(angular.isDefined(item.parent)) breadcrumb = scope.generateBreadCrumb(item.parent, breadcrumb);
          breadcrumb = breadcrumb + $filter("translate")(item.display) + " > ";
					//breadcrumb = breadcrumb + item.display + " > ";
          return breadcrumb;
        }

        scope.setParentsMenu(scope.menu[0].children);
      }
    }
  }]);

  angular.module("gp4App").directive('ixFocusOut', [ '$timeout', function($timeout){
    return {
      restrict: 'A',
      link: function(scope, elem, attr){
        if(angular.isDefined(scope[attr.ixFocusOut]) && typeof scope[attr.ixFocusOut] == "function"){
          elem.on('focusout', { prop: attr.ixFocusOutParam, idx: attr.ixFocusOutParamIdx }, function(e){
						$timeout(function(){
							scope[attr.ixFocusOut](e);
						},250);
					});
        }
      }
    }
  }]);





  angular.module("gp4App").directive('captureKeyDown', [ function(){
    return {
      restrict: 'EA',
      link: function(scope, elem, attr){
        elem.on('keydown', function(e){
        });
      }
    }
  }]);


  angular.module("gp4App").directive('datepickerTimezone', [ function () {
    var directive = {
            restrict: 'A',
            require: ['ngModel'],
            link: link
        };
        return directive;

        function link(scope, element, attr, ctrls) {
            var ngModelController = ctrls[0];

            // called with a JavaScript Date object when picked from the datepicker
            ngModelController.$parsers.push(function (viewValue) {
							if(viewValue){
								// undo the timezone adjustment we did during the formatting
                viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
                // we just want a local date in ISO format
                return viewValue.toISOString().substring(0, 10);
							}
							else {
								return null;
							}
            });

            // called with a 'yyyy-mm-dd' string to format
            ngModelController.$formatters.push(function (modelValue) {
                if (!modelValue) {
                    return undefined;
                }

              var timeZoneOffset = modelValue.getTimezoneOffset();
              if(timeZoneOffset != -60 && modelValue.getHours() != 0){
                /*if(timeZoneOffset < 0){
                  //Modificar la fecha a las 00:00 del mismo dia.
                  //modelValue.setDate(modelValue.getDate() - 1);
                  //modelValue.setHours(0);
                  //modelValue.setMinutes(0);
                  //modelValue.setSeconds(0);
                  //modelValue.setMilliseconds(0);
                  //modelValue.setMinutes(modelValue.getMinutes() + (timeZoneOffset) - 60);
                } else */
                if(timeZoneOffset > 0) {
                  //Modificar la fecha a las 00:00 del dia siguiente.
                  modelValue.setDate(modelValue.getDate() + 1);
                  modelValue.setHours(0);
                  modelValue.setMinutes(0);
                  modelValue.setMilliseconds(0);
                }
              }

              return modelValue;
            });
        }
}]);

	angular.module('gp4helpers').directive('ixForm', [ '$http', 'cfg', function($http, cfg){
		return {
			restrict: 'EA',
			scope: {
				entity: '@'
			},
			controller: ['$scope', function($scope){
				var that = this;
        this.getMetadata = function(){
					if(angular.isDefined($scope.entity)){
						return $http.get(cfg.baseURL + "metadata/" + $scope.entity).then(function(response){
							that.metadataForm = response.data;
							return that.metadataForm;
						});
					}
				};

				if(!this.metadataForm){
					this.getMetadata();
				}
      }]
		}
	}]);

//
	angular.module('gp4helpers').directive('ixField', [ function() {
		return {
			restrict: 'A',
			priority: 10,
			require: ['^ixForm', 'ngModel'],
			link: function(scope, elem, attr, controllers){
				scope.getMaxLength = function(keyName){
					var ixFormController = controllers[0];
					if(angular.isDefined(ixFormController.metadataForm)){
						var obj = ixFormController.metadataForm.find(function(e){ return e.Name == keyName; });
						return obj.MaxLength;
					}
				};

				scope.isVisible = function(keyName){
					var ixFormController = controllers[0];
					if(angular.isDefined(ixFormController.metadataForm)){
						var obj = ixFormController.metadataForm.find(function(e){ return e.Name == keyName; });
						return !obj.NoVisible;
					}
				};
			}
		};
	}]);

angular.module("gp4App").directive('ixHint', [ '$compile', function($compile){
    return {
      restrict: 'A',
			priority: 10,
      link: function(scope, elem, attr){
				var label = angular.element(elem.find('label')[0]);
				//Para añadir icono o cualquier html.
				var styles = "color:#7878ff;";
				if(attr.floatLeft){
					styles += "position: relative; left: -4px; ";
				} else {
					styles += "margin: 0px 2px;";
				}
        var template = '<span style="'+ styles +'"><i class="fa fa-question-circle fa-lg"></i></span>';
				label.prepend(template);
				
				label.attr("title", attr.ixHint);
      }
    }
  }]);


	angular.module('gp4helpers').directive('ixPreviewImage', [ 'ixUtilsService', function(ixUtilsService) {
		return {
			restrict: 'E',
			scope: {
				src: '@',
				type: '@?'
			},
			templateUrl: 'app/base/views/helpers_templates/ixPreviewImage.html',
			link: function(scope, elem, attr){
				scope.type = scope.type || "image";
				scope.openPopup = function(){
					var template = "ixPreviewImageModal.html";
					var params = { src: scope.src };
					ixUtilsService.openModalV2(template, { controller: "ixPreviewImageController" }, "small", params);
				};
			}
		}
	}]);

	angular.module('gp4helpers').directive('ixPreviewPdf', [ 'ixUtilsService', function(ixUtilsService) {
		return {
			restrict: 'E',
			scope: {
				src: '@',
				name: '@'
			},
			templateUrl: 'app/base/views/helpers_templates/ixPreviewPDF.html',
			link: function(scope, elem, attr){
				scope.openPopup = function(){
					var template = "ixPreviewPDFModal.html";
					var params = { src: scope.src };
					ixUtilsService.openModalV2(template, { controller: "ixPreviewPDFController" }, "medium", params);
				};
			}
		}
	}]);



})();

/*eslint angular/no-private-call: 0*/
/*eslint angular/document-service: 0*/
angular.module('gp4helpers').directive('myTransitionEnd', ['$parse', 'ixStatusService', '$log', '$document', '$rootScope', '$timeout', function ( $parse, ixStatusService, $log, $document, $rootScope, $timeout ) {
  var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
  };

  var whichTransitionEvent = function () {
    var t,
      el = document.createElement("fakeelement");

    for (t in transitions) {
      if (angular.isDefined(el.style[t])){
        return transitions[t];
      }
    }
  };

  var transitionEvent = whichTransitionEvent();

  return {
    'restrict': 'A',
    'priority': 100,
    'link': function (scope, element, attrs) {
      var expr = attrs['myTransitionEnd'];
      var delayAnimation = attrs['delay'] || 1000;
      var fn = $parse(expr);

			var transitionEnd = function (evt) {
				if(!ixStatusService.current.transitionend){
          $log.log('got a css transition event', evt);

          if (scope.$root && !scope.$root.$$phase) {
            scope.finishedAnimation();
          }
        }
			};

      element.bind(transitionEvent, transitionEnd);

      scope.finishedAnimation = function(){
        //ixStatusService.current.transitionend = true;
        if(ixStatusService.current.realtransitionend != true)
        {
          $timeout(function(){
            $rootScope.$broadcast('splash_hide');
          },delayAnimation);
          ixStatusService.current.transitionend = true;
        }
        var phase = scope.$root.$$phase;

        if (phase === '$apply' || phase === '$digest') {
          fn();
        } else {
          scope.$apply(fn);
        }
      }
			//Forcem el trigger del transitionEvent passat un segon.
			//MS ha fet Edge més ràpid amb alguna actualització i quan acabava la transició encara no s'havia executat la linea que fa el bind del transitionEvent.
			$timeout(function(){
				element.trigger(transitionEvent);
			},1000);
    }
  };
 }]);

/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global CMP_ISNULL*/
/*global CMP_LIKENONE*/
/*global buildIxSearch*/
	angular.module('angular-virtual-select', ['vs-repeat']);
	angular.module('angular-virtual-select').directive('virtualSelect', ['$filter', '$document', '$timeout', '$http', 'cfg', 'uiGridEditConstants', 'ixStatusService', 'lodash', '$q', function($filter, $document, $timeout, $http, cfg, uiGridEditConstants, ixStatusService, _, $q) {
			return {
				restrict: 'AE',
				replace: true,
				require: '?ngModel',
				scope: {
					ngModel: '=',
					choicesRepeat: '=',
					filterBy: '=',
					placeholder: '=',
					displayProperty: '=',
					coreProperty: '=',
					singleselect: '=',
					multiselect: '=',
					limit: '=',
					onInputChange: '&',
					dynamicChoices: '=',
					allowCustom: '=?',
					allowCustomPriority: '=?',
					selectName: '=',
					localizeDisplayProperty: '=',
					blockModelUpdate: '=',
					ngDisabled: '=?',
					ngRequired: '=?',
					ngRequiredForm: '=?',

					//ix-select
					entity: '=',
					extraField: '=?',
					filterFields: '=?',
					preload: '=?',
					conditions: '=?',
					loadFunction: '=?',
					ngDefault: '=?',
					//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
					wholeObj: '=?',
					orderStringAsInt: '=?',
					//Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
					preloadFunction: '=?',
					//
					preloadObj: '=?',
					//La pk no sempre s'ha de dir igual que la del viewmodel.
					preloadPk: '=?',
					//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
					loadAllItems: '=?',
					//Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
					entityData: '=?',
					entityDataPk: '=?',
					entityDataDesc: '=?',
					onSelect: '=?',
					appendToBody: '=?',

					//Grid properties:

					dropdownInGrid: "=?",
					gridRow: "=?",
					gridCol: "=?",
					keyFields: "=?",
					lookupKeyFields: "=?",
					lookupOrders: "=?",
					template: "=?",
					minLengthToLoad: "=?",
					maxLength: "=?",
					skipTableNameFilter: '=?',
					skipTableNameOrderBy: '=?',
					tableAliasName: '=?',
					longerResultBox: '=?'
				},
				/*template: `<div class="virtual-select ui-select-container ui-select-multiple ui-select-bootstrap">
						<div class="ui-select-match">
							<span ng-repeat="item in selected track by $index">
								<span class="ui-select-match-item btn btn-primary btn-xs btn-sm">
									<span class="close ui-select-match-close" ng-click="removeItem(item)">&nbsp;&times;</span>
									<span>{{display(item)}}</span>
								</span>
							</span>
							<input type="text" class="ui-select-search" ng-model="searchText" ng-click="activate()" placeholder="{{ selected.length ? '' : placeholder}}">
						</div>
						<ul ng-if="opened && list" class="virtual-select-list-container ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu">
							<li class="virtual-scroll-container ui-select-choices-group" vs-repeat="{size: 48}">
								<div class="ui-select-choices-row btn-sm" ng-repeat="choice in list | virtualSelectfilterSelected:choice:selected track by $index" ng-click="itemClick(choice)">
									<a class="virtual-scroll-list-item ui-select-choices-row-inner"> <!-- ui-select layout -->
										<span>
											{{display(choice)}}
										</span>
									</a>
								</div>
							</li>
						</ul>
					</div>`,*/
				template: '<div class="virtual-select ui-select-container ui-select-multiple ui-select-bootstrap">' +
						'<div class="ui-select-match">' +
							'<span ng-if="!dropdownInGrid" ng-repeat="item in selected track by $index" style="width:calc(100% - 26px);">' +
								'<span class="ui-select-match-item" style="width:100%;" ng-click="focusInput()">' +
									'<span ng-if="!dropdownInGrid" style="display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;">{{display(item)}}</span>' +
								'</span>' +
							'</span>' +
							'<span ng-if="dropdownInGrid" style="width: calc(100% - 24px);" ng-click="forceInputFocus($event)" ng-dblclick="activate($event)">' +
								'<span class="ui-select-match-item" style="width:100%; margin:0;">' +
									'<span ng-if="dropdownInGrid" ng-bind="ngModelDescription" ng-init="gridfkUpdate(gridRow, gridCol);" style="min-height: 22px; margin-top: 3px; display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;"></span>' +
								'</span>' +
							'</span>' +
							'<input autocomplete="off" ng-click="forceInputFocus($event)" ng-dblclick="activate($event)" ng-disabled="ngDisabled" type="text" class="ui-select-search" ng-model-options="{\'updateOn\': \'default blur\',\'debounce\': {\'default blur\': 350 }}" ng-model="searchText" ng-keydown="checkActivateKeys($event)" placeholder="{{ selected.length ? \'\' : placeholder}}" maxlength="{{ allowCustom ? maxLength : 100}}">' +
							'<span ng-if="(!$parent.ngDisabled && !ngDisabled) && (!$parent.ngRequired && !ngRequired) && (!$parent.ngRequiredForm && !ngRequiredForm) && isSingleSelect() && ((ngModel != null && ngModel != \'\') || ($parent.ngModel != null && $parent.ngModel != \'\'))" class="icon close ui-select-match-close" ng-mousedown="clearSelected($event)">&nbsp;&times;</span>' +
							'<span ng-click="forceInputFocus($event)" ng-if="!ngDisabled" ng-mousedown="activate($event)" class"icon"><i ng-class="{ \'fa-angle-down\': (!opened), \'fa-angle-up\': (opened) }" class="fa fa-lg"></i></span>' +
						'</div>' +
						'<ul ng-if="opened" class="virtual-select-list-container ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu">' +
							'<li class="virtual-scroll-container ui-select-choices-group" ng-class="{ \'longer-result-box\': longerResultBox }">' +
								'<div ng-if="!template" class="ui-select-choices-row btn-sm" ng-repeat="choice in list | virtualSelectfilterSelected:choice:selected:this track by $index" ng-click="itemClick(choice)" ng-class="{active: highlighted == $index}">' +
									'<a class="virtual-scroll-list-item ui-select-choices-row-inner"> <!-- ui-select layout -->' +
										'<div>{{choice[displayProperty]}} <span ng-if="extraField || gridCol.colDef.LookUpResultFields.length == 3">/ {{choice[extraField] || choice[gridCol.colDef.LookUpResultFields[1]]}}</span></div>' +
										'<div ng-class="{ \'invisible\': cfg.dropdownSinCodigo }" class="text-muted">{{choice[coreProperty]}}</div>' +
									'</a>' +
								'</div>' +
								'<div ng-if="template" ng-include src="template"></div>' +
							'</li>' +
						'</ul>' +
					'</div>',
				link: function (scope, element, attrs) {
					scope.cfg = cfg;
					//Tecles:

					var cancellerCompleteLoad = {};

					var TAB_KEY = 9;
					var INTRO_KEY = 13;
					var ARROW_DOWN_KEY = 40;
					var ARROW_UP_KEY = 38;
					var ESCAPE_KEY = 27;
					var F4_KEY = 115;
					var SPACE_BAR_KEY = 32;

					//Status ixSelect:
					var JUST_LOADED = 0;
					var FIRST_LOAD_INIT = 1;
					var FIRST_LOAD_DONE = 2;
					var COMPLETE_LOAD_DONE = 3;

					var CELL_HEIGHT = 39;
					var RESULT_BOX_HEIGHT = 200;
					var RESULT_OPTION_HEIGHT = 38;

					var customOption = {};
					var calledFromItemClick = false;

					var input = angular.element(element.find('input')[0]);


					scope.forceInputFocus = function(ev){
						if(scope.dropdownInGrid){

							var isFocused = input.parent(".ui-grid-cell-focus");

							scope.focusInput();
							ev.preventDefault();
							if(angular.element(isFocused).hasClass("ui-grid-cell-focus"))
								ev.stopPropagation();
						}
					};
					
					scope.gridfkUpdate = function(row, col){
						//var itemWithDescription = $filter("gridfk")(input, scope.gridRow, scope.gridCol);
						scope.ngModelDescription = $filter("gridfk")(input, row, col);						
					};

					var clearHighlight = function(){
						scope.highlighted = -1;
					};

					//scope.firstLoadOrOpened = false;
					scope.dropdownStatus = JUST_LOADED;

					if(scope.preload) {
						$http.get(cfg.baseURL+scope.entity).then(function(r) {
							addToDropdown(r.data);
							clearHighlight();
							scope.choicesRepeat = r.data;
							if(!scope.dropdownInGrid){
								if (scope.list.length == 1) {
									//Si nomes hi ha un que quedi marcat
									//scope.ngModel = (scope.choicesRepeat[0][scope.coreProperty] !== 0) ? scope.choicesRepeat[0][scope.coreProperty] : null;
									//if(scope.ngModel != null) scope.wholeObj = scope.choicesRepeat[0];
									scope.itemClick(scope.list[0]);
								}
							}
						});
					}
					else {
						if(!scope.dropdownInGrid)
							scope.list = [];

						scope.lastSearch = "";

						scope.refreshDropdown = function(searchInInput){
							//input.focus();
							scope.refresh(searchInInput);
						};

						scope.refresh = function(searchText){
							if(!scope.minLengthToLoad || (scope.minLengthToLoad && searchText.length >= scope.minLengthToLoad)){
								if(angular.isDefined(scope.preloadFunction) && scope.dropdownStatus == JUST_LOADED && scope.changedConditions)
									scope.loadFromPreloadFunction();
								else if(angular.isDefined(scope.entityData) && angular.isDefined(scope.entityDataDesc) && scope.dropdownStatus == JUST_LOADED && scope.changedConditions)
									scope.loadFromEntityData();
								else
									scope.doCompleteLoad(searchText, false);
							}
						};

						scope.loadFromEntityData = function(){
							scope.dropdownStatus = FIRST_LOAD_DONE;
							var item = {};
							item[scope.coreProperty] = angular.isDefined(scope.entityDataPk) ? scope.entityData[scope.entityDataPk] : scope.entityData[scope.coreProperty];
							item[scope.displayProperty] = scope.entityData[scope.entityDataDesc];

							addToDropdown([item]);
							clearHighlight();
						};

						scope.doCompleteLoad = function(search, equal){
							var param = {Filters:[],OrderBy:[]};
							var operator = CMP_LIKE;
							if(equal) operator = CMP_LIKENONE;
							
							if(scope.lookupKeyFields){
								param.Filters = scope.lookupKeyFields.map(function (c, ii, aa) {
								//Filtrem per clau composta només quan té valor.
									if(ii!==scope.lookupKeyFields.length-1) {
										// no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
										// PREMISA: pos(KeyField)===pos(LookupKeyField).
										var tblName = "";
										if(!scope.skipTableNameFilter && scope.entity){
											tblName = scope.entity+".";
										}
										return {Field: tblName + c, Value: scope.gridRow.entity[scope.keyFields[ii]], Operator: CMP_EQ};
									}
								});
								param.Filters.pop();
							}

							if(!scope.dropdownInGrid && angular.isDefined(scope.entity) && !scope.skipTableNameFilter){
								param.Filters.push({StartPar:true, Field : scope.entity+"."+scope.displayProperty, Value : search, Operator : operator});
								param.Filters.push({Or: true, Field : scope.entity+"."+scope.coreProperty, Value : search, Operator : operator, EndPar:true});
							} else {
								param.Filters.push({StartPar:true, Field : scope.displayProperty, Value : search, Operator : operator});
								param.Filters.push({Or: true, Field : scope.coreProperty, Value : search, Operator : operator, EndPar:true});
							}

							var tblName = "";
							if(!scope.skipTableNameOrderBy){
								if(scope.tableAliasName)
									tblName = scope.tableAliasName + ".";
								else if(!scope.skipTableNameFilter && scope.entity)
									tblName = scope.entity + ".";
							}
							if(!scope.dropdownInGrid){
								if(angular.isDefined(scope.displayProperty)) param.OrderBy.push(tblName + scope.displayProperty);
							}
							else {
								param.OrderBy = scope.lookupOrders.map(function (o) {return (o.Desc ? "-" : "") + tblName + o.KeyField;});
							}

							if(scope.conditions) {
								scope.error = false;
								if(scope.dropdownInGrid){
									scope.conditions.forEach(function(cond) {
										if(angular.isUndefined(cond.Value)) scope.error = true;
										param.Filters.push({Field: cond.KeyField, Value: cond.Value, Operator : cond.Operator | CMP_EQ, Not : cond.Not | false, Skip: cond.Skip | false });
									});
								} else {
									scope.conditions.forEach(function(cond) {
										if(angular.isUndefined(cond.value)) scope.error = true;
										param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
									});
								}
							}

							if(angular.isDefined(cancellerCompleteLoad[scope.entity])){
								//console.log("Entity (" + new Date() + "): " + scope.entity);
								//console.log("cancellerCompleteLoad(" + new Date() + "): " + cancellerCompleteLoad);								
								cancellerCompleteLoad[scope.entity].resolve();								
							}
							cancellerCompleteLoad[scope.entity] = $q.defer();

							if(scope.loadFunction) {
								scope.loadingResults = true;
								if(scope.dropdownInGrid){
									scope.loadFunction({ selected: (scope.selected) ? scope.selected[0] : scope.selected, search: search }, scope.gridRow, param, cancellerCompleteLoad[scope.entity]).then(function(r){
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										var results = r.data.Items ? r.data.Items : r.data;
										//Si al buscar valor exacto solo se devuelve el item inventado, recuperamos los resultados cargados en la lista.
										if(equal && (results.length - countCustomOptions(results)) == 0)
											results = scope.list;
										if (!equal || (equal && results.length >0)){
											addToDropdown(results);
										}
										

										if(scope.moveBoxAfterLoad){
											moveBox();
										}

										clearHighlight();
										
										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										} else if (equal) {											
											var item = getItemMatchingWithSearchText(search);
											if(angular.isDefined(item))
												scope.$emit("changeSelectionByValue", item);
											else
												scope.$emit("changeSelectionByValue", results[0]);
										}
									});
								}
								else {
									return scope.loadFunction(param, search, scope.entity).then(function(r) {
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										var results = r.data.Items ? r.data.Items : r.data;
										if (!equal || (equal && results.length>0)){
											addToDropdown(results);
										}
										if(getAllowCustom()){
											addCustomOption();
										}

										//Filtrar los resultados aquí. Se hace por si el loadFunction hace un get sin tener en cuenta parámetros.
										if(angular.isDefined(scope.searchText)){
											//scope.choicesRepeat = r.data.Items ? r.data.Items : r.data;
											//initializeListIfNeeded();
											initialList = angular.copy(scope.list);
											filterBySearchText(scope.searchText, null);
										}

										clearHighlight();

										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										} else if (equal) {											
											var item = getItemMatchingWithSearchText(search);
											if(angular.isDefined(item))
												scope.$emit("changeSelectionByValue", item);
											else
												scope.$emit("changeSelectionByValue", results[0]);
										}	else if(getAllowCustom() && search != scope.searchTextAux && scope.list.length == 1 && scope.selected.length == 0 && !scope.opened){
											scope.itemClick(scope.list[0], true);
										}
									});
								}
							} else {
								if(!scope.error){
									scope.loadingResults = true;

									var requestPromise = $http({
										url: cfg.baseURL+scope.entity+"/Search?ItemsPerPage=100",
										data: param,
										timeout: cancellerCompleteLoad[scope.entity].promise,
										method: "POST"
									});

									//return $http.post(cfg.baseURL+scope.entity+"/Search?ItemsPerPage=100", param).then(function(r) {
									return requestPromise.success(function(r) {
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										//addToDropdown(r.data.Items);
										if (!equal || (equal && r.Items.length>0)){
											addToDropdown(r.Items);
										}
										if(getAllowCustom()){
											addCustomOption();
										}
										clearHighlight();

										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										}

										if (equal)
											scope.$emit("changeSelectionByValue", r.Items[0]);
										
										//TODO: Mirar si això dona alguna mena de problema.
										//if(!scope.dropdownInGrid)
											//scope.choicesRepeat = angular.copy(scope.list);
									}).error(function(r) {
										if (equal)
											scope.$emit("changeSelectionByValue", undefined);
									});
								}

							}
						};


					}

					scope.loadFromPreloadFunction = function(){
						return scope.preloadFunction().then(function(r) {
							scope.dropdownStatus = FIRST_LOAD_DONE;
							if(r.data != null){
								var obj = {};
								var objToSearch = angular.isDefined(scope.preloadObj) ? r.data[scope.preloadObj] : r.data;

								obj[scope.coreProperty] = angular.isDefined(scope.preloadPk) ? objToSearch[scope.preloadPk] : objToSearch[scope.coreProperty];

								if(scope.coreProperty != scope.displayProperty)
									obj[scope.displayProperty] = angular.isDefined(scope.preloadPk) ? objToSearch[scope.preloadPk + "nombre"] : objToSearch[scope.coreProperty + "nombre"];

								addToDropdown([obj]);
								clearHighlight();
							} else {
								scope.changedConditions = false;
							}
						});
					};

					scope.focusInput = function(){
						input.focus();
					};

					scope.loadSelectedItem = function(value){
						var param = buildIxSearch();
						param.Filters.push({ Field: scope.coreProperty, Value: value, Operator: CMP_EQ });
						/*angular.forEach(scope.conditions, function(condition){
							param.Filters.push({ Field: condition.field, Value: condition.value, Operator: condition.op || CMP_EQ, Skip: condition.skip | false });
						});*/

						scope.dropdownStatus = FIRST_LOAD_INIT;
						
						if(angular.isDefined(cancellerCompleteLoad[scope.entity])){
							//console.log("Entity - loadSelectedItem (" + new Date() + "): " + scope.entity);
							//console.log("cancellerCompleteLoad - loadSelectedItem (" + new Date() + "): " + cancellerCompleteLoad);
							cancellerCompleteLoad[scope.entity].resolve();								
						}							

						if(scope.loadFunction) {
							return scope.loadFunction(param, "", scope.entity).then(function(r) {
								scope.loadingResults = false;
								scope.dropdownStatus = COMPLETE_LOAD_DONE;
								var results = r.data.Items ? r.data.Items : r.data;
								addToDropdown(results);
								if(getAllowCustom()){
									addCustomOption();
								}
								if(angular.isDefined(scope.changeSelectionAfterLoad)){
									scope.changeSelectionAfterLoad(scope.searchTextAux);
								}
								clearHighlight();
							});
						} else {

							return $http.post(cfg.baseURL + scope.entity + "/Search?ItemsPerPage=1", param).then(function(r){
								scope.dropdownStatus = FIRST_LOAD_DONE;
								if(angular.isDefined(r.data.Items) && r.data.Items[0]){
									//scope.choicesRepeat.push(r.data.Items[0]);
									//scope.virtualSelectSelectedOption(r.data.Items[0]);
									addToDropdown(r.data.Items);
								}
							});
						}
					};

					var restoreSingleSelectedValue = function(){
						var newSelected = {};
						var foundOne = false;

						//Aixo no hauria de perque ser-hi, scope.selected es converteix en array en algun punt despres de fer la sel·lecció.
						//Si es troba a on i no fa falta que sigui array, podrem esborrar la linea següent:
						scope.selected = (angular.isArray(scope.selected)) ? scope.selected[0] : scope.selected;

						if(angular.isDefined(scope.selected)){
							if(scope.dropdownInGrid){
								var filteredList = scope.filterResultsByPK(angular.copy(scope.list));
								foundOne = restoreFromList(filteredList);
							} else {
								foundOne = restoreFromList(scope.list);
							}

							if (foundOne) {
								newSelected = foundOne;
							}
						}

						return newSelected;
					};

					var restoreFromList = function(list){
						var foundOne = false;
						if (scope.coreProperty) {
							foundOne = _.find(list, function (obj) {
								return _.isEqual(jsonsify(obj[scope.coreProperty]), jsonsify(scope.selected[scope.coreProperty]));
							});
						}
						else {
							foundOne = _.find(list, function (obj) {
								return _.isEqual(jsonsify(obj), jsonsify(scope.selected));
							});
						}
						return foundOne;
					};

					var restoreMultipleSelectedValues = function(){
						var newSelected = [];
						var foundOne = false;
						_.each(scope.selected, function (value) {

							if (scope.coreProperty) {
								foundOne = _.find(scope.list, function (obj) {
									return _.isEqual(jsonsify(obj[scope.coreProperty]), jsonsify(value[scope.coreProperty]));
								});
							}
							else {
								foundOne = _.find(scope.list, function (obj) {
									return _.isEqual(jsonsify(obj), jsonsify(value));
								});
							}

							if (foundOne) {
								newSelected.push(foundOne);
							}
						});
						return newSelected;
					};

					var optionNotInList = function(id){
						var itemInList = scope.list.find(function(e){ return e[scope.coreProperty] == id; });
						return angular.isUndefined(itemInList);
					};

					var addCustomOption = function(){
						if(Object.keys(customOption).length > 0){
							if(!getItemMatchingWithSearchText(customOption[scope.coreProperty]))
								scope.list.push(customOption);
							//scope.searchText = '';
						}
					};
					/*
					var pushSelectionIfNotPresent = function(arrayToInspect, valuesToExclude){
						var returnedItems, selectedItemsNotInNewList;
						//TODO: Si hi ha condicions, s'haurà de mirar també per aquelles condicions.
						if(scope.dropdownInGrid){
							returnedItems = addNotPresentOptions(arrayToInspect, valuesToExclude);
						}
						else {
							selectedItemsNotInNewList = _.differenceBy(arrayToInspect, valuesToExclude, scope.coreProperty);
							returnedItems = selectedItemsNotInNewList.concat(valuesToExclude);
						}
						return returnedItems;
					};

					var addNotPresentOptions = function(newOptions, existingOptions){
						var alreadyExistingOptions = getDuplicateds(newOptions, existingOptions);
						return existingOptions.concat(_.difference(newOptions, alreadyExistingOptions));
					};

					var getDuplicateds = function(newOptions, existingOptions){
						var duplicateds = [];
						//La idea es que no ens retorni objectes que tinguin la PK repetida.
						angular.forEach(existingOptions, function(existingOption){
							duplicateds = duplicateds.concat(duplicatedItems(existingOption, newOptions));
						});
						return duplicateds;
					};

					var duplicatedItems = function(existingOption, newOptions){
						return newOptions.filter(function(newOption){
							var isInArray = true;
							for(var i = 0; i < scope.lookupKeyFields.length; i++){
								var filter = scope.lookupKeyFields[i];
								if(newOption[filter] != existingOption[filter])
									isInArray = false;
							}
							return isInArray;
						});
					};
					*/

					var addToDropdown = function(dataResult){
						dataResult.forEach(function(res){
							if(res.ContextID)
								delete res.ContextID;
						});

						if(scope.changedConditions){
							scope.list = dataResult;
							//setSelectedOption();
							//TODO: Se podría hacer otra cosa, como por ejemplo mirar si en la lista hay algún elemento con la misma pk, de momento solamente vacíamos.
							if(scope.dropdownStatus == COMPLETE_LOAD_DONE && (scope.selected[0] && !scope.containsObject(scope.selected[0], dataResult) && !dataResult.find(function(e){ return e[scope.coreProperty] === scope.ngModel; })))
							{
								scope.ngModel = null;
								scope.gridfkUpdate(scope.gridRow, scope.gridCol);
							}
							scope.changedConditions = false;
						} else {
							//scope.list = pushSelectionIfNotPresent(dataResult, (scope.dropdownInGrid) ? angular.copy(scope.list) : scope.selected);
							scope.list = dataResult;
						}


						if(scope.orderStringAsInt){ scope.list.sort(sortByNumber) }
						/*if (scope.list.length == 1 && (scope.ngRequired || scope.ngRequiredForm)) {
							$timeout(function(){
								scope.itemClick(scope.list[0]);
							},1);
						} else */
						if(scope.list.length == 0 ) {
							// Si no n'hi ha cap esborrar valor
							scope.ngModel = null;
							scope.wholeObj = {};
							scope.selected = [];
						}
						//Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
						else if(angular.isUndefined(scope.ngModel) && angular.isDefined(scope.ngDefault)){
							scope.ngModel = scope.ngDefault;
							setSelectedOption();
						} else {
							//Esta linea se ha puesto porque cuando hay dropdowns que arrastran datos no se muestra el valor seleccionado.
							setSelectedOption();
						}
					};

					var sortByNumber = function(a, b){
						return a[scope.displayProperty] - b[scope.displayProperty];
					};

					if(scope.conditions) {
						scope.$watch(function() {return scope.conditions}, function(nv, ov) {
							if(!angular.equals(nv,ov)) {
								scope.changedConditions = true;
								scope.wholeObj = null;
								scope.refresh("");
							}
						});
					}

					scope.clearSelected = function(event){
						initializeListIfNeeded();
						if(singleselect){
							scope.selected = null;
						} else {
							scope.selected = [];
						}
						updateModel();
						scope.opened = false;
						clearHighlight();
						onChangeResult();
						event.stopPropagation();
					};

					scope.isSingleSelect = function(){
						return singleselect;
					};

					var setSelectedOption = function(){
						//var appliableOptions = angular.copy(initialList);
						//var appliableOptions = angular.copy(scope.choicesRepeat);
						var appliableOptions = (angular.isDefined(scope.list)) ? angular.copy(scope.list) : angular.copy(scope.choicesRepeat);
						if(scope.dropdownInGrid)
							appliableOptions = scope.filterResultsByPK(appliableOptions);

						var found = appliableOptions.find(function(e){ return e[scope.coreProperty] === scope.ngModel && e[scope.coreProperty]; });
						if(scope.wholeObj)
							scope.wholeObj = found;
						if(found)
							scope.selected = [found];
						//ERROR SCROLL GRID FIXED
						//Per algun motiu, el grid, al fer scroll està gravant també a l'scope de les lineas de sota el selected.
						else if(scope.ngModel == null && scope.selected)
							scope.selected = [];
					};

					//


					var singleselect = attrs.singleselect != null;
					var multiselect = attrs.multiselect != null;
					var dynamicChoices = attrs.dynamicChoices != null;
					var allowCustom = scope.allowCustom;

					clearHighlight();

					var inputChangeFunctionProvided = attrs.onInputChange;

					var jsonsify = function (target) {
						var jsonsified = target;

						if (target && typeof target == 'object') {
							jsonsified = angular.fromJson(angular.toJson(jsonsified));
						}

						return jsonsified;
					};

					if (!singleselect && !multiselect) {
						multiselect = true;
					}

					var initialList;

					var initialize = function () {

						initialList = angular.copy(scope.choicesRepeat);
						initialList = jsonsify(initialList);

						//scope.list = angular.copy(initialList);
					};
					//initialize();

					var initializeListIfNeeded = function(){
						if((!initialList) || initialList.length == 0)
							initialize();
						if((!scope.list) || scope.list.length == 0)
							scope.list = angular.copy(initialList);
					};

					var applyFilters = function () {
						if (scope.filterBy) {
							var haveSomeFilters = _.some(scope.filterBy, function (val) {
								return !_.isUndefined(val);
							});

							var newVal;

							if (haveSomeFilters) {
								newVal = angular.copy(initialList);
							}

							_.each(scope.filterBy, function (filterValue, filterName) {
								if (filterValue) {
									newVal = $filter(filterName)(newVal, filterValue);
								}
							});

							if (haveSomeFilters) {
								scope.list = newVal;
								initialList = scope.list;
							}
						}
					};
					/*
					scope.$watchCollection('choicesRepeat', function () {

						initialize();

						applyFilters();
						filterBySearchText(scope.searchText);

						if (!scope.blockModelUpdate) {
							restoreSelectedValues();
						}
					}, true);
					*/


					var restoreSelectedValues = function () {
						if (typeof scope.selected != 'undefined') {
							var newSelected = [];

							if(singleselect){
								newSelected = restoreSingleSelectedValue();
							} else {
								newSelected = restoreMultipleSelectedValues();
							}
							if(newSelected.length > 0){
								scope.selected = newSelected;
							}
							updateModel();
						}
					};

					scope.$watchCollection('filterBy', function(newValue, oldValue) {
						if (newValue) {
							if (!_.isEqual(newValue, oldValue)) {
								applyFilters();
							}
						}
					}, true);

					var convert = function (model) {
						var result = [];

						var initialListAux = angular.copy(scope.list);
						if(scope.dropdownInGrid){
							initialListAux = scope.filterResultsByPK(initialListAux);
						}

						if (typeof model != 'object') {
							var candidate = _.find(initialListAux, function (item) {
								var target = scope.coreProperty ? item[scope.coreProperty] : item;
								if (typeof target == 'object') {
									target = jsonsify(target);
								}

								return _.isEqual(target, model);
							});

							if (candidate != null) result.push(candidate);
						}
						else if (typeof model == 'object') {
							_.each(model, function (value) {
								var candidate = _.find(initialListAux, function (item) {
									var target = scope.coreProperty ? item[scope.coreProperty] : item;
									if (typeof target == 'object') {
										target = jsonsify(target);
									}

									return _.isEqual(target, value);
								});

								if (candidate != null) result.push(candidate);
							});
						}

						return result;
					};

					var convertDynamic = function (model) {
						var result = [];

						if (typeof model == 'string') {
							result.push(model);
						}
						else if (typeof model == 'object') {
							_.each(model, function (value) {
								result.push(value);
							});
						}

						return result;
					};

					scope.display = function (item) {
						/*if(!scope.selected)
							setSelectedOption();

						if(scope.selected){
							var item = scope.selected[0];
							var result = item;
							if (scope.displayProperty) {
								result = item[scope.displayProperty];
								if(scope.extraField && angular.isDefined(item[scope.extraField]))
									result += " / " + item[scope.extraField];
							}
							if (attrs.localizeDisplayProperty != null) {
								result = $filter('i18n')(result, scope.localizeDisplayProperty);
							}

							return result;
						}
						return null;*/
						if(!scope.dropdownInGrid){
							if (item != null) {
								var result = item;

								if (scope.displayProperty) {
									result = item[scope.displayProperty];
									if(scope.extraField && angular.isDefined(item[scope.extraField]))
										result += " / " + item[scope.extraField];
								}
								if (attrs.localizeDisplayProperty != null) {
									result = $filter('i18n')(result, scope.localizeDisplayProperty);
								}

								return result;
							}
							return null;
						}/* else {
							var itemWithDescription = $filter("gridfk")(item, scope.gridRow, scope.gridCol);
							if(angular.isUndefined(itemWithDescription) && scope.ngModel){
								//scope.ngModel = null;
							}
							return itemWithDescription || scope.ngModel;
						}*/
					};

					var updateModel = function () {
						var result = null;

						if(angular.isDefined(scope.selected) && scope.selected != null){
							if(singleselect){
								if (scope.coreProperty) {
									result = scope.selected[scope.coreProperty];
								}
								else {
									result = scope.selected;
								}
							} else {
								if (scope.selected && scope.selected.length) {
									if (scope.coreProperty) {
										result = scope.selected.map(function(el){ return el[scope.coreProperty]; });
									}
									else {
										result = scope.selected;
									}
								}
							}
						}
						if(!calledFromItemClick)
							scope.selected = convert(jsonsify(result));
						else
							scope.selected = [ angular.copy(scope.selected) ];
						if(scope.selected.length == 0) scope.ngModel = "";
						else scope.ngModel = result;
					};


					////

					//provar
					scope.highlight = function(index){
						if(index < -1){
							index = -1;
							scope.highlighted = index;
						}
						else {
							var length = scope.list.length;
							if (length){
								var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
								//scope.highlighted = scope.list.indexOf(scope.list[index]);
								//scope.highlighted = scope.list.indexOf(visibleElements[index]);
								scope.highlighted = visibleElements.indexOf(visibleElements[index]);
							}
						}
						scrollToHighlightedRegister();
					};

					var scrollToHighlightedRegister = function(){
						$timeout(function(){
							//scroll to element:
							var containerElement = angular.element(".virtual-select-list-container .virtual-scroll-container");
							containerElement.scrollTop(0);//set to top
							if(scope.highlighted > -1){
								var activeRowElement = angular.element('.ui-select-choices-row.active');
								var activeRowElementOffset = activeRowElement.offset();
								if(angular.isDefined(activeRowElementOffset)){
									//var activeRowElementTop = activeRowElementOffset.top;
									//var containerElementHeight = containerElement.height();
									var activeRowElementHeight = activeRowElement.height();
									//containerElement.scrollTop(activeRowElementTop - containerElementHeight);//then set equal to the position of the selected element minus the height of scrolling div
									containerElement.scrollTop(activeRowElementHeight * scope.highlighted);//then set equal to the position of the selected element minus the height of scrolling div
								}
							} else {
								containerElement.scrollTop(0);//set to top
							}
						},1);
					};

					var countCustomOptions = function(result){
						var customOptions = result.filter(function(e){ return e.specialFlag == -1 || e.id == -1 });
						return customOptions.length;
					};

					scope.checkActivateKeys = function(event){
						if(scope.opened){
							if(event.keyCode == ESCAPE_KEY){
								scope.searchText = '';
								//Tancar la llista sense sel·leccionar valor.
								if(scope.dropdownInGrid){
									scope.$emit('refreshCellFocus');
								}
								disposeElement();
							}
							else if(event.keyCode == ARROW_UP_KEY){
								//Tecla de flecha hacia arriba. Marcar opción superior
								scope.highlight(scope.highlighted - 1)
							}
							else if(event.keyCode == ARROW_DOWN_KEY){
								//Tecla de flecha hacia abajo. Marcar opción inferior
								scope.highlight(scope.highlighted + 1);
							}
							else if(event.keyCode == INTRO_KEY || event.keyCode == TAB_KEY){

								if(!scope.loadingResults){
									changeSelection();
								} else {
									scope.searchTextAux = angular.copy(scope.searchText);
									scope.changeSelectionAfterLoad = changeSelectionAfterLoad;
								}
								scope.searchText = '';
								if(scope.dropdownInGrid){
									scope.$emit('refreshCellFocus');
								}
								disposeElement();
							}
						}
						else {
							if(event.keyCode == SPACE_BAR_KEY){
								event.preventDefault();
							}
							if(event.keyCode == F4_KEY ||
								 anyNumberKey(event.keyCode) ||
								 anyLetterKey(event.keyCode) ||
								 event.keyCode == ARROW_DOWN_KEY ||
								 event.keyCode == SPACE_BAR_KEY){
								scope.activate(event);
							} else if((event.keyCode == INTRO_KEY || event.keyCode == TAB_KEY) && scope.searchText){
								scope.searchText = '';
							}
						}
						//TODO: Provar amb els grids que entra a dintre de la funció i que no fa el que fa al apretar les fletxes per evitar canvii de cel·la.
						//event.stopPropagation();
					};

					var anyNumberKey = function(keyCode){
						return (keyCode >= 96 && keyCode <= 105) || (keyCode >= 48 && keyCode <= 57);
					};

					var anyLetterKey = function(keyCode){
						return (keyCode >= 65 && keyCode <= 90);
					};

					var isDisabled = function(){
						if(scope.dropdownInGrid){
							return isCellDisabled();
						}
						else {
							return scope.ngDisabled;
						}
					};

					var isCellDisabled = function(){
						return scope.gridCol.grid.api.ix.disableField({row: scope.gridRow, col: scope.gridCol });
					};

					scope.filterResultsByPK = function(items){
						for(var i = 0; i < scope.keyFields.length - 1; i++){
							var keyField = scope.keyFields[i];
							var lookupKeyField = scope.lookupKeyFields[i];
							items = items.filter(function(e){ return e[lookupKeyField] == scope.gridRow.entity[keyField]; });
						}
						return items;
					};

					///

					scope.activate = function (event) {
						if(!scope.ngDisabled && !scope.opened){
							initializeListIfNeeded();
							input.focus();
							if (multiselect && scope.limit && scope.selected && (scope.limit <= scope.selected.length)) {
								return;
							}

							scope.opened = true;

							//if(scope.dropdownStatus == COMPLETE_LOAD_DONE && scope.searchText == "")
								//scope.refreshDropdown("");

							$timeout(function () {
								scope.$digest();
								if(scope.dropdownInGrid || scope.appendToBody)
									//TODO: Colocar la caja allí donde toque:
									input.focus();
									event.currentTarget = event.currentTarget.parentNode;
									putResultBoxCloseToClickedCell(event);
							}, 0);
						} else {

							disposeElement();
						}
					};

					var putResultBoxCloseToClickedCell = function(event){

						var clickedElement = angular.element(event.currentTarget);
						var clickedElementOffset = clickedElement.offset();

						var resultBox = angular.element("ul.virtual-select-list-container");
						if((scope.dropdownInGrid || scope.appendToBody) && angular.isDefined(resultBox[0])){
							resultBox[0].style.top = (clickedElement[0].offsetTop + clickedElement[0].offsetHeight) + "px";
							resultBox[0].style.left = clickedElement[0].offsetLeft + "px";
							resultBox[0].style.minWidth = clickedElement[0].clientWidth + "px";
							appendToBody(resultBox);
						}/* else {
							resultBox[0].style.top = clickedElementOffset.top + "px";
							resultBox[0].style.left = clickedElementOffset.left + "px";
						}*/

						//if(scope.appendToBody)
							//appendToBody(resultBox);

						scope.focused = false;
						scope.focused = true;
					};

					var appendToBody = function(htmlElement){
						htmlElement = setCoordinates(htmlElement);
						$document.find('body').append(htmlElement);
					};

					var setCoordinates = function(htmlElement){
						var bodyRect = $document.find('body')[0].getBoundingClientRect();
    				var elemRect = htmlElement[0].getBoundingClientRect();
    				var offsetTop = elemRect.top - bodyRect.top;
						var offsetLeft = elemRect.left - bodyRect.left;


						if(!isOutOfBodyRect(bodyRect, elemRect)){
							htmlElement[0].style.top = offsetTop + "px";
							htmlElement[0].style.left = offsetLeft + "px";
						} else {
							scope.initialTop = (offsetTop - RESULT_BOX_HEIGHT - CELL_HEIGHT);
							htmlElement[0].style.top = (offsetTop - RESULT_BOX_HEIGHT - CELL_HEIGHT) + "px";
							htmlElement[0].style.left = offsetLeft + "px";

							scope.moveBoxAfterLoad = true;
							if(scope.dropdownStatus != JUST_LOADED && !scope.loadingResults)
								moveBox();
						}

						return htmlElement;
					};

					var moveBox = function(){
						if(scope.opened){
							var numItems = scope.list.length;
							var resultBox = angular.element("ul.virtual-select-list-container");
							resultBox[0].style.top = (scope.initialTop) + "px";
							if(((angular.isDefined(scope.selected)) && scope.selected.length > 0)){
								var selected = false;
								for(var i = 0; i < scope.list.length; i++){
									var item = scope.list[i];
									if(angular.equals(item, scope.selected[0])){
										selected=true;
										break;
									}
								}
								if(selected)
									numItems--;
							}

							if(numItems < 6){
								if(numItems == 5)
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + 8)+ "px";
								else if(numItems > 0)
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + (RESULT_OPTION_HEIGHT * (5 - numItems)) + 8)+ "px";
								else
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + (RESULT_OPTION_HEIGHT * 5) + 8)+ "px";
							}
						}
					};

					var isOutOfBodyRect = function(bodyRect, elemRect){
						return (elemRect.y + RESULT_BOX_HEIGHT > bodyRect.height);
					};

					scope.$on('virtualScrollActivate', function (event, name) {
						if ((name == scope.selectName) && (name != null)) {
							scope.activate();
						}
						else if (name != scope.selectName) {
							disposeElement();
						}
					});

					scope.virtualSelectSelectedOption = function(value){
						//scope.selectedAfterLoad = true;
						if(singleselect){
							scope.selected = value;
						} else {
							if (!scope.limit || (scope.limit && scope.selected && (+scope.limit > scope.selected.length))) {
								scope.selected.push(value);
							}
						}
					};

					/*scope.$watch('opened', function (newVal, oldVal) {
						if (scope.selectName) {
							scope.$emit('vsSpecificOpenStateChange', {name: scope.selectName, val: newVal});
						}
						if(newVal == true && scope.dropdownStatus != COMPLETE_LOAD_DONE && !scope.preload) scope.refreshDropdown("");
					});*/

					scope.itemClick = function (choice, isDelayed) {
						var alreadySelected;
						if(singleselect){
							alreadySelected = _.isEqual(scope.selected, choice);
						} else {
							alreadySelected = _.find(scope.selected, function (item) {
								return _.isEqual(item, choice);
							});
						}

						if (!alreadySelected) {
							calledFromItemClick = true;
							if (singleselect) {
								//scope.selected = [ choice ];
								scope.selected = choice;
								updateModel();
							}
							else if (multiselect) {
								if (!scope.limit || (scope.limit && scope.selected && (+scope.limit > scope.selected.length))) {
									scope.selected.push(choice);
									updateModel();
								}
							}
						}

						if (!multiselect) {
							scope.opened = false;
						}

						if (!getAllowCustom() || (scope.selected && scope.selected.length)) {
							scope.searchText = '';
						}

						clearHighlight();
						onChangeResult();
						calledFromItemClick = false;
					};

					scope.removeItem = function (event, choice) {

						var ind = scope.selected && scope.selected.indexOf(choice);

						if (ind > -1) {
							scope.selected.splice(ind, 1);
							updateModel();
						}

						if (inputChangeFunctionProvided) {
							scope.onInputChange({text: ''});
						}

						event.preventDefault();
					};


					scope.removeSelection = function(event){
						scope.removeItem(event, scope.selected[0]);
					};

					var disposeElement = function (emptySearchText) {
						if(scope.searchText)
							scope.needsReload = true;

						scope.opened = false;

						if ((emptySearchText) || (!getAllowCustom()) || (scope.selected && scope.selected.length)) {
							scope.searchText = '';
						}

						$timeout(function () {
							scope.$digest();
						}, 0);
					};

					var onDocumentClick = function (event) {
						if (!element[0].contains(event.target)) {
							disposeElement(true);
						}
					};

					var changeSelection = function(){

						var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
						//si hay alguno marcado quedarse con ese.
						if(hasOptionHighlighted()){
							scope.itemClick(visibleElements[scope.highlighted]);
						} else if(scope.searchText){//si no, quedarse con el primero que coincida con el texto de busqueda, si no hay ninguno coge el primero de la lista.
							var matchingElement = getItemMatchingWithSearchText(scope.searchText);
							if(matchingElement)
								scope.itemClick(matchingElement);
							else
							{	
								//seleccionamos el primer item
								//scope.itemClick(visibleElements[0]);
								
								//ibran: aquí lanzaremos un search con IGUAL a scope.searchText del código								
								scope.doCompleteLoad(scope.searchText, true);								
							}
						}
					};
					
					scope.$on("changeSelectionByValue", function (ev, item) {
						var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
						if(angular.isUndefined(item))
							scope.itemClick(visibleElements[0]);										
						else
							scope.itemClick(item);										
					});

					var onChangeResult = function(){
						if(!calledFromItemClick)
							setSelectedOption();

						scope.searchText = '';
						if(scope.dropdownInGrid)
							scope.raiseAfterCellEdit = true;

						$timeout(function(){
							if(angular.isDefined(scope.onSelect)){
								if(singleselect){
									scope.onSelect(scope.selected[0], scope.ngModel);
								}
							}
						});
					};

					scope.$watch('opened', function (newVal, oldVal) {
						if (newVal) {
							$document[0].addEventListener('click', onDocumentClick, true);
						}
						else if (!_.isUndefined(newVal)) {
							$document[0].removeEventListener('click', onDocumentClick, true);
						}
						if (scope.selectName) {
							scope.$emit('vsSpecificOpenStateChange', {name: scope.selectName, val: newVal});
						}
						//ERROR SCROLL GRID FIXED
						//Per algun motiu, el grid, al fer scroll està gravant també a l'scope de les lineas de sota el selected.
						if(scope.selected && scope.ngModel == null)
							scope.needsReload = true;
						if(newVal == true && (scope.dropdownStatus != COMPLETE_LOAD_DONE && !scope.preload || scope.needsReload)){
							scope.needsReload = false;
							scope.refreshDropdown("");
						}
					});


					//Events per marcar la opció marcada al dropdown de formulari.
					if(!scope.dropdownInGrid){
						angular.element(input).bind('focus',function(e){
							angular.element(e.currentTarget.parentNode).addClass("focused");
							scope.focused = true;
						});

						angular.element(input).bind('blur',function(e){
							angular.element(e.currentTarget.parentNode).removeClass("focused");
							scope.focused = false;
						});
					}

					scope.$watch('ngModel', function (newVal, oldVal) {
						if(!scope.dropdownInGrid){
							//el dropdown está en un formulario.
							if (angular.isDefined(newVal) /*&& newVal != null*/ && (typeof newVal != 'object' || newVal == null /* && !newVal.length*/)) {
								if (!dynamicChoices && !getAllowCustom()) {
									scope.selected = convert(jsonsify(newVal));
									if(scope.selected.length == 0 && newVal != null/* && scope.dropdownStatus == JUST_LOADED*/){
										if(!scope.loadAllItems){
											if(angular.isDefined(scope.preloadFunction) && scope.dropdownStatus == JUST_LOADED)
												scope.loadFromPreloadFunction();
											else if(angular.isDefined(scope.entityData) && angular.isDefined(scope.entityDataDesc))
												scope.loadFromEntityData();
											else if(scope.dropdownStatus == JUST_LOADED || optionNotInList(newVal))
												scope.loadSelectedItem(newVal);
										}
										else
											scope.refresh("");
									}
								}
								else {
									if (typeof newVal == 'string') {
										scope.searchText = newVal;
										scope.forceLoad = true;
									}
									else {
										scope.selected = newVal;
									}
								}
							}
							else if(angular.isUndefined(scope.ngModel)){
								scope.selected = [];
							}
							else {
								if(angular.isDefined(scope.selected) && scope.selected.length > 0){
									if(singleselect){
										scope.list.push(scope.selected);
									} else {
										scope.list.push.apply(scope.list, scope.selected);
									}
								} else {
									scope.selected = [];
									scope.searchText = '';
								}
							}
						}
						else {
							//el dropdown está dentro de un grid
							//setSelectedOption();
							if(ixStatusService.current.editing && oldVal != newVal){
								if(scope.raiseAfterCellEdit){
									$timeout(function(){
										scope.raiseAfterCellEdit = false;									
										scope.$emit('raiseAfterCellEdit', { newVal: newVal, oldVal: oldVal} );									
										scope.gridfkUpdate(scope.gridRow, scope.gridCol);
									},1);
								} else {
									scope.gridfkUpdate(scope.gridRow, scope.gridCol);
								}
							}
						}
					});

					scope.containsObject = function(obj, list) {
						var i;
						for (i = 0; i < list.length; i++) {
							if (angular.equals(list[i], obj)) {
								return true;
							}
						}
						return false;
					};

					scope.$watch('searchText', function (newVal, oldVal) { // filter by search text
						if(angular.isDefined(newVal)){
							if(newVal != "" || oldVal != ""){
								filterBySearchText(newVal, oldVal);
								scope.searchTextChanged = true;
								if((scope.opened || typeof scope.opened == "undefined") && (!scope.preload || scope.forceLoad)){
									scope.forceLoad = false;
									if(getAllowCustom() && scope.forceLoad)
										scope.searchText = '';
									scope.refreshDropdown(newVal);
								}
							}
						}
					});

					var filterBySearchText = function (newVal, oldVal) {
						if (inputChangeFunctionProvided) {
							scope.onInputChange({text: newVal});
						}
						else if (newVal) {
							if (newVal != oldVal) {
								scope.list = _.filter(initialList, function (item) {
									var target = scope.displayProperty ? item[scope.displayProperty] : item;
									var targetID = scope.coreProperty ? item[scope.coreProperty] : item;
									
									var resultok = ((target && target.toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
										(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1));
									if(scope.extraField && !resultok){
										var targetExtraField = scope.extraField ? item[scope.extraField] : item;
										resultok = (targetExtraField && targetExtraField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);										
									}
									if(scope.filterFields && !resultok){
										var i;
										for (i = 0; i < scope.filterFields.length; i++) {
											var targetFilterField = item[scope.filterFields[i]];
											resultok = (targetFilterField && targetFilterField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);
											if(resultok)										
												i =  scope.filterFields.length;
										}
										/*
										for(var filterField of scope.filterFields) {
											var targetFilterField = item[filterField];
											resultok = (targetFilterField && targetFilterField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);
											if(resultok)										
												break;											
										}	
										*/									
									}
									return resultok;
									
									/*
									if(scope.extraField){
										var targetExtraField = scope.extraField ? item[scope.extraField] : item;
										return ((target && target.toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
											(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
											(targetExtraField && targetExtraField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1)
										);
									}
									else
										return ((target && target.toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
										(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1));
									*/
								});
							}
						}
						else {
							//scope.list = initialList || scope.list;
							scope.list = scope.list;
						}

						if (newVal && getAllowCustom()) {
							if(!scope.dropdownInGrid){
								buildCustomOption(newVal);
								//if (!scope.selected || !scope.selected.length) {
									//scope.ngModel = newVal;
								//}
							}
						}

						var scrollContainer = element[0].getElementsByClassName('virtual-scroll-container') && element[0].getElementsByClassName('virtual-scroll-container')[0];
						if (scrollContainer) {
							scrollContainer.scrollTo(0, 0); // fix issue with vs-repeat scroll
						}

						$timeout(function () {
							scope.$digest();
						}, 0);
					};

					var buildCustomOption = function(val){
						customOption.id = -1;
						customOption[scope.coreProperty] = val;
						if(angular.isDefined(scope.displayProperty) && scope.displayProperty != scope.coreProperty){
							customOption[scope.displayProperty] = val;
						}
					};

					var hasOptionHighlighted = function(){
						return (scope.highlighted != -1 && angular.isDefined(scope.list[scope.highlighted]));
					};

					var changeSelectionAfterLoad = function(searchText){
						
						scope.changeSelectionAfterLoad = undefined;
						if(scope.list && scope.list.length > 0){
							var itemMatching = getItemMatchingWithSearchText(scope.searchTextAux);

							if(itemMatching)
								scope.itemClick(itemMatching, true);
							else
								scope.doCompleteLoad(scope.searchTextAux, true);
						}						
						scope.searchTextAux = '';

					};

					var getItemMatchingWithSearchText = function(searchText){
						var itemMatching = scope.list.find(function(e){
							return (
								(angular.isNumber(e[scope.coreProperty]) && e[scope.coreProperty] == searchText) ||
								(!angular.isNumber(e[scope.coreProperty]) && e[scope.coreProperty].toString().toUpperCase() == searchText.toUpperCase()) ||
								(e[scope.displayProperty].toString().toUpperCase() == searchText.toUpperCase())
							)
						});

						if(((angular.isDefined(itemMatching))) && (angular.isDefined(itemMatching.specialFlag) || angular.isDefined(itemMatching.id))){
							if((itemMatching.specialFlag == -1 || itemMatching.id == -1) && scope.allowCustomPriority == false)
								itemMatching = undefined;
						}
						return itemMatching;
					};
					
					var getAllowCustom = function(){
						var result = allowCustom;
						if(angular.isFunction(allowCustom))
							result = allowCustom(scope.gridRow.entity);
						return result;
					};
					
					/** evento que se dispara en ui-grid **/
					if(scope.dropdownInGrid) {
						scope.$on('gridfkUpdate', function() {						
							scope.gridfkUpdate(scope.gridRow, scope.gridCol);
						});
					}
					scope.$on('$destroy', function() {
						$document.off('click', onDocumentClick);
					});
				}
			};
		}]);
	angular.module('angular-virtual-select').filter('virtualSelectfilterSelected', [ 'lodash', function(_) {
		return function(items, item, selected, scope) {			
			var textLength = (!scope.searchText) ? 0 : scope.searchText.length;
			if(scope.minLengthToLoad && scope.minLengthToLoad > textLength){
				return [];
			}
			else {			
				if(scope.dropdownInGrid && scope.keyFields.length > 0 && scope.lookupKeyFields.length > 0)
					items = scope.filterResultsByPK(items);

				if (!selected || !selected.length) {
					return items;
				}
				else {
					if(angular.isArray(selected)){
						return _.differenceBy(items, selected, scope.coreProperty);
					} else {
						return _.differenceBy(items, [ selected ], scope.coreProperty);
					}
				}			
			}
			//return items;
		};
	}]);

/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixSelectMultipleController',
['$scope','$http', '$timeout', 'cfg', '$log', 'ixUtilsService', function($scope, $http, $timeout, cfg, $log, ixUtilsService) {
  $scope.firstLoad = false;
	$scope.cfg = cfg;
  if($scope.preload) {
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $scope.allItems = r.data;
    });
  } else {
    $scope.allItems = [];
    $scope.lastSearch = "";
    $scope.refresh =  function($select, forceRefresh){
      var userInputItem = undefined;
      var search = $select.search;

			//Aqui podem afegir ho que l'usuari escriu al filtre com a opció de dropdown.
      if($scope.editableDropdown){
				//var list = angular.copy($scope.allItems),
				var FLAG = -1;
				//remove last user input
//				if(angular.isDefined(list)){
//					list = list.filter(function(item) {
//						return item.id !== FLAG;
//					});
//				}

				if (search) {
					//manually add user input and set selection
					userInputItem = {
						id: FLAG,
						description: search
					};
					userInputItem[$scope.pk] = search;
					userInputItem[$scope.desc] = search;


					//$select.selected = userInputItem;

					if(!$scope.optionInList(search)){
						$scope.allItems.push(userInputItem);
					}
				}

			}
      if($scope.allItems.length > 1 && !forceRefresh) return;

      $scope.lastSearch = search;
      if(!$scope.preload) {
        $scope.doCompleteLoad($select, search, userInputItem);
      }
    }

    $scope.filtrarResultados = function($select){
      return function(item){
        // Comparacion sin tener en cuenta acentos
        if (!$select.search || ixUtilsService.comparar(item[$scope.pk].toString(),$select.search) != -1 
            || ixUtilsService.comparar(item[$scope.desc].toString(),$select.search) != -1){
              return item;
        }
      }
    };


    $scope.doCompleteLoad = function($select, search, userInputItem){
      var param = {Filters:[],OrderBy:[]};

      if(angular.isDefined($scope.entity) && !$scope.skipTableNameFilter){
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.entity+"."+$scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.entity+"."+$scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.entity+"."+$scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      } else {
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      }

      if($scope.conditions) {
        $scope.error = false;
        $scope.conditions.forEach(function(cond) {
          if(angular.isUndefined(cond.value)) $scope.error = true;
		  param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
        });
      }

      if($scope.loadFunction) {
        return $scope.loadFunction(param, "", $scope.entity).then(function(r) {
          $scope.allItems = r.data.Items ? r.data.Items : r.data;
					if($scope.editableDropdown){
						$scope.addOptionIfNotExists(userInputItem);
						if($scope.allItems.length == 0 && $scope.wholeObj)
							$scope.addOptionIfNotExists($scope.wholeObj);
					}


//          if ($scope.allItems.length == 1 && !$scope.editableDropdown) {
//            //Si nomes hi ha un que quedi marcat
//            $scope.ngModel = [ $scope.allItems[0][$scope.pk] ];
//            $scope.wholeObj = $scope.allItems[0];
//          } else
					if($scope.allItems.length == 0 ) {
            // Si no n'hi ha cap esborrar valor
            $scope.ngModel = undefined;
          }
          //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
          else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //$scope.wholeObj = $scope.allItems.find(function(e){ })$scope.ngModel;
            $scope.wholeObj = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
          }
        });
      } else {
        if(!$scope.error){
          return $http.post(cfg.baseURL+$scope.entity+"/Search?ItemsPerPage=9999", param).then(function(r) {
            $scope.allItems = r.data.Items;
            if(angular.isDefined(userInputItem)) $scope.allItems.push(userInputItem);
            //Crearem la opció
            if($scope.editableDropdown && (angular.isDefined($scope.ngModel) && $scope.ngModel != null)){
              $select.search = $scope.ngModel;
              $scope.refresh($select);
            }
            if($scope.orderStringAsInt){ $scope.allItems.sort($scope.sortByNumber) }
//            if ($scope.allItems.length == 1) {
//              //Si nomes hi ha un que quedi marcat
//              //if($scope.ngRequired == true){
//                $scope.ngModel = [ $scope.allItems[0][$scope.pk] ];
//              //} else {
//                //$scope.ngModel = undefined;
//              //}
//            } else
							if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              if(angular.isDefined($scope.ngModel)){
                $scope.ngModel = null;
              }/* else {
                $scope.ngModel = undefined;
              }*/
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            }
          });
        }

      }
    };

		$scope.addOptionIfNotExists = function(userInputItem){
			var customOptionAdded = $scope.allItems.find(function(e){ return e.id === -1; });

			if(angular.isDefined(userInputItem) && angular.isUndefined(customOptionAdded))
				$scope.allItems.push(userInputItem);
		};

		$scope.optionInList = function(search){
			var found = $scope.allItems.some(function(e) {
				return (e[$scope.pk] == search || e[$scope.desc] == search);
			});

			return found;
		};

    if($scope.conditions) {
      $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
        if(!angular.equals(nv,ov)) {
          $scope.ngModel = undefined;
          $scope.refresh({ search: $scope.lastSearch }, true);
        }
      });
    }
  }

  $scope.onSelectOption = function($item, $model) {
    $scope.$apply(function() {
      $scope.wholeObj = $item;
    });
  };

  $scope.sortByNumber = function(a, b){
    return a[$scope.desc] - b[$scope.desc];
  };

  $scope.$watch("ngModel", function(value, oldVal){
    //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
    if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
      $scope.ngModel = $scope.ngDefault;
    }
		if(value){
			if($scope.commaSeparated){
				if(!$scope.ngModelFormatted)//Si aun no se ha definido la propiedad.
					$scope.ngModelFormatted = value.split(",");
				else if($scope.ngModelFormatted.length != value.split(",").length)//si se han añadido o quitado etiquetas
					$scope.ngModelFormatted = value.split(",");

				for(var i = 0; i < $scope.ngModelFormatted.length; i++){
					if(!isNaN($scope.ngModelFormatted[i]))
						$scope.ngModelFormatted[i] = parseInt($scope.ngModelFormatted[i]);
				}

			} else {
				$scope.ngModelFormatted = $scope.ngModel;
			}
		} else {
			$scope.ngModelFormatted = $scope.ngModel;
		}
  });

	$scope.$watch("ngModelFormatted", function(value, oldVal){
		if(value){
			if(value != oldVal){
				if($scope.commaSeparated)
					$scope.ngModel = $scope.ngModelFormatted.join(",");
				else
					$scope.ngModel = $scope.ngModelFormatted;
			}

		}
  });
}]);

/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixSelectController',
['$scope','$http', '$timeout', 'cfg', '$log', function($scope, $http, $timeout, cfg, $log) {
  $scope.firstLoadOrOpened = false;
  if($scope.preload) {
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $scope.allItems = r.data;
      if ($scope.allItems.length == 1) {
        //Si nomes hi ha un que quedi marcat
        $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
        if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
			}
    });
  }
  //Valorar si a alguna pantalla fa falta un preloadFunction.
  //S'ha de pensar que els preloads no paginen ni actualitzen valors quan s'escriu.
  //Si s'ha d'afegir es possarà aqui un else if($scope.preloadFunction) i es cridarà.
  else {
    $scope.allItems = [];
    $scope.lastSearch = "";
    $scope.refresh =  function($select){
			if($scope.skipNextRefresh){
				$scope.skipNextRefresh = false;
				return;
			}
      //serveix per actualitzar el nou valor sel·leccionat quan aquest canvi s'ha fet per alguna condició.
      if(angular.isDefined($select.selected) && angular.isDefined($scope.newSelected)){
        $select.selected = angular.copy($scope.newSelected);
        $scope.newSelected = undefined;
      }

      var userInputItem = undefined;
      var search = $select.search;

      //Aqui podem afegir ho que l'usuari escriu al filtre com a opció de dropdown.
      if($scope.editableDropdown == true){
        var list = angular.copy($select.items),
        FLAG = -1;
        //remove last user input
        if(angular.isDefined(list)){
          list = list.filter(function(item) {
            return item.id !== FLAG;
          });
        }

        if (search) {
          //manually add user input and set selection
          userInputItem = {
            id: FLAG,
            description: search
          };
          userInputItem[$scope.pk] = search;
          userInputItem[$scope.desc] = search;

          var found = $scope.allItems.some(function(e) {
            return e.id == userInputItem.id;
          });

					$select.selected = userInputItem;

          if(!found){
            $scope.allItems = [userInputItem].concat(list);
          }
        }
      }
      if(($scope.firstLoadOrOpened) && ($scope.ngModel) && !$scope.editableDropdown && !$scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; })){
        $scope.loadFirst($select, search);
        return;
      }
      if(($scope.countNotEmpties() > 1 || $scope.countNotEmpties() == 1 && manuallyAddedOptionSelection($select)) && (!$scope.conditions || $scope.conditions && !$scope.changedConditions) && $scope.lastSearch == search && !$scope.justLoaded){
				return;
			} else {
				$scope.lastSearch = search;
				if(!$scope.preload) {

					//1: Per defecte ensenyarà el valor que té marcat.
					//Com només arriva la clau, hem de fer un search per obtenir la descripció
					//S'ha de tenir en compte de manera general les condicions. Les quals serviràn per filtrar.
					if(!$scope.firstLoadOrOpened && !$scope.loadAllItems){
						$scope.doFirstLoad($select, search);
					}

					//2: Primera càrrega de resultats: Es farà la primera càrrega al obrir el dropdown.
					//i
					//3: Ja ha sigut carregat i té resultats però s'ha de refrescar. O bé perquè té filtres (conditions) o perquè s'està filtrant pel camp de text.
					else {
						$scope.doCompleteLoad($select, search, userInputItem);
					}
					if($scope.justLoaded) $scope.justLoaded = false;
				}
			}
    }

    $scope.doFirstLoad = function($select, search){
      //s'utilitza a pantalles que tenen molta càrrega, per exemple, les d'entrades manuals, assignacio,.., fitxa d'operativa,...
      //el nom està mal possat, mes que preloadFunction ve a ser un loadFromModelFunction ja que està pensat per carregar les dades després d'un get que retorni un objecte complex.
      if($scope.preloadFunction){
        return $scope.preloadFunction().then(function(r) {
          $scope.firstLoadOrOpened = true;
          if(r.data != null){
            var obj = {};
            obj[$scope.pk] = angular.isDefined($scope.preloadPk) ? r.data[$scope.preloadPk] : r.data[$scope.pk];
            obj[$scope.desc] = angular.isDefined($scope.preloadPk) ? r.data[$scope.preloadPk + "nombre"] : r.data[$scope.pk + "nombre"];

            //Si el valor ha sigut modificat en pantalla i tornem a entrar a la pantalla desde l'escriptori l'ensenyem en comptes de l'inicial.
            if(angular.isDefined($scope.ngModel) && $scope.ngModel != obj[$scope.pk]){
              $scope.loadFirst($select, search);
            } else {
              if(angular.isDefined($scope.extraField)){
                obj[$scope.extraField] = r.data[$scope.extraField];
              }

              //Pot ser que el viewmodel no porti algun paràmetre o aquest sigui null.
              //Si és així, deixem allItems buit. D'aquesta manera veurem el placeholder.
              if(angular.isDefined(obj[$scope.pk]) && obj[$scope.pk] != null){
                $scope.allItems = [obj];
              }
              if ($scope.allItems.length == 1) {
                //Si nomes hi ha un que quedi marcat
                $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
                if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
              } else if($scope.allItems.length == 0 ) {
                // Si no n'hi ha cap esborrar valor
                $scope.ngModel = undefined;
              }
              //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
              else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
                $scope.ngModel = $scope.ngDefault;
              } else {
                $scope.wholeObj = obj;
              }
            }
          }
        });
      } else {
        $scope.loadFirst($select, search);
      }
    };

    $scope.loadFirst = function($select, search){
      if($scope.ngModel != null){
        if(angular.isDefined($scope.entityData) && angular.isDefined($scope.entityDataDesc)){
          $scope.firstLoadOrOpened = true;
          $scope.allItems = [];
          var item = {};
          item[$scope.pk] = angular.isDefined($scope.entityDataPk) ? $scope.entityData[$scope.entityDataPk] : $scope.entityData[$scope.pk];
          item[$scope.desc] = $scope.entityData[$scope.entityDataDesc];

          var found = $scope.allItems.some(function(e) {
            return angular.equals(e,item);
          });

          if(!found){
            $scope.allItems.push(item);
          }
        }
        else if(angular.isUndefined($scope.loadFunction)){
          var param = buildIxSearch();
          param.Filters.push({ Field: $scope.pk, Value: $scope.ngModel, Operator: CMP_EQ });
          angular.forEach($scope.conditions, function(condition){
            param.Filters.push({ Field: condition.field, Value: condition.value, Operator: condition.op || CMP_EQ });
          });

          return $http.post(cfg.baseURL + $scope.entity + "/Search?ItemsPerPage=1", param).then(function(r){
            $scope.firstLoadOrOpened = true;
						$scope.justLoaded = true;
            //$scope.allItems = r.data.Items;
            //$scope.allItems.push.apply($scope.allItems, r.data.Items);

            r.data.Items.forEach(function(result){
              var found = $scope.allItems.some(function(e) {
                //return angular.equals(e,result);
                return e[$scope.pk] == result[$scope.pk];
              });

              if(!found){
                $scope.allItems.push(result);
              }
            });

						$scope.allItems = $scope.getNotEmpties();

            if ($scope.allItems.length == 1) {
              //Si nomes hi ha un que quedi marcat
              $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
              if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
            } else if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              $scope.ngModel = undefined;
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            } else {
              $scope.wholeObj = r.data;
            }
          });
        } else {//20180112: Si algun dropdown de formulari fa el tonto, revissar aquest else. La seva raó de ser es la de recarregar el dropdowns de traspassos al guardar canvis.
          $scope.doCompleteLoad($select, search, undefined);
        }
      } else {
        //Aquest push fa que allItems tingui alguna cosa i per tant inicialitza el html de la directiva, fent que no perdi caràcters al escriure al inici.
        //$scope.firstLoadOrOpened = true;
        var containsVacio = $scope.allItems.find(function(e){ return e.pk == ""; });
        if(!containsVacio) $scope.allItems.push({pk:'',desc:''});
      }
    };

    $scope.doCompleteLoad = function($select, search, userInputItem){
      var param = {Filters:[],OrderBy:[]};

      if(angular.isDefined($scope.entity)){
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.entity+"."+$scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.entity+"."+$scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.entity+"."+$scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      } else {
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      }

      if($scope.conditions) {
        $scope.error = false;
        $scope.conditions.forEach(function(cond) {
          if(angular.isUndefined(cond.value)) $scope.error = true;
          param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
        });
      }

      if($scope.loadFunction) {
        return $scope.loadFunction(param).then(function(r) {
          $scope.allItems = r.data.Items ? r.data.Items : r.data;
          if ($scope.allItems.length == 1) {
            //Si nomes hi ha un que quedi marcat
            $scope.ngModel = $scope.allItems[0][$scope.pk];
            $scope.wholeObj = $scope.allItems[0];
          } else if($scope.allItems.length == 0 ) {
            // Si no n'hi ha cap esborrar valor
            $scope.ngModel = undefined;
          }
          //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
          else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //$scope.wholeObj = $scope.allItems.find(function(e){ })$scope.ngModel;
            $scope.wholeObj = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
          }

          //Forcem el focus.
          if(angular.isDefined($select) && angular.isDefined($select.focusSearchInput)) $select.focusSearchInput();
        });
      } else {
        if(!$scope.error){
          return $http.post(cfg.baseURL+$scope.entity+"/Search?ItemsPerPage=10", param).then(function(r) {
            if($scope.changedConditions && $scope.allItems.length == 1)
              $scope.allItems.push.apply($scope.allItems, r.data.Items);
            else
              $scope.allItems = r.data.Items;
            if(angular.isDefined(userInputItem) && $scope.allItems.indexOf(userInputItem) == -1) $scope.allItems.push(userInputItem);
            //Crearem la opció
            //if($scope.editableDropdown && (angular.isDefined($scope.ngModel) && $scope.ngModel != null)){
              ////$select.search = $scope.ngModel;
              //if(((angular.isDefined($select.selected))) && (angular.isUndefined($select.selected.id) || (angular.isDefined($select.selected.id) && $select.selected.id != -1)))
                //$scope.refresh($select);
            //}
            if($scope.orderStringAsInt){ $scope.allItems.sort($scope.sortByNumber) }
            if ($scope.allItems.length == 1) {
              //Si nomes hi ha un i es obligatori que quedi marcat
              if($scope.ngRequired == true){
                $scope.ngModel = $scope.allItems[0][$scope.pk];
              } //else {
                //$scope.ngModel = undefined;
              //}
            } else if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              if(angular.isDefined($scope.ngModel)){
                $scope.ngModel = null;
              }/* else {
                $scope.ngModel = undefined;
              }*/
            } else if($scope.changedConditions && angular.isDefined($scope.ngModel)){
              $scope.changedConditions = false;
              //Mirem si el conjunt d'opcions retornat conté el valor. Si no és així el netejem.
              var found = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
              if(angular.isDefined(found)){
                $scope.newSelected = found;
              } else {
                $scope.ngModel = null;
              }
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            }

            //Forcem el focus.
            if(angular.isDefined($select) && angular.isDefined($select.focusSearchInput)) $select.focusSearchInput();
          });
        }

      }
    };

    if($scope.conditions) {
      $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
        if(!angular.equals(nv,ov)) {
          //$scope.ngModel = undefined;
          $scope.changedConditions = true;
          //$scope.ngModel = null;
          $scope.wholeObj = null;
          $scope.refresh({ search: $scope.lastSearch });
        }
      });
    }
  }

  $scope.onSelectOption = function($item, $model) {
		if(angular.isDefined($item)){
			if(angular.isDefined($item.id) && $item.id == -1){
				$scope.skipNextRefresh = true;
			}
		}
    $scope.$apply(function() {
      //Hi havia casos en que, quan l'atribut preload era true, el dropdown desmarcava el valor sel·leccionat i deixava marcat l'anterior.
			//if($scope.preload){
				$scope.ngModel = $item[$scope.pk];
			//}
      $scope.wholeObj = $item;
    });
  };

  $scope.sortByNumber = function(a, b){
    return a[$scope.desc] - b[$scope.desc];
  };

  $scope.onOpenCloseDropdown = function(isOpen) {
    if(isOpen) $scope.firstLoadOrOpened = true;
  };

  $scope.countNotEmpties = function(){
    var notEmpties = $scope.allItems.filter(function(e){ if(angular.isDefined(e)){ return e[$scope.pk] !== "" && e.pk !== ""; } });
    return notEmpties.length;
  };

	$scope.getNotEmpties = function(){
    var notEmpties = $scope.allItems.filter(function(e){ if(angular.isDefined(e)){ return e[$scope.pk] !== "" && e.pk !== ""; } });
    return notEmpties;
  };


  $scope.$watch("ngModel", function(value){
    if(angular.isDefined(value) && !$scope.firstLoadOrOpened && !$scope.preloadFunction && !$scope.preload){
      //Si durant el moment de la primera càrrega, el ng-model no tenia valor, no ha fet el Search. Farem el Search del item sel·leccionat ara.
      $scope.refresh({ search: $scope.lastSearch });
    } else if(angular.isDefined(value) && value != null && !$scope.preloadFunction && !$scope.preload){//TODO: Afegir al else if aquest, que faci el refresh si l'item no està a $scope.allItems.
      //$scope.firstLoadOrOpened = false;
      $scope.refresh({ search: $scope.lastSearch });
    }
    //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
    if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
      $scope.ngModel = $scope.ngDefault;
    }
  });

	var manuallyAddedOptionSelection = function($select){
		if(angular.isDefined($select.selected)){
			if((angular.isDefined($select.selected) && $select.selected != null) && $select.selected.id == -1){
				return true;
			}
			return false;
		}
		return false;
	};

}]);

/*eslint angular/document-service:0*/
angular.module("gp4App").controller('ixPreviewPDFController', [ '$scope', '$uibModalInstance', '$location', function($scope, $uibModalInstance, $location){
	$scope.src = $scope.$resolve.src;

	var protocol = $location.protocol();
	var host = $location.host();
	var port = $location.port();
	$scope.urlPDF = protocol + "://" + host + ":" + port + "/assets/documents/" + $scope.src;

	$scope.downloadFile = function(src){
		var link = document.createElement("a");
		link.download = src;
		link.href = "assets/documents/"+src;
		link.click();
	};
}]);

/*eslint angular/document-service:0*/
angular.module("gp4App").controller('ixPreviewImageController', [ '$scope', '$uibModalInstance', function($scope, $uibModalInstance){
	$scope.src = $scope.$resolve.src;

	$scope.downloadFile = function(src){
		var link = document.createElement("a");
		link.download = src;
		link.href = "assets/images/"+src;
		link.click();
	};
}]);

/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global CMP_EQ*/
angular.module("gp4App").controller('ixCellValorDefController',
[ "$scope", "$q", "ivhTreeviewMgr", "cfg", "ixStatusService", "ixUtilsService", "$http", "$uibModalInstance", "$timeout", "$filter",
function($scope, $q, ivhTreeviewMgr, cfg, ixStatusService, ixUtilsService, $http, $uibModalInstance, $timeout, $filter) {
  $scope.entity = $scope.$resolve.entity;
  $scope.columnType = $scope.$resolve.column.type;
  $scope.control = $scope.$resolve.column.control;


  $scope.filtro_periodo = [];

  $scope.filtro = $scope.$resolve.filtro == null ? undefined : $scope.$resolve.filtro;
  if(($scope.columnType == "date" && typeof $scope.filtro == "string") && $scope.filtro.lastIndexOf("*") != -1){
    $scope.filtroespecial = $scope.filtro;
  }

  $scope.filterOp = $scope.$resolve.filterOp;
  $scope.singleOption = angular.isDefined($scope.$resolve.singleOption) ? true : false;
  $scope.hideSelectionMode = angular.isDefined($scope.$resolve.hideSelectionMode) ? $scope.$resolve.hideSelectionMode : false;

  $scope.filterSearchfiltro = function(value) {
    return ixUtilsService.comparar(value.label,$scope.searchfiltro) !== -1;
  }

  $scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchfiltro != null){
      angular.forEach($scope.listOfValues, function(value){
        if(ixUtilsService.comparar(value.label,$scope.searchfiltro) !== -1){
          matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.deselectAll = function() {
		$scope.searchfiltro = "";
    ivhTreeviewMgr.deselectAll($scope.listOfValues);
  };

  $scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){
    if($scope.singleOption){
      if(ivhIsSelected){
        ivhTreeviewMgr.selectAll($scope.listOfValues);
        ivhTreeviewMgr.deselectAll($scope.listOfValues);
        ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);
      }
    }
  };

  $scope.processData = function(){
    //Mirem si hem de canviar el operador.
    if($scope.filtro == "#value" || $scope.filtro == "#empty"){
      $scope.filterOp = CMP_ISNULL;
      $scope.listOfValues = undefined;
    }
    $uibModalInstance.close({ filtro: $scope.filtro, filtros: $scope.listOfValues, op: $scope.filterOp, filtro_periodo: $scope.filtro_periodo });
  };


  //
  $scope.loadSelectableOptions = function(column, filtroObj){
      var selected = false;
      var listOfValues = [];
      var deferred = $q.defer();
      if(angular.isDefined(column) && angular.isDefined(column.Search) && column.Search != null){
        if(angular.isDefined(column.options)){
          if(column.options != null){
            column.options.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = (filtroObj == item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]]);
              }
              //listOfValues.push({id:item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]], label:item.nombre, selected:selected, children:[]});
              var id = item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]];
              var label = "";
              for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                var key = column.Search.LookUpResultFields[i];
                label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
              }
              listOfValues.push({id:id, label:label, selected:selected, children:[]});
            });
            $timeout(function(){
              return deferred.resolve(listOfValues);
            },0);
          }
        } else {
          $http.get(cfg.baseURL + column.Search.LookUpTableName).then(function(r){

            if(r.data != null){
              //Mirem si té alguna condició per aplicar-la al conjunt de resultats.
              if(angular.isDefined(column.Search.LookUpConditions) && column.Search.LookUpConditions.length > 0){
                angular.forEach(column.Search.LookUpConditions, function(condition){
                  //Fem filters de r.data fins que s'hagin comprovat totes les condicions.
                  r.data = r.data.filter(function(e){ return e[condition.KeyField] == condition.Value; });
                });
              }
              column.Search.LookUpOrders.forEach(function(order){
                r.data = $filter("orderBy")(r.data, order.KeyField, order.Desc);
              });
              column.options = r.data;
              r.data.forEach(function(item){
                selected = false;
                if(angular.isDefined(filtroObj)){
                  selected = (filtroObj == item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]]);
                }
                //listOfValues.push({id:item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]], label:item.nombre, selected:selected, children:[]});

                var id = item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]];
                var label = "";
                for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                  var key = column.Search.LookUpResultFields[i];
                  label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                  if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
                }
                listOfValues.push({id:id, label:label, selected:selected, children:[]});

              });
              return deferred.resolve(listOfValues);
            }
          });
        }
      }
      return deferred.promise;
    };

  //

  //var columna = $scope.data.metadata.find(function(e){ return e.name.toLowerCase() == $scope.entity.campo.toLowerCase(); });//Si al provar els traspassos dona un error
  var columna = $scope.$resolve.column;//si provant els traspassos dona error, comentar aquesta línea i descomentar la de la fila de dalt.
  $scope.loadSelectableOptions(columna, $scope.filtro).then(function(data){
    $scope.listOfValues = data;
  });
}]);

/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixCellFiltroController',
[ "$scope", "$q", "ivhTreeviewMgr", "cfg", "ixStatusService", "ixUtilsService", "$http", "$uibModalInstance", "$timeout", "$filter",
function($scope, $q, ivhTreeviewMgr, cfg, ixStatusService, ixUtilsService, $http, $uibModalInstance, $timeout, $filter) {
  $scope.entity = $scope.$resolve.entity;
  $scope.columnType = $scope.$resolve.column.type;
  $scope.control = $scope.$resolve.column.control;
  $scope.gridEntity = $scope.$resolve.gridEntity;


  $scope.filtro_periodo = [];

  $scope.filtro = $scope.$resolve.filtro == null ? undefined : $scope.$resolve.filtro;
  angular.forEach($scope.filtro, function(filtro, i){
    if(($scope.columnType == "date" && typeof filtro == "string") && filtro.lastIndexOf("*") != -1){
      $scope.filtro_periodo[i] = filtro;
    }
  });
  if(($scope.columnType == "date" && typeof $scope.filtro == "string") && $scope.filtro.lastIndexOf("*") != -1){
    $scope.filtroespecial = $scope.filtro;
  } else if($scope.columnType == "number"){
    if(angular.isUndefined($scope.filtro)){//Si es de tipus numeric, s'ha de mostrar un rang desde / hasta, inicialitzem els valors del filtre ja que sino no es mostrarà el 2on input.
      $scope.filtro = [];
      $scope.filtro[0] = "";
      $scope.filtro[1] = "";
    }
  }

  $scope.filterOp = $scope.$resolve.filterOp;
  $scope.singleOption = angular.isDefined($scope.$resolve.singleOption) ? true : false;
  $scope.hideSelectionMode = angular.isDefined($scope.$resolve.hideSelectionMode) ? $scope.$resolve.hideSelectionMode : false;

  $scope.filterOptions = function(){
    var deferral = $q.defer();
    deferral.resolve({
        data: [{ op: CMP_EQ, nombre: 'Valor exacto'}, {op: CMP_LIKE, nombre: 'Contiene'}]
    });
    return deferral.promise;
  };

  $scope.loadTiposFecha = function(){
    if(angular.isUndefined($scope.tiposFecha)){
      return $http.get(cfg.baseURL + "tipos_fecha").then(function(response){
        var result = [];
        if(response.data != null){
          result = response;
        }
        $scope.tiposFecha = result;
        return result;
      }, function(err){
        ixStatusService.setResponse(err);
      });
    } else {
      var defer = $q.defer();
      defer.resolve({ data: $scope.tiposFecha });
      return defer.promise;
    }
  };

  if($scope.columnType == "date"){
    $scope.loadTiposFecha().then(function(response){
      $scope.tiposFecha = response.data;
    });
  }

  $scope.filterSearchfiltro = function(value) {
    return ixUtilsService.comparar(value.label,$scope.searchfiltro) !== -1;
  }

  $scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchfiltro != null){
      angular.forEach($scope.listOfValues, function(value){
        if(ixUtilsService.comparar(value.label,$scope.searchfiltro) !== -1){
          matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.deselectAll = function() {
		$scope.searchfiltro = "";
    ivhTreeviewMgr.deselectAll($scope.listOfValues);
  };

  $scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){
    if($scope.singleOption){
      if(ivhIsSelected){
        ivhTreeviewMgr.selectAll($scope.listOfValues);
        ivhTreeviewMgr.deselectAll($scope.listOfValues);
        ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);
      }
    }
  };

  $scope.processData = function(){
    //Mirem si hem de canviar el operador.
    if($scope.filtro == "#value" || $scope.filtro == "#empty"){
      $scope.filterOp = CMP_ISNULL;
      $scope.listOfValues = undefined;
    }
    $uibModalInstance.close({ filtro: $scope.filtro, filtros: $scope.listOfValues, op: $scope.filterOp, filtro_periodo: $scope.filtro_periodo });
  };

  //
  $scope.loadSelectableOptions = function(column, filtroObj){
    var selected = false;
    var listOfValues = [];
    var deferred = $q.defer();
    if(angular.isDefined(column) && angular.isDefined(column.Search) && column.Search != null){
      if(angular.isDefined(column.options)){
        if(column.options != null){
          column.options.forEach(function(item){
            selected = false;
            if(angular.isDefined(filtroObj)){
              selected = filtroObj.indexOf(item[column.Search.LookUpResultFields[0]])>=0;
            }
            var id = item[column.Search.LookUpResultFields[0]];
            var label = "";
            for(var i=0; i < column.Search.LookUpResultFields.length; i++){
              var key = column.Search.LookUpResultFields[i];
              label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
              if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
            }
            listOfValues.push({id:id, label:label, selected:selected, children:[]});
          });
          $timeout(function(){
            return deferred.resolve(listOfValues);
          },0);
        }
      } else {
        $http.get(cfg.baseURL + column.Search.LookUpTableName).then(function(r){
          if(r.data != null){
            if(angular.isDefined(column.Search.LookUpConditions) && column.Search.LookUpConditions.length > 0){
              angular.forEach(column.Search.LookUpConditions, function(condition){
                //Fem filters de r.data fins que s'hagin comprovat totes les condicions.
                r.data = r.data.filter(function(e){ return e[condition.KeyField] == condition.Value; });
              });
            }
            column.Search.LookUpOrders.forEach(function(order){
              r.data = $filter("orderBy")(r.data, order.KeyField, order.Desc);
            });
            column.options = r.data;
            r.data.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = filtroObj.indexOf(item[column.Search.LookUpResultFields[0]])>=0;
              }
              var id = item[column.Search.LookUpResultFields[0]];
              var label = "";
              for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                var key = column.Search.LookUpResultFields[i];
                label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
              }
              listOfValues.push({id:id, label:label, selected:selected, children:[]});
            });
            return deferred.resolve(listOfValues);
          }
        });
      }
    } else if(column.type == "string" && column.Control == null) {
      if(angular.isDefined(column.options)){

        if(column.options != null){
          column.options.forEach(function(item){
            selected = false;
            if(angular.isDefined(filtroObj)){
              selected = filtroObj.indexOf(item[column.name])>=0;
            }
            listOfValues.push({id:item[column.name], label:item[column.name], selected:selected, children:[]});
          });
          $timeout(function(){
            return deferred.resolve(listOfValues);
          },0);
        }
      } else {
        var param = { Fields: [ { Field: column.name } ], Selection: buildIxSearch() };
        //Fer un SelectAndProject del camp
        $http.post(cfg.baseURL + $scope.gridEntity + "/SelectAndProject", param).then(function(response){
          if(response.data != null){
            var uniqueValues = $filter('unique')(response.data, column.name);
            column.options = uniqueValues;
            uniqueValues.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = filtroObj.indexOf(item[column.name])>=0;
              }
              listOfValues.push({id:item[column.name], label:item[column.name], selected:selected, children:[]});
            });
            return deferred.resolve(listOfValues);
            //return listOfValues;
          }
        }, function(err){
          ixStatusService.setResponse(err);
        });
      }
    } else {
      $timeout(function(){
        return deferred.resolve(null);
      });
    }
    return deferred.promise;
  };
  //

  //var columna = $scope.data.metadata.find(function(e){ return e.name.toLowerCase() == $scope.entity.campo.toLowerCase(); });//Si al provar els traspassos dona un error
  var columna = $scope.$resolve.column;//si provant els traspassos dona error, comentar aquesta línea i descomentar la de la fila de dalt.
  $scope.loadSelectableOptions(columna, $scope.filtro).then(function(data){
    $scope.listOfValues = data;
  });
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global checkPermission*/
/*global buildMenus*/
angular.module('gp4App').controller("ApiPerfilesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.data.pk = "perfil";


  function getNodes(node) {
    var vm = this;
    if(node.children) {
      node.children.forEach(getNodes, vm + (angular.isDefined(node.display) ? "/" + node.display : ""));
    } else {
      if(node.href && ($scope.allowedMenus.some(function(e){ return e.indexOf(vm + "/"+node.display)!==-1 }) || $scope.authentication.perfiles.some(function(e){ return e.toUpperCase().indexOf("IXNET")!==-1;}))){
        var item = {
          node: node,
          path: vm.toString(),
          checked: false
        }
        $scope.data.menuItems[vm+"/"+node.display] = item;
      }
    }
  }

  if(!$scope.data.menuItems){
    $scope.data.menuItems = {};
    buildMenus().forEach(getNodes, "");
  }

  //
  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo.isNew = true;
    $scope.data.datos = nuevo;
    $scope.data.menuItems = {};
    buildMenus().forEach(getNodes, "");
    return nuevo;
  };

	$scope.deleteUser = function(u) {
		if($scope.status.editing) {
			$scope.data.datos.perfilesusuario.splice($scope.data.datos.perfilesusuario.indexOf(u),1);
		}
	}

	$scope.notAssigned = function(u) {
		return ($scope.data.datos.perfilesusuario.indexOf(u) !== -1);
	}
	$scope.onSelectNewUser = function(u){
    if($scope.data.datos.perfilesusuario.indexOf(u) == -1)
		  $scope.data.datos.perfilesusuario.push(u);
	}

	$http.get(cfg.baseURL + 'api_usuarios/GetAllByClientId?clientId='+cfg.clientId).then(function (response) {
		$scope.allUsers = response.data.map(function(x){return x.usuario});
	});

  $scope.$watch('current', function (current) {
    if(current && current.isNew && !$scope.data.datos.perfilesusuario && !$scope.data.datos.perfilesmenu){
      $scope.data.datos.perfilesusuario = [];
      $scope.data.datos.perfilesmenu = [];
      return;
    }
		if(!current || current.perfil == undefined || Object.keys(current).length == 0 ) return;
		else if(!current.isNew) {
			$http.get(cfg.baseURL + 'api_perfiles/Usuarios_Menus/'+current.perfil+'?clientId='+cfg.clientId).then(function (response) {
        $scope.data.datos = response.data;
        $scope.data.datos.perfil = current.perfil;
				if(response.data){
					$scope.data.menuItems = {};
					buildMenus().forEach(getNodes, "");
				}
				for(var key in $scope.data.menuItems) {
					$scope.data.menuItems[key].checked = false;
				}
				response.data.perfilesmenus.forEach(function(e) {
					if($scope.data.menuItems[e]) {
						$scope.data.menuItems[e].checked = true;
					}
				});
        $scope.data.datosOriginales = angular.copy(response.data);
			});
		}
	}, true);

	$scope.ixGuardar = function() {
    if($scope.data.datos.perfil){
      var data = {
        perfilesusuario: $scope.data.datos.perfilesusuario,
        perfilesmenus: []
      };
      for(var key in $scope.data.menuItems) {
        if($scope.data.menuItems[key].checked){
          data.perfilesmenus.push(key);
        }
      }

      var partsPerfil = $scope.data.datos.perfil.split(" ");
      if(partsPerfil.length > 0){
        $scope.data.datos.perfil = partsPerfil.join("_");
      }
      $scope.data.datos.perfil = $scope.data.datos.perfil.toLowerCase();

      $http.post(cfg.baseURL + 'api_perfiles/Usuarios_Menus/'+$scope.data.datos.perfil+'?clientId='+cfg.clientId, data).then(function (response) {
        $scope.response = response;
        $scope.applyFilter();
        ixStatusService.setEditing(false);
        if($scope.data.datos.isNew) delete($scope.data.datos.isNew);
      }, function(error) {
        $scope.response = error;
      });
    }
	};

  if(!$scope.data.list){
    $scope.$parent.actualizarListado();
  }

}]);

angular.module("gp4App").controller('VideoPlayerController', [ '$scope', function($scope){
  $scope.config = {
    sources: [],
    /*tracks: [
      {
        src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
        kind: "subtitles",
        srclang: "en",
        label: "English",
        default: ""
      }
    ],*/
    theme: "bower_components/videogular-themes-default/videogular.css",
    plugins: {
      poster: "",
      controls: {
        autoHide: true,
        autoHideTime: 5000
      }
    }
  };
}]);

/*global CMP_EQ*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
angular.module('gp4App').controller('ListadosProgramadosListController', ['$scope', '$controller', 'cfg', '$interval', 'ixStatusService', '$uibModal', '$http', '$routeParams', function($scope, $controller, cfg, $interval, ixStatusService, $uibModal, $http, $routeParams){

  $scope.filterByUser = $routeParams.filterByUser;

  $scope.gridManualLoad = true;
  $scope.acciones = [
    {
      icon: "fa-list",
      title: "Editar listado",
      accion: function(entity){
        $scope.clickedList = entity;
        var modalInstance = $uibModal.open({
          templateUrl: 'app/base/views/listados_programados_popup.html',
          controller: 'ListadosProgramadosController',
          //scope: $scope,
          size: 'medium',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            clickedList: function(){
              return angular.copy(entity);
            }
          }
        });

        modalInstance.result.then(function(datosListadoProgramado){
          if(angular.isDefined(datosListadoProgramado)){
            var data = {};
            data.CambiosListado = ixGetPatchOperations($scope.clickedList, datosListadoProgramado);
            data.Mailto = (angular.isDefined(datosListadoProgramado.mailto) && datosListadoProgramado.mailto != null && datosListadoProgramado.mailto != "") ? angular.copy(datosListadoProgramado.mailto) : [];
            data.Mailcco = (angular.isDefined(datosListadoProgramado.mailcc) && datosListadoProgramado.mailcc != null && datosListadoProgramado.mailcc != "") ? angular.copy(datosListadoProgramado.mailcc) : [];

            delete datosListadoProgramado.mailto;
            delete datosListadoProgramado.mailcc;

            $http.put(cfg.baseURL + "listados_programados/PutCustom/" + $scope.clickedList.contador, data).then(function(response){
              ixStatusService.setResponse(response);
              $scope.data.grid.ixLoadInitialData();
            }, function(err){
              ixStatusService.setResponse(err);
            });
          }
        });
      }
    }
  ];
  $controller("GridEditorController", {$scope: $scope});
  var interval;
  interval = $interval(function(){
    if(angular.isDefined($scope.data.grid)){

      $scope.ixAddRow = undefined;

      if($scope.data.grid.data.length == 0){
        $scope.data.grid.filtroExterno = [{ Field: "client_id", Value: cfg.clientId, Operator: CMP_EQ, StartPar: true }, { Or: true, Field: "client_id", Operator: CMP_ISNULL, Value: "", EndPar: true }];
        if($scope.filterByUser == true){
          $scope.data.grid.filtroExterno.push({ Field: "usuario", Value: $scope.$parent.user.usuario, Operator: CMP_EQ });
        }
        $scope.data.grid.ixLoadInitialData();
      }
      $interval.cancel(interval);
    }
  }, 100);
}]);

/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('gp4App').controller('ListadosProgramadosController', ['$scope', '$uibModalInstance', 'ixStatusService', '$http', 'cfg', function($scope, $uibModalInstance, ixStatusService, $http, cfg){
  $scope.status = { editing: true };

	$scope.loadMetadata = function(metadataEntity){
		if(angular.isDefined(metadataEntity)){
			return $http.get(cfg.baseURL + "metadata/" + metadataEntity).then(function(response){
				$scope.data.metadataForm = response.data;
				return $scope.data.metadataForm;
			});
		}
	};

	$scope.getMaxLength = function(keyName){
		if(angular.isDefined($scope.data.metadataForm)){
			var obj = $scope.data.metadataForm.find(function(e){ return e.Name == keyName; });
			return obj.MaxLength;
		}
	};

  $scope.data = {};

	if(!$scope.data.metadataForm){
		$scope.loadMetadata("listados_programados");
	}

  $scope.data.intervalo = 0;
  $scope.data.intervalo_horas = 0;
  $scope.data.intervalo_dias = 0;
  $scope.data.intervalo_meses = 0;

  $scope.data.lunes = 1;
  $scope.data.martes = 1;
  $scope.data.miercoles = 1;
  $scope.data.jueves = 1;
  $scope.data.viernes = 1;
  $scope.data.sabado = 1;
  $scope.data.domingo = 1;

  $scope.data.clave = ixStatusService.current.href;

  //De moment nomes es poden treure excels.
  $scope.data.extension = "XLS";

  $scope.save = function () {
    if($scope.data.intervaloseleccionado == 0){
      $scope.data.intervalo = 0;
      $scope.data.intervalo_horas = 0;
      $scope.data.intervalo_dias = 0;
      $scope.data.intervalo_meses = 0;
    } else if($scope.data.intervaloseleccionado == 1){
      $scope.data.intervalo_horas = 0;
      $scope.data.intervalo_dias = 0;
      $scope.data.intervalo_meses = 0;
    } else if($scope.data.intervaloseleccionado == 2){
      $scope.data.intervalo = 0;
      $scope.data.intervalo_dias = 0;
      $scope.data.intervalo_meses = 0;
    } else if($scope.data.intervaloseleccionado == 3){
      $scope.data.intervalo = 0;
      $scope.data.intervalo_horas = 0;
      $scope.data.intervalo_meses = 0;
    } else if($scope.data.intervaloseleccionado == 4){
      $scope.data.intervalo = 0;
      $scope.data.intervalo_horas = 0;
      $scope.data.intervalo_dias = 0;
    }

    if(angular.isDefined($scope.data.mailto) && $scope.data.mailto != null){
      $scope.data.mailto = $scope.data.mailto.split(";");
    }

    if(angular.isDefined($scope.data.mailcc) && $scope.data.mailcc != null){
      $scope.data.mailcc = $scope.data.mailcc.split(";");
    }

    $uibModalInstance.close($scope.data);
  };

  $scope.$close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.getListadoProgramado = function(datos){
    if(datos.intervalo > 0){
      datos.intervaloseleccionado = 1;
    } else if(datos.intervalo_horas > 0){
      datos.intervaloseleccionado = 2;
    } else if(datos.intervalo_dias > 0){
      datos.intervaloseleccionado = 3;
    } else if(datos.intervalo_meses > 0){
      datos.intervaloseleccionado = 4;
    } else {
      datos.intervaloseleccionado = 0;
    }
    $scope.datosOriginales = datos;

    return datos;
  };

  //Si el llistat ja existeix, rebrem un objecte entity amb els atributs d'aquest llistat.
  if(angular.isDefined($scope.$resolve.clickedList)){
    var datos = $scope.$resolve.clickedList;
    $scope.data = $scope.getListadoProgramado(datos);

    var param = { Fields: [ { Field: "mail" } ], Selection: buildIxSearch() };
    param.Selection.Filters.push({ Field: "contador", Value: datos.contador, Operator: CMP_EQ });

    $http.post(cfg.baseURL + "listados_programados_mailto/SelectAndProject", param).then(function(mailto){
      if(mailto.data.length > 0){
        var arrStrings = mailto.data.map(function(obj){
          return obj.mail;
        });
        $scope.data.mailto = arrStrings.join(';');
      }
    });

    $http.post(cfg.baseURL + "listados_programados_mailcco/SelectAndProject", param).then(function(mailcco){
      if(mailcco.data.length > 0){
        var arrStrings = mailcco.data.map(function(obj){
          return obj.mail;
        });
        $scope.data.mailcc = arrStrings.join(';');
      }
    });
  }
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
angular.module('gp4App').controller('ListEditController', ['$scope', '$rootScope', '$controller', '$http', '$routeParams', '$uibModal', '$timeout', 'cfg', 'uiGridConstants', 'authService', 'ixStatusService', 'gridService', '$log', function($scope, $rootScope, $controller, $http, $routeParams, $uibModal, $timeout, cfg, uiGridConstants, authService, ixStatusService, gridService, $log) {
	$scope.angular = angular;
  $scope.ixEditar = function () {
    //No canviar a mode edició si no hi ha cap registre sel·leccionat.
    if(!$scope.data.datos[$scope.data.pk]) return;
    // TODO: crear un bloqueo
    /*$scope.bloqueo = {
      user: authService.authentication.userName,
      ts: new Date(),
      app: $scope.entity
    };*/
    ixStatusService.setEditing(true);
  };

  $scope.ixCancelEdit = function () {
    delete ixStatusService.current.response;
    $scope.data.cancelEdit = true;
    $scope.current = {};
    $scope.data.datos = {};

    $scope.applyFilter();
    ixStatusService.setEditing(false);
    //Recuperar l'objecte que estava sel·leccionat del llistat lateral.
    $timeout(function(){
      $scope.selectItem($scope.data.datosOriginales);
    });
  };

  // todo: obnener filtros de backend
  $scope.filters = [
    {name:$scope.entity, view:"list", search: {Filters: [], OrderBy: []}, data : {CurrentPage:1, ItemsPerPage: 6, Items:[]}, filterVisible:false }
  ];

  $scope.init = function(){
    var timer;
    var lastBusqueda = "";
    $scope.module = ($routeParams.module && $routeParams.module != "") ? $routeParams.module + "/" : '';
    $scope.entity = $routeParams.entity;

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;
    if(angular.isUndefined($scope.data)) $scope.data = {};
    $scope.includeFiltersTemplate = ($routeParams.includeFiltersTemplate && $routeParams.includeFiltersTemplate != "") ? $routeParams.includeFiltersTemplate : 'app/base/views/filters.html';
    //$scope.gridManualLoad = true;
    if(!$scope.current) $scope.current = {};
    if(!$scope.data.datos){
      $scope.data.datos = {};
    }

    $scope.loadMetadata = function(metadataEntity){
      if(angular.isDefined(metadataEntity)){
        return $http.get(cfg.baseURL + "metadata/" + metadataEntity).then(function(response){
          $scope.data.metadataForm = response.data;
          return $scope.data.metadataForm;
        });
      }
    };

		$scope.getMaxLength = function(keyName){
      if(angular.isDefined($scope.data.metadataForm)){
        var obj = $scope.data.metadataForm.find(function(e){ return e.Name == keyName; });
				if(obj.MaxLength == null && obj.Type == "Int32"){
					obj.MaxLength = 11;
				}
        return obj.MaxLength;
      }
    };

    //Per evitar els if else if... el applyFilters i la inicialització de la grid es faràn desde els controllers inferiors (lineas, campas, orides,...)
    if($scope.entity == "orides"){
      //$scope.filters[0].search.Filters.push({Field : "tpo", Value : "1", Operator : CMP_GT});
    } else if($scope.entity == "campas"){
      //$scope.filters[0].search.Filters.push({Field : "tpo", Value : "1", Operator : CMP_EQ});
    } else if($scope.entity == "api_perfiles"){
      $scope.filters[0].search.Filters.push({Field : "client_id", Value : cfg.clientId, Operator : CMP_EQ});
    }



    if($scope.data.grid){
      $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
      $scope.data.grid.ixRestoreConfig();
      if (!$scope.data.ocultaExportarList)
        $scope.ixDownloadExcelListado = $scope.data.grid.ixDownloadExcel;
    }

    //Fins aqui anirà fora.
    $scope.addNewItem = function(f) {
      var newItem = (typeof(f.onNew) == "function") ? f.onNew() : { "isNew": true };
      $scope.data.list.push(newItem);
      $scope.current = newItem;
      ixStatusService.setEditing(true);
    }


    if(angular.isDefined($routeParams.readOnly) && $routeParams.readOnly == true){
      $scope.readOnly = true;
      $scope.ixEditar = undefined;
      $scope.ixCancelEdit = undefined;
      $scope.addNewItem = undefined;
    }

    $scope.applyFilter = function() {
      $scope.actualizarListado(true);
    };

    $scope.selectItem = function(item) {
      if(!ixStatusService.current.editing && !ixStatusService.current.filtered || $scope.changeWhileEditing){
        $scope.current = angular.merge($scope.current, item);
        //$scope.currentItemObj = item;
      }
    };
    $scope.accion = function(entity){
      if(!$scope.status.editing){
        if(entity.isNew) delete entity.isNew;
        $scope.current = angular.merge($scope.current, entity);
        //ixStatusService.setEditing(true);
      }
    };

    $scope.cargarGrid = function(){
      $scope.tipoBusqueda = $scope.buscar ? $scope.buscar : $scope.entity;
      if($scope.data.listpk) {
        $scope.data.grid = gridService.createGrid($scope, "Mant_"+$scope.entity+"Grid", { minWidth: 75, minRowsToShow: 5, enableCellEdit: true, enableFiltering: true, showOnlyDescribedCols: $scope.showOnlyDescribedCols, loadItemWhenSelect: true }, ($scope.metadataFrom ? $scope.metadataFrom : "gp4_listado_"+$scope.tipoBusqueda+"VM"), ($scope.setAcciones ? $scope.setAcciones() : null));
        //TODO: Este if se borrará, al final todos irán por la entity y se pasará un parámetro listado (operaciones/listado... , orides/listado...).
        if($scope.entity == "operaciones"){
          $scope.data.grid.entity = $scope.entity;
          $scope.data.grid.listado = "listado_" + $scope.entity;
        } else if($scope.entity == "zcp"){
          $scope.data.grid.entity = "listado_campas";
        } else {
          if(!$scope.data.useModel){
            $scope.data.grid.entity = "listado_" + $scope.entity;
          } else {
            $scope.data.grid.entity = $scope.tipoBusqueda;
          }
        }
      } else {
        $scope.data.grid = gridService.createGrid($scope, "Mant_"+$scope.entity+"Grid",  { minWidth: 75, minRowsToShow: 5, enableCellEdit: true, enableFiltering: true, loadItemWhenSelect: true }, $scope.tipoBusqueda, ($scope.setAcciones ? $scope.setAcciones() : null));
        $scope.data.grid.filtroExterno = $scope.filters[0].search.Filters;
      }
      $scope.filters[0].isOpen=true;
      if (!$scope.data.ocultaExportarList)
        $scope.ixDownloadExcelListado = $scope.data.grid.ixDownloadExcel;
    };

    $scope.actualizarListado = function(forzarActualizacion){
      var listado = "";
      $scope.tipoBusqueda = $scope.buscar ? $scope.buscar : $scope.entity;
      //TODO: Al final tots anirán per entitat/listado/...
      if($scope.entity == "operaciones") listado = $scope.data.listpk ? $scope.entity + "/listado_" : "";
      else listado = $scope.data.listpk && !$scope.data.useModel ? "/listado_" : "";

      if(lastBusqueda !== $scope.data.busqueda || forzarActualizacion){
        $scope.data.list = [];
        $scope.data.loaded = false;
        if(timer){ $timeout.cancel(timer); }
        timer = $timeout(function(){
            var params = {Filters: [], OrderBy: []};
            params.Filters = angular.merge(params.Filters, $scope.filters[0].search.Filters);//En cas de que hi hagi algun parametre obligatori per separat.
            if($scope.data.busqueda && $scope.data.busqueda != ""){
              //Si el search es fa contra la API executant una query passarem un sol Field busqueda.
              if($scope.data.listpk && !$scope.data.useModel){
                params.Filters.push({Field : "busqueda", Value : $scope.data.busqueda, Operator : CMP_LIKE, Skip: true});
              } else {
                //Si fa el search contra un objecte PetaPoco passarem alguna cosa més.

                //TODO: Tots es montaran a partir d'un array de camps a buscar entre parentesis i OR's.
                //El useModel només existirà mentre no s'hagi fet a tots.
                if(!$scope.data.useModel){
                  var filter = { Field : $scope.data.pk, Value : $scope.data.busqueda, Operator : CMP_LIKE };
                  if($scope.data.list[0] && ($scope.data.list[0].nombre || $scope.data.list[0].descripcion)){
                    filter["StartPar"] = true;
                  }
                  params.Filters.push(filter);
                  if($scope.data.list[0] && $scope.data.list[0].nombre){
                    params.Filters.push({Or: true, Field : "nombre", Value : $scope.data.busqueda, Operator : CMP_LIKE, EndPar: true});
                  } else if($scope.data.list[0] && $scope.data.list[0].descripcion){
                    params.Filters.push({Or: true, Field : "descripcion", Value : $scope.data.busqueda, Operator : CMP_LIKE, EndPar: true});
                  }
                } else {
                  angular.forEach($scope.data.fieldsToFilter, function(field, idx){
										var param = { Field: field, Value: $scope.data.busqueda, Operator: CMP_LIKE };
										if(idx == 0) param.StartPar = true;
										if(idx == ($scope.data.fieldsToFilter.length - 1)){
											param.EndPar = true;
										}
										if(idx > 0)
											param.Or = true;
										params.Filters.push(param);
									});
                  //params.Filters.push({ Field: $scope.data.fieldsToFilter[0], Value: $scope.data.busqueda, Operator: CMP_LIKE, StartPar: true});
                  //params.Filters.push({ Field: $scope.data.fieldsToFilter[1], Value: $scope.data.busqueda, Operator: CMP_LIKE, EndPar: true, Or:true });
                }

              }
            }
            if(angular.isDefined($scope.data.fieldsToOrderBy)){
              $scope.data.fieldsToOrderBy.forEach(function(fieldToOrderBy){
                params.OrderBy.push(fieldToOrderBy);
              });
            }
            $http.post(cfg.baseURL + listado + $scope.tipoBusqueda + "/Search?Page=1&ItemsPerPage=200", params).then(function(response){

              $timeout(function(){
                $scope.data.list = response.data.Items;
                $scope.data.loaded = true;
              },1);
            }, function(error){
              ixStatusService.setResponse(error);
            });
        },350);
      }
      lastBusqueda = $scope.data.busqueda;
    };

		$scope.fullScreen = function(to_fullscreen){
			$scope.data.fullScreen = to_fullscreen;
		};
  }

}]);

angular.module('gp4App').controller('GridUsuariosGruposController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', '$http', '$filter', 'uiGridConstants', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService, $http, $filter, uiGridConstants){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.grid = gridService.createGrid($scope, "admin_usuarios_api_gruposusuarioGrid",  { showOnlyDescribedCols: [ 'grupo' ]}, "api_gruposusuario");

  $scope.ixEditar = $scope.grid.ixEditar;
  $scope.ixCancelEdit = $scope.grid.ixCancelEdit;
  $scope.ixAddRow = $scope.grid.ixAddRow;
  $scope.ixDeleteSelectedRows = $scope.grid.ixDeleteSelectedRows;
  $timeout(function(){
    $scope.numberOfChanges = $scope.grid.numberOfChanges;
  });
  $scope.updateIxGuardarTooltip = $scope.grid.updateIxGuardarTooltip;

  //Buscar només tot el que estigui relacionat amb l'usuari.
  $scope.grid.filtroExterno = {usuario:$scope.$parent.$parent.$parent.row.entity.usuario};

  $scope.grid.ixCheckErrors = function(){
    //No comprova res.
    return true;
  };
  
  $scope.grid.ixLoadInitialData = function(){
    $scope.grid.ixIsLoading = true;
    $http.get(cfg.baseURL + $scope.grid.entity + '/GetByUsuario?usuario='+$scope.grid.filtroExterno.usuario).then(function (response) {
      //Per a cada crida s'actualitzarà la data d'informació generada.
      //$scope.grid.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
      $scope.data.ixProgress = 0;
      $scope.grid.data = response.data;    
      $scope.data.ixProgress = 100;
      $scope.grid.ixIsLoading = false;
      $timeout(function () {
        delete $scope.data.ixProgress;
      }, 500);
    }, function (response) {
      $scope.grid.ixIsLoading = false;
      ixStatusService.setResponse(response);
    });
  };
  
  $scope.save = function(){
    var bulkParam  = $scope.grid.ixGetBulkParam();
        
    $http.patch(cfg.baseURL + $scope.grid.entity + '/UpdateBulkCustom', bulkParam).then(function (response) {
      if (response.data.Result) {
        ixStatusService.setResponse(response);
        $scope.grid.deletedRows = [];
        $scope.grid.insertedRows = [];

        var dataRows = $scope.grid.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
        $scope.grid.gridApi.rowEdit.setRowsClean( dataRows );

        ixStatusService.setEditing(false);

        // Rehabilitar ordenacion al finalizar la edición
        $scope.grid.enableSorting = true;
        $scope.grid.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);

        $scope.grid.ixLoadInitialData();
      } else {
        ixStatusService.setResponse(response);
      }
    }, function (response) {
      $scope.grid.insertedRows.forEach(function(e){e.isNew=true;});
      ixStatusService.setResponse(response);
    });
  };
}]);

angular.module('gp4App').controller('GridUsuariosEtiquetasController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.grid = gridService.createGrid($scope, "admin_usuarios_etiquetasGrid",  { showOnlyDescribedCols: [ 'etiqueta', 'valor' ] }, "configuraciones");

  $scope.ixEditar = $scope.grid.ixEditar;
  $scope.ixCancelEdit = $scope.grid.ixCancelEdit;
  $timeout(function(){
    $scope.numberOfChanges = $scope.grid.numberOfChanges;
  });
  $scope.updateIxGuardarTooltip = $scope.grid.updateIxGuardarTooltip;
  $scope.save = $scope.grid.ixGuardar;

  //Buscar només tot el que estigui relacionat amb l'usuari.
  $scope.grid.filtroExterno = {usuario:$scope.$parent.$parent.$parent.row.entity.usuario};
  
  $scope.grid.ixCheckErrors = function(){
    //No comprova res.
    return true;
  };
}]);

angular.module('gp4App').controller('GridUsuariosMegawhereController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  //$scope.openWindow = function(size){
  //if(ixStatusService.current.editing){

		var metadata = [{ Name: "cliente", skipTableNameForDropdown: true },
									  { Name: "proveedor", skipTableNameForDropdown: true },
                    { Name: "laboratorio", skipTableNameForDropdown: true },
                    { Name: "contextID", NoVisible: true }];

    $scope.gridmegawhere = gridService.createGrid($scope, "extranet_condition_userGrid",  { metadata: metadata }, "extranet_condition_user");

    $scope.gridmegawhere.entity = "extranet_condition_user";

    $scope.ixEditar = $scope.gridmegawhere.ixEditar;
    $scope.ixCancelEdit = $scope.gridmegawhere.ixCancelEdit;
    $scope.ixAddRow = $scope.gridmegawhere.ixAddRow;
    $scope.ixDeleteSelectedRows = $scope.gridmegawhere.ixDeleteSelectedRows;
    //$scope.ixDownloadExcel = $scope.gridmegawhere.ixDownloadExcel;
    $timeout(function(){
      $scope.numberOfChanges = $scope.gridmegawhere.numberOfChanges;
    });
    $scope.updateIxGuardarTooltip = $scope.gridmegawhere.updateIxGuardarTooltip;
    $scope.save = $scope.gridmegawhere.ixGuardar;

    //Buscar només tot el que estigui relacionat amb l'usuari.
    $scope.gridmegawhere.filtroExterno = {username:$scope.$parent.$parent.$parent.row.entity.usuario};

    $scope.gridmegawhere.ixCheckErrors = function(){
      //No comprova res.
      return true;
    };
  //}
  //};
}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
angular.module('gp4App').controller("GridUsuariosController", ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService) {
  $scope.status = ixStatusService.current;
  $scope.init = function(){
    $scope.data = ixStatusService.current.data;
    $scope.entity = "api_usuarios";

    if(!$scope.data.filtro) {
      $scope.data.filtro = {client_id:cfg.clientId}
      if(cfg.clientId == ""){
        $scope.data.filtro.client_id = "GPv4";
      }
    }

    $scope.showClient = authService.authentication.perfiles.some(function(e){ return e.toUpperCase().indexOf("IXNET")!==-1;});


    var gridName = $scope.entity + "Grid";


    if(!$scope.data.grid){
      var metadata = [{
                        Name: "client_id",
                        overridePreloadedOptions: true,
                        busquedaFunction:function(column){
                          return $http.post(cfg.baseURL + "api_client/Search", { id: $scope.data.filtro.client_id }).then(function(response){
                            if(response.data != null){
                              column.options = response.data.map(function(e){ return { client_id: e.id, id: e.id }; });
                              return column.options;
                            }
                            column.options = [];
                            return column.options;
                          }, function(err){
                            ixStatusService.setResponse(err);
                            return [];
                          });

                        }
                      }
                     ];
      //
      var acciones = [
        {
          icon: "fa-window-maximize",
          title: "Condiciones",
          template: "app/base/views/gridUsuarios_megawhere.html",
          visible: function(entity){
            return !entity.isNew && (cfg.clientId.toUpperCase() == "EXTRANET" || cfg.clientId.toUpperCase() == "FTBASE" || cfg.clientId.toUpperCase() == "DEMOBIOFT");
          }
        },
        {
          icon: "fa-group",
          title: "Grupos",
          template: "app/base/views/gridUsuarios_grupos.html",
          visible: function(entity){
            return !entity.isNew && cfg.clientId.toUpperCase() == "GPV4";
          }
        },
        {
          icon: "fa-cog",
          title: "Etiquetas",
          template: "app/base/views/gridUsuarios_etiquetas.html",
          visible: function(entity){
            return !entity.isNew;
          }
        }
      ];

      $scope.data.grid = gridService.createGrid($scope, $scope.entity + "Grid", { metadata: metadata }, $scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
      $scope.data.grid.entity = $scope.entity;
      $scope.data.grid.filtroExterno = $scope.data.filtro;
      //$scope.data.grid.ixLoadInitialData();
    } else {
      $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
      $scope.data.grid.ixRestoreConfig();
    }

    $scope.ixEditar = $scope.data.grid.ixEditar;
    $scope.ixCancelEdit = $scope.data.grid.ixCancelEdit;
    $scope.ixAddRow = function(){
      var newItem = {};
      newItem.idioma = cfg.defaultLanguage || "es";
      $scope.data.grid.ixAddRow(newItem);
    }
    $scope.ixDeleteSelectedRows = $scope.data.grid.ixDeleteSelectedRows;
    $scope.ixDownloadExcel = $scope.data.grid.ixDownloadExcel;
    $scope.numberOfChanges = $scope.data.grid.numberOfChanges;
    $scope.updateIxGuardarTooltip = $scope.data.grid.updateIxGuardarTooltip;
    $scope.addIncidencia = $scope.data.grid.addIncidencia;
    $scope.ixGuardar = $scope.data.grid.ixGuardar;
    //$scope.ixLoadInitialData = $scope.grid.ixLoadInitialData($scope.grid, gridName);


    $scope.$on("$destroy", function() {
      delete($scope.delayedActions);
      $scope.isDestroyed=true;
    });


    /**
     * Construye un objeto PK para enviar a la API
     * Si la entity es barco, devuelve  {barco: 123}
     */
    $scope.buildPK = function (item) {
      return $scope.data.grid.buildPK(item);
    };

    $scope.loadClients = function(){
      var param = cfg.clientId;
      if(cfg.clientId == "GPv4"){
        param = "";
      }
      return $http.get(cfg.baseURL + "api_client");
    };

    $scope.$watch('data.filtro.client_id', function(nuevo, anterior){
      if(nuevo !== anterior){
        $scope.data.grid.ixLoadInitialData();
      }
    });

    /*$scope.$watch('status.response', function(nuevo, anterior){
      if(nuevo !== anterior){
        $timeout(function(){
          delete $scope.status.response;
        }, 2000);
      }
    });*/
  }
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*global checkPermission*/
/*global CMP_EQ*/
"use strict";
angular.module('gp4Controllers').controller('GridTraduccionesController', ['$scope', '$controller', '$log', function ($scope, $controller, $log) {
  $controller('GridEditorController', {$scope: $scope});
  $scope.executeAfterInit = function(){
    $scope.ixAddRow = undefined;
    $scope.ixDeleteSelectedRows = undefined;
  };
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global checkPermission */
/*global convertDateStringsToDates */
/*global parseObjectsToString */
/*global ixGridColumnFilter */
/*global ixGridColumnFilterCondition*/
/*global ixNewDate*/
/*global CMP_EQ*/
angular.module("gp4App").controller('GridEditorController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  
  $scope.init = function(){
    $scope.entity = angular.isUndefined($scope.entity) ? $routeParams.entity : $scope.entity;

		if(angular.isDefined($scope.nombreCesta))
			ixCestaVehiculosService.init($scope.nombreCesta);

    if(!$scope.data.grid) {
      var gridOptions = angular.merge({
        enableHorizontalScrollbar: 2,
        enableFiltering: true
      }, $scope.gridOptions);

      if(angular.isUndefined($scope.nombreConfigListado)){
        $scope.nombreConfigListado = $scope.entity + "Grid";
      }
      $scope.data.grid = gridService.createGrid($scope, $scope.nombreConfigListado, gridOptions, $scope.entity, (!$scope.acciones ? [] : [{ name: 'Acciones', type: 'detalle', acciones: $scope.acciones }]));
      $scope.data.grid.entity = $scope.routeEntity ? $scope.routeEntity : $scope.entity;
			//Incluir params de cesta:
			if(angular.isDefined($scope.nombreCesta))
      	$scope.data.grid.incloureCesta = true;
      if (angular.isDefined($scope.filtroExterno))
        $scope.data.grid.filtroExterno = $scope.filtroExterno;

    } else{
      $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
      $scope.data.grid.ixRestoreConfig();
    }

    $scope.ixEditar = $scope.data.grid.ixEditar;
    $scope.ixCancelEdit = angular.isUndefined($scope.ixCancelEdit) ? $scope.data.grid.ixCancelEdit : $scope.ixCancelEdit;
    $scope.ixAddRow = angular.isUndefined($scope.ixAddRow) ? $scope.data.grid.ixAddRow : $scope.ixAddRow;//en cas de que definim un ixAddRow a un controller que hereda d'aquest.
    $scope.ixDeleteSelectedRows = $scope.data.grid.ixDeleteSelectedRows;
    $scope.ixDownloadExcel = $scope.data.grid.ixDownloadExcel;
    $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.grid.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
    $scope.updateIxGuardarTooltip = $scope.data.grid.updateIxGuardarTooltip;
    $scope.ixGuardar = angular.isUndefined($scope.ixGuardar) ? $scope.data.grid.ixGuardar : $scope.ixGuardar;//en cas de que definim un ixGuardar a un controller que hereda d'aquest.

    $scope.$on("$destroy", function() {
			if(ixCestaVehiculosService && angular.isDefined($scope.nombreCesta)){
        ixCestaVehiculosService.setShowing(false);
      }
      $scope.data.grid.ixSaveConfig();
      $scope.isDestroyed=true;
    });

    /**
     * Construye un objeto PK para enviar a la API
     * Si la entity es barco, devuelve  {barco: 123}
     */
    $scope.buildPK = function (item) {
      return gridService.buildPK($scope, item);
    };
    //Si tenim algún controller que heredi d'aquest i volem executar codi després de que s'executi l'init, l'haurem de possar dintre d'una funció que es digui executeAfterInit.
    if(angular.isDefined($scope.executeAfterInit)){
      $scope.executeAfterInit();
    }
  }
}]);



/**
 * proporciona metode per notificar la fi de edició de la cell
 */
angular.module("gp4App").directive('ixUiGridSelectEditor', ['gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', '$animate', function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, $animate) {
	return {
		require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel', 'uiSelect'],
		link: function (scope, elm, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }

			var uiSelect = controllers[3];

      //Deshabilitem el animate, l'activem dintre del timeout. Si no ho fem l'animació de transició entre pantalles deixarà de funcionar.
      $animate.enabled(false, elm);

      //Treiem el activate i focus del timeout. Dintre del timeout calculem el top.
      uiSelect.activate();
      uiSelect.focusSearchInput();
			$timeout(function() {//Al possar el uiSelect.activate fora del timeout visualment és més ràpid, però el top no es calcula bé. El calculem dintre.
        var wrongTop = elm.css("top");
        wrongTop = parseInt(wrongTop);
        var calculatedTop = wrongTop + 39;

        elm.css("top", calculatedTop+"px");

        angular.element(uiSelect.searchInput[0]).bind('blur',function(e){
          if(e.relatedTarget) {
            if(!e.relatedTarget.closest(".ui-select-dropdown")) {
              // Blur hacia fuera del dropdown. cerramos cellEditor
              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            } else {
              // Blur hacia dentro del dropdown: devolvemos focus al searchinput
              $timeout(function(){
                uiSelect.focusSearchInput();
              });
            }
          }
        });
        $animate.enabled(true, elm);
			},1);

      angular.element(uiSelect.searchInput[0]).on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }

        if (evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN){
          evt.stopPropagation();
        }
        // Pass the keydown event off to the cellNav service, if it exists
        else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });


      scope.stopEdit = function (evt) {
        /*if (scope.inputForm && !scope.inputForm.$valid) {
          evt.stopPropagation();
          scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
        }
        else {
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
        scope.deepEdit = false;*/
        evt.stopPropagation();
        scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
      };
      //

			//Possem sempre un z-index superior als modals, això té utilitat quan hi ha una grid a un popup, per exemple, al llistat d'usuaris.
			//TODO: Mirar d'aplicar només el z-index en aquells casos que el ix-ui-grid-select-editor es trobi dins d'un popup.
			elm.css("z-index", "1051");
		}
	};
}]);

/**
 * proporciona metode per notificar la fi de edició de la cell
 */
angular.module("gp4App").directive('ixUiGridSelectEditor2', ['gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', '$animate', 'ixStatusService', function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, $animate, ixStatusService) {
	return {
		restrict: 'A',
		scope: false,
		require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
		link: function (scope, elm, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }

			var input = angular.element(elm.find('input')[0]);
			var TAB_KEY = 9;
			var INTRO_KEY = 13;
			var LEFT_KEY = 37;
			var UP_KEY = 38;
			var RIGHT_KEY = 39;
			var DOWN_KEY = 40;
			

			//la llibrería angular-ui-grid es la que s'encarrega de canviar el valor a la propietat focused.
			scope.$watch('focused', function(newVal, oldVal){
				if(newVal){
					//$timeout(function(){
					//console.log("focused");
						input.focus();
						input.select();						
					//},0);
				}
			});
			
			input.on('blur', function (evt) {
				if(!scope.focused)
				{
					//console.log("blur: NO focused");
					//scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
					//input.off();
				}
				else if(angular.element(evt.relatedTarget).hasClass("ui-grid-focuser")) {
					//console.log("blur: focused");
					input.focus();
					input.select();
				}
			});			

			scope.$on('raiseAfterCellEdit', function(event, data){
				uiGridCtrl.grid.api.edit.raise.afterCellEdit(scope.row.entity, scope.col.colDef, data.newVal, data.oldVal);
			});

			scope.$on('refreshCellFocus', function(event){
				scope.stopEdit(event);
			});
			scope.stopEdit = function (evt) {
        scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
      };

			input.on('keydown', function(evt) {
				if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
					evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
					if(evt.keyCode == INTRO_KEY || evt.keyCode == TAB_KEY || evt.keyCode == LEFT_KEY || evt.keyCode == RIGHT_KEY){
						if(evt.keyCode == INTRO_KEY || evt.keyCode == TAB_KEY)							
							ixStatusService.current.ixCellNav = true;
						if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
							scope.stopEdit(evt);
						}
					}
					else {
						ixStatusService.current.ixCellNav = false;
					}
				}
				return true;
			});
		}
	};
}]);

angular.module("gp4App").directive('ixGridTimeEditor', [ 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', 'uiGridEditService', '$log', '$filter', '$timeout', function(gridUtil, uiGridConstants, uiGridEditConstants, uiGridEditService, $log, $filter, $timeout) {
  return {
    restrict: 'EA',
    //require: '?ngModel',
                               require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    scope: {
      ngModel: '=',
      name: '@'
    },
    //template: '<input time="text" ui-grid-editor class="form-control" ng-model="ngModel" ui-mask="99:99" model-view-value="true" ui-validate="\'validateTIME($value)\'" />',
    //template: '<input time="text" ui-grid-editor class="form-control" ng-model="ngModel" />'/*,
    //template: '<input type="text" ui-grid-editor class="form-control" ng-model="ngModel" />'/*,
    //template: '<input type="text" ui-grid-editor ng-model="MODEL_COL_FIELD" class="form-control" />'/*,
    //template: '<div><form name="test"><input type="text" ui-grid-editor ng-model="MODEL_COL_FIELD"></form></div>'/*,
    //link: function(scope, elem, attrs, ngModelController) {
    link: function(scope, elem, attrs, controllers) {
                                               var uiGridCtrl, renderContainerCtrl, ngModelController;
                                               if (controllers[0]) { uiGridCtrl = controllers[0]; }
                                               if (controllers[1]) { renderContainerCtrl = controllers[1]; }
                                               if (controllers[2]) { ngModelController = controllers[2]; }
                                               
      var input = elem;
                                               $timeout(function(){
                                                               input.focus();
                                               });
      
                                               input.on('keypress', function(e){
                                                               var keyCode = (e.which||e.charCode||e.keyCode);
                                                               if("0123456789:. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                                                                                              [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                                                                                              ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                                                                                              (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
                                                               ) {
                                                                               return true;
                                                               } else {
                                                                               e.preventDefault();
                                                                               return false;
                                                               }
                                               });
      input.on('blur', function(event){
        $log.log("blur");
        //scope.done = true;
        //scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        //scope.$apply();
                                                               var newVal = event.target.value;
                                                               var dateParts = newVal.split(/[\:\.\- '\+]{1}/);

                                                               var now = ($filter("date")(new Date(), "H:mm:ss", null)).split(":");
                                                               var hours = now[0];
                                                               var minutes = now[1];              
                                                               var seconds = "00";

                                                               /* INI introduccio sense separadors (. | + | -) */
                                                               if(dateParts.length==1) {
                                                                               if(dateParts[0].length==0) {
                                                                                              ngModelController.$setViewValue(null);
                                                                                              ngModelController.$render();
																							  if(scope.callStopEdit == undefined)
																								scope.stopEdit(event);
                                                                                              return;
                                                                               }
                                                                               var index = 2;
                                                                               hours = parseInt(dateParts[0].slice(0,2));                                                                                                                           
                                                                               if(hours>23) {                                                                                                                                  
                                                                                              hours = dateParts[0].slice(0,1);
                                                                                              index = 1;
                                                                               }
                                                                               if(dateParts[0].length>2) {                                                                                                                                        
                                                                                              minutes = dateParts[0].slice(index,index+2);
                                                                                              if(parseInt(minutes)>59)
                                                                                              {
                                                                                                              minutes = "0"+dateParts[0].slice(index,index+1);
                                                                                                              index = index + 1;
                                                                                              }
                                                                                              else {
                                                                                                              index = index + 2;
                                                                                              }
                                                                               }
                                                                               if(dateParts[0].length>4) {
                                                                                              //seconds = dateParts[0].slice(index,index+2);
                                                                                              seconds = parseInt(dateParts[0].slice(index,index+2)) < 9 ? "0"+parseInt(dateParts[0].slice(index,index+2)) : dateParts[0].slice(index,index+2);
                                                                               } else {
                                                                                              seconds = "00";
                                                                               }
                                                               }
                                                               /* FIN introduccio sense separadors (. | + | -) */

                                                               /* INI introduccio amb separadors (. | + | -) */
                                                               if(dateParts[0].length>0 && dateParts[0].length<=2) {
                                                                               hours = parseInt(dateParts[0]);
                                                               }
                                                               if(dateParts.length>1 && dateParts[1].length>0) {
                                                                               if(parseInt(dateParts[1]) < 9){
                                                                                              minutes = "0"+parseInt(dateParts[1]);
                                                                               } else if(parseInt(dateParts[1]) > 59){
                                                                                              minutes = "00";
                                                                               } else {
                                                                                              minutes = dateParts[1];
                                                                               }
                                                               }
                                                               if(dateParts.length>2 && dateParts[2].length>0) {
                                                                               if(parseInt(dateParts[2]) < 9){
                                                                                              seconds = "0"+parseInt(dateParts[2]);
                                                                               } else if(parseInt(dateParts[2]) > 59){
                                                                                              seconds = "00";
                                                                               } else {
                                                                                              seconds = dateParts[2];
                                                                               }
                                                               }
                                                               /* FIN introduccio amb separadors (. | + | -) */              

                                                               scope.ngModel = hours + ":" + minutes + ":" + seconds;
                                                               scope.validateTIME(scope.ngModel);
                                                               scope.$apply();
															   if(scope.callStopEdit == undefined)
																   scope.stopEdit(event);
      });

                                               /*
      input.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }

        if (scope.deepEdit &&
          (evt.keyCode === uiGridConstants.keymap.LEFT ||
           evt.keyCode === uiGridConstants.keymap.RIGHT ||
           evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN)) {
          evt.stopPropagation();
        }
        // Pass the keydown event off to the cellNav service, if it exists
        else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });
                                               */
                                               
                                               input.on('keydown', function (evt) {
                                                               switch (evt.keyCode) {
                                                                               case uiGridConstants.keymap.ESC:
                                                                                              evt.stopPropagation();
                                                                                              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                                                                                              break;
                                                                               case 8://backspace
                                                                                              scope.changed = true;
                                                                                              break;
                                                                               case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
                                                                               case uiGridConstants.keymap.TAB:
																							  scope.calledStopEdit = true;
                                                                                              input.blur();
                                                                                              evt.stopPropagation();
                                                                                              evt.preventDefault();
                                                                                              uiGridCtrl.cellNav.handleKeyDown(evt);
                                                                                              scope.stopEdit(evt);																							  
                                                                                              break;
																			    default:																
																							  if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
																								scope.stopEdit(evt);
																							  }
																							  break;
                                                               }

                                                               if (scope.deepEdit &&
                                                                               (evt.keyCode === uiGridConstants.keymap.LEFT ||
                                                                               evt.keyCode === uiGridConstants.keymap.RIGHT ||
                                                                               evt.keyCode === uiGridConstants.keymap.UP ||
                                                                               evt.keyCode === uiGridConstants.keymap.DOWN)) {
                                                                               evt.stopPropagation();
                                                               }

                                                               return true;
                                               });
                                               
                                               scope.stopEdit = function (evt) {
                                                               if (scope.inputForm && !scope.inputForm.$valid) {
                                                                               evt.stopPropagation();
                                                                               scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                                                               }
                                                               else {
                                                                               scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
                                                               }
                                                               scope.deepEdit = false;
                                               };
                                               
                                                               
                                               scope.validateTIME = function(val){
                                                               //TODO: Fer que rebi per paràmetre si ha de ser en format hh:mm o hh:mm:ss.
                                                               //var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
                                                               var regex = /^(?:\d|[01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;                                                                 
                                                               if(val && !regex.test(val)){
                                                                               ngModelController.$setViewValue(null);
                                                                               ngModelController.$render();
                                                               }
                                               };                            

      /*scope.validateTIME = function(value){
        $log.log("validateTIME");
        var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
        return !value || regex.test(value);
      }*/
    }
  }
}]);


angular.module("gp4App").directive('ixUiGridCheckbox', [ 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', 'uiGridEditService', '$log', '$timeout', function(gridUtil, uiGridConstants, uiGridEditConstants, uiGridEditService, $log, $timeout) {
  return {
    restrict: 'EA',
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel' ],
		link: function (scope, elem, attrs, controllers) {
      var hasFocus = false;
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }

			//la llibrería angular-ui-grid es la que s'encarrega de canviar el valor a la propietat focused.
			scope.$watch('focused', function(newVal, oldVal){
				if(newVal){
					$timeout(function(){
						elem.focus();
					});
				}
			});
      elem.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
          case uiGridConstants.keymap.SPACE:
						elem.on('blur',function(){
							elem.focus();
							elem.off("blur");
						});
            break;
        }
		/*
        if (evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN){
          evt.stopPropagation();
        }
		*/
        // Pass the keydown event off to the cellNav service, if it exists
        //else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
		if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }
        return true;
      });


			scope.checkboxClick = function(cell, col) {
				var noeditable = true;
				(typeof(cell.col.colDef.noeditable) == "function") ? noeditable = cell.col.colDef.noeditable(cell) : noeditable = cell.col.colDef.noeditable;
				if(!noeditable){
					var rowEntity = cell.row.entity;  //TODO: revisar el valor que s'enviara
					var oldVal = rowEntity[col.colDef.name];
					if(col.colDef.beforeClick){ col.colDef.beforeClick(cell, col); }
					if(col.colDef.type == "number"){
						//Si es de tipus numeric significa que a les metadates ve com a int, per tant, mantenim el tipus de la variable.
						if(typeof(rowEntity[col.colDef.name]) === "boolean"){
							rowEntity[col.colDef.name] === true ? rowEntity[col.colDef.name] = 1 : rowEntity[col.colDef.name] = 0;
						} else {
							rowEntity[col.colDef.name] === 0 ? rowEntity[col.colDef.name] = 1 : rowEntity[col.colDef.name] = 0;
						}
					} else {

						if(angular.isString(oldVal)){
							oldVal = (oldVal == "True") ? true : false;
							rowEntity[col.colDef.name] = (rowEntity[col.colDef.name] == "True") ? false : true;
						} else {
							oldVal = !oldVal;
							rowEntity[col.colDef.name] = rowEntity[col.colDef.name];
						}
					}
					var newVal = rowEntity[col.colDef.name];
					//Si es fa click a una columna extra tipus Sel, la linea no es marca com dirty.
					if(!cell.col.colDef.isExtraColumn)
						uiGridCtrl.grid.api.rowEdit.setRowsDirty([rowEntity]);

//					if(angular.isDefined(uiGridCtrl.grid.api.cellNav)){
//						var focusedCell = uiGridCtrl.grid.api.cellNav.getFocusedCell();
//
//						if(!cell.col.colDef.ignoreCellModifications)
//							uiGridCtrl.grid.api.edit.raise.afterCellEdit(focusedCell.row.entity, focusedCell.col.colDef, newVal, oldVal);
//
//						if(col.colDef.afterClick){ col.colDef.afterClick(cell, col); }
//					}

					if(!cell.col.colDef.ignoreCellModifications)
						uiGridCtrl.grid.api.edit.raise.afterCellEdit(cell.row.entity, col.colDef, newVal, oldVal);

					ngModelController.$modelValue = rowEntity[col.colDef.name];
				}
			};
      scope.stopEdit = function (evt) {
        //evt.stopPropagation();
        scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
      };
    }
  }
}]);

//Fa el mateix que el ixDatepicker, amb l'afegit que canviar l'estil a position absolute quan el popup esta obert perque es vegi el calendari sencer i marca a dirtyRow la fila quan s'ha editat la cel·la.
angular.module("gp4App").directive('ixUiGridDateEditor', ['$filter', 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', 'cfg', 'moment','ixStatusService', function ($filter, gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, cfg, moment, ixStatusService) {
	  return {
	      restrict: 'E',
	      require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	      scope: {
	    		ngModel: '=',
					name: '@',
          dateLimit: '=?'
	      },
	      template: '<p class="input-group"><input type="text" style="background-color: white; width: 100%;" uib-datepicker-popup datepicker-timezone ng-model="ngModel" datepicker-append-to-body="true" datepicker-options="{maxDate: dateLimit}" show-button-bar="false" is-open="isOpen" placeholder="DD/MM/YYYY" /><span class="input-group-btn"><span class="btn btn-default" ng-click="checkIsOpen()"><i class="glyphicon glyphicon-calendar"></i></span></span></p>',
	      link: function(scope, elem, attrs, controllers) {
          var uiGridCtrl, renderContainerCtrl, ngModelController;
          if (controllers[0]) { uiGridCtrl = controllers[0]; }
          if (controllers[1]) { renderContainerCtrl = controllers[1]; }
          if (controllers[2]) { ngModelController = controllers[2]; }
	    	  var input = elem.children(0).children(0);
              input.on('keypress', function(e){
	    		  var keyCode = (e.which||e.charCode||e.keyCode);
	    		  if("0123456789/-. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
	    				  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
	    				  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
	    				  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
	    		  ) {
							scope.changed = true;
	    			  return true;
	    		  } else {
	    			  e.preventDefault();
	    			  return false;
	    		  }
	    	  });

          $timeout(function(){
            input.focus();
          });

          //
          input.on('keydown', function (evt) {
            switch (evt.keyCode) {
              case uiGridConstants.keymap.ESC:
                evt.stopPropagation();
                scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                break;
							case 8://backspace
								scope.changed = true;
								break;
							case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
							case uiGridConstants.keymap.TAB:
								input.blur();
								evt.stopPropagation();
								evt.preventDefault();
								uiGridCtrl.cellNav.handleKeyDown(evt);
								scope.stopEdit(evt);
								break;
							default:																
								if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
									scope.stopEdit(evt);
								}
								break;
            }			
			
/*
            if (scope.deepEdit &&
              (evt.keyCode === uiGridConstants.keymap.LEFT ||
               evt.keyCode === uiGridConstants.keymap.RIGHT ||
               evt.keyCode === uiGridConstants.keymap.UP ||
               evt.keyCode === uiGridConstants.keymap.DOWN)) {
              evt.stopPropagation();			  
            }	
*/
            return true;
          });


          scope.stopEdit = function (evt) {
            if (scope.inputForm && !scope.inputForm.$valid) {
              evt.stopPropagation();
              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            }
            else {
              scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
            }
            scope.deepEdit = false;
          };
          //

	    	  input.on('blur',function(event){
	    		  var newVal = event.target.value;
						if(angular.isDefined(newVal)){


							var dateParts = newVal.split(/[\/\.\- '\+]{1}/);
							//var now = new Date();
							var now = ixNewDate(cfg, moment);

							var day = now.getDate();
							var month = now.getMonth() + 1;
							var year = now.getFullYear();

							if(dateParts.length==1) {
								if(dateParts[0].length==0) {
									ngModelController.$setViewValue(null);
									ngModelController.$render();

									$timeout(function(){
										scope.dateChanged(event, input);
									});
									return;
								}
								day = dateParts[0].slice(0,2);
								if(dateParts[0].length>2) {
									month = dateParts[0].slice(2,4)
								}
								if(dateParts[0].length>4) {
									year = dateParts[0].slice(4,8);
								}
							}

							if(dateParts[0].length>0 && dateParts[0].length<=2) {
								day = dateParts[0];
							}
							if(dateParts.length>1 && dateParts[1].length>0) {
								month = dateParts[1];
							}
							if(dateParts.length>2 && dateParts[2].length>0) {
								year = dateParts[2];
							}

							if(year.length<=2) {
								// si sintrodueix l'any en 2 dígits, el passem al segle que correspon
								year = parseInt(year) + (now.getFullYear()-(now.getFullYear()%100));
							}

							var keepUTC = true;

							var newDate = ixNewDate(cfg, moment, day, month-1, year, keepUTC);
							if((!ngModelController.$viewValue) || newDate.getTime() !== ngModelController.$viewValue.getTime()){
								ngModelController.$setViewValue(newDate);
							}
							scope.dateChanged(event, input);
						}
	    	});

        scope.dateChanged = function (event, input) {
          if((!event.relatedTarget) || !event.relatedTarget.closest(".ui-grid-cell") || elem.closest(".ui-grid-cell").attr("id") !== angular.element(event.relatedTarget).attr("id")) {
            scope.done = true;
						scope.changed = false;
            scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
          }
        };
        scope.checkIsOpen = function(){
          scope.isOpen = !scope.isOpen;
          if(scope.isOpen){
            elem.parent().parent().css("position", "absolute");
          }
        };

        input.css("z-index", "1051");
        elem.parent().parent().css("width", Number(elem.parent().parent().css("width").replace(/[^\d\.\-]/g, '')));
	    }
	  };
	}]);


/**
 * Directiva y controller para los filtros en el grid
 */
angular.module("gp4App").directive('ixGridFiltro', [ function() {
  return {
    templateUrl: 'app/base/views/helpers_templates/ixGridFiltro.html',
    controller: 'ixGridFiltroController'
  };
}]).controller('ixGridFiltroController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', 'ixUtilsService', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, ixUtilsService ) {
  $scope.showFilterModal = function() {
    //Per defecte tindrem la opció "Según selección" marcada.
    if(angular.isUndefined($scope.col.filters[0].selectionType)){
      $scope.col.filters[0].selectionType = "undefined";
    }
    //Aprofitem que la opció "Limpiar todos los filtros" del angular-ui-grid esborra la propietat condition. Quan s'esborri netejarem el control de cerca.
    if(angular.isUndefined($scope.col.filters[0].condition)){
      $scope.col.filters[0].filtervalue = "";
    }
		$uibModal.open({
			templateUrl: "ixGridFiltroModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		}).result.then(function(){
  		var selectedValues = [];
      if(angular.isDefined($scope.col.filters[0].selectionType) && $scope.col.filters[0].selectionType != "undefined" && $scope.col.filters[0].selectionType != "#lista"){
        selectedValues.push($scope.col.filters[0].selectionType);
      }
			$scope.listOfValues.forEach( function( val ) {
				if(val.selected) {
					selectedValues.push( val.id );
				}
				val.children.forEach(function(v2) {
					v2.children.forEach(function(v3) {
						if(v3.selected){
							selectedValues.push(v3.id);
						}
					});
				});
			});
			if(selectedValues.length == 0)
				$scope.col.filters[0].filtervalue = "";
      //La opció "Limpiar todos los filtros" està inclosa al mòdul angular-ui-grid.
      //Els filtres que nosaltres fem servir són personalitzats, per aquesta raó, al netejar els filtres, la condició que nosaltres apliquem s'esborra.
      //Si això passa, la tornem a assignar.
      if(angular.isUndefined($scope.col.filters[0].condition)){
        $scope.col.filters[0].condition = ixGridColumnFilterCondition();
      }
			$scope.col.filters[0].term = selectedValues.join('|');
			$scope.col.filters[0].numfilters = selectedValues.length;

      var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
      if(angular.isDefined(columnDef)){
        if(selectedValues.length > 0){
          columnDef.enableHiding = false;
        } else {
          columnDef.enableHiding = true;
        }
      }

			//$scope.col.filters[0].condition = new RegExp($scope.col.filters[0].term);
		});

		var distinctValues = {};
  	$scope.listOfValues = [];
		var type = $scope.col.colDef.type;
    var esSearch = $scope.col.colDef.control == "Search";
		var selectedValues = [];
		if($scope.col.filters[0].term) {
			selectedValues=$scope.col.filters[0].term.split("|");
		}

    //Pendiente revisar para ignorar el filtro de la propia columna: ($scope.grid.api.core.getVisibleRows()).forEach(function(obj) {
    //$scope.col.grid.options.data.forEach( function ( row ) {
    filterIgnoringItself().forEach( function ( obj ) {
      var row = obj.entity;
      var selected = "";
      var value = row[$scope.col.field];
      if(value){
        if(type=="date"){
          selected = false;
          var year = value.getFullYear()
          //Agafa el dia i mes actual (sense convertir el datetime actual a UTC, sino agafa el dia anterior ja que la data conte la zona horaria)
          var month = year+"-"+( (value.getMonth() + 1) < 10 ? "0"+(value.getMonth() + 1) : (value.getMonth() + 1) );
          var day = month+"-"+(value.getDate() < 10 ? "0"+value.getDate() : value.getDate() );
          //var month = value.toISOString().substring(0,7);
          //var day =  value.toISOString().substring(0,10);
          if ( !distinctValues[year] ) {
            distinctValues[year]={id:year, label:year, selected:selected, children:[]};
            $scope.listOfValues.push(distinctValues[year]);
          }
          if ( !distinctValues[month] ) {
            distinctValues[month]={id:month, label:$filter("date")(value,"MMMM"), selected:selected, children:[]};
            distinctValues[year].children.push(distinctValues[month])
          }
          if ( !distinctValues[day] ) {
            //distinctValues[day]={id:day,label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
            distinctValues[day]={id:$filter("date")(value,"yyyy-MM-dd"),label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
            distinctValues[month].children.push(distinctValues[day])
          }

        } else if($scope.col.colDef.control == "Search"){
          var lookupresultfields = $scope.col.colDef.LookUpResultFields;
          var fkObjects = $scope.col.colDef.allFkObjects;
          //var object = fkObjects.filter(function(e){ return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value }).map(function(e){
					var object = fkObjects.filter(function(e){ return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value || e[lookupresultfields[2]]==value }).map(function(e){
            var label = e[lookupresultfields[0]];
            if(lookupresultfields.length > 1){
              for(var i = 1; i < lookupresultfields.length; i++){
                if(angular.isDefined(e[lookupresultfields[i]])){
                  label += " - " + e[lookupresultfields[i]];
                }
              }
            }
            return { "clave": e[$scope.col.colDef.LookUpKeyFields[$scope.col.colDef.LookUpKeyFields.length - 1]], "label": label };
          });
          object = object[0];
          if ( !distinctValues[object.label] ) {
            distinctValues[object.label]=true;
            selected = selectedValues.indexOf(object.clave.toString())>=0;
            $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
          }
        } else {
          if ( !distinctValues[value] ) {
            distinctValues[value]=true;
            selected = selectedValues.indexOf(value.toString())>=0;
            $scope.listOfValues.push({id:value, label:value, selected:selected, children:[]});
          } else {
            //$scope.listOfValues[0].children.push({label:value,selected:false});
          }

        }
      }
    });
    //Sort recursive.
    sortListOfValues($scope.listOfValues);
  };

  $scope.filtrarFiltervalue = function(item) {
    return ixUtilsService.comparar(item.label,$scope.col.filters[0].filtervalue)!=-1;
  }

	$scope.filterList = function(item, B) {		
		var listValues = $scope.col.filters[0].filtervalue.split("\n");
		for (var i = 0, len = listValues.length; i < len; i++) {
			if(ixUtilsService.comparar(item.label.toString(),listValues[i]) !== -1) {			
				return true;
			}			
		}
		return false;
	};
	
  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children;// && obj.children.length > 1;
  };

  var filterIgnoringItself = function(){
    var gridFilters = $scope.col.grid.columns.filter(function(column){ return column.field !== $scope.col.field && angular.isDefined(column.filter.term) && column.filter.term !== null && column.filter.term !== ""; });
    var dataRows = $scope.col.grid.rows;

    var filteredDataRows = dataRows.filter(function(_row){
      var isMatch = true;
      angular.forEach(gridFilters, function (_filter) {
        isMatch = isMatch && _filter.filter.condition(_filter.filter.term, _row.entity[_filter.field], _row, _filter);
      });

      return isMatch;
    });
    return filteredDataRows;
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.col.filters[0].filtervalue != null){
			var listValues = $scope.col.filters[0].filtervalue.toUpperCase().split("\n");			
			angular.forEach($scope.listOfValues, function(value){
      	for (var i = 0, len = listValues.length; i < len; i++) {
					if(ixUtilsService.comparar(value.label.toString(),listValues[i]) !== -1) {			
						matchingValues.push(value);
						break;
					}			
				}  
      });			
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.selectAllNotEmpty = function(){
    $scope.selectionType = "*";
  };

  $scope.selectAllEmpty = function(){
    $scope.selectionType = "\"\"";
  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.col.filters[0].filtervalue = "";
  };

	$scope.deslectAllAndApply = function() {		
		$scope.col.filters[0].filtervalue = "";		
		$scope.col.filters[0].condition = ixGridColumnFilterCondition();
		$scope.col.filters[0].term = "";
		$scope.col.filters[0].numfilters = 0;
		var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
		columnDef.enableHiding = true;		
	};
}]);


angular.module("gp4App").directive('ixGridFiltroServidor', [ function(){
  return {
    //restrict: 'E',
    templateUrl: 'app/base/views/helpers_templates/ixGridFiltroServidor.html',
    //scope: false,
    controller: 'ixGridFiltroServidorController'
  };
}]).controller('ixGridFiltroServidorController', [ '$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', 'ixUtilsService', '$http', function($scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, ixUtilsService, $http){
  //TODO: Aixo s'haurà de mirar per tal de fer-ho més dinàmic.
	var numfilters;
  if($scope.col.colDef.filteropt == "Fecha"){
    var num = 0;
    if($scope.col.colDef.filters[0].data_ini != null) num++;
    if($scope.col.colDef.filters[0].data_fi != null) num++;
    $scope.col.filters[0].numfilters = num;
  } else if($scope.col.colDef.filteropt == "Texto"){
    numfilters = angular.isDefined($scope.col.filters[0].term) ? $scope.col.filters[0].term.split("|") : [];
    $scope.col.filters[0].numfilters = numfilters.length;
  } else if($scope.col.colDef.filteropt == "Numero"){
    numfilters = angular.isDefined($scope.col.filters[0].term) ? $scope.col.filters[0].term.split("|") : [];
    $scope.col.filters[0].numfilters = numfilters.length;
  }
  //


  $scope.showFilterModal = function() {
    convertDateStringsToDates($scope.col.filters[0]);
		$uibModal.open({
			templateUrl: "ixGridFiltroServidorModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		}).result.then(function(){
      //TODO: Passar type a la directiva. Si és date, llavors passem dos paràmetres com filtre >= data_ini <= data_fi.
      convertDateStringsToDates($scope.col.filters[0]);
      //TODO: Aixo s'haurà de mirar per tal de fer-ho més dinàmic.
      var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
			var selectedValues = [];
      if($scope.col.colDef.filteropt == "Fecha"){
        var num = 0;
        if($scope.col.colDef.filters[0].periodo_ini != null) num++;
        else if($scope.col.colDef.filters[0].data_ini != null) num++;
        if($scope.col.colDef.filters[0].periodo_fin != null) num++;
        else if($scope.col.colDef.filters[0].data_fi != null) num++;
        $scope.col.filters[0].numfilters = num;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

      } else if($scope.col.colDef.filteropt == "Texto"){
        
        $scope.listOfValues.forEach( function( val ) {
          if(val.selected) {
            if(val.id.indexOf('-') !== -1){
              //var partsId = val.id.split('-');
              //var valId = partsId[partsId.length - 1].replace(/\s+/g, '');
              var valId = val.id.substr(0, val.id.lastIndexOf('-'));
              valId = valId.trim();
              selectedValues.push( valId );
            } else {
              selectedValues.push( val.id );
            }
          }
          val.children.forEach(function(v2) {
            v2.children.forEach(function(v3) {
              if(v3.selected){
                selectedValues.push(v3.id);
              }
            });
          });
        });

				if(selectedValues.length == 0)
					$scope.col.filters[0].filtervalue = "";

        $scope.col.filters[0].term = selectedValues.join('|');
        $scope.col.filters[0].numfilters = selectedValues.length;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

        //$scope.col.filters[0].condition = new RegExp($scope.col.filters[0].term);
        $scope.col.filters[0].condition = $scope.col.filter.condition;
      } else if($scope.col.colDef.filteropt == "Numero"){        
        $scope.listOfValues.forEach( function( val ) {
          if(val.selected) {
            if(val.id.indexOf('-') !== -1){              
              //var valId = val.id.substr(1, val.id.lastIndexOf('-'));
							var valId = val.id.split("-")[1];							
              valId = valId.trim();
              selectedValues.push( valId );
            } else {
              selectedValues.push( val.id );
            }
          }
          val.children.forEach(function(v2) {
            v2.children.forEach(function(v3) {
              if(v3.selected){
                selectedValues.push(v3.id);
              }
            });
          });
        });

				if(selectedValues.length == 0)
					$scope.col.filters[0].filtervalue = "";

        $scope.col.filters[0].term = selectedValues.join('|');
        $scope.col.filters[0].numfilters = selectedValues.length;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

        //$scope.col.filters[0].condition = new RegExp($scope.col.filters[0].term);
        $scope.col.filters[0].condition = $scope.col.filter.condition;
      }
      //
      $scope.applyFiltersToGrid();
		});


    //Aixo es per quan es tipus Texto:
		var distinctValues = {};
		var type;
		var selectedValues = [];
    if($scope.col.colDef.filteropt == "Texto"){      
      $scope.listOfValues = [];
      type = $scope.col.colDef.type;
      //var esSearch = $scope.col.colDef.control == "Search";
      
      if($scope.col.filters[0].term) {
        selectedValues=$scope.col.filters[0].term.split("|");
      }
      /*if(!$scope.col.filters[0].numfilters){
        $scope.col.filters[0].numfilters = 0;
      }*/

      //$scope.col.grid.options.data.forEach( function ( row ) {
      $scope.col.colDef.listValues.forEach(function(value){
        //var value = row[$scope.col.field];
        if(value){
          //Per ara nomes tenim fets els camps string
          /*if($scope.col.colDef.control == "Search"){
            var filtersKey = $scope.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
              if(ii!==aa.length-1) {
                return {Field: c, Value: row[$scope.col.colDef.KeyFields[ii]]};
              }
            });
            var lookupresultfields = $scope.col.colDef.LookUpResultFields;

            var fkObjects = $scope.col.colDef.allFkObjects;

            var object = fkObjects.filter(function(e){
              return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value && (angular.isDefined(filtersKey[0]) ? e[filtersKey[0].Field] == filtersKey[0].Value : true);
            }).map(function(e){ return { "clave": value, "label": e[lookupresultfields[0]] + " - " + e[lookupresultfields[1]] }; });
            object = object[0];
            if ( !distinctValues[object.label] ) {
              distinctValues[object.label]=true;
              var selected = selectedValues.indexOf(object.clave.toString())>=0;
              $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
            }
          } else {*/
            if ( !distinctValues[value] ) {
              distinctValues[value]=true;
              var selected = selectedValues.indexOf(value.toString())>=0 || selectedValues.indexOf(value.substr(0, value.lastIndexOf('-')).trim()) >= 0;
              //if(selected) $scope.col.filters[0].numfilters++;
              $scope.listOfValues.push({id:value, label:value, selected:selected, children:[]});
            } else {
              //$scope.listOfValues[0].children.push({label:value,selected:false});
            }

          //}
        }
      });
      //Sort recursive.
      sortListOfValues($scope.listOfValues);
    } else if($scope.col.colDef.filteropt == "Numero"){
      
      $scope.listOfValues = [];
      type = $scope.col.colDef.type;
      //var esSearch = $scope.col.colDef.control == "Search";
      
      if($scope.col.filters[0].term) {
        selectedValues=$scope.col.filters[0].term.split("|");
      }
      /*if(!$scope.col.filters[0].numfilters){
        $scope.col.filters[0].numfilters = 0;
      }*/

      //$scope.col.grid.options.data.forEach( function ( row ) {
      $scope.col.colDef.listValues.forEach(function(value){
        //var value = row[$scope.col.field];
        if(value){
          //Per ara nomes tenim fets els camps string
          /*if($scope.col.colDef.control == "Search"){
            var filtersKey = $scope.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
              if(ii!==aa.length-1) {
                return {Field: c, Value: row[$scope.col.colDef.KeyFields[ii]]};
              }
            });
            var lookupresultfields = $scope.col.colDef.LookUpResultFields;

            var fkObjects = $scope.col.colDef.allFkObjects;

            var object = fkObjects.filter(function(e){
              return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value && (angular.isDefined(filtersKey[0]) ? e[filtersKey[0].Field] == filtersKey[0].Value : true);
            }).map(function(e){ return { "clave": value, "label": e[lookupresultfields[0]] + " - " + e[lookupresultfields[1]] }; });
            object = object[0];
            if ( !distinctValues[object.label] ) {
              distinctValues[object.label]=true;
              var selected = selectedValues.indexOf(object.clave.toString())>=0;
              $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
            }
          } else {*/
            if ( !distinctValues[value] ) {
              distinctValues[value]=true;
              var selected = selectedValues.indexOf(value.toString())>=0 || selectedValues.indexOf(value.substr(1, value.lastIndexOf('-')).trim()) >= 0;
              //if(selected) $scope.col.filters[0].numfilters++;
              $scope.listOfValues.push({id:value, label:value, selected:selected, children:[]});
            } else {
              //$scope.listOfValues[0].children.push({label:value,selected:false});
            }

          //}
        }
      });
      //Sort recursive.
      sortListOfValues($scope.listOfValues);
    }
  };

  $scope.loadTiposFecha = function(){
    return $http.get(cfg.baseURL + "tipos_fecha").then(function(response){
      var result = [];
      if(response.data != null){
        result = response;
      }
      return result;
    }, function(err){
      ixStatusService.setResponse(err);
    });
  };

  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children && obj.children.length > 1;
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.col.filters[0].filtervalue != null){
      angular.forEach($scope.listOfValues, function(value){
        if(ixUtilsService.comparar(value.label.toString(),$scope.col.filters[0].filtervalue) !== -1){
         matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.col.filters[0].filtervalue = "";
  };

  $scope.applyFiltersToGrid = function(){
    $scope.col.grid.options.ixLoadInitialData();
  };
}]);


//Directiva dels dialegs modals que s'obren a través de la app:

angular.module("gp4App").directive('ixGridModal', [ function(){
  return {
    scope: {
      colDisplayname: '=',
      colField: '=',
      entity: '=',
      isNew: '='
    },
    templateUrl: 'app/base/views/helpers_templates/ixGridModal.html',
    controller: 'ixGridModalController'
  };
}]).controller('ixGridModalController', ['$rootScope','$scope','$compile', '$timeout', '$filter', 'cfg', '$http', 'ixStatusService', function($rootScope, $scope, $compile, $timeout, $filter, cfg, $http, ixStatusService){
  if(!ixStatusService.current.data.grid.delayedActions){
    ixStatusService.current.data.grid.delayedActions = [];
  }

  $scope.colDisplayname = $scope.$parent.colDisplayname;
  $scope.colField = $scope.$parent.colField;
  $scope.entity = $scope.$parent.gridEntity;
  $scope.isNew = $scope.$parent.isNew;

  var popup = angular.element('ix-grid-modal');
  $scope.closePopup = function () {
    if(popup){
      popup.remove();
    }
  };

  $scope.saveData = function () {
    if(Object.keys($scope.modalForm.$error).length === 0){
      var data = $scope.$parent.buildPK($scope.$parent.entityObj);
      data["new"+$scope.colField] = $scope.modify_value;
      if($scope.isNew){
				$scope.$parent.entityObj[$scope.colField] = $scope.modify_value;
        //Si l'usuari és nou, guardem l'attempt per més tard.
        //data.url = cfg.baseURL + $scope.entity + "/Reset"+$scope.colDisplayname;
        //ixStatusService.current.data.grid.delayedActions.push( data );
        $scope.closePopup();
      } else {
        $http.post(cfg.baseURL + $scope.entity + "/Reset"+$scope.colDisplayname, data).then(function(r){
            ixStatusService.setResponse(r);
            $scope.closePopup();
        }, function(err){
					ixStatusService.setResponse(err);
				});
      }
    }
  };

}]);

angular.module("gp4App").directive('ixMegawhere', [ function(){
  return {
    restrict: 'E',
    templateUrl: 'app/base/views/helpers_templates/ixMegawhere.html',
    controller: 'ixMegawhereController'
  };
}]).controller('ixMegawhereController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){
  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.openWindow = function(size){
    if(ixStatusService.current.editing){

      $scope.gridmegawhere = gridService.createGrid($scope, "extranet_condition_userGrid",  {}, "extranet_condition_user");

      $scope.gridmegawhere.entity = "extranet_condition_user";

      $scope.ixEditar = $scope.gridmegawhere.ixEditar;
      $scope.ixCancelEdit = $scope.gridmegawhere.ixCancelEdit;
      $scope.ixAddRow = $scope.gridmegawhere.ixAddRow;
      $scope.ixDeleteSelectedRows = $scope.gridmegawhere.ixDeleteSelectedRows;
      //$scope.ixDownloadExcel = $scope.gridmegawhere.ixDownloadExcel;
      $timeout(function(){
        $scope.numberOfChanges = $scope.gridmegawhere.numberOfChanges;
      });
      $scope.updateIxGuardarTooltip = $scope.gridmegawhere.updateIxGuardarTooltip;
      $scope.ixGuardar = $scope.gridmegawhere.ixGuardar;

      //Buscar només tot el que estigui relacionat amb l'usuari.
      $scope.gridmegawhere.filtroExterno = {username:$scope.row.entity.usuario};

      $scope.gridmegawhere.ixLoadInitialData();



      $uibModal.open({
        templateUrl: "ixMegawhereModal.html",
        scope: $scope,
        size: size,
        windowClass: 'megawhere-popup',
        backdrop: 'static',
        keyboard: false
      }).result.then(function(){

      });
    }
  };
}]);
//TODO: Simplificar directiva de manera que al final rebi els paràmetres:
//{icon:"", title:"", action:function(obj){ $uibModal.open(template, size,...)},  visible: function(obj) {if(obj.Filterloquesea...)}}
/*angular.module("gp4App").directive('ixDetallePopup', [ 'gridService', '$uibModal', 'ixStatusService', '$http', 'cfg', '$filter', function(gridService, $uibModal, ixStatusService, $http, cfg, $filter){
  return {
    restrict: 'E',
    scope: {
      title: '@',
      pks: '@',
      viewmodel: '@'
    },
    template: '<div ng-dblclick="open()" class ="ui-grid-cell-contents"><i ng-click="open()" title="Petición servicio" class="fa fa-fw fa-window-maximize"></i></div>',
    link: function(scope, element, attrs){

      scope.status = ixStatusService.current;

      scope.loadPeticionServiciosSolicitar = function(){
        if(scope.serviciosPDI != null){
          var urlAttr = "?pdi="+scope.serviciosPDI+"&VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          return $http.get(cfg.baseURL+scope.grid1.entity+urlAttr).then(function(response) {
            //Per a cada crida s'actualitzarà la data d'informació generada.
            scope.grid1.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
            scope.grid1.data = response.data;
            //S'esta editant.
            scope.grid1.gridApi.ix.status.editing = true;
          }, function (response) {
            ixStatusService.setResponse(response);
          });
        }
      };

      scope.loadPeticionServiciosAccesorios = function(){
        if(scope.serviciosPDI != null){
          var urlAttr = "?pdi="+scope.serviciosPDI+"&VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          return $http.get(cfg.baseURL+scope.grid2.entity+urlAttr).then(function(response) {
            //Per a cada crida s'actualitzarà la data d'informació generada.
            scope.grid2.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
            scope.grid2.data = response.data;
            //S'esta editant.
            scope.grid2.gridApi.ix.status.editing = true;
          }, function (response) {
            ixStatusService.setResponse(response);
          });
        }
      }

      scope.loadPeticionServiciosHistorico = function(){

        var urlAttr = "?VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
        return $http.get(cfg.baseURL+scope.grid3.entity+urlAttr).then(function(response) {
          //Per a cada crida s'actualitzarà la data d'informació generada.
          scope.grid3.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
          scope.grid3.data = response.data;
        }, function (response) {
          ixStatusService.setResponse(response);
        });

      }

      scope.loadData = function(){
        scope.grid1.ixLoadInitialData();
        scope.grid2.ixLoadInitialData();
      }

      scope.cellEditableCondition = function (cell) {
        return !cell.col.colDef.noeditable && (!cell.col.colDef.pk || cell.row.entity.isNew );
      };

      scope.open = function(){
        if(typeof(scope.viewmodel) == "string"){
          scope.viewmodel = scope.viewmodel.split(",");
        }
        if(typeof(scope.pks) == "string"){
          scope.pks = scope.pks.split(",");
        }
        if(!scope.grid1){
          scope.grid1 = gridService.createGrid(scope, scope.viewmodel[0]+"Grid",  { enableCellEdit: true, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[0], [{ name: 'Cancelar servicio', type: 'CheckBox' }]);
          scope.grid1.entity = "peticion_servicios/solicitar";

          scope.grid1.ixLoadInitialData = scope.loadPeticionServiciosSolicitar;
          scope.grid1.cellEditableCondition = scope.cellEditableCondition;
        }

        if(!scope.grid2){
          scope.grid2 = gridService.createGrid(scope, scope.viewmodel[1]+"Grid",  { enableCellEdit: true, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[1],  [{ name: 'Asignar accesorio', type: 'CheckBox' }]);
          scope.grid2.entity = "peticion_servicios/accesorios";
          scope.grid2.ixLoadInitialData = scope.loadPeticionServiciosAccesorios;
          scope.grid2.cellEditableCondition = scope.cellEditableCondition;
        }

        if(!scope.grid3){
          scope.grid3 = gridService.createGrid(scope, scope.viewmodel[1]+"Grid",  { enableCellEdit: false, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[2]);
          scope.grid3.entity = "peticion_servicios/historico";
          scope.grid3.ixLoadInitialData = scope.loadPeticionServiciosHistorico;
          scope.grid3.ixLoadInitialData();
        }

        scope.titleVal = scope.$parent.row.entity[scope.pks[0]];
        $uibModal.open({
					templateUrl: 'Extranet/Peticion_servicios_popup.html?'+v,
					size: 'big',
          scope: scope
				});
      };

      scope.save = function(){
        scope.idServicios = new Array();
        scope.grid1.data.forEach(function(rowOri){
          var cancelado = false;
          scope.grid1.gridApi.rowEdit.getDirtyRows().forEach(function(rowMod){
            if(rowOri.trabajo == rowMod.entity.trabajo && rowMod.entity["Cancelar servicio"] == true){
              cancelado = true;
            }
          });
          if(!cancelado){
            scope.idServicios.push(rowOri.trabajo);
          }
        });
        scope.grid2.gridApi.rowEdit.getDirtyRows().forEach(function(rowMod){
          if(rowMod.entity["Asignar accesorio"] == true){
            scope.idServicios.push(rowMod.entity.trabajo);
          }
        });
        if(scope.idServicios.length > 0){
          var urlAttr = "?VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          $http.post(cfg.baseURL + "peticion_servicios/Set"+urlAttr, { idServicios: scope.idServicios }).then(function(response){
            //Show success
            scope.grid1.ixLoadInitialData();
            scope.grid2.ixLoadInitialData();
            scope.grid3.ixLoadInitialData();
            if(ixStatusService.current.data != null)
              ixStatusService.current.data.grid.ixLoadInitialData();

          }, function(response){
            //Show error.


          });
        }
      }
    }
  }
}]);*/
//Botonets d'acció en general.
angular.module("gp4App").directive('ixAccion', [ '$timeout', 'ixStatusService', '$uibModal', 'cfg', function($timeout, ixStatusService, $uibModal, cfg) {
  return {
    restrict: 'A',
    scope: {
      'item': '=',
      'accion': '=',
			'itemAux': '=?'
    },
    link: function(scope, elem, attrs){
      elem.addClass("accion");
      elem.on('click', function(event){

				if(angular.isFunction(scope.item)){
					if(angular.isDefined(scope.itemAux)){
						scope.item = scope.item(scope.itemAux);
					} else {
						scope.item = scope.item();
					}
				}

				if((angular.isUndefined(scope.accion.isDisabled)) || (angular.isDefined(scope.accion.isDisabled) && !scope.accion.isDisabled(scope.item))){
					if(scope.accion.accion)
						scope.accion.accion(scope.item);
					else {
						var atributos = {};
						var atributosTitleObj = {};
						var displayAttr = "";
						if(typeof(scope.accion.redirect.atributos) == "string"){
							scope.accion.redirect.atributos = scope.accion.redirect.atributos.split(",");
						}
						if(typeof(scope.accion.redirect.atributosTitle) == "string"){
							scope.accion.redirect.atributosTitle = scope.accion.redirect.atributosTitle.split(",");
						}
						scope.accion.redirect.atributos.forEach(function(valor){
							if (scope.item[valor] != undefined)
								atributos[valor] = scope.item[valor];
							else
								atributos[valor] = valor;
						});
						scope.accion.redirect.atributosTitle.forEach(function(valor){
							var partsValor = valor.split("$");
							if(partsValor.length > 1){
								displayAttr += " - " + partsValor[0] + " " + scope.item[partsValor[1]];
								atributosTitleObj[partsValor[1]] = scope.item[partsValor[1]];
							}
							else {
								displayAttr += " - " + partsValor[0] + " " + scope.item[partsValor[0]];
								atributosTitleObj[partsValor[0]] = scope.item[partsValor[0]];
							}
						});
						var app = {};
						var claves = Object.keys(atributos);
						app.icon = scope.accion.redirect.iconBox;
						app.display = scope.accion.title/* + displayAttr*/;
						app.href = scope.accion.redirect.template;
						app.atributos = atributos;
						app.atributosTitle = displayAttr;
						app.atributosTitleObj = atributosTitleObj;
						$timeout(function(){
							ixStatusService.openApp(app).bind(ixStatusService);
						},1);
					}
				}
      });
    }
  }
}]);
//Botonets d'acció dintre d'una grid.
angular.module("gp4App").directive('ixAccionGrid', [ '$timeout', 'ixStatusService', '$uibModal', 'cfg', function($timeout, ixStatusService, $uibModal, cfg) {
  return {
    restrict: 'EA',
    scope: {
      'index': '@'
    },
    template: '<span title="{{ accionDef.title || accionDef.titleFunction(entity) }}" ng-show="visibleFunction(entity) || visibleFunction == undefined" ng-dblclick="actionFunction(entity)">'+
		'<i ng-style="getStyleFunction(entity)" ng-show="!accionDef.customType" ng-click="actionFunction(entity)" class="fa fa-fw" ng-class="accionDef.icon" ></i>'+
		'<img ng-style="getStyleFunction(entity)" ng-if="accionDef.customType" ng-click="actionFunction(entity)" ng-src="{{ accionDef.icon }}" />'+
		'<span ng-show="showBadgeFunction(entity) && showBadgeFunction(entity) != 0" class="badge">{{ showBadgeFunction(entity) }}</span><span ng-show="accionDef.showValueFunction(entity)">{{ accionDef.showValueFunction(entity) }}</span></span>',
    controller: function($scope){
      var colDef = $scope.$parent.col.colDef;
      var row = $scope.$parent.row;
			$scope.accionDef = colDef.acciones[$scope.index];
			$scope.entity = row.entity;
      //si es visible.
      if($scope.accionDef.visible){
        $scope.visibleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.visible($scope.entity);
        };
      }
      //si ha de mostrar alguna mena de contador.
      if($scope.accionDef.showBadge){
        $scope.showBadgeFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.showBadge($scope.entity);
        };
      }
      //Si te algun estil especial aplicat desde el controller.
      if($scope.accionDef.getStyle){
        $scope.getStyleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.getStyle($scope.entity);
        };
      }
      //Si el titol s'ha de calcular al controller mitjançant alguna funció.
      if($scope.accionDef.titleFunction && typeof $scope.accionDef.titleFunction == 'function'){
        $scope.titleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.titleFunction($scope.entity);
        }
      }
      //Si el valor s'ha de calcular al controller mitjançant alguna funció.
      if($scope.accionDef.showValueFunction && typeof $scope.accionDef.showValueFunction == 'function'){
        $scope.showValueFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.showValueFunction($scope.entity);
        }
      }
			if($scope.accionDef.accion) {
				//$scope.actionFunction = $scope.accionDef.accion.bind($scope.accionDef);
        $scope.actionFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            //$scope.accionDef.accion($scope.entity).bind($scope.accionDef);
            $scope.accionDef.accion($scope.entity, $scope.$parent.col.grid);
          }
        };
      } else if($scope.accionDef.redirect){
        var atributos = {};
        var displayAttr = "";
        if(typeof($scope.accionDef.redirect.atributos) == "string"){
          $scope.accionDef.redirect.atributos = $scope.accionDef.redirect.atributos.split(",");
        }
        if(typeof($scope.accionDef.redirect.atributosTitle) == "string"){
          $scope.accionDef.redirect.atributosTitle = $scope.accionDef.redirect.atributosTitle.split(",");
        }
        $scope.actionFunction = function() {
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            $scope.accionDef.redirect.atributos.forEach(function(valor){
              atributos[valor] = $scope.entity[valor];
            });
            $scope.accionDef.redirect.atributosTitle.forEach(function(valor){
              displayAttr += " - " + valor + " " + $scope.entity[valor];
            });
            var app = {};
            var claves = Object.keys(atributos);
            app.icon = $scope.accionDef.redirect.iconBox;
            app.display = $scope.accionDef.title + displayAttr;
            app.href = $scope.accionDef.redirect.template;
            app.atributos = atributos;
						app.multiple = $scope.accionDef.redirect.multiple;
            ixStatusService.openApp(app).bind(ixStatusService);
          }
        };
			} else {
				$scope.actionFunction = function() {
          var currentStatus = ixStatusService.current.editing;
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            $uibModal.open({
              templateUrl: $scope.accionDef.template,
              size: $scope.accionDef.size ? $scope.accionDef.size : 'big',
              scope: $scope,
              backdrop: 'static',
              keyboard: false
            }).result.then(function(response){
              if(cfg.clientId == "Extranet"){
                ixStatusService.setEditing(currentStatus);
              }
              if(angular.isDefined($scope.accionDef.onClose)){
                $scope.accionDef.onClose(response);
              }
            });
          }
				};
			}
    }
		/*
    link: function(scope, elem, attrs){
			scope.accion = scope.col.colDef.acciones[scope.index];
			scope.actionFunction = scope.accion.bind(scope.row.entity);
    }
		*/
  }
}])/*.controller("ixAccionCtrl", ['$scope', function($scope){
  console.log("ixAccionCtrl");
  console.log($scope);
}])*/;

angular.module("gp4App").directive('ixDetalle', [ 'ixStatusService', '$httpParamSerializer', function(ixStatusService, $httpParamSerializer){
  return {
    restrict: 'E',
    template: '<div ng-dblclick="goTo()" class ="ui-grid-cell-contents"><i ng-click="goTo()" title="Ver detalles" class="fa fa-fw fa-window-maximize"></i></div>',
    link: function(scope, element, attr){
      scope.goTo = function(){
        var atributos = {};
        scope.atributos = attr.atributos.split(",");
        scope.atributos.forEach(function(valor){
          atributos[valor] = scope.row.entity[valor];
        });
        var item = {};
        var claves = Object.keys(atributos);
        item.display = attr.title + " - " + claves[0] + atributos[claves[0]];
        item.href = attr.url;
        item.atributos = atributos;

        ixStatusService.openApp(item);
      }
    }
  };
}]);

angular.module("gp4App").directive('ixDatetimeGridGenerada', [ 'ixStatusService', function(ixStatusService){
  return {
    scope: {
      grid: '='
    },
    template: "<div style=\"display: block; width:100%;\">"+
    "<span style=\"display: block; float: left;\">{{'search.totalItems' | t}} {{grid.gridApi.grid.rows.length}}</span>"+
    "<span style=\"display: block; float: left;\" ng-if=\"grid.gridApi.grid.renderContainers.body.visibleRowCache.length !== grid.gridApi.grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.gridApi.grid.renderContainers.body.visibleRowCache.length}})</span>"+
    "<span style=\"display: block; float:right;\" ng-if=\"grid.generadaEl\"><translate translate-value-generadael=\"{{grid.generadaEl}}\">{{ 'Información generada el \\{\\{ generadael \\}\\}' }}</translate> - <a ng-click=\"actualizar()\"><translate>Actualizar</translate></a></span>"+
    "</div>",
    link: function(scope, ele, attrs){
      //scope.grid = ixStatusService.current.data.grid;
      scope.actualizar = function(){
        if(ixStatusService.current.editing && scope.grid.numberOfChanges() > 0){
          scope.grid.ixCancelEdit();
        } else {
          scope.grid.ixLoadInitialData();
        }
      }
    }
  }
}]);

angular.module('gp4App').directive('ixGridMultipleSelect', [ function() {
  return {
		scope: {
      ngModel: '=',
      valor: '@'
    },
    require: 'ngModel',
    replace: true,
		template: '<div><i ng-click="showModalSelection()" class="fa fa-search" style="position:contents;"></i>{{ valor }}<input type="text" ng-model="ngModel" style="width:0px;position:fixed;left:-20px;" readonly></input></div>',
    controller: 'ixGridMultipleSelectController'
  };
}]).controller('ixGridMultipleSelectController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', 'ixUtilsService', 'uiGridEditConstants', '$element', '$translate', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, ixUtilsService, uiGridEditConstants, $element, $translate) {
  var ngModel = $element.controller('ngModel');
	$scope.nombrecolumna = $scope.$parent.col.colDef.displayName;

	$scope.input = ($element.children())[1];
	$timeout(function(){
		$scope.input.focus();
	});
	angular.element($scope.input).on('blur',function(event){
		$timeout(function(){
			if(!$scope.clickEnLupa){
				if(((event.relatedTarget == null) || event.relatedTarget == $scope.input || $scope.opened)){
					$scope.clickEnLupa = true;
					$scope.input.focus();
				} else {
					$timeout(function(){
						$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
					});
				}
			}
		},250);
	});


  $scope.selectedOptions = $scope.valor;
  $scope.searchvalue = "";
  $scope.showModalSelection = function() {
		$scope.opened = true;
		//donar focus
		$uibModal.open({
			templateUrl: "ixGridMultipleSelectModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		}).result.then(function(aplicar){
			$scope.opened = false;
			$scope.clickEnLupa = false;

			if(aplicar){
				var selectedValues = [];
				$scope.optionValues.forEach( function( val ) {
					if(val.selected) {
						selectedValues.push( val.id );
					}
					val.children.forEach(function(v2) {
						v2.children.forEach(function(v3) {
							if(v3.selected){
								selectedValues.push(v3.id);
							}
						});
					});
				});
				$scope.selectedOptions = selectedValues.join(',');
				if(selectedValues.length == 0)
					ngModel.$setViewValue(null);
				else
					ngModel.$setViewValue($scope.selectedOptions);
			}

			$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
		});

    var distinctValues = {};
    $scope.optionValues = [];
    var selectedValues = [];
    if($scope.selectedOptions) {
      selectedValues=$scope.selectedOptions.split(",");
    }
    var lookupresultfields = $scope.$parent.col.colDef.LookUpResultFields;
    angular.forEach($scope.$parent.col.colDef.allFkObjects, function(obj){
      var value = "";
      var clave = "";
      angular.forEach(lookupresultfields, function(lookupresultfield){
        if(value !== "") value = value + " - ";
        value = value + obj[lookupresultfield];
        clave = obj[$scope.$parent.col.colDef.LookUpKeyFields[0]];
      });
      distinctValues[value]=true;
      var selected = (selectedValues.indexOf(clave)>=0 || selectedValues.indexOf(clave.toString())>=0);
      $scope.optionValues.push({id:clave, label:value, selected:selected, children:[]});
    });

    //Sort recursive.
    sortListOfValues($scope.optionValues);
  };

  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children && obj.children.length > 1;
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchvalue != null){
      angular.forEach($scope.optionValues, function(value){
        if(ixUtilsService.comparar(value.label,$scope.searchvalue) !== -1){
         matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.optionValues);
    }

  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.optionValues);
		$scope.col.filters[0].filtervalue = "";
  };



  $scope.filterValue = function(v,i,a) {
    return ixUtilsService.comparar(v.label,$scope.searchvalue)>=0;
  }

}]);

/////

angular.module('gp4App').directive('ixGridSelect', [ 'gridService', '$uibModal', 'ixStatusService', 'uiGridEditConstants', 'uiGridConstants', '$timeout', function(gridService, $uibModal, ixStatusService, uiGridEditConstants, uiGridConstants, $timeout) {
  return {
    restrict: 'EA',
		scope: {
      ngModel: '=',
      valor: '@'
    },
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    template: '<p class="input-group"><input style="width:calc(100% - 20px);" type="text" ng-model="ngModel" ix-number><i style="text-align:center;width:20px;" ng-click="showModalSelection()" class="fa fa-search"></i></input></p>',
    link: function(scope, elem, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }
      var input = elem.children(0).children(0);

      scope.selectedOptions = scope.valor;
      scope.searchvalue = "";
      scope.showModalSelection = function() {
        scope.modalDialog = $uibModal.open({
          templateUrl: "ixGridSelectModal.html",
          scope: scope,
          size: "big",
          backdrop: 'static',
          keyboard: false
        });
        scope.modalDialog.result.then(function(){
          ngModelController.$setViewValue(scope.ngModel);
          $timeout(function(){
            input.focus();
          });
          //scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        });
      };

      if(!scope.gridSeleccion){
        var acciones = [
          {
            icon: "fa-eye",
            title: "Seleccionar",
            accion: function(entity){
              scope.ngModel = entity.operacion;
              //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
              setValue(entity);
              scope.modalDialog.close();
              return true;
            }
          }
        ];

        var visibleCols = [];
        var filtersApi = [];
				var params = [];
        //var visibleCols = (scope.showOnlyDescribedCols) ? scope.showOnlyDescribedCols : [];
        //var filtersApi = ($scope.filtersApi) ? $scope.filtersApi : [];

        //
        //No es poden accedir propietats de l'objecte colDef del angular-ui-grid.
        //
        if(scope.$parent.col.colDef.LookUpTableName == "operaciones"){
          visibleCols = [ 'operacion', 'medio', 'fecha', 'fechape', 'estado', 'barco', 'num_viaje', 'num_atraque', 'num_carpeta' ];
          filtersApi = [{ field: "fecha", type: "Fecha"}];
					params = scope.$parent.col.colDef.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ};});					
        }

        scope.gridSeleccion = gridService.createGrid(scope, "selectFromGrid_"+scope.$parent.col.colDef.LookUpTableName+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, enableCellEdit: false, filtersAPI: filtersApi }, scope.$parent.col.colDef.LookUpTableName, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);				
				scope.gridSeleccion.filtroExterno = params;
				
      } else {
        scope.gridSeleccion = gridService.createGridFunctions(scope, scope.gridSeleccion);
        scope.gridSeleccion.ixRestoreConfig();
      }

      var setValue = function(entity){
        scope.valor = scope.ngModel;
      };

      $timeout(function(){
        input.focus();
      });

      //
      input.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }
/*
        if (scope.deepEdit &&
          (evt.keyCode === uiGridConstants.keymap.LEFT ||
           evt.keyCode === uiGridConstants.keymap.RIGHT ||
           evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN)) {
          evt.stopPropagation();
        } */
        // Pass the keydown event off to the cellNav service, if it exists
        //else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
		if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {			
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });


      scope.stopEdit = function (evt) {
        if (scope.inputForm && !scope.inputForm.$valid) {
          evt.stopPropagation();
          scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
        }
        else {
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
        scope.deepEdit = false;
      };
      //

      input.on('blur',function(event){
        //scope.ngModel = new Date(year, month-1, day);

        $timeout(function(){
          scope.dataChanged(event, input);
          scope.$apply();
        });
      });

      scope.dataChanged = function (event, input) {
        if((!event.relatedTarget) || !event.relatedTarget.closest(".ui-grid-cell") || elem.closest(".ui-grid-cell").attr("id") !== angular.element(event.relatedTarget).attr("id")) {
          scope.done = true;
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
      };
    }
  };
}]);


/////
angular.module('gp4App').directive('ixUiColorGridCell', [ function(){
  return {
    restrict: 'A',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			col: '='
		},
		template: '<div class="text-muted"><label class="colorPreview" ng-class="{ \'full-cell\' : hideDesc }" ng-style="getHTMLColor()"></label><span ng-show="!hideDesc">{{selectedColor.name}}</span></div>',
    link: function(scope, elem, attrs){
			scope.hideDesc = scope.col.colDef.hideDesc;
      scope.getHTMLColor = function(){
        scope.selectedColor = scope.col.colDef.colors.find(function(e){ return e.color == scope.ngModel;});
				var resultado = {};
				if(angular.isDefined(scope.selectedColor))
					resultado = { 'background-color': scope.selectedColor.visual };
        return resultado;
      };
    }
  }
}]);

/* Filtro para mostar descripciones de las FK */
angular.module("gp4App").filter('gridfk', [ 'cfg', function(cfg) {
	return function(input, row, col) {

    if(angular.isDefined(row)){
      if(!col || !col.colDef.allFkObjects) {
        return "...";	// mentre no estigui carregat
      }

      // indice de la columna en la grid
      var colIndex = col.grid.columns.findIndex(function(e) {return e.field === col.field;});

      // construimos la clave para la cache de descripciones
      var lookupKey = col.colDef.LookUpKeyFields.reduce(function(prev,curr,idx){
        return prev+"|"+row.entity[col.colDef.KeyFields[idx]];
      },"");

      if(!col.colDef.usedDescriptionsCache) {
        col.colDef.usedDescriptionsCache = {};  // mantememos una cache de lookupKey-descripcion utilizadas
      }
      if(col.colDef.usedDescriptionsCache[lookupKey]) {
        return col.colDef.usedDescriptionsCache[lookupKey]; // cache HIT!
      } else {
        if(angular.isDefined(input) && col.colDef.allFkObjects) {
          var lookupObjects = col.colDef.allFkObjects.filter(function(e,i) {
            var pasa=true;
            col.colDef.LookUpKeyFields.forEach(function(keyField, idx) {              							
							if(row.entity[col.colDef.KeyFields[idx]]!==e[keyField] && angular.isDefined(e[keyField]) && ((e[keyField]!=="") || e[keyField]=="" && col.colDef.LookUpResultFields.length == 1)) {
                pasa = false;
              }
            });
            return pasa;
          });
          if(lookupObjects.length>0) {
						var fields = angular.copy(col.colDef.LookUpResultFields);
						if(cfg.dropdownSinCodigo && fields.length > 1)
							fields = fields.slice(0, -1);
            var result = parseObjectsToString(lookupObjects, fields); //col·lecció d'objectes, camps.
            col.colDef.usedDescriptionsCache[lookupKey] = result[0];
            return result[0];
          }
					else{
						//console.log("Field:" + col.field + " Entity:" + row.entity.campa + "/" + row.entity.zona + "/" + row.entity.calle + "/" + row.entity.posicion);
					}
        }
      }
    }
  }
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*global angular */
/*global CMP_EQ*/

angular.module('gp4App').controller('DesktopController', ['$scope', '$rootScope', '$log', '$location', '$http', '$timeout', 'cfg', 'authService', '$window', 'ixStatusService', '$injector', function ($scope, $rootScope, $log, $location, $http, $timeout, cfg, authService, $window, ixStatusService, $injector) {
	$scope.frameClass = 'page-desktop';
	// publiquem tot perquè necessitem accedir a totes les aplicacions (lo normal es publicar ixStatusService.current)
	$scope.status = ixStatusService;

	$scope.setFav = function (app) {
		app.fav = !app.fav;
		//Agafem només les propietats display, href i icon de les apps favorites.
		var favApps = $scope.status.availApps.filter(function (e) {
			return e.fav == true;
		}).map(function (item) {
			return { display: item.display, href: item.href, icon: item.icon };
		});
		//Guardar tots els fav a fend_config
		var bodyValue = angular.toJson(favApps);
		$http({
			url: cfg.baseURL + "fend_config/usuario?usuario=" + authService.authentication.userName + "&clave=Desktop",
			method: "POST",
			data: bodyValue
		}).then(function (r) {
			ixStatusService.setResponse(r);
		});
	};


	$scope.filterFunction = function (filter) {
		if (angular.isObject($scope.appFilter)) {
			if ($scope.appFilter.fav && angular.isDefined($scope.appFilter.fav)) {
				if ($scope.appFilter.$ !== "" && angular.isDefined($scope.appFilter.$)) {
					return filter.fav && filter.display.toLowerCase().lastIndexOf($scope.appFilter.$.toLowerCase()) !== -1;
				}
				return filter.fav;
			} else if ($scope.appFilter.$ !== "" && angular.isDefined($scope.appFilter.$)) {
				if (filter.display.toLowerCase().lastIndexOf($scope.appFilter.$.toLowerCase()) !== -1) {
					return true;
				}
			} else {
				return filter.open;
			}
		} else {
			//La vista just s'ha inicialitzat i encara no s'ha introduït cap valor al searchbox.
			//Mostrem només apps obertes.
			return filter.open;
		}
	};

	/* #region Alarmas */

	$scope.mostrarAlarmas = false;
	$scope.titulosAlarmas = [];
	var usuario = authService.authentication.userName;

	if (cfg.appCliente == "EUROMADI") {
			$scope.titulosAlarmas.push(
			{
				titulo: "Estado fuera de plazo",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Estado fuera de plazo',
					href: 'Alarmas/estado_fuera_plazo',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Expiración certificados",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Expiración certificados',
					href: 'Alarmas/expiracion_certificados',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Actualización FT",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Actualización FT',
					href: 'Alarmas/actualizacion_ft',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Verificación nuevos ingredientes",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Verificación ingredientes',
					href: 'Alarmas/verificacion_ingredientes',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Certificado fichero obligatorio",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Certificado fichero obligatorio',
					href: 'Alarmas/certificados_ficheros',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Ingredientes a monitorizar",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Ingredientes a monitorizar',
					href: 'Alarmas/ingredientes_monitorizar',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "FT en revisión propietario",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'FT por revisar',
					href: 'Alarmas/ft_revision_propietario',
					icon: 'person_pin'
				}
			}
		);

		$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
			$scope.extranetUser = response.data;
			if ($scope.extranetUser.proveedor) {
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;
				$scope.titulosAlarmas[2].mostrar = true;
				$scope.titulosAlarmas[4].mostrar = true;
			}
			if ($scope.extranetUser.cliente) { 
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;
				$scope.titulosAlarmas[2].mostrar = true;
				if ($scope.extranetUser.cliente == 1031)
					$scope.titulosAlarmas[5].mostrar = true;
				$scope.titulosAlarmas[6].mostrar = true;
			}
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		//Cargar counts de alarmas

		$http.post(cfg.baseURL + "alarma_estado_fuera_plazoVM/Count").then(function (response) {
			$scope.titulosAlarmas[0].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_expiracion_certificadosVM/Count").then(function (response) {
			$scope.titulosAlarmas[1].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_actualizacion_ftVM/Count").then(function (response) {
			$scope.titulosAlarmas[2].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_verificacion_nuevo_ingredienteVM/Count").then(function (response) {
			$scope.titulosAlarmas[3].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_certificado_ficherosVM/Count").then(function (response) {
			$scope.titulosAlarmas[4].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_ingredientes_monitorizarVM/Count").then(function (response) {
			$scope.titulosAlarmas[5].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		var param = { Filters: [{ Field: "estado", Operator: CMP_EQ, Value: "S" }] };
		$http.post(cfg.baseURL + "listado_ftVM/Count", param).then(function (response) {
			$scope.titulosAlarmas[6].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}
	else if (cfg.appCliente == "BONPREU") {
		$scope.$on('currentUserLoaded', function () {
			$scope.titulosAlarmas.push(
				{
					titulo: "Estado fuera de plazo",
					cantidad: 0,
					mostrar: false,
					app:
					{
						display: 'Estado fuera de plazo',
						href: 'ListadosAlarmas/estado_fuera_plazo',
						icon: 'person_pin'
					}
				}
			);
			$scope.titulosAlarmas.push(
				{
					titulo: "Expiración certificados proveedores",
					cantidad: 0,
					mostrar: false,
					app:
					{
						display: 'Expiración certificados proveedores',
						href: 'ListadosAlarmas/expiracion_certificados',
						icon: 'person_pin'
					}
				}
			);

			var perfilesUsuario = authService.perfilesUsuario();
			var esProveedor = false;
			var esBpuser = false;

			if (perfilesUsuario.indexOf("usr_proveedor") != -1) esProveedor = true;
			if (perfilesUsuario.indexOf("usr_bp_userkey") != -1) esBpuser = true;

			if (esProveedor || esBpuser) {
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;

				$http.post(cfg.baseURL + "alarmabp_estado_fuera_plazoVM/Count").then(function (response) {
					$scope.titulosAlarmas[0].cantidad = response.data;
				}, function (error) {
					ixStatusService.setResponse(error);
				});

				$http.post(cfg.baseURL + "alarmabp_expiracion_certificadosVM/Count").then(function (response) {
					$scope.titulosAlarmas[1].cantidad = response.data;
				}, function (error) {
					ixStatusService.setResponse(error);
				});
			}
		});

	}

	$scope.openAlarma = function (app) {
		ixStatusService.openApp(app);
	}

	/* #endregion */


	$scope.appFilter = {};

	if (cfg.clientId == "GPv4") {

		var DataService = $injector.get("DataService");
		var gridService = $injector.get("gridService");

		$http.get(cfg.baseURL + "fend_config_dashboards/dashboards_usuario?usuario=" + authService.authentication.userName + "&modulo=Desktop").then(function (response) {
			$scope.dashboards = response.data;
			angular.forEach($scope.dashboards, function (dashboard) {
				dashboard.isOpen = true;
				dashboard.widgets = angular.fromJson(dashboard.valor);
				angular.forEach(dashboard.widgets, function (widget) {
					DataService.loadWidget($scope, dashboard.modulo, widget);
				});

			});
		});


		// FIXME: gridService mira aquesta variable per dedicir si te que fer un Search inicial o no, per els widgets tipus taula s'ha de posar perquè sino fa una crida Serach amb entity "undefinded"
		$scope.gridManualLoad = true;

		$scope.gridsterOptions = {
			margins: [20, 20],
			columns: 4,
			mobileModeEnabled: false,
			draggable: { enabled: false },
			resizable: { enabled: false }
		}

		$scope.init = function () {


			// We want to manually handle `window.resize` event in each directive.
			// So that we emulate `resize` event using $broadcast method and internally subscribe to this event in each directive
			// Define event handler
			$scope.events = {
				resize: function (e, scope) {
					$timeout(function () {
						scope.api.update()
					}, 200)
				}
			};
			angular.element(window).on('resize', function (e) {
				$scope.$broadcast('resize');
			});


			// We want to hide the charts until the grid will be created and all widths and heights will be defined.
			// So that use `visible` property in config attribute
			$scope.config = {
				visible: false
			};
			$timeout(function () {
				$scope.config.visible = true;
			}, 200);





		}
	}



}]);

/**
 * Coses que no s'haurien de fer així però que és massa complicat fer en angulat-way
 */



/**
 * Funció per maximitzar els ui-grid. Cal que el ui-grid tingui autoResize activat.
 * S'utilitza a grideditable.html i a ixGridToolBar.html
 * El grid ha de tenir les propietats css height i min-height definides amb el mateix valor.
 *
 * @param button botó que llança la funcio (this) situat a una toolbar a sobre del ui-grid
 * @param event event javascript onclick
 */
/*function maximizeGrid(button, event) {
	var grid = button.parentNode.nextElementSibling;
	if(grid.style.height==grid.style.minHeight) {
		grid.style.height='75vh';
		window.scroll(0,event.pageY-120);
		//window.scroll(0,grid.getBoundingClientRect().top);
	} else {
		grid.style.height=grid.style.minHeight;
		window.scroll(0,0);
	}
	angular.element(button).toggleClass('active');
}*/


/*jslint browser: true, white: false*/
function buildBaseAppMenus() {
	var menus = {
    children: [
      { // Administracion
        display: 'Administración',
        children: [
          {
            display: 'Usuarios',
            href: 'Administracion/api_usuarios/edit',
            icon: 'person'
          },
          {
            display: 'Perfiles',
            href: 'Administracion/api_perfiles/list',
            icon: 'group'
          },
          {
            display: 'Mis listados programados',
            href: 'Administracion/mis_listados_programados/edit',
            icon: 'list'
          },
          {
            display: 'Listados programados',
            href: 'Administracion/listados_programados/edit',
            icon: 'list'
          },
          {
            display: 'Traducciones',
            href: 'Administracion/api_traduction_msg/edit',
            icon: 'translate'
          }
        /*Utilidades
                Gestor de Menus
                Gestor de Bloqueos
                Gestor de Sentencias SQL
                Gestor de Auditorias
                Gestor de Traducciones
                Gestor de Usuarios
                Configuración de Accesos
                Configuración MiPc
                Configuración Usuarios
                       Mi Usuario
                       Cualquier Usuario
                       Modificar Password
                Configuración Perfiles
                       Mi Perfil
                       Cualquier Perfil
                Configuración Aplicación
                Otros
                       Traspasos de Referencias
        Ayuda
                Acerca de...
        Salir
      */
         ]
      }
    ]
};
  return menus;
}

function mergeSubArrays(objectArray){
  var baseMenuChildren = objectArray[0].children;
  for(var pos = 1; pos < objectArray.length; pos++){
    //Itera el menu baseApp, si ja hi ha algun item (ex: Administración), li afegeix els items del submenu.
    angular.forEach(baseMenuChildren, function(menuchildren){
      var itemInNextMenu = objectArray[pos].children.find(function(e){ return e.display === menuchildren.display; });
      if(angular.isDefined(itemInNextMenu)){

				//Test

				angular.forEach(itemInNextMenu.children, function(childMenu){
					var foundSubMenu = menuchildren.children.find(function(e){ return e.display == childMenu.display; });
					if(foundSubMenu && angular.isDefined(foundSubMenu.children)){
						foundSubMenu.children.push.apply(foundSubMenu.children, childMenu.children);
					} else {
						//menuchildren.children.push.apply(menuchildren.children, childMenu);
						menuchildren.children.push(childMenu);
					}
				});


				//

				//Original:
        //menuchildren.children = menuchildren.children.concat(itemInNextMenu.children);
      }
    });
    //Mirem si hi ha algun item (Tablas Maestras,...) que no hi es al menu principal, sino hi es l'afegim.
    angular.forEach(objectArray[pos].children, function(menuchildren){
      var found = baseMenuChildren.some(function(e){ return menuchildren.display === e.display; });
      if(!found){
        baseMenuChildren = baseMenuChildren.concat(menuchildren);
      }
    });
  }
  objectArray[0].children = baseMenuChildren;
  return objectArray;
}

/*eslint angular/window-service:0*/
/*eslint angular/angularelement:0*/
/*eslint angular/timeout-service:0*/
/*eslint angular/document-service:0*/
/*eslint angular/typecheck-string:0*/
/*eslint angular/typecheck-function:0*/
/*eslint angular/interval-service:0*/
/*eslint angular/typecheck-object:0*/
/* jquery.signalR.core.js */
/*global window:false */
/*!
 * ASP.NET SignalR JavaScript Library v2.2.2
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="Scripts/jquery-1.6.4.js" />
/// <reference path="jquery.signalR.version.js" />
(function ($, window, undefined) {

    var resources = {
        nojQuery: "jQuery was not found. Please ensure jQuery is referenced before the SignalR client JavaScript file.",
        noTransportOnInit: "No transport could be initialized successfully. Try specifying a different transport or none at all for auto initialization.",
        errorOnNegotiate: "Error during negotiation request.",
        stoppedWhileLoading: "The connection was stopped during page load.",
        stoppedWhileNegotiating: "The connection was stopped during the negotiate request.",
        errorParsingNegotiateResponse: "Error parsing negotiate response.",
        errorDuringStartRequest: "Error during start request. Stopping the connection.",
        stoppedDuringStartRequest: "The connection was stopped during the start request.",
        errorParsingStartResponse: "Error parsing start response: '{0}'. Stopping the connection.",
        invalidStartResponse: "Invalid start response: '{0}'. Stopping the connection.",
        protocolIncompatible: "You are using a version of the client that isn't compatible with the server. Client version {0}, server version {1}.",
        sendFailed: "Send failed.",
        parseFailed: "Failed at parsing response: {0}",
        longPollFailed: "Long polling request failed.",
        eventSourceFailedToConnect: "EventSource failed to connect.",
        eventSourceError: "Error raised by EventSource",
        webSocketClosed: "WebSocket closed.",
        pingServerFailedInvalidResponse: "Invalid ping response when pinging server: '{0}'.",
        pingServerFailed: "Failed to ping server.",
        pingServerFailedStatusCode: "Failed to ping server.  Server responded with status code {0}, stopping the connection.",
        pingServerFailedParse: "Failed to parse ping server response, stopping the connection.",
        noConnectionTransport: "Connection is in an invalid state, there is no transport active.",
        webSocketsInvalidState: "The Web Socket transport is in an invalid state, transitioning into reconnecting.",
        reconnectTimeout: "Couldn't reconnect within the configured timeout of {0} ms, disconnecting.",
        reconnectWindowTimeout: "The client has been inactive since {0} and it has exceeded the inactivity timeout of {1} ms. Stopping the connection."
    };

    if (typeof ($) !== "function") {
        // no jQuery!
        throw new Error(resources.nojQuery);
    }

    var signalR,
        _connection,
        _pageLoaded = (window.document.readyState === "complete"),
        _pageWindow = $(window),
        _negotiateAbortText = "__Negotiate Aborted__",
        events = {
            onStart: "onStart",
            onStarting: "onStarting",
            onReceived: "onReceived",
            onError: "onError",
            onConnectionSlow: "onConnectionSlow",
            onReconnecting: "onReconnecting",
            onReconnect: "onReconnect",
            onStateChanged: "onStateChanged",
            onDisconnect: "onDisconnect"
        },
        ajaxDefaults = {
            processData: true,
            timeout: null,
            async: true,
            global: false,
            cache: false
        },
        log = function (msg, logging) {
            if (logging === false) {
                return;
            }
            var m;
            if (typeof (window.console) === "undefined") {
                return;
            }
            m = "[" + new Date().toTimeString() + "] SignalR: " + msg;
            if (window.console.debug) {
                window.console.debug(m);
            } else if (window.console.log) {
                window.console.log(m);
            }
        },

        changeState = function (connection, expectedState, newState) {
            if (expectedState === connection.state) {
                connection.state = newState;

                $(connection).triggerHandler(events.onStateChanged, [{ oldState: expectedState, newState: newState }]);
                return true;
            }

            return false;
        },

        isDisconnecting = function (connection) {
            return connection.state === signalR.connectionState.disconnected;
        },

        supportsKeepAlive = function (connection) {
            return connection._.keepAliveData.activated &&
                   connection.transport.supportsKeepAlive(connection);
        },

        configureStopReconnectingTimeout = function (connection) {
            var stopReconnectingTimeout,
                onReconnectTimeout;

            // Check if this connection has already been configured to stop reconnecting after a specified timeout.
            // Without this check if a connection is stopped then started events will be bound multiple times.
            if (!connection._.configuredStopReconnectingTimeout) {
                onReconnectTimeout = function (connection) {
                    var message = signalR._.format(signalR.resources.reconnectTimeout, connection.disconnectTimeout);
                    connection.log(message);
                    $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
                    connection.stop(/* async */ false, /* notifyServer */ false);
                };

                connection.reconnecting(function () {
                    var connection = this;

                    // Guard against state changing in a previous user defined even handler
                    if (connection.state === signalR.connectionState.reconnecting) {
                        stopReconnectingTimeout = window.setTimeout(function () { onReconnectTimeout(connection); }, connection.disconnectTimeout);
                    }
                });

                connection.stateChanged(function (data) {
                    if (data.oldState === signalR.connectionState.reconnecting) {
                        // Clear the pending reconnect timeout check
                        window.clearTimeout(stopReconnectingTimeout);
                    }
                });

                connection._.configuredStopReconnectingTimeout = true;
            }
        };

    signalR = function (url, qs, logging) {
        /// <summary>Creates a new SignalR connection for the given url</summary>
        /// <param name="url" type="String">The URL of the long polling endpoint</param>
        /// <param name="qs" type="Object">
        ///     [Optional] Custom querystring parameters to add to the connection URL.
        ///     If an object, every non-function member will be added to the querystring.
        ///     If a string, it's added to the QS as specified.
        /// </param>
        /// <param name="logging" type="Boolean">
        ///     [Optional] A flag indicating whether connection logging is enabled to the browser
        ///     console/log. Defaults to false.
        /// </param>

        return new signalR.fn.init(url, qs, logging);
    };

    signalR._ = {
        defaultContentType: "application/x-www-form-urlencoded; charset=UTF-8",

        ieVersion: (function () {
            var version,
                matches;

            if (window.navigator.appName === 'Microsoft Internet Explorer') {
                // Check if the user agent has the pattern "MSIE (one or more numbers).(one or more numbers)";
                matches = /MSIE ([0-9]+\.[0-9]+)/.exec(window.navigator.userAgent);

                if (matches) {
                    version = window.parseFloat(matches[1]);
                }
            }

            // undefined value means not IE
            return version;
        })(),

        error: function (message, source, context) {
            var e = new Error(message);
            e.source = source;

            if (typeof context !== "undefined") {
                e.context = context;
            }

            return e;
        },

        transportError: function (message, transport, source, context) {
            var e = this.error(message, source, context);
            e.transport = transport ? transport.name : undefined;
            return e;
        },

        format: function () {
            /// <summary>Usage: format("Hi {0}, you are {1}!", "Foo", 100) </summary>
            var s = arguments[0];
            for (var i = 0; i < arguments.length - 1; i++) {
                s = s.replace("{" + i + "}", arguments[i + 1]);
            }
            return s;
        },

        firefoxMajorVersion: function (userAgent) {
            // Firefox user agents: http://useragentstring.com/pages/Firefox/
            var matches = userAgent.match(/Firefox\/(\d+)/);
            if (!matches || !matches.length || matches.length < 2) {
                return 0;
            }
            return parseInt(matches[1], 10 /* radix */);
        },

        configurePingInterval: function (connection) {
            var config = connection._.config,
                onFail = function (error) {
                    $(connection).triggerHandler(events.onError, [error]);
                };

            if (config && !connection._.pingIntervalId && config.pingInterval) {
                connection._.pingIntervalId = window.setInterval(function () {
                    signalR.transports._logic.pingServer(connection).fail(onFail);
                }, config.pingInterval);
            }
        }
    };

    signalR.events = events;

    signalR.resources = resources;

    signalR.ajaxDefaults = ajaxDefaults;

    signalR.changeState = changeState;

    signalR.isDisconnecting = isDisconnecting;

    signalR.connectionState = {
        connecting: 0,
        connected: 1,
        reconnecting: 2,
        disconnected: 4
    };

    signalR.hub = {
        start: function () {
            // This will get replaced with the real hub connection start method when hubs is referenced correctly
            throw new Error("SignalR: Error loading hubs. Ensure your hubs reference is correct, e.g. <script src='/signalr/js?v=68da480ffb459961fe49667b14b84622'></script>.");
        }
    };

    // .on() was added in version 1.7.0, .load() was removed in version 3.0.0 so we fallback to .load() if .on() does
    // not exist to not break existing applications
    if (typeof _pageWindow.on == "function") {
        _pageWindow.on("load", function () { _pageLoaded = true; });
    }
    else {
        _pageWindow.load(function () { _pageLoaded = true; });
    }

    function validateTransport(requestedTransport, connection) {
        /// <summary>Validates the requested transport by cross checking it with the pre-defined signalR.transports</summary>
        /// <param name="requestedTransport" type="Object">The designated transports that the user has specified.</param>
        /// <param name="connection" type="signalR">The connection that will be using the requested transports.  Used for logging purposes.</param>
        /// <returns type="Object" />

        if ($.isArray(requestedTransport)) {
            // Go through transport array and remove an "invalid" tranports
            for (var i = requestedTransport.length - 1; i >= 0; i--) {
                var transport = requestedTransport[i];
                if ($.type(transport) !== "string" || !signalR.transports[transport]) {
                    connection.log("Invalid transport: " + transport + ", removing it from the transports list.");
                    requestedTransport.splice(i, 1);
                }
            }

            // Verify we still have transports left, if we dont then we have invalid transports
            if (requestedTransport.length === 0) {
                connection.log("No transports remain within the specified transport array.");
                requestedTransport = null;
            }
        } else if (!signalR.transports[requestedTransport] && requestedTransport !== "auto") {
            connection.log("Invalid transport: " + requestedTransport.toString() + ".");
            requestedTransport = null;
        } else if (requestedTransport === "auto" && signalR._.ieVersion <= 8) {
            // If we're doing an auto transport and we're IE8 then force longPolling, #1764
            return ["longPolling"];

        }

        return requestedTransport;
    }

    function getDefaultPort(protocol) {
        if (protocol === "http:") {
            return 80;
        } else if (protocol === "https:") {
            return 443;
        }
    }

    function addDefaultPort(protocol, url) {
        // Remove ports  from url.  We have to check if there's a / or end of line
        // following the port in order to avoid removing ports such as 8080.
        if (url.match(/:\d+$/)) {
            return url;
        } else {
            return url + ":" + getDefaultPort(protocol);
        }
    }

    function ConnectingMessageBuffer(connection, drainCallback) {
        var that = this,
            buffer = [];

        that.tryBuffer = function (message) {
            if (connection.state === $.signalR.connectionState.connecting) {
                buffer.push(message);

                return true;
            }

            return false;
        };

        that.drain = function () {
            // Ensure that the connection is connected when we drain (do not want to drain while a connection is not active)
            if (connection.state === $.signalR.connectionState.connected) {
                while (buffer.length > 0) {
                    drainCallback(buffer.shift());
                }
            }
        };

        that.clear = function () {
            buffer = [];
        };
    }

    signalR.fn = signalR.prototype = {
        init: function (url, qs, logging) {
            var $connection = $(this);

            this.url = url;
            this.qs = qs;
            this.lastError = null;
            this._ = {
                keepAliveData: {},
                connectingMessageBuffer: new ConnectingMessageBuffer(this, function (message) {
                    $connection.triggerHandler(events.onReceived, [message]);
                }),
                lastMessageAt: new Date().getTime(),
                lastActiveAt: new Date().getTime(),
                beatInterval: 5000, // Default value, will only be overridden if keep alive is enabled,
                beatHandle: null,
                totalTransportConnectTimeout: 0 // This will be the sum of the TransportConnectTimeout sent in response to negotiate and connection.transportConnectTimeout
            };
            if (typeof (logging) === "boolean") {
                this.logging = logging;
            }
        },

        _parseResponse: function (response) {
            var that = this;

            if (!response) {
                return response;
            } else if (typeof response === "string") {
                return that.json.parse(response);
            } else {
                return response;
            }
        },

        _originalJson: window.JSON,

        json: window.JSON,

        isCrossDomain: function (url, against) {
            /// <summary>Checks if url is cross domain</summary>
            /// <param name="url" type="String">The base URL</param>
            /// <param name="against" type="Object">
            ///     An optional argument to compare the URL against, if not specified it will be set to window.location.
            ///     If specified it must contain a protocol and a host property.
            /// </param>
            var link;

            url = $.trim(url);

            against = against || window.location;

            if (url.indexOf("http") !== 0) {
                return false;
            }

            // Create an anchor tag.
            link = window.document.createElement("a");
            link.href = url;

            // When checking for cross domain we have to special case port 80 because the window.location will remove the
            return link.protocol + addDefaultPort(link.protocol, link.host) !== against.protocol + addDefaultPort(against.protocol, against.host);
        },

        ajaxDataType: "text",

        contentType: "application/json; charset=UTF-8",

        logging: false,

        state: signalR.connectionState.disconnected,

        clientProtocol: "1.5",

        reconnectDelay: 2000,

        transportConnectTimeout: 0,

        disconnectTimeout: 30000, // This should be set by the server in response to the negotiate request (30s default)

        reconnectWindow: 30000, // This should be set by the server in response to the negotiate request

        keepAliveWarnAt: 2 / 3, // Warn user of slow connection if we breach the X% mark of the keep alive timeout

        start: function (options, callback) {
            /// <summary>Starts the connection</summary>
            /// <param name="options" type="Object">Options map</param>
            /// <param name="callback" type="Function">A callback function to execute when the connection has started</param>
            var connection = this,
                config = {
                    pingInterval: 300000,
                    waitForPageLoad: true,
                    transport: "auto",
                    jsonp: false
                },
                initialize,
                deferred = connection._deferral || $.Deferred(), // Check to see if there is a pre-existing deferral that's being built on, if so we want to keep using it
                parser = window.document.createElement("a");

            connection.lastError = null;

            // Persist the deferral so that if start is called multiple times the same deferral is used.
            connection._deferral = deferred;

            if (!connection.json) {
                // no JSON!
                throw new Error("SignalR: No JSON parser found. Please ensure json2.js is referenced before the SignalR.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
            }

            if ($.type(options) === "function") {
                // Support calling with single callback parameter
                callback = options;
            } else if ($.type(options) === "object") {
                $.extend(config, options);
                if ($.type(config.callback) === "function") {
                    callback = config.callback;
                }
            }

            config.transport = validateTransport(config.transport, connection);

            // If the transport is invalid throw an error and abort start
            if (!config.transport) {
                throw new Error("SignalR: Invalid transport(s) specified, aborting start.");
            }

            connection._.config = config;

            // Check to see if start is being called prior to page load
            // If waitForPageLoad is true we then want to re-direct function call to the window load event
            if (!_pageLoaded && config.waitForPageLoad === true) {
                connection._.deferredStartHandler = function () {
                    connection.start(options, callback);
                };
                _pageWindow.bind("load", connection._.deferredStartHandler);

                return deferred.promise();
            }

            // If we're already connecting just return the same deferral as the original connection start
            if (connection.state === signalR.connectionState.connecting) {
                return deferred.promise();
            } else if (changeState(connection,
                            signalR.connectionState.disconnected,
                            signalR.connectionState.connecting) === false) {
                // We're not connecting so try and transition into connecting.
                // If we fail to transition then we're either in connected or reconnecting.

                deferred.resolve(connection);
                return deferred.promise();
            }

            configureStopReconnectingTimeout(connection);

            // Resolve the full url
            parser.href = connection.url;
            if (!parser.protocol || parser.protocol === ":") {
                connection.protocol = window.document.location.protocol;
                connection.host = parser.host || window.document.location.host;
            } else {
                connection.protocol = parser.protocol;
                connection.host = parser.host;
            }

            connection.baseUrl = connection.protocol + "//" + connection.host;

            // Set the websocket protocol
            connection.wsProtocol = connection.protocol === "https:" ? "wss://" : "ws://";

            // If jsonp with no/auto transport is specified, then set the transport to long polling
            // since that is the only transport for which jsonp really makes sense.
            // Some developers might actually choose to specify jsonp for same origin requests
            // as demonstrated by Issue #623.
            if (config.transport === "auto" && config.jsonp === true) {
                config.transport = "longPolling";
            }

            // If the url is protocol relative, prepend the current windows protocol to the url.
            if (connection.url.indexOf("//") === 0) {
                connection.url = window.location.protocol + connection.url;
                connection.log("Protocol relative URL detected, normalizing it to '" + connection.url + "'.");
            }

            if (this.isCrossDomain(connection.url)) {
                connection.log("Auto detected cross domain url.");

                if (config.transport === "auto") {
                    // TODO: Support XDM with foreverFrame
                    config.transport = ["webSockets", "serverSentEvents", "longPolling"];
                }

                if (typeof (config.withCredentials) === "undefined") {
                    config.withCredentials = true;
                }

                // Determine if jsonp is the only choice for negotiation, ajaxSend and ajaxAbort.
                // i.e. if the browser doesn't supports CORS
                // If it is, ignore any preference to the contrary, and switch to jsonp.
                if (!config.jsonp) {
                    config.jsonp = !$.support.cors;

                    if (config.jsonp) {
                        connection.log("Using jsonp because this browser doesn't support CORS.");
                    }
                }

                connection.contentType = signalR._.defaultContentType;
            }

            connection.withCredentials = config.withCredentials;

            connection.ajaxDataType = config.jsonp ? "jsonp" : "text";

            $(connection).bind(events.onStart, function (e, data) {
                if ($.type(callback) === "function") {
                    callback.call(connection);
                }
                deferred.resolve(connection);
            });

            connection._.initHandler = signalR.transports._logic.initHandler(connection);

            initialize = function (transports, index) {
                var noTransportError = signalR._.error(resources.noTransportOnInit);

                index = index || 0;
                if (index >= transports.length) {
                    if (index === 0) {
                        connection.log("No transports supported by the server were selected.");
                    } else if (index === 1) {
                        connection.log("No fallback transports were selected.");
                    } else {
                        connection.log("Fallback transports exhausted.");
                    }

                    // No transport initialized successfully
                    $(connection).triggerHandler(events.onError, [noTransportError]);
                    deferred.reject(noTransportError);
                    // Stop the connection if it has connected and move it into the disconnected state
                    connection.stop();
                    return;
                }

                // The connection was aborted
                if (connection.state === signalR.connectionState.disconnected) {
                    return;
                }

                var transportName = transports[index],
                    transport = signalR.transports[transportName],
                    onFallback = function () {
                        initialize(transports, index + 1);
                    };

                connection.transport = transport;

                try {
                    connection._.initHandler.start(transport, function () { // success
                        // Firefox 11+ doesn't allow sync XHR withCredentials: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#withCredentials
                        var isFirefox11OrGreater = signalR._.firefoxMajorVersion(window.navigator.userAgent) >= 11,
                            asyncAbort = !!connection.withCredentials && isFirefox11OrGreater;

                        connection.log("The start request succeeded. Transitioning to the connected state.");

                        if (supportsKeepAlive(connection)) {
                            signalR.transports._logic.monitorKeepAlive(connection);
                        }

                        signalR.transports._logic.startHeartbeat(connection);

                        // Used to ensure low activity clients maintain their authentication.
                        // Must be configured once a transport has been decided to perform valid ping requests.
                        signalR._.configurePingInterval(connection);

                        if (!changeState(connection,
                                            signalR.connectionState.connecting,
                                            signalR.connectionState.connected)) {
                            connection.log("WARNING! The connection was not in the connecting state.");
                        }

                        // Drain any incoming buffered messages (messages that came in prior to connect)
                        connection._.connectingMessageBuffer.drain();

                        $(connection).triggerHandler(events.onStart);

                        // wire the stop handler for when the user leaves the page
                        _pageWindow.bind("unload", function () {
                            connection.log("Window unloading, stopping the connection.");

                            connection.stop(asyncAbort);
                        });

                        if (isFirefox11OrGreater) {
                            // Firefox does not fire cross-domain XHRs in the normal unload handler on tab close.
                            // #2400
                            _pageWindow.bind("beforeunload", function () {
                                // If connection.stop() runs runs in beforeunload and fails, it will also fail
                                // in unload unless connection.stop() runs after a timeout.
                                window.setTimeout(function () {
                                    connection.stop(asyncAbort);
                                }, 0);
                            });
                        }
                    }, onFallback);
                }
                catch (error) {
                    connection.log(transport.name + " transport threw '" + error.message + "' when attempting to start.");
                    onFallback();
                }
            };

            var url = connection.url + "/negotiate",
                onFailed = function (error, connection) {
                    var err = signalR._.error(resources.errorOnNegotiate, error, connection._.negotiateRequest);

                    $(connection).triggerHandler(events.onError, err);
                    deferred.reject(err);
                    // Stop the connection if negotiate failed
                    connection.stop();
                };

            $(connection).triggerHandler(events.onStarting);

            url = signalR.transports._logic.prepareQueryString(connection, url);

            connection.log("Negotiating with '" + url + "'.");

            // Save the ajax negotiate request object so we can abort it if stop is called while the request is in flight.
            connection._.negotiateRequest = signalR.transports._logic.ajax(connection, {
                url: url,
                error: function (error, statusText) {
                    // We don't want to cause any errors if we're aborting our own negotiate request.
                    if (statusText !== _negotiateAbortText) {
                        onFailed(error, connection);
                    } else {
                        // This rejection will noop if the deferred has already been resolved or rejected.
                        deferred.reject(signalR._.error(resources.stoppedWhileNegotiating, null /* error */, connection._.negotiateRequest));
                    }
                },
                success: function (result) {
                    var res,
                        keepAliveData,
                        protocolError,
                        transports = [],
                        supportedTransports = [];

                    try {
                        res = connection._parseResponse(result);
                    } catch (error) {
                        onFailed(signalR._.error(resources.errorParsingNegotiateResponse, error), connection);
                        return;
                    }

                    keepAliveData = connection._.keepAliveData;
                    connection.appRelativeUrl = res.Url;
                    connection.id = res.ConnectionId;
                    connection.token = res.ConnectionToken;
                    connection.webSocketServerUrl = res.WebSocketServerUrl;

                    // The long poll timeout is the ConnectionTimeout plus 10 seconds
                    connection._.pollTimeout = res.ConnectionTimeout * 1000 + 10000; // in ms

                    // Once the server has labeled the PersistentConnection as Disconnected, we should stop attempting to reconnect
                    // after res.DisconnectTimeout seconds.
                    connection.disconnectTimeout = res.DisconnectTimeout * 1000; // in ms

                    // Add the TransportConnectTimeout from the response to the transportConnectTimeout from the client to calculate the total timeout
                    connection._.totalTransportConnectTimeout = connection.transportConnectTimeout + res.TransportConnectTimeout * 1000;

                    // If we have a keep alive
                    if (res.KeepAliveTimeout) {
                        // Register the keep alive data as activated
                        keepAliveData.activated = true;

                        // Timeout to designate when to force the connection into reconnecting converted to milliseconds
                        keepAliveData.timeout = res.KeepAliveTimeout * 1000;

                        // Timeout to designate when to warn the developer that the connection may be dead or is not responding.
                        keepAliveData.timeoutWarning = keepAliveData.timeout * connection.keepAliveWarnAt;

                        // Instantiate the frequency in which we check the keep alive.  It must be short in order to not miss/pick up any changes
                        connection._.beatInterval = (keepAliveData.timeout - keepAliveData.timeoutWarning) / 3;
                    } else {
                        keepAliveData.activated = false;
                    }

                    connection.reconnectWindow = connection.disconnectTimeout + (keepAliveData.timeout || 0);

                    if (!res.ProtocolVersion || res.ProtocolVersion !== connection.clientProtocol) {
                        protocolError = signalR._.error(signalR._.format(resources.protocolIncompatible, connection.clientProtocol, res.ProtocolVersion));
                        $(connection).triggerHandler(events.onError, [protocolError]);
                        deferred.reject(protocolError);

                        return;
                    }

                    $.each(signalR.transports, function (key) {
                        if ((key.indexOf("_") === 0) || (key === "webSockets" && !res.TryWebSockets)) {
                            return true;
                        }
                        supportedTransports.push(key);
                    });

                    if ($.isArray(config.transport)) {
                        $.each(config.transport, function (_, transport) {
                            if ($.inArray(transport, supportedTransports) >= 0) {
                                transports.push(transport);
                            }
                        });
                    } else if (config.transport === "auto") {
                        transports = supportedTransports;
                    } else if ($.inArray(config.transport, supportedTransports) >= 0) {
                        transports.push(config.transport);
                    }

                    initialize(transports);
                }
            });

            return deferred.promise();
        },

        starting: function (callback) {
            /// <summary>Adds a callback that will be invoked before anything is sent over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute before the connection is fully instantiated.</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onStarting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        send: function (data) {
            /// <summary>Sends data over the connection</summary>
            /// <param name="data" type="String">The data to send over the connection</param>
            /// <returns type="signalR" />
            var connection = this;

            if (connection.state === signalR.connectionState.disconnected) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection must be started before data can be sent. Call .start() before .send()");
            }

            if (connection.state === signalR.connectionState.connecting) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection has not been fully initialized. Use .start().done() or .start().fail() to run logic after the connection has started.");
            }

            connection.transport.send(connection, data);
            // REVIEW: Should we return deferred here?
            return connection;
        },

        received: function (callback) {
            /// <summary>Adds a callback that will be invoked after anything is received over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when any data is received on the connection</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onReceived, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        stateChanged: function (callback) {
            /// <summary>Adds a callback that will be invoked when the connection state changes</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection state changes</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onStateChanged, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        error: function (callback) {
            /// <summary>Adds a callback that will be invoked after an error occurs with the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when an error occurs on the connection</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onError, function (e, errorData, sendData) {
                connection.lastError = errorData;
                // In practice 'errorData' is the SignalR built error object.
                // In practice 'sendData' is undefined for all error events except those triggered by
                // 'ajaxSend' and 'webSockets.send'.'sendData' is the original send payload.
                callback.call(connection, errorData, sendData);
            });
            return connection;
        },

        disconnected: function (callback) {
            /// <summary>Adds a callback that will be invoked when the client disconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is broken</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onDisconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        connectionSlow: function (callback) {
            /// <summary>Adds a callback that will be invoked when the client detects a slow connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is slow</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onConnectionSlow, function (e, data) {
                callback.call(connection);
            });

            return connection;
        },

        reconnecting: function (callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport begins reconnecting</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection enters a reconnecting state</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onReconnecting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        reconnected: function (callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport reconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is restored</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).bind(events.onReconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        stop: function (async, notifyServer) {
            /// <summary>Stops listening</summary>
            /// <param name="async" type="Boolean">Whether or not to asynchronously abort the connection</param>
            /// <param name="notifyServer" type="Boolean">Whether we want to notify the server that we are aborting the connection</param>
            /// <returns type="signalR" />
            var connection = this,
                // Save deferral because this is always cleaned up
                deferral = connection._deferral;

            // Verify that we've bound a load event.
            if (connection._.deferredStartHandler) {
                // Unbind the event.
                _pageWindow.unbind("load", connection._.deferredStartHandler);
            }

            // Always clean up private non-timeout based state.
            delete connection._.config;
            delete connection._.deferredStartHandler;

            // This needs to be checked despite the connection state because a connection start can be deferred until page load.
            // If we've deferred the start due to a page load we need to unbind the "onLoad" -> start event.
            if (!_pageLoaded && (!connection._.config || connection._.config.waitForPageLoad === true)) {
                connection.log("Stopping connection prior to negotiate.");

                // If we have a deferral we should reject it
                if (deferral) {
                    deferral.reject(signalR._.error(resources.stoppedWhileLoading));
                }

                // Short-circuit because the start has not been fully started.
                return;
            }

            if (connection.state === signalR.connectionState.disconnected) {
                return;
            }

            connection.log("Stopping connection.");

            // Clear this no matter what
            window.clearTimeout(connection._.beatHandle);
            window.clearInterval(connection._.pingIntervalId);

            if (connection.transport) {
                connection.transport.stop(connection);

                if (notifyServer !== false) {
                    connection.transport.abort(connection, async);
                }

                if (supportsKeepAlive(connection)) {
                    signalR.transports._logic.stopMonitoringKeepAlive(connection);
                }

                connection.transport = null;
            }

            if (connection._.negotiateRequest) {
                // If the negotiation request has already completed this will noop.
                connection._.negotiateRequest.abort(_negotiateAbortText);
                delete connection._.negotiateRequest;
            }

            // Ensure that initHandler.stop() is called before connection._deferral is deleted
            if (connection._.initHandler) {
                connection._.initHandler.stop();
            }

            delete connection._deferral;
            delete connection.messageId;
            delete connection.groupsToken;
            delete connection.id;
            delete connection._.pingIntervalId;
            delete connection._.lastMessageAt;
            delete connection._.lastActiveAt;

            // Clear out our message buffer
            connection._.connectingMessageBuffer.clear();

            // Clean up this event
            $(connection).unbind(events.onStart);

            // Trigger the disconnect event
            changeState(connection, connection.state, signalR.connectionState.disconnected);
            $(connection).triggerHandler(events.onDisconnect);

            return connection;
        },

        log: function (msg) {
            log(msg, this.logging);
        }
    };

    signalR.fn.init.prototype = signalR.fn;

    signalR.noConflict = function () {
        /// <summary>Reinstates the original value of $.connection and returns the signalR object for manual assignment</summary>
        /// <returns type="signalR" />
        if ($.connection === signalR) {
            $.connection = _connection;
        }
        return signalR;
    };

    if ($.connection) {
        _connection = $.connection;
    }

    $.connection = $.signalR = signalR;

}(window.jQuery, window));
/* jquery.signalR.transports.common.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        startAbortText = "__Start Aborted__",
        transportLogic;

    signalR.transports = {};

    function beat(connection) {
        if (connection._.keepAliveData.monitoring) {
            checkIfAlive(connection);
        }

        // Ensure that we successfully marked active before continuing the heartbeat.
        if (transportLogic.markActive(connection)) {
            connection._.beatHandle = window.setTimeout(function () {
                beat(connection);
            }, connection._.beatInterval);
        }
    }

    function checkIfAlive(connection) {
        var keepAliveData = connection._.keepAliveData,
            timeElapsed;

        // Only check if we're connected
        if (connection.state === signalR.connectionState.connected) {
            timeElapsed = new Date().getTime() - connection._.lastMessageAt;

            // Check if the keep alive has completely timed out
            if (timeElapsed >= keepAliveData.timeout) {
                connection.log("Keep alive timed out.  Notifying transport that connection has been lost.");

                // Notify transport that the connection has been lost
                connection.transport.lostConnection(connection);
            } else if (timeElapsed >= keepAliveData.timeoutWarning) {
                // This is to assure that the user only gets a single warning
                if (!keepAliveData.userNotified) {
                    connection.log("Keep alive has been missed, connection may be dead/slow.");
                    $(connection).triggerHandler(events.onConnectionSlow);
                    keepAliveData.userNotified = true;
                }
            } else {
                keepAliveData.userNotified = false;
            }
        }
    }

    function getAjaxUrl(connection, path) {
        var url = connection.url + path;

        if (connection.transport) {
            url += "?transport=" + connection.transport.name;
        }

        return transportLogic.prepareQueryString(connection, url);
    }

    function InitHandler(connection) {
        this.connection = connection;

        this.startRequested = false;
        this.startCompleted = false;
        this.connectionStopped = false;
    }

    InitHandler.prototype = {
        start: function (transport, onSuccess, onFallback) {
            var that = this,
                connection = that.connection,
                failCalled = false;

            if (that.startRequested || that.connectionStopped) {
                connection.log("WARNING! " + transport.name + " transport cannot be started. Initialization ongoing or completed.");
                return;
            }

            connection.log(transport.name + " transport starting.");

            transport.start(connection, function () {
                if (!failCalled) {
                    that.initReceived(transport, onSuccess);
                }
            }, function (error) {
                // Don't allow the same transport to cause onFallback to be called twice
                if (!failCalled) {
                    failCalled = true;
                    that.transportFailed(transport, error, onFallback);
                }

                // Returns true if the transport should stop;
                // false if it should attempt to reconnect
                return !that.startCompleted || that.connectionStopped;
            });

            that.transportTimeoutHandle = window.setTimeout(function () {
                if (!failCalled) {
                    failCalled = true;
                    connection.log(transport.name + " transport timed out when trying to connect.");
                    that.transportFailed(transport, undefined, onFallback);
                }
            }, connection._.totalTransportConnectTimeout);
        },

        stop: function () {
            this.connectionStopped = true;
            window.clearTimeout(this.transportTimeoutHandle);
            signalR.transports._logic.tryAbortStartRequest(this.connection);
        },

        initReceived: function (transport, onSuccess) {
            var that = this,
                connection = that.connection;

            if (that.startRequested) {
                connection.log("WARNING! The client received multiple init messages.");
                return;
            }

            if (that.connectionStopped) {
                return;
            }

            that.startRequested = true;
            window.clearTimeout(that.transportTimeoutHandle);

            connection.log(transport.name + " transport connected. Initiating start request.");
            signalR.transports._logic.ajaxStart(connection, function () {
                that.startCompleted = true;
                onSuccess();
            });
        },

        transportFailed: function (transport, error, onFallback) {
            var connection = this.connection,
                deferred = connection._deferral,
                wrappedError;

            if (this.connectionStopped) {
                return;
            }

            window.clearTimeout(this.transportTimeoutHandle);

            if (!this.startRequested) {
                transport.stop(connection);

                connection.log(transport.name + " transport failed to connect. Attempting to fall back.");
                onFallback();
            } else if (!this.startCompleted) {
                // Do not attempt to fall back if a start request is ongoing during a transport failure.
                // Instead, trigger an error and stop the connection.
                wrappedError = signalR._.error(signalR.resources.errorDuringStartRequest, error);

                connection.log(transport.name + " transport failed during the start request. Stopping the connection.");
                $(connection).triggerHandler(events.onError, [wrappedError]);
                if (deferred) {
                    deferred.reject(wrappedError);
                }

                connection.stop();
            } else {
                // The start request has completed, but the connection has not stopped.
                // No need to do anything here. The transport should attempt its normal reconnect logic.
            }
        }
    };

    transportLogic = signalR.transports._logic = {
        ajax: function (connection, options) {
            return $.ajax(
                $.extend(/*deep copy*/ true, {}, $.signalR.ajaxDefaults, {
                    type: "GET",
                    data: {},
                    xhrFields: { withCredentials: connection.withCredentials },
                    contentType: connection.contentType,
                    dataType: connection.ajaxDataType
                }, options));
        },

        pingServer: function (connection) {
            /// <summary>Pings the server</summary>
            /// <param name="connection" type="signalr">Connection associated with the server ping</param>
            /// <returns type="signalR" />
            var url,
                xhr,
                deferral = $.Deferred();

            if (connection.transport) {
                url = connection.url + "/ping";

                url = transportLogic.addQs(url, connection.qs);

                xhr = transportLogic.ajax(connection, {
                    url: url,
                    success: function (result) {
                        var data;

                        try {
                            data = connection._parseResponse(result);
                        }
                        catch (error) {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR.resources.pingServerFailedParse,
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                            connection.stop();
                            return;
                        }

                        if (data.Response === "pong") {
                            deferral.resolve();
                        }
                        else {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR._.format(signalR.resources.pingServerFailedInvalidResponse, result),
                                    connection.transport,
                                    null /* error */,
                                    xhr
                                )
                            );
                        }
                    },
                    error: function (error) {
                        if (error.status === 401 || error.status === 403) {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR._.format(signalR.resources.pingServerFailedStatusCode, error.status),
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                            connection.stop();
                        }
                        else {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR.resources.pingServerFailed,
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                        }
                    }
                });
            }
            else {
                deferral.reject(
                    signalR._.transportError(
                        signalR.resources.noConnectionTransport,
                        connection.transport
                    )
                );
            }

            return deferral.promise();
        },

        prepareQueryString: function (connection, url) {
            var preparedUrl;

            // Use addQs to start since it handles the ?/& prefix for us
            preparedUrl = transportLogic.addQs(url, "clientProtocol=" + connection.clientProtocol);

            // Add the user-specified query string params if any
            preparedUrl = transportLogic.addQs(preparedUrl, connection.qs);

            if (connection.token) {
                preparedUrl += "&connectionToken=" + window.encodeURIComponent(connection.token);
            }

            if (connection.data) {
                preparedUrl += "&connectionData=" + window.encodeURIComponent(connection.data);
            }

            return preparedUrl;
        },

        addQs: function (url, qs) {
            var appender = url.indexOf("?") !== -1 ? "&" : "?",
                firstChar;

            if (!qs) {
                return url;
            }

            if (typeof (qs) === "object") {
                return url + appender + $.param(qs);
            }

            if (typeof (qs) === "string") {
                firstChar = qs.charAt(0);

                if (firstChar === "?" || firstChar === "&") {
                    appender = "";
                }

                return url + appender + qs;
            }

            throw new Error("Query string property must be either a string or object.");
        },

        // BUG #2953: The url needs to be same otherwise it will cause a memory leak
        getUrl: function (connection, transport, reconnecting, poll, ajaxPost) {
            /// <summary>Gets the url for making a GET based connect request</summary>
            var baseUrl = transport === "webSockets" ? "" : connection.baseUrl,
                url = baseUrl + connection.appRelativeUrl,
                qs = "transport=" + transport;

            //IXNET: Si no peta
            //take my url, if not the same!
            /*if (url != connection.url) {
              url = connection.url;
            }*/

            if (!ajaxPost && connection.groupsToken) {
                qs += "&groupsToken=" + window.encodeURIComponent(connection.groupsToken);
            }

            if (!reconnecting) {
                url += "/connect";
            } else {
                if (poll) {
                    // longPolling transport specific
                    url += "/poll";
                } else {
                    url += "/reconnect";
                }

                if (!ajaxPost && connection.messageId) {
                    qs += "&messageId=" + window.encodeURIComponent(connection.messageId);
                }
            }
            url += "?" + qs;
            url = transportLogic.prepareQueryString(connection, url);

            if (!ajaxPost) {
                url += "&tid=" + Math.floor(Math.random() * 11);
            }

            //IXNET:
            //return url;
            return connection.url + url.substring(url.indexOf(connection.appRelativeUrl) + connection.appRelativeUrl.length);
        },

        maximizePersistentResponse: function (minPersistentResponse) {
            return {
                MessageId: minPersistentResponse.C,
                Messages: minPersistentResponse.M,
                Initialized: typeof (minPersistentResponse.S) !== "undefined" ? true : false,
                ShouldReconnect: typeof (minPersistentResponse.T) !== "undefined" ? true : false,
                LongPollDelay: minPersistentResponse.L,
                GroupsToken: minPersistentResponse.G
            };
        },

        updateGroups: function (connection, groupsToken) {
            if (groupsToken) {
                connection.groupsToken = groupsToken;
            }
        },

        stringifySend: function (connection, message) {
            if (typeof (message) === "string" || typeof (message) === "undefined" || message === null) {
                return message;
            }
            return connection.json.stringify(message);
        },

        ajaxSend: function (connection, data) {
            var payload = transportLogic.stringifySend(connection, data),
                url = getAjaxUrl(connection, "/send"),
                xhr,
                onFail = function (error, connection) {
                    $(connection).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.sendFailed, connection.transport, error, xhr), data]);
                };


            xhr = transportLogic.ajax(connection, {
                url: url,
                type: connection.ajaxDataType === "jsonp" ? "GET" : "POST",
                contentType: signalR._.defaultContentType,
                data: {
                    data: payload
                },
                success: function (result) {
                    var res;

                    if (result) {
                        try {
                            res = connection._parseResponse(result);
                        }
                        catch (error) {
                            onFail(error, connection);
                            connection.stop();
                            return;
                        }

                        transportLogic.triggerReceived(connection, res);
                    }
                },
                error: function (error, textStatus) {
                    if (textStatus === "abort" || textStatus === "parsererror") {
                        // The parsererror happens for sends that don't return any data, and hence
                        // don't write the jsonp callback to the response. This is harder to fix on the server
                        // so just hack around it on the client for now.
                        return;
                    }

                    onFail(error, connection);
                }
            });

            return xhr;
        },

        ajaxAbort: function (connection, async) {
            if (typeof (connection.transport) === "undefined") {
                return;
            }

            // Async by default unless explicitly overidden
            async = typeof async === "undefined" ? true : async;

            var url = getAjaxUrl(connection, "/abort");

            transportLogic.ajax(connection, {
                url: url,
                async: async,
                timeout: 1000,
                type: "POST"
            });

            connection.log("Fired ajax abort async = " + async + ".");
        },

        ajaxStart: function (connection, onSuccess) {
            var rejectDeferred = function (error) {
                    var deferred = connection._deferral;
                    if (deferred) {
                        deferred.reject(error);
                    }
                },
                triggerStartError = function (error) {
                    connection.log("The start request failed. Stopping the connection.");
                    $(connection).triggerHandler(events.onError, [error]);
                    rejectDeferred(error);
                    connection.stop();
                };

            connection._.startRequest = transportLogic.ajax(connection, {
                url: getAjaxUrl(connection, "/start"),
                success: function (result, statusText, xhr) {
                    var data;

                    try {
                        data = connection._parseResponse(result);
                    } catch (error) {
                        triggerStartError(signalR._.error(
                            signalR._.format(signalR.resources.errorParsingStartResponse, result),
                            error, xhr));
                        return;
                    }

                    if (data.Response === "started") {
                        onSuccess();
                    } else {
                        triggerStartError(signalR._.error(
                            signalR._.format(signalR.resources.invalidStartResponse, result),
                            null /* error */, xhr));
                    }
                },
                error: function (xhr, statusText, error) {
                    if (statusText !== startAbortText) {
                        triggerStartError(signalR._.error(
                            signalR.resources.errorDuringStartRequest,
                            error, xhr));
                    } else {
                        // Stop has been called, no need to trigger the error handler
                        // or stop the connection again with onStartError
                        connection.log("The start request aborted because connection.stop() was called.");
                        rejectDeferred(signalR._.error(
                            signalR.resources.stoppedDuringStartRequest,
                            null /* error */, xhr));
                    }
                }
            });
        },

        tryAbortStartRequest: function (connection) {
            if (connection._.startRequest) {
                // If the start request has already completed this will noop.
                connection._.startRequest.abort(startAbortText);
                delete connection._.startRequest;
            }
        },

        tryInitialize: function (connection, persistentResponse, onInitialized) {
            if (persistentResponse.Initialized && onInitialized) {
                onInitialized();
            } else if (persistentResponse.Initialized) {
                connection.log("WARNING! The client received an init message after reconnecting.");
            }

        },

        triggerReceived: function (connection, data) {
            if (!connection._.connectingMessageBuffer.tryBuffer(data)) {
                $(connection).triggerHandler(events.onReceived, [data]);
            }
        },

        processMessages: function (connection, minData, onInitialized) {
            var data;

            // Update the last message time stamp
            transportLogic.markLastMessage(connection);

            if (minData) {
                data = transportLogic.maximizePersistentResponse(minData);

                transportLogic.updateGroups(connection, data.GroupsToken);

                if (data.MessageId) {
                    connection.messageId = data.MessageId;
                }

                if (data.Messages) {
                    $.each(data.Messages, function (index, message) {
                        transportLogic.triggerReceived(connection, message);
                    });

                    transportLogic.tryInitialize(connection, data, onInitialized);
                }
            }
        },

        monitorKeepAlive: function (connection) {
            var keepAliveData = connection._.keepAliveData;

            // If we haven't initiated the keep alive timeouts then we need to
            if (!keepAliveData.monitoring) {
                keepAliveData.monitoring = true;

                transportLogic.markLastMessage(connection);

                // Save the function so we can unbind it on stop
                connection._.keepAliveData.reconnectKeepAliveUpdate = function () {
                    // Mark a new message so that keep alive doesn't time out connections
                    transportLogic.markLastMessage(connection);
                };

                // Update Keep alive on reconnect
                $(connection).bind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                connection.log("Now monitoring keep alive with a warning timeout of " + keepAliveData.timeoutWarning + ", keep alive timeout of " + keepAliveData.timeout + " and disconnecting timeout of " + connection.disconnectTimeout);
            } else {
                connection.log("Tried to monitor keep alive but it's already being monitored.");
            }
        },

        stopMonitoringKeepAlive: function (connection) {
            var keepAliveData = connection._.keepAliveData;

            // Only attempt to stop the keep alive monitoring if its being monitored
            if (keepAliveData.monitoring) {
                // Stop monitoring
                keepAliveData.monitoring = false;

                // Remove the updateKeepAlive function from the reconnect event
                $(connection).unbind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                // Clear all the keep alive data
                connection._.keepAliveData = {};
                connection.log("Stopping the monitoring of the keep alive.");
            }
        },

        startHeartbeat: function (connection) {
            connection._.lastActiveAt = new Date().getTime();
            beat(connection);
        },

        markLastMessage: function (connection) {
            connection._.lastMessageAt = new Date().getTime();
        },

        markActive: function (connection) {
            if (transportLogic.verifyLastActive(connection)) {
                connection._.lastActiveAt = new Date().getTime();
                return true;
            }

            return false;
        },

        isConnectedOrReconnecting: function (connection) {
            return connection.state === signalR.connectionState.connected ||
                   connection.state === signalR.connectionState.reconnecting;
        },

        ensureReconnectingState: function (connection) {
            if (changeState(connection,
                        signalR.connectionState.connected,
                        signalR.connectionState.reconnecting) === true) {
                $(connection).triggerHandler(events.onReconnecting);
            }
            return connection.state === signalR.connectionState.reconnecting;
        },

        clearReconnectTimeout: function (connection) {
            if (connection && connection._.reconnectTimeout) {
                window.clearTimeout(connection._.reconnectTimeout);
                delete connection._.reconnectTimeout;
            }
        },

        verifyLastActive: function (connection) {
            if (new Date().getTime() - connection._.lastActiveAt >= connection.reconnectWindow) {
                var message = signalR._.format(signalR.resources.reconnectWindowTimeout, new Date(connection._.lastActiveAt), connection.reconnectWindow);
                connection.log(message);
                $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
                connection.stop(/* async */ false, /* notifyServer */ false);
                return false;
            }

            return true;
        },

        reconnect: function (connection, transportName) {
            var transport = signalR.transports[transportName];

            // We should only set a reconnectTimeout if we are currently connected
            // and a reconnectTimeout isn't already set.
            if (transportLogic.isConnectedOrReconnecting(connection) && !connection._.reconnectTimeout) {
                // Need to verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
                if (!transportLogic.verifyLastActive(connection)) {
                    return;
                }

                connection._.reconnectTimeout = window.setTimeout(function () {
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    transport.stop(connection);

                    if (transportLogic.ensureReconnectingState(connection)) {
                        connection.log(transportName + " reconnecting.");
                        transport.start(connection);
                    }
                }, connection.reconnectDelay);
            }
        },

        handleParseFailure: function (connection, result, error, onFailed, context) {
            var wrappedError = signalR._.transportError(
                signalR._.format(signalR.resources.parseFailed, result),
                connection.transport,
                error,
                context);

            // If we're in the initialization phase trigger onFailed, otherwise stop the connection.
            if (onFailed && onFailed(wrappedError)) {
                connection.log("Failed to parse server response while attempting to connect.");
            } else {
                $(connection).triggerHandler(events.onError, [wrappedError]);
                connection.stop();
            }
        },

        initHandler: function (connection) {
            return new InitHandler(connection);
        },

        foreverFrame: {
            count: 0,
            connections: {}
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.webSockets.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic;

    signalR.transports.webSockets = {
        name: "webSockets",

        supportsKeepAlive: function () {
            return true;
        },

        send: function (connection, data) {
            var payload = transportLogic.stringifySend(connection, data);

            try {
                connection.socket.send(payload);
            } catch (ex) {
                $(connection).triggerHandler(events.onError,
                    [signalR._.transportError(
                        signalR.resources.webSocketsInvalidState,
                        connection.transport,
                        ex,
                        connection.socket
                    ),
                    data]);
            }
        },

        start: function (connection, onSuccess, onFailed) {
            var url,
                opened = false,
                that = this,
                reconnecting = !onSuccess,
                $connection = $(connection);

            if (!window.WebSocket) {
                onFailed();
                return;
            }

            if (!connection.socket) {
                if (connection.webSocketServerUrl) {
                    url = connection.webSocketServerUrl;
                } else {
                    url = connection.wsProtocol + connection.host;
                }

                url += transportLogic.getUrl(connection, this.name, reconnecting);
                //IXNET:
                var protocol = url.substr(0, url.indexOf('://'));
                url = protocol + url.substr(url.lastIndexOf('://'));

                connection.log("Connecting to websocket endpoint '" + url + "'.");
                connection.socket = new window.WebSocket(url);

                connection.socket.onopen = function () {
                    opened = true;
                    connection.log("Websocket opened.");

                    transportLogic.clearReconnectTimeout(connection);

                    if (changeState(connection,
                                    signalR.connectionState.reconnecting,
                                    signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                };

                connection.socket.onclose = function (event) {
                    var error;

                    // Only handle a socket close if the close is from the current socket.
                    // Sometimes on disconnect the server will push down an onclose event
                    // to an expired socket.

                    if (this === connection.socket) {
                        if (opened && typeof event.wasClean !== "undefined" && event.wasClean === false) {
                            // Ideally this would use the websocket.onerror handler (rather than checking wasClean in onclose) but
                            // I found in some circumstances Chrome won't call onerror. This implementation seems to work on all browsers.
                            error = signalR._.transportError(
                                signalR.resources.webSocketClosed,
                                connection.transport,
                                event);

                            connection.log("Unclean disconnect from websocket: " + (event.reason || "[no reason given]."));
                        } else {
                            connection.log("Websocket closed.");
                        }

                        if (!onFailed || !onFailed(error)) {
                            if (error) {
                                $(connection).triggerHandler(events.onError, [error]);
                            }

                            that.reconnect(connection);
                        }
                    }
                };

                connection.socket.onmessage = function (event) {
                    var data;

                    try {
                        data = connection._parseResponse(event.data);
                    }
                    catch (error) {
                        transportLogic.handleParseFailure(connection, event.data, error, onFailed, event);
                        return;
                    }

                    if (data) {
                        // data.M is PersistentResponse.Messages
                        if ($.isEmptyObject(data) || data.M) {
                            transportLogic.processMessages(connection, data, onSuccess);
                        } else {
                            // For websockets we need to trigger onReceived
                            // for callbacks to outgoing hub calls.
                            transportLogic.triggerReceived(connection, data);
                        }
                    }
                };
            }
        },

        reconnect: function (connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        stop: function (connection) {
            // Don't trigger a reconnect after stopping
            transportLogic.clearReconnectTimeout(connection);

            if (connection.socket) {
                connection.log("Closing the Websocket.");
                connection.socket.close();
                connection.socket = null;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.serverSentEvents.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        clearReconnectAttemptTimeout = function (connection) {
            window.clearTimeout(connection._.reconnectAttemptTimeoutHandle);
            delete connection._.reconnectAttemptTimeoutHandle;
        };

    signalR.transports.serverSentEvents = {
        name: "serverSentEvents",

        supportsKeepAlive: function () {
            return true;
        },

        timeOut: 3000,

        start: function (connection, onSuccess, onFailed) {
            var that = this,
                opened = false,
                $connection = $(connection),
                reconnecting = !onSuccess,
                url;

            if (connection.eventSource) {
                connection.log("The connection already has an event source. Stopping it.");
                connection.stop();
            }

            if (!window.EventSource) {
                if (onFailed) {
                    connection.log("This browser doesn't support SSE.");
                    onFailed();
                }
                return;
            }

            url = transportLogic.getUrl(connection, this.name, reconnecting);

            try {
                connection.log("Attempting to connect to SSE endpoint '" + url + "'.");
                connection.eventSource = new window.EventSource(url, { withCredentials: connection.withCredentials });
            }
            catch (e) {
                connection.log("EventSource failed trying to connect with error " + e.Message + ".");
                if (onFailed) {
                    // The connection failed, call the failed callback
                    onFailed();
                } else {
                    $connection.triggerHandler(events.onError, [signalR._.transportError(signalR.resources.eventSourceFailedToConnect, connection.transport, e)]);
                    if (reconnecting) {
                        // If we were reconnecting, rather than doing initial connect, then try reconnect again
                        that.reconnect(connection);
                    }
                }
                return;
            }

            if (reconnecting) {
                connection._.reconnectAttemptTimeoutHandle = window.setTimeout(function () {
                    if (opened === false) {
                        // If we're reconnecting and the event source is attempting to connect,
                        // don't keep retrying. This causes duplicate connections to spawn.
                        if (connection.eventSource.readyState !== window.EventSource.OPEN) {
                            // If we were reconnecting, rather than doing initial connect, then try reconnect again
                            that.reconnect(connection);
                        }
                    }
                },
                that.timeOut);
            }

            connection.eventSource.addEventListener("open", function (e) {
                connection.log("EventSource connected.");

                clearReconnectAttemptTimeout(connection);
                transportLogic.clearReconnectTimeout(connection);

                if (opened === false) {
                    opened = true;

                    if (changeState(connection,
                                         signalR.connectionState.reconnecting,
                                         signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                }
            }, false);

            connection.eventSource.addEventListener("message", function (e) {
                var res;

                // process messages
                if (e.data === "initialized") {
                    return;
                }

                try {
                    res = connection._parseResponse(e.data);
                }
                catch (error) {
                    transportLogic.handleParseFailure(connection, e.data, error, onFailed, e);
                    return;
                }

                transportLogic.processMessages(connection, res, onSuccess);
            }, false);

            connection.eventSource.addEventListener("error", function (e) {
                var error = signalR._.transportError(
                    signalR.resources.eventSourceError,
                    connection.transport,
                    e);

                // Only handle an error if the error is from the current Event Source.
                // Sometimes on disconnect the server will push down an error event
                // to an expired Event Source.
                if (this !== connection.eventSource) {
                    return;
                }

                if (onFailed && onFailed(error)) {
                    return;
                }

                connection.log("EventSource readyState: " + connection.eventSource.readyState + ".");

                if (e.eventPhase === window.EventSource.CLOSED) {
                    // We don't use the EventSource's native reconnect function as it
                    // doesn't allow us to change the URL when reconnecting. We need
                    // to change the URL to not include the /connect suffix, and pass
                    // the last message id we received.
                    connection.log("EventSource reconnecting due to the server connection ending.");
                    that.reconnect(connection);
                } else {
                    // connection error
                    connection.log("EventSource error.");
                    $connection.triggerHandler(events.onError, [error]);
                }
            }, false);
        },

        reconnect: function (connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function (connection) {
            // Don't trigger a reconnect after stopping
            clearReconnectAttemptTimeout(connection);
            transportLogic.clearReconnectTimeout(connection);

            if (connection && connection.eventSource) {
                connection.log("EventSource calling close().");
                connection.eventSource.close();
                connection.eventSource = null;
                delete connection.eventSource;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.foreverFrame.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        createFrame = function () {
            var frame = window.document.createElement("iframe");
            frame.setAttribute("style", "position:absolute;top:0;left:0;width:0;height:0;visibility:hidden;");
            return frame;
        },
        // Used to prevent infinite loading icon spins in older versions of ie
        // We build this object inside a closure so we don't pollute the rest of
        // the foreverFrame transport with unnecessary functions/utilities.
        loadPreventer = (function () {
            var loadingFixIntervalId = null,
                loadingFixInterval = 1000,
                attachedTo = 0;

            return {
                prevent: function () {
                    // Prevent additional iframe removal procedures from newer browsers
                    if (signalR._.ieVersion <= 8) {
                        // We only ever want to set the interval one time, so on the first attachedTo
                        if (attachedTo === 0) {
                            // Create and destroy iframe every 3 seconds to prevent loading icon, super hacky
                            loadingFixIntervalId = window.setInterval(function () {
                                var tempFrame = createFrame();

                                window.document.body.appendChild(tempFrame);
                                window.document.body.removeChild(tempFrame);

                                tempFrame = null;
                            }, loadingFixInterval);
                        }

                        attachedTo++;
                    }
                },
                cancel: function () {
                    // Only clear the interval if there's only one more object that the loadPreventer is attachedTo
                    if (attachedTo === 1) {
                        window.clearInterval(loadingFixIntervalId);
                    }

                    if (attachedTo > 0) {
                        attachedTo--;
                    }
                }
            };
        })();

    signalR.transports.foreverFrame = {
        name: "foreverFrame",

        supportsKeepAlive: function () {
            return true;
        },

        // Added as a value here so we can create tests to verify functionality
        iframeClearThreshold: 50,

        start: function (connection, onSuccess, onFailed) {
            var that = this,
                frameId = (transportLogic.foreverFrame.count += 1),
                url,
                frame = createFrame(),
                frameLoadHandler = function () {
                    connection.log("Forever frame iframe finished loading and is no longer receiving messages.");
                    if (!onFailed || !onFailed()) {
                        that.reconnect(connection);
                    }
                };

            if (window.EventSource) {
                // If the browser supports SSE, don't use Forever Frame
                if (onFailed) {
                    connection.log("Forever Frame is not supported by SignalR on browsers with SSE support.");
                    onFailed();
                }
                return;
            }

            frame.setAttribute("data-signalr-connection-id", connection.id);

            // Start preventing loading icon
            // This will only perform work if the loadPreventer is not attached to another connection.
            loadPreventer.prevent();

            // Build the url
            url = transportLogic.getUrl(connection, this.name);
            url += "&frameId=" + frameId;

            // add frame to the document prior to setting URL to avoid caching issues.
            window.document.documentElement.appendChild(frame);

            connection.log("Binding to iframe's load event.");

            if (frame.addEventListener) {
                frame.addEventListener("load", frameLoadHandler, false);
            } else if (frame.attachEvent) {
                frame.attachEvent("onload", frameLoadHandler);
            }

            frame.src = url;
            transportLogic.foreverFrame.connections[frameId] = connection;

            connection.frame = frame;
            connection.frameId = frameId;

            if (onSuccess) {
                connection.onSuccess = function () {
                    connection.log("Iframe transport started.");
                    onSuccess();
                };
            }
        },

        reconnect: function (connection) {
            var that = this;

            // Need to verify connection state and verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
            if (transportLogic.isConnectedOrReconnecting(connection) && transportLogic.verifyLastActive(connection)) {
                window.setTimeout(function () {
                    // Verify that we're ok to reconnect.
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    if (connection.frame && transportLogic.ensureReconnectingState(connection)) {
                        var frame = connection.frame,
                            src = transportLogic.getUrl(connection, that.name, true) + "&frameId=" + connection.frameId;
                        connection.log("Updating iframe src to '" + src + "'.");
                        frame.src = src;
                    }
                }, connection.reconnectDelay);
            }
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        receive: function (connection, data) {
            var cw,
                body,
                response;

            if (connection.json !== connection._originalJson) {
                // If there's a custom JSON parser configured then serialize the object
                // using the original (browser) JSON parser and then deserialize it using
                // the custom parser (connection._parseResponse does that). This is so we
                // can easily send the response from the server as "raw" JSON but still
                // support custom JSON deserialization in the browser.
                data = connection._originalJson.stringify(data);
            }

            response = connection._parseResponse(data);

            transportLogic.processMessages(connection, response, connection.onSuccess);

            // Protect against connection stopping from a callback trigger within the processMessages above.
            if (connection.state === $.signalR.connectionState.connected) {
                // Delete the script & div elements
                connection.frameMessageCount = (connection.frameMessageCount || 0) + 1;
                if (connection.frameMessageCount > signalR.transports.foreverFrame.iframeClearThreshold) {
                    connection.frameMessageCount = 0;
                    cw = connection.frame.contentWindow || connection.frame.contentDocument;
                    if (cw && cw.document && cw.document.body) {
                        body = cw.document.body;

                        // Remove all the child elements from the iframe's body to conserver memory
                        while (body.firstChild) {
                            body.removeChild(body.firstChild);
                        }
                    }
                }
            }
        },

        stop: function (connection) {
            var cw = null;

            // Stop attempting to prevent loading icon
            loadPreventer.cancel();

            if (connection.frame) {
                if (connection.frame.stop) {
                    connection.frame.stop();
                } else {
                    try {
                        cw = connection.frame.contentWindow || connection.frame.contentDocument;
                        if (cw.document && cw.document.execCommand) {
                            cw.document.execCommand("Stop");
                        }
                    }
                    catch (e) {
                        connection.log("Error occurred when stopping foreverFrame transport. Message = " + e.message + ".");
                    }
                }

                // Ensure the iframe is where we left it
                if (connection.frame.parentNode === window.document.documentElement) {
                    window.document.documentElement.removeChild(connection.frame);
                }

                delete transportLogic.foreverFrame.connections[connection.frameId];
                connection.frame = null;
                connection.frameId = null;
                delete connection.frame;
                delete connection.frameId;
                delete connection.onSuccess;
                delete connection.frameMessageCount;
                connection.log("Stopping forever frame.");
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        },

        getConnection: function (id) {
            return transportLogic.foreverFrame.connections[id];
        },

        started: function (connection) {
            if (changeState(connection,
                signalR.connectionState.reconnecting,
                signalR.connectionState.connected) === true) {

                $(connection).triggerHandler(events.onReconnect);
            }
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.longPolling.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        isDisconnecting = $.signalR.isDisconnecting,
        transportLogic = signalR.transports._logic;

    signalR.transports.longPolling = {
        name: "longPolling",

        supportsKeepAlive: function () {
            return false;
        },

        reconnectDelay: 3000,

        start: function (connection, onSuccess, onFailed) {
            /// <summary>Starts the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to start</param>
            var that = this,
                fireConnect = function () {
                    fireConnect = $.noop;

                    connection.log("LongPolling connected.");

                    if (onSuccess) {
                        onSuccess();
                    } else {
                        connection.log("WARNING! The client received an init message after reconnecting.");
                    }
                },
                tryFailConnect = function (error) {
                    if (onFailed(error)) {
                        connection.log("LongPolling failed to connect.");
                        return true;
                    }

                    return false;
                },
                privateData = connection._,
                reconnectErrors = 0,
                fireReconnected = function (instance) {
                    window.clearTimeout(privateData.reconnectTimeoutId);
                    privateData.reconnectTimeoutId = null;

                    if (changeState(instance,
                                    signalR.connectionState.reconnecting,
                                    signalR.connectionState.connected) === true) {
                        // Successfully reconnected!
                        instance.log("Raising the reconnect event");
                        $(instance).triggerHandler(events.onReconnect);
                    }
                },
                // 1 hour
                maxFireReconnectedTimeout = 3600000;

            if (connection.pollXhr) {
                connection.log("Polling xhr requests already exists, aborting.");
                connection.stop();
            }

            connection.messageId = null;

            privateData.reconnectTimeoutId = null;

            privateData.pollTimeoutId = window.setTimeout(function () {
                (function poll(instance, raiseReconnect) {
                    var messageId = instance.messageId,
                        connect = (messageId === null),
                        reconnecting = !connect,
                        polling = !raiseReconnect,
                        url = transportLogic.getUrl(instance, that.name, reconnecting, polling, true /* use Post for longPolling */),
                        postData = {};

                    if (instance.messageId) {
                        postData.messageId = instance.messageId;
                    }

                    if (instance.groupsToken) {
                        postData.groupsToken = instance.groupsToken;
                    }

                    // If we've disconnected during the time we've tried to re-instantiate the poll then stop.
                    if (isDisconnecting(instance) === true) {
                        return;
                    }

                    connection.log("Opening long polling request to '" + url + "'.");
                    instance.pollXhr = transportLogic.ajax(connection, {
                        xhrFields: {
                            onprogress: function () {
                                transportLogic.markLastMessage(connection);
                            }
                        },
                        url: url,
                        type: "POST",
                        contentType: signalR._.defaultContentType,
                        data: postData,
                        timeout: connection._.pollTimeout,
                        success: function (result) {
                            var minData,
                                delay = 0,
                                data,
                                shouldReconnect;

                            connection.log("Long poll complete.");

                            // Reset our reconnect errors so if we transition into a reconnecting state again we trigger
                            // reconnected quickly
                            reconnectErrors = 0;

                            try {
                                // Remove any keep-alives from the beginning of the result
                                minData = connection._parseResponse(result);
                            }
                            catch (error) {
                                transportLogic.handleParseFailure(instance, result, error, tryFailConnect, instance.pollXhr);
                                return;
                            }

                            // If there's currently a timeout to trigger reconnect, fire it now before processing messages
                            if (privateData.reconnectTimeoutId !== null) {
                                fireReconnected(instance);
                            }

                            if (minData) {
                                data = transportLogic.maximizePersistentResponse(minData);
                            }

                            transportLogic.processMessages(instance, minData, fireConnect);

                            if (data &&
                                $.type(data.LongPollDelay) === "number") {
                                delay = data.LongPollDelay;
                            }

                            if (isDisconnecting(instance) === true) {
                                return;
                            }

                            shouldReconnect = data && data.ShouldReconnect;
                            if (shouldReconnect) {
                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into a invalid state in processMessages.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }
                            }

                            // We never want to pass a raiseReconnect flag after a successful poll.  This is handled via the error function
                            if (delay > 0) {
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, shouldReconnect);
                                }, delay);
                            } else {
                                poll(instance, shouldReconnect);
                            }
                        },

                        error: function (data, textStatus) {
                            var error = signalR._.transportError(signalR.resources.longPollFailed, connection.transport, data, instance.pollXhr);

                            // Stop trying to trigger reconnect, connection is in an error state
                            // If we're not in the reconnect state this will noop
                            window.clearTimeout(privateData.reconnectTimeoutId);
                            privateData.reconnectTimeoutId = null;

                            if (textStatus === "abort") {
                                connection.log("Aborted xhr request.");
                                return;
                            }

                            if (!tryFailConnect(error)) {

                                // Increment our reconnect errors, we assume all errors to be reconnect errors
                                // In the case that it's our first error this will cause Reconnect to be fired
                                // after 1 second due to reconnectErrors being = 1.
                                reconnectErrors++;

                                if (connection.state !== signalR.connectionState.reconnecting) {
                                    connection.log("An error occurred using longPolling. Status = " + textStatus + ".  Response = " + data.responseText + ".");
                                    $(instance).triggerHandler(events.onError, [error]);
                                }

                                // We check the state here to verify that we're not in an invalid state prior to verifying Reconnect.
                                // If we're not in connected or reconnecting then the next ensureReconnectingState check will fail and will return.
                                // Therefore we don't want to change that failure code path.
                                if ((connection.state === signalR.connectionState.connected ||
                                    connection.state === signalR.connectionState.reconnecting) &&
                                    !transportLogic.verifyLastActive(connection)) {
                                    return;
                                }

                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into the disconnected or connecting state within the above error handler trigger.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }

                                // Call poll with the raiseReconnect flag as true after the reconnect delay
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, true);
                                }, that.reconnectDelay);
                            }
                        }
                    });

                    // This will only ever pass after an error has occurred via the poll ajax procedure.
                    if (reconnecting && raiseReconnect === true) {
                        // We wait to reconnect depending on how many times we've failed to reconnect.
                        // This is essentially a heuristic that will exponentially increase in wait time before
                        // triggering reconnected.  This depends on the "error" handler of Poll to cancel this
                        // timeout if it triggers before the Reconnected event fires.
                        // The Math.min at the end is to ensure that the reconnect timeout does not overflow.
                        privateData.reconnectTimeoutId = window.setTimeout(function () { fireReconnected(instance); }, Math.min(1000 * (Math.pow(2, reconnectErrors) - 1), maxFireReconnectedTimeout));
                    }
                }(connection));
            }, 250); // Have to delay initial poll so Chrome doesn't show loader spinner in tab
        },

        lostConnection: function (connection) {
            if (connection.pollXhr) {
                connection.pollXhr.abort("lostConnection");
            }
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function (connection) {
            /// <summary>Stops the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to stop</param>

            window.clearTimeout(connection._.pollTimeoutId);
            window.clearTimeout(connection._.reconnectTimeoutId);

            delete connection._.pollTimeoutId;
            delete connection._.reconnectTimeoutId;

            if (connection.pollXhr) {
                connection.pollXhr.abort();
                connection.pollXhr = null;
                delete connection.pollXhr;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.hubs.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var eventNamespace = ".hubProxy",
        signalR = $.signalR;

    function makeEventName(event) {
        return event + eventNamespace;
    }

    // Equivalent to Array.prototype.map
    function map(arr, fun, thisp) {
        var i,
            length = arr.length,
            result = [];
        for (i = 0; i < length; i += 1) {
            if (arr.hasOwnProperty(i)) {
                result[i] = fun.call(thisp, arr[i], i, arr);
            }
        }
        return result;
    }

    function getArgValue(a) {
        return $.isFunction(a) ? null : ($.type(a) === "undefined" ? null : a);
    }

    function hasMembers(obj) {
        for (var key in obj) {
            // If we have any properties in our callback map then we have callbacks and can exit the loop via return
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }

        return false;
    }

    function clearInvocationCallbacks(connection, error) {
        /// <param name="connection" type="hubConnection" />
        var callbacks = connection._.invocationCallbacks,
            callback;

        if (hasMembers(callbacks)) {
            connection.log("Clearing hub invocation callbacks with error: " + error + ".");
        }

        // Reset the callback cache now as we have a local var referencing it
        connection._.invocationCallbackId = 0;
        delete connection._.invocationCallbacks;
        connection._.invocationCallbacks = {};

        // Loop over the callbacks and invoke them.
        // We do this using a local var reference and *after* we've cleared the cache
        // so that if a fail callback itself tries to invoke another method we don't
        // end up with its callback in the list we're looping over.
        for (var callbackId in callbacks) {
            callback = callbacks[callbackId];
            callback.method.call(callback.scope, { E: error });
        }
    }

    // hubProxy
    function hubProxy(hubConnection, hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        return new hubProxy.fn.init(hubConnection, hubName);
    }

    hubProxy.fn = hubProxy.prototype = {
        init: function (connection, hubName) {
            this.state = {};
            this.connection = connection;
            this.hubName = hubName;
            this._ = {
                callbackMap: {}
            };
        },

        constructor: hubProxy,

        hasSubscriptions: function () {
            return hasMembers(this._.callbackMap);
        },

        on: function (eventName, callback) {
            /// <summary>Wires up a callback to be invoked when a invocation request is received from the server hub.</summary>
            /// <param name="eventName" type="String">The name of the hub event to register the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            // If there is not an event registered for this callback yet we want to create its event space in the callback map.
            if (!callbackMap[eventName]) {
                callbackMap[eventName] = {};
            }

            // Map the callback to our encompassed function
            callbackMap[eventName][callback] = function (e, data) {
                callback.apply(that, data);
            };

            $(that).bind(makeEventName(eventName), callbackMap[eventName][callback]);

            return that;
        },

        off: function (eventName, callback) {
            /// <summary>Removes the callback invocation request from the server hub for the given event name.</summary>
            /// <param name="eventName" type="String">The name of the hub event to unregister the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap,
                callbackSpace;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            callbackSpace = callbackMap[eventName];

            // Verify that there is an event space to unbind
            if (callbackSpace) {
                // Only unbind if there's an event bound with eventName and a callback with the specified callback
                if (callbackSpace[callback]) {
                    $(that).unbind(makeEventName(eventName), callbackSpace[callback]);

                    // Remove the callback from the callback map
                    delete callbackSpace[callback];

                    // Check if there are any members left on the event, if not we need to destroy it.
                    if (!hasMembers(callbackSpace)) {
                        delete callbackMap[eventName];
                    }
                } else if (!callback) { // Check if we're removing the whole event and we didn't error because of an invalid callback
                    $(that).unbind(makeEventName(eventName));

                    delete callbackMap[eventName];
                }
            }

            return that;
        },

        invoke: function (methodName) {
            /// <summary>Invokes a server hub method with the given arguments.</summary>
            /// <param name="methodName" type="String">The name of the server hub method.</param>
            var that = this,
                connection = that.connection,
                args = $.makeArray(arguments).slice(1),
                argValues = map(args, getArgValue),
                data = { H: that.hubName, M: methodName, A: argValues, I: connection._.invocationCallbackId },
                d = $.Deferred(),
                callback = function (minResult) {
                    var result = that._maximizeHubResponse(minResult),
                        source,
                        error;

                    // Update the hub state
                    $.extend(that.state, result.State);

                    if (result.Progress) {
                        if (d.notifyWith) {
                            // Progress is only supported in jQuery 1.7+
                            d.notifyWith(that, [result.Progress.Data]);
                        } else if(!connection._.progressjQueryVersionLogged) {
                            connection.log("A hub method invocation progress update was received but the version of jQuery in use (" + $.prototype.jquery + ") does not support progress updates. Upgrade to jQuery 1.7+ to receive progress notifications.");
                            connection._.progressjQueryVersionLogged = true;
                        }
                    } else if (result.Error) {
                        // Server hub method threw an exception, log it & reject the deferred
                        if (result.StackTrace) {
                            connection.log(result.Error + "\n" + result.StackTrace + ".");
                        }

                        // result.ErrorData is only set if a HubException was thrown
                        source = result.IsHubException ? "HubException" : "Exception";
                        error = signalR._.error(result.Error, source);
                        error.data = result.ErrorData;

                        connection.log(that.hubName + "." + methodName + " failed to execute. Error: " + error.message);
                        d.rejectWith(that, [error]);
                    } else {
                        // Server invocation succeeded, resolve the deferred
                        connection.log("Invoked " + that.hubName + "." + methodName);
                        d.resolveWith(that, [result.Result]);
                    }
                };

            connection._.invocationCallbacks[connection._.invocationCallbackId.toString()] = { scope: that, method: callback };
            connection._.invocationCallbackId += 1;

            if (!$.isEmptyObject(that.state)) {
                data.S = that.state;
            }

            connection.log("Invoking " + that.hubName + "." + methodName);
            connection.send(data);

            return d.promise();
        },

        _maximizeHubResponse: function (minHubResponse) {
            return {
                State: minHubResponse.S,
                Result: minHubResponse.R,
                Progress: minHubResponse.P ? {
                    Id: minHubResponse.P.I,
                    Data: minHubResponse.P.D
                } : null,
                Id: minHubResponse.I,
                IsHubException: minHubResponse.H,
                Error: minHubResponse.E,
                StackTrace: minHubResponse.T,
                ErrorData: minHubResponse.D
            };
        }
    };

    hubProxy.fn.init.prototype = hubProxy.fn;

    // hubConnection
    function hubConnection(url, options) {
        /// <summary>Creates a new hub connection.</summary>
        /// <param name="url" type="String">[Optional] The hub route url, defaults to "/signalr".</param>
        /// <param name="options" type="Object">[Optional] Settings to use when creating the hubConnection.</param>
        var settings = {
            qs: null,
            logging: false,
            useDefaultPath: true
        };

        $.extend(settings, options);

        if (!url || settings.useDefaultPath) {
            url = (url || "") + "/signalr";
        }
        return new hubConnection.fn.init(url, settings);
    }

    hubConnection.fn = hubConnection.prototype = $.connection();

    hubConnection.fn.init = function (url, options) {
        var settings = {
                qs: null,
                logging: false,
                useDefaultPath: true
            },
            connection = this;

        $.extend(settings, options);

        // Call the base constructor
        $.signalR.fn.init.call(connection, url, settings.qs, settings.logging);

        // Object to store hub proxies for this connection
        connection.proxies = {};

        connection._.invocationCallbackId = 0;
        connection._.invocationCallbacks = {};

        // Wire up the received handler
        connection.received(function (minData) {
            var data, proxy, dataCallbackId, callback, hubName, eventName;
            if (!minData) {
                return;
            }

            // We have to handle progress updates first in order to ensure old clients that receive
            // progress updates enter the return value branch and then no-op when they can't find
            // the callback in the map (because the minData.I value will not be a valid callback ID)
            if (typeof (minData.P) !== "undefined") {
                // Process progress notification
                dataCallbackId = minData.P.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    callback.method.call(callback.scope, minData);
                }
            } else if (typeof (minData.I) !== "undefined") {
                // We received the return value from a server method invocation, look up callback by id and call it
                dataCallbackId = minData.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    // Delete the callback from the proxy
                    connection._.invocationCallbacks[dataCallbackId] = null;
                    delete connection._.invocationCallbacks[dataCallbackId];

                    // Invoke the callback
                    callback.method.call(callback.scope, minData);
                }
            } else {
                data = this._maximizeClientHubInvocation(minData);

                // We received a client invocation request, i.e. broadcast from server hub
                connection.log("Triggering client hub event '" + data.Method + "' on hub '" + data.Hub + "'.");

                // Normalize the names to lowercase
                hubName = data.Hub.toLowerCase();
                eventName = data.Method.toLowerCase();

                // Trigger the local invocation event
                proxy = this.proxies[hubName];

                // Update the hub state
                $.extend(proxy.state, data.State);
                $(proxy).triggerHandler(makeEventName(eventName), [data.Args]);
            }
        });

        connection.error(function (errData, origData) {
            var callbackId, callback;

            if (!origData) {
                // No original data passed so this is not a send error
                return;
            }

            callbackId = origData.I;
            callback = connection._.invocationCallbacks[callbackId];

            // Verify that there is a callback bound (could have been cleared)
            if (callback) {
                // Delete the callback
                connection._.invocationCallbacks[callbackId] = null;
                delete connection._.invocationCallbacks[callbackId];

                // Invoke the callback with an error to reject the promise
                callback.method.call(callback.scope, { E: errData });
            }
        });

        connection.reconnecting(function () {
            if (connection.transport && connection.transport.name === "webSockets") {
                clearInvocationCallbacks(connection, "Connection started reconnecting before invocation result was received.");
            }
        });

        connection.disconnected(function () {
            clearInvocationCallbacks(connection, "Connection was disconnected before invocation result was received.");
        });
    };

    hubConnection.fn._maximizeClientHubInvocation = function (minClientHubInvocation) {
        return {
            Hub: minClientHubInvocation.H,
            Method: minClientHubInvocation.M,
            Args: minClientHubInvocation.A,
            State: minClientHubInvocation.S
        };
    };

    hubConnection.fn._registerSubscribedHubs = function () {
        /// <summary>
        ///     Sets the starting event to loop through the known hubs and register any new hubs
        ///     that have been added to the proxy.
        /// </summary>
        var connection = this;

        if (!connection._subscribedToHubs) {
            connection._subscribedToHubs = true;
            connection.starting(function () {
                // Set the connection's data object with all the hub proxies with active subscriptions.
                // These proxies will receive notifications from the server.
                var subscribedHubs = [];

                $.each(connection.proxies, function (key) {
                    if (this.hasSubscriptions()) {
                        subscribedHubs.push({ name: key });
                        connection.log("Client subscribed to hub '" + key + "'.");
                    }
                });

                if (subscribedHubs.length === 0) {
                    connection.log("No hubs have been subscribed to.  The client will not receive data from hubs.  To fix, declare at least one client side function prior to connection start for each hub you wish to subscribe to.");
                }

                connection.data = connection.json.stringify(subscribedHubs);
            });
        }
    };

    hubConnection.fn.createHubProxy = function (hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        /// <param name="hubName" type="String">
        ///     The name of the hub on the server to create the proxy for.
        /// </param>

        // Normalize the name to lowercase
        hubName = hubName.toLowerCase();

        var proxy = this.proxies[hubName];
        if (!proxy) {
            proxy = hubProxy(this, hubName);
            this.proxies[hubName] = proxy;
        }

        this._registerSubscribedHubs();

        return proxy;
    };

    hubConnection.fn.init.prototype = hubConnection.fn;

    $.hubConnection = hubConnection;

}(window.jQuery, window));
/* jquery.signalR.version.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.core.js" />
(function ($, undefined) {
    $.signalR.version = "2.2.2";
}(window.jQuery));

/*jslint browser: true, white: false*/
/*global CMP_GTE*/
/*global CMP_LTE*/
/*global CMP_LT*/
/*global CMP_EQ*/
/*global CMP_LIKEL*/
/*global CMP_ISNULL*/
function convertDateStringsToDates(input) {
  var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)$/;
  // Ignore things that aren't objects.
  if (!angular.isObject(input)) {
    return input;
  }
  var key = "";
  for (key in input) {
    if (!input.hasOwnProperty(key)) { continue; }

    var value = input[key];
    var match;
    // Check for string properties which look like dates.
    if (angular.isString(value) && (match = value.match(regexIso8601))) {
      var milliseconds = Date.parse(match[0]);
      if (!isNaN(milliseconds)) {
        input[key] = new Date(milliseconds);
      }
    } else if (angular.isObject(value)) {
      // Recurse into object
      convertDateStringsToDates(value);
    }
  }
}

/*function convertDateStringsToDates2(input) {
  var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)$/;

  var value = input;
  var match;
  // Check for string properties which look like dates.
  if (angular.isString(value) && (match = value.match(regexIso8601))) {
    var milliseconds = Date.parse(match[0]);
    if (!isNaN(milliseconds)) {
        input = new Date(milliseconds);
    }
  }
  return input;
}

function convertDateToUTC(year,month,day) {
  var date = new Date(Date.UTC(year,month,day));
  //return new Date(dateUtc);
  var utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return utc;
}*/


function convertFromServerType(servertype) {
  if (servertype == "Int32" || servertype == "Byte") return "number";
  else if (servertype == "Decimal" || servertype == "Double") return "decimal";
  else if (servertype == "Char") return "boolean";
  else if (servertype == "DateTime") return "date";
  else return "string";
}
function setDefaultFilter(filterType, filterApiBy, minus, noDates) {
  if (filterType == "Fecha") {
    if (noDates) {
      return [{ data_ini: null, data_fi: null }];
    }
    filterApiBy = angular.isDefined(filterApiBy) ? filterApiBy : "month";
    var ahora = new Date();
    var fechaCalculada = new Date();

    if (filterApiBy == "days") {
      if (angular.isNumber(minus)) {
        fechaCalculada.setDate(ahora.getDate() - minus);
      } else {
        //TODO: Ara mateix nomes es fa servir aixo per la setmana actual, quan rep un string fa la setmana actual.
        //Si hi haguessin més opcions, s'hauria de fer ús d'un switch.
        var day = fechaCalculada.getDay() || 7;
        if (day !== 1) {
          fechaCalculada.setHours(-24 * (day - 1));
        }
      }
    } else {
      fechaCalculada.setDate(1);
    }

    if (filterApiBy == "month") {
      if (minus) {
        fechaCalculada.setMonth(ahora.getMonth() - minus);
      } else {
        fechaCalculada.setMonth(ahora.getMonth());
      }
    }

    if (filterApiBy == "year" || filterApiBy == "full_year") {
      if (minus) {
        fechaCalculada.setFullYear(ahora.getFullYear() - minus);
      } else {
        fechaCalculada.setFullYear(ahora.getFullYear());
      }
      fechaCalculada.setMonth(0);
    }

    if (filterApiBy == "full_year") {
      ahora.setFullYear(fechaCalculada.getFullYear());
      ahora.setMonth(11);
      ahora.setDate(31);
    }

    return [{ data_ini: fechaCalculada, data_fi: ahora }];
  } else if (filterType == "CheckBox") {
    return filterApiBy;
  } else if (filterType == "Texto") {
    return [{ term: filterApiBy }];
  }
}


function getDefaultFilters(columns, param, $filter) {
  var hayFiltros = false;
  if (angular.isDefined(columns)) {
    columns.forEach(function (column) {
      if (column.filteropt == "Fecha") {
        if (column.filters != null && column.filters.length != 0) {
          //Periodo: Hoy, Ayer,...
          if (angular.isDefined(column.filters[0].periodo_ini) && column.filters[0].periodo_ini != null) {
            hayFiltros = true;
            param.Filters.push({ Field: column.field, Value: column.filters[0].periodo_ini, Operator: CMP_GTE });
            //param.Filters.push({ Field: column.field, Value: column.filters[0].data_especial, Operator: CMP_LTE });
          } else {
            if (column.filters[0].data_ini != null) {
              hayFiltros = true;
              param.Filters.push({ Field: column.field, Value: $filter("date")(column.filters[0].data_ini, "yyyy-MM-dd"), Operator: CMP_GTE });
            }
          }
          //Periodo: Hoy, Ayer,...
          if (angular.isDefined(column.filters[0].periodo_fin) && column.filters[0].periodo_fin != null) {
            hayFiltros = true;
            param.Filters.push({ Field: column.field, Value: column.filters[0].periodo_fin, Operator: CMP_LTE });
          } else {
            if (column.filters[0].data_fi != null) {
              hayFiltros = true;
              var now = $filter("date")(column.filters[0].data_fi, "yyyy-MM-dd");
              var partsDate = now.split("-");
              var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
              //li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
              dateMax.setDate(dateMax.getDate() + 1);
              param.Filters.push({ Field: column.field, Value: $filter("date")(dateMax, "yyyy-MM-dd"), Operator: CMP_LT });
            }
          }
        }
      } else if (column.filteropt == "CheckBox") {
        if (column.filter.term != null) {
          var valor = column.filter.term;
          if (typeof (valor) === "boolean") {
            valor == true ? valor = "1" : valor = "0";
          }
          hayFiltros = true;
          param.Filters.push({ Field: column.field, Value: valor, Operator: CMP_EQ });
        }
      } else if (column.filteropt == "Texto") {
        if (column.filters != null && column.filters.length != 0) {
          if (column.filters[0].term != null && column.filters[0].term != "") {
            hayFiltros = true;
            var pars = column.filters[0].term.split("|");
            var first = true;
            pars.forEach(function (parameter, index) {
              //var partsParameter = parameter.split('-');
              //var parameterValue = parameter.indexOf('-');
              //if(parameterValue != -1){
              //parameterValue = partsParameter[partsParameter.length - 1].replace(/\s+/g, '');//Arnau: Crec que no fa falta esborrar espais.
              //parameterValue = partsParameter[partsParameter.length - 1];
              //parameterValue = parameter.substr(parameter.indexOf('-') + 1);
              //} else {
              var parameterValue = parameter;
              //}
              var paramObj = { Field: column.field, Value: parameterValue, Operator: CMP_EQ };
              if (first == true) {
                paramObj.StartPar = true;
                first = false;
              } else {
                paramObj.Or = true;
              }
              if (index == (pars.length - 1)) {
                paramObj.EndPar = true;
              }
              param.Filters.push(paramObj);
            });

          }/* else { //Això serveix per fer que si un filtre d'API està buit la API no retorni resultats, però en Joan vol que en aquest cas es retornin tots.
            param.Filters.push({ Field: column.field, Value: "", Operator: CMP_EQ });
          }*/
        }
      }
    });
  }
  return hayFiltros;
}

function getLocalFilters(columns, param, $filter) {
  columns.forEach(function (column) {
    if (angular.isUndefined(column.filteropt)) {
      if (column.filter != null && angular.isDefined(column.filter.numfilters) && column.filter.numfilters > 0) {
        if (column.filter.term != null && column.filter.term != "") {
          var pars = column.filter.term.split("|");
          var first = true;

          pars.forEach(function (parameter, index) {
            if (column.type == "date" && parameter == "#empty") {
              addNullOrEmpty(param.Filters, column.field);
            }
            else {
              if (column.type != "date" || column.type == "date" && parameter.lastIndexOf("-") != -1) {

                if (parameter == "#value") {
                  addNotNullAndNotEmpty(param.Filters, column.field);

                } else if (parameter == "#empty") {
                  addNullOrEmpty(param.Filters, column.field);

                } else {
                  var paramObj = { Field: column.field, Value: parameter, Operator: CMP_EQ };
                  if (first == true) {
                    paramObj.StartPar = true;
                    first = false;
                  } else {
                    paramObj.Or = true;
                  }
                  if (index == (pars.length - 1)) {
                    paramObj.EndPar = true;
                  }
                  param.Filters.push(paramObj);
                }
              }
            }
          });
        }
      }
    }
  });
}

function addNotNullAndNotEmpty(paramFilters, colName) {
  var paramNotEmpty = { Field: colName, Value: "", Operator: CMP_EQ, StartPar: true, Not: true };
  var paramNotNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Not: true };

  paramFilters.push(paramNotEmpty);
  paramFilters.push(paramNotNull);

  return paramFilters;
}

function addNullOrEmpty(paramFilters, colName) {
  var paramEmpty = { Field: colName, Value: "", Operator: CMP_EQ, StartPar: true };
  var paramNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Or: true };

  paramFilters.push(paramEmpty);
  paramFilters.push(paramNull);

  return paramFilters;
}

function getCestaFilters(param, $filter, cfg, cesta, metadata, skip) {

  var items = cesta.items;
  var terminacion = cesta.terminacion;
  var campo = cesta.campo;

  var numItems = items.length;

  for (var i = 0; i < items.length; i++) {
    var newparam = { Field: getNameFromConfig(campo, cfg), Value: items[i] };

    if (campo == "chasis" && terminacion == 1) {
      newparam.Operator = CMP_LIKEL;
      newparam.Field = "chasisr";
      newparam.Value = $filter("reverse")(newparam.Value);
    } else {
      newparam.Operator = CMP_EQ;
    }

    //Busquem el param a la metadata per aplicar el TableAliasName si aquest ve.
    if (angular.isDefined(metadata) && metadata != null) {
      var attrMetadata = metadata.find(function (e) { return e.Name.toUpperCase() == newparam.Field.toUpperCase() });
      if (angular.isDefined(attrMetadata) && attrMetadata.TableAliasName) {
        newparam.Field = attrMetadata.TableAliasName + "." + newparam.Field;
      }
    }

    if (i == 0 && i != numItems - 1) {
      newparam.StartPar = true;
    }
    else if (i == numItems - 1 && i > 0) {
      newparam.EndPar = true;
      newparam.Or = true;
    }
    else if (i > 0) {
      newparam.Or = true;
    }
    if (angular.isDefined(skip) && skip) {
      newparam.skip = true;
    }

    param.Filters.push(newparam);
  }
  return param.Filters;
}

function getNameFromConfig(field, cfg) {
  if (field == "chasis")
    return cfg.cestaFilterBy;
  else
    return field;
}


function ixGetPatchOperations(originalObj, newObj) {
  var data = [];
  angular.forEach(originalObj, function (valor, clave) {
    if (angular.isDefined(newObj[clave]) && originalObj[clave] != newObj[clave] &&
      (!angular.isObject(newObj[clave]) ||
        (angular.isDate(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave])) ||
        (angular.isArray(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave]) &&
          //chapuza perque no hi hagi problemes al editar un llistat programat.
          clave != "mailto" && clave != "mailcc")
      )
    ) {
      data.push({
        value: newObj[clave],
        path: "/" + clave,
        op: "replace"
      });
    }
  });
  return data;
}

function getColors() {
  return [
    { color: 0, name: "Black", visual: "#000000" },
    { color: 128, name: "Maroon", visual: "#800000" },
    { color: 32768, name: "Green", visual: "#008000" },
    { color: 32896, name: "Olive", visual: "#808000" },
    { color: 8388608, name: "Navy", visual: "#000080" },
    { color: 8388736, name: "Purple", visual: "#800080" },
    { color: 8421376, name: "Teal", visual: "#008080" },
    { color: 8421504, name: "Gray", visual: "#808080" },
    { color: 12632256, name: "Silver", visual: "#C0C0C0" },
    { color: 255, name: "Red", visual: "#FF0000" },
    { color: 65280, name: "Lime", visual: "#00FF00" },
    { color: 65535, name: "Yellow", visual: "#FFFF00" },
    { color: 1219071, name: "Orange", visual: "#FF9912" },
    { color: 16711680, name: "Blue", visual: "#0000FF" },
    { color: 16711935, name: "Fuchsia", visual: "#FF00FF" },
    { color: 16776960, name: "Aqua", visual: "#00FFFF" },
    { color: 16777215, name: "White", visual: "#FFFFFF" },
    { color: 12639424, name: "MoneyGreen", visual: "#c0dcc0" },
    { color: 15780518, name: "SkyBlue", visual: "#a6caf0" },
    { color: 16449525, name: "Cream", visual: "#F5FFFA" },
    { color: 10789024, name: "MedGray", visual: "#a4a0a0" }
  ];
}
//Sol·lució temporal per problema d'Extranet.
function ixPing($interval, $http, cfg) {
  var interval
  interval = $interval(function () {
    //if(angular.isDefined(localStorage['authorizationData'])){
    if (angular.isDefined(sessionStorage['authorizationData'])) {
      $http.get(cfg.baseURL + 'api_usuarios/CurrentUser');
    } else {
      if (angular.isDefined(interval)) {
        $interval.cancel(interval);
      }
    }
  }, 60 * 1000);
}

function buildIxSearch() {
  return { Filters: [], OrderBy: [] };
}

function buildIxProjectionParam() {
  return { Selection: { Filters: [], OrderBy: [] }, Fields: [] };
}

function addToParamFilters(paramFilters, field, value, op, or) {
  if (angular.isUndefined(op)) op = CMP_EQ;
  paramFilters.push({
    Field: field,
    Value: value,
    Operator: op,
    Or: (angular.isDefined(or) && or)
  });

  return paramFilters;
}

function checkPermission($http, cfg, entity) {
  return $http.get(cfg.baseURL + "configuraciones/GetConfig/" + entity).then(function (response) {
    return response.data;
  });
}

function checkMultiplePermission($http, cfg, entities) {
  return $http.post(cfg.baseURL + "configuraciones/GetConfigMultiple/", entities).then(function (response) {
    return response.data;
  });
}

function mergeArraysByTag(iterateArray, searchInArray, tag) {
  var mergedArr = [];
  iterateArray.forEach(function (arrayItem) {
    var updateItem = searchInArray.find(function (e) { return e[tag].toLowerCase() === arrayItem[tag].toLowerCase(); });
    if (angular.isUndefined(updateItem)) searchInArray.push(arrayItem);
    else angular.merge(updateItem, arrayItem);
  });
  return searchInArray;
}

function getCurrentDate() {
  var now = new Date();
  var day = now.getDate();
  var month = now.getMonth() + 1;
  var year = now.getFullYear();

  return new Date(year, month - 1, day);
}

function getCurrentTime() { }

function parseObjectsToString(objects, fields){
  return objects.map(function(e) {
    // Para casos en que el objeto tiene ID y DESCRICPCION iguales, devolvemos  sólo un valor
    if(fields.length==2 && e[fields[0]]==e[fields[1]]) {
      return e[fields[0]];
    }
    return fields.map(function(ee) { return e[ee]}).join(" - ");
  });
}

function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function skipValidationErrors() {
  return ["parse", "mask", "date"];
}

function deleteSkippedValidations(formErrors, skippedErrors) {
  angular.forEach(Object.keys(formErrors), function (error) {
    if (skippedErrors.indexOf(error) > -1) delete formErrors[error];
  });
  return formErrors;
}

function simulateAPIError(contextStatusObj, errorKey, messages) {
  contextStatusObj.$invalid = true;
  contextStatusObj.$error[errorKey] = messages;
}

function ixGridColumnFilterCondition($filter) {
  return function (searchTerm, cellValue, row, column) {
    if (searchTerm == "#empty") searchTerm = "";
    else if (searchTerm == "#value") searchTerm = "*";
    if (typeof (searchTerm) === "boolean") {
      searchTerm === true ? searchTerm = "1" : searchTerm = "0";
    }
    searchTerm = searchTerm.replace(/\\/g, "");
    var conditions = searchTerm.split('|');

    if (column.colDef.type == "number" && typeof (cellValue) !== "boolean" && column.colDef.control == "CheckBox") {//serveix per retornar tots aquells checks que no estiguin marcats perque el seu valor es null o undefined
      if (cellValue !== 1) cellValue = 0;
    }

    //Si la row es nova es mostra sense importar el filtre que hi hagi.
    if (row.entity.isNew == true) {
      return true;
    } else if (angular.isDefined(cellValue) && cellValue != null) {//Si no, mirem que tingui valor i que aquest es trobi dintre de la col·lecció de condicions.
      if (column.colDef.type == "date") {
        var dateParts = [];
        if (angular.isDate(cellValue))
          dateParts = ($filter("date")(cellValue, "dd/MM/yyyy", null)).split("/");
        else
          dateParts = cellValue.split("/");
        var newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        cellValue = newDate.toISOString().slice(0, 10);
        //var newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        //cellValue = newDate.toISOString().slice(0,10);
        cellValue = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
      } else if (typeof (cellValue) === "boolean") {
        cellValue === true ? cellValue = 1 : cellValue = 0;
      }
      if (searchTerm == "*") {
        return cellValue.toString() != "";
      } else {
        for (var i = 0; i < conditions.length; i++) {
          conditions[i] = conditions[i].toString().trim();
        }
        return conditions.indexOf(cellValue.toString().trim()) > -1;
      }

    } else if (searchTerm == "") {//Si marquem todos los vacíos, retornem aquells que son null.
      return cellValue == null;
    }
    return false;
  };
}

function ixFiltersToArray(filtersArray, $filter, entity, fieldsToSkip) {
  var param = [];
  var paramValue;
  var filter;
  angular.forEach(filtersArray, function (value, key) {
    var i = 0;
    if (angular.isObject(value) && Object.keys(value).length > 0) {
      var notNullValues = Object.keys(value).filter(function (e) { return angular.isDefined(value[e]) && value[e] != null && value[e] != ""; }).map(function (a) { return { value: value[a], first: (a == 0) }; });
      while (i < notNullValues.length) {
        paramValue = notNullValues[i].value;

        if (angular.isUndefined(entity)) {
          filter = { Field: key, Value: paramValue };
        } else {
          filter = { Field: entity + "." + key, Value: paramValue };
        }

        //obrim parentesis
        if (i == 0) {
          filter.StartPar = true;
        } else if (i < (notNullValues.length) && !angular.isDate(paramValue)) {//si hi ha múltiples i no són dates anem possant OR
          filter.Or = true;
        }

        if (angular.isDate(paramValue)) {
          if (i == 0 && notNullValues[i].first) {
            filter.Value = $filter("date")(filter.Value, "yyyy-MM-dd");
            filter.Operator = CMP_GTE;
          } else {
            var now = $filter("date")(filter.Value, "yyyy-MM-dd");
            var partsDate = now.split("-");
            var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
            //li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
            dateMax.setDate(dateMax.getDate() + 1);
            filter.Value = $filter("date")(dateMax, "yyyy-MM-dd");
            filter.Operator = CMP_LT;
          }
        } else {
          filter.Operator = CMP_EQ;
        }

        if (i == (notNullValues.length - 1)) {
          filter.EndPar = true;
        }
        if (angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
        param.push(filter);
        i++;
      }
    } else {
      paramValue = value;

      if (angular.isUndefined(entity)) {
        filter = { Field: key };
      } else {
        filter = { Field: entity + "." + key };
      }
      if (angular.isDate(paramValue)) {
        filter.Value = $filter("date")(paramValue, "yyyy-MM-dd");
      } else {
        filter.Value = paramValue;
      }
      filter.Operator = CMP_EQ;
      if (angular.isDefined(filter.Value) && filter.Value != null && filter.Value !== "") {
        if (angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
        param.push(filter);
      }
    }
  });
  return param;
}

function ixNewDate(cfg, moment, day, month, year, keepUTC) {
  var date = new Date();
  if (angular.isUndefined(day)) {
    year = date.getFullYear();
    month = date.getMonth();
    day = date.getDate();
  } else {
    date.setYear(year);
    date.setMonth(month, day);
  }

  if (angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)) {
    if (month < 9 && (angular.isUndefined(month.length) || month.length < 2)) month = "0" + month;
    if (day < 9 && (angular.isUndefined(day.length) || day.length < 2)) day = "0" + day;
    var d = moment();
    d.year(parseInt(year)).month(parseInt(month)).date(parseInt(day)).hours("00").minutes("00").seconds(0).milliseconds(0);

    var another = d.clone();
    another.tz(cfg.serverTimeZone, true);

    return ixCalculateTzOffset(another.format(), keepUTC);
  } else {
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

function ixCalculateTzOffset(value, keepUTC) {
  var date = new Date(value);
  var minutes;
  if (isNaN(date) || (value == null)) {
    return value;  // needed for null/empty/undefined values
  }
  var timeZoneOffset = date.getTimezoneOffset();

  var timezoneOriginal = value.substring((value.lastIndexOf("+") + 1), value.lastIndexOf(":"));

  if (timeZoneOffset < 0) {
    minutes = (timeZoneOffset * -1);
    if (!keepUTC) {
      minutes = minutes - (60 * parseInt(timezoneOriginal));
    }
    date.setMinutes(minutes);  // forces the "local" version of the date to match the intended +0100 date when necessary
  } else {
    minutes = (timeZoneOffset);
    if (!keepUTC) {
      minutes = minutes + (60 * parseInt(timezoneOriginal));
    }
    date.setMinutes(minutes);  // forces the "local" version of the date to match the intended +0100 date when necessary
  }
  return date;
}

function addDateDeriveds(cfg, $filter, derivers, data) {
  var derivedsObj = {};
  if (angular.isDefined(data) && data.length > 0) {
    var firstRecord = data[0]
    angular.forEach(firstRecord, function (value, key) {
      if (angular.isDate(value)) {
        var transformed = false;
        if (angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)) {
          var hoursToAdd = cfg.timeDiff * -1;
          value.setTime(value.getTime() + (hoursToAdd * 60 * 60 * 1000));
          if (hoursToAdd > 0) transformed = true;
        }
        derivedsObj[key] = function (record) {
          return $filter("date")(record[key], cfg.dateFormat);
        }
      }
    });
  }
  return derivedsObj;
}


/*!
 * SmartMenus more option - November 9, 2016
 * http://www.smartmenus.org/
 */
var ixMenuMore;
var handleResize;
var ixMenuMoreFunction = function ($) {

  if (angular.isUndefined($.SmartMenus.prototype.old_init))
    $.SmartMenus.prototype.old_init = $.SmartMenus.prototype.init;

  $.SmartMenus.prototype.init = function (refresh) {
    var injector = angular.element(angular.element(document).injector().get('$document')[0].body).injector();
    var $translate = injector.get('$translate');
    
    if (!refresh && !this.$root.hasClass('sm-vertical') && (this.$root.prop('id') == 'main-menu') && !this.$root.hasClass('sm-collapsible')) {
      var $originalItems = this.$root.children('li'),
        $moreSub = this.$root.clone(true, true).removeAttr('id').removeAttr('class').addClass('dropdown-menu'),
        $moreSubItems = $moreSub.children('li'),
        $moreItem = angular.element('<li><a>+ '+$translate.instant("Más")+' <span class="caret"></span></a></li>').append($moreSub).appendTo(this.$root),
        self = this,
        vieportW,
        hiddenItems = [],
        hiddenMoreItems = [];
    }

    if (!this.$root.hasClass('sm-collapsible')) {
      this.old_init(refresh);
    }

    if (!refresh && !this.$root.hasClass('sm-vertical') && (this.$root.prop('id') == 'main-menu') && !this.$root.hasClass('sm-collapsible')) {
      handleResize = function (force) {
        var curWidth = angular.element(window).width() - 600;
        //var curWidth = $(window).width();
        if (vieportW !== curWidth || force) {
          if (!self.$root.hasClass('sm-collapsible')) {
            angular.element("#main-menu").css('width', curWidth);
          }
          else {
            angular.element("#main-menu").css('width', "auto");
          }


          // hide More item
          $moreItem.detach();

          // show all main menu items
          $.each(hiddenItems, function () {
            angular.element(this).appendTo(self.$root);
          });
          hiddenItems = [];

          // show all More sub items
          $.each(hiddenMoreItems, function () {
            angular.element(this).prependTo($moreSub);
          });
          hiddenMoreItems = [];

          // if in desktop view and the last item is wrapped
          if (!self.$root.hasClass('sm-vertical') && !self.$root.hasClass('sm-collapsible') && (self.$root.prop('id') == 'main-menu') && (/^(left|right)$/.test(self.$firstLink.parent().css('float')) || self.$firstLink.parent().css('display') == 'table-cell') && $originalItems.eq(-1)[0].offsetTop != $originalItems.eq(0)[0].offsetTop) {
            // show More item
            $moreItem.appendTo(self.$root);

            // while the More item is wrapped
            while ($moreItem[0].offsetTop != $originalItems.eq(0)[0].offsetTop) {
              hiddenItems.unshift($moreItem.prev('li').detach());
            }

            // hide proper More sub items
            $moreSubItems.slice(0, $moreSubItems.length - hiddenItems.length).each(function () {
              hiddenMoreItems.unshift(angular.element(this).detach());
            });
          }

          // save new viewport width
          vieportW = curWidth;
        }
      }
      handleResize();

      angular.element(window).bind({
        'load.smartmenus': function () {
          handleResize(true);
        },
        'resize.smartmenus': handleResize
      });
    }
  };

  ixMenuMore = $.SmartMenus.prototype.init;

  // Fix isCollapsible method
  $.SmartMenus.prototype.isCollapsible = function () {
    return this.$root.find('ul').eq(0).css('position') == 'static';
  };

};

angular.module("gp4App").run(["$templateCache", function($templateCache) {$templateCache.put("app/base/views/changePassword.html","<div class=\"div-login\">\r\n<form class=\"form-login\" role=\"form\">\r\n    <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{\"Cambiar password\" }}</translate></h3>\r\n    <div class=\"form-group\">\r\n        <input type=\"password\" translate translate-attr-placeholder=\"Password actual\" ng-model=\"data.oldpassword\" required autofocus>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <input type=\"password\" translate translate-attr-placeholder=\"Nuevo password\" ng-model=\"data.newpassword\" required>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <input type=\"password\" translate translate-attr-placeholder=\"Repetir nuevo password\" ng-model=\"data.repetir\" required>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <button class=\"btn btn-lg btn-gp-red btn-block\" ng-click=\"send()\"><translate>{{\"Aplicar\" }}</translate></button>\r\n    </div>\r\n    <div ng-show=\"message\" class=\"alert\" ng-class=\"{\'alert-danger\':message.ErrType==2,\'alert-warning\':message.ErrType==1,\'alert-info\':message.ErrType==0}\">\r\n        {{message.Msg}}\r\n    </div>\r\n</form>\r\n</div>\r\n");
$templateCache.put("app/base/views/desktop.html","<div id=\"div-desktop\">\r\n	<header class=\"header-toolbar\">\r\n		<div class=\"toolbar-buttons\">\r\n			<span class=\"toolbar-title\">\r\n				<translate>{{\"Desktop\" }}</translate>\r\n			</span>\r\n			<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"appFilter.fav = (appFilter.fav?undefined:true)\">\r\n				<i class=\"material-icons\" data-ng-show=\"!appFilter.fav\">star</i>\r\n				<i class=\"material-icons yellow\" data-ng-show=\"appFilter.fav\">star</i>\r\n			</a>\r\n			<div class=\"container-search input-group pull-right\">\r\n				<input id=\"search\" type=\"text\" translate translate-attr-placeholder=\"{{\'Buscar aplicación...\' }}\" data-ng-model=\"appFilter.$\" ix-clear-input>\r\n				<span class=\"input-group-addon icon\"><i class=\"fa fa-search\"></i></span>\r\n			</div>\r\n\r\n		</div>\r\n	</header>\r\n	<div class=\"row\">\r\n		<div class=\"col-lg-2 col-md-3 col-sm-6 repeated-item\" data-ng-repeat=\"app in status.availApps | filter:filterFunction\">\r\n\r\n			<div ng-class=\"{\'open\': app.open}\" class=\"appbox\" data-ng-click=\"status.openApp(app)\">\r\n				<div class=\"appbox-image\"></div>\r\n				<div class=\"appbox-content\">\r\n					<div class=\"name\">\r\n						<span class=\"appbox-content-title\">\r\n							<translate>{{app.display }}</translate> <small>{{app.groupname}}</small>\r\n							<small ng-if=\"app.multiple\" ng-show=\"!key.startsWith(\'_\')\" ng-repeat=\"(key,value) in app.atributos\">{{ value }}</small>\r\n						</span>\r\n						<span class=\"appbox-content-text\" ng-if=\"!app.multiple && app.editing\">\r\n							<span ng-if=\"app.data.datos\" style=\"display:block; clear:both\">\r\n								<translate translate-value-idregistro=\"{{app.data.datos[app.data.showAsID] || app.data.datos[app.data.pk]}}\">\r\n									{{ \'Modificando registro con id \\{\\{ idregistro \\}\\}\'  }}</translate>\r\n							</span>\r\n							<span ng-if=\"!app.data.datos && app.data.grid\">\r\n								<translate translate-value-numregistros=\"{{app.data.grid.numberOfChanges()}}\">\r\n									{{ \'Registros por confirmar: \\{\\{numregistros\\}\\}\' }}</translate>\r\n							</span>\r\n						</span>\r\n					</div>\r\n					<uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>\r\n				</div>\r\n				<div class=\"appbox-icons\">\r\n					<div ng-show=\"app.open\" class=\"icon\" data-ng-click=\"status.closeApp(app);$event.stopPropagation()\" style=\"float: right\">\r\n						<i class=\"material-icons\">close</i>\r\n					</div>\r\n					<div class=\"icon\">\r\n						<!--<i data-ng-class=\"app.icon\" class=\"fa fa-fw\"></i>-->\r\n						<i class=\"material-icons\">{{app.icon}}</i>\r\n					</div>\r\n					<div class=\"star\" data-ng-click=\"setFav(app);$event.stopPropagation()\">\r\n						<!--<i class=\"fa fa-star-o grey\" data-ng-show=\"!app.fav\"></i> <i class=\"fa fa-star yellow\" data-ng-show=\"app.fav\"></i>-->\r\n						<i class=\"material-icons\" data-ng-show=\"!app.fav\">star</i> <i class=\"material-icons yellow\" data-ng-show=\"app.fav\">star</i>\r\n					</div>\r\n					<div class=\"star\" ng-show=\"app.editing\">\r\n						<i class=\"material-icons\" aria-hidden=\"true\">lock</i>\r\n					</div>\r\n				</div>\r\n				<!-- div class=\"boxbotleft\">{{app.id}}</div -->\r\n				<div class=\"count\" data-ng-class=\"app.countclass\">{{app.count}}</div>\r\n				<div class=\"count_label\" data-ng-class=\"app.countclass\">{{app.label}}</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n	<div ng-show=\"mostrarAlarmas\">\r\n		<header class=\"header-toolbar\">\r\n			<div class=\"toolbar-buttons\">\r\n				<span class=\"toolbar-title\">\r\n					<translate>{{\"Alarmas caducidad\" }}</translate>\r\n				</span>\r\n			</div>\r\n		</header>\r\n		<div class=\"row\">\r\n			<div class=\"col-lg-3 col-md-4 col-sm-6 repeated-item\">\r\n\r\n				<div ng-class=\"{\'open\': app.open}\" class=\"appbox\">\r\n					<hr>\r\n					<div class=\"appbox-content-alarma\">\r\n\r\n						<div class=\"name\">\r\n							<span class=\"appbox-content-title\">\r\n\r\n								<button style=\"display:block !important\" class=\"btn\" ng-class=\"{ \'con-alarma\': alarma.cantidad > 0 }\" ng-click=\"openAlarma(alarma.app)\" ng-repeat=\"alarma in titulosAlarmas\" ng-if=\"alarma.mostrar\">{{ alarma.titulo }}\r\n									{{ alarma.cantidad }}</button>\r\n							</span>\r\n						</div>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n\r\n\r\n\r\n<style>\r\n	.nvd3 .nv-groups .nv-point {\r\n		stroke-opacity: 0.5 !important;\r\n		stroke-width: 10px;\r\n	}\r\n</style>\r\n\r\n<div class=\"div-desktop-dash\" my-transition-end=\"init()\" ng-if=\"dashboards.length>0\">\r\n	<div class=\"row\">\r\n		<uib-accordion close-others=\"oneAtATime\">\r\n			<div uib-accordion-group class=\"panel-default ixFilter div-desktop-dash\" heading=\"{{dashboard.clave}}\" is-open=\"dashboard.isOpen\" ng-repeat=\"dashboard in dashboards\">\r\n				<div class=\"row dashboard\">\r\n					<!-- Dashboard widgets -->\r\n					<div gridster=\"gridsterOptions\">\r\n						<ul class=\"with-3d-shadow with-transitions\">\r\n							<li gridster-item=\"widget\" ng-repeat=\"widget in dashboard.widgets\">\r\n								<div class=\"box\">\r\n									<div class=\"box-header\">\r\n										<a class=\"widget-information\" title=\"{{ widget.explicativo }}\"><i class=\"glyphicon glyphicon-info-sign\"></i></a>\r\n										<span class=\"h3\">{{ widget.titulo }}</span> <span class=\"h4\"> -\r\n											{{ widget.subtitulo }}</span>\r\n										<div ng-if=\"status.editing\" class=\"box-header-btns pull-right\">\r\n											<a title=\"Ajustes\" ng-click=\"openSettings(widget)\"><i class=\"glyphicon glyphicon-cog\"></i></a>\r\n											<a title=\"Eliminar\" ng-click=\"remove(widget)\"><i class=\"glyphicon glyphicon-trash\"></i></a>\r\n										</div>\r\n									</div>\r\n									<div class=\"box-content\">\r\n										<!-- Grafic -->\r\n										<nvd3 class=\"small-text\" ng-if=\"widget.tipo != \'grid\'\" options=\"widget.chart.options\" data=\"widget.chart.data\" api=\"widget.chart.api\" config=\"config\" events=\"events\"></nvd3>\r\n										<!-- O grid -->\r\n										<div ng-if=\"widget.tipo == \'grid\' && widget.grid\" style=\"height:inherit\" data-ui-grid=\"widget.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\r\n									</div>\r\n								</div>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n\r\n				</div>\r\n			</div>\r\n		</uib-accordion>\r\n	</div>\r\n</div>");
$templateCache.put("app/base/views/desktop_new.html","<div id=\"div-desktop\">\r\n<header class=\"header-toolbar\">\r\n	<div class=\"toolbar-buttons\">\r\n		<span class=\"toolbar-title\">Desktop</span>\r\n		<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"appFilter.fav = (appFilter.fav?undefined:true)\">\r\n			<i class=\"fa fa-star-o\" data-ng-show=\"!appFilter.fav\"></i>\r\n			<i class=\"fa fa-star yellow\" data-ng-show=\"appFilter.fav\"></i>\r\n		</a>\r\n		<!--<div class=\"input-group pull-right\" style=\"width: 300px;\">\r\n			<input id=\"search\" class=\"form-control\" type=\"text\" placeholder=\"Buscar aplicación...\" data-ng-model=\"appFilter.$\"/>\r\n			<span class=\"input-group-addon\"><i class=\"fa fa-search fa-lg\"></i></span>\r\n		</div>	-->\r\n		<div class=\"container-search input-group pull-right\">\r\n      <input id=\"search\" type=\"text\" placeholder=\"Buscar aplicación...\" data-ng-model=\"appFilter.$\">\r\n			<span class=\"input-group-addon icon\"><i class=\"fa fa-search\"></i></span>\r\n  	</div>\r\n\r\n	<!--<a class=\"btn btn-primary pull-right\" role=\"button\"><i class=\"fa fa-plus\"></i> Abrir aplicación</a>-->\r\n\r\n	</div>\r\n</header>\r\n<div class=\"row\" style=\"padding-bottom:20px\">\r\n	<div class=\"col-lg-2 col-md-3 col-sm-6 repeated-item\" data-ng-repeat=\"app in status.availApps | filter:filterFunction\">\r\n\r\n		<div ng-class=\"{\'open\': app.open}\" class=\"appbox\" data-ng-click=\"status.openApp(app)\">\r\n			<div ng-show=\"app.open\" class=\"close\" data-ng-click=\"status.closeApp(app);$event.stopPropagation()\">\r\n				<i class=\"fa fa-times black\"></i>\r\n			</div>\r\n			<div class=\"icon\">\r\n				<i data-ng-class=\"app.icon\" class=\"fa fa-fw\"></i>\r\n			</div>\r\n      <div class=\"star\" data-ng-click=\"setFav(app);$event.stopPropagation()\">\r\n        <i class=\"fa fa-star-o grey\" data-ng-show=\"!app.fav\"></i> <i class=\"fa fa-star yellow\" data-ng-show=\"app.fav\"></i>\r\n      </div>\r\n      <div class=\"star\" ng-show=\"app.editing\">\r\n        <i class=\"fa fa-lock\" aria-hidden=\"true\"></i>\r\n      </div>\r\n      <uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>\r\n			<div class=\"name\">\r\n        <span>\r\n				  {{app.display}} <small>{{app.groupname}}</small>\r\n        </span>\r\n        <span ng-if=\"app.editing\">\r\n          <span ng-if=\"app.data.datos\" style=\"display:block; clear:both\">\r\n            modificando registro con id {{ app.data.datos[app.data.pk] }}\r\n          </span>\r\n          <span ng-if=\"!app.data.datos && app.data.grid\">\r\n            registros por confirmar: {{app.data.grid.numberOfChanges()}}\r\n          </span>\r\n        </span>\r\n\r\n			</div>\r\n			<!-- div class=\"boxbotleft\">{{app.id}}</div -->\r\n			<div class=\"count\" data-ng-class=\"app.countclass\">{{app.count}}</div>\r\n			<div class=\"count_label\" data-ng-class=\"app.countclass\">{{app.label}}</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n</div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/base/views/filters.html","<style>\r\n    .ix-panel-nopaddingh > div > .panel-body {\r\n        padding: 15px 0; /* elimina el padding horizntal */\r\n    }\r\n</style>\r\n<div>\r\n<!--<uib-accordion close-others=\"true\">-->\r\n  <div>\r\n    <!--<div uib-accordion-group ng-repeat=\"f in filters track by $index\" is-open=\"f.isOpen\" class=\"panel-default ix-panel-nopaddingh\">-->\r\n    <div ng-repeat=\"f in filters track by $index\" is-open=\"f.isOpen\" class=\"panel-default ix-panel-nopaddingh\">\r\n        <!--<uib-accordion-heading>-->\r\n        <div class=\"header-toolbar\">\r\n          <div class=\"btn-toolbar toolbar-buttons\">\r\n            <button class=\"btn btn-primary\" ng-click=\"addNewItem(f)\" ng-show=\"addNewItem && f.view==\'list\'\" ng-disabled=\"status.editing || data.ixReadOnly == true\" uib-tooltip=\"Nuevo registro\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\r\n            <button class=\"btn btn-default\" ng-show=\"ixDownloadExcelListado && f.view==\'grid\'\" ng-click=\"ixDownloadExcelListado()\" uib-tooltip=\"Descargar excel\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n            <div class=\"pull-right btn-group\">\r\n                <label class=\"btn btn-default\" ng-model=\"f.view\" uib-btn-radio=\"\'list\'\"><i class=\"fa fa-th-list\"></i></label>\r\n                <label class=\"btn btn-default\" ng-model=\"f.view\" uib-btn-radio=\"\'grid\'\" ng-click=\"showGrid(data.grid)\"><i class=\"fa fa-table\"></i></label>\r\n								<label class=\"btn btn-default\" ng-click=\"fullScreen(true)\"><i class=\"fa fa-eye-slash\"></i></label>\r\n            </div>\r\n          </div>\r\n            <!--<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': f.isOpen, \'glyphicon-chevron-right\': !f.isOpen}\"></i>-->\r\n        <!--</uib-accordion-heading>-->\r\n        </div>\r\n        <div style=\"min-height: 50px; background-color: #eee\">\r\n            <div class=\"btn-toolbar\" ng-show=\"f.view==\'list\'\">\r\n              <!--<button class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i></button>-->\r\n\r\n              <!--<input class=\"btn btn-default form-control\" type=\"text\" name=\"buscar\" placeholder=\"Buscar\" />-->\r\n              <div style=\"width: 100%\" ng-if=\"loadExtraFilters\" data-ng-include=\"module + entity+\'/\'+entity+\'Filters.html?\'+v\"></div>\r\n              <div class=\"input-group\" style=\"width: 100%;background-color: #fafafa;border-bottom: 1px solid #e1e1e1\">\r\n								<span class=\"input-group-addon\" style=\"border: 0px;background-color: #fafafa\"><i class=\"fa fa-search fa-lg\"></i></span> <input id=\"search\" type=\"text\" translate translate-value-entidad=\"{{::f.name}}\" translate-attr-placeholder=\"{{ \'Buscar \\{\\{entidad\\}\\}...\' }}\" ng-disabled=\"status.editing && !changeWhileEditing\" ng-change=\"actualizarListado()\" ng-model=\"data.busqueda\" style=\"border: 0px; background-color: #fafafa;line-height: 2.2em; font-size: 16px; width: 90%\" ix-clear-input autocomplete=\"off\">\r\n              </div>\r\n              <!--<button class=\"btn btn-default pull-right\" ng-model=\"f.orderByVisible\" uib-btn-checkbox><i class=\"fa fa-sort-alpha-asc\"></i> <span class=\"badge\" style=\"margin: 0 0 0 5px\">{{f.search.OrderBy.length}}</span></button>\r\n              <button class=\"btn btn-default pull-right\" ng-model=\"f.filterVisible\" uib-btn-checkbox><i class=\"fa fa-filter\"></i> <span class=\"badge\" style=\"margin: 0 0 0 5px\">{{f.search.Filters.length}}</span></button>-->\r\n            </div>\r\n						<div ng-scrollbars class=\"scrolldiv\">\r\n							<div ng-show=\"f.view==\'list\'\">\r\n								<div>\r\n									<!--<form name=\"searchform\" class=\"form-horizontal\" novalidate style=\"padding: 10px 15px 5px\" ng-show=\"f.filterVisible\">\r\n											<div class=\"form-group\" ng-repeat=\"field in f.search.Filters\">\r\n													<label class=\"col-md-5\">\r\n															<button type=\"button\" class=\"close\" ng-click=\"removeFilter(f,$index)\">&times;</button>\r\n															{{field.Field}}\r\n													</label>\r\n													<div class=\"col-md-7\">\r\n															<div class=\"input-group\">\r\n																	<div class=\"input-group-btn\">\r\n																			<div uib-dropdown class=\"btn btn-default\">\r\n																					<div uib-dropdown-toggle><i ng-class=\"k.CMP[field.Operator].icon\"></i></div>\r\n																					<ul uib-dropdown-menu>\r\n																							<li ng-repeat=\"op in k.CMP\" ng-click=\"field.Operator=op.operator; applyFilter(f)\">&nbsp;&nbsp;<i ng-class=\"op.icon\"></i> &nbsp;&nbsp;{{op.name}}</li>\r\n																					</ul>\r\n																			</div>\r\n																	</div>\r\n																	<input type=\"text\" class=\"form-control\" ng-model=\"field.Value\" ng-change=\"applyFilter(f)\" ng-model-options=\"{updateOn:\'blur\'}\" />\r\n															</div>\r\n													</div>\r\n											</div>\r\n											<div class=\"form-group\">\r\n													<div class=\"col-md-5\">\r\n															<input type=\"text\" class=\"form-control\" placeholder=\"nuevo filtro\" ng-model=\"newFilter\" uib-typeahead=\"field.Name as field.Name for field in metadata | filter:$viewValue\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelectNewFilter($item);newFilter=null\" typeahead-focus-on-select=\"false\" typeahead-append-to-body=\"true\">\r\n													</div>\r\n											</div>\r\n									</form>\r\n									<div style=\"padding: 10px 15px 5px\" ng-show=\"f.orderByVisible\">\r\n											<div class=\"form-group\">\r\n													<div class=\"input-group\">\r\n															<span class=\"input-group-addon\">\r\n																	<i class=\"fa fa-sort-alpha-asc\"></i>\r\n															</span>\r\n															<ui-select multiple ng-model=\"f.search.OrderBy\" append-to-body=\"true\">\r\n																	<ui-select-match placeholder=\"seleccione los campos para ordenar\">\r\n																			{{$item.Name}}\r\n																	</ui-select-match>\r\n																	<ui-select-choices repeat=\"field.Name as field in (metadata | filter: $select.search) track by $index\">\r\n																			<span ng-bind=\"field.Name\"></span>\r\n																	</ui-select-choices>\r\n															</ui-select>\r\n													</div>\r\n											</div>\r\n									</div>-->\r\n									<div ng-if=\"data.loaded\">\r\n											<!--<uib-pagination ng-show=\"f.data.TotalPages>1\" items-per-page=\"f.data.ItemsPerPage\" total-items=\"f.data.TotalItems\" ng-model=\"f.data.CurrentPage\" max-size=\"5\" class=\"pagination-md\" next-text=\">\" previous-text=\"<\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"applyFilter(f)\" style=\"padding: 0 20px;\"></uib-pagination>-->\r\n										<div class=\"listEditResult\" ng-repeat=\"item in data.list\" ng-style=\"{\'background-color\':item.color}\" ng-click=\"selectItem(item, $event)\" ng-show=\"!item.ToDelete\" ng-include=\"module + entity+\'/\'+entity+\'Card.html\'\" ng-class=\"{\'bg-info\':(angular.equals(item,current) || (data.datos[data.pk] && (data.datos[data.pk] == item[data.pk] || data.datos[data.pk] == item[data.listpk]))) && entity != \'FormularioFtBP\', \'recordDisabled\': (item.activo == 0 || item.estado == 0) }\"></div>\r\n									</div>\r\n								</div>\r\n							</div>\r\n              <div ng-show=\"f.view==\'grid\'\" style=\"height: calc(100vh - 190px)\">\r\n                <span ng-if=\"!data.grid\"><translate>Esta acción puede tardar unos segundos.</translate><button class=\"btn btn-primary\" ng-click=\"cargarGrid()\"><translate>Cargar datos</translate></button></span>\r\n                <span ng-if=\"data.grid\">\r\n                  <div class=\"fwGrid\" ui-grid=\"data.grid\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n                    <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">\r\n                      <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                  <div>\r\n                    <div class=\"footer\">\r\n                      <div ix-datetime-grid-generada grid=\"data.grid\"></div>\r\n                    </div>\r\n                  </div>\r\n                </span>\r\n              </div>\r\n					</div>\r\n        </div>\r\n    </div>\r\n<!--</uib-accordion>-->\r\n  </div>\r\n</div>\r\n\r\n\r\n<script type=\"text/ng-template\" id=\"setOrderBy.html\">\r\n	<h1>\r\n		Ordenar resultados\r\n	</h1>\r\n	<div>\r\n		<div ng-repeat=\"f in orderBy\">\r\n            <span ng-if=\"\">{{f}}</span>\r\n        </div>\r\n		<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button>\r\n		<button type=\"button\" class=\"btn btn-danger\" ng-click=\"$uibModalInstance.dismiss(\'cancel\')\">Cancelar</button>\r\n	</div>\r\n	<div data-ng-show=\"{{user.role!=\'administrador\'}}\" data-ng-bind-html=\"currentApp.help\"></div>\r\n</script>\r\n");
$templateCache.put("app/base/views/gridEditor.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div ng-show=\"!showPivot\" style=\"width:100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">          \r\n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>					\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div ng-show=\"showPivot && generatePivot\">\r\n      <div ng-include src=\"\'app/base/views/pivot.html\'\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.grid\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/gridFooterCustomTemplate.html","<div class=\"ui-grid-footer-info ui-grid-grid-footer\">\r\n  <span>{{\'search.totalItems\' | t}} {{grid.rows.length}}</span>\r\n  <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span>\r\n  <span ng-if=\"grid.api.ix.generadaEl\" class=\"pull-right\">Información generada el {{grid.api.ix.generadaEl}}</span>\r\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n          <fieldset class=\"form-data-filter\" ng-disabled=\"status.editing\">\r\n              <!--<div ng-repeat=\"(key, value) in filtro.data\" class=\"col-md-4\">\r\n                <!-- TODO: Fer-ho més dinàmic, possar tots els atributs necessaris en un objecte, llavors podriem reutilitzar la mateixa view sense importar els filtres que aquesta tingui. -->\r\n                <!--<ix-select ng-model=\"filtro.data[key]\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\'Client\' ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>-->\r\n                <!--<ix-select ng-model=\"filtro.data.client_id\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\'Client\' ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>\r\n              </div>-->\r\n            <!-- EXEMPLE de directiva ixSearchFromGrid -->\r\n            <!--<div class=\"col-md-4\">\r\n              <ix-search-from-grid ng-model=\"data.filtro.operativa\" entity=\"operaciones\" pk=\"operacion\" ng-disabled=\"status.editing\" ng-required=\"true\" name=\"Operativa\" show-only-described-cols=\"[\'operacion\', \'medio\', \'fecha\' ]\"></ix-search-from-grid>\r\n            </div>-->\r\n            <div class=\"col-md-4\" ng-if=\"showClient\">\r\n                <ix-select ng-model=\"data.filtro.client_id\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\"Client\" ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>\r\n            </div>\r\n          </fieldset>\r\n      <!--<fieldset class=\"form-data\" ng-disabled=\"!status.editing\">\r\n      <div class=\"col-md-12\">-->\r\n          <div style=\"width:100%\">\r\n            <div ng-show=\"!showPivot\" class=\"ui-grid-with-filters\" data-ui-grid=\"data.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\r\n              <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">\r\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-if=\"generatePivot\" ng-show=\"showPivot\">\r\n          <div ng-include src=\"\'Framework/views/pivot.html\'\"></div>\r\n          </div>\r\n      <!--</div>\r\n      </fieldset>-->\r\n    </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios_etiquetas.html","<div ng-controller=\"GridUsuariosEtiquetasController\">\r\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\n    <div class=\"pull-right\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <ix-tool-bar></ix-tool-bar>\r\n  </div>-->\n  <ix-popup-tool-bar title-left=\"Etiquetas\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\n          <div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios_grupos.html","<div ng-controller=\"GridUsuariosGruposController\">\r\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\n    <div class=\"pull-right\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <ix-tool-bar></ix-tool-bar>\r\n  </div>-->\n  <ix-popup-tool-bar title-left=\"Grupos\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\n          <div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios_megawhere.html","<div ng-controller=\"GridUsuariosMegawhereController\">\r\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\r\n    <div class=\"pull-right\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <ix-tool-bar></ix-tool-bar>\r\n  </div>-->\r\n  <ix-popup-tool-bar title-left=\"Condiciones\"></ix-popup-tool-bar>\r\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridmegawhere\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\r\n          <div class=\"grid-loading\" ng-if=\"gridmegawhere.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/listEdit.html","<div my-transition-end=\"init()\" style=\"position:relative; height: calc(100vh - 82px)\">\r\n  <ix-splash></ix-splash>\r\n  <div ui-layout=\"{ flow : \'column\', disableToggle: true, dividerSize: 0 }\" ng-class=\"{ \'centerToFullScreen\': data.fullScreen }\">\r\n      <div class=\"ix-layout-left\" ui-layout-container size=\"18%\" style=\"background-color:#ffffff\">\r\n          <div ng-if=\"status.transitionend\" data-ng-include=\"includeFiltersTemplate\" style=\"overflow-x:hidden\"></div>\r\n      </div>\r\n      <div class=\"ix-layout-central\" ui-layout-container=\"central\">\r\n          <div ng-if=\"status.transitionend\" data-ng-include=\"module + entity+\'/\'+entity+\'Form.html\'\"></div>\r\n      </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/listados_programados_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Programar Listado\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <h3 style=\"margin-left:90px\">Listado</h3>\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"data.nombre\" name=\"Listado\" ng-required=\"true\" max-length=\"getMaxLength(\'nombre\')\"></ix-text>\r\n              <ix-text-area ng-model=\"data.descripcion\" name=\"Descripción\" max-length=\"getMaxLength(\'descripcion\')\"></ix-text-area>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-radio ng-model=\"data.intervaloseleccionado\" options=\'[{value: 0, text: \"Único\"},{value: 1, text: \"Minutos\"},{value: 2, text: \"Horas\"},{value: 3, text: \"Días\"},{value: 4, text: \"Meses\"},]\' name=\"intervalo\" label=\"Intervalo\"></ix-radio>\r\n              <ix-text ng-if=\"data.intervaloseleccionado == \'1\'\" ng-model=\"data.intervalo\" name=\"Minutos\" ix-number min-value=\"1\" max-value=\"59\"></ix-text>\r\n              <ix-text ng-if=\"data.intervaloseleccionado == \'2\'\" ng-model=\"data.intervalo_horas\" name=\"Horas\" ix-number min-value=\"1\" max-value=\"24\"></ix-text>\r\n              <ix-text ng-if=\"data.intervaloseleccionado == \'3\'\" ng-model=\"data.intervalo_dias\" name=\"Días\" ix-number min-value=\"1\" max-value=\"31\"></ix-text>\r\n              <ix-text ng-if=\"data.intervaloseleccionado == \'4\'\" ng-model=\"data.intervalo_meses\" name=\"Meses\" ix-number min-value=\"1\" max-value=\"12\"></ix-text>\r\n            </div>\r\n\r\n            <div class=\"col-md-6\">\r\n              <ix-options-si-no ng-model=\"data.activo\" name=\"Activo\"></ix-options-si-no>\r\n              <ix-date ng-model=\"data.fecha_ini\" name=\"Fecha Inicial\" ng-required=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.fecha_fin\" name=\"Fecha Final\"></ix-date>\r\n              <ix-time ng-model=\"data.hora_ini\" name=\"Hora Inicial\" ng-required=\"true\"></ix-time>\r\n              <!--<ix-time ng-model=\"data.hora_fin\" name=\"Hora Final\" ng-required=\"data.intervaloseleccionado == 2 && data.intervalo_horas != \'0\'\"></ix-time>-->\r\n              <ix-time ng-model=\"data.hora_fin\" name=\"Hora Final\" ng-required=\"data.intervaloseleccionado == 1 || data.intervaloseleccionado == 2\"></ix-time>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <!-- De moment només es poden treure excels. -->\r\n              <!--<ix-radio ng-model=\"data.extension\" options=\'[{value: \"XLS\", text: \"XLS\"},{value: \"TXT\", text: \"TXT\"},{value: \"CSV\", text: \"CSV\"},{value: \"PDF\", text: \"PDF\"}]\' name=\"extension\" label=\"Extensión\"></ix-radio>\r\n              <ix-options-si-no ng-if=\"data.extension==\'CSV\'\" ng-model=\"data.con_cabeceras\" name=\"Con cabeceras de columna\"></ix-options-si-no>-->\r\n              <ix-options-si-no ng-model=\"data.test\" name=\"Forzar un envío único (se realizará en los siguientes 5 minutos)\" text-max-width=\"true\"></ix-options-si-no>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n              <ix-options-si-no ng-model=\"data.enviar_sin_resultados\" name=\"Enviar si no se generan resultados\" text-max-width=\"true\"></ix-options-si-no>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\" ng-if=\"data.intervaloseleccionado == \'3\' && data.intervalo_dias == 1 && datosOriginales.client_id\">\r\n            <h3 style=\"margin-left:90px\">Días de envío</h3>\r\n            <div class=\"col-md-2\">\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n              <ix-options-si-no ng-model=\"data.lunes\" name=\"Lunes\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"data.martes\" name=\"Martes\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"data.miercoles\" name=\"Miércoles\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"data.jueves\" name=\"Jueves\"></ix-options-si-no>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n              <ix-options-si-no ng-model=\"data.viernes\" name=\"Viernes\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"data.sabado\" name=\"Sábado\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"data.domingo\" name=\"Domingo\"></ix-options-si-no>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <h3 style=\"margin-left:90px\">Envío</h3>\r\n            <div class=\"col-md-6\">\r\n              <ix-text-area ng-model=\"data.mailto\" name=\"Direcciones de correo\"></ix-text-area>\r\n              <p style=\"padding-left:120px\">Puede separar direcciones de correo con ;</p>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n              <ix-text-area ng-model=\"data.mailcc\" name=\"Direcciones de correo ocultas\"></ix-text-area>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/login.html","<div class=\"div-login\">\r\n<form class=\"form-login\" role=\"form\">\r\n    <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{ cfg.welcomeMsg || \"Bienvenido a \" }} </translate> <translate>{{ cfg.appName }}</translate></h3>\r\n    <h4 style=\"text-align:center\"><translate>{{\"Inicia la sesión\"}}</translate></h4>\r\n    <div class=\"form-group\">\r\n        <input type=\"text\" placeholder=\"Usuario\" data-ng-model=\"loginData.userName\" required autofocus>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <input type=\"password\" placeholder=\"Contraseña\" data-ng-model=\"loginData.password\" required>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <ui-select ng-model=\"loginData.domain\" search-enabled=\"false\" ng-hide=\"!allDomains.length\">\r\n             <ui-select-match allow-clear=\"true\" placeholder=\"Dominio\">{{$select.selected}}</ui-select-match>\r\n             <ui-select-choices repeat=\"item in (allDomains)\">\r\n                <div>{{item}}</div>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n   	</div>\r\n    <div class=\"form-group\">\r\n        <ui-select class=\"ui-select-login\" ng-model=\"loginData.api\" search-enabled=\"false\" on-select=\"ChangeAPI()\" ng-hide=\"allApis.length<=1\">\r\n             <ui-select-match placeholder=\"API | translate\">{{$select.selected.Descripcion}}</ui-select-match>\r\n             <ui-select-choices repeat=\"item in (allApis)\">\r\n                <div>{{item.Descripcion}}</div>\r\n            </ui-select-choices>\r\n        </ui-select>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <button class=\"btn btn-lg btn-gp-red btn-block\" type=\"submit\" data-ng-click=\"login()\"><translate>ACCEDER</translate></button>\r\n    </div>\r\n    <div data-ng-hide=\"message == \'\'\" class=\"alert alert-danger\">\r\n        {{message.error_description}}\r\n    </div>\r\n</form>\r\n</div>\r\n");
$templateCache.put("app/base/views/pivot.html","<div>\r\n	<div>\r\n		<div id=\"pivotTableOutput\" style=\"margin:30px\"></div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/sidebar_apps.html","<div id=\"div-sidebar-apps\" class=\"scrolldiv\" ng-scrollbars>			\r\n	<ul class=\"list-group\">\r\n		<li data-ng-repeat=\"app in status.availApps | filter:filterFunction\" ng-class=\"{\'current\': isCurrent(app)}\">\r\n			<div ng-class=\"{\'open\': app.open}\" data-ng-click=\"status.openApp(app);closeSideBarApps()\">		\r\n				<div ng-show=\"app.open && !isCurrent(app)\" class=\"icon\" data-ng-click=\"app.onCloseGoTo=status.current.href;status.closeApp(app);$event.stopPropagation()\" style=\"float:right; position: relative; right: -10px\">\r\n					<i class=\"material-icons\">close</i>\r\n				</div>					\r\n				<a>\r\n					<span class=\"pull-left\"><i class=\"material-icons\">{{app.icon}}</i></span> <translate>{{app.display }}</translate> <small>{{app.groupname}}</small>\r\n					<small ng-if=\"app.multiple\" ng-show=\"!key.startsWith(\'_\')\" ng-repeat=\"(key,value) in app.atributos\">{{ value }}</small>\r\n				</a>\r\n				<uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>				\r\n			</div>		\r\n		</li>\r\n	</ul>\r\n</div>\r\n");
$templateCache.put("app/base/views/videoPlayer.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n      <div class=\"videogular-container\">\r\n        <videogular vg-theme=\"config.theme\">\r\n          <vg-media vg-src=\"config.sources\" vg-tracks=\"config.tracks\">\r\n          </vg-media>\r\n\r\n          <vg-controls vg-autohide=\"config.plugins.controls.autoHide\" vg-autohide-time=\"config.plugins.controls.autoHideTime\">\r\n            <vg-play-pause-button></vg-play-pause-button>\r\n            <vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\r\n            <vg-scrub-bar>\r\n              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\r\n            </vg-scrub-bar>\r\n            <vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\r\n            <vg-volume>\r\n              <vg-mute-button></vg-mute-button>\r\n              <vg-volume-bar></vg-volume-bar>\r\n            </vg-volume>\r\n            <vg-fullscreen-button></vg-fullscreen-button>\r\n          </vg-controls>\r\n\r\n          <vg-overlay-play></vg-overlay-play>\r\n          <vg-poster vg-url=\"config.plugins.poster\"></vg-poster>\r\n        </videogular>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/framework_templates/ixErrorsPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Errores\" hide-all=\"true\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <h4></h4>\r\n              <span ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\r\n                <p ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></p>\r\n              </span>\r\n              <span ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\r\n                <p ng-repeat=\"error in status.response.data.obj.Errors | filter:{ErrType: 2}\">{{error.Msg}}</p>\r\n              </span>\r\n              <span ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\r\n              </span>\r\n              <span ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\r\n              </span>\r\n              <span ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\r\n              </span>\r\n              <span ng-repeat=\"itemResp in status.response.data.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/framework_templates/ixGridToolBar.html","<div class=\"btn-toolbar\">\r\n	<div class=\"pull-left\" ng-show=\"status.editing\">\r\n		{{gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n		{{deletedRows.length}} filas eliminadas\r\n		{{insertedRows.length}} filas creadas\r\n		{{gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n	</div>\r\n	<button class=\"btn btn-default pull-right\" onclick=\"maximizeGrid(this, event)\" uib-tooltip=\"maximizar/minimizar\"><i class=\"fa fa-arrows-alt\"></i></button>\r\n	<div uib-dropdown class=\"pull-right\" is-open=\"false\">\r\n		<button uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i> <span class=\"caret\"></span></button>\r\n		<ul uib-dropdown-menu>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"savePreferences()\"><i class=\"fa fa-floppy-o\"></i> Guardar preferencias de visualización</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"restorePreferences()\"><i class=\"fa fa-undo\"></i> Restaurar preferencias de visualización</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-wrench\"></i> Predefinir para todos los usuarios (admin)</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-trash-o\"></i> Eiminar settings de todos los usuarios (admin)</a></li>\r\n		</ul>\r\n	</div>\r\n	<a class=\"btn btn-default pull-right\" ng-class=\"gridOptions.enableFiltering?\'active\':\'\'\" role=\"button\" data-ng-click=\"toggleFiltering()\" uib-tooltip=\"togle filter\"><i class=\"fa fa-filter\"></i></a>\r\n	<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"downloadCSV()\" uib-tooltip=\"Descargar datos de la tabla cómo excel\"><i class=\"fa fa-file-excel-o\"></i></a>\r\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows()\" uib-tooltip=\"Eliminar selección\"><i class=\"fa fa-trash-o\"></i></a>\r\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"Nuevo registro\"><i class=\"fa fa-plus\"></i></a>\r\n\r\n</div>\r\n");
$templateCache.put("app/base/views/framework_templates/ixPopupToolBar.html","<div>\r\n<header class=\"header-toolbar\">\r\n	<div class=\"btn-toolbar\">\r\n		<div style=\"float: left\" ng-if=\"!hideAll\">\r\n    <!-- Per warnings de frontend nostres -->\r\n    <!--<span uib-dropdown is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" class=\"\" ng-if=\"warnings && warnings.length\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell amarillo\"></i><span class=\"badge\">{{warnings.length}}</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-warning\" >\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>Atención ({{warnings.length}})</strong>\r\n						<br>\r\n						<small ng-repeat=\"warning in warnings\">{{warning}}{{$last ? \'\' : \', \'}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n\r\n\r\n		<span uib-dropdown class=\"\" is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" ng-show=\"form.$invalid && (!status.data.pk || status.data.datos[status.data.pk])\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n				<li ng-repeat=\"(k,v) in form.$error\">\r\n					<a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\" >\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}} ({{v.length}})</strong>\r\n						<br>\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n            </small>\r\n            <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>-->\r\n\r\n		<span uib-dropdown auto-close=\"disabled\" ng-if=\"warnings && warnings.length\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell amarillo\"></i><span class=\"badge\">{{warnings.length}}</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-warning\">\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>Atención ({{warnings.length}})</strong>\r\n						<br>\r\n						<small ng-repeat=\"warning in warnings\">{{warning}}{{$last ? \'\' : \', \'}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n    <!-- -->\r\n		<span uib-dropdown auto-close=\"disabled\" ng-show=\"form.$invalid && (!status.data.pk || status.data.datos[status.data.pk])\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n				<li ng-repeat=\"(k,v) in form.$error\">\r\n					<a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\">\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}} ({{v.length}})</strong>\r\n						<br>\r\n            <!--<small ng-repeat=\"vv in v\">{{vv.$name}}{{$last ? \'\' : \', \'}}</small>-->\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n            </small>\r\n            <!-- PERSONALITZATS -->\r\n            <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n\r\n    <!-- Errors de grid abans d\'anar a la API -->\r\n    <span uib-dropdown ng-show=\"gridStatus.$invalid && status.editing\">\r\n      <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(gridStatus)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n        <li ng-repeat=\"(k,v) in gridStatus.$error\">\r\n          <a ng-if=\"v.length > 0\" class=\"alert-callout alert-warning\" ng-click=\"setFocusError(k)\">\r\n            <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\r\n            <small ng-if=\"k == \'required\'\">\r\n              <br>\r\n              <span><translate>Los campos siguientes son obligatorios:</translate></span>\r\n            </small>\r\n            <br>\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name && vv.pk && k != \'required\'\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk && k == \'required\'\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\r\n            </small>\r\n            <small ng-if=\"k == \'required\'\">\r\n              <br>\r\n              <span ng-repeat=\"vv in v | unique:\'pk\'\">\r\n                <span ng-if=\"$first\"><translate>Revise los registros con</translate></span>\r\n                <span ng-repeat=\"(pkKey, pkVal) in vv.pk\">\r\n                  <span ng-if=\"$last && $parent.$first\"> {{pkKey}}: <br></span>\r\n                  <span ng-if=\"$last\">{{pkVal}}{{$parent.$parent.$last ? \'\' : \', \'}}</span>\r\n                </span>\r\n              </span>\r\n            </small>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </span>\r\n\r\n		<span uib-dropdown auto-close=\"disabled\" ng-class=\"{\'open\': status.response.data.GlobalMessage.ErrType == 0}\" ng-show=\"status.response.status==400 || status.response.status==200 || status.response.GlobalMessage.ErrType==2\">\r\n      <a uib-dropdown-toggle><i class=\"fa fa-bell\" ng-class=\"{\'verde\' : status.response.data.GlobalMessage.ErrType == 0, \'amarillo\': status.response.data.GlobalMessage.ErrType == 1, \'rojo\': status.response.data.GlobalMessage.ErrType == 2 || status.response.status==400}\"></i><span class=\"badge\">{{ status.response.data.Errors.length || \'1\' }}</span></a>\r\n			<ul uib-dropdown-menu>\r\n        <li ng-switch on=\"status.response.data.GlobalMessage.ErrType\" ng-show=\"status.response.data.GlobalMessage.ErrType >= 0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2 || status.response.GlobalMessage.ErrType==2}\">\r\n						<i class=\"fa fa-info-circle\" ng-switch-when=\"0\"></i>\r\n						<i class=\"fa fa-exclamation-triangle\" ng-switch-when=\"1\"></i>\r\n						<i class=\"fa fa-exclamation-circle\" ng-switch-when=\"2\"></i>\r\n						<strong ng-switch-when=\"0\"><translate>{{ \"Info\" }}</translate></strong>\r\n						<strong ng-switch-when=\"1\"><translate>{{ \"Warning\" }}</translate></strong>\r\n						<strong ng-switch-when=\"2\"><translate>{{ \"Error\" }}</translate></strong>\r\n						<br>\r\n            <small ng-switch-when=\"0\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con éxito.\") }}</translate></small>\r\n            <small ng-switch-when=\"1\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con avisos.\") }}</translate></small>\r\n            <small ng-switch-when=\"2\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Se ha producido un error al realizar la operación.\") }}</translate></small>\r\n					</a>\r\n				</li>\r\n        <!-- Mostrar errors 400 d\'API -->\r\n        <li ng-show=\"!status.response.data.GlobalMessage && status.response.status==400\">\r\n          <a class=\"alert-callout alert-error\">\r\n						<i class=\"fa fa-exclamation-circle\"></i>\r\n						<strong>{{status.response.statusText}}</strong>\r\n						<br>\r\n						<small>{{status.response.data}}</small>\r\n					</a>\r\n        </li>\r\n        <!-- Aixo mostrarà els errors que vinguin dintre d\'un OperationResult. -->\r\n        <!--<li ng-repeat=\"itemResp in status.response.data\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">-->\r\n				<li ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></small>\r\n					</a>\r\n				</li>\r\n        <!-- -->\r\n\r\n				<li ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':status.response.data.GlobalMessage.ErrType==0,\'fa-exclamation-triangle\':status.response.data.GlobalMessage.ErrType==1,\'fa-exclamation-circle\':status.response.data.GlobalMessage.ErrType==2}\"></i>\r\n						<strong>Error</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in status.response.data.obj.Errors | filter:{ErrType: 2}\">{{error.Msg}}<br></small>\r\n					</a>\r\n				</li>\r\n				<!-- -->\r\n				<li ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error de inserción</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error de modificación</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error al eliminar</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<span ng-repeat=\"error in itemResp.Errors\">\r\n							<strong>Error: {{error.Msg}}</strong>\r\n							<br>\r\n							<small><strong>{{error.Property}}</strong>: {{error.Values[0]}}</small>\r\n						</span>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n		<span uib-dropdown ng-show=\"status.response.status>400\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">1</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-error\">\r\n						<i class=\"fa fa-exclamation-circle\"></i>\r\n						<strong>{{status.response.statusText}}</strong>\r\n						<br>\r\n						<small>{{status.response.data.Message}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n      <a data-ng-show=\"status.data.bloqueo && !status.editing\"><i class=\"fa fa-lock\"></i> <translate translate-value-username=\"{{status.data.bloqueo.user.name}}\" translate-value-tiempo=\"{{status.data.bloqueo.ts | date:\'HH:mm:ss\'}}\">{{ \'Registro bloqueado por <strong>\\{\\{username\\}\\}</strong> a las \\{\\{tiempo\\}\\}h\'  }}</translate> </a>\r\n		</div>\r\n    <span style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\"><translate>{{ titleLeft }}</translate> {{ titleLeftParam }} {{ titleVal }}</span>\r\n    \r\n    <div class=\"toolbar-buttons\">\r\n      <button id=\"cancelFilter\" class=\"btn pull-right\" ng-click=\"$dismiss()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" tooltip-placement=\"bottom\"><translate>{{ closeBtnText || \'CERRAR\' }}</translate></button>\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"gridApi.selection.getSelectedRows().length==0\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"{{ \'Eliminar selección\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"(ixAddRow && status.editing && !hideNuevo)\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\" ng-disabled=\"data.ixReadOnly == true\"></i> <translate>Nuevo</translate></button>\r\n\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" data-ng-show=\"ixEditar && !status.editing\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"ixEditarDisabled || data.grid.ixIsLoading == true || data.ixReadOnly == true || form.$invalid\" uib-tooltip=\"{{ixEditarTooltip | translate }}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-click=\"ixCancelEdit()\" ng-show=\"(ixCancelEdit && ixEditar && status.editing && !hideCancelEdit)\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><translate>CANCELAR</translate></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"exportar\" ng-click=\"exportar()\" uib-tooltip=\"{{ \'Descargar excel\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" data-ng-show=\"status.editing && save\" ng-click=\"save()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ (ixGuardarTooltip || \'Guardar cambios\') | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"gridStatus.$invalid || numberOfChanges()==0 || form.$invalid\"><i class=\"fa fa-floppy-o\"></i> <translate>{{ okBtnText || \'Guardar\' }}</translate> <span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\r\n\r\n      <div ng-transclude>\r\n        <!-- AQUI -->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"pull-right loader\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <div class=\"center\">\r\n      <span style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\" class=\"ng-binding\">{{ titleCenter }} {{ titleCenterParam }}</span>\r\n    </div>\r\n	</div>\r\n</header>\r\n	<uib-progressbar max=\"100\" min=\"0\" value=\"data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !data.ixProgress}\"></uib-progressbar>\r\n</div>\r\n");
$templateCache.put("app/base/views/framework_templates/ixToolBar.html","<div>\r\n  <!-- header style=\"position:fixed\"  desactivado para listEdit, investigar angular-sticky -->\r\n  <header class=\"header-toolbar\">\r\n    <div class=\"btn-toolbar\">\r\n      <div style=\"float: left\" ng-show=\"!hideHeader\">\r\n        <!-- Errors de formulari abans d\'anar a la API -->\r\n        <span uib-dropdown is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" ng-show=\"form.$invalid && numberOfErrors(form) > 0 && (!status.data.pk || status.data.datos[status.data.pk])\">\r\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\r\n          <ul uib-dropdown-menu>\r\n            <li ng-repeat=\"(k,v) in form.$error\">\r\n              <a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\">\r\n                <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\r\n                <small ng-if=\"k == \'required\'\">\r\n                  <br>\r\n                  <span><translate>Los campos siguientes son obligatorios:</translate></span>\r\n                </small>\r\n                <br>\r\n                <!--<small ng-repeat=\"vv in v\">{{vv.$name}}{{$last ? \'\' : \', \'}}</small>-->\r\n                <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n                  <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\r\n                </small>\r\n                <!-- PERSONALITZATS -->\r\n                <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </span>\r\n        <!-- Errors de grid abans d\'anar a la API -->\r\n        <span uib-dropdown ng-show=\"gridStatus.$invalid && status.editing\">\r\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(gridStatus)}}</span></a>\r\n          <ul uib-dropdown-menu>\r\n            <li ng-repeat=\"(k,v) in gridStatus.$error\">\r\n              <a ng-if=\"v.length > 0\" class=\"alert-callout alert-warning\" ng-click=\"setFocusError(k)\">\r\n                <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\r\n                <small ng-if=\"k == \'required\'\">\r\n                  <br>\r\n                  <span><translate>Los campos siguientes son obligatorios:</translate></span>\r\n                </small>\r\n                <br>\r\n                <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n                  <span ng-if=\"vv.$name && vv.pk && k != \'required\'\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.$name && vv.pk && k == \'required\'\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n                  <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\r\n                </small>\r\n                <small ng-if=\"k == \'required\'\">\r\n                  <br>\r\n                  <span ng-repeat=\"vv in v | unique:\'pk\'\">\r\n                    <span ng-if=\"$first\"><translate>Revise los registros con</translate></span>\r\n                    <span ng-repeat=\"(pkKey, pkVal) in vv.pk\">\r\n                      <span ng-if=\"$last && $parent.$first\"> {{pkKey}}: <br></span>\r\n                      <span ng-if=\"$last\">{{pkVal}}{{$parent.$parent.$last ? \'\' : \', \'}}</span>\r\n                    </span>\r\n                  </span>\r\n                </small>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </span>\r\n        <!-- Resposta de la API. Pot ser un OK o un error però només estarà obert si és un OK -->\r\n        <span uib-dropdown is-open=\"openIfError(status)\" auto-close=\"disabled\" ng-class=\"{\'open\': (status.response.data.GlobalMessage.ErrType == 0 || (status.response.data.GlobalMessage.ErrType == 2 && showErrorNotif))}\" ng-show=\"status.response.status==400 || status.response.status==403 || status.response.status==200 || status.response.GlobalMessage.ErrType==2\">\r\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\" ng-class=\"{\'verde\' : status.response.data.GlobalMessage.ErrType == 0, \'amarillo\': status.response.data.GlobalMessage.ErrType == 1, \'rojo\': status.response.data.GlobalMessage.ErrType == 2 || status.response.status==400 || status.response.status==403}\"></i><span class=\"badge\">{{ status.response.data.Errors.length || \'1\' }}</span></a>\r\n          <ul uib-dropdown-menu>\r\n            <span style=\"margin: 1px 0px 0px 6px\" ng-show=\"status.response.data.GlobalMessage.ErrType == 2\">\r\n              <a ng-click=\"openPopup(status.response.data)\" title=\"Ver errores en popup\" style=\"display:inline-block\"><i class=\"fa fa-window-maximize\"></i></a>\r\n              <a ng-click=\"downloadTxt(status.response.data)\" title=\"Generar fichero de errores\" style=\"display:inline-block\"><i class=\"fa fa-download\"></i></a>\r\n            </span>\r\n            <li ng-switch on=\"status.response.data.GlobalMessage.ErrType\" ng-show=\"status.response.data.GlobalMessage.ErrType >= 0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2 || status.response.GlobalMessage.ErrType==2}\">\r\n                <i class=\"fa fa-info-circle\" ng-switch-when=\"0\"></i>\r\n                <i class=\"fa fa-exclamation-triangle\" ng-switch-when=\"1\"></i>\r\n                <i class=\"fa fa-exclamation-circle\" ng-switch-when=\"2\"></i>\r\n                <strong ng-switch-when=\"0\"><translate>{{ \"Info\" }}</translate></strong>\r\n                <strong ng-switch-when=\"1\"><translate>{{ \"Warning\" }}</translate></strong>\r\n                <strong ng-switch-when=\"2\"><translate>{{ \"Error\" }}</translate></strong>\r\n                <br>\r\n                <small ng-switch-when=\"0\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con éxito.\") }}</translate></small>\r\n                <small ng-switch-when=\"1\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con avisos.\") }}</translate></small>\r\n                <small ng-switch-when=\"2\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Se ha producido un error al realizar la operación.\") }}</translate></small>\r\n              </a>\r\n            </li>\r\n            <!-- Mostrar errors 400 d\'API -->\r\n            <li ng-show=\"!status.response.data.GlobalMessage && (status.response.status==400 || status.response.status==403)\">\r\n              <a class=\"alert-callout alert-error\">\r\n                <i class=\"fa fa-exclamation-circle\"></i>\r\n                <strong>{{status.response.statusText}}</strong>\r\n                <br>\r\n                <small>{{status.response.data.Messsage || status.response.data}}</small>\r\n              </a>\r\n            </li>\r\n            <!-- Aixo mostrarà els errors que vinguin dintre d\'un OperationResult. -->\r\n            <!--<li ng-repeat=\"itemResp in status.response.data\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">-->\r\n            <li ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n                <strong>Error</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></small>\r\n              </a>\r\n            </li>\r\n            <!-- -->\r\n            <li ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':status.response.data.GlobalMessage.ErrType==0,\'fa-exclamation-triangle\':status.response.data.GlobalMessage.ErrType==1,\'fa-exclamation-circle\':status.response.data.GlobalMessage.ErrType==2}\"></i>\r\n                <strong>Error</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in status.response.data.obj.Errors | filter:{ErrType: 2}\">{{error.Msg}}<br></small>\r\n              </a>\r\n            </li>\r\n            <!-- -->\r\n            <li ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle de inserción</strong>\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType != 0\">Error de inserción</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\r\n              </a>\r\n            </li>\r\n            <li ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle de modificación</strong>\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType != 0\">Error de modificación</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\r\n              </a>\r\n            </li>\r\n            <li ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n                <strong>Error al eliminar</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\r\n              </a>\r\n            </li>\r\n            <li ng-repeat=\"itemResp in status.response.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n                <!--<span ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">\r\n                  <strong>Error: {{error.Msg}}</strong>\r\n                  <br>\r\n                  <small><strong>{{error.Property}}</strong>: {{error.Values[0]}}</small>\r\n                </span>-->\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle</strong>\r\n                <strong ng-if=\"itemResp.Errors[0].ErrType != 0\">Error</strong>\r\n                <br>\r\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </span>\r\n        <div ng-show=\"data.fullScreen\" class=\"btn-toolbar toolbar-buttons\" style=\"float:left\">\r\n          <label class=\"btn btn-default\" ng-click=\"fullScreen(false)\"><i class=\"fa fa-eye\"></i></label>\r\n        </div>\r\n      <span uib-dropdown ng-show=\"status.response.status>400 && status.response.status!=403\">\r\n        <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">1</span></a>\r\n        <ul uib-dropdown-menu>\r\n          <li>\r\n            <a class=\"alert-callout alert-error\">\r\n              <i class=\"fa fa-exclamation-circle\"></i>\r\n              <strong>{{status.response.statusText}}</strong>\r\n              <br>\r\n              <small>{{status.response.data.Message}}</small>\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </span>\r\n        <a data-ng-show=\"status.data.bloqueo && !status.editing\"><i class=\"fa fa-lock\"></i> <translate translate-value-username=\"{{status.data.bloqueo.user.name}}\" translate-value-tiempo=\"{{status.data.bloqueo.ts | date:\'HH:mm:ss\'}}\">{{ \'Registro bloqueado por <strong>\\{\\{username\\}\\}</strong> a las \\{\\{tiempo\\}\\}h\'  }}</translate> </a>\r\n      </div>\r\n      <!-- LINEA ORIGINAL --><!-- <span ng-show=\"!hideHeader\" style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em;\"><ix-bread-crumb app=\"status\" menu=\"menu\"></ix-bread-crumb><translate>{{ (manualTitle() || status.display)  }}</translate> {{ status.atributosTitle || \'\' }} <span ng-if=\"status.data.datos && status.data.pk && status.data.datos[status.data.pk]\"> > <translate translate-value-idregistro=\"{{status.data.datos[status.data.showAsID] || status.data.datos[status.data.tituloCabecera] || status.data.datos[status.data.pk]}}\">{{ \'ID \\{\\{idregistro\\}\\}\' }}</translate></span><span ng-if=\"status.data.tituloExtra\">&nbsp;{{ status.data.tituloExtra }}</span></span> -->\r\n      <span ng-show=\"!hideHeader\" style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\"><ix-bread-crumb app=\"status\" menu=\"menu\"></ix-bread-crumb><translate>{{ (manualTitle() || status.display)  }}</translate> {{ status.atributosTitle || \'\' }} <span ng-if=\"status.data.datos && status.data.pk && status.data.datos[status.data.pk]\"> > <translate translate-value-idregistro=\"{{status.data.datos[status.data.showAsID] || status.data.datos[status.data.tituloCabecera] || status.data.datos[status.data.pk]}}\">{{ \'\\{\\{idregistro\\}\\}\' }}</translate></span><span ng-if=\"status.data.tituloExtra\">&nbsp;{{ status.data.tituloExtra }}</span></span>\r\n    <!--\r\n      <a class=\"btn  pull-right\" data-ng-show=\"!incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-plus\"></i> Incidencia</a>\r\n      <a class=\"btn btn-warning pull-right\" data-ng-show=\"incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-exclamation-circle\"></i> Incidencia <span class=\"badge\">{{incidencias.length}}</span></a>\r\n      <div uib-dropdown class=\"pull-right\">\r\n        <a uib-dropdown-toggle class=\"btn \"><i class=\"fa fa-print\"></i> Impresos <span class=\"caret\"></span></a>\r\n        <ul uib-dropdown-menu>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar</a></li>\r\n        </ul>\r\n      </div>\r\n      <div uib-dropdown class=\"pull-right\">\r\n        <a uib-dropdown-toggle class=\"btn \"><i class=\"fa fa-bolt\"></i> Acciones <span class=\"caret\"></span></a>\r\n        <ul uib-dropdown-menu>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-truck\"></i> Acción Una</a></li>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-plus\"></i> Acción dos</a></li>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-venus-mars\"></i> Acción tres</a></li>\r\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-secret\"></i> Acción cuatro</a></li>\r\n        </ul>\r\n      </div>\r\n      <a class=\"btn btn-warning pull-right\" role=\"button\" data-ng-show=\"!status.editing && bloqueo\" data-ng-click=\"desbloquear()\"><i class=\"fa fa-unlock\"></i> Desbloquear</a>\r\n  \r\n      <a class=\"btn  pull-right\" role=\"button\" data-ng-show=\"ixEditar && !status.editing\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\r\n    -->\r\n      <div class=\"toolbar-buttons\" ng-if=\"!specialToolBar\" ng-show=\"!hideButtons\">\r\n        <button class=\"btn pull-right\" ng-show=\"ixCloseApp\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixCloseApp()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" tooltip-placement=\"bottom\"><translate>CERRAR</translate></button>\r\n        <div ng-if=\"generatePivot\" ng-show=\"pivotData\" class=\"pull-right btn-group\">\r\n            <label class=\"btn\" ng-model=\"showPivot\" uib-btn-radio=\"true\" ng-click=\"setPivot(true)\"><i class=\"fa fa-th-list\"></i></label>\r\n            <label class=\"btn\" ng-model=\"showPivot\" uib-btn-radio=\"false\" ng-click=\"setPivot(false)\"><i class=\"fa fa-table\"></i></label>\r\n        </div>\r\n        <button class=\"btn pull-right\" ng-show=\"ixDownloadExcel\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixDownloadExcel()\" uib-tooltip=\"{{ \'Descargar Excel\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixProgramar && ixPermiteProgramar\" ng-click=\"ixProgramar()\" uib-tooltip=\"{{ \'Programar listado\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"material-icons\">access_time</i> <translate>Programar</translate></button>\r\n  \r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"status.blockUIBtns || gridApi.selection.getSelectedRows().length==0 || !status.deleteEnabled || data.ixReadOnly == true\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"{{ \'Eliminar selección\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixAddRow && status.editing\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\r\n  \r\n  \r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixFiltrar && !status.editing\" ng-click=\"ixFiltrar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixProcesar && !status.editing\" ng-click=\"ixProcesar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Procesar</translate></button>\r\n        <button class=\"btn pull-right\" data-ng-show=\"ixEditar && !ocultaEditar && !status.editing\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"status.blockUIBtns || ixEditarDisabled || data.grid.ixIsLoading == true\" uib-tooltip=\"{{ (ixEditarTooltip || \'Cambia a modo edición\' ) | translate }}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\r\n  \r\n        <button class=\"btn pull-right\" data-ng-show=\"(ixCancelEdit && (ixEditar || ixFiltrar) && !ocultaEditar) && status.editing\" ng-click=\"ixCancelEdit()\" ng-disabled=\"status.blockUIBtns\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\"></i> <translate>Cancelar</translate></button>\r\n        <button class=\"btn pull-right\" data-ng-show=\"((ixEditar || ixFiltrar || ixGuardar) && !ocultaGuardar) && status.editing\" ng-click=\"ixGuardar()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ (ixGuardarTooltip || \'Guardar cambios\') | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || numberOfChanges()==0 || (form.$invalid)\"><i class=\"fa fa-floppy-o\"></i> <translate>Guardar</translate> <span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\r\n        <button class=\"btn pull-right\" data-ng-show=\"(ixCustomButton) && status.editing\" ng-click=\"ixCustomButton()\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || form.$invalid\"><translate>{{ixCustomButtonText}}</translate> </button>\r\n  \r\n        <div ng-transclude>\r\n          <!-- Podem afegir botons html desde el template. Apareixerien a continuació: -->\r\n        </div>\r\n        <!--<button class=\"btn btn-success pull-right\" ng-show=\"ixGuardar && !ixEditar && !ixFiltrar\" ng-click=\"ixGuardar()\" ng-disabled=\"form.$invalid\"><i class=\"fa fa-floppy-o\"></i> Guardar</button>-->\r\n      </div>\r\n  \r\n      <div class=\"toolbar-buttons\" ng-if=\"specialToolBar == true\" ng-show=\"!hideButtons\">\r\n        <button class=\"btn pull-right\" ng-show=\"ixCloseApp\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixCloseApp()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" tooltip-placement=\"bottom\"><translate>CERRAR</translate></button>\r\n        <!--<div ng-if=\"generatePivot\" ng-show=\"pivotData\" class=\"pull-right btn-group\">\r\n            <label class=\"btn \" ng-model=\"showPivot\" uib-btn-radio=\"true\" ng-click=\"setPivot(true)\"><i class=\"fa fa-th-list\"></i></label>\r\n            <label class=\"btn \" ng-model=\"showPivot\" uib-btn-radio=\"false\" ng-click=\"setPivot(false)\"><i class=\"fa fa-table\"></i></label>\r\n        </div>-->\r\n  \r\n  \r\n  \r\n  \r\n        <!-- En mode edició: -->\r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixDownloadExcel && (status.editing || status.filtered)\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixDownloadExcel()\" uib-tooltip=\"{{ \'Descargar excel\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixProgramar && status.editing && ixPermiteProgramar\" ng-click=\"ixProgramar()\" uib-tooltip=\"{{ \'Programar listado\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"material-icons\">access_time</i> <translate>Programar</translate></button>\r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixAddRowWhenEdit && status.editing\" ng-click=\"ixAddRowWhenEdit()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"status.blockUIBtns || gridApi.selection.getSelectedRows().length==0 || !status.deleteEnabled || data.ixReadOnly == true\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"{{ \'Eliminar selección\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\r\n  \r\n  \r\n        <!-- Pantalla carregada, sense estar filtrant ni editant -->\r\n  \r\n        <button class=\"btn pull-right\" ng-show=\"ixFiltrar && !status.editing && !status.filtered\" ng-click=\"ixFiltrar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixProcesar && !status.editing && !status.filtered\" ng-click=\"ixProcesar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Procesar</translate></button>\r\n        <button class=\"btn pull-right\" ng-show=\"ixAddRow && !status.editing && !status.filtered && !hideNewOnPreFilter\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\r\n        <!-- -->\r\n  \r\n  \r\n        <!-- En mode edició: -->\r\n        <button class=\"btn pull-right\" data-ng-show=\"(ixEditar || ixFiltrar) && (status.editing || (status.filtered && !hideCancelOnFilter))\" ng-click=\"ixCancelEdit()\" ng-disabled=\"status.blockUIBtns\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\"></i> <translate>Cancelar</translate></button>\r\n        <button class=\"btn pull-right\" data-ng-show=\"((ixEditar || ixFiltrar || ixGuardar) && !ocultaGuardar) && status.editing\" ng-click=\"ixGuardar()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ (ixGuardarTooltip || \'Guardar cambios\') }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || numberOfChanges()==0 || form.$invalid\"><i class=\"fa fa-floppy-o\"></i> <translate>Guardar</translate> <span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\r\n  \r\n  \r\n  \r\n  \r\n        <!-- -->\r\n  \r\n        <div ng-transclude>\r\n          <!-- Podem afegir botons html desde el template. Apareixerien a continuació: -->\r\n        </div>\r\n  \r\n        <button class=\"btn pull-right\" data-ng-show=\"(ixCustomButton) && status.editing\" ng-click=\"ixCustomButton()\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || form.$invalid\"><translate>{{ixCustomButtonText}}</translate> </button>\r\n        <!-- -->\r\n  \r\n        <!-- Filtrant pel registre sel·leccionat -->\r\n        <button class=\"btn pull-right\" data-ng-show=\"ixEditar && !status.editing && status.filtered\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"status.blockUIBtns || ixEditarDisabled || data.grid.ixIsLoading == true || form.$invalid\" uib-tooltip=\"{{ (ixEditarTooltip || \'Cambia a modo edición\') | translate }}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\r\n  \r\n        <!-- -->\r\n  \r\n  \r\n        <!--<button class=\"btn btn-success pull-right\" ng-show=\"ixGuardar && !ixEditar && !ixFiltrar\" ng-click=\"ixGuardar()\" ng-disabled=\"form.$invalid\"><i class=\"fa fa-floppy-o\"></i> Guardar</button>-->\r\n      </div>\r\n  \r\n      <script type=\"text/ng-template\" id=\"incidencia.html\">\r\n        <h1>Incidencias <small>{{status.current.title}}</small></h1>\r\n        <div data-ng-repeat=\"i in incidencias track by $index\">\r\n          <div data-ng-bind-html=\"i.text\" style=\"padding: 10px 0\"></div>\r\n          <small class=\"pull-right\">reported by <strong>{{i.user.name}}</strong> {{i.time | timeago}}</small>\r\n        </div>\r\n        <div>\r\n          <div data-text-angular data-ng-model=\"newIncidencia.text\" style=\"padding: 10px 0\"></div>\r\n          <button type=\"button\" class=\"btn \" data-ng-click=\"addIncidencia()\"><i class=\"fa fa-plus\"></i> añadir</button>\r\n        </div>\r\n      </script>\r\n    </div>\r\n  </header>\r\n    <uib-progressbar max=\"100\" min=\"0\" value=\"data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !data.ixProgress}\"></uib-progressbar>\r\n  </div>\r\n  ");
$templateCache.put("app/base/views/grid/checkBoxHeaderCell.html","<!--<div ng-class=\"{ \'sortable\': sortable }\">\r\n  <div class=\"ui-grid-vertical-bar\">&nbsp;</div>\r\n  <div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\">\r\n    <span>{{ col.displayName CUSTOM_FILTERS }}</span>\r\n    <span ui-grid-visible=\"col.sort.direction\" ng-class=\"{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, \'ui-grid-icon-down-dir\': col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }\">&nbsp;</span>\r\n  </div>\r\n  <div class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" class=\"ui-grid-column-menu-button\" ng-click=\"toggleMenu($event)\">\r\n    <i class=\"ui-grid-icon-angle-down\">&nbsp;</i>\r\n  </div>-->\r\n  <div class=\"ui-grid-filter-container\">\r\n    <span style=\"text-align: center\" ng-if=\"filterable\" class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\">\r\n      <div class=\"checkbox\">\r\n        <label>\r\n          <input type=\"checkbox\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"$event.stopPropagation()\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\r\n          <span class=\"checkbox-material\">\r\n            <span class=\"check\"></span>\r\n          </span>\r\n        </label>\r\n        <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-show=\"colFilter.term != null\">1</span>\r\n        <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null\">\r\n          <i ng-click=\"colFilter.term = null\" class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\r\n        </div>\r\n\r\n      </div>\r\n    </span>\r\n  </div>\r\n<!--</div>-->\r\n");
$templateCache.put("app/base/views/grid/ixCellGridFiltro.html","<div class=\"modal-header\">\r\n  <h3><translate translate-value-nombrecolumna=\"{{entity.campo}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"row\" ng-show=\"!hideSelectionMode\">\r\n    <div class=\"col-md-12\">\r\n      <ix-radio ng-model=\"filtro\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Según selección\"}, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }]\' multiple-in-line=\"true\"></ix-radio>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\r\n        <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\r\n        <span ng-show=\"listOfValues != undefined\">\r\n          <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n          <hr>\r\n        </span>\r\n        <!-- Filtrar camps que no van contra ninguna taula -->\r\n        <div class=\"row\" ng-show=\"columnType == \'string\' && listOfValues == undefined\">\r\n          <div class=\"col-md-12\">\r\n            <ix-text ng-model=\"filtro\" name=\"Filtro\" is-filter=\"true\"></ix-text>\r\n          </div>\r\n          <div class=\"col-md-12\">\r\n            <ix-select ng-show=\"control == \'Text\'\" ng-model=\"filterOp\" name=\"Método\" pk=\"op\" desc=\"nombre\" load-function=\"filterOptions\" load-all-items=\"true\" ng-default=\"7\"></ix-select>\r\n          </div>\r\n        </div>\r\n        <span ng-show=\"columnType == \'date\'\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-if=\"columnType == \'date\'\" ng-model=\"filtro_periodo[0]\" name=\"Periodo Inicial\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-if=\"columnType == \'date\'\" ng-model=\"filtro_periodo[1]\" name=\"Periodo Final\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n              <ix-date ng-show=\"filtro_periodo[0] == undefined\" ng-model=\"filtro[0]\" name=\"Fecha Inicial\"></ix-date>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n              <ix-date ng-show=\"filtro_periodo[1] == undefined\" ng-model=\"filtro[1]\" name=\"Fecha Final\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </span>\r\n        <span ng-show=\"columnType == \'number\'\">\r\n          <!--<ix-text ng-model=\"filtro[0]\" ng-model2=\"filtro[1]\" name=\"Valor entre\" is-filter=\"true\" ix-number></ix-text>-->\r\n          <ix-text ng-model=\"filtro\" name=\"Valor\" is-filter=\"true\" ix-number></ix-text>\r\n        </span>\r\n        <div class=\"col-md-12\">\r\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterSearchfiltro\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\r\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined && !singleOption\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n  </div>\r\n  <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"processData()\"><translate>Aplicar</translate></button>\r\n  <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/ixCellGridValorDef.html","<div class=\"modal-header\">\r\n  <h3><translate translate-value-nombrecolumna=\"{{entity.campo}}\">{{ \'Valor por Defecto \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"row\" ng-show=\"!hideSelectionMode\">\r\n    <div class=\"col-md-12\">\r\n      <ix-radio ng-model=\"filtro\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Según selección\"}, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }]\' multiple-in-line=\"true\"></ix-radio>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\r\n        <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\r\n        <span ng-show=\"listOfValues != undefined\">\r\n          <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n          <hr>\r\n        </span>\r\n        <!-- Filtrar camps que no van contra ninguna taula -->\r\n        <div class=\"row\" ng-show=\"listOfValues == undefined\">\r\n          <div class=\"col-md-12\">\r\n            <ix-text ng-model=\"filtro\" name=\"Valor\" is-filter=\"true\"></ix-text>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-12\">\r\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterSearchfiltro\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\r\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined && !singleOption\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n  </div>\r\n  <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"processData()\"><translate>Aplicar</translate></button>\r\n  <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/ixGridProgress.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">\r\n  <uib-progressbar value=\"COL_FIELD\" type=\"danger\" animate=\"false\"></uib-progressbar>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/ui-grid-header.html","<div role=\"rowgroup\" class=\"ui-grid-header\">\r\n  <!-- theader -->\r\n  <div class=\"ui-grid-top-panel\">\r\n    <div class=\"ui-grid-header-viewport\">\r\n      <div class=\"ui-grid-header-canvas\">\r\n        <div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\">\r\n          <div role=\"row\" class=\"ui-grid-header-cell-row\">\r\n            <div class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\" style=\"vertical-align: middle\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/ui-grid-row.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"con-alarma\": grid.appScope.conAlarma(row), \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/ui-grid-tree-row.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ng-style=\"{\'padding-left\': grid.options.treeIndent * row.treeLevel + \'px\'}\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"tree-level-0\": (row.treeLevel == 0), \"tree-level-1\": (row.treeLevel == 1), \"tree-level-2\": (row.treeLevel == 2), \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/base/views/grid/uiGridSortableCell.html","<div>\r\n  <div class=\"ui-grid-cell-contents\" ng-click=\"grid.appScope.orderInRow(grid, row, col)\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}} <i ng-class=\"{ \'ui-grid-icon-up-dir\': row.entity.orderby == \'asc\', \'ui-grid-icon-down-dir\': row.entity.orderby == \'desc\' }\"><sub ui-grid-visible=\"grid.appScope.isSortPriorityVisible(grid, row, col)\" class=\"ui-grid-sort-priority-number\">{{row.priority + 1}}</sub></i></div>\r\n</div>\r\n");
$templateCache.put("app/base/views/select/SearchBastidorInfo.html","<div>\r\n<form>\r\n<ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\r\n  <ui-select-match translate-attr=\"placeholder\">{{$select.selected[\"chasis\"]}} </ui-select-match>\r\n  <ui-select-choices repeat=\"item[\'chasis\'] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"50\">\r\n    <span ng-if=\"item.chasis\">\r\n      <span>{{item.chasis}} - <span ng-if=\"item.matricula\">{{item.matricula}} -</span> {{item.gruponombre}} - {{item.marcanombre}} - {{item.modelonombre}}</span>\r\n      <br>\r\n      <span class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento != 0\">Entrada: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </span><span class=\"text-muted\" ng-if=\"item.s_fecha && item.movimiento != 0\">Salida: {{ item.s_fecha | date: \"dd/MM/yyyy\" }}</span>\r\n      <span class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento == 0\">Previsión: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </span>\r\n      <br>\r\n      <span class=\"text-muted\">Cliente: {{item.clientenombre}} Cuenta: {{item.cuentanombre}}</span>\r\n    </span>\r\n  </ui-select-choices>\r\n</ui-select>\r\n</form>\r\n</div>\r\n");
$templateCache.put("app/base/views/select/SearchBastidorInfo2.html","<div class=\"ui-select-choices-row btn-sm\" ng-repeat=\"item in list | virtualSelectfilterSelected:item:selected:this track by $index\" ng-click=\"itemClick(item)\" ng-class=\"{active: highlighted == $index}\">\r\n	<a class=\"virtual-scroll-list-item ui-select-choices-row-inner\">\r\n		<span ng-if=\"item.chasis || item.vin\">\r\n      <div>{{item.chasis || item.vin}} - <span ng-if=\"item.matricula\">{{item.matricula}} -</span> {{item.gruponombre}} - {{item.marcanombre}} - {{item.modelonombre}}</div>\r\n      <div class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento != 0\">Entrada: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </div><div class=\"text-muted\" ng-if=\"item.s_fecha && item.movimiento != 0\">Salida: {{ item.s_fecha | date: \"dd/MM/yyyy\" }}</div>\r\n      <div class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento == 0\">Previsión: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </div>\r\n      <div class=\"text-muted\">Cliente: {{item.clientenombre}} Cuenta: {{item.cuentanombre}}</div>\r\n    </span>\r\n	</a>\r\n</div>\r\n");
$templateCache.put("app/base/views/select/SearchRefcarga.html","<div class=\"ui-select-choices-row btn-sm\" ng-repeat=\"item in list | virtualSelectfilterSelected:item:selected:this track by $index\" ng-click=\"itemClick(item)\" ng-class=\"{active: highlighted == $index}\">\r\n	<a class=\"virtual-scroll-list-item ui-select-choices-row-inner\">\r\n		<span ng-if=\"item.refcarga || item.refcargatr || item.matriculacamion || item.auxiliar\">\r\n			<div>{{item.refcarga}} - <span>{{item.vehiculos}} </span></div>\r\n			<div>Ref.T: {{item.refcargatr}} - <span>{{item.auxiliar}}</span></div>\r\n			<div>Matr. C: {{item.matriculacamion}}</div>\r\n			<div>Grupo: {{ item.gruponombre }} </div>\r\n		</span>\r\n	</a>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixBuscaFichaBastidor.html","<div>\r\n  <!--<div class=\"input-group\" style=\"width: 300px; padding-top: 8px;\">\r\n    <span class=\"input-group-addon\"><i class=\"fa fa-search fa-lg\"></i></span> <input class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" placeholder=\"Buscar VIN...\" ng-model=\"filtreVIN\" type=\"text\"><span ng-if=\"filtreVIN.length\" ng-click=\"clearSearch()\" class=\"input-group-addon\"><i class=\"fa fa-close fa-lg\"></i></span>\r\n\r\n  </div>-->\r\n  <div class=\"input-group\" style=\"width: 200px;background-color: #fafafa;border-bottom: 1px solid #e1e1e1;top:10px\">\r\n    <span class=\"input-group-addon\" style=\"border: 0px;background-color: #fafafa\"><i class=\"fa fa-search fa-lg\"></i></span> \r\n    <input placeholder=\"Buscar VIN...\" ng-model=\"filtreVIN\" type=\"text\" style=\"border: 0px; background-color: #fafafa;height: 30px;color:#333\">\r\n    <span ng-if=\"filtreVIN.length\" ng-click=\"clearSearch()\" class=\"input-group-addon\"><i class=\"fa fa-close fa-lg\"></i></span>\r\n  </div>\r\n  <div ng-show=\"listItems.length\" class=\"listcontainer\">\r\n    <!--<ul ng-show=\"abrir\">-->\r\n    <ul>\r\n      <li ng-mousedown=\"open(item)\" ng-repeat=\"item in listItems\">\r\n        <span>\r\n          Chasis: <b>{{item.VIN || item.vin }}</b> Matrícula: <b>{{item.Matricula || item.matricula}}</b><br>\r\n          {{item.Marca || item.marca}} {{item.Modelo || item.modelo }}<br>\r\n        </span>\r\n        <span ng-show=\"item.estado_gp || item.estado_personalizado\">\r\n          Estado: {{ item.estado_gp }} - {{ item.estado_personalizado }}<br>\r\n        </span>\r\n				<span ng-show=\"item.campa\">\r\n					Ubicación: {{ item.campa }} / {{ item.zona }} / {{ item.calle }} / {{ item.posicion }}<br>\r\n				</span>\r\n        <span>\r\n          <span ng-show=\"(item.FechaEntrada || item.fecha_ent)\">Entrada: {{(item.FechaEntrada || item.fecha_ent) | date: \'dd/MM/yyyy\' }}</span> <span ng-show=\"item.FechaSalida || item.fecha_sal\">Salida: {{(item.FechaSalida || item.fecha_sal) | date: \'dd/MM/yyyy\' }}</span>\r\n        </span>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixCestaVehiculosModal.html","<div class=\"modal-header\">\r\n  <h3>Cesta vehiculos</h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n<div class=\"row\">\r\n  <ix-text-area ng-class=\"inputcestaVehiculos\" ng-model=\"$parent.vehiculos\" name=\"Numeros de {{ $parent.campo }}\"></ix-text-area>\r\n	<ix-text ix-number is-filter=\"true\" ng-if=\"$parent.clientId == \'GPv4\'\" ng-model=\"$parent.$parent.cortar\" name=\"Cortar\"></ix-text>	\r\n</div>\r\n<div class=\"row\">\r\n  <ix-radio ng-model=\"$parent.campo\" name=\"campo\" label=\"Buscar por\" options=\"[{value:\'matricula\', text:\'Matrícula\'},{value:\'chasis\', text: \'Chasis\'}]\"></ix-radio>\r\n  <ix-options-si-no ng-if=\"$parent.clientId == \'GPv4\'\" ng-model=\"$parent.$parent.terminacion\" name=\"Terminación\"></ix-options-si-no>\r\n</div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n<button id=\"cancelFilter\" class=\"btn btn-danger pull-left\" ng-click=\"vaciarCesta()\">Vaciar</button>\r\n\r\n<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Guardar</button>\r\n<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cerrar</button>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixColor.html","<div class=\"form-group\">\r\n	<label class=\"col-md-4\"><translate>Color</translate>\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div class=\"col-md-8\">\r\n		<ui-select ng-model=\"$parent.ngModel\" ng-disabled=\"ngDisabled\">\r\n			<ui-select-match placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\"><label class=\"colorPreview\" style=\"background-color:{{$select.selected.visual}}\"></label>{{$select.selected.name}}</ui-select-match>\r\n			<ui-select-choices repeat=\"color.color as color in (colors | filter: $select.search) track by color.color\" refresh=\"refresh($select.search)\" refresh-delay=\"300\">\r\n				<div><translate>{{color.name}}</translate></div>\r\n				<div class=\"text-muted\"><label class=\"colorPreview\" style=\"background-color:{{color.visual}}\"></label>{{color.color}}</div>\r\n			</ui-select-choices>\r\n		</ui-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixDate.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<ix-datepicker ng-model=\"ngModel\" name=\"{{name}}\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-disabled=\"ngDisabled\" append-to-body=\"appendToBody\"></ix-datepicker>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixDateTime.html","		<div class=\"form-group\">\r\n			<label class=\"col-md-4\">{{name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n			<div class=\"col-md-8\">\r\n				<div class=\"row\">\r\n					<div class=\"col-xs-8\">\r\n						<ix-datepicker ng-model=\"ngModel\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-required=\"ngRequired\" name=\"{{name}}\" compare-datetime=\"true\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\"></ix-datepicker>\r\n					</div>\r\n					<div class=\"col-xs-4\" style=\"padding-left: 0\">\r\n						<!-- <input id=\"horaVarChar\" name=\"{{name}} (hora)\" time=\"text\" class=\"form-control\" ng-model=\"ngModelTime\" ui-mask=\"99:99\" model-view-value=\"true\" ui-validate=\"\'$parent.validateTIME($value)\'\" ng-required=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\"/> -->\r\n						<input id=\"horaVarChar\" name=\"{{name}} (hora)\" type=\"text\" ng-model=\"ngModelTime\" placeholder=\"HH:MM\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\">\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGrid.html","	<div style=\"height: {{height}}\" data-ui-grid=\"{{options}}\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridColor.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\" ix-ui-color-grid-cell>\r\n  <div class=\"text-muted\"><label class=\"colorPreview\" ng-style=\"getHTMLColor()\"></label><span ng-show=\"!hideDesc\">{{selectedColor.name}}</span></div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridColorEditor.html","<div>\r\n  <form>\r\n    <ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\r\n      <ui-select-match placeholder=\"Selecciona un registro...\"><label class=\"colorPreview\" style=\"background-color:{{$select.selected.visual}}\"></label>{{$select.selected.name}}</ui-select-match>\r\n      <ui-select-choices repeat=\"color.color as color in (col.colDef.colors | filter: $select.search) track by color.color\" refresh=\"refresh($select.search)\" refresh-delay=\"300\">\r\n        <div>{{color.name}}</div>\r\n        <div class=\"text-muted\"><label class=\"colorPreview\" style=\"background-color:{{color.visual}}\"></label>{{color.color}}</div>\r\n      </ui-select-choices>\r\n    </ui-select>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridDateEditor.html","<!--<div>\r\n  <form>\r\n    <div class=\"col-md-8\">\r\n      <ix-datepicker ng-model=\"MODEL_COL_FIELD\" name=\"COL_FIELD\"></ix-datepicker>\r\n    </div>\r\n  </form>\r\n</div>-->\r\n<div>\r\n	<form>\r\n		<ix-ui-grid-date-editor ng-model=\"MODEL_COL_FIELD\" name=\"{{COL_FIELD}}\"></ix-ui-grid-date-editor>\r\n	</form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridFiltro.html","<div class=\"ui-grid-filter-container\">\r\n  <button ng-class=\"{ \'novisible\': col.colDef.NoFilterable == true }\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\r\n		<i class=\"fa fa-filter\"></i>\r\n		<span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters && col.filters[0].term\">{{col.filters[0].numfilters}}</span>\r\n	</button>\r\n	<div class=\"ui-grid-filter-button\" ng-click=\"deslectAllAndApply()\">\r\n		<i ng-click=\"deslectAllAndApply()\" class=\"ui-grid-icon-cancel\" ng-show=\"col.filters[0].numfilters && col.filters[0].term\">&nbsp;</i>\r\n	</div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixGridFiltroModal.html\">\r\n			<div class=\"modal-header\">\r\n				<h3><translate translate-value-nombrecolumna=\"{{col.displayName}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <ix-radio ng-model=\"col.filters[0].selectionType\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: \"undefined\", text: \"Según selección\" }, { value: \"#lista\", text: \"Lista\" }, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }]\' multiple-in-line=\"true\"></ix-radio>\r\n          </div>\r\n          <div ng-show=\"col.filters[0].selectionType == \'undefined\'\">            \r\n            <div class=\"col-md-12\" ng-show=\"col.colDef.type !== \'date\'\">              \r\n              <ix-text ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n              <hr/>\r\n            </div>\r\n            <div class=\"col-md-12\">              \r\n              <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filtrarFiltervalue\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n					<div ng-if=\"col.filters[0].selectionType == \'#lista\'\">            \r\n            <div class=\"col-md-12\" ng-show=\"col.colDef.type !== \'date\'\">              \r\n              <ix-text-area ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" rows=\"8\"></ix-text-area>\r\n              <hr/>\r\n            </div>\r\n            <div class=\"col-md-12\">              \r\n              <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterList\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n			</div>\r\n			<div class=\"modal-footer\">\r\n        <span ng-show=\"col.filters[0].selectionType == \'undefined\' || col.filters[0].selectionType == \'#lista\'\">\r\n          <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n          <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n        </span>\r\n        <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\"><translate>Aplicar</translate></button>\r\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\r\n			</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridFiltroServidor.html","<div class=\"ui-grid-filter-container\">\r\n	<button ng-if=\"col.colDef.filteropt == \'Fecha\'\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\r\n		<i class=\"fa fa-filter\"></i>\r\n    <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters\">{{col.filters[0].numfilters}}</span>\r\n	</button>\r\n  <button ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\r\n    <i class=\"fa fa-filter\"></i>\r\n    <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters && col.filters[0].term\">{{col.filters[0].numfilters}}</span>\r\n  </button>\r\n  <!--<div ng-if=\"col.colDef.filteropt == \'CheckBox\'\" style=\"text-align: center;\" ng-repeat=\"colFilter in col.filters\">\r\n      <input type=\"checkbox\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"applyFiltersToGrid()\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\r\n    <span class=\"badge\" style=\"margin: 0 0 0 5px; background-color: red;\" ng-show=\"colFilter.term != null\">1</span>\r\n    <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null; applyFiltersToGrid()\">\r\n      <i class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\r\n    </div>\r\n  </div>-->\r\n  <div ng-if=\"col.colDef.filteropt == \'CheckBox\'\" style=\"text-align: center\" ng-repeat=\"colFilter in col.filters\">\r\n    <div class=\"checkbox\">\r\n      <label>\r\n        <input type=\"checkbox\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"applyFiltersToGrid()\" ng-checked=\"colFilter.term == \'1\'\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\r\n        <span class=\"checkbox-material\">\r\n          <span class=\"check\"></span>\r\n        </span>\r\n      </label>\r\n      <span class=\"badge\" style=\"margin: 0 0 0 5px; background-color: red\" ng-show=\"colFilter.term != null\">1</span>\r\n      <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null; applyFiltersToGrid()\">\r\n        <i ng-click=\"colFilter.term = null\" class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixGridFiltroServidorModal.html\">\r\n			<div class=\"modal-header\">\r\n				<h3><translate translate-value-nombrecolumna=\"{{col.displayName}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <div ng-if=\"col.colDef.filteropt == \'Fecha\'\" class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <ix-select ng-model=\"col.filters[0].periodo_ini\" name=\"Periodo inicio\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\r\n          </div>\r\n          <div class=\"col-md-12\">\r\n            <ix-select ng-model=\"col.filters[0].periodo_fin\" name=\"Periodo fin\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\r\n          </div>\r\n          <div class=\"col-md-12\" ng-show=\"col.filters[0].data_especial == undefined\">\r\n            <ix-date ng-if=\"!col.filters[0].periodo_ini\" ng-model=\"col.filters[0].data_ini\" name=\"Fecha inicio\"></ix-date>\r\n            <ix-date ng-if=\"!col.filters[0].periodo_fin\" ng-model=\"col.filters[0].data_fi\" name=\"Fecha final\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" class=\"row\">\r\n          <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\r\n          <span ng-show=\"col.colDef.type !== \'date\'\">\r\n              <!--<label>Buscar</label>\r\n              <input type=\"text\" ng-model=\"col.filters[0].filtervalue\" />-->\r\n            <ix-text ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n            <hr/>\r\n          </span>\r\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filtrarFiltervalue\">\r\n          </div>\r\n        </div>\r\n			</div>\r\n			<div ng-if=\"col.colDef.filteropt == \'Fecha\'\" class=\"modal-footer\">\r\n				<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Aplicar</button>\r\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button>\r\n			</div>\r\n			<div ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" class=\"modal-footer\">\r\n				<button class=\"btn pull-left\" ng-click=\"selectAll()\">Todos</button>\r\n				<button class=\"btn pull-left\" ng-click=\"deselectAll()\">Ninguno</button>\r\n				<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Aplicar</button>\r\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button>\r\n			</div>\r\n</script>");
$templateCache.put("app/base/views/helpers_templates/ixGridModal.html","<div class=\"modal\" ng-style=\"{display:\'block\'}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\">{{ colDisplayname }}</h3>\r\n      </div>\r\n      <div class=\"modal-body\" id=\"modal-body\">\r\n        <form class=\"popup-form\" name=\"modalForm\">\r\n          <div uib-alert class=\"alert-danger\" ng-if=\"modalForm.modify_value_repeat.$error.validator\">¡Las contraseñas no coinciden!</div>\r\n          <!-- Tots els camps que no siguin password seran tipus text -->\r\n          <div class=\"row\" ng-if=\"colField !== \'password\'\">\r\n            <!--<div><label>{{ colDisplayname }}<i class=\"fa fa-asterisk\"></i></label>\r\n              <input type=\"text\" ng-model=\"$parent.modify_value\" name=\"modify_value\" />\r\n            </div>-->\r\n            <div class=\"col-md-12\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-md-4\"><translate>{{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\r\n                <div class=\"col-md-8\">\r\n                  <input class=\"input-full-width\" type=\"text\" ng-model=\"$parent.modify_value\" name=\"modify_value\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Camps tipus password, s\'hauran de repetir. -->\r\n          <div class=\"row\" ng-if=\"colField === \'password\'\">\r\n            <!--<div><label>{{ colDisplayname }}<i class=\"fa fa-asterisk\"></i></label>\r\n                <input type=\"password\" ng-model=\"$parent.modify_value\" name=\"modify_value\" />\r\n            </div>-->\r\n            <!--<div ng-if=\"colField === \'password\'\"><label>Repeat {{ colDisplayname }}<i class=\"fa fa-asterisk\" style=\"color:red\"></i></label>\r\n                <input type=\"password\" ng-model=\"$parent.modify_value_repeat\" name=\"modify_value_repeat\" ui-validate=\" \'$value==modify_value\' \" ui-validate-watch=\" \'modify_value\' \" />\r\n            </div>-->\r\n            <div class=\"col-md-12\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-md-4\"><translate>{{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\r\n                <div class=\"col-md-8\">\r\n                  <input class=\"input-full-width\" type=\"password\" ng-model=\"$parent.modify_value\" name=\"modify_value\" autocomplete=\"off\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-md-4\"><translate>Repeat {{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\r\n                <div class=\"col-md-8\">\r\n                  <input class=\"input-full-width\" type=\"password\" ng-model=\"$parent.modify_value_repeat\" name=\"modify_value_repeat\" ui-validate=\" \'$value==modify_value\' \" ui-validate-watch=\" \'modify_value\' \" autocomplete=\"off\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button class=\"btn btn-success\" ng-click=\"saveData()\">Guardar</button>\r\n        <button class=\"btn btn-danger\" ng-click=\"closePopup()\">Cerrar</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridMultipleSelectEditor.html","<div class=\"ui-grid-cell-contents\">\r\n  <ix-grid-multiple-select ng-model=\"MODEL_COL_FIELD\" valor=\"{{COL_FIELD}}\"></ix-grid-multiple-select>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixGridMultipleSelectModal.html\">\r\n			<div class=\"modal-header\">\r\n				<h3><translate translate-value-nombrecolumna=\"{{nombrecolumna}}\">{{ \'Selección de \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <label><translate>Buscar</translate></label>\r\n        <input type=\"text\" ng-model=\"$parent.searchvalue\" />\r\n        <hr/>\r\n        <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"optionValues\" ivh-treeview-filter=\"$parent.filterValue\">\r\n				</div>\r\n			</div>\r\n			<div class=\"modal-footer\">\r\n        <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n        <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n        <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close(true)\"><translate>Aplicar</translate></button>\r\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$close()\"><translate>Cancelar</translate></button>\r\n			</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSelectEditor.html","<div>\r\n  <form>\r\n    <ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\r\n      <ui-select-match translate-attr=\"placeholder\"><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\r\n      <ui-select-choices repeat=\"item[col.colDef.LookUpKeyFields[col.colDef.LookUpKeyFields.length-1]] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"50\">\r\n        <span ng-repeat=\"f in col.colDef.LookUpResultFields\" ng-class=\"{\'text-muted\':(col.colDef.LookUpKeyFields.indexOf(f)>=0)}\"><span ng-if=\"$index>0 && item[f]\"> - </span>{{item[f]}}</span>\r\n      </ui-select-choices>\r\n    </ui-select>\r\n\r\n\r\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" theme=\"TEMA_GRID\" ng-disabled=\"disabled\" ix-ui-grid-select-editor append-to-body=\"true\">\r\n      <ui-select-match translate-attr=\"placeholder\"><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\r\n      <ui-select-choices repeat=\"item in col.colDef.editDropdownOptionsArray | filter: $select.search\">\r\n        <span>{{ item }}</span>\r\n      </ui-select-choices>\r\n    </ui-select>-->\r\n\r\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px;\" theme=\"TEMA_GRID\" append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\r\n      <ui-select-match><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\r\n      <ui-select-choices repeat=\"item[col.colDef.LookUpKeyFields[col.colDef.LookUpKeyFields.length-1]] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"300\">\r\n        <span ng-repeat=\"f in col.colDef.LookUpResultFields\" ng-class=\"{\'text-muted\':(col.colDef.LookUpKeyFields.indexOf(f)>=0)}\"><span ng-if=\"$index>0 && item[f]\"> - </span>{{item[f]}}</span>\r\n      </ui-select-choices>\r\n    </ui-select>-->\r\n\r\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" theme=\"selectize\" ng-disabled=\"disabled\" append-to-body=\"true\">\r\n      <ui-select-match placeholder=\"Choose...\">{{ COL_FIELD }}</ui-select-match>\r\n      <ui-select-choices repeat=\"item in col.colDef.editDropdownOptionsArray | filter: $select.search\">\r\n        <span>{{ item }}</span>\r\n      </ui-select-choices>\r\n    </ui-select>-->\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSelectEditor2.html","<div>\r\n  <form>\r\n		<virtual-select title=\"TOOLTIP\" ng-class=\"{\'required\':col.colDef.required, \'noeditable\':col.grid.api.ix.disableField({row: row, col: col }, col)}\" choices-repeat=\"col.colDef.editDropdownOptionsArray\" ix-ui-grid-select-editor2 style=\"line-height:22px\" ng-model=\"MODEL_COL_FIELD\" core-property=\"col.colDef.LookUpResultFields[col.colDef.LookUpResultFields.length - 1]\" display-property=\"col.colDef.LookUpResultFields[0]\" singleselect dropdown-in-grid=\"true\" ng-disabled=\"col.grid.api.ix.disableField({row: row, col: col }, col)\" ng-required=\"col.colDef.required\" entity=\"col.colDef.LookUpTableName\" extra-field=\"extraField\" preload=\"preload\" conditions=\"col.colDef.LookUpConditions\" key-fields=\"col.colDef.KeyFields\" lookup-key-fields=\"col.colDef.LookUpKeyFields\" load-function=\"col.colDef.refreshDropdown\" allow-custom=\"col.colDef.EditableDropdown\" allow-custom-priority=\"col.colDef.EditableDropdownPriority\" on-select=\"col.colDef.onSelectDropdown\" grid-row=\"row\" grid-col=\"col\" append-to-body=\"true\" all-fk-objects=\"col.colDef.allFkObjects\" template=\"col.colDef.template\" min-length-to-load=\"col.colDef.minLengthToLoad\" max-length=\"col.colDef.maxLength\" skip-table-name-filter=\"col.colDef.skipTableNameFilter\" skip-table-name-order-by=\"col.colDef.skipTableNameOrderBy\" table-alias-name=\"col.colDef.TableAliasName\" lookup-orders=\"col.colDef.LookUpOrders\"></virtual-select>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSiNoEditor.html","<div>\r\n  <form>\r\n    <ui-select class=\"ix-si-no\" ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\r\n      <ui-select-match allow-clear=\"true\">{{$select.selected.desc}}</ui-select-match>\r\n      <ui-select-choices repeat=\"item.pk as item in (col.colDef.editDropdownOptionsArray | filter: $select.search) track by item.pk\" refresh=\"col.colDef.onOpenCloseDropdown(true)\" refresh-delay=\"50\">\r\n				<div>{{::item.desc}}</div>\r\n				<div class=\"text-muted\">{{::item.pk}}</div>\r\n			</ui-select-choices>\r\n    </ui-select>\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixGridTimeEditor.html","<div>\r\n  <form>\r\n    <!--<input style=\"background-color: white;\" time=\"text\" ix-grid-time-editor ui-grid-editor class=\"form-control\" ng-model=\"MODEL_COL_FIELD\" ui-mask=\"99:99:99\" model-view-value=\"true\" ui-validate=\"\'validateTIME($value)\'\" />-->\r\n   <input style=\"background-color: white\" time=\"text\" ix-grid-time-editor class=\"form-control\" ng-model=\"MODEL_COL_FIELD\">\r\n  </form>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixListSelect.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" class=\"input-full-width\" ngrequired=\"ngRequired\" ng-disabled=\"true\" ng-value=\"ngValue\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\">\r\n		<span class=\"icon-box\" ng-click=\"showModalSelection()\"><i class=\"fa fa-search\"></i></span>\r\n	</div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"ixListSelectModal.html\">\r\n			<div class=\"modal-header\">\r\n				<h3>{{ $parent.name }}</h3>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <label><translate>Buscar</translate></label>\r\n        <input type=\"text\" ng-model=\"$parent.searchvalue\" />\r\n        <hr/>\r\n        <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"optionValues\" ivh-treeview-filter=\"$parent.searchvalue\">\r\n				</div>\r\n			</div>\r\n			<div class=\"modal-footer\">\r\n        <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n        <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n        <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\"><translate>Aplicar</translate></button>\r\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\r\n			</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixMegawhere.html","<div ng-dblclick=\"openWindow(\'big\')\" class=\"ui-grid-cell-contents\">\r\n  <i ng-click=\"openWindow(\'big\')\" title=\"Condiciones\" class=\"fa fa-fw fa-window-maximize\"></i>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixMegawhereModal.html\" class=\"megawhereWindow\">\r\n			<div class=\"modal-header\">\r\n				<ix-tool-bar></ix-tool-bar>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridmegawhere\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\r\n        </div>\r\n			</div>\r\n			<div class=\"modal-footer\">\r\n				<!--<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Guardar</button>-->\r\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cerrar</translate></button>\r\n			</div>\r\n</script>\r\n\r\n");
$templateCache.put("app/base/views/helpers_templates/ixOptionsSiNo.html","<div class=\"togglebutton\" abm-toggle>\r\n  <label ng-class=\"{ \'col-md-8\': textMaxWidth == true, \'col-md-4\': !textMaxWidth }\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n  <input ng-class=\"{ \'pull-right\': textMaxWidth == true }\" ng-checked=\"estaSeleccionado == 1\" type=\"checkbox\" ng-click=\"changeSelected(ngModel)\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixPreviewImage.html","<div>\r\n	<button ng-if=\"type == \'button\'\" ng-click=\"openPopup()\"></button>\r\n	<img ng-if=\"type == \'image\'\" class=\"img-thumbnail\" src=\"assets/images/{{src}}\" ng-click=\"openPopup()\">\r\n</div>\r\n\r\n\r\n<script type=\"text/ng-template\" id=\"image_viewer.html\">\r\n	<div class=\"col-md-12 imgContainer\">\r\n		<img class=\"slide\" src=\"assets/images/{{src}}\" />\r\n	</div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"ixPreviewImageModal.html\">\r\n	<div>\r\n		<ix-popup-tool-bar title-left=\"Previsualizar Imagen\"></ix-popup-tool-bar>\r\n		<div ng-scrollbars class=\"scrolldiv\">\r\n			<div class=\"scrolldiv-content\">\r\n				<div class=\"modal-body\">\r\n					<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n						<div class=\"row\">\r\n							<span ng-include=\"\'image_viewer.html\'\"></span>\r\n						</div>\r\n						<div class=\"row\">\r\n							<div class=\"col-md-3\">\r\n								<button ng-click=\"downloadFile(src)\"><i class=\"fa fa-download\"></i></button>\r\n							</div>\r\n						</div>\r\n					</form>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixPreviewPDF.html","<span>\r\n	<button class=\"btn no-margin\" ng-click=\"openPopup()\">{{ name }}</button>\r\n</span>\r\n\r\n<script type=\"text/ng-template\" id=\"pdf_viewer.html\">\r\n	<div class=\"col-md-12\" style=\"height: 700px\">\r\n		<div class=\"some-pdf-container\" style=\"width: 100%; height: 100%;\">\r\n			<pdfjs-viewer src=\"{{urlPDF}}\"></pdfjs-viewer>\r\n		</div>\r\n	</div>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"ixPreviewPDFModal.html\">\r\n	<div>\r\n		<ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\r\n		<div ng-scrollbars class=\"scrolldiv\">\r\n			<div class=\"scrolldiv-content\">\r\n				<div class=\"modal-body\">\r\n					<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n						<div class=\"row\">\r\n							<span ng-include=\"\'pdf_viewer.html\'\"></span>\r\n						</div>\r\n					</form>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixRadio.html","<div class=\"form-group\">\r\n	<label class=\"col-md-4\"><translate>{{label}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"col-md-8\">\r\n    <div class=\"row options\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"options-container\">\r\n          <div ng-repeat=\"option in options\" ng-class=\"{ \'multipleinline\': multipleInLine == true }\">\r\n            <!-- ngRepeat crea un childScope, per accedir propietats de la directiva ha de ser a través de $parent -->\r\n            <input type=\"radio\" id=\"{{name}}{{option.value}}\" ng-model=\"$parent.ngModel\" name=\"{{$parent.name}}\" ng-value=\"option.value\" ng-disabled=\"ngDisabled\">\r\n            <label for=\"{{name}}{{option.value}}\"><img ng-if=\"option.icon\" src=\"{{::option.icon}}\"> {{option.text | translate}}</label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixSearchFromGrid.html","<div class=\"form-group\">\r\n  <label class=\"col-md-4\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n  <div class=\"col-md-8\">\r\n    <div class=\"input-group add-on\">\r\n      <input ng-model=\"ngModel\" type=\"text\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\" ng-value=\"ngValue\" ix-focus-out=\"validateFunction\">\r\n      <span class=\"input-group-btn\">\r\n        <span class=\"btn btn-default\" ng-disabled=\"ngDisabled\" ng-click=\"openWindow(\'big\')\">\r\n          <span ng-transclude></span>\r\n        </span>\r\n      </span>\r\n    </div>\r\n    <!--<input ng-click=\"openWindow(\'big\')\" type=\"text\" ngRequired =\"ngRequired\" ng-disabled=\"ngDisabled\" ng-value=\"ngValue\" readonly>-->\r\n  </div>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixSearchGridModal.html\" class=\"megawhereWindow\">\r\n  <ix-popup-tool-bar title-left=\"Buscar\" title-left-param=\"entity\"></ix-popup-tool-bar>\r\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"btn-toolbar\">\r\n          <div style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridBusqueda\" data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-cellNav>\r\n            <div class=\"grid-loading\" ng-if=\"gridBusqueda.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixSelect.html","<div class=\"form-group\">\r\n	<label class=\"col-md-4\"><translate>{{::name || pk}}</translate>\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<ui-select ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"$parent.ngModel\" ng-class=\"{ \'show-always\': editableDropdown == true }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\" uis-open-close=\"onOpenCloseDropdown(isOpen)\">\r\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$select.selected[desc]}} <span ng-if=\"extraField\">/ {{$select.selected[extraField]}}</span></ui-select-match>\r\n			<!--ixTODO: aquet filtre de DOM ((allItems | filt...) per un filtre de controller-->\r\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: $select.search) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\r\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\r\n				<div class=\"text-muted\">{{::item[pk]}}</div>\r\n			</ui-select-choices>\r\n		</ui-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixSelect2.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name || pk}}</translate>\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<virtual-select ng-class=\"{ \'disabled\': ngDisabled }\" choices-repeat=\"allItems\" ng-model=\"ngModel\" core-property=\"pk\" display-property=\"desc\" singleselect ng-disabled=\"ngDisabled\" custom-ng-required=\"ngRequired\" entity=\"entity\" extra-field=\"extraField\" filter-fields=\"filterFields\" preload=\"preload\" conditions=\"conditions\" load-function=\"loadFunction\" ng-default=\"ngDefault\" whole-obj=\"wholeObj\" order-string-as-int=\"orderStringAsInt\" allow-custom=\"editableDropdown\" preload-function=\"preloadFunction\" preload-obj=\"preloadObj\" preload-pk=\"preloadPk\" load-all-items=\"loadAllItems\" entity-data=\"entityData\" entity-data-pk=\"entityDataPk\" entity-data-desc=\"entityDataDesc\" append-to-body=\"appendToBody\" on-select=\"onSelect\" template=\"template\" skip-table-name-filter=\"skipTableNameFilter\" skip-table-name-order-by=\"skipTableNameOrderBy\" longer-result-box=\"longerResultBox\"></virtual-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixSelectFromGrid.html","<div>\r\n  <form>\r\n    <ix-grid-select ng-model=\"MODEL_COL_FIELD\" valor=\"{{COL_FIELD}}\"></ix-grid-select>\r\n  </form>\r\n</div>\r\n\r\n<script type=\"text/ng-template\" id=\"ixGridSelectModal.html\">\r\n			<div class=\"modal-header\">\r\n				<h3>Selección de {{$parent.$parent.col.name}}</h3>\r\n			</div>\r\n			<div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"btn-toolbar\">\r\n              <div style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridSeleccion\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-cellNav>\r\n                <div class=\"grid-loading\" ng-if=\"gridSeleccion.ixIsLoading\">\r\n                  <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n			</div>\r\n			<div class=\"modal-footer\">\r\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$close()\"><translate>Cancelar</translate></button>\r\n			</div>\r\n</script>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixSelectMultiple.html","<div class=\"form-group\">\r\n	<label class=\"col-md-4\"><translate>{{::name || pk}}</translate>\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div class=\"col-md-8\">\r\n		<ui-select multiple ng-model=\"$parent.ngModel\" ng-class=\"{ \'show-always\': editableDropdown == true }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\">\r\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$item[desc]}} {{ (cfg.dropdownSinCodigo) ? \"\" : \"- \"+$item[pk] }}</ui-select-match>\r\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: filtrarResultados($select)) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\r\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\r\n				<div ng-class=\"{\'invisible\': cfg.dropdownSinCodigo }\" class=\"text-muted\">{{::item[pk]}}</div>\r\n			</ui-select-choices>\r\n		</ui-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixText.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" ng-class=\"(ngModel2 === undefined) ? \'input-full-width\' : \'input-half-width\'\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-show=\"ngModel2 !== undefined\" ng-model=\"ngModel2\" class=\"input-half-width\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" maxlength=\"{{::maxLength2}}\" autocomplete=\"off\">\r\n	</div>\r\n	<div ng-transclude></div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixTextArea.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<textarea ng-class=\"ngClass\" ng-model=\"ngModel\" style=\"width:100%\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\" maxlength=\"{{::maxLength}}\" rows=\"{{::rows}}\" cols=\"{{::cols}}\"></textarea>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/base/views/helpers_templates/ixTime.html","<div class=\"form-group\">\r\n  <label class=\"col-md-4\">{{name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n  <div ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n    <!--<input time=\"text\" ng-model=\"ngModel\" ui-mask=\"99:99\" model-view-value=\"true\" ui-validate=\"{ Tiempo: \'validateTIME($value)\' }\" ngRequired=\"ngRequired\" ng-disabled=\"ngDisabled\" />-->\r\n		<input type=\"text\" ng-model=\"ngModel\" placeholder=\"HH:MM:SS\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\">\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/api_perfiles/api_perfilesCard.html","<strong>{{item.perfil}}</strong>\r\n<br>\r\n{{item.bd}}\r\n");
$templateCache.put("app/base/views/api_perfiles/api_perfilesForm.html","<div ng-controller=\"ApiPerfilesController\">\r\n	<ix-tool-bar></ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<fieldset>\r\n          <legend><ix-text ng-model=\"data.datos.perfil\" name=\"Nombre del perfil\" ng-required=\"true\"></ix-text></legend>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-6\">\r\n							<h3><translate>Usuarios</translate></h3>\r\n							<ul class=\"list-group\">\r\n								<li class=\"list-group-item\" ng-repeat=\"u in data.datos.perfilesusuario\">\r\n									{{u}}<span class=\"pull-right\" ng-click=\"deleteUser(u)\" uib-tooltip=\"{{ \'Quitar\' | translate }} {{u}}\" tooltip-append-to-body=\"true\">&times;</span>\r\n								</li>\r\n								<li class=\"list-group-item\" ng-show=\"status.editing\">\r\n									<input type=\"text\" class=\"form-control\" placeholder=\"añadir usuario\" ng-model=\"newUser\" uib-typeahead=\"u for u in allUsers | filter:$viewValue\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelectNewUser($item);newUser=undefined\" typeahead-focus-on-select=\"false\" typeahead-append-to-body=\"true\">\r\n								</li>\r\n							</ul>\r\n						</div>\r\n						<div class=\"col-md-6\">\r\n							<h3><translate>Menús</translate></h3>\r\n							<ul class=\"list-group\">\r\n								<li class=\"list-group-item\" ng-repeat=\"(key,menu) in data.menuItems\">\r\n									{{menu.path}}/{{menu.node.display}}\r\n                  <div class=\"checkbox pull-right\" abm-checkbox>                    \r\n                    <input type=\"checkbox\" ng-model=\"menu.checked\" class=\"pull-right\" ng-disabled=\"!status.editing\">\r\n                  </div>\r\n								</li>\r\n							</ul>\r\n						</div>\r\n					</div>\r\n				</fieldset>\r\n			</form>\r\n		</div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/base/views/controls/editbuttons.html","	<span uib-dropdown ng-show=\"form.$invalid\">\r\n		<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{length(form.$error)}}</span></a>\r\n		<ul uib-dropdown-menu>\r\n			<li ng-repeat=\"(k,v) in form.$error\">\r\n				<a class=\"alert-callout alert-warning\" ng-click=\"setFocus(v[0].$name)\">\r\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}}</strong><br>\r\n					<small ng-repeat=\"vv in v\">{{vv.$name}}&nbsp;</small>\r\n				</a>\r\n			</li>\r\n		</ul>\r\n	</span>\r\n	<a data-ng-show=\"bloqueo && !editing\"><i class=\"fa fa-lock\"></i> Registro bloqueado por <strong>{{bloqueo.user.name}}</strong> a las {{bloqueo.ts | date:\'HH:mm:ss\'}}h </a>\r\n	<div class=\"alertbox alert alert-warning\" role=\"alert\" ng-show=\"response.status==-1 || response.status>=400 || (response.data.Result)\">\r\n		<a class=\"close\" aria-label=\"close\">&times;</a>\r\n		<div ng-show=\"response.status==-1\">\r\n			<i class=\"fa fa-exclamation-triangle\"></i> Error <strong>OPTIONS</strong>\r\n		</div>\r\n		<div ng-show=\"response.status>=400\">\r\n			<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error {{response.status}}</strong>: {{respose.statusText}} {{response.data.Message}}\r\n		</div>\r\n		<div ng-show=\"response.data.Result\">\r\n			<i class=\"fa fa-info-circle\"></i> {{response.data.ErrorMessage}}\r\n		</div>\r\n		<div ng-show=\"response.data.Result==false\">\r\n			<i class=\"fa fa-exclamation-triangle\"></i> {{response.data.GlobalMessage.Msg}}\r\n			<div ng-repeat=\"item in response.data.Deleted\">\r\n				<div ng-repeat=\"error in item.Errors\">\r\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Deleting</strong>: {{error.Msg}}\r\n				</div>\r\n			</div>\r\n			<div ng-repeat=\"item in response.data.Updated\">\r\n				<div ng-repeat=\"error in item.Errors\">\r\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Updating</strong>: {{error.Msg}}\r\n				</div>\r\n			</div>\r\n			<div ng-repeat=\"item in response.data.Inserted\">\r\n				<div ng-repeat=\"error in item.Errors\">\r\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Inserting</strong>: {{error.Msg}}\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n\r\n\r\n\r\n	<a class=\"btn btn-primary pull-right\" data-ng-show=\"!incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-plus\"></i> Incidencia</a>\r\n	<a class=\"btn btn-warning pull-right\" data-ng-show=\"incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-exclamation-circle\"></i> Incidencia <span class=\"badge\">{{incidencias.length}}</span></a>\r\n	<div uib-dropdown class=\"pull-right\">\r\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-print\"></i> Impresos <span class=\"caret\"></span></a>\r\n		<ul uib-dropdown-menu>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar</a></li>\r\n		</ul>\r\n	</div>\r\n	<div uib-dropdown class=\"pull-right\">\r\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-bolt\"></i> Acciones <span class=\"caret\"></span></a>\r\n		<ul uib-dropdown-menu>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-truck\"></i> Acción Una</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-plus\"></i> Acción dos</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-venus-mars\"></i> Acción tres</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-secret\"></i> Acción cuatro</a></li>\r\n		</ul>\r\n	</div>\r\n	<a class=\"btn btn-warning pull-right\" role=\"button\" data-ng-show=\"!editing && bloqueo\" data-ng-click=\"desbloquear()\"><i class=\"fa fa-unlock\"></i> Desbloquear</a>\r\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"!editing\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\r\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"!editing\" data-ng-click=\"editar()\" data-ng-disabled=\"{{bloqueo}}\"><i class=\"fa fa-pencil\"></i> Editar</a>\r\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"cancelEdit()\"><i class=\"fa fa-times\"></i> Cancelar</a>\r\n	<a class=\"btn btn-success pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"guardar()\"><i class=\"fa fa-floppy-o\"></i> Guardar</a>\r\n\r\n\r\n	<script type=\"text/ng-template\" id=\"incidencia.html\">\r\n		<h1>Incidencias <small>{{$root.currentApp.name}}</small></h1>\r\n		<div data-ng-repeat=\"i in incidencias track by $index\">\r\n			<div data-ng-bind-html=\"i.text\" style=\"padding: 10px 0\"></div>\r\n			<small class=\"pull-right\">reported by <strong>{{i.user.name}}</strong> {{i.time | timeago}}</small>\r\n		</div>\r\n		<div>\r\n			<div data-text-angular data-ng-model=\"newIncidencia.text\" style=\"padding: 10px 0\"></div>\r\n			<button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"addIncidencia()\"><i class=\"fa fa-plus\"></i> añadir</button>\r\n		</div>\r\n	</script>\r\n\r\n");
$templateCache.put("app/base/views/controls/formerrors.html","	<div class=\"alert alert-warning alert-dismissible\" role=\"alert\">\r\n		<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\r\n			<span aria-hidden=\"true\">&times;</span>\r\n		</button>\r\n		<div ng-repeat=\"error in form.$error\">\r\n			<strong>Warning!</strong> Better check yourself, you\'re not looking too good.\r\n		</div>\r\n	</div>\r\n	errors\r\n");
$templateCache.put("app/base/views/controls/grideditable.html","<div class=\"btn-toolbar\">\r\n	<div class=\"pull-left\" ng-show=\"editing\">\r\n		{{gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n		{{deletedRows.length}} filas eliminadas\r\n		{{insertedRows.length}} filas creadas\r\n		{{gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n	</div>\r\n	<a class=\"btn btn-default pull-right\" role=\"button\" onclick=\"maximizeGrid(this, event)\" uib-tooltip=\"Maximize/minimize grid\"><i class=\"fa fa-arrows-alt\"></i></a>\r\n	<div uib-dropdown class=\"pull-right\">\r\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i> <span class=\"caret\"></span></a>\r\n		<ul uib-dropdown-menu>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"savePreferences()\"><i class=\"fa fa-floppy-o\"></i> Guardar preferencias de visualización</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"restorePreferences()\"><i class=\"fa fa-undo\"></i> Restaurar preferencias de visualización</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-wrench\"></i> Predefinir para todos los usuarios (admin)</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-trash-o\"></i> Eiminar settings de todos los usuarios (admin)</a></li>\r\n		</ul>\r\n	</div>\r\n	<a class=\"btn btn-default pull-right\" ng-class=\"gridOptions.enableFiltering?\'active\':\'\'\" role=\"button\" data-ng-click=\"toggleFiltering()\" uib-tooltip=\"togle filter\"><i class=\"fa fa-filter\"></i></a>\r\n	<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"downloadCSV()\" uib-tooltip=\"Download grid data as CSV\"><i class=\"fa fa-file-excel-o\"></i></a>\r\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-disabled=\"gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows()\" uib-tooltip=\"Delete selected items\"><i class=\"fa fa-trash-o\"></i></a>\r\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"addRow()\" uib-tooltip=\"Add new item\"><i class=\"fa fa-plus\"></i></a>\r\n\r\n</div>\r\n<div style=\"height:400px\" data-ui-grid=\"gridOptions\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\r\n");
$templateCache.put("app/base/views/controls/listbuttons.html","	<div class=\"alert alert-warning pull-left\" role=\"alert\" ng-show=\"response\">\r\n		<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error {{response.status}}</strong>: {{respose.statusText}} {{response.data.Message}} ({{response}})\r\n	</div>\r\n\r\n	<a class=\"btn btn-warning pull-right\"><i class=\"fa fa-print\"></i> Imprimir</a>\r\n	<div class=\"dropdown pull-right\">\r\n		<a class=\"btn btn-default dropdown-toggle\" role=\"button\" data-toggle=\"dropdown\"><i class=\"fa fa-download\"></i> Exportar <span class=\"caret\"></span></a>\r\n		<ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dropdownMenu1\">\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\r\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar al portapapeles</a></li>\r\n		</ul>\r\n	</div>\r\n	<a class=\"btn btn-danger pull-right\" role=\"button\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\r\n	<a class=\"btn btn-success pull-right\" role=\"button\" data-ng-href=\"{{entity}}\"><i class=\"fa fa-plus\"></i> Nuevo </a>\r\n\r\n");}]);
angular.module("FTBaseApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/FTBase/Contratos/detalles_contrato_ft.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar contrato\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"contrato.ncontrato\" name=\"Núm. Contrato\" ng-required=\"true\"></ix-text>\r\n              <ix-date ng-model=\"contrato.fecha\" name=\"Fecha\" ng-disabled=\"!status.editing\"></ix-date>\r\n              <ix-text ng-model=\"contrato.numfactura\" name=\"Núm. Factura\"></ix-text>\r\n              <ix-text ng-model=\"contrato.concepto\" name=\"Concepto\"></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.mantenimiento\" name=\"Mantenimiento\"></ix-options-si-no>\r\n              <ix-text ng-model=\"contrato.coste_ft\" name=\"Coste por ficha técnica\" ix-number></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.pagado\" name=\"Pagado\"></ix-options-si-no>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"contrato.nrevision\" name=\"Núm. revisión\" ix-number></ix-text>\r\n              <ix-select ng-model=\"contrato.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"contrato.cod_cli_fact\" name=\"Codigo cliente facturacion\"></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.aceptado\" name=\"Aceptado\"></ix-options-si-no>\r\n              <ix-text ng-model=\"contrato.coste_mantenimiento\" name=\"Coste mantenimiento\" ix-number></ix-text>\r\n              <ix-text ng-model=\"contrato.iva\" name=\"IVA\" ix-number></ix-text>\r\n              <ix-date ng-model=\"contrato.fechapago\" name=\"Fecha de pago\" ng-disabled=\"!status.editing\"></ix-date>\r\n            </div>\r\n          </div>\r\n          <hr>\r\n          <div style=\"width:100%\">\r\n            <div class=\"pull-left\">\r\n              <ix-select ng-model=\"ft_add\" name=\"Seleccionar FT\" pk=\"id\" desc=\"id\" load-function=\"loadFt\" on-select=\"loadDetFt\" append-to-body=\"true\"></ix-select>\r\n            </div>\r\n            <div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFt.ixIsLoading\" data-ng-disabled=\"data.gridFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFt.ixIsLoading\" data-ng-click=\"addRow(data.gridFt)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridFt.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/GestionFichasTecnicasCard.html","<style>\r\n	.listEditResult {\r\n    border-bottom: none;\r\n    padding: inherit;\r\n	}\r\n</style>\r\n<div class=\"row\" style=\"position:relative;padding: 10px 30px;border-bottom: 1px solid #e5e5e5\">\r\n	<div class=\"col-md-1\">\r\n		<span><i class=\"fa fa-{{item.icono}} icono-ficha-tecnica\"></i></span>\r\n	</div>\r\n	<div class=\"col-md-9\">\r\n		<div class=\"table\">\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\" style=\"width: 36px\">\r\n					<span ng-show=\"item.nivel1\"><strong>{{ item.nivel1 }}<span ng-show=\"item.nivel2\">.{{ item.nivel2 }}<span ng-show=\"item.nivel3\">.{{ item.nivel3 }}</span></span> -</strong></span>\r\n				</div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2\"><strong class=\"uppercase\">{{item.titulo1}}</strong></span>\r\n					<span ng-if=\"item.nivel2\"><strong class=\"uppercase\">{{item.titulo2}}</strong></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2 && (item.titulo2 || item.titulo2_valor)\"><strong>{{ item.titulo2 }}</strong>{{item.titulo2_valor}}<br></span>\r\n					<span ng-if=\"item.titulo3 || item.titulo3_valor\"><strong>{{ item.titulo3 }}</strong>{{item.titulo3_valor}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}} de {{item.titulo4_valor2}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}<br></span>\r\n					<span ng-if=\"item.titulo6 || item.titulo6_valor\"><strong>{{ item.titulo6 }}</strong>{{item.titulo6_valor}}<br></span>\r\n				</div>\r\n			</div>\r\n			<!--<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.nivel2nombre\">Preguntas: {{item.nc_preguntas}}/{{item.nt_preguntas}}<br/></span>\r\n				</div>\r\n			</div>-->\r\n		</div>\r\n	</div>\r\n	<div class=\"col-md-2\" style=\"height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0\">\r\n		<div class=\"table\" style=\"top:25%; position:relative\">\r\n			<div class=\"table-row\">\r\n				<!-- <div class=\"table-cell\">\r\n					<span><i class=\"fa fa-{{item.icono_cabecera}} icono-ficha-tecnica\"></i></span>\r\n				</div> -->\r\n				<div class=\"table-cell\" ng-if=\"item.nivel1 || item.icono == \'home\' || item.icono == \'industry\' || item.icono == \'paperclip\'\">\r\n					<!-- Solo se verá con un perfil de biotecnal, además, los botones tendrán enlazada una función ng-click -->\r\n					<span ng-show=\"tienePerfilAdmin() && !item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,1)\"><i class=\"material-icons icono-ficha-tecnica\">lock_open</i></span>\r\n					<span ng-show=\"tienePerfilAdmin() && item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,0)\"><i class=\"material-icons icono-ficha-tecnica\">lock</i></span>\r\n				</div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.alarma\"><i style=\"color: red\" class=\"material-icons icono-ficha-tecnica alarma\" title=\"{{item.alarma_info}}\">warning</i></span>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n<div class=\"listEditResult detalles\" ng-repeat=\"item in item.subniveles\" style=\"padding: 0px 0px 0px 10px\" ng-style=\"{\'background-color\':item.color}\" ng-click=\"selectItem(item, $event);$event.stopPropagation();\" ng-show=\"!item.ToDelete\" ng-include=\"module + entity+\'/\'+entity+\'Card.html\'\" ng-class=\"{\'bg-info\':angular.equals(item,current) || (data.datos[data.pk] && (data.datos[data.pk] == item[data.pk] || data.datos[data.pk] == item[data.listpk])), \'recordDisabled\': (item.activo == 0 || item.estado == 0), \'visible\': (item.visible), \'error-tarjeta\': (item.error) }\"></div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/GestionFichasTecnicasForm.html","<style>\r\n\r\n	.ui-grid-row{\r\n		height: auto!important;\r\n		min-height:39px\r\n	}\r\n\r\n	.ui-grid-render-container-body .ui-grid-viewport {\r\n/*		height: auto !important;*/\r\n		min-height:70px;\r\n	}\r\n\r\n	.ui-grid-row   > div {\r\n		display: table-row;\r\n\r\n	}\r\n\r\n	.ui-grid-row > div .ui-grid-cell {\r\n		display: table-cell;\r\n		float: none;\r\n		vertical-align: middle;\r\n		/*height: auto!important;*/\r\n		min-height:40px;\r\n	}\r\n\r\n	.ui-grid-cell-contents{\r\n		line-height: 16px !important;\r\n		white-space: normal;\r\n		text-overflow: inherit;\r\n		word-break: break-word;\r\n	}\r\n\r\n	.ui-grid-cell-contents .ui-select-match-item span {\r\n		white-space: normal !important;\r\n	}\r\n\r\n\r\n	.ui-grid-draggable-row {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-draggable-row > div.ui-grid-row-header-cell {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-cell-contents.ui-grid-disable-selection {\r\n		height: 38px !important;\r\n	}\r\n\r\n</style>\r\n<div ng-controller=\"GestionFichasTecnicasController\">\r\n	<ix-tool-bar>\r\n		<div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\" ng-show=\"!extranetUser.laboratorio\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-show=\"(!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente && !pantallaBasePorProducto())\" ng-click=\"versionarFt()\"><a>Versionar ficha técnica</a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tienePerfilRestringido()\" ng-click=\"duplicarFt(2)\"><a>Duplicar niveles</a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tienePerfilRestringido()\" ng-click=\"duplicarFt(0)\"><a>Duplicar ficha técnica</a></li>\r\n		<hr ng-show=\"!tienePerfilRestringido()\">\r\n		<li role=\"menuitem\" ng-click=\"imprimirFt(\'PDF\',0)\"><a>Imprimir ficha ténica PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"imprimirFt(\'PDF\',1)\"><a>Imprimir ficha ténica reducida PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',0)\" ng-show=\"!extranetUser.laboratorio\"><a>Imprimir ficha ténica word</a></li>\r\n		<li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',1)\" ng-show=\"!extranetUser.laboratorio\"><a>Imprimir ficha técnica reducida word</a></li>\r\n		<li role=\"menuitem\" ng-click=\"imprimirFtRevision()\" ng-show=\"permiteImprimirFtRevision()\"><a>Imprimir ficha revisión</a></li>\r\n		<li role=\"menuitem\" ng-click=\"control_errores_transformacion()\" ng-show=\"permiteControlTransformacion()\"><a>Controlar errores transformacion</a></li>\r\n		<hr ng-show=\"data.modoTraduccion\">\r\n		<!-- <li role=\"menuitem\" ng-show=\"tienePerfilAdmin() && data.modoTraduccion && data.datos.estado_traduccion != \'P\'\" ng-click=\"cambioEstadoTraduccion(\'P\')\"><a>Volver traducción a pendiente</a></li>\r\n		<li role=\"menuitem\" ng-show=\"tienePerfilAdmin() && data.modoTraduccion && data.datos.estado_traduccion == \'C\'\" ng-click=\"cambioEstadoTraduccion(\'V\')\"><a>Validar traducción</a></li> -->\r\n		<li role=\"menuitem\" ng-click=\"soloPreguntasPdt()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver solo preguntas pendientes de traducir</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"soloCardsPdt()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver solo tarjetas pendientes de traducir</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"verTodasCards()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver todo</translate></a></li>\r\n      </ul>\r\n    </div>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectNextPage()\" uib-tooltip=\"Siguiente\" ng-disabled=\"isLast()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-right\"></i> <translate class=\"ng-scope\">Siguiente</translate></button>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectPreviousPage()\" uib-tooltip=\"Anterior\" ng-disabled=\"isFirst()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-left\"></i> <translate class=\"ng-scope\">Anterior</translate></button>\r\n		<button class=\"btn pull-right\" ng-show=\"!tienePerfilRestringido() && data.datos.ft_cabecera.estado == \'O\' && !data.modoTraduccion\" ng-click=\"confirmarCumplimentacion()\" uib-tooltip=\"Finalizar cumplimentación\" tooltip-placement=\"bottom\"><i class=\"fa fa-check\"></i> <translate class=\"ng-scope\">Finalizar</translate></button>\r\n		<!-- <button class=\"btn pull-right\" ng-show=\"data.modoTraduccion && data.datos.estado_traduccion == \'P\'\" ng-click=\"cambioEstadoTraduccion(\'C\')\" uib-tooltip=\"Finalizar traducción\"  tooltip-placement=\"bottom\"><i class=\"fa fa-check\"></i> <translate class=\"ng-scope\">Finalizar traducción</translate></button> -->\r\n	</ix-tool-bar>\r\n\r\n	<div ng-scrollbars ng-scrollbars-config=\"scrollBarConfig\" class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-class=\"{ \'multi-ft\': data.id_fichas_tecnicas }\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<uib-tabset ng-if=\"data.id_fichas_tecnicas\" class=\"ix-tabs multi-ft no-margin-bottom\" active=\"data.activeTabFichaTecnica\">\r\n					<uib-tab ng-repeat=\"ficha_tecnica in data.id_fichas_tecnicas track by $index\" index=\"$index\" heading=\"{{ ficha_tecnica }}\" translate-attr=\"heading\" select=\"cambiarFicha(ficha_tecnica, $index)\">\r\n					</uib-tab>\r\n				</uib-tabset>\r\n\r\n				<!-- Si la tarjeta es de tipo Cabecera-->\r\n				<div ng-if=\"data.pantalla == \'cabecera\'\">\r\n					<div class=\"row\">\r\n						<ix-select ng-if=\"data.modoTraduccion\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadEstadosTraduccion\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n						<!-- <ix-select ng-if=\"data.modoTraduccion && data.datos.traducir_completa == 1\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" entity=\"ft_estados_traduccion\" pk=\"codigo\" desc=\"descripcion\" loadFunction=\"loadEstadosTraduccion()\" conditions=\"[{ field: \'codigo\', value: \'V\', op: \'0\', not: true }]\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select> -->\r\n						<!-- <ix-select ng-show=\"data.modoTraduccion && data.datos.traducir_completa == 0\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" entity=\"ft_estados_traduccion\" pk=\"codigo\" desc=\"descripcion\" conditions=\"[{ field: \'codigo\', value: \'W\', op: \'0\', not: true }]\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select> -->\r\n						<div ng-show=\"tienePerfilAdmin()\">\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.revisor_FT\" name=\"Revisor FT\" entity=\"usuarios_RevisorVM\" pk=\"usuario\" desc=\"user_nombre\" append-to-body=\"true\" ng-disabled=\"!status.editing\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n						</div>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.titulo\" name=\"Título\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\"></ix-text>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha\" name=\"Fecha creación\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-select ng-model=\"data.datos.ft_cabecera.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\" on-select=\"marcarRecargaFicherosProveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\"></ix-select>\r\n						<ix-select ng-model=\"data.datos.ft_cabecera.cliente\" name=\"Cliente Master\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n						<!--<ix-select-multiple ng-model=\"data.datos.ft_cabecera.clientesasociados\" name=\"Clientes asociados\" pk=\"codigo\" desc=\"nombre\" load-function=\"loadClientes\" append-to-body=\"true\" ng-disabled=\"!status.editing\" ix-focus-out=\"ixGuardar\"></ix-select-multiple>-->\r\n						<ix-select ng-if=\"data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.ft_version\" name=\"Tipo\" entity=\"ft_versiones_idioma\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"true\"></ix-select>\r\n						<ix-select ng-if=\"!data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.ft_version\" name=\"Tipo\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"true\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.familia\" name=\"Familia\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.ft_componentes\" name=\"Componentes\" ng-disabled=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.comentarios\" name=\"Comentarios\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-select ng-show=\"!data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.estado\" name=\"Estado\" entity=\"ft_estados\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\"></ix-select>\r\n						<ix-select ng-show=\"data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.estado\" name=\"Estado\" entity=\"ft_estados_idioma\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ix-number ng-show=\"(!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente) || (extranetUser.cliente == 1031)\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_aprobada\" name=\"Fecha aprobación\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_revision\" name=\"Fecha revisión\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_baja\" name=\"Fecha baja\" ng-disabled=\"true\"></ix-date>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdmin() && !data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.traducible\" name=\"Traducible\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-options-si-no ng-if=\"!data.modoTraduccion\" ng-model=\"data.datos.traducir_completa\" name=\"Traducir completa\" ng-disabled=\"!tienePerfilAdmin() || (!status.editing && tienePerfilAdmin())\"></ix-options-si-no>\r\n					</div>\r\n					<div class=\"row\" style=\"border: 2px solid red\" ng-if=\"!data.modoTraduccion && (tienePerfilAdmin() || extranetUser.proveedor) && false\">\r\n						<div class=\"col-md-8\">\r\n							<p><translate>Nota compromiso proveedor</translate></p>\r\n						</div>\r\n						<div class=\"col-md-4\">\r\n							<ix-options-si-no ng-model=\"data.datos.ft_cabecera.aceptacion_compromiso_proveedor\" name=\"Aceptado\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						</div>\r\n					</div>\r\n					<br ng-if=\"!data.modoTraduccion && (tienePerfilAdmin() || extranetUser.proveedor)\">\r\n					<div class=\"row\" ng-if=\"tienePerfilAdmin() && !data.modoTraduccion\">\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_inicial\" name=\"Revisión inicial\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_final\" name=\"Revisión final\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.notificacion_proveedor\" name=\"Notificación proveedor\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.revision_etiquetado\" name=\"Revisión etiquetado\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"loadRevisionEtiquetado\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n						</div>\r\n					</div>\r\n					<div style=\"width:100%\" ng-if=\"data.gridProductosFT\">\r\n						<div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridProductosFT.ixIsLoading && !tieneCabeceraRestringida() && !data.modoTraduccion\" data-ng-disabled=\"data.gridProductosFT.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridProductosFT)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridProductosFT.ixIsLoading && !tieneCabeceraRestringida() && !data.modoTraduccion\" data-ng-click=\"addRow(data.gridProductosFT)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridProductosFT\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridProductosFT.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n						<div class=\"pull-left\" ng-show=\"status.editing\">\r\n								{{data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n								{{data.gridProductosFT.deletedRows.length}} filas eliminadas\r\n								{{data.gridProductosFT.insertedRows.length}} filas creadas\r\n								{{data.gridProductosFT.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n						</div>\r\n					</div>\r\n				</div>\r\n\r\n				<!-- Si la tarjeta es de tipo Ficheros -->\r\n				<div ng-if=\"data.pantalla == \'ficheros\'\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabFicheros\">\r\n						<uib-tab index=\"0\" heading=\"Ficheros de ficha técnica\" translate-attr=\"heading\" select=\"changeTabFicheros(0)\">\r\n							<div style=\"width:100%\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"!data.gridFicherosFT.ixIsLoading && !tienePerfilRestringido() && data.datos.ft_cabecera.bloqueo_datos_ficheros == 0\" data-ng-disabled=\"data.gridFicherosFT.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicherosFT, true)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"!data.gridFicherosFT.ixIsLoading && !tienePerfilRestringido() && data.datos.ft_cabecera.bloqueo_datos_ficheros == 0\" data-ng-click=\"openPopupFicheros(data.gridFicherosFT, \'ficheros_ft\')\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicherosFT\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicherosFT.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n								<div class=\"pull-left\" ng-show=\"status.editing\">\r\n										{{data.gridFicherosFT.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n										{{data.gridFicherosFT.deletedRows.length}} filas eliminadas\r\n										{{data.gridFicherosFT.insertedRows.length}} filas creadas\r\n										{{data.gridFicherosFT.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n						<uib-tab index=\"1\" heading=\"Ficheros del proveedor\" translate-attr=\"heading\" select=\"changeTabFicheros(1)\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridFicherosProveedor\">\r\n								<div data-ui-grid=\"data.gridFicherosProveedor\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicherosProveedor.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n								<div class=\"pull-left\" ng-show=\"status.editing\">\r\n										{{data.gridFicherosProveedor.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n										{{data.gridFicherosProveedor.deletedRows.length}} filas eliminadas\r\n										{{data.gridFicherosProveedor.insertedRows.length}} filas creadas\r\n										{{data.gridFicherosProveedor.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n\r\n			<!-- Si la tarjeta es de tipo Datos Proveedor -->\r\n				<div ng-show=\"data.pantalla == \'proveedor\'\">\r\n					<div style=\"width:100%\" ng-if=\"data.gridPlantasFabricante\">\r\n						<!-- <button class=\"btn btn-primary\" ng-click=\"guardarProveedores()\">Aplicar cambios</button> -->\r\n						<button class=\"btn btn-primary\" ng-click=\"openProveedor()\">Detalles proveedor</button>\r\n						<div data-ui-grid=\"data.gridPlantasFabricante\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridPlantasFabricante.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n						<div class=\"pull-left\">\r\n								{{data.gridPlantasFabricante.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'comentarios\'\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabComentarios\">\r\n						<uib-tab index=\"0\" heading=\"Comentarios\" translate-attr=\"heading\" select=\"changeTabComentarios(0)\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridComentariosFt\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-disabled=\"data.gridComentariosFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridComentariosFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-click=\"addRowComentarioFt(data.gridComentariosFt,0)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridComentariosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridComentariosFt.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n						<uib-tab index=\"1\" heading=\"Comentarios Internos\" translate-attr=\"heading\" select=\"changeTabComentarios(1)\" ng-if=\"tienePerfilAdmin()\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridComentariosInternosFt\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosInternosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-disabled=\"data.gridComentariosInternosFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridComentariosInternosFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosInternosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-click=\"addRowComentarioFt(data.gridComentariosInternosFt,1)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridComentariosInternosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridComentariosInternosFt.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'log\'\">\r\n					<div class=\"row\">\r\n						<!-- <div class=\"col-md-8\"></div> -->\r\n						<div class=\"col-md-12\">\r\n							<button class=\"btn btn-default\" ng-click=\"descargarExcelLog()\">Descargar Excel</button>\r\n						</div>\r\n					</div>\r\n					<div style=\"width:100%\" ng-if=\"data.gridCambioDatosFt\">\r\n						<div data-ui-grid=\"data.gridCambioDatosFt\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridCambioDatosFt.ixIsloading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/HomologacionPlantas/editar_auditoria_planta.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar datos auditoría\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <ng-form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-model=\"data.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" on-select=\"limpiarPlanta\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-select ng-model=\"data.datos.planta\" name=\"Planta\" entity=\"plantas\" pk=\"planta\" desc=\"nombre_planta\" load-function=\"cargarPlantasProveedor\" ng-required=\"true\" ng-disabled=\"!status.editing || !data.proveedor\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-select ng-model=\"data.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-text-area ng-model=\"data.datos.alcance\" name=\"Alcance\" rows=\"5\" ng-show=\"data.categoria == 1\" ng-required=\"data.categoria == 1\"></ix-text-area>\r\n              <ix-select ng-model=\"data.datos.tipo\" name=\"Tipo\" entity=\"tipos_auditorias_plantas\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'categoria\',value: data.categoria}]\" ng-required=\"true\" ng-disabled=\"!status.editing || !data.categoria\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-date ng-model=\"data.datos.fecha_realizacion\" name=\"Fecha realización\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-date>\r\n              <ix-select ng-model=\"data.datos.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"data.datos.resultado_auditoria\" name=\"Resultado (%)\" ix-number with-decimals=\"2\" min-value=\"0.00\" max-value=\"100.00\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\"></ix-text>\r\n              <ix-text ng-model=\"data.datos.proxima_auditoria\" name=\"Próxima auditoría\" ix-number ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\"></ix-text>\r\n              <ix-text-area ng-model=\"data.datos.comentarios\" name=\"Comentarios\" rows=\"3\"></ix-text-area>\r\n              <ix-options-si-no ng-model=\"data.datos.verificacion\" name=\"Verificado\"></ix-options-si-no>\r\n              <div class=\"row\" ng-if=\"data.isNew\">\r\n                <div class=\"col-md-12\">\r\n                  <div ngf-drop ngf-select ng-model=\"data.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\">\r\n                  <translate>Arrastrar o hacer click para adjuntar documento</translate>\r\n                  </div>\r\n                  <ul>\r\n                    <li ng-repeat=\"f in data.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n                  </ul>\r\n                  </div>\r\n              </div>\r\n              <div class=\"row\" ng-if=\"!data.isNew\">\r\n                <h5><translate>Documentos adjuntos</translate></h5>\r\n                <hr>\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"btn-toolbar\">\r\n                    <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"true\" ng-disabled=\"data.gridDocs.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedDocs()\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n                      <i class=\"fa fa-trash-o\"></i>\r\n                    </button>\r\n                    <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"true\" data-ng-click=\"addDoc()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\">\r\n                      <i class=\"fa fa-plus\"></i>\r\n                    </button>\r\n                  </div>\r\n                  <div data-ui-grid=\"data.gridDocs\" ng-if=\"data.gridDocs\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                    <div class=\"grid-loading\" ng-if=\"data.gridDocs.ixIsLoading\">\r\n                      <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/HomologacionPlantas/listado_control_homologacion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <button ng-if=\"data.permisoSubirCertificado\" id=\"acciones-button\" uib-tooltip=\"Crear nuevo certificado\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openCertificado()\">\r\n        <i class=\"fa fa-plus\"></i> Nuevo certificado\r\n    </button>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Crear nueva auditoría\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openEditAuditoria()\">\r\n        <i class=\"fa fa-plus\"></i> Nueva auditoría\r\n    </button>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <uib-accordion close-others=\"oneAtATime\">\r\n            <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n              <fieldset class=\"form-data-filter\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-4\">\r\n                    <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Sólo datos vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </uib-accordion>\r\n      </form>\r\n      <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.grid_control_homologacion\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_control_homologacion\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.grid_control_homologacion.ixIsLoading\">\r\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n      </div>\r\n      <div>\r\n          <div class=\"footer\">\r\n              <div ix-datetime-grid-generada grid=\"data.grid_control_homologacion\"></div>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/HomologacionPlantas/listado_resumen_homologacion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga de los ficheros seleccionados\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        Descarga Masiva<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"descargarFicherosSeleccionados()\"><a>Descargar ficheros de lineas seleccionadas</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Plantas activas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.solo_exclusivas\" name=\"Sólo FT exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.grid_resumen_homologacion\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_resumen_homologacion\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.grid_resumen_homologacion.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.grid_resumen_homologacion\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Herramientas/cambio_estado_masivo.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar></ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n          <div id=\"hot-container\" style=\"height:600px\">\r\n              <hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n                  <hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\" type=\"column.type\" value=\"column.value\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n              </hot-table>\r\n          </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/Herramientas/eans_cod_interno_masivo.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar></ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n          <div id=\"hot-container\" style=\"height:600px\">\r\n              <hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n                  <hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\" type=\"column.type\" value=\"column.value\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n              </hot-table>\r\n          </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/ListadosFT/busqueda_avanzada.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div ng-if=\"!ocultarSelAsociados\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <uib-accordion close-others=\"oneAtATime\">\r\n          <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n            <fieldset class=\"form-data-filter\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                  <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\"></ix-select-multiple>\r\n                </div>\r\n                <div class=\"col-md-4\"></div>\r\n                <div class=\"col-md-4\"></div>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n        </uib-accordion>\r\n      </form>\r\n      </div>\r\n    <div style=\"width:100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.gridBusqueda\" ng-style=\"{\'height\': (!ocultarSelAsociados) ? ((filterStatus.isCollapsed) ? \'calc(100vh - 300px)\' : \'calc(100vh - 220px)\') : \'calc(100vh - 160px)\' }\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridBusqueda.ixIsLoading\">\r\n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridBusqueda\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/carga_ficheros_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Carga Ficheros\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Cargar ficheros<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"guardarFichero()\"><a>Guardar</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-show=\"status.transitionend\">\r\n\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <!-- <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\"\r\n                  ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                  <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                </div>\r\n                <ul>\r\n                  <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n  \r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion> -->\r\n      <div class=\"panel-default\">\r\n        <fieldset>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\">\r\n              <ix-select ng-model=\"seleccion.tipoSeleccionadoFt\" name=\"Tipo archivo\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\" on-select=\"tipoArchivoSeleccionado\" append-to-body=\"true\" ng-required=\"true\" load-function=\"loadTiposFicheroFT\">\r\n              </ix-select>\r\n              <ix-date ng-model=\"seleccion.inicioValidez\" name=\"Inicio validez\" ng-disabled=\"false\" append-to-body=\"true\">\r\n              </ix-date>\r\n              <ix-date ng-model=\"seleccion.fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"false\" append-to-body=\"true\" ng-required=\"caducidad_obligatoria\"></ix-date>\r\n            </div>\r\n            <div class=\"col-md-8\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                  <div ngf-drop ngf-select ng-model=\"seleccion.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                    <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <ul>\r\n                    <li ng-repeat=\"f in seleccion.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}\r\n                    </li>\r\n                  </ul>\r\n                  <button class=\"btn btn-danger\" ng-click=\"seleccion.archivosToUpload = null\" ng-show=\"seleccion.archivosToUpload\">Borrar</button>\r\n                </div>\r\n                <div class=\"col-md-4\"></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </form>\r\n\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridProductosFt\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': \'calc(100vh - 310px)\' }\" data-ui-grid=\"data.gridProductosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridProductosFt.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridProductosFt\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/control_presencia_fotos.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-options-si-no ng-model=\"data.filtro.ft_activas\" name=\"Visializar sólo FT activas\" is-filter=\"true\"></ix-options-si-no>\r\n                            </div>\r\n                            <div class=\"col-md-4\"></div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div ng-if=\"data.grid_control_fotos\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_control_fotos\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.grid_control_fotos.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.grid_control_fotos\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/descarga_informes_analiticas.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Descargar informes\" is-open=\"true\" is-disabled=\"true\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-p name=\"Lista de EANs, un EAN por línea\"></ix-p>\r\n                                <br>\r\n                                <textarea ng-model=\"data.listEans\" style=\"width:100%\" rows=\"15\"></textarea>\r\n                            </div>\r\n                            <div class=\"col-md-4\">\r\n                                <ix-date ng-model=\"data.fecha_inicio\" name=\"Fecha inicio\"></ix-date>\r\n                                <ix-date ng-model=\"data.fecha_fin\" name=\"Fecha fin\"></ix-date>\r\n                            </div>\r\n                            <div class=\"col-md-4\">\r\n                                <ix-options-si-no ng-model=\"data.checkInformesEnsayo\" name=\"Informes de ensayo\">\r\n                                </ix-options-si-no>\r\n                                <ix-options-si-no ng-model=\"data.checkInformesEtiquetado\" name=\"Informes de etiquetado\">\r\n                                </ix-options-si-no>\r\n                                <ix-options-si-no ng-model=\"data.checkInformesPosicionamiento\" name=\"Informes de posicionamiento\">\r\n                                </ix-options-si-no>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-11\">\r\n                                <button class=\"btn btn-primary pull-right\" ng-click=\"descargarInformes()\">\r\n                                    <translate>Descargar informes</translate>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_analiticas_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Subir fotos\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"abrirPopupAnalitica(true)\" ng-show=\"extranetUser.cliente\">\r\n      <i class=\"fa fa-plus\"></i> Nueva planificación\r\n    </button>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <!-- <h4>Periodo Inicio</h4> -->\r\n                <ix-select ng-model=\"data.filtro.start_month\" name=\"Periodo inicio - Mes\" entity=\"meses\" pk=\"mes\" desc=\"mes_nombre\"></ix-select>\r\n                <ix-text ng-model=\"data.filtro.start_year\" name=\"Periodo inicio - Año\" ix-number is-filter=\"true\"></ix-text>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <!-- <h4>Periodo final</h4> -->\r\n                <ix-select ng-model=\"data.filtro.end_month\" name=\"Periodo final - Mes\" entity=\"meses\" pk=\"mes\" desc=\"mes_nombre\"></ix-select>\r\n                <ix-text ng-model=\"data.filtro.end_year\" name=\"Periodo final - Año\" ix-number is-filter=\"true\"></ix-text>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.exclusivas\" name=\"Fichas Técnicas exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridft_analiticas\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 365px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridft_analiticas\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridft_analiticas.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridft_analiticas\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_cambio_estados_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" name=\"Proveedor\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-2\">\r\n                <ix-date ng-model=\"data.filtro.fecha_inicio\" name=\"Desde\"></ix-date>\r\n                <ix-date ng-model=\"data.filtro.fecha_fin\" name=\"Hasta\"></ix-date>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" data-ui-grid=\"data.gridCambioEstadosFt\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 350px)\' : \'calc(100vh - 230px)\' }\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridCambioEstadosFt.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridCambioEstadosFt\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_control_envio_obs_alergenos_app.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n        <!-- <button id=\"editar-button\" ng-show=\"!data.grid_envio_obs.ixEditar\" uib-tooltip=\"Marcar/desmarcar envío observaciones\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"setEditar()\" >\r\n            Editar\r\n        </button>\r\n        <button id=\"guardar-button\" ng-show=\"data.grid_envio_obs.ixEditar\" uib-tooltip=\"Guardar cambios\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"marcar_envios()\" >\r\n            Guardar\r\n        </button> -->\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div class=\"grid full-ui-grid\" data-ui-grid=\"data.grid_envio_obs\" data-ui-grid-cellnav data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.grid_envio_obs.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.grid_envio_obs\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_emd_fichas_seguridad.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"descargaMasivaArchivos()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar líneas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedores\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-show=\"!extranetUser.proveedor\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipos_ficheros\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\" name=\"Tipo fichero\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.exclusivas\" name=\"Sólo exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.vigentes\" name=\"Sólo archivos vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridFicheros\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 365px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridFicheros\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridFicheros\"></div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_ft.html","<style>\r\n  .row-alarm {\r\n  background-color: rgb(255, 116, 108) !important;\r\n}\r\n  .row-ok {\r\n  background-color: rgb(178, 251, 165) !important;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n		<div ng-if=\"status.filtered\" class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <!-- <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled || status.blockUIBtns\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button> -->\r\n      <!-- <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-class=\"{\'disabled\': getSelectedRows().length == 0 }\"><a ng-click=\"abrirMultiplesFichasTecnicas()\">Abrir múltiples fichas técnicas</a></li>\r\n      </ul> -->\r\n    </div>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Crear nueva ficha técnica\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openAddFtPopup()\" ng-show=\"status.editing && !extranetUser.proveedor\">\r\n      <i class=\"fa fa-plus\"></i> Nueva FT\r\n    </button>\r\n    <button id=\"acciones-button\" class=\"btn pull-right\" ng-show=\"!(extranetUser.proveedor || extranetUser.cliente || extranetUser.laboratorio)\" ng-click=\"EliminarFtObsoletas()\">Eliminar Obsoletas</button> \r\n\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"herramientas\" ng-show=\"!(extranetUser.proveedor || extranetUser.cliente || extranetUser.laboratorio)\">\r\n      <button class=\"btn\" uib-dropdown-toggle ng-disabled=\"data.gridFichasTecnicas.gridApi.selection.getSelectedRows()==0 || !Herramientas()\">\r\n          Herramientas <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n          <li role=\"menuitem\" ng-click=\"VersionarMasivamente()\"><a>Versionar Masivamente</a></li>\r\n          <li role=\"menuitem\" ng-click=\"DesbloquearMasivamente()\"><a>Desbloquear Masivamente</a></li>\r\n      </ul>\r\n    </div>\r\n\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.estado\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-show=\"!extranetUser.proveedor\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n      <uib-tab index=\"0\" heading=\"Fichas técnicas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.gridFichasTecnicas\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 430px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridFichasTecnicas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridFichasTecnicas.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div>\r\n          <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridFichasTecnicas\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\" heading=\"Resumen\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div id=\"pivotFichasTecnicas\" style=\"margin:30px; overflow:auto\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_ft_fotos_producto.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga múltiple de fotos\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Descarga Fotos<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"selectVisibleRows()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"cleanSelectedRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"downloadSelectedPictures()\"><a>Descargar</a></li>\r\n      </ul>\r\n    </div>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Subir fotos\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-show=\"!hideLoadFotos\" ng-click=\"abrirPopupSubirFotos()\">\r\n      <i class=\"fa fa-plus\"></i> Subir fotos\r\n    </button>\r\n  </ix-tool-bar>\r\n  <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n    <uib-accordion close-others=\"oneAtATime\">\r\n      <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n        <fieldset class=\"form-data-filter\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\">\r\n              <ix-date ng-model=\"data.filtro.fecha_inicio\" name=\"Fecha inicio\"></ix-date>\r\n              <ix-date ng-model=\"data.filtro.fecha_fin\" name=\"Fecha fin\"></ix-date>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </uib-accordion>\r\n  </form>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridft_fotos_producto\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 340px)\' : \'calc(100vh - 225px)\' }\" data-ui-grid=\"data.gridft_fotos_producto\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridft_fotos_producto.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridft_fotos_producto\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_productos_ft.html","<style>\r\n  .row-alarm {\r\n  background-color: rgb(255, 116, 108) !important;\r\n}\r\n  .row-ok {\r\n  background-color: rgb(178, 251, 165) !important;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Acciones<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n<!--\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\"\r\n        uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Descarga masiva <span class=\"caret\"></span>\r\n-->\r\n			<button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\" ng-click=\"impresionMasivaFT()\">\r\n        Descarga masiva\r\n      </button>\r\n<!--\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'PDF\',0)\"><a>Imprimir FT PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'PDF\',1)\"><a>Imprimir FT reducida PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'MSWORD\',0)\"><a>Imprimir FT Doc</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'MSWORD\',1)\"><a>Imprimir FT reducida Doc</a></li>\r\n      </ul>\r\n-->\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <!-- <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\"\r\n                  name=\"Tipo\"></ix-select-multiple> -->\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- <ix-select-multiple ng-model=\"data.filtro.estado\" entity=\"ft_estados\" pk=\"codigo\" desc=\"descripcion\"\r\n                  name=\"Estado\"></ix-select-multiple> -->\r\n                <ix-select-multiple ng-if=\"!esPerfilVisitante()\" ng-model=\"data.filtro.estado\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-if=\"!esPerfilExport()\" ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!modificacionesRestringidas()\" ng-model=\"data.filtro.exclusivas\" name=\"Fichas Técnicas exclusivas\" is-filter=\"true\">\r\n                </ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n      <uib-tab index=\"0\" heading=\"Productos - Fichas técnicas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.gridProductosFt\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 432px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridProductosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridProductosFt.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div>\r\n          <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridProductosFt\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\" heading=\"Resumen\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div id=\"pivotProductosFt\" style=\"margin:30px; overflow:auto\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_productos_marca.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\" ng-show=\"esClienteDM() || tienePerfilAdmin()\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" name=\"Cliente\" pk=\"cliente\" desc=\"nombre\"></ix-select-multiple>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n        <!-- ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 436px)\' : \'calc(100vh - 265px)\' }\" -->\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <!-- <div class=\"grid full-ui-grid\"\r\n                ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 300px)\' : \'calc(100vh - 200px)\' }\"\r\n                data-ui-grid=\"data.gridProductosMarca\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav\r\n                data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection\r\n                data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter\r\n                data-ui-grid-validate> -->\r\n                <div class=\"grid full-ui-grid\" ng-style=\"calcularAlturaDisponible()\" data-ui-grid=\"data.gridProductosMarca\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.gridProductosMarca.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.gridProductosMarca\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_proveedores_ficheros.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n      <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n        <button uib-tooltip=\"Descarga Masiva lineas seleccionadas\" tooltip-placement=\"bottom\" class=\"btn\" ng-disabled=\"data.gridProveedoresFicheros.gridApi.selection.getSelectedRows()==0\" uib-dropdown-toggle ng-click=\"downloadMultiFile()\"><span class=\"badge\"> {{data.gridProveedoresFicheros.gridApi.selection.getSelectedRows().length}}</span>Descarga Masiva</button>\r\n      </div>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                  <fieldset class=\"form-data-filter\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-4\">\r\n                        <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Solo ficheros vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n                      </div>\r\n                      <div class=\"col-md-4\">\r\n                      </div>\r\n                      <div class=\"col-md-4\">\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </div>\r\n              </uib-accordion>\r\n        </form>\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 436px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridProveedoresFicheros\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate data-ui-grid-selection>\r\n                <div class=\"grid-loading\" ng-if=\"data.gridProveedoresFicheros.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.gridProveedoresFicheros\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/views/ftNzToggle.html","<div class=\"togglebutton manual-control form-group\">\r\n  <label class=\"{{::labelClass || \'col-md-4\'}}\">\r\n		<img style=\"width: 60px; margin-right: 5px\" ng-src=\"data:image/png;base64, {{::icono || \'R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\'}}\" title=\"{{::name}}\" ng-if=\"icono\">\r\n		{{::name}} <i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i>\r\n	</label>\r\n	<span class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<nz-toggle tri-toggle on-toggle=\"changeSelected()\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" val-true=\"\'1\'\" val-false=\"\'0\'\" val-null=\"null\"></nz-toggle>\r\n	</span>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ftTitulo.html","<div>\r\n	<div style=\"font-size: large\">\r\n		<span ng-show=\"item.nivel1\"><strong>{{ item.nivel1 }}<span ng-show=\"item.nivel2\">.{{ item.nivel2 }}<span ng-show=\"item.nivel3\">.{{ item.nivel3 }}</span></span> -</strong></span><strong class=\"uppercase\">{{item.titulo2}}</strong><span ng-show=\"item.nivel3\"><strong> {{item.titulo3}}</strong></span><br>\r\n	</div>\r\n	<strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}} de {{item.titulo4_valor2}}\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/grid_jerarquico_add_row_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{rowsGrid.length > 0 ? \'Añadir\' : \'Editar\'}} Ingrediente {{ rowsGrid.length > 0 ? \'Nuevo\' : entity.valor }}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n<!--\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n					<div class=\"row\">\r\n						<div ng-if=\"rowsGrid.length > 0\" class=\"col-md-7\">\r\n							<ix-select ng-if=\"!reload\" ng-model=\"entity.orden_bucle\" name=\"Seleccionar Nivel/Posición\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarValoresNivel\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-text ng-model=\"$parent.searchtext\" name=\"Buscar ingrediente\"></ix-text>\r\n							<ix-text ng-model=\"entity.valor\" name=\"Ingrediente\" ng-show=\"false\" ng-required=\"true\"></ix-text>\r\n							<div style=\"border:1px solid black; float:right;\" class=\"col-md-8\">\r\n								<p>Ingrediente:</p>\r\n								<div style=\"height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterItems\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div ng-class=\"{ \'col-md-5\': (rowsGrid.length > 0), \'col-md-8\': (rowsGrid.length == 0) }\">\r\n							<ft-pregunta pregunta=\"pregunta\" data=\"entity\" in-popup=\"true\" modo-traduccion=\"modoTraduccion\"></ft-pregunta>\r\n						</div>\r\n					</div>\r\n        </form>\r\n-->\r\n				<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-7\">\r\n							<ix-select ng-if=\"!reload && rowsGrid.length > 0\" ng-model=\"entity.orden_bucle\" name=\"Seleccionar Nivel/Posición\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarValoresNivel\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-text ng-model=\"searchtext\" name=\"Buscar ingrediente\"></ix-text>\r\n							<ix-text ng-model=\"entity.valor\" name=\"Ingrediente\" ng-show=\"false\" ng-required=\"true\"></ix-text>\r\n							<div style=\"border:1px solid black; float:right\" class=\"col-md-8\">\r\n								<p>Ingrediente:</p>\r\n								<div style=\"height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterItems\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div class=\"col-md-5\">\r\n							<ft-pregunta pregunta=\"pregunta\" data=\"entity\" in-popup=\"true\" modo-traduccion=\"modoTraduccion\"></ft-pregunta>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixCustomHintFt.html","<div>\r\n	<span ng-mousedown=\"copiarValorHint()\"><i class=\"fa fa-clipboard\"></i></span>\r\n	<span><translate>Texto original</translate>: </span>\r\n	<span ng-if=\"value && value != \'null\'\">{{ value }}</span>\r\n	<span ng-if=\"valueGrid\">{{ valueGrid }}</span>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixDateFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<ix-datepicker ng-model=\"ngModel\" name=\"{{name}}\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-disabled=\"ngDisabled\" append-to-body=\"appendToBody\"></ix-datepicker>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixOptionsSiNoFt.html","<div class=\"togglebutton\" abm-toggle>\r\n  <label ng-class=\"{ \'col-md-8\': textMaxWidth == true, \'col-md-4\': !textMaxWidth }\">{{::name}}<i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n  <input ng-class=\"{ \'pull-right\': textMaxWidth == true }\" ng-checked=\"estaSeleccionado == 1\" type=\"checkbox\" ng-click=\"changeSelected(ngModel)\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixSelect2Ft.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name || pk}}\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<virtual-select ng-class=\"{ \'disabled\': ngDisabled }\" choices-repeat=\"allItems\" ng-model=\"ngModel\" core-property=\"pk\" display-property=\"desc\" singleselect ng-disabled=\"ngDisabled\" custom-ng-required=\"ngRequired\" entity=\"entity\" extra-field=\"extraField\" filter-fields=\"filterFields\" preload=\"preload\" conditions=\"conditions\" load-function=\"loadFunction\" ng-default=\"ngDefault\" whole-obj=\"wholeObj\" order-string-as-int=\"orderStringAsInt\" allow-custom=\"editableDropdown\" preload-function=\"preloadFunction\" preload-obj=\"preloadObj\" preload-pk=\"preloadPk\" load-all-items=\"loadAllItems\" entity-data=\"entityData\" entity-data-pk=\"entityDataPk\" entity-data-desc=\"entityDataDesc\" append-to-body=\"appendToBody\" on-select=\"onSelect\" template=\"template\" skip-table-name-filter=\"skipTableNameFilter\" skip-table-name-order-by=\"skipTableNameOrderBy\" keep-original-value=\"keepOriginalValue\"></virtual-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixSelectMultipleFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name || pk}}\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n		<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<ui-select multiple ng-model=\"$parent.ngModel\" ng-class=\"{ \'show-always\': (editableDropdown == true ||  keepOriginalValue == true) }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\">\r\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$item[desc]}} {{ (cfg.dropdownSinCodigo) ? \"\" : \"- \"+$item[pk] }}</ui-select-match>\r\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: filtrarResultados($select)) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\r\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\r\n				<div ng-class=\"{\'invisible\': cfg.dropdownSinCodigo }\" class=\"text-muted\">{{::item[pk]}}</div>\r\n			</ui-select-choices>\r\n		</ui-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixTextAreaFt.html","<div class=\"form-group\" ng-class=\"{\'ToConfirm\': traducible && !confirmado }\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name}}<i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<span ng-show=\"traducible && customHint && ngModel\" style=\"top: 4px;position: absolute;left: 19px\">\r\n			<i ng-show=\"!confirmado\" class=\"fa fa-pencil\"></i>\r\n			<i ng-show=\"confirmado\" class=\"fa fa-check\"></i>\r\n		</span>\r\n		<textarea autosize ng-class=\"ngClass\" ng-focus=\"showCustomHint($event)\" ng-model=\"ngModel\" style=\"width:100%\" ng-required=\"ngRequired\" ng-disabled=\"ngDisabled\" maxlength=\"{{::maxLength}}\" rows=\"{{::rows}}\" cols=\"{{::cols}}\" placeholder=\"{{::placeholder}}\"></textarea>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixTextFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" ng-class=\"(ngModel2 === undefined) ? \'input-full-width\' : \'input-half-width\'\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-show=\"ngModel2 !== undefined\" ng-model=\"ngModel2\" class=\"input-half-width\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" maxlength=\"{{::maxLength2}}\" autocomplete=\"off\">\r\n	</div>\r\n	<div ng-transclude></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/previsualizar_imagen_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar Imagen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 imgContainer\">\r\n              <img class=\"slide\" style=\"width: 43%\" src=\"{{selectedImage}}\">\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(selectedImage)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/previsualizar_pdf_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\" style=\"height: 700px\">\r\n              <div class=\"some-pdf-container\" style=\"width: 100%; height: 100%\">\r\n								<pdfjs-viewer src=\"{{urlPDF}}\"></pdfjs-viewer>\r\n							</div>\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(selectedPDF)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-cell-editor-traduccion.html","<div>\r\n	<ix-custom-hint-ft on-copy-value=\"grid.appScope.changeCellValue\" row=\"row\" col=\"col\" value-grid=\"{{ grid.appScope.getCustomHint(row,col) }}\" style=\"position: fixed; background: #fff; outline: 1px solid black; padding: 4px 5px\"></ix-custom-hint-ft>\r\n	<form name=\"inputForm\">\r\n		<input type=\"INPUT_TYPE\" placeholder=\"{{ grid.appScope.getCustomHint(row,col) }}\" class=\"cell-traduccion\" ng-class=\"\'colt\' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\">\r\n	</form>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-cell-traduccion.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">\r\n    <span ng-show=\"COL_FIELD\"></span>{{COL_FIELD CUSTOM_FILTERS}}\r\n    <span ng-show=\"!COL_FIELD\" style=\"color:blue\">{{ grid.appScope.getCustomHint(row,col) }}</span>\r\n</div>");
$templateCache.put("app/FTBase/views/ui-grid-row-ft.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0), \"CellToConfirm\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 1, \"CellConfirmed\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 2 }\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-tree-row-traduccion.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ng-style=\"{\'padding-left\': grid.options.treeIndent * row.treeLevel + \'px\'}\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"tree-level-0\": (row.treeLevel == 0), \"tree-level-1\": (row.treeLevel == 1), \"tree-level-2\": (row.treeLevel == 2), \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0), \"CellToConfirm\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 1, \"CellConfirmed\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 2 }\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_niveles/ft_nivelesCard.html","<strong>Nombre: {{ item.nombre }} </strong><br>\r\n<strong>Tipo FT: {{item.version}}</strong><br>\r\n<strong>Nivel 1: {{item.nivel1}}</strong><br>\r\n<strong>Nivel 2: {{item.nivel2}}</strong><br>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_niveles/ft_nivelesForm.html","<div ng-controller=\"Ft_NivelesController\">\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n            <ix-select ng-model=\"data.datos.version\" name=\"Tipo FT\" ng-disabled=\"!status.editing\" ng-required=\"true\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n            <ix-text ng-model=\"data.datos.nivel1\" name=\"Nivel 1\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n            <ix-text ng-model=\"data.datos.nivel2\" name=\"Nivel 2\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n            <ix-text ng-model=\"data.datos.nivel3\" name=\"Nivel 3\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/ft_versionesCard.html","<strong>Tipo: {{ item.nombre }} </strong><br>\r\n<strong>Id: {{item.version}}</strong><br>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/ft_versionesForm.html","<div ng-controller=\"Ft_VersionesController\">\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Tipo\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n          </div>\r\n          <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.version)\" uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/traducciones_ft_versiones.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Versiones\" title-left-param=\"nombre\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Dashboards/Dashboard/dashboard.html","<style>\r\n	.nvd3 .nv-groups .nv-point {\r\n    stroke-opacity: 0.5 !important;\r\n    stroke-width: 10px;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar special-tool-bar=\"true\">\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-button\" ng-show=\"status.editing\" ng-disabled=\"!status.editing\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\"><a ng-click=\"addWidget()\">Añadir widget</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <!--<div class=\"page-content\" ng-if=\"status.transitionend\">-->\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n      <div class=\"page-content\" ng-show=\"status.transitionend\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <uib-accordion close-others=\"oneAtATime\">\r\n            <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n              <fieldset class=\"form-data-filter\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-4\" ng-if=\"!status.editing\">\r\n                    <ix-select ng-model=\"data.filtro.id\" entity=\"fend_config_dashboards\" pk=\"id\" desc=\"clave\" extra-field=\"asignado_a\" name=\"Dashboard\" ng-disabled=\"status.editing || status.filtered\" load-function=\"loadDashboardsUsuario\" on-select=\"onSelectDashboard\" ng-required=\"true\" conditions=\"[{field: \'modulo\', value: modulo }]\"></ix-select>\r\n                  </div>\r\n                  <div class=\"col-md-4\" ng-if=\"status.editing\">\r\n                    <ix-text ng-model=\"data.filtro.nombre_dashboard\" name=\"Dashboard\" ng-required=\"true\"></ix-text>\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                    <ix-select ng-model=\"data.filtro.nivel_acceso\" name=\"Nivel de acceso\" pk=\"acceso\" desc=\"nombre\" load-function=\"loadNivelesAcceso\" load-all-items=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n										<ix-select ng-if=\"data.filtro.nivel_acceso == \'u\' && data.dashboardsEdit == 2\" ng-model=\"data.filtro.usuario\" name=\"Usuario\" entity=\"api_usuarios\" pk=\"usuario\" desc=\"usuario\" conditions=\"[{field:\'activo\',value:1},{field:\'client_id\', value:cfg.clientId}]\" ng-disabled=\"!status.editing\"></ix-select>\r\n										<ix-select ng-if=\"data.filtro.nivel_acceso == \'p\' && data.dashboardsEdit == 2\" ng-model=\"data.filtro.perfil\" name=\"Perfil\" entity=\"api_perfiles\" pk=\"perfil\" desc=\"perfil\" conditions=\"[{field:\'client_id\', value:cfg.clientId}]\" ng-disabled=\"!status.editing\"></ix-select>\r\n                  </div>\r\n									<div class=\"col-md-4\">\r\n                    <ix-options-si-no ng-model=\"data.filtro.desktop\" name=\"Mostrar en Escritorio\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n										<button class=\"btn btn-primary pull-right\" style=\"margin-right:13px\" ng-click=\"cargarWidgets()\">Actualizar</button>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </uib-accordion>\r\n        </form>\r\n        <div class=\"dashboard\">\r\n          <!-- Dashboard widgets -->\r\n          <div gridster=\"gridsterOptions\" style=\"min-height: calc(100vh - 192px)\">\r\n            <ul class=\"with-3d-shadow with-transitions\">\r\n              <li gridster-item=\"widget\" ng-repeat=\"widget in data.dashboard.widgets\">\r\n                <div class=\"box\">\r\n                    <div class=\"box-header\">\r\n                      <a class=\"widget-information\" title=\"{{ widget.explicativo }}\"><i class=\"glyphicon glyphicon-info-sign\"></i></a>\r\n                      <span class=\"h3\">{{ widget.titulo }}</span> <span class=\"h4\"> - {{ widget.subtitulo }}</span>\r\n                      <div class=\"box-header-btns pull-right\">\r\n												<button ng-if=\"!status.editing && widget.tipo == \'grid\'\" class=\"btn btn-primary\" ng-click=\"exportWidget(widget)\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n												<button ng-if=\"!status.editing\" class=\"btn btn-primary\" ng-click=\"openSettings(widget)\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\r\n                        <a ng-if=\"status.editing\" title=\"Exportar\" ng-click=\"exportWidget(widget)\"><i class=\"fa fa-file-excel-o\"></i></a>\r\n                        <a ng-if=\"status.editing\" title=\"Ajustes\" ng-click=\"openSettings(widget)\"><i class=\"glyphicon glyphicon-cog\"></i></a>\r\n                        <a ng-if=\"status.editing\" title=\"Eliminar\" ng-click=\"remove(widget)\"><i class=\"glyphicon glyphicon-trash\"></i></a>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"box-content\">\r\n                      <!-- Grafic -->\r\n                      <nvd3 class=\"small-text {{ widget.chart.options.class }}\" ng-if=\"widget.tipo != \'grid\'\" options=\"widget.chart.options\" data=\"widget.chart.data\" api=\"widget.chart.api\" config=\"config\" events=\"events\"></nvd3>\r\n                      <!-- O grid -->\r\n											<div ng-if=\"widget.tipo == \'grid\' && widget.grid\" style=\"height:inherit\">\r\n												<div style=\"height:inherit\" data-ui-grid=\"widget.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\r\n												<div class=\"footer\" style=\"position:relative;top:-20px\">\r\n													<div ix-datetime-grid-generada grid=\"widget.grid\"></div>\r\n												</div>\r\n											</div>\r\n                    </div>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  <!--</div>-->\r\n</div>\r\n");
$templateCache.put("app/FTBase/Dashboards/Dashboard/settings_animacion_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Animación\"></ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <ix-text ng-model=\"animacion_segundos\" name=\"Segundos animación\" is-filter=\"true\" ng-required=\"true\"></ix-text>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/Dashboards/Dashboard/widget_settings_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Ajustes\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n							<div ng-if=\"isEditing\">\r\n								<h4>General</h4>\r\n								<ix-select ng-model=\"formSettings.dataSource\" name=\"Fuente Datos\" pk=\"nombre\" desc=\"titulo\" on-select=\"onSelectDataSource\" load-function=\"loadDataSources\" append-to-body=\"true\" load-all-items=\"true\"></ix-select>\r\n								<ix-search-from-grid ng-model=\"formSettings.dataSource\" name=\"Fuente Datos\" entity=\"api_dashboard\" pk=\"nombre\" desc=\"titulo\" ng-disabled=\"status.editing\" on-select=\"onSelectDataSource\" conditions=\"[{ field: \'modulo\', value: modulo }]\" show-only-described-cols=\"[ \'nombre\', \'titulo\', \'subtitulo\', \'explicativo\']\">\r\n                  <i class=\"material-icons ng-binding\">dashboard</i>\r\n                </ix-search-from-grid>               \r\n                <ix-text ng-model=\"formSettings.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n								<ix-text ng-model=\"formSettings.subtitulo\" name=\"Subtítulo\" ng-required=\"true\"></ix-text>\r\n								<ix-select ng-if=\"formSettings.tipo != \'medidor_radial\' && formSettings.tipo != \'tabla\' && dataSourceObj.tipo != \'medidor_radial\' && dataSourceObj.tipo != \'tabla\'\" ng-model=\"formSettings.tipo\" pk=\"tipo\" desc=\"nombre\" name=\"Tipo\" load-function=\"loadChartTypes\" append-to-body=\"true\" load-all-items=\"true\" ng-required=\"true\"></ix-select>\r\n							</div>\r\n              <h4 ng-show=\"formSettings.filtros.length > 0\">Filtros</h4>\r\n\r\n              <span ng-repeat=\"(idx, filtro) in formSettings.filtros\">\r\n                <!-- año -->\r\n                <ix-text ng-if=\"filtro.tipo == \'anyo\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" ix-number max-value=\"2050\"></ix-text>\r\n                <!-- mes -->\r\n                <ix-text ng-if=\"filtro.tipo == \'mes\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" ix-number min-value=\"1\" max-value=\"12\"></ix-text>\r\n                <!-- periodos -->\r\n                <div ng-if=\"filtro.tipo == \'periodo\'\" class=\"manual-control form-group\">\r\n                  <label class=\"col-md-4\"><translate class=\"ng-scope ng-binding\">{{ filtro.visibleText }}</translate></label>\r\n                  <div class=\"col-md-8\">\r\n                    <input time=\"text\" ng-model=\"filtro.value\" ui-mask=\"9999-99\" model-view-value=\"true\" class=\"input-full-width\">\r\n                  </div>\r\n                </div>\r\n                <!-- texto -->\r\n                <ix-text ng-if=\"filtro.tipo == \'texto\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\"></ix-text>								\r\n\r\n								<!-- fecha -->\r\n								<ix-date ng-if=\"filtro.tipo == \'fecha\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" append-to-body=\"true\"></ix-date>\r\n\r\n                <!-- TODO: Intentar reduir els ng-if. Si quan és tipus busqueda vingués la pk i la descripcio de la base de dades ens estalviariem 2 ng-if x cada possible filtre. -->\r\n                <!-- clientes -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'cliente\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'cliente\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n                <!-- proveedores -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'proveedor\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'proveedor\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- marcas -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'marca\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'marca\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- ft_versiones -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'version\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'version\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n                <!-- materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'material\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"diccionarios_valores\" pk=\"id\" desc=\"valor\" name=\"{{ filtro.visibleText }}\" conditions=\"[{ field: \'diccionario\', value: 59 }]\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'material\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"diccionarios_valores\" pk=\"id\" desc=\"valor\" name=\"{{ filtro.visibleText }}\" conditions=\"[{ field: \'diccionario\', value: 59 }]\"></ix-select-multiple>\r\n\r\n                <!-- tipo materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'tipo_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_tipo_mat_reciclajeVM\" pk=\"tipo\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'subtipo_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_subtipo_mat_reciclajeVM\" pk=\"subtipo\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n\r\n                <!-- agrupador materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'agrupa_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_agrupa_mat_reciclajeVM\" pk=\"agrupa\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/add_elementos_saludables_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Añadir Elementos Saludables\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <span ng-show=\"listOfValues != undefined\">\r\n            <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n            <hr>\r\n          </span>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-12\">\r\n							<div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: searchfiltro }\">\r\n							</div>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/datos_fabricante_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Datos Fabricante\" title-left-param=\"cif_fabricante\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"datos_fabricante.razon_social\" name=\"Razón social\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.cif\" name=\"CIF\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.direccion\" name=\"Dirección\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.cp\" name=\"CP\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.localidad\" name=\"Localidad\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.provincia\" name=\"Provincia\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.pais\" name=\"País\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.telefono\" name=\"Teléfono\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.reg_sanitario\" name=\"Registro sanitario\" ng-disabled=\"true\"></ix-text>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/datos_planta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Datos Planta\" title-left-param=\"planta_nombre\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"datos_planta.nombre_planta\" name=\"Nombre\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.direccion\" name=\"Dirección\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.cp\" name=\"CP\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.localidad\" name=\"Localidad\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.provincia\" name=\"Provincia\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.pais\" name=\"País\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.telefono\" name=\"Teléfono\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.reg_sanitario\" name=\"Registro sanitario\" ng-disabled=\"true\"></ix-text>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_nutricionales_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Dependencia Etiquetado\" title-left-param=\"pregunta_formulario\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n	<div class=\"scrolldiv-content\">\r\n		<div class=\"modal-body\">\r\n			<!-- <div style=\"width:100%;\" ng-if=\"!tabs\">\r\n				<div class=\"btn-toolbar\" style=\"\">	\r\n					<button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-trash-o\"></i></button>\r\n					<button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"grid.ixAddRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-plus\"></i></button>\r\n				</div>\r\n				<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n					<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n						<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n					</div>\r\n				</div>\r\n			</div> -->\r\n			<div ng-if=\"tabs\">\r\n				<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"activeTabDependenciaEtiquetado\">\r\n					<uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" heading=\"{{ tab.nombre }}\" translate-attr=\"heading\" select=\"cambiarTabDependenciaEtiquetado(tab, $index)\">\r\n						<div class=\"btn-toolbar\">	\r\n							<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tab.grid.data.length == 0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteNutricionales(tab.grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n							<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada || registrosCreados || tab.grid.data.length > 0\" data-ng-click=\"addNutricionales(tab, $index)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n						</div>\r\n						<div ng-if=\"tab.grid\" class=\"full-ui-grid\" data-ui-grid=\"tab.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n							<div class=\"grid-loading\" ng-if=\"tab.grid.ixIsLoading\">\r\n								<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n							</div>\r\n						</div>\r\n					</uib-tab>\r\n				</uib-tabset>\r\n			</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_popup.html","<div>\r\n	<ix-popup-tool-bar title-left=\"Dependencia Etiquetado\" title-left-param=\"pregunta_formulario\"></ix-popup-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<div class=\"modal-body\">\r\n				<div style=\"width:100%\" ng-if=\"!tabs\">\r\n					<div class=\"btn-toolbar\">\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<!-- <button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"grid.ixAddRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-plus\"></i></button> -->\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"addRow(grid)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div ng-if=\"tabs\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"activeTabDependenciaEtiquetado\">\r\n						<uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" heading=\"{{ tab.nombre }}\" translate-attr=\"heading\" select=\"cambiarTabDependenciaEtiquetado(tab, $index)\">\r\n							<div class=\"btn-toolbar\">\r\n								<div ng-if=\"!esGridJerarquico()\">\r\n									<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tab.grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(tab.grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n								</div>\r\n\r\n								<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"addRow(tab.grid)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n							</div>\r\n							<div ng-if=\"tab.grid\" class=\"full-ui-grid\" data-ui-grid=\"tab.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-tree-view data-ui-grid-validate>\r\n								<div class=\"grid-loading\" ng-if=\"tab.grid.ixIsLoading\">\r\n									<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/duplicarFT_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Duplicar Ficha Técnica\" title-left-param=\"ft_origen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"ft_destino\" name=\"Ficha técnica destino\" ng-required=\"true\"></ix-text>\r\n          <ix-select ng-model=\"nivel1\" name=\"Nivel 1\" entity=\"ft_niveles\" pk=\"nivel1\" desc=\"nivel1\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: version},{field: \'nivel1\',value: \'1\', op: 1},{field: \'nivel2\',value: \'0\'},{field: \'nivel3\',value: \'0\'}]\" ng-show=\"nivel_duplicar > 0\" ng-required=\"nivel_duplicar > 0\" append-to-body=\"true\"></ix-select>\r\n          <ix-select ng-model=\"nivel2\" name=\"Nivel 2\" entity=\"ft_niveles\" pk=\"nivel2\" desc=\"nivel2\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: version},{field: \'nivel1\', value: nivel1},{field: \'nivel2\',value: \'0\', op: 1},{field: \'nivel3\',value: \'0\'}]\" ng-show=\"nivel_duplicar > 1\" ng-disabled=\"!nivel1\" append-to-body=\"true\"></ix-select>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar Imagen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 imgContainer\">\r\n              <img class=\"slide\" style=\"width: 43%\" ng-src=\"data:image/png;base64,{{selectedImage.imagenBase64}}\">\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile({ id: idFicheroPreview })\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\" style=\"height: 700px\">\r\n              <div class=\"some-pdf-container\" style=\"width: 100%; height: 100%\">\r\n								<pdfjs-viewer data=\"selectedPDF\"></pdfjs-viewer>\r\n							</div>\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(idFicheroPreview)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1.6;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.nota-explicativa{\r\n		margin: 1em 0 0.5em 0;\r\n		font-weight: normal;\r\n		position: relative;\r\n		text-shadow: 0 -1px rgba(0,0,0,0.6);\r\n		/* font-size: 18px; */\r\n		line-height: 30px;\r\n		background: #d15a4a;\r\n		/* background: rgba(53,86,129, 0.8); */\r\n		border: 1px solid #fff;\r\n		padding: 5px 15px;\r\n		color: white;\r\n		border-radius: 0 10px 0 10px;\r\n		box-shadow: inset 0 0 5px rgba(53,86,129, 0.5);\r\n		font-family: \'Muli\', sans-serif;\r\n	};\r\n</style>\r\n\r\n<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\"></div>\r\n            <div class=\"col-md-8\">\r\n              <!-- <input ng-disabled=\"!status.editing\" class=\"btn\" type=\"file\" ngf-select ngf-multiple=\"true\"\r\n                  ng-model=\"archivosToUpload\" name=\"archivo\" ng-required=\"true\" ngf-max-size=\"{{maxUploadFileSize}}\"\r\n                  ngf-model-invalid=\"errorFile\"> -->\r\n              <!-- <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\"\r\n                  ng-show=\"archivosToUpload\">Borrar</button> -->\r\n              <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n              </div>\r\n              <ul>\r\n                <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"nota-importante\" ng-show=\"tipoSeleccionadoFt == 28\">\r\n                <translate>Explicativo formato imágenes</translate>\r\n              </div>\r\n              <ix-select ng-model=\"tipoSeleccionadoFt\" name=\"Tipo archivo\" entity=\"tipos_fichero_ftVM\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"tipoArchivoSeleccionado\" append-to-body=\"true\" ng-required=\"true\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n              <ix-select-multiple ng-model=\"productoSeleccionado\" ng-show=\"especificar_producto\" name=\"Producto\" entity=\"ft_productos\" pk=\"id_producto\" desc=\"ean\" ng-required=\"especificar_producto\" conditions=\"[{field: \'id_ficha_tecnica\', value: id_ficha_tecnica, skip: 1}]\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select-multiple>\r\n              <ix-date ng-model=\"inicioValidez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\" ng-required=\"caducidad_obligatoria\" ng-show=\"caducidad_obligatoria\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/HomologacionPlantas/modales/uploadDocumentoAuditoriaPlanta.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar documento auditoría planta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-4\"></div>\r\n          <div class=\"col-md-8\">\r\n            <div ngf-drop ngf-select ng-model=\"data.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n            </div>\r\n            <ul>\r\n              <li ng-repeat=\"f in data.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Integraciones/Planificaciones_analiticas/planificacion_analiticas.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n		<div id=\"hot-container\" style=\"height:600px\">\r\n			<hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n				<hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n			</hot-table>\r\n		</div>\r\n  </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/add_documentos_analitica_ft_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Agregar boletín\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n        <div class=\"modal-body\">\r\n            <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <div>\r\n                            <div ngf-drop ngf-select ng-model=\"data.filesToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                                <translate>Arrastrar o hacer click aquí para subir un documento</translate>\r\n                            </div>\r\n                            <ul>\r\n                                <li ng-repeat=\"f in data.filesToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}}\r\n                                    {{f.$errorParam}}</li>\r\n                            </ul>\r\n                        </div>\r\n                        <div>\r\n                            <ix-select ng-model=\"data.datos.tipo\" name=\"Tipo de informe\" pk=\"id\" desc=\"nombre\" entity=\"tipos_boletines_analisis\" conditions=\"[{field: \'id\', value: 3,not: !(data.tipo_analisis==3) }]\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/acciones/add_ft_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Crear nueva ficha técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n						<ix-text ng-model=\"nuevaft.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"nuevaft.cliente\" name=\"Cliente Master\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" ng-required=\"true\"></ix-select>\r\n						<ix-select ng-model=\"nuevaft.ft_version\" name=\"Tipo FT\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" ng-required=\"true\"></ix-select>\r\n						<ix-text ng-model=\"nuevaft.ft_componentes\" name=\"Componentes\"></ix-text>\r\n						<ix-select ng-model=\"nuevaft.idioma\" name=\"Idioma Master\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadIdiomas\" ng-required=\"true\"></ix-select>\r\n						<ix-options-si-no ng-model=\"nuevaft.traducible\" name=\"Traducible\"></ix-options-si-no>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/analitica_ft_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Analítica\">\r\n        <button id=\"acciones-button\" uib-tooltip=\"Finalizar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"finalizar()\" ng-show=\"!$resolve.is_new && $resolve.extranetUser.laboratorio && (data.datos.estado == \'PLANIFICADO\' || data.datos.estado == \'EN CORRECCION\')\">\r\n            Finalizar\r\n        </button>\r\n    </ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n        <div class=\"modal-body\">\r\n            <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n                <div class=\"row\">\r\n                    <h4>Cabecera</h4>\r\n                    <hr>\r\n                    <!--Cabecera-->\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.id_ficha_tecnica\" name=\"Ficha técnica\" ng-disabled=\"save\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.ean\" name=\"Ean\" ng-disabled=\"save\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.marca_desc\" name=\"Marca\" ng-disabled=\"true\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.proveedor\" name=\"Proveedor\" ng-disabled=\"true\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.cod_interno\" name=\"Código interno\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.denominacion\" name=\"Denominación\" ng-disabled=\"true\"></ix-text>\r\n                        <!-- Campos a rellenar por cliente-->\r\n                        <ix-select ng-model=\"data.datos.id_laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.mes_planificacion\" name=\"Mes planificación\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos[\'año_planificacion\']\" name=\"Año planificación\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <!--Tipo analisis-->\r\n                        <ix-select ng-model=\"data.datos.tipo_analisis\" name=\"Tipo análisis\" entity=\"ft_tipo_analisis\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.parametro\" name=\"Parámetro\" ng-show=\"data.datos.tipo_analisis == 2\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.num_unidades\" name=\"Num. unidades\" ng-show=\"data.datos.tipo_analisis == 2\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <button class=\"btn btn-primary pull-right\" ng-show=\"$resolve.is_new && !save\" ng-click=\"cargarCamposLectura()\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                            Cargar\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <h4>Estado</h4>\r\n                    <hr>\r\n                    <!--Estado-->\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.estado\" name=\"Estado\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-date ng-model=\"data.datos.fecha_finalizacion\" name=\"Fecha finalización\" ng-disabled=\"true\"></ix-date>\r\n                    </div>\r\n                </div>\r\n                <div ng-show=\"!$resolve.is_new\">\r\n                    <fieldset ng-disabled=\"deshabilitarResultados()\">\r\n                        <div class=\"row\">\r\n                            <h4>Resultados</h4>\r\n                            <hr>\r\n                            <!--Resultados-->\r\n                            <div class=\"col-md-6\">\r\n                                <ix-date ng-model=\"data.datos.fecha_realizacion\" name=\"Fecha análisis\" ng-show=\"false\"></ix-date>\r\n                                <ix-text ng-model=\"data.datos.ref_analisis\" name=\"Referéncia análisis\"></ix-text>\r\n                                <ix-text ng-model=\"data.datos.ref_analisis_corregido\" name=\"Análisis corregido\" ng-disabled=\"true\"></ix-text>\r\n                                <ix-select ng-model=\"data.datos.estado_incidencia_planificacion\" name=\"Estado incidencia\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresEstadosIncidencia\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                </ix-select>\r\n                                <ix-text-area ng-model=\"data.datos.incidencias_planificacion\" name=\"Incidencias planificación\" rows=\"4\"></ix-text-area>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-6\">\r\n                                <h5>\r\n                                    Resultados analitica\r\n                                </h5>\r\n                                <hr>\r\n                                <div>\r\n                                    <!--Resultados analitica-->\r\n                                    <ix-select ng-model=\"data.datos.resultado_analisis\" name=\"Resultado analítica\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresResultados\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\" on-select=\"cleanValues\">\r\n                                    </ix-select>\r\n                                </div>\r\n                                <div ng-show=\"data.datos.resultado_analisis == \'NO CONFORME\' || data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                                    <ix-select-multiple ng-model=\"data.datos.desviacion_analisis\" name=\"Desviaciones analítica\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_desviaciones_analiticas\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select-multiple>\r\n                                    <ix-text-area ng-model=\"data.datos.descripcion_desviacion_analisis\" name=\"Descripción detallada de las desviaciones\" rows=\"4\">\r\n                                    </ix-text-area>\r\n                                    <ix-select-multiple ng-model=\"data.datos.acciones_analisis\" name=\"Acciones correctoras\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_acciones_correctoras\" ng-disabled=\"deshabilitarResultados()\" ng-show=\"data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                                    </ix-select-multiple>\r\n                                </div>\r\n                                <!-- PARA TIPO ANÁLISIS SOMMELIER -->\r\n                                <div ng-show=\"data.datos.tipo_analisis == 5\">\r\n                                    <ix-select ng-model=\"data.datos.puntuacion_vinos\" name=\"Puntuación\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPuntuacionVinos\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                    <ix-text-area ng-model=\"data.datos.valoracion_sensorial\" name=\"Valoración sensorial\" rows=\"4\"></ix-text-area>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"col-md-6\">\r\n                                <h5>\r\n                                    Resultados etiquetado\r\n                                </h5>\r\n                                <hr>\r\n                                <!--Resultados etiquetado-->\r\n                                <ix-select ng-model=\"data.datos.resultado_etiquetado\" name=\"Resultado etiquetado\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresResultados\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                </ix-select>\r\n                                <div>\r\n                                    <div ng-show=\"data.datos.resultado_etiquetado == \'INCORRECTO\'\">\r\n                                        <ix-select-multiple ng-model=\"data.datos.desviacion_etiquetado\" name=\"Desviaciones etiquetado\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_desviaciones_etiquetados\" ng-disabled=\"deshabilitarResultados()\">\r\n                                        </ix-select-multiple>\r\n                                        <ix-text-area ng-model=\"data.datos.descripcion_desviacion_etiquetado\" name=\"Descripción detallada de las desviaciones\" rows=\"4\"></ix-text-area>\r\n                                    </div>\r\n                                    <ix-text-area ng-model=\"data.datos.error_ft\" name=\"Error FT\" rows=\"4\"></ix-text-area>\r\n                                    <ix-select ng-model=\"data.datos.revision_nutriscore\" name=\"Revisión Nutriscore\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresRevisionNutriscore\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                    <ix-select ng-model=\"data.datos.puntuacion_nutriscore\" name=\"Puntuación Nutriscore\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPuntuacionNutriscore\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                </div>\r\n\r\n                                <ix-text-area ng-if=\"data.datos.estado != \'PLANIFICADO\' && data.datos.estado != \'EN CORRECCION\'\" ng-model=\"data.datos.revision_online\" name=\"Revisión OnLine\" rows=\"4\">\r\n                                </ix-text-area>\r\n                                <ix-select-multiple ng-if=\"data.datos.estado == \'PLANIFICADO\' || data.datos.estado == \'EN CORRECCION\'\" ng-model=\"data.datos.revision_online\" name=\"Revisión OnLine\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_valores_revision_online\">\r\n                                </ix-select-multiple>\r\n                            </div>\r\n                        </div>\r\n                </fieldset></div>\r\n                <div class=\"row\" ng-show=\"data.datos.tipo_analisis == 3\">\r\n                    <div class=\"col-md-12\">\r\n                        <h5>\r\n                            Valores Posicionamiento\r\n                        </h5>\r\n                        <hr>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text-area ng-model=\"data.datos.comentario_envases\" name=\"Comentario Envases\" rows=\"4\"></ix-text-area>\r\n                        <ix-text-area ng-model=\"data.datos.comentario_receta\" name=\"Comentario Receta\" rows=\"4\"></ix-text-area>\r\n                        <ix-text ng-model=\"data.datos.valoracion_producto\" name=\"Valoración producto AUCHAN\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-select ng-model=\"data.datos.tipo_estudio\" name=\"Tipo estudio\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresTiposEstudio\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                        </ix-select>\r\n                        <ix-select ng-model=\"data.datos.categorizacion\" name=\"Categorización\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresCategorizaciones\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados() || data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.valoracion_global\" name=\"Valoración global\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.intencion_compra\" name=\"Intención de compra\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\">\r\n                        </ix-text>\r\n                        <ix-select ng-model=\"data.datos.perfil_nutricional\" name=\"Perfil nutricional\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPerfilesNutricionales\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                        </ix-select>\r\n                    </div>\r\n                </div>\r\n\r\n                <div ng-show=\"!$resolve.is_new\" class=\"row\" style=\"padding: 2em 2em\">\r\n                    <div class=\"col-md-12\">\r\n                        <h5>\r\n                            Informes\r\n                        </h5>\r\n                        <hr>\r\n                    </div>\r\n                    <div class=\"col\" ng-if=\"data.griddocumentos\">\r\n                        <div>\r\n                            <div class=\"btn-toolbar\">\r\n                                <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"data.datos.estado != \'FINALIZADO\'\" data-ng-disabled=\"data.griddocumentos.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.griddocumentos)\" uib-tooltip=\"{{ \'Eliminar documentos seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n                                <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-disabled=\"deshabilitarResultados()\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.griddocumentos)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n                            </div><br>\r\n                            <div data-ui-grid=\"data.griddocumentos\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\r\n                        </div>\r\n                        <div>\r\n                            <div class=\"footer\">\r\n                                <div ix-datetime-grid-generada grid=\"data.griddocumentos\"></div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                \r\n        </form></div>\r\n\r\n        \r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/desbloquear_masivamente_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Bloquear/Desbloquear masivamente\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n          <div class=\"row\">\r\n            <ix-select-multiple ng-model=\"data.preguntas\" entity=\"ft_preguntas\" pk=\"id_pregunta\" desc=\"pregunta_formulario\" extra-field=\"orden\" name=\"Preguntas\" conditions=\"[{field: \'version\', value: tipoFT},{field: \'activa\', value: \'1\'}]\" ng-required=\"true\"></ix-select-multiple>\r\n            <ix-select ng-model=\"data.bloqueardesbloquear\" name=\"Bloquear/Desbloquear\" pk=\"id\" desc=\"nombre\" load-function=\"loadBloquearDesbloquear\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Descargar Ficha Técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"!extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"},{value: \"MSWORD\", text: \"Word\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n            <ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"reducida\" options=\'[{value: 0, text: \"Completa\"},{value: 1, text: \"Reducida\"}]\' name=\"reducida\" label=\"Tipo\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\" ng-show=\"traducible\">\r\n						<!-- <ix-radio ng-model=\"idioma\" options=\'idiomas\' name=\"idioma\" label=\"Idioma\" ng-required=\"traducible\"></ix-radio> -->\r\n            <ix-radio ng-model=\"idioma\" options=\"idiomas\" name=\"idioma\" label=\"Idioma\"></ix-radio>\r\n					</div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/subir_foto_producto_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <div class=\"col-md-8\">\r\n                                <input ng-disabled=\"!status.editing\" class=\"btn\" type=\"file\" ngf-select ngf-multiple=\"true\" ng-model=\"archivosToUpload\" name=\"archivo\" ngf-max-size=\"{{maxUploadFileSize}}\" ngf-model-invalid=\"errorFile\">\r\n                                <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\" ng-show=\"archivosToUpload\">Borrar</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <ul>\r\n                                <li ng-repeat=\"error in erroresUpload\">{{error.Msg}}</li>\r\n                            </ul>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/acciones/versionar_masivamente_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Versionar masivamente\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n          <div class=\"row\">\r\n            <ix-text ng-model=\"data.comentario\" name=\"Comentario FT origen\" is-filter=\"true\"></ix-text>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/Mantenimientos/clientes/clientesCard.html","<strong><translate>Referencia</translate>: {{ item.referencia }} </strong><br>\r\n<strong><translate>Nombre</translate>: {{item.nombre}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/clientes/clientesForm.html","<div ng-controller=\"ClientesController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-select ng-model=\"data.datos.cliente\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\'Cliente\' ng-required=\"true\" ng-disabled=\"!status.editing || !data.datos.isNew\"></ix-select> -->\r\n						<ix-text ng-model=\"data.datos.referencia\" name=\"Referencia\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon\" name=\"Razón Social\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Direccion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Poblacion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.telefono1\" name=\"Teléfono 1\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.telefono2\" name=\"Teléfono 2\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.telefono3\" name=\"Teléfono 3\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-md-12\" ng-if=\"data.datos.cliente && data.datos[data.pk] != 0\">\r\n					<!-- <h4>Contactos responsables</h4> -->\r\n					<hr>\r\n					<div class=\"col-md-6\">\r\n						<ix-select-multiple ng-model=\"data.marcas_extra\" entity=\"extranet_marcas\" name=\"Visibilidad otras marcas\" pk=\"id\" desc=\"marca\" load-function=\"loadMarcas\" conditions=\"[{field: \'propietario\',value: data.datos.cliente, not: true}]\" append-to-body=\"true\" ng-disabled=\"!status.editing\">\r\n						<!-- skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" -->\r\n					</ix-select-multiple>\r\n					</div>\r\n				</div>\r\n				\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/compradores/compradoresCard.html","<strong><translate>Nombre</translate>: {{ item.nombre }} </strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/compradores/compradoresForm.html","<div ng-controller=\"CompradoresController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Direccion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Poblacion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'31\'}]\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<!-- <ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing\" ></ix-text> -->\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/departamentosCard.html","<strong><translate>Descripción</translate>: {{ item.descripcion }} </strong><br>");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/departamentosForm.html","<div ng-controller=\"DepartamentosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n							class=\"fa fa-language\"></i></button> -->\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/traducciones_departamentos.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones áreas\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/diccionarios/diccionariosCard.html","<strong> {{ item.descripcion }} </strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/diccionarios/diccionariosForm.html","<div ng-controller=\"DiccionariosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<button ng-click=\"ordenarValores()\" class=\"btn btn-primary\" ng-show=\"status.editing\">\r\n							<translate>Ordenar valores</translate>\r\n						</button>\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing && data.datos.isNew\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-12\">\r\n						<div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridDiccionariosValores.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridDiccionariosValores)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' |translate }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.gridDiccionariosValores)\" uib-tooltip=\"{{ \'Nuevo\' | translate }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridDiccionariosValores\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows data-ui-grid-exporter>\r\n						</div>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/extranet_marcas/extranet_marcasCard.html","<strong><translate>Marca</translate>: {{ item.marca }} </strong><br>\r\n<strong><translate>Propietario</translate>: {{item.propietarionombre}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/extranet_marcas/extranet_marcasForm.html","<div ng-controller=\"Extranet_MarcasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.marca\" name=\"Marca\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.propietario\" name=\"Propietario\" ng-disabled=\"!status.editing\" ng-required=\"true\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/ft_estadosCard.html","<strong><translate>Estado</translate>: {{ item.descripcion }} </strong><br>\r\n<strong><translate>Código</translate>: {{item.codigo}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/ft_estadosForm.html","<div ng-controller=\"Ft_EstadosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.codigo\" name=\"Código\" ng-disabled=\"!data.datos.isNew\" ng-required=\"true\">\r\n						</ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\" uib-tooltip=\"{{ \'Traducciones\'  | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.posicion\" name=\"Posición\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/traducciones_ft_estados.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Estados\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/laboratoriosCard.html","<strong><translate>Nombre</translate>: {{ item.nombre }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/laboratoriosForm.html","<div ng-controller=\"LaboratoriosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-text ng-model=\"data.datos.id_laboratorio\" name=\"ID\" ng-disabled=\"!status.editing || !data.datos.isNew\" ng-required=\"true\"></ix-text> -->\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon_social\" name=\"Razón social\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Población\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Cód. Postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" name=\"Pais\" ng-disabled=\"!status.editing\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\" append-to-body=\"true\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"fax\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.url\" name=\"Página Web\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text-area ng-model=\"data.datos.notas\" name=\"Notas\" ng-class=\"resizable\" ng-disabled=\"!status.editing\" rows=\"4\"></ix-text-area>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\" ng-show=\"data.datos.id_laboratorio\">\r\n					<div class=\"col-md-12\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n							<uib-tab index=\"0\" heading=\"Contactos\" translate-attr=\"heading\" select=\"changeTab(0)\" ng-show=\"data.datos.id_laboratorio != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridContactos.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridContactos)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRowContactos()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridContactos\" ng-if=\"data.gridContactos && data.activeTab == 0\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{\'height\': \'calc(100vh - 580px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridContactos.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"1\" heading=\"Ficheros\" translate-attr=\"heading\" select=\"changeTab(1)\" ng-show=\"data.datos.id_laboratorio != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridFicheros.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicheros)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i>\r\n									</button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addFicherosPopup()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i>\r\n									</button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicheros\" ng-if=\"data.gridFicheros && data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{\'height\': \'calc(100vh - 580px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/proveedoresCard.html","<strong>{{ item.nombre }} </strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/proveedoresForm.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.row-alarm {\r\n    color: red;\r\n  }\r\n</style>\r\n<div ng-controller=\"ProveedoresController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon\" name=\"Razón social\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\">\r\n						</ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Población\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing || blockMainDetails\" name=\"Pais\" ng-required=\"true\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ng-disabled=\"!status.editing || blockMainDetails\" ix-number ng-show=\"(!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente) || (extranetUser.cliente == 1031)\"></ix-text>\r\n						<br>\r\n						<ix-options-si-no ng-model=\"data.datos.bloqueado\" name=\"Bloqueado\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.baja\" name=\"Baja\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-options-si-no>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\" ng-show=\"data.datos.proveedor && data.datos[data.pk] != 0\">\r\n					<div class=\"col-md-12\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n							<uib-tab index=\"0\" heading=\"Otros datos\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"col-md-6\">\r\n											<ix-text ng-model=\"data.datos.registro_sanitario\" name=\"Registro sanitario\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										</div>\r\n\r\n									</div>\r\n									<div class=\"col-md-12\">\r\n										<h4>Contactos responsables</h4>\r\n										<hr>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.responsable_alerta\" name=\"Responsable alerta\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_alerta\" name=\"Teléfono responsable alerta\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_alerta\" name=\"E-mail responsable alerta\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.cargo_responsable_alerta\" name=\"Cargo responsable alerta\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.responsable_calidad\" name=\"Responsable calidad\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.tel_responsable_calidad\" name=\"Teléfono responsable calidad\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.email_responsable_calidad\" name=\"E-mail responsable calidad\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.responsable_comercial\" name=\"Responsable comercial\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_comercial\" name=\"Teléfono responsable comercial\" ng-disabled=\"!status.editing || data.datos.bloqueado\">\r\n										</ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_comercial\" name=\"E-mail responsable comercial\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.responsable_marketing\" name=\"Responsable marketing\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.tel_responsable_marketing\" name=\"Teléfono responsable marketing\" ng-disabled=\"!status.editing || data.datos.bloqueado\">\r\n											</ix-text>\r\n											<ix-text ng-model=\"data.datos.email_responsable_marketing\" name=\"E-mail responsable marketing\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.email_envio_notificaciones\" name=\"E-mail notificación alarmas\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n									</div>\r\n								</div>\r\n								<!-- <div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<h4>Laboratorios</h4>\r\n										<hr />\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.laboratorio_propio\" name=\"Laboratorio propio\"\r\n											ng-disabled=\"!status.editing\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.laboratorio_externo\" name=\"Laboratorio externo\"\r\n											ng-disabled=\"!status.editing\"></ix-text>\r\n									</div>\r\n								</div> -->\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<h4>Información proveedores de cosméticos <i>(solo rellenar en el caso que sea proveedor de cosméticos)</i></h4>\r\n										<hr>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.autorizacion_cosmeticos\" name=\"Autorización cosméticos\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.num_inscripcion_plaguicidas\" name=\"Num. inscripción plaguicidas\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<!-- <uib-tab index=\"1\" heading=\"Certificados proveedor\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"btn-toolbar\">\r\n											<a class=\"btn btn-danger pull-right\" role=\"button\"\r\n												data-ng-show=\"status.editing && !(extranetUser.cliente || extranetUser.proveedor || extranetUser.laboratorio)\"\r\n												data-ng-disabled=\"data.gridCertificadosProveedor.gridApi.selection.getSelectedRows().length==0\"\r\n												data-ng-click=\"deleteSelectedRows(data.gridCertificadosProveedor)\"\r\n												uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\"\r\n												translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n											<a class=\"btn btn-primary pull-right\" role=\"button\"\r\n												data-ng-show=\"status.editing\"\r\n												data-ng-click=\"addRow(data.gridCertificadosProveedor)\" uib-tooltip=\"{{ \'Nuevo\' }}\"\r\n												translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n										</div>\r\n										<div data-ui-grid=\"data.gridCertificadosProveedor\" ng-if=\"data.activeTab == 1 && data.gridCertificadosProveedor\"\r\n											data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav\r\n											data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning\r\n											data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize\r\n											ui-grid-clipboard>\r\n											<div class=\"grid-loading\"\r\n												ng-if=\"data.gridCertificadosProveedor.ixIsLoading\">\r\n												<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n											</div>\r\n										</div>\r\n									</div>\r\n								</div>\r\n							</uib-tab> -->\r\n							<uib-tab index=\"1\" heading=\"Fabricantes/plantas\" translate-attr=\"heading\" select=\"changeTab(1)\" ng-show=\"data.datos.proveedor != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.bloqueado\" data-ng-disabled=\"data.gridFabricantes.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFabricantes)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.bloqueado\" data-ng-click=\"addRow(data.gridFabricantes)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFabricantes\" ng-if=\"data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFabricantes.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab ng-show=\"data.datos.proveedor != 0\" index=\"2\" heading=\"Certificados y otros ficheros\" translate-attr=\"heading\" select=\"changeTab(2)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"nota-importante\">\r\n											<translate>Nota Importante Certificados Plantas</translate>\r\n										</div>\r\n									</div>\r\n								</div>\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridFicheros.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicheros)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicheros\" ng-if=\"data.activeTab == 2\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_certificados_proveedor/tipos_certificados_proveedorCard.html","<strong>Nombre: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_certificados_proveedor/tipos_certificados_proveedorForm.html","<div ng-controller=\"TiposCertificadosProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.tipo_fichero_proveedor\" name=\"Tipo fichero proveedor\" ng-disabled=\"!status.editing\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" append-to-body=\"true\" ng-required=\"false\"></ix-select>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/tipos_analisisCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/tipos_analisisForm.html","<div ng-controller=\"TiposAnalisisController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.extra\" name=\"Extra\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n          </div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/traducciones_tipos_analisis.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Análisis\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/tipos_fichero_laboratorioCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/tipos_fichero_laboratorioForm.html","<div ng-controller=\"TiposFicheroLaboratorioController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/traducciones_tipos_fichero_laboratorio.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Ficheros laboratorio\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/tipos_fichero_ftCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/tipos_fichero_ftForm.html","<div ng-controller=\"TiposFicheroFtController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-text ng-model=\"data.datos.id_laboratorio\" name=\"ID\" ng-disabled=\"!status.editing || !data.datos.isNew\" ng-required=\"true\"></ix-text> -->\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.especificar_producto\" name=\"Especificar producto\" ng-disabled=\"!status.editing\" ng-required=\"false\"></ix-options-si-no>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/traducciones_tipos_fichero_ft.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Fichero FT\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/tipos_fichero_proveedorCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/tipos_fichero_proveedorForm.html","<div ng-controller=\"TiposFicheroProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.certificado\" name=\"Es certificado\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Ficheros Proveedor\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_auditorias_plantas/tipos_auditorias_plantasCard.html","<strong>Categoria: {{ item.descripcioncategoria }} </strong><br>\r\n<strong>Tipo: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_auditorias_plantas/tipos_auditorias_plantasForm.html","<div ng-controller=\"TiposAuditoriasPlantasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_fichero_proveedor/tipos_fichero_proveedorCard.html","<strong>Nombre: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_fichero_proveedor/tipos_fichero_proveedorForm.html","<div ng-controller=\"TiposFicherosCertificadosAuditoriasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.certificado\" name=\"Es certificado\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n            <ix-select ng-model=\"data.datos.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-show=\"data.datos.certificado\" ng-disabled=\"!status.editing\" ng-required=\"data.datos.certificado\" append-to-body=\"true\">\r\n            </ix-select>\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n          </div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/MantenimientosEuromadi/categorias_certificaciones_proveedores/categorias_certificaciones_proveedoresCard.html","<strong>Nombre: {{ item.categoria }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/categorias_certificaciones_proveedores/categorias_certificaciones_proveedoresForm.html","<div ng-controller=\"CategoriasCertificacionesProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.categoria\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar pregunta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n            <uib-tab index=\"0\" heading=\"General\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <ix-select ng-model=\"pregunta.version\" name=\"Tipo FT\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel1\" name=\"Nivel 1\" entity=\"ft_niveles\" pk=\"nivel1\" desc=\"nivel1\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel2\',value: \'0\'},{field: \'nivel3\',value: \'0\'}]\" ng-disabled=\"!pregunta.version\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel2\" name=\"Nivel 2\" entity=\"ft_niveles\" pk=\"nivel2\" desc=\"nivel2\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel1\',value: data.nivel1 },{field: \'nivel2\',value: \'0\', op:1},{field: \'nivel3\',value: \'0\'}]\" ng-disabled=\"!data.nivel1\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel3\" name=\"Nivel 3\" entity=\"ft_niveles\" pk=\"nivel3\" desc=\"nivel3\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel1\',value: data.nivel1 },{field: \'nivel2\',value: data.nivel2 },{field: \'nivel3\',value: \'0\', op:1}]\" ng-disabled=\"!data.nivel2\" append-to-body=\"true\"></ix-select>\r\n                  <!-- <ix-text ng-model=\"pregunta.nivel\" name=\"Nivel\" ix-number></ix-text> -->\r\n                  <ix-text ng-model=\"pregunta.orden\" name=\"Orden\" ix-number></ix-text>\r\n                  <ix-text ng-model=\"pregunta.pregunta_formulario\" name=\"Pregunta (En formulario)\" ng-disabled=\"true\"></ix-text>\r\n                  <!-- <ix-text ng-model=\"pregunta.pregunta_informe\" name=\"Pregunta (En impresos)\"></ix-text> -->\r\n                  <ix-options-si-no ng-model=\"pregunta.activa\" name=\"Activa\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.obligatoria\" name=\"Obligatoria\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.preguntar_componente\" name=\"Por componente\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.preguntar_obs\" name=\"Observaciones\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.dependencia_etiquetado\" name=\"Dependencia etiquetado\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.separador_linea\" name=\"Linea de separación\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.muestra_en_recepcion\" name=\"Muestra en recepción\"></ix-options-si-no>\r\n                  <ix-text ng-model=\"pregunta.ayuda_pregunta\" name=\"Info pregunta (tooltip)\"></ix-text>\r\n									<!-- <ix-options-si-no ng-model=\"pregunta.traducible\" name=\"Traducible\"></ix-options-si-no> -->\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <ix-options-si-no ng-model=\"pregunta.bucle\" name=\"Tabla\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.sub_bucle\" name=\"Sub Tabla\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.resultados_fijos\" name=\"Resultados fijos\"></ix-options-si-no>\r\n                  <ix-text ng-model=\"pregunta.titulo_primera_columna\" name=\"Título en primera columna\"></ix-text>\r\n                  <ix-text ng-model=\"pregunta.dimensiones\" name=\"Dimensiones columnas\"></ix-text>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_valor_b\" name=\"Bloqueo respuesta\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_borrar_b\" name=\"Bloqueo eliminar filas\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_insert_b\" name=\"Bloquear agregar filas\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.adjuntar_fichero\" name=\"Adjuntar fichero\"></ix-options-si-no>\r\n                  <ix-select-multiple ng-model=\"pregunta.tipos_fichero\" name=\"Tipo fichero\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\"></ix-select-multiple>\r\n                  <ix-options-si-no ng-model=\"pregunta.fichero_obligatorio\" name=\"Fichero obligatorio\"></ix-options-si-no>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-11\">\r\n                      <ix-text ng-model=\"pregunta.imagen\" name=\"Archivo imagen\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-1\">\r\n                      <button class=\"btn btn-danger\" role=\"button\" data-ng-click=\"eliminarImagenPregunta()\" ng-disabled=\"!pregunta.imagen\" uib-tooltip=\"{{\'Eliminar imagen\'}}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-trash-o\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\"></div>\r\n                    <div class=\"col-md-10\">\r\n                      <input ng-disabled=\"fileUploaded\" class=\"btn\" type=\"file\" ngf-select ng-model=\"data.archivosToUpload\" name=\"archivo\" ngf-max-size=\"{{maxUploadFileSize}}\" ngf-model-invalid=\"errorFile\">\r\n                        <!-- <button ng-disabled=\"data.fileUploaded || data.uploadingFile\" class=\"btn btn-danger\" ng-click=\"data.archivo = null\" ng-show=\"data.archivosToUpload\">Borrar</button> -->\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </uib-tab>\r\n            <uib-tab index=\"1\" heading=\"Pregunta principal\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n              <ix-text ng-model=\"pregunta.pregunta_formulario\" name=\"Pregunta (En formulario)\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.pregunta_informe\" name=\"Pregunta (En impresos)\"></ix-text>\r\n              <ix-text-area ng-model=\"pregunta.nota_pregunta\" name=\"Nota explicativa\" rows=\"4\"></ix-text-area>\r\n              <ix-select ng-model=\"pregunta.tipo_valor\" name=\"Tipo valor\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_pregunta\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_pregunta\" name=\"Diccionario pregunta\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor==\'DICCIONARIO\' || pregunta.tipo_valor==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor\" name=\"Formato respuesta\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo\" name=\"Val. minimo respuesta\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo\" name=\"Val. máximo respuesta\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.traducible\" name=\"Traducible\"></ix-options-si-no>\r\n              <ix-text ng-model=\"pregunta.valor_defecto\" name=\"Valor por defecto\" ng-show=\"pregunta.bucle == 0\"></ix-text>\r\n            </uib-tab>\r\n            <uib-tab index=\"2\" heading=\"Subpregunta 1\" translate-attr=\"heading\" select=\"changeTab(2)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta1\" name=\"Subpregunta 1\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta1\" name=\"Tipo valor subresp 1\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta1\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta1==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta1\" name=\"Diccionario subpregunta 1\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta1==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta1==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta1\" name=\"Formato subresp 1\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta1\" name=\"Val. min subresp 1\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta1\" name=\"Val. max subresp 1\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta1\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta1\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta1_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"3\" heading=\"Subpregunta 2\" translate-attr=\"heading\" select=\"changeTab(3)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta2\" name=\"Subpregunta 2\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta2\" name=\"Tipo valor subresp 2\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta2\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta2==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta2\" name=\"Diccionario subpregunta 2\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta2==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta2==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta2\" name=\"Formato subresp 2\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta2\" name=\"Val. min subresp 2\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta2\" name=\"Val. max subresp 2\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta2\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta2\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta2_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"4\" heading=\"Subpregunta 3\" translate-attr=\"heading\" select=\"changeTab(4)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta3\" name=\"Subpregunta 3\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta3\" name=\"Tipo valor subresp 3\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta3\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta3==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta3\" name=\"Diccionario subpregunta 3\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta3==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta3==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta3\" name=\"Formato subresp 3\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta3\" name=\"Val. min subresp 3\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta3\" name=\"Val. max subresp 3\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta3\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta3\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta3_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"5\" heading=\"Subpregunta 4\" translate-attr=\"heading\" select=\"changeTab(5)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta4\" name=\"Subpregunta 4\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta4\" name=\"Tipo valor subresp 4\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta4\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta4==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta4\" name=\"Diccionario subpregunta 4\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta4==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta4==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta4\" name=\"Formato subresp 4\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta4\" name=\"Val. min subresp 4\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta4\" name=\"Val. max subresp 4\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta4\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta4\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta4_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"6\" heading=\"Subpregunta 5\" translate-attr=\"heading\" select=\"changeTab(6)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta5\" name=\"Subpregunta 5\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta5\" name=\"Tipo valor subresp 5\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta5\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta5==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta5\" name=\"Diccionario subpregunta 5\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta5==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta5\" name=\"Formato subresp 5\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta5\" name=\"Val. min subresp 5\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta5\" name=\"Val. max subresp 5\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta5\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta5\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta5_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"7\" heading=\"Subpregunta 6\" translate-attr=\"heading\" select=\"changeTab(7)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta6\" name=\"Subpregunta 6\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta6\" name=\"Tipo valor subresp 6\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta6\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta6==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta6\" name=\"Diccionario subpregunta 6\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta6==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta6\" name=\"Formato subresp 6\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta6\" name=\"Val. min subresp 6\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta6\" name=\"Val. max subresp 6\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta6\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta6\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta6_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"8\" heading=\"Subpregunta 7\" translate-attr=\"heading\" select=\"changeTab(8)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta7\" name=\"Subpregunta 7\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta7\" name=\"Tipo valor subresp 7\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta7\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta7==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta7\" name=\"Diccionario subpregunta 7\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta7==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta7\" name=\"Formato subresp 7\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta7\" name=\"Val. min subresp 7\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta7\" name=\"Val. max subresp 7\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta7\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta7\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta7_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"9\" heading=\"Subpregunta 8\" translate-attr=\"heading\" select=\"changeTab(9)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta8\" name=\"Subpregunta 8\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta8\" name=\"Tipo valor subresp 8\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta8\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta8==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta8\" name=\"Diccionario subpregunta 8\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta8==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta8\" name=\"Formato subresp 8\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta8\" name=\"Val. min subresp 8\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta8\" name=\"Val. max subresp 8\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta8\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta8\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta8_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"10\" heading=\"Subpregunta 9\" translate-attr=\"heading\" select=\"changeTab(10)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta9\" name=\"Subpregunta 9\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta9\" name=\"Tipo valor subresp 9\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta9\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta9==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta9\" name=\"Diccionario subpregunta 9\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta9==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta9\" name=\"Formato subresp 9\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta9\" name=\"Val. min subresp 9\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta9\" name=\"Val. max subresp 9\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta9\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta9\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta9_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"11\" heading=\"Subpregunta 10\" translate-attr=\"heading\" select=\"changeTab(10)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta10\" name=\"Subpregunta 10\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta10\" name=\"Tipo valor subresp 10\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta10\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta10==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta10\" name=\"Diccionario subpregunta 10\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta10==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta10\" name=\"Formato subresp 10\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta10\" name=\"Val. min subresp 10\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta10\" name=\"Val. max subresp 10\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta10\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta10\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta10_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"12\" heading=\"Subpregunta 11\" translate-attr=\"heading\" select=\"changeTab(12)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta11\" name=\"Subpregunta 11\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta11\" name=\"Tipo valor subresp 11\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta11\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta11==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta11\" name=\"Diccionario subpregunta 11\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta11==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta11\" name=\"Formato subresp 11\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta11\" name=\"Val. min subresp 11\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta11\" name=\"Val. max subresp 11\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta11\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta11\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta11_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"13\" heading=\"Subpregunta 12\" translate-attr=\"heading\" select=\"changeTab(13)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta12\" name=\"Subpregunta 12\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta12\" name=\"Tipo valor subresp 12\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta12\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta12==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta12\" name=\"Diccionario subpregunta 12\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta12==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta12\" name=\"Formato subresp 12\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta12\" name=\"Val. min subresp 12\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta12\" name=\"Val. max subresp 12\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta12\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta12\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta12_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"14\" heading=\"Subpregunta 13\" translate-attr=\"heading\" select=\"changeTab(14)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta13\" name=\"Subpregunta 13\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta13\" name=\"Tipo valor subresp 13\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta13\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta13==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta13\" name=\"Diccionario subpregunta 13\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta13==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta13\" name=\"Formato subresp 13\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta13\" name=\"Val. min subresp 13\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta13\" name=\"Val. max subresp 13\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta13\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta13\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta13_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"15\" heading=\"Subpregunta 14\" translate-attr=\"heading\" select=\"changeTab(15)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta14\" name=\"Subpregunta 14\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta14\" name=\"Tipo valor subresp 14\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta14\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta14==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta14\" name=\"Diccionario subpregunta 14\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta14==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta14\" name=\"Formato subresp 14\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta14\" name=\"Val. min subresp 14\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta14\" name=\"Val. max subresp 14\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta14\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta14\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta14_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <!-- <uib-tab index=\"16\" heading=\"Subpregunta 15\" translate-attr=\"heading\" select=\"changeTab(16)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta15\" name=\"Subpregunta 15\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta15\" name=\"Tipo valor subresp 15\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta15\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta15==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta15\" name=\"Diccionario subpregunta 15\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta15==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta15\" name=\"Formato subresp 15\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta15\" name=\"Val. min subresp 15\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta15\" name=\"Val. max subresp 15\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta15\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta15\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta15_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"17\" heading=\"Subpregunta 16\" translate-attr=\"heading\" select=\"changeTab(17)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta16\" name=\"Subpregunta 16\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta16\" name=\"Tipo valor subresp 16\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta16\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta16==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta16\" name=\"Diccionario subpregunta 16\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta16==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta16\" name=\"Formato subresp 16\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta16\" name=\"Val. min subresp 16\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta16\" name=\"Val. max subresp 16\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta16\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta16\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta16_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab> -->\r\n          </uib-tabset>\r\n				</form>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/previsualizar_pregunta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar pregunta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div class=\"row\">\r\n        	<ft-preguntas preguntas=\"preguntas\" preview=\"true\"></ft-preguntas>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/modales/popupFicheroLaboratorio.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{tituloPopup}}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\" ng-show=\"esNuevo\">\r\n              <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"esNuevo\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n              </div>\r\n              <ul>\r\n                <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-md-8\">\r\n              <ix-text ng-show=\"!esNuevo\" ng-model=\"data.archivo\" name=\"Nombre fichero\" ng-disabled=\"!status.editing\" ng-required=\"!esNuevo\"></ix-text>\r\n              <ix-select ng-model=\"data.tipo\" name=\"Tipo archivo\" entity=\"tipos_fichero_laboratorio\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n              <ix-date ng-model=\"data.fecha_carga\" name=\"Fecha carga\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.fecha_caducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/fabricantesPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Fabricante\" title-left-param=\"mes\">\r\n    <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\">\r\n      Guardar\r\n    </button>\r\n  </ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"data.fabricante.razon_social\" name=\"Razón social\" ng-required=\"true\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cif\" name=\"CIF\" ng-required=\"true\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.direccion\" name=\"Dirección\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cp\" name=\"Código postal\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.localidad\" name=\"Localidad\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.provincia\" name=\"Provincia\"></ix-text>\r\n              <ix-select ng-model=\"data.fabricante.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\">\r\n              </ix-select>\r\n              <ix-text ng-model=\"data.fabricante.telefono\" name=\"Teléfono\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.fax\" name=\"Fax\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.email\" name=\"E-mail\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.reg_sanitario\" name=\"Registro sanitario\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <!-- Grid de plantas -->\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n              <uib-tab index=\"0\" heading=\"Plantas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridPlantas.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridPlantas)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i>\r\n                        </a>\r\n                      <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"isNew\" data-ng-click=\"addRow(data.gridPlantas)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridPlantas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridPlantas.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n              <!-- <uib-tab index=\"1\" heading=\"Certificados fabricante\" translate-attr=\"heading\" select=\"changeTab(1)\" disable=\"isNew\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"data.gridCertificadosFabricante.gridApi.selection.getSelectedRows().length==0\"\r\n                        data-ng-click=\"deleteSelectedRows(data.gridCertificadosFabricante)\"\r\n                        uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i\r\n                          class=\"fa fa-trash-o\"></i></a>\r\n                      <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"false\" data-ng-click=\"addFicheros()\"\r\n                        uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridCertificadosFabricante\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning\r\n                  data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridCertificadosFabricante.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab> -->\r\n            </uib-tabset>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/plantasPopup.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n</style>\r\n\r\n<div>\r\n    <ix-popup-tool-bar title-left=\"Planta\" title-left-param=\"mes\">\r\n        <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\" ng-show=\"status.editing\">\r\n            Guardar\r\n        </button>\r\n    </ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                            <ix-text ng-model=\"data.planta.nombre_planta\" name=\"Nombre planta\" ng-required=\"true\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.direccion\" name=\"Dirección\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.cp\" name=\"Código postal\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.localidad\" name=\"Localidad\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.provincia\" name=\"Provincia\"></ix-text>\r\n                            <ix-select ng-model=\"data.planta.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n                            <ix-text ng-model=\"data.planta.telefono\" name=\"Teléfono\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.reg_sanitario\" name=\"Registro sanitario\"></ix-text>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                            <ix-date ng-model=\"data.planta.fecha_alta\" name=\"Fecha Alta\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-date>\r\n                            <ix-options-si-no ng-model=\"data.planta.baja\" name=\"Baja\" ng-if=\"!isNew\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n                            <ix-date ng-model=\"data.planta.fecha_baja\" name=\"Fecha Baja\" ng-show=\"data.planta.baja==1\" ng-if=\"!isNew\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-date>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n                <!-- Grid de plantas -->\r\n                <br>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"nota-importante\">\r\n                            <translate>Nota Importante Certificados Plantas</translate>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"btn-toolbar\">\r\n                            <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridCertificadosPlanta.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridCertificadosPlanta)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n                            <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"isNew\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n                        </div>\r\n                        <div data-ui-grid=\"data.gridCertificadosPlanta\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n                            <div class=\"grid-loading\" ng-if=\"data.gridCertificadosPlanta.ixIsLoading\">\r\n                                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\">\r\n                <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                  <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ul>\r\n                  <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}\r\n                  </li>\r\n                </ul>\r\n                <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\" ng-show=\"archivosToUpload\">Borrar</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-model=\"proveedor\" ng-show=\"soloHayPlantaPuesta\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" on-select=\"limpiarPlanta\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select>\r\n              \r\n              <ix-select ng-model=\"grupo\" name=\"Grupo\" entity=\"grupos_proveedores_ficheros\" pk=\"grupo\" desc=\"grupo\" ng-required=\"true\" ng-disabled=\"!status.editing || bloquearGrupos || soloHayPlantaPuesta\" append-to-body=\"true\" on-select=\"seleccionadoGrupo\"></ix-select>\r\n              \r\n                <ix-select ng-model=\"fabricante\" name=\"Fabricante\" entity=\"fabricantes\" pk=\"fabricante\" desc=\"razon_social\" ng-required=\"grupo==\'FABRICANTE\'\" ng-disabled=\"!status.editing || bloquearGrupos\" append-to-body=\"true\" conditions=\"[{field: \'proveedor\',value: proveedor}]\" ng-show=\"grupo == \'FABRICANTE\' || grupo == \'PLANTA\'\"></ix-select>\r\n\r\n              <ix-select ng-model=\"planta\" name=\"Planta\" entity=\"plantas\" pk=\"planta\" desc=\"nombre_planta\" ng-required=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || bloquearGrupos\" append-to-body=\"true\" conditions=\"[{field: \'fabricante\',value: fabricante}]\" ng-show=\"grupo == \'PLANTA\'\"></ix-select>\r\n              <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 0}]\" ng-required=\"true\" ng-show=\"grupo==\'PROVEEDOR\' || grupo==\'FABRICANTE\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\"></ix-select>\r\n              <!-- <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 1}]\" ng-required=\"true\" ng-show=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\" on-select=\"seleccionadoTipoFichero\"></ix-select> -->\r\n              <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 1}]\" ng-required=\"true\" ng-show=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\"></ix-select>\r\n              <ix-date ng-model=\"inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" ng-required=\"grupo==\'PLANTA\'\" append-to-body=\"true\"></ix-date>\r\n              <ix-text ng-model=\"num_certificado\" name=\"Número certificado\" ng-show=\"seleccionadoCertificado\" ng-disabled=\"!status.editing\"></ix-text>\r\n              <ix-text ng-model=\"certificadora\" name=\"Certificadora\" ng-show=\"seleccionadoCertificado\" ng-disabled=\"!status.editing\"></ix-text>\r\n              <ix-text ng-model=\"alcance\" name=\"Alcance\" ng-disabled=\"!status.editing\" ng-required=\"seleccionadoCertificado\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");}]);